import React from "react";

export function SvgDashboard({ color = "#292929" }) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.05943 1.93029C4.78821 1.78821 3.4723 1.78821 2.20109 1.93029C1.8922 1.96481 1.6486 2.2094 1.61385 2.50646C1.46205 3.8044 1.46205 5.11561 1.61385 6.41355C1.6486 6.71061 1.8922 6.9552 2.20109 6.98972C3.4723 7.1318 4.78821 7.1318 6.05943 6.98972C6.36832 6.9552 6.61192 6.71061 6.64666 6.41355C6.79847 5.11561 6.79847 3.8044 6.64666 2.50646C6.61192 2.2094 6.36832 1.96481 6.05943 1.93029ZM2.03448 0.43957C3.41642 0.285117 4.84409 0.285117 6.22604 0.43957C7.21688 0.550311 8.01932 1.3303 8.1365 2.33221C8.30185 3.74592 8.30185 5.17409 8.1365 6.5878C8.01932 7.58971 7.21688 8.3697 6.22604 8.48044C4.84409 8.63489 3.41642 8.63489 2.03448 8.48044C1.04364 8.3697 0.241192 7.58971 0.12401 6.5878C-0.0413366 5.17409 -0.0413366 3.74592 0.12401 2.33221C0.241192 1.3303 1.04364 0.550311 2.03448 0.43957Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.05943 11.9303C4.78821 11.7882 3.4723 11.7882 2.20109 11.9303C1.8922 11.9648 1.6486 12.2094 1.61385 12.5065C1.46205 13.8044 1.46205 15.1156 1.61385 16.4136C1.6486 16.7106 1.8922 16.9552 2.20109 16.9897C3.4723 17.1318 4.78821 17.1318 6.05943 16.9897C6.36832 16.9552 6.61192 16.7106 6.64666 16.4136C6.79847 15.1156 6.79847 13.8044 6.64666 12.5065C6.61192 12.2094 6.36832 11.9648 6.05943 11.9303ZM2.03448 10.4396C3.41642 10.2851 4.84409 10.2851 6.22604 10.4396C7.21688 10.5503 8.01932 11.3303 8.1365 12.3322C8.30185 13.7459 8.30185 15.1741 8.1365 16.5878C8.01932 17.5897 7.21688 18.3697 6.22604 18.4804C4.84409 18.6349 3.41642 18.6349 2.03448 18.4804C1.04364 18.3697 0.241192 17.5897 0.12401 16.5878C-0.0413366 15.1741 -0.0413366 13.7459 0.12401 12.3322C0.241192 11.3303 1.04364 10.5503 2.03448 10.4396Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0594 1.93029C14.7882 1.78821 13.4723 1.78821 12.2011 1.93029C11.8922 1.96481 11.6486 2.2094 11.6139 2.50646C11.462 3.8044 11.462 5.11561 11.6139 6.41355C11.6486 6.71061 11.8922 6.9552 12.2011 6.98972C13.4723 7.1318 14.7882 7.1318 16.0594 6.98972C16.3683 6.9552 16.6119 6.71061 16.6467 6.41355C16.7985 5.11561 16.7985 3.8044 16.6467 2.50646C16.6119 2.2094 16.3683 1.96481 16.0594 1.93029ZM12.0345 0.43957C13.4164 0.285117 14.8441 0.285117 16.226 0.43957C17.2169 0.550311 18.0193 1.3303 18.1365 2.33221C18.3019 3.74592 18.3019 5.17409 18.1365 6.5878C18.0193 7.58971 17.2169 8.3697 16.226 8.48044C14.8441 8.63489 13.4164 8.63489 12.0345 8.48044C11.0436 8.3697 10.2412 7.58971 10.124 6.5878C9.95866 5.17409 9.95866 3.74592 10.124 2.33221C10.2412 1.3303 11.0436 0.550311 12.0345 0.43957Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0594 11.9303C14.7882 11.7882 13.4723 11.7882 12.2011 11.9303C11.8922 11.9648 11.6486 12.2094 11.6139 12.5065C11.462 13.8044 11.462 15.1156 11.6139 16.4136C11.6486 16.7106 11.8922 16.9552 12.2011 16.9897C13.4723 17.1318 14.7882 17.1318 16.0594 16.9897C16.3683 16.9552 16.6119 16.7106 16.6467 16.4136C16.7985 15.1156 16.7985 13.8044 16.6467 12.5065C16.6119 12.2094 16.3683 11.9648 16.0594 11.9303ZM12.0345 10.4396C13.4164 10.2851 14.8441 10.2851 16.226 10.4396C17.2169 10.5503 18.0193 11.3303 18.1365 12.3322C18.3019 13.7459 18.3019 15.1741 18.1365 16.5878C18.0193 17.5897 17.2169 18.3697 16.226 18.4804C14.8441 18.6349 13.4164 18.6349 12.0345 18.4804C11.0436 18.3697 10.2412 17.5897 10.124 16.5878C9.95866 15.1741 9.95866 13.7459 10.124 12.3322C10.2412 11.3303 11.0436 10.5503 12.0345 10.4396Z"
        fill={color}
      />
    </svg>
  );
}

export function svgLight() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.41667 13.7988V15.75C7.41667 16.6705 8.16286 17.4167 9.08333 17.4167C10.0038 17.4167 10.75 16.6705 10.75 15.75V13.7988M9.08333 0.75V1.58333M1.58333 9.08333H0.75M3.66667 3.66667L3.16659 3.16659M14.5 3.66667L15.0002 3.16659M17.4167 9.08333H16.5833M14.0833 9.08333C14.0833 11.8448 11.8448 14.0833 9.08333 14.0833C6.32191 14.0833 4.08333 11.8448 4.08333 9.08333C4.08333 6.32191 6.32191 4.08333 9.08333 4.08333C11.8448 4.08333 14.0833 6.32191 14.0833 9.08333Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  )
}

export function SvgHoliday() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9.91667" cy="9.91667" r="9.16667" stroke="#141B34" stroke-width="1.5" />
      <path d="M9.91406 3.04175C11.2738 3.04175 12.603 3.44496 13.7336 4.20039C14.8642 4.95583 15.7454 6.02956 16.2657 7.2858C16.7861 8.54204 16.9222 9.92437 16.657 11.258C16.3917 12.5916 15.7369 13.8166 14.7754 14.7781C13.8139 15.7396 12.5889 16.3944 11.2553 16.6596C9.92169 16.9249 8.53936 16.7888 7.28311 16.2684C6.02687 15.7481 4.95314 14.8669 4.19771 13.7363C3.44227 12.6057 3.03906 11.2765 3.03906 9.91675H9.91406V3.04175Z" fill="#141B34" />
    </svg>

  )
}

export function SvgInfosIcon() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9.08333" cy="9.08333" r="8.33333" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M9.07812 12.4165V8.6665" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M9.07812 5.75977V5.74977" stroke="#141B34" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  )
}

export function SvgMediumArrow({ className }) {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1 13L7 7L1 1"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgFolderOutline({ className, color = "black" }) {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9 3.75L8.16334 2.07669C7.92255 1.5951 7.80215 1.3543 7.62253 1.17837C7.46368 1.0228 7.27224 0.90448 7.06206 0.831982C6.82437 0.75 6.55516 0.75 6.01672 0.75H3.15C2.30992 0.75 1.88988 0.75 1.56901 0.91349C1.28677 1.0573 1.0573 1.28677 0.91349 1.56901C0.75 1.88988 0.75 2.30992 0.75 3.15V3.75M0.75 3.75H12.15C13.4101 3.75 14.0402 3.75 14.5215 3.99524C14.9448 4.21095 15.289 4.55516 15.5048 4.97852C15.75 5.45982 15.75 6.08988 15.75 7.35V10.65C15.75 11.9101 15.75 12.5402 15.5048 13.0215C15.289 13.4448 14.9448 13.789 14.5215 14.0048C14.0402 14.25 13.4101 14.25 12.15 14.25H4.35C3.08988 14.25 2.45982 14.25 1.97852 14.0048C1.55516 13.789 1.21095 13.4448 0.995235 13.0215C0.75 12.5402 0.75 11.9101 0.75 10.65V3.75Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgSubAssignationArrow({ color = "black" }) {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.75 0.75V1.50833C0.75 3.3285 0.75 4.23859 1.10423 4.9338C1.41582 5.54533 1.913 6.04252 2.52453 6.3541C3.21974 6.70833 4.12983 6.70833 5.95 6.70833H9.41667M6.70833 9.41667L9.41667 6.70833L6.70833 4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgMonHoraire({ color = "#292929" }) {
  return (
    <svg
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3554 8.74475H0.783263C0.398339 8.74475 0.0859375 8.43235 0.0859375 8.04742C0.0859375 7.6625 0.398339 7.3501 0.783263 7.3501H17.3554C17.7404 7.3501 18.0528 7.6625 18.0528 8.04742C18.0528 8.43235 17.7404 8.74475 17.3554 8.74475"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.205 12.3756C12.82 12.3756 12.5039 12.0632 12.5039 11.6783C12.5039 11.2934 12.8117 10.981 13.1966 10.981H13.205C13.5899 10.981 13.9023 11.2934 13.9023 11.6783C13.9023 12.0632 13.5899 12.3756 13.205 12.3756"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.078 12.3756C8.69307 12.3756 8.37695 12.0632 8.37695 11.6783C8.37695 11.2934 8.68471 10.981 9.06963 10.981H9.078C9.46292 10.981 9.77532 11.2934 9.77532 11.6783C9.77532 12.0632 9.46292 12.3756 9.078 12.3756"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.94416 12.3756C4.55924 12.3756 4.24219 12.0632 4.24219 11.6783C4.24219 11.2934 4.55087 10.981 4.93579 10.981H4.94416C5.32909 10.981 5.64149 11.2934 5.64149 11.6783C5.64149 12.0632 5.32909 12.3756 4.94416 12.3756"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.205 15.9889C12.82 15.9889 12.5039 15.6765 12.5039 15.2916C12.5039 14.9066 12.8117 14.5942 13.1966 14.5942H13.205C13.5899 14.5942 13.9023 14.9066 13.9023 15.2916C13.9023 15.6765 13.5899 15.9889 13.205 15.9889"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.078 15.9889C8.69307 15.9889 8.37695 15.6765 8.37695 15.2916C8.37695 14.9066 8.68471 14.5942 9.06963 14.5942H9.078C9.46292 14.5942 9.77532 14.9066 9.77532 15.2916C9.77532 15.6765 9.46292 15.9889 9.078 15.9889"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.94416 15.9889C4.55924 15.9889 4.24219 15.6765 4.24219 15.2916C4.24219 14.9066 4.55087 14.5942 4.93579 14.5942H4.94416C5.32909 14.5942 5.64149 14.9066 5.64149 15.2916C5.64149 15.6765 5.32909 15.9889 4.94416 15.9889"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8243 4.91985C12.4394 4.91985 12.127 4.60745 12.127 4.22252V1.16266C12.127 0.777734 12.4394 0.465332 12.8243 0.465332C13.2092 0.465332 13.5216 0.777734 13.5216 1.16266V4.22252C13.5216 4.60745 13.2092 4.91985 12.8243 4.91985"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.31451 4.91985C4.92959 4.91985 4.61719 4.60745 4.61719 4.22252V1.16266C4.61719 0.777734 4.92959 0.465332 5.31451 0.465332C5.69944 0.465332 6.01184 0.777734 6.01184 1.16266V4.22252C6.01184 4.60745 5.69944 4.91985 5.31451 4.91985"
        fill={color}
      />
      <mask
        id="mask0_5621_8718"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="1"
        width="19"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 1.93311H18.1305V20.4549H0V1.93311Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_5621_8718)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.13361 3.32764C2.72273 3.32764 1.39502 4.61351 1.39502 6.94815V15.3616C1.39502 17.7474 2.72273 19.0602 5.13361 19.0602H12.9976C15.4085 19.0602 16.7362 17.7716 16.7362 15.4323V6.94815C16.7399 5.79989 16.4312 4.90731 15.8185 4.29367C15.1881 3.66142 14.2165 3.32764 13.006 3.32764H5.13361ZM12.9972 20.455H5.13325C1.96739 20.455 0 18.5034 0 15.3617V6.94827C0 3.854 1.96739 1.93311 5.13325 1.93311H13.0056C14.5946 1.93311 15.9083 2.40915 16.8055 3.30823C17.6767 4.18314 18.1351 5.44112 18.1305 6.95013V15.4324C18.1305 18.5304 16.1631 20.455 12.9972 20.455V20.455Z"
          fill={color}
        />
      </g>
    </svg>
  );
}

export function SvgSuiviHours({ color = "#292929" }) {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 4.45996C9.5 4.04575 9.16421 3.70996 8.75 3.70996C8.33579 3.70996 8 4.04575 8 4.45996V9.45996C8 9.71855 8.13321 9.95891 8.3525 10.096L11.3525 11.971C11.7038 12.1905 12.1665 12.0837 12.386 11.7325C12.6055 11.3812 12.4988 10.9185 12.1475 10.699L9.5 9.04428V4.45996Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75 0.709961C3.91751 0.709961 0 4.62747 0 9.45996C0 14.2925 3.91751 18.21 8.75 18.21C13.5825 18.21 17.5 14.2925 17.5 9.45996C17.5 4.62747 13.5825 0.709961 8.75 0.709961ZM1.5 9.45996C1.5 5.4559 4.74594 2.20996 8.75 2.20996C12.7541 2.20996 16 5.4559 16 9.45996C16 13.464 12.7541 16.71 8.75 16.71C4.74594 16.71 1.5 13.464 1.5 9.45996Z"
        fill={color}
      />
    </svg>
  );
}

export function SvgNews({ color = "#292929" }) {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.25 6.86446C11.25 6.45024 10.9142 6.11446 10.5 6.11446H4.5C4.08579 6.11446 3.75 6.45024 3.75 6.86446C3.75 7.27867 4.08579 7.61446 4.5 7.61446H10.5C10.9142 7.61446 11.25 7.27867 11.25 6.86446Z"
        fill={color}
      />
      <path
        d="M10.25 9.86446C10.25 9.45024 9.91421 9.11446 9.5 9.11446H4.5C4.08579 9.11446 3.75 9.45024 3.75 9.86446C3.75 10.2787 4.08579 10.6145 4.5 10.6145H9.5C9.91421 10.6145 10.25 10.2787 10.25 9.86446Z"
        fill={color}
      />
      <path
        d="M10.5 12.1145C10.9142 12.1145 11.25 12.4502 11.25 12.8645C11.25 13.2787 10.9142 13.6145 10.5 13.6145H4.5C4.08579 13.6145 3.75 13.2787 3.75 12.8645C3.75 12.4502 4.08579 12.1145 4.5 12.1145H10.5Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 18.8645H16.75C18.2688 18.8645 19.5 17.6332 19.5 16.1145V10.6145C19.5 10.2003 19.1642 9.86446 18.75 9.86446H15.5V2.05765C15.5 0.634251 13.8911 -0.193716 12.7328 0.633619L12.5578 0.758653C11.7773 1.31615 10.7201 1.31427 9.93593 0.754164C8.63206 -0.177169 6.86794 -0.177169 5.56407 0.754164C4.77992 1.31427 3.7227 1.31615 2.94221 0.758653L2.76717 0.633619C1.6089 -0.193716 0 0.634252 0 2.05765V15.1145C0 17.1855 1.67893 18.8645 3.75 18.8645ZM6.43593 1.97476C7.21825 1.41596 8.28175 1.41596 9.06407 1.97476C10.3661 2.90479 12.1239 2.91189 13.4296 1.97925L13.6047 1.85422C13.7702 1.73603 14 1.85431 14 2.05765V16.1145C14 16.5646 14.1081 16.9894 14.2999 17.3645H3.75C2.50736 17.3645 1.5 16.3571 1.5 15.1145V2.05765C1.5 1.85431 1.72984 1.73603 1.89531 1.85422L2.07036 1.97925C3.37605 2.91189 5.1339 2.90479 6.43593 1.97476ZM15.5 16.1145V11.3645H18V16.1145C18 16.8048 17.4404 17.3645 16.75 17.3645C16.0596 17.3645 15.5 16.8048 15.5 16.1145Z"
        fill={color}
      />
    </svg>
  );
}

export function SvgMyFiche({ color = "#292929" }) {
  return (
    <svg
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1741 5.06818C17.195 5.19899 17.2146 5.32995 17.2329 5.46105C17.2504 5.58596 17.3433 5.68635 17.4645 5.72126C17.8223 5.82431 18.1566 5.9829 18.4574 6.18709C18.6079 6.28928 18.8288 6.17611 18.8096 5.99518C18.7685 5.60645 18.7171 5.2185 18.6553 4.83175L18.5912 4.43032C18.3853 3.14029 17.2726 2.19108 15.9663 2.19108L7.65182 2.19108C7.4463 1.13342 6.51504 0.334961 5.39728 0.334961H3.10572C1.74943 0.334961 0.60703 1.34839 0.445323 2.695L0.172837 4.96412C-0.116823 7.37625 -0.0420663 9.81823 0.394598 12.2081C0.610117 13.3877 1.59662 14.2719 2.79265 14.3574L4.30666 14.4658C6.48739 14.6218 8.67339 14.6793 10.858 14.6383C10.9969 14.6357 11.1144 14.5373 11.1508 14.4033C11.2421 14.0671 11.3713 13.7465 11.5337 13.4465C11.6108 13.304 11.5082 13.1228 11.3462 13.127C9.03483 13.1871 6.72125 13.1347 4.4137 12.9696L2.89969 12.8613C2.38622 12.8245 1.9627 12.4449 1.87017 11.9385C1.46054 9.69658 1.39041 7.40577 1.66214 5.14296L1.93462 2.87384C2.00581 2.28107 2.50869 1.83496 3.10572 1.83496H5.39728C5.83733 1.83496 6.19405 2.19168 6.19405 2.63173C6.19405 3.21679 6.66834 3.69108 7.2534 3.69108H15.9663C16.5354 3.69108 17.0203 4.10466 17.11 4.66674L17.1741 5.06818Z"
        fill={color}
      />
      <path
        d="M16.494 7.08496C15.3895 7.08496 14.494 7.98039 14.494 9.08496C14.494 10.1895 15.3895 11.085 16.494 11.085C17.5986 11.085 18.494 10.1895 18.494 9.08496C18.494 7.98039 17.5986 7.08496 16.494 7.08496Z"
        fill={color}
      />
      <path
        d="M12.494 15.585C12.494 13.9281 13.8372 12.585 15.494 12.585H17.494C19.1509 12.585 20.494 13.9281 20.494 15.585C20.494 16.1372 20.0463 16.585 19.494 16.585H13.494C12.9418 16.585 12.494 16.1372 12.494 15.585Z"
        fill={color}
      />
    </svg>
  );
}

export function SvgListEmployers({ color = "#292929", className }) {
  return (
    <svg
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.886 8.21071C16.518 8.21071 16.197 7.93971 16.144 7.56471C16.087 7.15372 16.372 6.77472 16.783 6.71772C17.823 6.57172 18.608 5.66971 18.61 4.61772C18.61 3.57472 17.862 2.69272 16.831 2.52372C16.423 2.45671 16.146 2.07072 16.213 1.66172C16.281 1.25272 16.664 0.978715 17.075 1.04372C18.833 1.33272 20.11 2.83671 20.11 4.61971C20.106 6.41471 18.765 7.95471 16.99 8.20371C16.955 8.20871 16.92 8.21071 16.886 8.21071Z"
        fill={color}
      />
      <mask
        id="mask0_5621_8750"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="17"
        y="10"
        width="5"
        height="5"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9785 10.0664H21.7725V14.596H17.9785V10.0664Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_5621_8750)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.8618 14.596C19.5598 14.596 19.2748 14.412 19.1608 14.113C19.0128 13.726 19.2078 13.292 19.5948 13.145C20.2728 12.887 20.2728 12.602 20.2728 12.465C20.2728 12.027 19.7158 11.721 18.6178 11.557C18.2088 11.495 17.9258 11.114 17.9868 10.703C18.0478 10.293 18.4278 10.02 18.8408 10.073C21.2638 10.436 21.7728 11.574 21.7728 12.465C21.7728 13.009 21.5588 14.002 20.1288 14.547C20.0408 14.58 19.9508 14.596 19.8618 14.596Z"
          fill={color}
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8867 11.9785C8.51073 11.9785 5.67773 12.2705 5.67773 13.6605C5.67773 15.0615 8.51073 15.3555 10.8867 15.3555C13.2627 15.3555 16.0947 15.0645 16.0947 13.6775C16.0947 12.2735 13.2627 11.9785 10.8867 11.9785ZM10.8867 16.8555C9.22773 16.8555 4.17773 16.8555 4.17773 13.6605C4.17773 10.4785 9.22773 10.4785 10.8867 10.4785C12.5457 10.4785 17.5947 10.4785 17.5947 13.6775C17.5947 16.8555 12.7217 16.8555 10.8867 16.8555Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8864 1.56445C9.1944 1.56445 7.8184 2.94145 7.8184 4.63345C7.8154 5.45345 8.1294 6.22045 8.7044 6.79945C9.2794 7.37845 10.0454 7.69945 10.8614 7.70245L10.8864 8.45245V7.70245C12.5784 7.70245 13.9554 6.32645 13.9554 4.63345C13.9554 2.94145 12.5784 1.56445 10.8864 1.56445ZM10.8864 9.20245H10.8594C9.6394 9.19845 8.4964 8.72045 7.6404 7.85645C6.7824 6.99345 6.3134 5.84745 6.3184 4.63045C6.3184 2.11445 8.3674 0.0644531 10.8864 0.0644531C13.4064 0.0644531 15.4554 2.11445 15.4554 4.63345C15.4554 7.15245 13.4064 9.20245 10.8864 9.20245Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.88511 8.2109C4.85111 8.2109 4.81611 8.2089 4.78111 8.2039C3.00611 7.9549 1.66611 6.4149 1.66211 4.6219C1.66211 2.8369 2.93911 1.3329 4.69711 1.0439C5.11811 0.977903 5.49111 1.2549 5.55911 1.6619C5.62611 2.0709 5.34911 2.4569 4.94111 2.5239C3.91011 2.6929 3.16211 3.5749 3.16211 4.6199C3.16411 5.6699 3.94911 6.5729 4.98811 6.7179C5.39911 6.7749 5.68411 7.1539 5.62711 7.5649C5.57411 7.9399 5.25311 8.2109 4.88511 8.2109Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.912 14.5958C1.823 14.5958 1.733 14.5798 1.645 14.5468C0.214 14.0008 0 13.0078 0 12.4648C0 11.5748 0.509 10.4358 2.933 10.0728C3.346 10.0208 3.724 10.2928 3.786 10.7028C3.847 11.1138 3.564 11.4948 3.155 11.5568C2.057 11.7208 1.5 12.0268 1.5 12.4648C1.5 12.6018 1.5 12.8858 2.179 13.1448C2.566 13.2918 2.761 13.7258 2.613 14.1128C2.499 14.4118 2.214 14.5958 1.912 14.5958Z"
        fill={color}
      />
    </svg>
  );
}

export function SvgParameters({ color = "#292929" }) {
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1035 4.20996H0.75C0.335786 4.20996 0 3.87417 0 3.45996C0 3.04575 0.335786 2.70996 0.75 2.70996H10.1035C10.43 1.55571 11.4912 0.709961 12.75 0.709961C14.0088 0.709961 15.07 1.55571 15.3965 2.70996H16.75C17.1642 2.70996 17.5 3.04575 17.5 3.45996C17.5 3.87417 17.1642 4.20996 16.75 4.20996H15.3965C15.07 5.36421 14.0088 6.20996 12.75 6.20996C11.4912 6.20996 10.43 5.36421 10.1035 4.20996ZM11.5 3.45996C11.5 2.76961 12.0596 2.20996 12.75 2.20996C13.4404 2.20996 14 2.76961 14 3.45996C14 4.15032 13.4404 4.70996 12.75 4.70996C12.0596 4.70996 11.5 4.15032 11.5 3.45996Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.39648 12.21H16.75C17.1642 12.21 17.5 11.8742 17.5 11.46C17.5 11.0457 17.1642 10.71 16.75 10.71H7.39648C7.07002 9.55571 6.00878 8.70996 4.75 8.70996C3.49122 8.70996 2.42998 9.55571 2.10352 10.71H0.75C0.335787 10.71 0 11.0457 0 11.46C0 11.8742 0.335787 12.21 0.75 12.21H2.10352C2.42998 13.3642 3.49122 14.21 4.75 14.21C6.00878 14.21 7.07002 13.3642 7.39648 12.21ZM3.5 11.46C3.5 10.7696 4.05964 10.21 4.75 10.21C5.44036 10.21 6 10.7696 6 11.46C6 12.1503 5.44036 12.71 4.75 12.71C4.05964 12.71 3.5 12.1503 3.5 11.46Z"
        fill={color}
      />
    </svg>
  );
}

export function SvgFormation({ color = "#292929" }) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6391 7.47504L11.8183 6.95996M11.6391 7.47504L19.9325 10.3597C20.3801 10.5154 20.3801 11.1485 19.9325 11.3042L11.6319 14.1913C11.5174 14.2312 11.3929 14.2317 11.2781 14.1929L2.91817 11.367C2.46799 11.2148 2.46399 10.5796 2.91222 10.4217L11.2789 7.47572C11.3954 7.43469 11.5224 7.43444 11.6391 7.47504ZM21.583 10.6866C21.5838 10.6849 21.5842 10.684 21.5842 10.684M1.00002 10.6919C1.00002 10.6919 1.00193 10.6941 1.00465 10.6983M21.536 18.437C21.5927 18.7066 21.387 18.9601 21.1115 18.9601C20.836 18.9601 20.6302 18.7066 20.687 18.437L20.9025 17.413C20.9062 17.3957 20.9189 17.3815 20.9362 17.3785V17.3785C20.9614 17.3742 20.9915 17.3728 21.0239 17.3757C21.1526 17.3872 21.2557 17.4138 21.3167 17.4444V17.4444C21.3242 17.4482 21.3293 17.4553 21.3311 17.4635L21.536 18.437ZM5.96907 15.1598C5.96907 14.7842 6.34001 14.521 6.69458 14.6451L10.9124 16.1214C11.2665 16.2453 11.6525 16.2438 12.0056 16.117L16.0655 14.6596C16.4208 14.5321 16.795 14.7954 16.795 15.1729V17.0273C16.795 17.1986 16.7204 17.3374 16.6133 17.4136C13.7597 19.4444 9.14035 19.7117 6.13929 17.4245C6.03867 17.3478 5.96907 17.2129 5.96907 17.048V15.1598ZM21.1695 15.7344C21.1695 15.7664 21.1436 15.7924 21.1115 15.7924C21.0795 15.7924 21.0535 15.7664 21.0535 15.7344C21.0535 15.7023 21.0795 15.6763 21.1115 15.6763C21.1436 15.6763 21.1695 15.7023 21.1695 15.7344Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function SvgShapeDropdown() {
  return (
    <svg
      width="7"
      height="6"
      viewBox="0 0 7 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.12524 0.000976524C6.82611 0.000976555 7.22036 0.914653 6.86992 1.61335L4.24162 5.07696C3.89119 5.77565 3.05889 5.77565 2.75226 5.07696L0.123964 1.61335C-0.226475 0.914653 0.211574 0.000976266 0.868648 0.000976294L6.12524 0.000976524Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgPerformance() {
  return (
    <svg
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25663 16.2814C2.3106 16.1326 2.45981 16.0348 2.6247 16.0401C2.63738 16.0406 2.64991 16.0417 2.66246 16.0435C2.80276 16.0614 2.9206 16.153 2.96729 16.2804L3.37664 17.4055L4.62579 17.4307C4.78591 17.4337 4.92646 17.533 4.97616 17.6782C5.02573 17.8232 4.97365 17.9825 4.84627 18.0749L3.84924 18.7954L4.21204 19.9355C4.25835 20.0819 4.20238 20.24 4.07275 20.3297C3.94312 20.4194 3.76806 20.4209 3.63667 20.3336L2.61063 19.6533L1.58635 20.3344C1.45471 20.4216 1.27939 20.4197 1.14989 20.3296C1.02025 20.2395 0.964911 20.081 1.01184 19.9348L1.37201 18.7946L0.376745 18.0741C0.250123 17.9814 0.198545 17.8227 0.248116 17.6779C0.29768 17.5332 0.437601 17.4341 0.597229 17.4307L1.84639 17.4065L2.25663 16.2814Z"
        fill="#130F26"
      />
      <path
        d="M7.52016 16.2814C7.57413 16.1326 7.72333 16.0348 7.88823 16.0401C7.90091 16.0406 7.91348 16.0417 7.92602 16.0435C8.06633 16.0614 8.18416 16.153 8.23085 16.2804L8.64019 17.4055L9.88845 17.4307C10.0486 17.4337 10.1891 17.533 10.2388 17.6782C10.2884 17.8232 10.2363 17.9825 10.1089 18.0749L9.11277 18.7954L9.47557 19.9355C9.52188 20.0819 9.46591 20.24 9.33627 20.3297C9.20665 20.4194 9.03158 20.4209 8.9002 20.3336L7.87415 19.6533L6.84901 20.3344C6.71738 20.4224 6.54157 20.4208 6.41168 20.3306C6.28167 20.2403 6.2262 20.0813 6.27364 19.9348L6.63557 18.7946L5.63941 18.0741C5.51278 17.9814 5.46121 17.8227 5.51078 17.6779C5.56034 17.5332 5.70026 17.4341 5.85989 17.4307L7.10905 17.4065L7.52016 16.2814Z"
        fill="#130F26"
      />
      <path
        d="M12.7839 16.2814C12.8378 16.133 12.9866 16.0352 13.1511 16.0401C13.1638 16.0406 13.1763 16.0417 13.1889 16.0435C13.3292 16.0614 13.447 16.153 13.4937 16.2804L13.903 17.4055L15.1522 17.4307C15.3123 17.4336 15.4529 17.533 15.5026 17.6782C15.5521 17.8232 15.5001 17.9825 15.3727 18.0749L14.3756 18.7953L14.7385 19.9355C14.7848 20.0819 14.7288 20.24 14.5992 20.3297C14.4695 20.4194 14.2945 20.4209 14.1631 20.3336L13.1379 19.6533L12.1119 20.3344C11.9802 20.4216 11.8049 20.4197 11.6754 20.3296C11.5458 20.2395 11.4905 20.081 11.5374 19.9348L11.8993 18.7946L10.9032 18.0741C10.7765 17.9815 10.725 17.8229 10.7743 17.6784C10.8237 17.5337 10.9634 17.4345 11.1228 17.4307L12.3728 17.4065L12.7839 16.2814Z"
        fill="#130F26"
      />
      <path
        d="M7.82314 0.034668C5.38651 0.034668 3.39449 1.93579 3.39449 4.25957C3.39449 5.62004 4.08013 6.8316 5.13529 7.6054C2.97542 8.57188 1.47501 10.6583 1.47501 13.0826V14.6873C1.47416 14.8811 1.55457 15.0671 1.69838 15.2042C1.84197 15.3412 2.03726 15.4179 2.24042 15.4173H13.4133C13.8343 15.4156 14.1745 15.0888 14.1728 14.6873V13.0826C14.1728 10.6578 12.6724 8.57166 10.5125 7.60539C11.5677 6.83164 12.2533 5.62002 12.2533 4.25956C12.2533 1.93583 10.2598 0.034668 7.82314 0.034668ZM7.82314 1.48888C9.43585 1.48888 10.7284 2.72153 10.7284 4.25957C10.7284 5.79756 9.43591 7.02881 7.82314 7.02881C6.21037 7.02881 4.91936 5.79756 4.91936 4.25957C4.91936 2.72159 6.21043 1.48888 7.82314 1.48888ZM7.82314 8.48312C10.5093 8.48312 12.6524 10.5212 12.6524 13.0829V13.9634H2.99998V13.0829C2.99998 10.521 5.13698 8.48312 7.82314 8.48312Z"
        fill="#130F26"
      />
    </svg>
  );
}

export function SvgQuestion() {
  return (
    <svg
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.385 13.4934C14.1008 13.9361 14.9257 14.1707 15.7674 14.1711C16.4713 14.1729 17.1656 14.0084 17.7939 13.6911L20.8336 14.7043L19.8204 11.6646C20.1377 11.0363 20.3022 10.342 20.3003 9.63811C20.3 8.79645 20.0654 7.97151 19.6227 7.25568C19.18 6.53984 18.5468 5.9614 17.7939 5.58513C17.1656 5.26778 16.4713 5.10333 15.7674 5.10517H15.5008M15.917 8.09029C15.9198 9.17185 15.6671 10.2388 15.1795 11.2042C14.6013 12.361 13.7125 13.334 12.6125 14.0143C11.5126 14.6945 10.245 15.0551 8.9517 15.0556C7.87015 15.0584 6.80322 14.8057 5.83782 14.3181L1.16699 15.875L2.72393 11.2042C2.23631 10.2388 1.98362 9.17185 1.98644 8.09029C1.98694 6.79701 2.34749 5.52941 3.02772 4.42947C3.70794 3.32953 4.68097 2.44069 5.83782 1.86252C6.80322 1.3749 7.87015 1.1222 8.9517 1.12502H9.36142C11.0694 1.21925 12.6827 1.94017 13.8922 3.14975C15.1018 4.35933 15.8227 5.97256 15.917 7.68057V8.09029Z"
        stroke="#101828"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgShapeDropdownFill({ fill }) {
  return (
    <svg
      width="7"
      height="6"
      viewBox="0 0 7 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={fill}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.12524 0.000976524C6.82611 0.000976555 7.22036 0.914653 6.86992 1.61335L4.24162 5.07696C3.89119 5.77565 3.05889 5.77565 2.75226 5.07696L0.123964 1.61335C-0.226475 0.914653 0.211574 0.000976266 0.868648 0.000976294L6.12524 0.000976524Z"
        fill={fill || "#292929"}
      />
    </svg>
  );
}

export function SvgAddSection() {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="path1"
        d="M44 22.5C44 10.6259 34.3741 1 22.5 1C10.6259 1 1 10.6259 1 22.5C1 34.3741 10.6259 44 22.5 44C34.3741 44 44 34.3741 44 22.5Z"
        fill="#FCB698"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M21.7253 29.5012V23.2795H15.5035C15.2973 23.2795 15.0995 23.1975 14.9536 23.0517C14.8078 22.9058 14.7258 22.708 14.7258 22.5018C14.7258 22.2955 14.8078 22.0977 14.9536 21.9518C15.0995 21.806 15.2973 21.724 15.5035 21.724H21.7253V15.5023C21.7253 15.2961 21.8072 15.0982 21.953 14.9524C22.0989 14.8065 22.2967 14.7246 22.503 14.7246C22.7092 14.7246 22.9071 14.8065 23.0529 14.9524C23.1987 15.0982 23.2807 15.2961 23.2807 15.5023V21.724H29.5024C29.7087 21.724 29.9065 21.806 30.0523 21.9518C30.1982 22.0977 30.2801 22.2955 30.2801 22.5018C30.2801 22.708 30.1982 22.9058 30.0523 23.0517C29.9065 23.1975 29.7087 23.2795 29.5024 23.2795H23.2807V29.5012C23.2807 29.7074 23.1987 29.9053 23.0529 30.0511C22.9071 30.197 22.7092 30.2789 22.503 30.2789C22.2967 30.2789 22.0989 30.197 21.953 30.0511C21.8072 29.9053 21.7253 29.7074 21.7253 29.5012Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function SvgAddLink() {
  return (
    <svg
      width="38"
      height="24"
      viewBox="0 0 38 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.0016 24H10.5018C5.81335 24.0028 1.90816 20.4058 1.52637 15.733C1.14458 11.0601 4.41409 6.87693 9.04077 6.11863C11.1703 2.34298 15.1669 0.00543797 19.5017 8.48981e-05C22.2047 -0.0101322 24.8303 0.902115 26.9446 2.58615C29.0208 4.23293 30.4968 6.51758 31.1446 9.0871C35.0204 9.68264 37.7833 13.1634 37.4836 17.0732C37.1839 20.983 33.9229 24.0021 30.0016 24ZM19.5017 3.00013C16.2493 3.00398 13.2507 4.75828 11.6537 7.59161L10.9518 8.85011L9.52826 9.0826C6.45371 9.5977 4.28582 12.3815 4.53962 15.4886C4.79343 18.5956 7.38437 20.9907 10.5018 21H30.0016C32.3545 21.0024 34.312 19.1919 34.4929 16.846C34.6738 14.5002 33.017 12.4109 30.6916 12.0526L28.7176 11.7526L28.2346 9.8146C27.2375 5.80484 23.6335 2.99258 19.5017 3.00013Z"
        fill="#73C7B7"
      />
      <circle
        cx="8.99993"
        cy="14.9999"
        r="8.99993"
        fill="#73C7B7"
      />
      <path
        d="M8.28697 9.94057L8.28697 14.0022H4.22535V15.5974H8.28697L8.28697 19.659L9.8822 19.659V15.5974L13.9438 15.5974V14.0022L9.8822 14.0022V9.94057L8.28697 9.94057Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgFile() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8498 2.25299H13.4161V0.819286C13.4161 0.368654 13.0474 0 12.597 0H2.15104C1.70044 0 1.33179 0.368654 1.33179 0.819286V13.9277C1.33179 14.3783 1.70044 14.747 2.15107 14.747H3.58481V16.1807C3.58481 16.6313 3.9533 17 4.4041 17H11.3677C11.8181 17 12.4555 16.7473 12.7835 16.4386L15.0721 14.2843C15.4004 13.9757 15.6687 13.3542 15.6687 12.9036L15.6691 3.07235C15.6691 2.62168 15.3004 2.25299 14.8498 2.25299ZM3.58475 3.07231V14.1325H2.15104C2.04004 14.1325 1.94624 14.0387 1.94624 13.9277V0.819286C1.94624 0.708288 2.04004 0.614489 2.15104 0.614489H12.597C12.7078 0.614489 12.8018 0.708288 12.8018 0.819286V2.25303H4.40403C3.95324 2.25303 3.58475 2.62168 3.58475 3.07231ZM14.651 13.8369L12.3623 15.9911C12.3154 16.0351 12.2544 16.0783 12.187 16.1195V14.2349C12.187 14.0942 12.2437 13.9676 12.3373 13.8734C12.4317 13.7798 12.5583 13.7229 12.699 13.7229H14.7482C14.7165 13.7661 14.6839 13.8058 14.651 13.8369ZM15.0542 12.9036C15.0542 12.9644 15.0431 13.0349 15.0264 13.1084H12.699C12.0774 13.1096 11.5737 13.6133 11.5725 14.2349V16.3607C11.4994 16.3755 11.4289 16.3854 11.3677 16.3854H4.40403V16.3855C4.2928 16.3855 4.19924 16.2917 4.19924 16.1807V3.07228C4.19924 2.96128 4.29284 2.86748 4.40403 2.86748H14.8498C14.9608 2.86748 15.0546 2.96128 15.0546 3.07228L15.0542 12.9036Z"
        fill="black"
      />
      <path
        d="M12.5963 5.12109H6.65653C6.48673 5.12109 6.3493 5.25852 6.3493 5.42832C6.3493 5.59812 6.48677 5.73555 6.65653 5.73555H12.5963C12.7659 5.73555 12.9035 5.59812 12.9035 5.42832C12.9035 5.25852 12.7659 5.12109 12.5963 5.12109Z"
        fill="black"
      />
      <path
        d="M12.5963 9.2168H6.65653C6.48673 9.2168 6.3493 9.35422 6.3493 9.52402C6.3493 9.69382 6.48677 9.83125 6.65653 9.83125H12.5963C12.7659 9.83125 12.9035 9.69382 12.9035 9.52402C12.9035 9.35419 12.7659 9.2168 12.5963 9.2168Z"
        fill="black"
      />
      <path
        d="M9.93404 11.2656H6.65696C6.48716 11.2656 6.34973 11.4031 6.34973 11.5729C6.34973 11.7427 6.48716 11.8801 6.65696 11.8801H9.93404C10.1036 11.8801 10.2411 11.7427 10.2411 11.5729C10.2411 11.4031 10.1036 11.2656 9.93404 11.2656Z"
        fill="black"
      />
      <path
        d="M12.5963 7.16797H6.65653C6.48673 7.16797 6.3493 7.3054 6.3493 7.4752C6.3493 7.645 6.48677 7.78242 6.65653 7.78242H12.5963C12.7659 7.78242 12.9035 7.645 12.9035 7.4752C12.9035 7.3054 12.7659 7.16797 12.5963 7.16797Z"
        fill="black"
      />
    </svg>
  );
}

export function SvgRoundEdit() {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="path1"
        d="M13.5 0.5C20.6797 0.5 26.5 6.3203 26.5 13.5C26.5 20.6797 20.6797 26.5 13.5 26.5C6.3203 26.5 0.5 20.6797 0.5 13.5C0.5 6.3203 6.3203 0.5 13.5 0.5Z"
        fill="#FCB698"
        stroke="white"
      />
      <path
        d="M14.7339 9.53128L17.2649 12.0612L10.8582 18.4653L8.32864 15.9353L14.7339 9.53128ZM19.1855 8.92112L18.0567 7.79285C17.6205 7.35681 16.9122 7.35681 16.4745 7.79285L15.3933 8.87362L17.9243 11.4036L19.1855 10.1429C19.5238 9.80471 19.5238 9.25931 19.1855 8.92112ZM7.00411 19.4914C6.95805 19.6986 7.14521 19.8843 7.35254 19.8339L10.1729 19.1503L7.64335 16.6204L7.00411 19.4914Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgRoundDelete() {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="path1"
        d="M13.5 0.5C20.6797 0.5 26.5 6.32036 26.5 13.5001C26.5 20.6799 20.6797 26.5003 13.5 26.5003C6.3203 26.5003 0.5 20.6799 0.5 13.5001C0.5 6.32036 6.3203 0.5 13.5 0.5Z"
        fill="#FCB698"
        stroke="white"
      />
      <path
        d="M9.93972 18.45C9.9408 18.7859 10.0661 19.1078 10.2884 19.3454C10.5106 19.5829 10.8117 19.7169 11.126 19.7181H15.8725C16.1875 19.7181 16.4897 19.5846 16.7128 19.3469C16.9359 19.1092 17.0618 18.7867 17.0629 18.45V10.8388H9.93972V18.45ZM17.6523 8.93624H15.5754L14.9827 8.30176H12.0158L11.4231 8.93624H9.34619V10.2043H17.6523V8.93624Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgVisibilityDocument() {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27 13.5C27 6.04416 20.9558 0 13.5 0C6.04416 0 0 6.04416 0 13.5C0 20.9558 6.04416 27 13.5 27C20.9558 27 27 20.9558 27 13.5Z"
        fill="#73C7B7"
      />
      <path
        d="M13.5 7.99609C9.86985 7.99609 6.57784 9.98136 4.14867 13.206C3.95044 13.4702 3.95044 13.8392 4.14867 14.1034C6.57784 17.3319 9.86985 19.3172 13.5 19.3172C17.1302 19.3172 20.4222 17.3319 22.8513 14.1073C23.0496 13.8431 23.0496 13.474 22.8513 13.2099C20.4222 9.98136 17.1302 7.99609 13.5 7.99609ZM13.7604 17.6427C11.3507 17.7942 9.36069 15.809 9.51227 13.3963C9.63665 11.4072 11.2496 9.79488 13.2396 9.67056C15.6493 9.51904 17.6393 11.5043 17.4877 13.9169C17.3595 15.9022 15.7465 17.5145 13.7604 17.6427ZM13.6399 15.8012C12.3418 15.8828 11.2691 14.8144 11.3546 13.5168C11.4206 12.4445 12.2912 11.5781 13.364 11.5082C14.6621 11.4266 15.7348 12.495 15.6493 13.7926C15.5794 14.8688 14.7088 15.7352 13.6399 15.8012Z"
        fill="#FFF9F9"
      />
    </svg>
  );
}

export function SvgNoVisibilityDocument() {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27 13.5C27 6.04416 20.9558 0 13.5 0C6.04416 0 0 6.04416 0 13.5C0 20.9558 6.04416 27 13.5 27C20.9558 27 27 20.9558 27 13.5Z"
        fill="#D8D8D8"
      />
      <path
        d="M13.5 7.99609C9.86985 7.99609 6.57784 9.98136 4.14867 13.206C3.95044 13.4702 3.95044 13.8392 4.14867 14.1034C6.57784 17.3319 9.86985 19.3172 13.5 19.3172C17.1302 19.3172 20.4222 17.3319 22.8513 14.1073C23.0496 13.8431 23.0496 13.474 22.8513 13.2099C20.4222 9.98136 17.1302 7.99609 13.5 7.99609ZM13.7604 17.6427C11.3507 17.7942 9.36069 15.809 9.51227 13.3963C9.63665 11.4072 11.2496 9.79488 13.2396 9.67056C15.6493 9.51904 17.6393 11.5043 17.4877 13.9169C17.3595 15.9022 15.7465 17.5145 13.7604 17.6427ZM13.6399 15.8012C12.3418 15.8828 11.2691 14.8144 11.3546 13.5168C11.4206 12.4445 12.2912 11.5781 13.364 11.5082C14.6621 11.4266 15.7348 12.495 15.6493 13.7926C15.5794 14.8688 14.7088 15.7352 13.6399 15.8012Z"
        fill="#FFF9F9"
      />
    </svg>
  );
}

export function SvgCloudLink() {
  return (
    <svg
      width="15"
      height="10"
      viewBox="0 0 15 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2468 4.10365L12.2963 4.46422L12.6546 4.52792C13.6442 4.70382 14.5 5.71106 14.5 7C14.5 8.43321 13.4598 9.5 12.334 9.5H2.66602C1.54019 9.5 0.5 8.43321 0.5 7C0.5 5.72255 1.34217 4.72018 2.32111 4.53256L2.74046 4.45219L2.72674 4.02543C2.72661 4.02118 2.72656 4.01515 2.72656 4C2.72656 2.00799 4.13853 0.5 5.74219 0.5C6.78659 0.5 7.75786 1.12047 8.31092 2.17801L8.5754 2.68373L9.04195 2.35506C9.37382 2.12127 9.74947 2 10.1367 2C11.1511 2 12.0763 2.86244 12.2468 4.10365Z"
        fill="white"
        stroke="#000000"
      />
    </svg>
  );
}

export function SvgCloudLinkFile() {
  return (
    <svg
      width="15"
      height="10"
      viewBox="0 0 15 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2468 4.10365L12.2963 4.46422L12.6546 4.52792C13.6442 4.70382 14.5 5.71106 14.5 7C14.5 8.43321 13.4598 9.5 12.334 9.5H2.66602C1.54019 9.5 0.5 8.43321 0.5 7C0.5 5.72255 1.34217 4.72018 2.32111 4.53256L2.74046 4.45219L2.72674 4.02543C2.72661 4.02118 2.72656 4.01515 2.72656 4C2.72656 2.00799 4.13853 0.5 5.74219 0.5C6.78659 0.5 7.75786 1.12047 8.31092 2.17801L8.5754 2.68373L9.04195 2.35506C9.37382 2.12127 9.74947 2 10.1367 2C11.1511 2 12.0763 2.86244 12.2468 4.10365Z"
        fill="#393C40"
        stroke="white"
      />
    </svg>
  );
}

export function SvgAddFile() {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8995 17H1.69993C0.761083 17 0 16.2389 0 15.3001V1.70067C0 0.761823 0.761083 0.00074072 1.69993 0.00074072H7.64967C7.65728 -0.000246907 7.665 -0.000246907 7.67262 0.00074072H7.67772C7.68574 0.00325496 7.694 0.00496332 7.70236 0.0058405C7.77732 0.0106455 7.85133 0.0252181 7.92251 0.0491886H7.93526H7.948H7.9582C7.97389 0.060175 7.98867 0.0723967 8.0024 0.085737C8.095 0.126895 8.17938 0.18449 8.25144 0.25573L13.3512 5.35551C13.4225 5.42757 13.4801 5.51195 13.5212 5.60455C13.5289 5.62325 13.5348 5.6411 13.5408 5.66064V5.67254V5.68444C13.5645 5.75532 13.5785 5.82909 13.5824 5.90373C13.5831 5.9122 13.5852 5.92051 13.5884 5.92838V5.93348C13.5927 5.93871 13.5964 5.94441 13.5994 5.95048V15.3001C13.5994 16.2389 12.8383 17 11.8995 17ZM1.69993 1.70067V15.3001H11.8995V6.80044H7.64967C7.18025 6.80044 6.7997 6.4199 6.7997 5.95048V1.70067H1.69993ZM8.49963 2.90251V5.10052H10.6976L8.49963 2.90251ZM7.64967 13.6001H5.94974V11.9002H4.24981V10.2003H5.94974V8.50037H7.64967V10.2003H9.34959V11.9002H7.64967V13.6001Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function SvgDeplaceFile() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4444 14H1.55556C0.696446 14 0 13.3036 0 12.4444V9.33333H1.55556V12.4444H12.4444V1.55556H1.55556V4.66667H0V1.55556C0 0.696446 0.696446 0 1.55556 0H12.4444C13.3036 0 14 0.696446 14 1.55556V12.4444C14 13.3036 13.3036 14 12.4444 14ZM6.22222 10.1111V7.77778H0V6.22222H6.22222V3.88889L10.1111 7L6.22222 10.1111Z"
        fill="#2E3A59"
      />
    </svg>
  );
}

export function SvgDeplaceDocument() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4444 14H1.55556C0.696446 14 0 13.3036 0 12.4444V9.33333H1.55556V12.4444H12.4444V1.55556H1.55556V4.66667H0V1.55556C0 0.696446 0.696446 0 1.55556 0H12.4444C13.3036 0 14 0.696446 14 1.55556V12.4444C14 13.3036 13.3036 14 12.4444 14ZM6.22222 10.1111V7.77778H0V6.22222H6.22222V3.88889L10.1111 7L6.22222 10.1111Z"
        fill="#2E3A59"
      />
    </svg>
  );
}

export function SvgRenameFile() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8307 4.83333H4.33073C3.39731 4.83333 2.9306 4.83333 2.57408 5.01499C2.26047 5.17478 2.00551 5.42975 1.84572 5.74335C1.66406 6.09987 1.66406 6.56658 1.66406 7.5V10.5C1.66406 11.4334 1.66406 11.9001 1.84572 12.2567C2.00551 12.5703 2.26047 12.8252 2.57408 12.985C2.9306 13.1667 3.39731 13.1667 4.33073 13.1667H10.8307M14.1641 4.83333H15.6641C16.5975 4.83333 17.0642 4.83333 17.4207 5.01499C17.7343 5.17478 17.9893 5.42975 18.1491 5.74335C18.3307 6.09987 18.3307 6.56658 18.3307 7.5V10.5C18.3307 11.4334 18.3307 11.9001 18.1491 12.2567C17.9893 12.5703 17.7343 12.8252 17.4207 12.985C17.0642 13.1667 16.5975 13.1667 15.6641 13.1667H14.1641M14.1641 16.5L14.1641 1.5M16.2474 1.50001L12.0807 1.5M16.2474 16.5L12.0807 16.5"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgTriangleRightFolder() {
  return (
    <svg
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33552 5.18866L0.998021 0.386126C0.965185 0.361272 0.926787 0.346764 0.886985 0.344171C0.847182 0.341578 0.807493 0.351 0.772215 0.371416C0.736937 0.391833 0.707414 0.422465 0.686844 0.459997C0.666274 0.497528 0.655441 0.540528 0.655518 0.584339L0.655518 10.1894C0.655586 10.2332 0.666525 10.276 0.687153 10.3134C0.70778 10.3509 0.737315 10.3814 0.772567 10.4017C0.807819 10.422 0.84745 10.4313 0.887183 10.4287C0.926916 10.4261 0.965241 10.4116 0.998021 10.3868L7.33552 5.58335C7.36469 5.56127 7.38855 5.53174 7.40503 5.49728C7.42151 5.46283 7.43012 5.42449 7.43012 5.38557C7.43012 5.34665 7.42151 5.30831 7.40503 5.27385C7.38855 5.2394 7.36469 5.21074 7.33552 5.18866Z"
        fill="#73C7B7"
      />
    </svg>
  );
}

export function SvgDossierEmployer() {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.76174 3.18882C5.17569 2.74728 5.76028 2.4894 6.36544 2.4894H14.6966V0.762789C14.6966 0.339538 14.3441 0 13.9209 0H2.53886C2.11541 0 1.78149 0.339538 1.78149 0.762789V4.16544H3.85061L4.76174 3.18882Z"
        fill="white"
      />
      <path
        d="M16.2653 4.17856C16.2078 4.11377 16.1401 4.05902 16.0658 4.0176C15.953 3.95493 15.825 3.91927 15.693 3.91927H6.3655C6.16346 3.91927 5.97034 4.00039 5.82729 4.14155C5.82008 4.14856 5.81304 4.1563 5.80621 4.16348L5.49388 4.49722L4.69842 5.34605C4.68017 5.36535 4.66121 5.3871 4.64138 5.40451C4.50288 5.52479 4.3245 5.59534 4.13913 5.59534H4.13896H0.766683C0.575279 5.59534 0.392529 5.66343 0.252444 5.79035C0.229983 5.81018 0.208903 5.83005 0.188867 5.85288C0.174824 5.86901 0.161826 5.8848 0.14903 5.90201C0.031776 6.06176 -0.020015 6.26101 0.00702543 6.45905L0.898687 12.998C1.01874 13.8782 1.69182 14.5676 2.53835 14.7249C2.65931 14.7474 2.78377 14.7641 2.91072 14.7641H13.4932C14.4281 14.7641 15.2282 14.1242 15.4583 13.2422C15.482 13.1511 15.4995 13.0548 15.5106 12.9587L16.0247 8.50396L16.4548 4.77709C16.457 4.7553 16.4584 4.73355 16.459 4.71213C16.4649 4.51685 16.3963 4.32572 16.2653 4.17856Z"
        fill="white"
      />
    </svg>
  );
}

//Modal HourPorpriety
export function SvgHour() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.88095 20C4.42385 20 0 15.5228 0 10C0 4.47715 4.42385 0 9.88095 0C15.338 0 19.7619 4.47715 19.7619 10C19.7559 15.5203 15.3356 19.9939 9.88095 20ZM9.88095 2C5.51527 2 1.97619 5.58172 1.97619 10C1.97619 14.4183 5.51527 18 9.88095 18C14.2466 18 17.7857 14.4183 17.7857 10C17.7808 5.58378 14.2446 2.00496 9.88095 2ZM14.8214 11H8.89285V5H10.869V9H14.8214V11Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgLieu() {
  return (
    <svg
      width="10"
      height="13"
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.30542 2.56867C8.42283 0.99766 6.85516 0.0378662 5.11188 0.00118652C5.03746 -0.000395507 4.96256 -0.000395507 4.88811 0.00118652C3.14486 0.0378662 1.57719 0.99766 0.694571 2.56867C-0.207592 4.17449 -0.232275 6.1034 0.628532 7.72852L4.23477 12.5367C4.23639 12.5397 4.23801 12.5428 4.23968 12.5458C4.39835 12.8302 4.68258 13 5.00005 13C5.31749 13 5.60173 12.8302 5.76037 12.5458C5.76204 12.5428 5.76366 12.5397 5.76528 12.5367L9.37152 7.72852C10.2323 6.1034 10.2076 4.17449 9.30542 2.56867ZM5 6.79688C3.87234 6.79688 2.95492 5.85062 2.95492 4.68751C2.95492 3.5244 3.87234 2.57814 5 2.57814C6.12766 2.57814 7.04507 3.5244 7.04507 4.68751C7.04507 5.85062 6.12769 6.79688 5 6.79688Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function SvgRepas() {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1261 0.048395C10.9935 -0.0228901 10.8313 -0.0148783 10.7051 0.0688208C8.83447 1.31591 8.06152 2.92777 8.06152 4.68469V8.64056C8.06152 8.86726 8.24497 9.05071 8.47168 9.05071H9.70215V13.1796C9.70215 13.6326 10.0694 13.9999 10.5225 13.9999C10.9755 13.9999 11.3428 13.6326 11.3428 13.1796C11.3428 6.62068 11.3428 6.84577 11.3428 0.410098C11.3428 0.258696 11.2595 0.119707 11.1261 0.048395Z"
        fill="#393C40"
      />
      <path
        d="M3.6914 0.000244141C3.4647 0.000244141 3.28125 0.183693 3.28125 0.4104V3.28149H2.46093V0.4104C2.46093 0.183693 2.27749 0.000244141 2.05078 0.000244141C1.82407 0.000244141 1.64062 0.183693 1.64062 0.4104V3.28149H0.820312V0.4104C0.820312 0.183693 0.636863 0.000244141 0.410156 0.000244141C0.183449 0.000244141 0 0.183693 0 0.4104C0 2.23376 0 2.68748 0 4.51196C0 5.19047 0.55196 5.76977 1.23047 5.76977H2.87109C3.5496 5.76977 4.10156 5.19047 4.10156 4.51196C4.10156 2.68685 4.10156 2.23477 4.10156 0.4104C4.10156 0.183693 3.91811 0.000244141 3.6914 0.000244141Z"
        fill="#393C40"
      />
      <path
        d="M1.23145 6.58984V13.1797C1.23145 13.6327 1.5987 14 2.05176 14C2.50481 14 2.87207 13.6327 2.87207 13.1797V6.58984H1.23145Z"
        fill="#393C40"
      />
    </svg>
  );
}

//End Modal HourPorpriety
export function SvgCalendar() {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 20H2C0.89543 20 0 19.1046 0 18V4C0 2.89543 0.89543 2 2 2H4V0H6V2H12V0H14V2H16C17.1046 2 18 2.89543 18 4V18C18 19.1046 17.1046 20 16 20ZM2 8V18H16V8H2ZM2 4V6H16V4H2ZM14 16H12V14H14V16ZM10 16H8V14H10V16ZM6 16H4V14H6V16ZM14 12H12V10H14V12ZM10 12H8V10H10V12ZM6 12H4V10H6V12Z"
        fill="#292929"
      />
    </svg>
  );
}

// Shape Input Number
export function SvgShapeDown() {
  return (
    <svg
      id="shapeDown"
      width="9"
      height="5"
      viewBox="0 0 9 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.67649 4.93018L8.96218 0.252785C8.98436 0.22855 8.99731 0.200211 8.99962 0.170835C9.00194 0.141458 8.99353 0.112166 8.97531 0.0861286C8.95709 0.0600914 8.92976 0.0383022 8.89626 0.0231206C8.86277 0.00793901 8.8244 -5.63814e-05 8.7853 2.89401e-07L0.213918 -1.01627e-07C0.174888 5.01564e-05 0.136617 0.00812324 0.103236 0.0233477C0.0698557 0.0385722 0.0426331 0.0603699 0.0245075 0.0863878C0.00638198 0.112406 -0.0019579 0.141656 0.000387185 0.17098C0.00273227 0.200305 0.0156727 0.228591 0.0378141 0.252785L4.32429 4.93018C4.34398 4.95171 4.37034 4.96932 4.40109 4.98148C4.43183 4.99364 4.46605 5 4.50078 5C4.53551 5 4.56973 4.99364 4.60047 4.98148C4.63122 4.96932 4.65679 4.95171 4.67649 4.93018Z"
        fill="#FCB698"
      />
    </svg>
  );
}

export function SvgShapeUp() {
  return (
    <svg
      id="shapeUp"
      width="9"
      height="5"
      viewBox="0 0 9 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.67649 0.0698192L8.96218 4.74722C8.98436 4.77145 8.99731 4.79979 8.99962 4.82917C9.00194 4.85854 8.99353 4.88783 8.97531 4.91387C8.95709 4.93991 8.92976 4.9617 8.89626 4.97688C8.86277 4.99206 8.8244 5.00006 8.7853 5L0.213918 5C0.174888 4.99995 0.136617 4.99188 0.103236 4.97665C0.0698557 4.96143 0.0426331 4.93963 0.0245075 4.91361C0.00638198 4.88759 -0.0019579 4.85834 0.000387185 4.82902C0.00273227 4.79969 0.0156727 4.77141 0.0378141 4.74722L4.32429 0.0698192C4.34398 0.0482867 4.37034 0.0306804 4.40109 0.0185177C4.43183 0.00635502 4.46605 -2.69997e-07 4.50078 -2.71582e-07C4.53551 -2.73166e-07 4.56973 0.00635501 4.60047 0.0185177C4.63122 0.0306804 4.65679 0.0482866 4.67649 0.0698192Z"
        fill="#FCB698"
      />
    </svg>
  );
}

export function SvgShapeUpBlack() {
  return (
    <svg
      width="8"
      height="7"
      viewBox="0 0 8 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.54127 6.5C0.84039 6.5 0.446146 5.58795 0.796585 4.8905L3.42488 1.43307C3.77532 0.735621 4.60761 0.735621 4.91425 1.43307L7.54254 4.8905C7.89298 5.58795 7.45493 6.5 6.79786 6.5L1.54127 6.5Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgShapeDownBlack() {
  return (
    <svg
      width="8"
      height="7"
      viewBox="0 0 8 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.79174 0.5C7.49262 0.5 7.88686 1.41205 7.53642 2.1095L4.90813 5.56693C4.55769 6.26438 3.7254 6.26438 3.41876 5.56693L0.790468 2.1095C0.440029 1.41205 0.878078 0.5 1.53515 0.5L6.79174 0.5Z"
        fill="#292929"
      />
    </svg>
  );
}

// End Shape Input Number
// Notifications Icones
export function SvgMyCompte({ fill, classParent }) {
  return (
    <div className={classParent}>
      <svg
        width="12"
        height="14"
        viewBox="0 0 12 14"
        fill="none"
        className={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.93028 6.74492C5.00368 6.74492 4.20132 6.41259 3.54573 5.7569C2.89015 5.10132 2.55782 4.29918 2.55782 3.37248C2.55782 2.4461 2.89015 1.64384 3.54584 0.988049C4.20153 0.332575 5.00378 0.000244141 5.93028 0.000244141C6.85698 0.000244141 7.65913 0.332575 8.31471 0.988156C8.9703 1.64374 9.30273 2.44599 9.30273 3.37248C9.30273 4.29918 8.9703 5.10143 8.3146 5.75701C7.65891 6.41248 6.85666 6.74492 5.93028 6.74492Z"
          fill={fill || "#AAB1B4"}
        />
        <path
          d="M0.0282297 10.765C0.0471382 10.4921 0.0853815 10.1945 0.141678 9.88024C0.198508 9.56362 0.271684 9.26429 0.35928 8.99072C0.44976 8.70795 0.572823 8.42871 0.724941 8.16112C0.882828 7.88337 1.06828 7.64152 1.27637 7.44251C1.49397 7.23431 1.76039 7.06692 2.06848 6.94482C2.37549 6.82336 2.71573 6.76183 3.07968 6.76183C3.22261 6.76183 3.36084 6.82047 3.6278 6.99428C3.79209 7.10142 3.98427 7.22534 4.19878 7.36239C4.38219 7.47926 4.63067 7.58875 4.93758 7.68789C5.23701 7.78478 5.54103 7.83392 5.8411 7.83392C6.14117 7.83392 6.44509 7.78478 6.74484 7.68789C7.05143 7.58886 7.2999 7.47936 7.48311 7.3625C7.69558 7.22673 7.88786 7.10281 8.05462 6.99417C8.32125 6.82037 8.45959 6.76172 8.60252 6.76172C8.96658 6.76172 9.30671 6.82336 9.61362 6.94492C9.92149 7.06681 10.188 7.2342 10.4058 7.44262C10.6138 7.64174 10.7994 7.88348 10.957 8.16112C11.1091 8.42871 11.2321 8.70785 11.3227 8.99082C11.4102 9.2644 11.4834 9.56362 11.5402 9.88024C11.5965 10.1941 11.6347 10.4918 11.6537 10.7653C11.6722 11.0332 11.6816 11.3113 11.6816 11.5921C11.6816 12.323 11.4493 12.9147 10.9911 13.3511C10.5386 13.7817 9.93986 14.0001 9.21174 14.0001H2.46982C1.7417 14.0001 1.14316 13.7818 0.690543 13.3511C0.232265 12.915 -7.9155e-05 12.3232 -7.9155e-05 11.592C2.76566e-05 11.3099 0.00953579 11.0316 0.0282297 10.765Z"
          fill={fill || "#AAB1B4"}
        />
      </svg>
    </div>
  );
}

export function SvgEntreprise({ fill }) {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      className={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0392 3.36386C10.8084 3.84614 11.3477 4.66227 11.4459 5.60961C11.7596 5.75619 12.1078 5.84048 12.4769 5.84048C13.8246 5.84048 14.9168 4.74822 14.9168 3.40081C14.9168 2.05319 13.8246 0.960938 12.4769 0.960938C11.1422 0.961353 10.0595 2.03409 10.0392 3.36386ZM8.44073 8.35945C9.78835 8.35945 10.8806 7.26699 10.8806 5.91958C10.8806 4.57217 9.78814 3.47991 8.44073 3.47991C7.09332 3.47991 6.00044 4.57237 6.00044 5.91979C6.00044 7.2672 7.09332 8.35945 8.44073 8.35945ZM9.47569 8.52575H7.40536C5.6828 8.52575 4.2814 9.92735 4.2814 11.6499V14.1818L4.28784 14.2214L4.46224 14.276C6.10612 14.7897 7.53429 14.9609 8.7098 14.9609C11.0058 14.9609 12.3366 14.3063 12.4186 14.2646L12.5816 14.1822H12.599V11.6499C12.5996 9.92735 11.1983 8.52575 9.47569 8.52575ZM13.5123 6.00698H11.458C11.4358 6.82893 11.0849 7.56907 10.5299 8.10139C12.0611 8.55668 13.1814 9.97655 13.1814 11.6537V12.4339C15.2098 12.3595 16.3786 11.7847 16.4557 11.746L16.6186 11.6634H16.6361V9.13074C16.6361 7.40837 15.2347 6.00698 13.5123 6.00698ZM4.15954 5.84089C4.63684 5.84089 5.08092 5.70158 5.45712 5.46428C5.57671 4.68428 5.99484 4.00268 6.59214 3.53846C6.59464 3.49278 6.59899 3.44752 6.59899 3.40143C6.59899 2.05382 5.50653 0.96156 4.15954 0.96156C2.81171 0.96156 1.71966 2.05382 1.71966 3.40143C1.71966 4.74843 2.81171 5.84089 4.15954 5.84089ZM6.35069 8.10139C5.79844 7.57177 5.44882 6.83557 5.42328 6.01861C5.34708 6.013 5.27172 6.00698 5.19407 6.00698H3.12396C1.40139 6.00698 0 7.40837 0 9.13074V11.663L0.00643602 11.702L0.180831 11.757C1.49959 12.1687 2.67655 12.3585 3.69884 12.4183V11.6537C3.69926 9.97655 4.81912 8.5571 6.35069 8.10139Z"
        fill={fill || "#AAB1B4"}
        fillOpacity="0.65"
      />
    </svg>
    // <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    //     <path d="M5.93028 6.74492C5.00368 6.74492 4.20132 6.41259 3.54573 5.7569C2.89015 5.10132 2.55782 4.29918 2.55782 3.37248C2.55782 2.4461 2.89015 1.64384 3.54584 0.988049C4.20153 0.332575 5.00378 0.000244141 5.93028 0.000244141C6.85698 0.000244141 7.65913 0.332575 8.31471 0.988156C8.9703 1.64374 9.30273 2.44599 9.30273 3.37248C9.30273 4.29918 8.9703 5.10143 8.3146 5.75701C7.65891 6.41248 6.85666 6.74492 5.93028 6.74492Z" fill="#AAB1B4" />
    //     <path d="M0.0282297 10.765C0.0471382 10.4921 0.0853815 10.1945 0.141678 9.88024C0.198508 9.56362 0.271684 9.26429 0.35928 8.99072C0.44976 8.70795 0.572823 8.42871 0.724941 8.16112C0.882828 7.88337 1.06828 7.64152 1.27637 7.44251C1.49397 7.23431 1.76039 7.06692 2.06848 6.94482C2.37549 6.82336 2.71573 6.76183 3.07968 6.76183C3.22261 6.76183 3.36084 6.82047 3.6278 6.99428C3.79209 7.10142 3.98427 7.22534 4.19878 7.36239C4.38219 7.47926 4.63067 7.58875 4.93758 7.68789C5.23701 7.78478 5.54103 7.83392 5.8411 7.83392C6.14117 7.83392 6.44509 7.78478 6.74484 7.68789C7.05143 7.58886 7.2999 7.47936 7.48311 7.3625C7.69558 7.22673 7.88786 7.10281 8.05462 6.99417C8.32125 6.82037 8.45959 6.76172 8.60252 6.76172C8.96658 6.76172 9.30671 6.82336 9.61362 6.94492C9.92149 7.06681 10.188 7.2342 10.4058 7.44262C10.6138 7.64174 10.7994 7.88348 10.957 8.16112C11.1091 8.42871 11.2321 8.70785 11.3227 8.99082C11.4102 9.2644 11.4834 9.56362 11.5402 9.88024C11.5965 10.1941 11.6347 10.4918 11.6537 10.7653C11.6722 11.0332 11.6816 11.3113 11.6816 11.5921C11.6816 12.323 11.4493 12.9147 10.9911 13.3511C10.5386 13.7817 9.93986 14.0001 9.21174 14.0001H2.46982C1.7417 14.0001 1.14316 13.7818 0.690543 13.3511C0.232265 12.915 -7.9155e-05 12.3232 -7.9155e-05 11.592C2.76566e-05 11.3099 0.00953579 11.0316 0.0282297 10.765Z" fill="#AAB1B4" />
    // </svg>
  );
}

export function NewSvgEnterprise({ fill, classParent }) {
  return (
    <div className={classParent}>
      <svg
        width="15"
        height="13"
        viewBox="0 0 15 13"
        fill="none"
        className={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.49992 0.5C3.65897 0.5 2.16659 1.99238 2.16659 3.83333C2.16659 5.67428 3.65897 7.16667 5.49992 7.16667C7.34087 7.16667 8.83325 5.67428 8.83325 3.83333C8.83325 1.99238 7.34087 0.5 5.49992 0.5ZM3.49992 3.83333C3.49992 2.72876 4.39535 1.83333 5.49992 1.83333C6.60449 1.83333 7.49992 2.72876 7.49992 3.83333C7.49992 4.9379 6.60449 5.83333 5.49992 5.83333C4.39535 5.83333 3.49992 4.9379 3.49992 3.83333Z"
          fill={fill || "#2E3A59"}
        />
        <path
          d="M10.7722 3.97885C10.5846 3.88323 10.3771 3.83337 10.1666 3.83337V2.50004C10.5876 2.50004 11.0027 2.59971 11.3778 2.79097C11.4192 2.81203 11.4599 2.83414 11.4999 2.85727C11.8235 3.04409 12.1047 3.29713 12.3248 3.60037C12.5721 3.94115 12.7352 4.33565 12.8007 4.75158C12.8663 5.16751 12.8324 5.59305 12.7019 5.99337C12.5713 6.39369 12.3479 6.75741 12.0497 7.05475C11.7516 7.3521 11.3873 7.57462 10.9866 7.70411C10.6301 7.81933 10.2538 7.85797 9.88228 7.81814C9.8363 7.8132 9.79039 7.80707 9.7446 7.79973C9.32912 7.73315 8.9353 7.56919 8.59533 7.32126L8.59464 7.32076L9.38061 6.24371C9.55067 6.36781 9.74772 6.44985 9.9556 6.48316C10.1635 6.51648 10.3763 6.50009 10.5766 6.43535C10.7769 6.37061 10.9591 6.25935 11.1081 6.11068C11.2572 5.96201 11.3689 5.78016 11.4342 5.58001C11.4995 5.37985 11.5164 5.16709 11.4836 4.95913C11.4509 4.75117 11.3693 4.55393 11.2457 4.38354C11.122 4.21316 10.9598 4.07448 10.7722 3.97885Z"
          fill={fill || "#2E3A59"}
        />
        <path
          d="M12.832 12.5C12.832 12.15 12.763 11.8034 12.6291 11.48C12.4951 11.1566 12.2988 10.8628 12.0513 10.6153C11.8038 10.3678 11.51 10.1714 11.1866 10.0375C10.8632 9.90354 10.5166 9.8346 10.1666 9.8346V8.5C10.6213 8.5 11.0722 8.57753 11.4999 8.72876C11.5663 8.75223 11.6321 8.77748 11.6973 8.80448C12.1826 9.0055 12.6236 9.30014 12.995 9.67157C13.3664 10.043 13.6611 10.484 13.8621 10.9693C13.8891 11.0345 13.9144 11.1003 13.9378 11.1667C14.0891 11.5944 14.1666 12.0453 14.1666 12.5H12.832Z"
          fill={fill || "#2E3A59"}
        />
        <path
          d="M10.1666 12.5H8.83325C8.83325 10.6591 7.34087 9.16667 5.49992 9.16667C3.65897 9.16667 2.16659 10.6591 2.16659 12.5H0.833252C0.833252 9.92267 2.92259 7.83333 5.49992 7.83333C8.07725 7.83333 10.1666 9.92267 10.1666 12.5Z"
          fill={fill || "#2E3A59"}
        />
      </svg>
    </div>
  );
}

// End Notificatins Icones
// Recruitments Icones
export function SvgRecruitments({ color = "#292929" }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.75 0.935059C5.40279 0.935059 3.5 2.83785 3.5 5.18506C3.5 7.53227 5.40279 9.43506 7.75 9.43506C10.0972 9.43506 12 7.53227 12 5.18506C12 2.83785 10.0972 0.935059 7.75 0.935059ZM5 5.18506C5 3.66628 6.23122 2.43506 7.75 2.43506C9.26878 2.43506 10.5 3.66628 10.5 5.18506C10.5 6.70384 9.26878 7.93506 7.75 7.93506C6.23122 7.93506 5 6.70384 5 5.18506Z"
        fill={color}
      />
      <path
        d="M1.5 14.6851C1.5 13.4424 2.50736 12.4351 3.75 12.4351H4.09087C4.11722 12.4351 4.14342 12.4392 4.16847 12.4474L5.03398 12.73C5.71351 12.9519 6.41343 13.0884 7.11804 13.1394C7.26632 13.1501 7.39645 13.046 7.42996 12.9011C7.50553 12.5744 7.60397 12.2565 7.72351 11.9491C7.77628 11.8133 7.67712 11.6633 7.53158 11.6589C6.84499 11.6382 6.16064 11.52 5.49959 11.3041L4.63407 11.0215C4.45869 10.9642 4.27536 10.9351 4.09087 10.9351H3.75C1.67893 10.9351 0 12.614 0 14.6851V15.8733C0 16.6266 0.545884 17.2688 1.28927 17.3902C3.44742 17.7425 5.62718 17.9172 7.80675 17.9141C7.95885 17.9139 8.05437 17.7496 7.9863 17.6136C7.83946 17.3201 7.71263 17.0149 7.6076 16.6998C7.55142 16.5312 7.39688 16.4129 7.21922 16.4105C5.31646 16.3843 3.41516 16.2174 1.53097 15.9098C1.51311 15.9069 1.5 15.8914 1.5 15.8733V14.6851Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.25 19.985C17.2876 19.985 19.75 17.5226 19.75 14.485C19.75 11.4474 17.2876 8.98502 14.25 8.98502C11.2124 8.98502 8.75 11.4474 8.75 14.485C8.75 17.5226 11.2124 19.985 14.25 19.985ZM14.25 18.485C16.4591 18.485 18.25 16.6942 18.25 14.485C18.25 12.2759 16.4591 10.485 14.25 10.485C12.0409 10.485 10.25 12.2759 10.25 14.485C10.25 16.6942 12.0409 18.485 14.25 18.485Z"
        fill={color}
      />
      <path
        d="M14.3125 11.4141C14.7267 11.4141 15.0625 11.7499 15.0625 12.1641V13.9141H16.8125C17.2267 13.9141 17.5625 14.2499 17.5625 14.6641C17.5625 15.0783 17.2267 15.4141 16.8125 15.4141H15.0625V17.1641C15.0625 17.5783 14.7267 17.9141 14.3125 17.9141C13.8983 17.9141 13.5625 17.5783 13.5625 17.1641V15.4141H11.8125C11.3983 15.4141 11.0625 15.0783 11.0625 14.6641C11.0625 14.2499 11.3983 13.9141 11.8125 13.9141H13.5625V12.1641C13.5625 11.7499 13.8983 11.4141 14.3125 11.4141Z"
        fill={color}
      />
    </svg>
  );
}

export function SvgUploadCV() {
  return (
    <svg
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.53088 0.0866005C6.47389 0.0305191 6.3971 -0.000615175 6.31729 9.21327e-06C6.23713 3.75946e-05 6.16029 0.0320517 6.10369 0.0890129L0.0856585 6.14612C-0.0306413 6.26583 -0.0282089 6.45752 0.0910889 6.57422C0.146835 6.62874 0.221417 6.65953 0.299252 6.66016H3.61778V11.416C3.61778 11.5832 3.75286 11.7188 3.91948 11.7188H8.74646C8.91307 11.7188 9.04815 11.5832 9.04815 11.416V6.66016H12.354C12.5206 6.66047 12.6559 6.52515 12.6562 6.35795C12.6564 6.27735 12.6245 6.20001 12.5676 6.14308L6.53088 0.0866005Z"
        fill="white"
      />
      <rect
        y="13.125"
        width="12.6562"
        height="1.875"
        fill="white"
      />
    </svg>
  );
}

export function SvgAddEtiquette() {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 14.5C28 7.04416 21.9558 1 14.5 1C7.04416 1 1 7.04416 1 14.5C1 21.9558 7.04416 28 14.5 28C21.9558 28 28 21.9558 28 14.5Z"
        fill="#73C7B7"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M14.0136 18.8962V14.9896H10.107C9.97747 14.9896 9.85326 14.9381 9.76168 14.8465C9.6701 14.755 9.61865 14.6308 9.61865 14.5012C9.61865 14.3717 9.6701 14.2475 9.76168 14.1559C9.85326 14.0644 9.97747 14.0129 10.107 14.0129H14.0136V10.1063C14.0136 9.97674 14.0651 9.85253 14.1567 9.76095C14.2483 9.66937 14.3725 9.61792 14.502 9.61792C14.6315 9.61792 14.7557 9.66937 14.8473 9.76095C14.9389 9.85253 14.9903 9.97674 14.9903 10.1063V14.0129H18.897C19.0265 14.0129 19.1507 14.0644 19.2423 14.1559C19.3338 14.2475 19.3853 14.3717 19.3853 14.5012C19.3853 14.6308 19.3338 14.755 19.2423 14.8465C19.1507 14.9381 19.0265 14.9896 18.897 14.9896H14.9903V18.8962C14.9903 19.0257 14.9389 19.15 14.8473 19.2415C14.7557 19.3331 14.6315 19.3846 14.502 19.3846C14.3725 19.3846 14.2483 19.3331 14.1567 19.2415C14.0651 19.15 14.0136 19.0257 14.0136 18.8962Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function SvgDeleteEtiquette() {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.8875 4.5L1.13125 1.74375C0.95625 1.56875 0.95625 1.30625 1.13125 1.13125C1.30625 0.95625 1.56875 0.95625 1.74375 1.13125L4.5 3.8875L7.25625 1.13125C7.43125 0.95625 7.69375 0.95625 7.86875 1.13125C8.04375 1.30625 8.04375 1.56875 7.86875 1.74375L5.1125 4.5L7.86875 7.25625C8.04375 7.43125 8.04375 7.69375 7.86875 7.86875C7.69375 8.04375 7.43125 8.04375 7.25625 7.86875L4.5 5.1125L1.74375 7.86875C1.56875 8.04375 1.30625 8.04375 1.13125 7.86875C0.95625 7.69375 0.95625 7.43125 1.13125 7.25625L3.8875 4.5Z"
        fill="#48B19D"
        stroke="#48B19D"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function SvgCommentaireCV() {
  return (
    <svg
      width="28"
      height="25"
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.04031 24.4328H2.07407L3.46441 23.0425C4.21406 22.2928 4.68219 21.3178 4.80805 20.26C1.59774 18.1533 0 15.1013 0 11.9016C0 5.99874 5.42533 0 13.922 0C22.9233 0 27.75 5.51996 27.75 11.3845C27.75 17.2877 22.8723 22.8039 13.922 22.8039C12.3541 22.8039 10.7181 22.5946 9.25737 22.2106C7.87463 23.6288 6.00113 24.4328 4.04031 24.4328Z"
        fill="#73C7B7"
      />
      <path
        d="M13.56 13.12C14.4216 13.12 15.12 12.4216 15.12 11.56C15.12 10.6984 14.4216 10 13.56 10C12.6984 10 12 10.6984 12 11.56C12 12.4216 12.6984 13.12 13.56 13.12Z"
        fill="white"
      />
      <path
        d="M19.56 13.12C20.4216 13.12 21.12 12.4216 21.12 11.56C21.12 10.6984 20.4216 10 19.56 10C18.6984 10 18 10.6984 18 11.56C18 12.4216 18.6984 13.12 19.56 13.12Z"
        fill="white"
      />
      <path
        d="M7.56 13.12C8.42156 13.12 9.12 12.4216 9.12 11.56C9.12 10.6984 8.42156 10 7.56 10C6.69844 10 6 10.6984 6 11.56C6 12.4216 6.69844 13.12 7.56 13.12Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgRoundPipeline() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25C19.4036 25 25 19.4036 25 12.5Z"
        fill="#73C7B7"
      />
      <g clipPath="url(#clip0)">
        <path
          d="M18.812 12.6455C18.7999 12.6374 18.7874 12.6299 18.7746 12.6231L17.923 12.1646L13.2006 14.6648C13.0751 14.7313 12.9249 14.7313 12.7994 14.6648L8.07704 12.1646L7.22546 12.6231C7.01849 12.733 6.93974 12.9898 7.0496 13.1968C7.05643 13.2096 7.06392 13.2221 7.07203 13.2343L13 16.3727L18.928 13.2343C19.0585 13.0397 19.0066 12.7761 18.812 12.6455Z"
          fill="white"
        />
        <path
          d="M18.9482 15.3675C18.9085 15.2939 18.8481 15.2336 18.7746 15.1939L17.923 14.7354L13.2006 17.2356C13.0751 17.3021 12.9249 17.3021 12.7995 17.2356L8.07704 14.7354L7.22545 15.1939C7.01715 15.3063 6.93946 15.5663 7.05188 15.7746C7.09158 15.8482 7.15193 15.9085 7.22545 15.9482L12.7969 18.9482C12.9237 19.0165 13.0764 19.0165 13.2032 18.9482L18.7746 15.9482C18.9829 15.8358 19.0606 15.5758 18.9482 15.3675Z"
          fill="white"
        />
        <path
          d="M18.812 10.0741C18.7999 10.066 18.7874 10.0585 18.7745 10.0517L13.2031 7.0517C13.0763 6.98342 12.9236 6.98342 12.7968 7.0517L7.2254 10.0517C7.01843 10.1616 6.93968 10.4184 7.04954 10.6254C7.05637 10.6382 7.06385 10.6507 7.07197 10.6628L12.9999 13.8013L18.9279 10.6628C19.0585 10.4683 19.0066 10.2047 18.812 10.0741Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(7 7)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgRoundCalendar() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25C19.4036 25 25 19.4036 25 12.5Z"
        fill="#73C7B7"
      />
      <path
        d="M17.675 8.86871C17.5088 8.70769 17.3117 8.62717 17.0841 8.62717H16.2439V8.01697C16.2439 7.73736 16.1409 7.49793 15.9353 7.29878C15.7294 7.09962 15.4823 7 15.1933 7H14.7733C14.4843 7 14.2371 7.09962 14.0314 7.2988C13.8256 7.49793 13.7227 7.73738 13.7227 8.01699V8.62719H11.2018V8.01699C11.2018 7.73738 11.0989 7.49796 10.8932 7.2988C10.6875 7.09962 10.4402 7 10.1513 7H9.73116C9.44231 7 9.195 7.09962 8.98926 7.2988C8.78358 7.49793 8.68065 7.73738 8.68065 8.01699V8.62719H7.84038C7.61274 8.62719 7.41581 8.70772 7.24949 8.86874C7.08317 9.02973 7 9.22047 7 9.4408V17.5765C7 17.7967 7.08317 17.9874 7.24949 18.1485C7.41579 18.3095 7.61271 18.39 7.84038 18.39H17.084C17.3115 18.39 17.5087 18.3095 17.6748 18.1485C17.8411 17.9874 17.9243 17.7967 17.9243 17.5765V9.44078C17.9243 9.22039 17.8412 9.02973 17.675 8.86871ZM14.5632 8.01706C14.5632 7.95769 14.5827 7.90891 14.6221 7.87087C14.6614 7.83278 14.7118 7.8137 14.7731 7.8137H15.1932C15.2546 7.8137 15.3048 7.83271 15.3443 7.87087C15.3836 7.90898 15.4033 7.95775 15.4033 8.01706V9.84753C15.4033 9.90688 15.3836 9.95557 15.3443 9.99372C15.3048 10.0318 15.2546 10.0509 15.1932 10.0509H14.7731C14.7118 10.0509 14.6614 10.0319 14.6221 9.99372C14.5827 9.95554 14.5632 9.90688 14.5632 9.84753V8.01706ZM9.52111 8.01706C9.52111 7.95769 9.54077 7.90891 9.58016 7.87087C9.61957 7.83278 9.66986 7.8137 9.73116 7.8137H10.1513C10.2126 7.8137 10.263 7.83271 10.3023 7.87087C10.3416 7.90898 10.3614 7.95775 10.3614 8.01706V9.84753C10.3614 9.90688 10.3417 9.95563 10.3023 9.99372C10.2629 10.0318 10.2126 10.0509 10.1513 10.0509H9.73116C9.66986 10.0509 9.6195 10.0319 9.58016 9.99372C9.54086 9.95554 9.52111 9.90688 9.52111 9.84753V8.01706ZM17.084 17.5764H7.84038V11.0679H17.084V17.5764Z"
        fill="white"
      />
      <rect
        x="8.40991"
        y="12.0615"
        width="2.35297"
        height="2.02489"
        fill="white"
      />
      <rect
        x="11.2854"
        y="12.0615"
        width="2.35297"
        height="2.02489"
        fill="white"
      />
      <rect
        x="14.1611"
        y="12.0615"
        width="2.35297"
        height="2.02489"
        fill="white"
      />
      <rect
        x="8.40991"
        y="14.5938"
        width="2.35297"
        height="2.02489"
        fill="white"
      />
      <rect
        x="11.2854"
        y="14.5938"
        width="2.35297"
        height="2.02489"
        fill="white"
      />
      <rect
        x="14.1611"
        y="14.5938"
        width="2.35297"
        height="2.02489"
        fill="white"
      />
    </svg>
  );
}

export function SvgFileLink() {
  return (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8114 2.63043H12.2256V1.03093L13.8114 2.63043Z"
        fill="white"
        stroke="#7A858A"
      />
      <path
        d="M11.0859 2.94766C11.0859 3.45214 11.495 3.86067 11.9991 3.86067H14.3656V13.256C14.3656 13.4378 14.2167 13.587 14.0342 13.587H4.74451C4.56196 13.587 4.41309 13.4378 4.41309 13.256V0.830964C4.41309 0.649152 4.56195 0.5 4.74448 0.5H11.0859V2.93561C11.0859 2.93769 11.0859 2.9397 11.0859 2.94164C11.0859 2.94358 11.0859 2.94559 11.0859 2.94766ZM11.087 2.96964C11.087 2.96904 11.0869 2.96837 11.0869 2.96764L11.0873 2.97422L11.087 2.96964ZM11.0873 2.90905L11.0869 2.91564C11.0869 2.91491 11.0869 2.91424 11.087 2.91364L11.0873 2.90905Z"
        fill="white"
        stroke="#7A858A"
      />
      <path
        d="M9.89589 6.5434H8.31006V4.9439L9.89589 6.5434Z"
        fill="white"
        stroke="#7A858A"
      />
      <path
        d="M7.17278 6.86063C7.17278 7.3651 7.5819 7.77363 8.086 7.77363H10.4525V17.1689C10.4525 17.3508 10.3036 17.4999 10.1211 17.4999H0.831424C0.648872 17.4999 0.5 17.3508 0.5 17.1689V4.74393C0.5 4.56212 0.648861 4.41296 0.831396 4.41296H7.17278V6.84858C7.17278 6.85065 7.1728 6.85266 7.17282 6.8546C7.1728 6.85654 7.17278 6.85855 7.17278 6.86063ZM7.1739 6.8826C7.17386 6.882 7.17383 6.88133 7.17379 6.8806L7.17419 6.88719L7.1739 6.8826ZM7.17419 6.82202L7.17379 6.8286C7.17383 6.82787 7.17386 6.8272 7.1739 6.8266L7.17419 6.82202Z"
        fill="white"
        stroke="#7A858A"
      />
    </svg>
  );
}

export function SvgInfos() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.31465 0C3.72301 0 0 3.72301 0 8.31465C0 12.9063 3.72301 16.63 8.31465 16.63C12.9063 16.63 16.63 12.9063 16.63 8.31465C16.63 3.72301 12.9063 0 8.31465 0ZM10.0456 12.8866C9.61759 13.0555 9.2769 13.1836 9.02138 13.2723C8.76656 13.361 8.47021 13.4054 8.13304 13.4054C7.61496 13.4054 7.21161 13.2787 6.92441 13.026C6.63722 12.7732 6.49432 12.453 6.49432 12.0637C6.49432 11.9124 6.50488 11.7575 6.526 11.5998C6.54782 11.4421 6.58231 11.2648 6.62947 11.0655L7.16515 9.17342C7.21232 8.99181 7.25314 8.81935 7.28552 8.65886C7.3179 8.49696 7.33339 8.34844 7.33339 8.21328C7.33339 7.97254 7.28341 7.80361 7.18416 7.70858C7.0835 7.61355 6.89415 7.56709 6.61188 7.56709C6.47391 7.56709 6.33172 7.5875 6.18601 7.63044C6.04171 7.67479 5.91641 7.71491 5.81364 7.75433L5.95512 7.17149C6.30567 7.02859 6.64144 6.90611 6.96172 6.80475C7.282 6.70198 7.58469 6.6513 7.86977 6.6513C8.38434 6.6513 8.78134 6.77659 9.0608 7.02437C9.33884 7.27285 9.47892 7.59595 9.47892 7.99296C9.47892 8.07532 9.46907 8.22032 9.45006 8.42727C9.43106 8.63493 9.39516 8.82428 9.34307 8.99815L8.8102 10.8846C8.76656 11.036 8.72785 11.2091 8.69265 11.4027C8.65816 11.5963 8.64126 11.7441 8.64126 11.8434C8.64126 12.094 8.69687 12.265 8.8095 12.3558C8.92072 12.4466 9.1157 12.4924 9.39164 12.4924C9.52186 12.4924 9.66757 12.4692 9.83229 12.4241C9.9956 12.3791 10.1139 12.3389 10.1885 12.3044L10.0456 12.8866ZM9.95125 5.22939C9.70277 5.46027 9.4036 5.57571 9.05376 5.57571C8.70462 5.57571 8.40334 5.46027 8.15275 5.22939C7.90356 4.9985 7.77756 4.71764 7.77756 4.38962C7.77756 4.0623 7.90426 3.78073 8.15275 3.54773C8.40334 3.31403 8.70462 3.19789 9.05376 3.19789C9.4036 3.19789 9.70347 3.31403 9.95125 3.54773C10.1997 3.78073 10.3243 4.0623 10.3243 4.38962C10.3243 4.71834 10.1997 4.9985 9.95125 5.22939Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgJobLink() {
  return (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8114 2.63043H12.2256V1.03093L13.8114 2.63043Z"
        fill="white"
        stroke="#7A858A"
      />
      <path
        d="M11.0859 2.94766C11.0859 3.45214 11.495 3.86067 11.9991 3.86067H14.3656V13.256C14.3656 13.4378 14.2167 13.587 14.0342 13.587H4.74451C4.56196 13.587 4.41309 13.4378 4.41309 13.256V0.830964C4.41309 0.649152 4.56195 0.5 4.74448 0.5H11.0859V2.93561C11.0859 2.93769 11.0859 2.9397 11.0859 2.94164C11.0859 2.94358 11.0859 2.94559 11.0859 2.94766ZM11.087 2.96964C11.087 2.96904 11.0869 2.96837 11.0869 2.96764L11.0873 2.97422L11.087 2.96964ZM11.0873 2.90905L11.0869 2.91564C11.0869 2.91491 11.0869 2.91424 11.087 2.91364L11.0873 2.90905Z"
        fill="white"
        stroke="#7A858A"
      />
      <path
        d="M9.89589 6.54352H8.31006V4.94402L9.89589 6.54352Z"
        fill="white"
        stroke="#7A858A"
      />
      <path
        d="M7.17278 6.86075C7.17278 7.36522 7.5819 7.77375 8.086 7.77375H10.4525V17.1691C10.4525 17.3509 10.3036 17.5 10.1211 17.5H0.831424C0.648872 17.5 0.5 17.3509 0.5 17.1691V4.74405C0.5 4.56224 0.648861 4.41309 0.831396 4.41309H7.17278V6.8487C7.17278 6.85077 7.1728 6.85278 7.17282 6.85472C7.1728 6.85666 7.17278 6.85867 7.17278 6.86075ZM7.1739 6.88272C7.17386 6.88212 7.17383 6.88146 7.17379 6.88073L7.17419 6.88731L7.1739 6.88272ZM7.17419 6.82214L7.17379 6.82873C7.17383 6.82799 7.17386 6.82733 7.1739 6.82673L7.17419 6.82214Z"
        fill="white"
        stroke="#7A858A"
      />
    </svg>
  );
}

export function SvgNotice() {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.8125 6.69429C8.8125 6.52103 8.88157 6.35487 9.00452 6.23235C9.12746 6.10984 9.29422 6.04102 9.46809 6.04102C9.64196 6.04102 9.80871 6.10984 9.93166 6.23235C10.0546 6.35487 10.1237 6.52103 10.1237 6.69429V10.5638C10.1237 10.737 10.0546 10.9032 9.93166 11.0257C9.80871 11.1482 9.64196 11.217 9.46809 11.217C9.29422 11.217 9.12746 11.1482 9.00452 11.0257C8.88157 10.9032 8.8125 10.737 8.8125 10.5638V6.69429Z"
        fill="#73c7b7"
      />
      <path
        d="M9.46607 13.5474C9.91871 13.5474 10.2857 13.1818 10.2857 12.7308C10.2857 12.2797 9.91871 11.9141 9.46607 11.9141C9.01342 11.9141 8.64648 12.2797 8.64648 12.7308C8.64648 13.1818 9.01342 13.5474 9.46607 13.5474Z"
        fill="#73c7b7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.62137 2.4561C9.6071 2.43146 9.58494 2.41069 9.55741 2.39617C9.52988 2.38165 9.49808 2.37395 9.46563 2.37395C9.43318 2.37395 9.40138 2.38165 9.37385 2.39617C9.34632 2.41069 9.32416 2.43146 9.30989 2.4561L2.27371 14.4744C2.26039 14.4968 2.25409 14.5217 2.25541 14.5468C2.25673 14.5718 2.26563 14.5961 2.28125 14.6175C2.29688 14.6388 2.31871 14.6563 2.34465 14.6685C2.3706 14.6806 2.39979 14.6869 2.42945 14.6868H16.5776C16.6073 14.6869 16.6365 14.6806 16.6624 14.6685C16.6884 14.6563 16.7102 14.6388 16.7258 14.6175C16.7414 14.5961 16.7503 14.5718 16.7516 14.5468C16.753 14.5217 16.7467 14.4968 16.7333 14.4744L9.62137 2.4561ZM8.53121 0.488023C8.61711 0.341483 8.74972 0.218146 8.91408 0.131918C9.07845 0.0456897 9.26804 0 9.46148 0C9.65491 0 9.84451 0.0456897 10.0089 0.131918C10.1732 0.218146 10.3059 0.341483 10.3917 0.488023L18.9054 14.8773C18.9773 15.0099 19.0091 15.1556 18.9978 15.3012C18.9864 15.4468 18.9323 15.5877 18.8404 15.7111C18.7485 15.8346 18.6216 15.9368 18.4712 16.0084C18.3209 16.0799 18.1518 16.1187 17.9792 16.1212H1.0382C0.861314 16.1224 0.687047 16.085 0.532186 16.0128C0.377326 15.9405 0.247093 15.8357 0.154037 15.7085C0.0609804 15.5813 0.00823713 15.436 0.00088914 15.2866C-0.00645885 15.1372 0.0318361 14.9886 0.112084 14.8554L8.53121 0.488023Z"
        fill="#73c7b7"
      />
    </svg>
  );
}

// End Recruitments Icones
export function SvgTimer() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99992 3.21289C5.80454 3.21289 3.21411 5.8031 3.21411 8.99829C3.21411 12.194 5.80454 14.7845 8.99992 14.7845C12.1951 14.7845 14.7855 12.1941 14.7855 8.99829C14.7855 5.8031 12.1951 3.21289 8.99992 3.21289ZM12.0874 9.74959H8.99992C8.59415 9.74959 8.24902 9.40446 8.24902 8.99847V4.75067C8.24902 4.34494 8.59415 4.01602 8.99992 4.01602C9.40572 4.01602 9.75085 4.3449 9.75085 4.75067V8.24776H12.0874C12.4929 8.24776 12.8222 8.59293 12.8222 8.99851C12.8222 9.40446 12.4929 9.74959 12.0874 9.74959Z"
        fill="#929A9E"
      />
      <path
        d="M8.99998 0C4.03755 0 0 4.03737 0 8.99998C0 13.9623 4.03755 17.9996 8.99998 17.9996C13.9624 17.9996 18 13.9622 18 8.99998C18 4.03737 13.9624 0 8.99998 0ZM8.99998 15.9485C5.16842 15.9485 2.05089 12.8314 2.05089 8.99998C2.05089 5.1682 5.16842 2.05093 8.99998 2.05093C12.8316 2.05093 15.9489 5.16823 15.9489 8.99998C15.9489 12.8314 12.8316 15.9485 8.99998 15.9485Z"
        fill="#929A9E"
      />
    </svg>
  );
}

export function SvgDeleteCongeAttente() {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.91646 11.4339L8.18329 8.16708L4.91646 4.90025C4.80816 4.79195 4.74731 4.64506 4.74731 4.4919C4.74731 4.33873 4.80816 4.19184 4.91646 4.08354C5.02476 3.97524 5.17165 3.9144 5.32481 3.9144C5.47797 3.9144 5.62486 3.97524 5.73317 4.08354L9 7.35037L12.2668 4.08354C12.3751 3.97524 12.522 3.9144 12.6752 3.9144C12.8283 3.9144 12.9752 3.97524 13.0835 4.08354C13.1918 4.19184 13.2527 4.33873 13.2527 4.4919C13.2527 4.64506 13.1918 4.79195 13.0835 4.90025L9.81671 8.16708L13.0835 11.4339C13.1918 11.5422 13.2527 11.6891 13.2527 11.8423C13.2527 11.9954 13.1918 12.1423 13.0835 12.2506C12.9752 12.3589 12.8284 12.4198 12.6752 12.4198C12.522 12.4198 12.3751 12.3589 12.2668 12.2506L9 8.98379L5.73317 12.2506C5.62486 12.3589 5.47797 12.4198 5.32481 12.4198C5.17165 12.4198 5.02476 12.3589 4.91646 12.2506C4.80816 12.1423 4.74731 11.9954 4.74731 11.8423C4.74731 11.6891 4.80816 11.5422 4.91646 11.4339Z"
        fill="#000000"
      />
    </svg>
  );
}

export function SvgAddIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5484 13.5484H14.4516V0.451613C14.4516 0.20221 14.2494 0 14 0C13.7506 0 13.5484 0.20221 13.5484 0.451613V13.5484H0.451613C0.20221 13.5484 0 13.7506 0 14C0 14.2494 0.20221 14.4516 0.451613 14.4516H13.5484V27.5484C13.5484 27.7978 13.7506 28 14 28C14.2494 28 14.4516 27.7978 14.4516 27.5484V14.4516H27.5484C27.7978 14.4516 28 14.2494 28 14C28 13.7506 27.7978 13.5484 27.5484 13.5484Z"
        fill="black"
      />
    </svg>
  );
}

export function SvgGalleryIcon() {
  return (
    <svg
      width="84"
      height="87"
      viewBox="0 0 84 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.191406"
        width="83.8459"
        height="86.4559"
        rx="15"
        fill="#F7F7F7"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="84"
        height="87"
      >
        <rect
          y="0.192383"
          width="83.8459"
          height="86.4559"
          rx="15"
          fill="#ECEDEF"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M17.1225 54.2802C14.0701 51.2411 9.14098 51.2411 6.08855 54.2802L-11.91 72.3075L-45.4813 38.6827C-48.5337 35.6435 -53.4628 35.6435 -56.5152 38.6827L-111.294 93.5483C-114.319 96.6394 -114.271 101.602 -111.184 104.632C-109.749 106.042 -107.826 106.844 -105.816 106.873H50.6938C55.0154 106.898 58.5393 103.409 58.5647 99.0805C58.5769 96.9745 57.7426 94.9528 56.2498 93.47L17.1225 54.2802Z"
          fill="url(#paint0_linear)"
          fill-opacity="0.3"
        />
        <path
          d="M120.731 40.9204C117.365 38.2327 112.465 38.7709 109.763 42.1252L93.8404 62.01L56.7982 32.2521C53.4322 29.5644 48.5326 30.1026 45.8303 33.4569L-2.62949 93.976C-5.29939 97.3789 -4.7094 102.306 -1.31078 104.982C0.270067 106.226 2.26881 106.814 4.27055 106.623L159.844 89.5327C164.143 89.0857 167.265 85.2334 166.817 80.9275C166.599 78.8328 165.549 76.9143 163.903 75.6033L120.731 40.9204Z"
          fill="url(#paint1_linear)"
        />
      </g>
      <path
        d="M29.5253 31.3474C33.8496 31.3474 37.3552 27.8418 37.3552 23.5175C37.3552 19.1931 33.8496 15.6875 29.5253 15.6875C25.2009 15.6875 21.6953 19.1931 21.6953 23.5175C21.6953 27.8418 25.2009 31.3474 29.5253 31.3474Z"
        fill="url(#paint2_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="-54.154"
          y1="34.4458"
          x2="-33.6004"
          y2="95.1281"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FCB698" />
          <stop
            offset="1"
            stop-color="#DC7144"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="47.7147"
          y1="28.9876"
          x2="74.7716"
          y2="87.0626"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FCB698" />
          <stop
            offset="1"
            stop-color="#F5814F"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="29.5253"
          y1="15.6875"
          x2="29.5253"
          y2="31.3474"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FCB698" />
          <stop
            offset="1"
            stop-color="#FA966B"
          />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function SvgUploadPauseIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="20"
        cy="20"
        r="20"
        fill="#F9FAFC"
      />
      <line
        x1="24.65"
        y1="15.65"
        x2="24.65"
        y2="24.35"
        stroke="#767676"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <line
        x1="16.65"
        y1="15.65"
        x2="16.65"
        y2="24.35"
        stroke="#767676"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function SvgCakeIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 5H8.5V4H7.5V5H3.5C2.672 5 2 5.672 2 6.5V8H14V6.5C14 5.672 13.328 5 12.5 5Z"
        fill="#393C40"
      />
      <path
        d="M15 9H1C0.448 9 0 9.448 0 10V11C0 12.105 0.895 13 2 13C3.105 13 4 12.105 4 11C4 12.105 4.895 13 6 13C7.105 13 8 12.105 8 11C8 12.105 8.895 13 10 13C11.105 13 12 12.105 12 11C12 12.105 12.895 13 14 13C15.105 13 16 12.105 16 11V10C16 9.448 15.552 9 15 9Z"
        fill="#393C40"
      />
      <path
        d="M14 14.0002C13.232 14.0002 12.531 13.7102 12 13.2342C11.469 13.7102 10.768 14.0002 10 14.0002C9.232 14.0002 8.531 13.7102 8 13.2342C7.469 13.7102 6.768 14.0002 6 14.0002C5.232 14.0002 4.531 13.7102 4 13.2342C3.469 13.7102 2.768 14.0002 2 14.0002C1.229 14.0002 0.532 13.6992 0 13.2202V15.0002C0 15.5522 0.448 16.0002 1 16.0002H15C15.552 16.0002 16 15.5522 16 15.0002V13.2202C15.468 13.7002 14.771 14.0002 14 14.0002Z"
        fill="#393C40"
      />
      <path
        d="M8 0C8 0 7 1.448 7 2C7 2.552 7.448 3 8 3C8.552 3 9 2.552 9 2C9 1.448 8 0 8 0Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function SvgUploadCancelIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="20"
        cy="20"
        r="20"
        fill="#F9FAFC"
      />
      <path
        d="M15.9165 23.4339L19.1833 20.1671L15.9165 16.9002C15.8082 16.7919 15.7473 16.6451 15.7473 16.4919C15.7473 16.3387 15.8082 16.1918 15.9165 16.0835C16.0248 15.9752 16.1717 15.9144 16.3248 15.9144C16.478 15.9144 16.6249 15.9752 16.7332 16.0835L20 19.3504L23.2668 16.0835C23.3751 15.9752 23.522 15.9144 23.6752 15.9144C23.8283 15.9144 23.9752 15.9752 24.0835 16.0835C24.1918 16.1918 24.2527 16.3387 24.2527 16.4919C24.2527 16.6451 24.1918 16.7919 24.0835 16.9002L20.8167 20.1671L24.0835 23.4339C24.1918 23.5422 24.2527 23.6891 24.2527 23.8423C24.2527 23.9954 24.1918 24.1423 24.0835 24.2506C23.9752 24.3589 23.8284 24.4198 23.6752 24.4198C23.522 24.4198 23.3751 24.3589 23.2668 24.2506L20 20.9838L16.7332 24.2506C16.6249 24.3589 16.478 24.4198 16.3248 24.4198C16.1716 24.4198 16.0248 24.3589 15.9165 24.2506C15.8082 24.1423 15.7473 23.9954 15.7473 23.8423C15.7473 23.6891 15.8082 23.5422 15.9165 23.4339Z"
        fill="#767676"
      />
    </svg>
  );
}

export function SvgFbIcon() {
  return (
    <svg
      width="25"
      height="27"
      viewBox="0 0 25 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6328 26.1364C24.4141 26.1364 25 25.483 25 24.707V1.42933C25 0.612571 24.375 0 23.6328 0H1.36719C0.625 0 0 0.653409 0 1.42933V24.6662C0 25.483 0.625 26.0955 1.36719 26.0955H23.6328V26.1364Z"
        fill="#3D5A98"
      />
      <path
        d="M16.3866 26.1355V17.1991H19.1459L19.5448 13.7039H16.3533V11.4698C16.3533 10.4609 16.6193 9.77623 17.9491 9.77623H19.6445V6.67734C19.3453 6.6413 18.348 6.5332 17.1512 6.5332C14.6911 6.5332 13.0288 8.15471 13.0288 11.1455V13.7039H10.2695V17.1991H13.0288V26.1355H16.3866Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgTwitIcon() {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.8523 27H3.14841C1.40932 27 0 25.5907 0 23.8521V3.14839C0 1.4093 1.40932 0 3.14841 0H23.8521C25.5907 0 27 1.4093 27 3.14839V23.8518C27.0003 25.5907 25.5909 27 23.8523 27Z"
        fill="black"
      />
      <path
        d="M4.14783 4.70391L11.4048 14.4072L4.10199 22.2962H5.74578L12.1395 15.3891L17.3051 22.2962H22.8983L15.2327 11.0472L22.0302 4.70391H20.3865L14.4985 11.0649L9.74101 4.70391H4.14783ZM6.56493 5.91481H9.13435L20.4809 21.0856H17.9115L6.56493 5.91481Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgInstagramIcon() {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="instaGradient"
          x1="0%"
          y1="100%"
          x2="100%"
          y2="0%"
        >
          <stop
            offset="0%"
            stopColor="#FEDA75"
          />
          <stop
            offset="25%"
            stopColor="#FA7E1E"
          />
          <stop
            offset="50%"
            stopColor="#D62976"
          />
          <stop
            offset="75%"
            stopColor="#962FBF"
          />
          <stop
            offset="100%"
            stopColor="#4F5BD5"
          />
        </linearGradient>
      </defs>

      <rect
        width="27"
        height="27"
        rx="4"
        fill="url(#instaGradient)"
      />
      <rect
        x="7"
        y="7"
        width="13"
        height="13"
        rx="3"
        stroke="white"
        strokeWidth="1.8"
        fill="none"
      />
      <circle
        cx="13.5"
        cy="13.5"
        r="3"
        stroke="white"
        strokeWidth="1.8"
        fill="none"
      />

      <circle
        cx="17.5"
        cy="9.5"
        r="1"
        fill="white"
      />
    </svg>
  );
}

export function SvgTikTokIcon() {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="27"
        height="27"
        rx="4"
        fill="black"
      />

      <path
        d="M14.5 6.5V14.6C14.5 15.8 13.6 16.7 12.5 16.7C11.4 16.7 10.5 15.8 10.5 14.6C10.5 13.6 11.1 12.8 12 12.6V10.9C10.2 11.1 8.8 12.7 8.8 14.6C8.8 16.8 10.5 18.5 12.5 18.5C14.6 18.5 16.2 16.8 16.2 14.6V9.6C16.8 10.1 17.6 10.4 18.5 10.4V8.7C17.2 8.6 16 7.8 15.5 6.5H14.5Z"
        fill="#25F4EE"
      />

      <path
        d="M15 6V14.2C15 15.4 14.1 16.3 13 16.3C12.1 16.3 11.3 15.7 11.1 14.9C11.1 16.7 12.6 18.2 14.4 18.2C16.2 18.2 17.7 16.7 17.7 14.9V10.1C18.3 10.5 19 10.7 19.8 10.7V9C18.4 8.9 17.1 8 16.6 6.7H15Z"
        fill="#FE2C55"
      />

      <path
        d="M14.8 6.3V14.5C14.8 15.6 13.9 16.5 12.8 16.5C11.7 16.5 10.8 15.6 10.8 14.5C10.8 13.4 11.5 12.5 12.5 12.3V10.6C10.7 10.8 9.3 12.4 9.3 14.5C9.3 16.7 11 18.4 12.8 18.4C14.7 18.4 16.3 16.7 16.3 14.5V9.4C16.9 9.9 17.7 10.2 18.6 10.2V8.5C17.2 8.4 16 7.5 15.5 6.3H14.8Z"
        fill="white"
      />

      <text
        x="13.5"
        y="24"
        textAnchor="middle"
        fontSize="5"
        fontFamily="Arial, Helvetica, sans-serif"
        fill="white"
        fontWeight="600"
      >
        TikTok
      </text>
    </svg>
  );
}

export function SvgLinkedInIcon() {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9375 27H5.0625C2.27813 27 0 24.7219 0 21.9375V5.0625C0 2.27813 2.27813 0 5.0625 0H21.9375C24.7219 0 27 2.27813 27 5.0625V21.9375C27 24.7219 24.7219 27 21.9375 27Z"
        fill="#007BB5"
      />
      <path
        d="M7.45938 10.4385H10.3563V19.7693H7.45938V10.4385ZM8.92188 5.78711C9.85 5.78711 10.6094 6.54366 10.6094 7.49635C10.6094 8.42102 9.85 9.20559 8.92188 9.20559C7.99375 9.20559 7.23438 8.44904 7.23438 7.49635C7.23438 6.54366 7.99375 5.78711 8.92188 5.78711Z"
        fill="white"
      />
      <path
        d="M12.0508 10.378H14.7376V11.6431H14.7645C15.1407 10.8841 16.0542 10.125 17.3976 10.125C20.2188 10.125 20.7294 12.0648 20.7294 14.595V19.7397H17.9619V15.1854C17.9619 14.1171 17.935 12.6833 16.5378 12.6833C15.1138 12.6833 14.872 13.8641 14.872 15.101V19.7679H12.0776V10.378H12.0508Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgAddAction() {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36C28.165 36 36 28.165 36 18.5Z"
        fill="#3D3D3D"
        stroke="white"
      />
      <path
        d="M17.8613 24.2032V19.139H12.7971C12.6292 19.139 12.4682 19.0723 12.3495 18.9536C12.2308 18.8349 12.1641 18.6739 12.1641 18.506C12.1641 18.3381 12.2308 18.1771 12.3495 18.0584C12.4682 17.9397 12.6292 17.873 12.7971 17.873H17.8613V12.8088C17.8613 12.6409 17.928 12.4799 18.0467 12.3612C18.1654 12.2425 18.3264 12.1758 18.4943 12.1758C18.6622 12.1758 18.8232 12.2425 18.9419 12.3612C19.0606 12.4799 19.1273 12.6409 19.1273 12.8088V17.873H24.1915C24.3594 17.873 24.5204 17.9397 24.6391 18.0584C24.7578 18.1771 24.8245 18.3381 24.8245 18.506C24.8245 18.6739 24.7578 18.8349 24.6391 18.9536C24.5204 19.0723 24.3594 19.139 24.1915 19.139H19.1273V24.2032C19.1273 24.3711 19.0606 24.5321 18.9419 24.6508C18.8232 24.7696 18.6622 24.8362 18.4943 24.8362C18.3264 24.8362 18.1654 24.7696 18.0467 24.6508C17.928 24.5321 17.8613 24.3711 17.8613 24.2032Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function SvgCancelAction() {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36C28.165 36 36 28.165 36 18.5Z"
        fill="#3D3D3D"
        stroke="white"
      />
      <path
        d="M14.018 22.0869L17.5989 18.506L14.018 14.9251C13.8993 14.8064 13.8326 14.6454 13.8326 14.4775C13.8326 14.3096 13.8993 14.1486 14.018 14.0299C14.1367 13.9111 14.2977 13.8445 14.4656 13.8445C14.6335 13.8445 14.7945 13.9111 14.9132 14.0299L18.4941 17.6108L22.0751 14.0299C22.1938 13.9111 22.3548 13.8445 22.5227 13.8445C22.6906 13.8445 22.8516 13.9111 22.9703 14.0299C23.089 14.1486 23.1557 14.3096 23.1557 14.4775C23.1557 14.6454 23.089 14.8064 22.9703 14.9251L19.3894 18.506L22.9703 22.0869C23.089 22.2056 23.1557 22.3667 23.1557 22.5345C23.1557 22.7024 23.089 22.8634 22.9703 22.9822C22.8516 23.1009 22.6906 23.1676 22.5227 23.1676C22.3548 23.1676 22.1938 23.1009 22.0751 22.9822L18.4941 19.4012L14.9132 22.9822C14.7945 23.1009 14.6335 23.1676 14.4656 23.1676C14.2977 23.1676 14.1367 23.1009 14.018 22.9822C13.8993 22.8634 13.8326 22.7024 13.8326 22.5345C13.8326 22.3667 13.8993 22.2056 14.018 22.0869Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function SvgEditAction() {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36C28.165 36 36 28.165 36 18.5Z"
        fill="#3D3D3D"
        stroke="white"
      />
      <path
        d="M14.018 22.0869L17.5989 18.506L14.018 14.9251C13.8993 14.8064 13.8326 14.6454 13.8326 14.4775C13.8326 14.3096 13.8993 14.1486 14.018 14.0299C14.1367 13.9111 14.2977 13.8445 14.4656 13.8445C14.6335 13.8445 14.7945 13.9111 14.9132 14.0299L18.4941 17.6108L22.0751 14.0299C22.1938 13.9111 22.3548 13.8445 22.5227 13.8445C22.6906 13.8445 22.8516 13.9111 22.9703 14.0299C23.089 14.1486 23.1557 14.3096 23.1557 14.4775C23.1557 14.6454 23.089 14.8064 22.9703 14.9251L19.3894 18.506L22.9703 22.0869C23.089 22.2056 23.1557 22.3667 23.1557 22.5345C23.1557 22.7024 23.089 22.8634 22.9703 22.9822C22.8516 23.1009 22.6906 23.1676 22.5227 23.1676C22.3548 23.1676 22.1938 23.1009 22.0751 22.9822L18.4941 19.4012L14.9132 22.9822C14.7945 23.1009 14.6335 23.1676 14.4656 23.1676C14.2977 23.1676 14.1367 23.1009 14.018 22.9822C13.8993 22.8634 13.8326 22.7024 13.8326 22.5345C13.8326 22.3667 13.8993 22.2056 14.018 22.0869Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function SvgEditIcon() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.22282 10.499L1.50101 7.77721L8.08418 1.19404L10.806 3.91585L4.22282 10.499ZM1.24659 8.25666L3.74337 10.7534L0 12L1.24659 8.25666ZM11.6431 3.0823L11.171 3.55439L8.44564 0.828983L8.91774 0.356884C9.39329 -0.118961 10.1645 -0.118961 10.64 0.356884L11.6431 1.36C12.1152 1.83715 12.1152 2.6053 11.6431 3.0823Z"
        fill="black"
      />
    </svg>
  );
}

export function SvgEditIconeOutlined() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.06324 12.0935C1.09578 11.8006 1.11205 11.6542 1.15636 11.5173C1.19568 11.3959 1.25122 11.2803 1.32149 11.1737C1.4007 11.0536 1.50489 10.9494 1.71327 10.7411L11.0677 1.38661C11.8501 0.604204 13.1187 0.604204 13.9011 1.38661C14.6835 2.16901 14.6835 3.43754 13.9011 4.21994L4.5466 13.5744C4.33822 13.7828 4.23403 13.887 4.11392 13.9662C4.00736 14.0364 3.89179 14.092 3.77035 14.1313C3.63347 14.1756 3.48702 14.1919 3.19414 14.2244L0.796875 14.4908L1.06324 12.0935Z"
        stroke="black"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgCheckDone() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4167 8.32144V9.0881C17.4156 10.8851 16.8338 12.6337 15.7578 14.073C14.6818 15.5122 13.1694 16.5652 11.4461 17.0747C9.72286 17.5842 7.88105 17.523 6.19539 16.9003C4.50973 16.2775 3.07055 15.1265 2.09247 13.619C1.11439 12.1115 0.649826 10.3282 0.768064 8.53503C0.886302 6.74191 1.58101 5.03504 2.74857 3.669C3.91613 2.30295 5.49399 1.35092 7.24682 0.954892C8.99966 0.558861 10.8336 0.740051 12.475 1.47144M17.4167 2.41667L9.08333 10.7583L6.58333 8.25833"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgCancelIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2598 15.44L11.3393 10.5195L16.2598 5.59911C16.3535 5.50541 16.3535 5.35347 16.2598 5.25977C16.1661 5.16607 16.0141 5.16607 15.9204 5.25977L11 10.1802L6.07957 5.25977C5.98587 5.16607 5.83393 5.16607 5.74023 5.25977C5.64653 5.35347 5.64653 5.50541 5.74023 5.59911L10.6607 10.5195L5.74023 15.44C5.64653 15.5337 5.64653 15.6856 5.74023 15.7793C5.83393 15.873 5.98587 15.873 6.07957 15.7793L11 10.8589L15.9204 15.7793C16.0141 15.873 16.1661 15.873 16.2598 15.7793C16.3535 15.6856 16.3535 15.5337 16.2598 15.44Z"
        fill="black"
      />
    </svg>
  );
}

export function SvgStarFull() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9608 5.66765C14.862 5.3507 14.5926 5.12631 14.2751 5.09633L9.94508 4.68612L8.23382 0.505394C8.10747 0.198241 7.81999 0 7.50001 0C7.18003 0 6.89243 0.198241 6.76689 0.505394L5.05563 4.68612L0.724889 5.09633C0.407425 5.12691 0.138599 5.3513 0.0392629 5.66765C-0.0595011 5.98459 0.0317097 6.33223 0.27181 6.55197L3.54499 9.54695L2.57989 13.9825C2.50928 14.3087 2.63059 14.6459 2.88992 14.8415C3.02931 14.9472 3.19307 15 3.35741 15C3.49864 15 3.63997 14.9608 3.7662 14.882L7.50001 12.5523L11.2331 14.882C11.507 15.0528 11.8513 15.0371 12.1101 14.8415C12.3694 14.6459 12.4907 14.3087 12.4201 13.9825L11.455 9.54695L14.7282 6.55197C14.9682 6.33223 15.0595 5.98531 14.9608 5.66765Z"
        fill="#8DD0C3"
      />
    </svg>
  );
}

export function SvgStarOutlined() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2281 5.59412L14.228 5.5941L9.89792 5.18389L9.59689 5.15537L9.48234 4.87553L7.77141 0.695601C7.77136 0.695491 7.77132 0.695382 7.77127 0.695272C7.71797 0.566028 7.60689 0.5 7.50001 0.5C7.39278 0.5 7.28215 0.566287 7.22972 0.694568L7.22963 0.694802L5.51836 4.87553L5.40382 5.15538L5.10278 5.18389L0.772817 5.59403C0.772722 5.59404 0.772626 5.59405 0.77253 5.59406C0.666004 5.60444 0.559015 5.6821 0.516466 5.81691C0.474025 5.9538 0.516302 6.09791 0.60934 6.18309C0.609352 6.1831 0.609364 6.18311 0.609375 6.18312L3.88251 9.17807L4.0947 9.37222L4.03355 9.65326L3.06857 14.0883C3.06856 14.0884 3.06855 14.0884 3.06854 14.0885C3.03762 14.2315 3.09335 14.3687 3.19102 14.4424L3.19201 14.4431C3.24368 14.4823 3.30115 14.5 3.35741 14.5C3.40557 14.5 3.45506 14.4868 3.50139 14.4579L3.50153 14.4578L7.23533 12.1281L7.50003 11.963L7.76472 12.1281L11.4977 14.4577C11.5951 14.5185 11.7144 14.5139 11.8086 14.4427L11.809 14.4424C11.9066 14.3687 11.9623 14.2317 11.9315 14.0887C11.9315 14.0886 11.9315 14.0885 11.9314 14.0883L10.9665 9.65326L10.9053 9.37222L11.1175 9.17807L14.3906 6.1832L14.2281 5.59412ZM14.2281 5.59412C14.3345 5.60416 14.4414 5.68171 14.4834 5.8164M14.2281 5.59412L14.4834 5.8164M14.4834 5.8164C14.5261 5.95411 14.4838 6.09777 14.3907 6.18309L14.4834 5.8164Z"
        stroke="#8DD0C3"
      />
    </svg>
  );
}

export function SvgDotsMenu({ color = "#292929" } = {}) {
  return (
    <svg
      width="4"
      height="15"
      viewBox="0 0 4 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 12.5039C3.5 13.4704 2.7165 14.2539 1.75 14.2539C0.783502 14.2539 0 13.4704 0 12.5039C0 11.5374 0.783502 10.7539 1.75 10.7539C2.7165 10.7539 3.5 11.5374 3.5 12.5039ZM1.75 9.00391C0.783502 9.00391 0 8.2204 0 7.25391C0 6.28741 0.783502 5.50391 1.75 5.50391C2.7165 5.50391 3.5 6.28741 3.5 7.25391C3.5 7.71804 3.31563 8.16315 2.98744 8.49134C2.65925 8.81953 2.21413 9.00391 1.75 9.00391ZM3.5 2.00391C3.5 2.9704 2.7165 3.75391 1.75 3.75391C0.783502 3.75391 0 2.9704 0 2.00391C0 1.03741 0.783502 0.253906 1.75 0.253906C2.7165 0.253906 3.5 1.03741 3.5 2.00391Z"
        fill={color}
      />
    </svg>
  );
}

export function SvgDotsReorder() {
  return (
    <svg
      width="10"
      height="14"
      viewBox="0 0 10 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16732 11.9987C9.16732 12.9192 8.42113 13.6654 7.50065 13.6654C6.58018 13.6654 5.83398 12.9192 5.83398 11.9987C5.83398 11.0782 6.58018 10.332 7.50065 10.332C8.42113 10.332 9.16732 11.0782 9.16732 11.9987ZM4.16732 11.9987C4.16732 12.9192 3.42113 13.6654 2.50065 13.6654C1.58018 13.6654 0.833984 12.9192 0.833984 11.9987C0.833984 11.0782 1.58018 10.332 2.50065 10.332C3.42113 10.332 4.16732 11.0782 4.16732 11.9987ZM9.16732 6.9987C9.16732 7.91917 8.42113 8.66536 7.50065 8.66536C6.58018 8.66536 5.83398 7.91917 5.83398 6.9987C5.83398 6.07822 6.58018 5.33203 7.50065 5.33203C8.42113 5.33203 9.16732 6.07822 9.16732 6.9987ZM2.50065 8.66536C1.58018 8.66536 0.833984 7.91917 0.833984 6.9987C0.833984 6.07822 1.58018 5.33203 2.50065 5.33203C3.42113 5.33203 4.16732 6.07822 4.16732 6.9987C4.16732 7.44073 3.99172 7.86465 3.67916 8.17721C3.3666 8.48977 2.94268 8.66536 2.50065 8.66536ZM9.16732 1.9987C9.16732 2.91917 8.42113 3.66536 7.50065 3.66536C6.58018 3.66536 5.83398 2.91917 5.83398 1.9987C5.83398 1.07822 6.58018 0.332031 7.50065 0.332031C8.42113 0.332031 9.16732 1.07822 9.16732 1.9987ZM4.16732 1.9987C4.16732 2.91917 3.42113 3.66536 2.50065 3.66536C1.58018 3.66536 0.833984 2.91917 0.833984 1.9987C0.833984 1.07822 1.58018 0.332031 2.50065 0.332031C3.42113 0.332031 4.16732 1.07822 4.16732 1.9987Z"
        fill="#2E3A59"
      />
    </svg>
  );
}

export function SvgBlackTrash() {
  return (
    <svg
      width="10"
      height="14"
      viewBox="0 0 10 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.697418 11.9293C0.698689 12.3243 0.845951 12.7026 1.10708 12.9819C1.3682 13.2612 1.722 13.4186 2.09129 13.42H7.66871C8.03883 13.42 8.39387 13.2631 8.65604 12.9837C8.9182 12.7043 9.06613 12.3252 9.06741 11.9293V2.98234H0.697418V11.9293ZM9.76 0.745842H7.31952L6.62307 0H3.13694L2.44048 0.745842H0V2.23649H9.76V0.745842Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgArchiveIcon() {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.90313 3.75367C1.80472 3.75108 1.73326 3.74528 1.66902 3.73227C1.19299 3.63582 0.820871 3.25682 0.726183 2.77197C0.703125 2.65391 0.703125 2.51193 0.703125 2.22797C0.703125 1.94402 0.703125 1.80204 0.726183 1.68397C0.820871 1.19913 1.19299 0.820121 1.66902 0.72368C1.78494 0.700195 1.92433 0.700195 2.20313 0.700195H11.2031C11.4819 0.700195 11.6213 0.700195 11.7372 0.72368C12.2133 0.820121 12.5854 1.19913 12.6801 1.68397C12.7031 1.80204 12.7031 1.94402 12.7031 2.22797C12.7031 2.51193 12.7031 2.65391 12.6801 2.77197C12.5854 3.25682 12.2133 3.63582 11.7372 3.73227C11.673 3.74528 11.6015 3.75108 11.5031 3.75367M5.50313 6.81131H7.90313M1.90313 3.75575H11.5031V8.76686C11.5031 9.79362 11.5031 10.307 11.3069 10.6992C11.1344 11.0441 10.859 11.3246 10.5203 11.5004C10.1353 11.7002 9.63122 11.7002 8.62313 11.7002H4.78313C3.77503 11.7002 3.27098 11.7002 2.88594 11.5004C2.54725 11.3246 2.27189 11.0441 2.09931 10.6992C1.90312 10.307 1.90313 9.79362 1.90313 8.76686V3.75575Z"
        stroke="black"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgViewPoste() {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7C6 4.92893 7.67893 3.25 9.75 3.25C11.8211 3.25 13.5 4.92893 13.5 7C13.5 9.07107 11.8211 10.75 9.75 10.75C7.67893 10.75 6 9.07107 6 7ZM9.75 4.75C8.50736 4.75 7.5 5.75736 7.5 7C7.5 8.24264 8.50736 9.25 9.75 9.25C10.9926 9.25 12 8.24264 12 7C12 5.75736 10.9926 4.75 9.75 4.75Z"
        fill="#292929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.07343 5.64635C1.65431 6.25029 1.5 6.7227 1.5 7C1.5 7.2773 1.65431 7.74971 2.07343 8.35365C2.47857 8.93744 3.08078 9.57028 3.84267 10.155C5.36978 11.3271 7.46345 12.25 9.75 12.25C12.0365 12.25 14.1302 11.3271 15.6573 10.155C16.4192 9.57028 17.0214 8.93744 17.4266 8.35365C17.8457 7.74971 18 7.2773 18 7C18 6.7227 17.8457 6.25029 17.4266 5.64635C17.0214 5.06256 16.4192 4.42972 15.6573 3.84497C14.1302 2.67292 12.0365 1.75 9.75 1.75C7.46345 1.75 5.36978 2.67292 3.84267 3.84497C3.08078 4.42972 2.47857 5.06256 2.07343 5.64635ZM2.92941 2.65503C4.65965 1.32708 7.06598 0.25 9.75 0.25C12.434 0.25 14.8403 1.32708 16.5706 2.65503C17.4374 3.32028 18.1532 4.06244 18.6589 4.79115C19.1506 5.49971 19.5 6.2773 19.5 7C19.5 7.7227 19.1506 8.50029 18.6589 9.20885C18.1532 9.93756 17.4374 10.6797 16.5706 11.345C14.8403 12.6729 12.434 13.75 9.75 13.75C7.06598 13.75 4.65965 12.6729 2.92941 11.345C2.06262 10.6797 1.34681 9.93756 0.841103 9.20885C0.349371 8.50029 0 7.7227 0 7C0 6.2773 0.349371 5.49971 0.841103 4.79115C1.34681 4.06244 2.06262 3.32028 2.92941 2.65503Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgBlackMove() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.846863 4.51663H10.2067L8.82954 5.8938C8.67072 6.05263 8.58149 6.26803 8.58149 6.49264C8.58149 6.71725 8.67072 6.93266 8.82954 7.09148C8.98836 7.2503 9.20377 7.33953 9.42838 7.33953C9.65299 7.33953 9.86839 7.2503 10.0272 7.09148L12.8501 4.2686C12.9287 4.18996 12.9911 4.0966 13.0337 3.99385C13.0762 3.89111 13.0982 3.78098 13.0982 3.66976C13.0982 3.55855 13.0762 3.44842 13.0337 3.34567C12.9911 3.24292 12.9287 3.14956 12.8501 3.07093L10.0272 0.248047C9.86839 0.0892251 9.65299 -1.67346e-09 9.42838 0C9.20377 1.67346e-09 8.98836 0.0892251 8.82954 0.248047C8.67072 0.406869 8.58149 0.622277 8.58149 0.846885C8.58149 1.07149 8.67072 1.2869 8.82954 1.44572L10.2067 2.8229H0.846863C0.622261 2.8229 0.406858 2.91212 0.248041 3.07094C0.0892231 3.22976 0 3.44516 0 3.66976C0 3.89437 0.0892231 4.10977 0.248041 4.26859C0.406858 4.4274 0.622261 4.51663 0.846863 4.51663Z"
        fill="#292929"
      />
      <path
        d="M12.2513 9.03335H2.8914L4.26861 7.65617C4.42743 7.49735 4.51666 7.28194 4.51666 7.05733C4.51666 6.83273 4.42743 6.61732 4.26861 6.4585C4.10979 6.29967 3.89438 6.21045 3.66977 6.21045C3.44516 6.21045 3.22976 6.29967 3.07093 6.4585L0.248056 9.28137C0.169413 9.36001 0.107029 9.45337 0.0644678 9.55612C0.0219062 9.65887 0 9.769 0 9.88021C0 9.99143 0.0219062 10.1016 0.0644678 10.2043C0.107029 10.3071 0.169413 10.4004 0.248056 10.4791L3.07093 13.3019C3.22976 13.4608 3.44516 13.55 3.66977 13.55C3.89438 13.55 4.10979 13.4608 4.26861 13.3019C4.42743 13.1431 4.51666 12.9277 4.51666 12.7031C4.51666 12.4785 4.42743 12.2631 4.26861 12.1043L2.8914 10.7271H12.2513C12.4759 10.7271 12.6913 10.6379 12.8501 10.479C13.0089 10.3202 13.0982 10.1048 13.0982 9.88021C13.0982 9.65561 13.0089 9.44021 12.8501 9.28139C12.6913 9.12257 12.4759 9.03335 12.2513 9.03335Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgMiHumberger({ fill = "#292929" }) {
  return (
    <svg
      width="17"
      height="12"
      viewBox="0 0 17 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9358 11.9999H5.49401C5.06365 11.9999 4.71484 11.6162 4.71484 11.1428C4.71484 10.6694 5.06365 10.2856 5.49401 10.2856H15.9356C16.3659 10.2856 16.7147 10.6694 16.7147 11.1428C16.7147 11.6162 16.3662 11.9999 15.9358 11.9999Z"
        fill={fill}
      />
      <path
        d="M15.9358 6.85685H5.49401C5.06365 6.85685 4.71484 6.47314 4.71484 5.99971C4.71484 5.52629 5.06365 5.14258 5.49401 5.14258H15.9356C16.3659 5.14258 16.7147 5.52629 16.7147 5.99971C16.715 6.47314 16.3662 6.85685 15.9358 6.85685Z"
        fill={fill}
      />
      <path
        d="M15.9358 1.71427H5.49401C5.06365 1.71427 4.71484 1.33056 4.71484 0.857134C4.71484 0.38371 5.06365 0 5.49401 0H15.9356C16.3659 0 16.7147 0.38371 16.7147 0.857134C16.7147 1.33056 16.3662 1.71427 15.9358 1.71427Z"
        fill={fill}
      />
      <path
        d="M1.42969 2C1.98197 2 2.42969 1.55228 2.42969 1C2.42969 0.447715 1.98197 0 1.42969 0C0.877403 0 0.429688 0.447715 0.429688 1C0.429688 1.55228 0.877403 2 1.42969 2Z"
        fill={fill}
      />
      <path
        d="M1.42969 7C1.98197 7 2.42969 6.55228 2.42969 6C2.42969 5.44772 1.98197 5 1.42969 5C0.877403 5 0.429688 5.44772 0.429688 6C0.429688 6.55228 0.877403 7 1.42969 7Z"
        fill={fill}
      />
      <path
        d="M1.42969 12C1.98197 12 2.42969 11.5523 2.42969 11C2.42969 10.4477 1.98197 10 1.42969 10C0.877403 10 0.429688 10.4477 0.429688 11C0.429688 11.5523 0.877403 12 1.42969 12Z"
        fill={fill}
      />
    </svg>
  );
}

export function SvgTag() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.2236 14.441C8.47826 15.1863 7.36025 15.1863 6.61491 14.441L0.931677 8.75776C0.465838 8.29193 0 7.36025 0 6.52174V1.86335C0 0.838509 0.838509 0 1.86335 0H6.52174C7.26708 0 8.19876 0.372671 8.75776 0.931677L14.441 6.61491C15.1863 7.36025 15.1863 8.47826 14.441 9.2236L9.2236 14.441ZM4.65838 6.61491C5.68323 6.61491 6.52174 5.7764 6.52174 4.75155C6.52174 3.72671 5.68323 2.8882 4.65838 2.8882C3.63354 2.8882 2.79503 3.72671 2.79503 4.75155C2.79503 5.7764 3.63354 6.61491 4.65838 6.61491Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function SvgWhiteRoundEdit() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="15"
        cy="15"
        r="15"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8061 13.6714L18.5661 13.9114L15.9261 11.2714L16.1661 11.0314C16.6461 10.5514 17.3061 10.3714 17.9661 10.5514C18.6261 10.7314 19.1061 11.2114 19.2861 11.8714C19.4661 12.5314 19.2861 13.1914 18.8061 13.6714ZM17.6661 14.8114L15.9261 16.5514L13.5861 18.8914C13.2861 19.1914 12.9261 19.3714 12.5661 19.4914L10.2861 20.0914C10.1661 20.1514 9.98609 20.0914 9.92609 20.0314C9.74609 19.9114 9.74609 19.7314 9.74609 19.6114L10.3461 17.3314C10.4661 16.9714 10.6461 16.6114 10.9461 16.3114L13.2861 13.9714L15.0261 12.2314L17.6661 14.8114Z"
        fill="#808D93"
      />
    </svg>
  );
}

export function SvgWhiteRoundCancel() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="15"
        cy="15"
        r="15"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2658 15.0003L10.9583 11.6928C10.7483 11.4828 10.7483 11.1678 10.9583 10.9578C11.1683 10.7478 11.4833 10.7478 11.6933 10.9578L15.0008 14.2653L18.3083 10.9578C18.5183 10.7478 18.8333 10.7478 19.0433 10.9578C19.2533 11.1678 19.2533 11.4828 19.0433 11.6928L15.7358 15.0003L19.0433 18.3078C19.2533 18.5178 19.2533 18.8328 19.0433 19.0428C18.8333 19.2528 18.5183 19.2528 18.3083 19.0428L15.0008 15.7353L11.6933 19.0428C11.4833 19.2528 11.1683 19.2528 10.9583 19.0428C10.7483 18.8328 10.7483 18.5178 10.9583 18.3078L14.2658 15.0003Z"
        fill="#808D93"
        stroke="#808D93"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function SvgDuplicate() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M9.36 0H0.52C0.232959 0 0 0.232959 0 0.52V9.36C0 9.64704 0.232959 9.88 0.52 9.88H9.36C9.64704 9.88 9.88 9.64704 9.88 9.36V0.52C9.88 0.232959 9.64704 0 9.36 0Z"
          fill="#292929"
        />
        <path
          d="M11.9602 10.6602V11.9602H10.6602V13.0002H12.4802C12.7672 13.0002 13.0002 12.7672 13.0002 12.4802V10.6602H11.9602Z"
          fill="#292929"
        />
        <path
          d="M9.4597 11.96H6.66211V13H9.4597V11.96Z"
          fill="#292929"
        />
        <path
          d="M4.15914 11.9602V10.6602H3.11914V12.4802C3.11914 12.7672 3.3521 13.0002 3.63914 13.0002H5.45914V11.9602H4.15914Z"
          fill="#292929"
        />
        <path
          d="M12.4802 3.12012H10.6602V4.16012H11.9602V5.46012H13.0002V3.64012C13.0002 3.35308 12.7672 3.12012 12.4802 3.12012Z"
          fill="#292929"
        />
        <path
          d="M13.0009 6.66113H11.9609V9.45872H13.0009V6.66113Z"
          fill="#292929"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="13"
            height="13"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgLinkIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.88177 16C2.85965 16 1.8944 15.595 1.14968 14.8503C0.369894 14.0705 -0.0374195 13.0488 0.00270553 11.9733C0.0441743 10.8626 0.545956 9.79562 1.45383 8.88774L3.08846 7.24646C3.33202 7.00186 3.72774 7.00105 3.97234 7.24465C4.2169 7.48821 4.21774 7.88396 3.97415 8.12852L2.33865 9.77074C1.0133 11.0961 0.888238 12.8211 2.03361 13.9664C3.17902 15.1119 4.90399 14.9868 6.22837 13.6623L8.47484 11.4158C9.15575 10.735 9.53125 9.95749 9.56072 9.16755C9.58775 8.44349 9.31012 7.75221 8.779 7.22108C8.60103 7.04315 8.40412 6.89215 8.19372 6.7723C7.89378 6.60146 7.78912 6.2198 7.95997 5.91989C8.13084 5.61996 8.5125 5.51533 8.81237 5.68614C9.11981 5.86127 9.40597 6.08033 9.66291 6.33724C10.4427 7.11702 10.85 8.13874 10.8099 9.21421C10.7684 10.3249 10.2666 11.3919 9.35875 12.2998L7.11228 14.5462C6.20437 15.4541 5.13743 15.9559 4.02671 15.9974C3.97834 15.9991 3.92993 16 3.88177 16ZM8.04015 10.0801C8.211 9.78018 8.10631 9.39852 7.8064 9.22771C7.596 9.10787 7.39906 8.95687 7.22112 8.77896C6.07574 7.63355 6.20081 5.90858 7.52525 4.58414L9.77172 2.3377C11.0962 1.01329 12.8211 0.888199 13.9665 2.03358C15.1119 3.17895 14.9868 4.90392 13.6614 6.22927L12.0259 7.87149C11.7823 8.11605 11.7832 8.5118 12.0278 8.75537C12.2723 8.99896 12.668 8.99809 12.9116 8.75355L14.5463 7.11224C15.4541 6.20436 15.9559 5.13739 15.9974 4.0267C16.0375 2.95123 15.6302 1.92948 14.8504 1.1497C14.0706 0.369886 13.0483 -0.0373647 11.9734 0.00269783C10.8627 0.0441666 9.79572 0.545949 8.88787 1.45382L6.64137 3.70027C5.73349 4.60814 5.23174 5.67511 5.19024 6.7858C5.15012 7.86127 5.55743 8.88302 6.33721 9.66284C6.59412 9.91971 6.88028 10.1387 7.18775 10.3139C7.28537 10.3695 7.39162 10.3959 7.4965 10.3959C7.71378 10.3959 7.9249 10.2824 8.04015 10.0801Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgEyesIcon() {
  return (
    <svg
      width="20"
      height="12"
      viewBox="0 0 20 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66292 0.241211C5.97052 0.241211 2.62205 2.26136 0.151215 5.54263C-0.050405 5.81145 -0.050405 6.18702 0.151215 6.45584C2.62205 9.74106 5.97052 11.7612 9.66292 11.7612C13.3553 11.7612 16.7038 9.74106 19.1746 6.4598C19.3763 6.19097 19.3763 5.81541 19.1746 5.54658C16.7038 2.26136 13.3553 0.241211 9.66292 0.241211ZM9.9278 10.0573C7.47673 10.2115 5.45263 8.19136 5.60681 5.73634C5.73332 3.71223 7.37395 2.0716 9.39805 1.9451C11.8491 1.79092 13.8732 3.81107 13.719 6.26608C13.5886 8.28624 11.9479 9.92687 9.9278 10.0573ZM9.80524 8.18345C8.48483 8.26647 7.39371 7.1793 7.48069 5.85889C7.54789 4.76777 8.43344 3.88618 9.52456 3.81502C10.845 3.732 11.9361 4.81917 11.8491 6.13958C11.778 7.23465 10.8924 8.11624 9.80524 8.18345Z"
        fill="#73C7B7"
      />
    </svg>
  );
}

export function SvgGreyRoundEdit() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.42918 3.30983L9.1794 3.55897L6.43183 0.81848L6.68161 0.569345C7.18117 0.0710742 7.86806 -0.115777 8.55495 0.0710742C9.24185 0.257926 9.74141 0.756196 9.92874 1.44132C10.1161 2.12644 9.92874 2.81156 9.42918 3.30983ZM8.24273 4.49323L6.43183 6.29946L3.99647 8.72853C3.68425 9.03994 3.30958 9.2268 2.93491 9.35136L0.562004 9.9742C0.437114 10.0365 0.24978 9.9742 0.187335 9.91192C0 9.78735 0 9.6005 0 9.47593L0.624449 7.10915C0.749339 6.73544 0.936674 6.36174 1.2489 6.05032L3.68425 3.62125L5.49515 1.81502L8.24273 4.49323Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgGreyRoundDelete() {
  return (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00945 4.00489L7.88634 1.1405C8.02427 1.00382 8.02427 0.782541 7.88634 0.646208C7.74876 0.509526 7.52529 0.509526 7.38771 0.646208L4.51327 3.50815L1.61229 0.603561C1.47471 0.46548 1.25123 0.46548 1.11366 0.603561C0.976081 0.741991 0.976081 0.966067 1.11366 1.10415L4.01255 4.00664L1.10318 6.90319C0.965606 7.03988 0.965606 7.26115 1.10318 7.39749C1.24076 7.53417 1.46423 7.53417 1.60181 7.39749L4.50873 4.50338L7.39819 7.39644C7.53577 7.53452 7.75924 7.53452 7.89682 7.39644C8.03439 7.25801 8.03439 7.03393 7.89682 6.89585L5.00945 4.00489Z"
        fill="#292929"
        stroke="#292929"
      />
    </svg>
  );
}

export function SvgRecruter() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0006 10.0001C11.1745 10.0001 12.1262 9.04841 12.1262 7.87448C12.1262 6.70056 11.1745 5.7489 10.0006 5.7489C8.82666 5.7489 7.875 6.70056 7.875 7.87448C7.875 9.04841 8.82666 10.0001 10.0006 10.0001Z"
        fill="#292929"
      />
      <path
        d="M9.99967 10.7062C8.04626 10.7062 6.45703 12.0967 6.45703 13.806C6.45703 14.0506 6.68361 14.2488 6.96312 14.2488H13.0362C13.3157 14.2488 13.5423 14.0506 13.5423 13.806C13.5423 12.0967 11.9531 10.7062 9.99967 10.7062Z"
        fill="#292929"
      />
      <path
        d="M10.0004 1.49927C5.31219 1.49927 1.49805 5.31341 1.49805 10.0016C1.49805 14.6898 5.31219 18.5039 10.0004 18.5039C14.6886 18.5039 18.5027 14.6898 18.5027 10.0016C18.5027 5.31341 14.6886 1.49927 10.0004 1.49927ZM10.0004 17.3703C5.93728 17.3703 2.63169 14.0647 2.63169 10.0016C2.63169 5.9385 5.93728 2.63291 10.0004 2.63291C14.0635 2.63291 17.3691 5.9385 17.3691 10.0016C17.3691 14.0647 14.0635 17.3703 10.0004 17.3703Z"
        fill="#292929"
      />
      <line
        x1="9.97461"
        y1="2.18557e-08"
        x2="9.97461"
        y2="2.1054"
        stroke="#292929"
      />
      <line
        x1="9.97461"
        y1="17.8943"
        x2="9.97461"
        y2="19.9997"
        stroke="#292929"
      />
      <path
        d="M17.6523 10.3264H20.0006"
        stroke="#292929"
      />
      <path
        d="M0 10.3264L2.34823 10.3264"
        stroke="#292929"
      />
    </svg>
  );
}

export function SvgChangeName() {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2545 5.04855L11.9299 5.37317L8.35904 1.80232L8.68367 1.4777C9.33291 0.82845 10.2256 0.584982 11.1183 0.82845C12.0111 1.07192 12.6603 1.72116 12.9038 2.61388C13.1472 3.50659 12.9038 4.39931 12.2545 5.04855ZM10.7126 6.59051L8.35904 8.94403L5.19397 12.1091C4.78819 12.5149 4.30126 12.7584 3.81432 12.9207L0.730402 13.7322C0.56809 13.8134 0.324623 13.7322 0.243467 13.6511C0 13.4888 0 13.2453 0 13.083L0.811558 9.99906C0.973869 9.51212 1.21734 9.02519 1.62312 8.61941L4.78819 5.45433L7.14171 3.10081L10.7126 6.59051Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgChangeColor() {
  return (
    <svg
      width="15"
      height="20"
      viewBox="0 0 15 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8435 2.047C14.8435 1.49999 14.6305 0.985675 14.2437 0.598864C13.4452 -0.199563 12.146 -0.19968 11.3474 0.598864L9.3746 2.57167L8.4789 1.67597C8.32632 1.52343 8.07904 1.52343 7.92642 1.67597L6.7545 2.84789C6.60196 3.00043 6.60196 3.24779 6.7545 3.40037L7.6502 4.29606L1.99984 9.94642C1.95695 9.98931 1.92465 10.0416 1.90547 10.0991L1.54401 11.1835L1.21857 11.509C0.635498 12.0921 0.635459 13.0409 1.21857 13.624C1.80167 14.2071 2.75046 14.2071 3.33356 13.624L3.659 13.2986L4.74342 12.9371C4.80096 12.9179 4.85323 12.8856 4.89612 12.8427L10.5465 7.19234L11.4422 8.08803C11.5948 8.24058 11.8421 8.24058 11.9947 8.08803L13.1666 6.91612C13.3192 6.76357 13.3192 6.51622 13.1666 6.36364L12.2709 5.46794L14.2437 3.49514C14.6305 3.10833 14.8435 2.59405 14.8435 2.047ZM7.6502 8.98369H4.06746L8.20268 4.84851L9.99403 6.63986L7.6502 8.98369ZM11.7184 7.25933L7.58321 3.12411L8.20264 2.50463L12.3378 6.63986L11.7184 7.25933ZM13.6912 2.9427L11.7184 4.9155L9.92704 3.12411L11.8998 1.15131C12.3938 0.657421 13.1974 0.657382 13.6912 1.15131C14.1827 1.62281 14.1826 2.4712 13.6912 2.9427Z"
        fill="#292929"
      />
      <path
        d="M1.95319 14.5312C1.82487 14.5312 1.70471 14.5943 1.63178 14.6998C1.35927 15.0944 0 17.1097 0 18.047C0 19.124 0.876203 20.0002 1.95319 20.0002C3.03019 20.0002 3.90639 19.124 3.90639 18.047C3.90639 17.1097 2.54712 15.0944 2.27461 14.6998C2.20168 14.5943 2.08152 14.5312 1.95319 14.5312ZM1.95319 19.2189C1.307 19.2189 0.781278 18.6932 0.781278 18.047C0.781278 17.6203 1.39095 16.5069 1.95319 15.6283C2.51544 16.5069 3.12511 17.6203 3.12511 18.047C3.12511 18.6932 2.59939 19.2189 1.95319 19.2189Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgGreenLocation() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25C19.4036 25 25 19.4036 25 12.5Z"
        fill="#73C7B7"
      />
      <path
        d="M12.5538 7.57617C10.6449 7.57617 9.0918 9.12928 9.0918 11.0382C9.0918 11.7936 9.33041 12.5114 9.78242 13.1136L12.3404 16.5588C12.3468 16.5671 12.3566 16.5703 12.3637 16.5778C12.4915 16.7147 12.676 16.6802 12.767 16.5588C13.5036 15.5759 14.8538 13.7403 15.3729 13.0479C15.3729 13.0479 15.3731 13.0474 15.3733 13.047L15.3765 13.0428C15.7948 12.4551 16.0158 11.762 16.0158 11.0382C16.0158 9.12928 14.4627 7.57617 12.5538 7.57617ZM12.5538 12.9059C11.526 12.9059 10.6861 12.066 10.6861 11.0382C10.6861 10.0104 11.526 9.17047 12.5538 9.17047C13.5816 9.17047 14.4215 10.0104 14.4215 11.0382C14.4215 12.066 13.5816 12.9059 12.5538 12.9059Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgGreenGroup() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25C19.4036 25 25 19.4036 25 12.5Z"
        fill="#73C7B7"
      />
      <path
        d="M11.6063 13.1433C12.8786 13.1433 13.9099 12.112 13.9099 10.8397C13.9099 9.56748 12.8786 8.53613 11.6063 8.53613C10.3341 8.53613 9.30273 9.56748 9.30273 10.8397C9.30273 12.112 10.3341 13.1433 11.6063 13.1433Z"
        fill="white"
      />
      <path
        d="M16.08 15.5397C13.4884 13.3644 9.72515 13.3644 7.13361 15.5397C7.04914 15.6111 7 15.7171 7 15.8284V16.8889C7 17.4079 7.344 17.7504 7.76786 17.7504H15.4465C15.8704 17.7504 16.2144 17.4079 16.2144 16.9833V15.9405C16.2144 15.7171 16.1652 15.6111 16.08 15.5397Z"
        fill="white"
      />
      <path
        d="M14.6794 10.8393C14.6794 11.1012 14.6456 11.3553 14.5834 11.5972C14.6164 11.5987 14.6464 11.6072 14.6794 11.6072C15.9495 11.6072 16.983 10.5736 16.983 9.30359C16.983 8.03354 15.9495 7 14.6794 7C13.8916 7 13.1967 7.39852 12.7812 8.00283C13.8939 8.46508 14.6794 9.56159 14.6794 10.8393Z"
        fill="white"
      />
      <path
        d="M19.1515 14.0039C17.7386 12.8184 15.9779 12.2839 14.2487 12.3914C14.0245 12.7684 13.7258 13.0971 13.3672 13.3497C14.5274 13.6215 15.6393 14.159 16.6022 14.9745C16.851 15.1849 16.9823 15.5051 16.9823 15.8307V16.2146H18.518C18.9419 16.2146 19.2859 15.8706 19.2859 15.4468V14.295C19.2859 14.1836 19.2367 14.0754 19.1515 14.0039Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgWhiteUpload() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.53088 0.36785C6.47389 0.311769 6.3971 0.280635 6.31729 0.281259C6.23713 0.281288 6.16029 0.313302 6.10369 0.370263L0.0856585 6.42737C-0.0306413 6.54708 -0.0282089 6.73877 0.0910889 6.85547C0.146835 6.90999 0.221417 6.94078 0.299252 6.94141H3.61778L3.61778 11.6973C3.61778 11.8645 3.75286 12 3.91948 12L8.74646 12C8.91307 12 9.04815 11.8645 9.04815 11.6973L9.04815 6.94141L12.354 6.94141C12.5206 6.94172 12.6559 6.8064 12.6562 6.6392C12.6564 6.5586 12.6245 6.48126 12.5676 6.42433L6.53088 0.36785Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgInfoIcon() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.49964 0C3.80584 0 0 3.80584 0 8.49964C0 13.1934 3.80584 17 8.49964 17C13.1934 17 17 13.1934 17 8.49964C17 3.80584 13.1934 0 8.49964 0ZM10.2691 13.1733C9.83158 13.346 9.4833 13.477 9.2221 13.5676C8.96161 13.6583 8.65867 13.7036 8.31399 13.7036C7.78438 13.7036 7.37206 13.5741 7.07848 13.3158C6.78489 13.0574 6.63881 12.73 6.63881 12.3321C6.63881 12.1774 6.64961 12.0191 6.6712 11.8579C6.6935 11.6967 6.72876 11.5154 6.77697 11.3117L7.32457 9.37752C7.37278 9.19187 7.41452 9.01558 7.44762 8.85151C7.48072 8.68601 7.49655 8.53418 7.49655 8.39602C7.49655 8.14993 7.44546 7.97723 7.344 7.88008C7.2411 7.78294 7.04753 7.73545 6.75898 7.73545C6.61795 7.73545 6.47259 7.75632 6.32364 7.80021C6.17613 7.84554 6.04804 7.88656 5.94298 7.92686L6.08762 7.33105C6.44597 7.18497 6.78921 7.05977 7.11661 6.95615C7.44402 6.85109 7.75344 6.79928 8.04487 6.79928C8.57088 6.79928 8.97672 6.92737 9.26239 7.18066C9.54662 7.43467 9.68982 7.76495 9.68982 8.17079C9.68982 8.25498 9.67975 8.40322 9.66032 8.61477C9.64089 8.82705 9.60419 9.02061 9.55094 9.19835L9.00622 11.1268C8.96161 11.2815 8.92203 11.4585 8.88605 11.6564C8.85079 11.8543 8.83352 12.0054 8.83352 12.1069C8.83352 12.363 8.89037 12.5379 9.0055 12.6307C9.1192 12.7236 9.31852 12.7703 9.60059 12.7703C9.73371 12.7703 9.88267 12.7466 10.051 12.7005C10.218 12.6545 10.3389 12.6135 10.4152 12.5782L10.2691 13.1733ZM10.1727 5.34574C9.91865 5.58176 9.61283 5.69977 9.2552 5.69977C8.89829 5.69977 8.59031 5.58176 8.33414 5.34574C8.07941 5.10971 7.9506 4.8226 7.9506 4.48728C7.9506 4.15268 8.08013 3.86485 8.33414 3.62667C8.59031 3.38777 8.89829 3.26904 9.2552 3.26904C9.61283 3.26904 9.91936 3.38777 10.1727 3.62667C10.4267 3.86485 10.554 4.15268 10.554 4.48728C10.554 4.82332 10.4267 5.10971 10.1727 5.34574Z"
        fill="#3F3F51"
      />
    </svg>
  );
}

export function SvgCommentTable() {
  return (
    <svg
      width="28"
      height="25"
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.04031 24.4328H2.07407L3.46441 23.0425C4.21406 22.2928 4.68219 21.3178 4.80805 20.26C1.59774 18.1533 0 15.1013 0 11.9016C0 5.99874 5.42533 0 13.922 0C22.9233 0 27.75 5.51996 27.75 11.3845C27.75 17.2877 22.8723 22.8039 13.922 22.8039C12.3541 22.8039 10.7181 22.5946 9.25737 22.2106C7.87463 23.6288 6.00113 24.4328 4.04031 24.4328Z"
        fill="#73C7B7"
      />
      <path
        d="M13.56 13.12C14.4216 13.12 15.12 12.4216 15.12 11.56C15.12 10.6984 14.4216 10 13.56 10C12.6984 10 12 10.6984 12 11.56C12 12.4216 12.6984 13.12 13.56 13.12Z"
        fill="white"
      />
      <path
        d="M19.56 13.12C20.4216 13.12 21.12 12.4216 21.12 11.56C21.12 10.6984 20.4216 10 19.56 10C18.6984 10 18 10.6984 18 11.56C18 12.4216 18.6984 13.12 19.56 13.12Z"
        fill="white"
      />
      <path
        d="M7.56 13.12C8.42156 13.12 9.12 12.4216 9.12 11.56C9.12 10.6984 8.42156 10 7.56 10C6.69844 10 6 10.6984 6 11.56C6 12.4216 6.69844 13.12 7.56 13.12Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgCollapseSideBar() {
  return (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.0899651 7.91C0.137225 7.96251 0.203976 7.99676 0.280232 7.99701L2.4362 8C2.57896 8.00025 2.69447 7.88475 2.69422 7.74197C2.69398 7.59921 2.52746 7.4387 2.45595 7.36719L1.91066 6.82188L3.49756 5.25024L2.74748 4.50016L1.18383 6.09482L0.638529 5.54951C0.520517 5.4315 0.400754 5.30598 0.257995 5.30574C0.115235 5.30548 -0.000279414 5.421 -3.0969e-05 5.56376L0.00296328 7.71972C0.00321172 7.79598 0.0374632 7.86274 0.0899651 7.91Z"
        fill="#292929"
      />
      <path
        d="M4.5046 2.74993L6.05875 1.20602L5.50394 0.64773C5.43119 0.574716 5.26193 0.410203 5.26167 0.264188C5.26167 0.118174 5.37918 -8.63167e-05 5.5242 0.000162103L7.71692 0.00315573C7.79443 0.00341727 7.8622 0.038414 7.91044 0.092171C7.96395 0.140672 7.99896 0.208928 7.99896 0.286936L8.00195 2.49365C8.00195 2.63967 7.88469 2.75793 7.73943 2.75768C7.59441 2.75743 7.47266 2.62892 7.35263 2.50815L6.79808 1.95009L5.25467 3.5L4.5046 2.74993Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgMaterial({ color = "#292929" }) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3991 0.392733C9.728 0.0424633 8.81861 0.0370587 8.14213 0.386426C5.54917 1.72557 3.1973 3.261 1.13632 4.96401C0.817615 5.22736 0.591435 5.61005 0.595294 6.06049C0.599137 6.50909 0.82992 6.88666 1.14669 7.14567C3.19054 8.81685 5.54435 10.3537 8.08984 11.6822C8.76096 12.0325 9.67036 12.0379 10.3468 11.6885C12.9398 10.3494 15.2917 8.81394 17.3526 7.11093C17.6713 6.84758 17.8975 6.46489 17.8937 6.01444C17.8898 5.56585 17.659 5.18827 17.3423 4.92926C15.2984 3.25809 12.9446 1.72127 10.3991 0.392733ZM8.83044 1.71918C9.0701 1.59541 9.46379 1.59658 9.70508 1.72251C12.1344 2.99043 14.3728 4.44913 16.312 6.0247C14.3612 7.62562 12.1295 9.07961 9.65853 10.3558C9.41886 10.4795 9.02517 10.4784 8.78388 10.3524C6.35454 9.08451 4.11614 7.6258 2.17691 6.05024C4.12771 4.44931 6.35946 2.99532 8.83044 1.71918Z"
        fill={color}
      />
      <path
        d="M18.4415 9.7305C18.6609 10.0819 18.5539 10.5445 18.2025 10.7639L12.0953 14.5768C11.2665 15.0942 10.2383 15.3334 9.24439 15.3334C8.25046 15.3335 7.22221 15.0944 6.39335 14.5771L0.353015 10.8074C0.00162017 10.5881 -0.105461 10.1254 0.113844 9.77403C0.333148 9.42263 0.795792 9.31555 1.14719 9.53486L7.18752 13.3046C7.73167 13.6442 8.47086 13.8335 9.2443 13.8334C10.0178 13.8334 10.7569 13.644 11.3009 13.3044L17.4081 9.4915C17.7595 9.27213 18.2222 9.37914 18.4415 9.7305Z"
        fill={color}
      />
      <path
        d="M18.4415 13.4851C18.6609 13.8365 18.5539 14.2992 18.2026 14.5186L12.9137 17.8214C11.856 18.4819 10.5331 18.7926 9.24435 18.7927C7.95564 18.7928 6.63258 18.4822 5.5748 17.8219L0.352939 14.562C0.00156999 14.3427 -0.105455 13.88 0.113891 13.5287C0.333238 13.1773 0.795894 13.0703 1.14726 13.2896L6.36913 16.5494C7.14214 17.032 8.17607 17.2928 9.24426 17.2927C10.3125 17.2927 11.3463 17.0318 12.1191 16.5491L17.4081 13.2463C17.7594 13.0269 18.2221 13.1338 18.4415 13.4851Z"
        fill={color}
      />
    </svg>
  );
}

export function SvgMosaiquePhoto() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 16V2C18 0.9 17.1 0 16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16ZM5.9 10.98L8 13.51L11.1 9.52C11.3 9.26 11.7 9.26 11.9 9.53L15.41 14.21C15.66 14.54 15.42 15.01 15.01 15.01H3.02C2.6 15.01 2.37 14.53 2.63 14.2L5.12 11C5.31 10.74 5.69 10.73 5.9 10.98Z"
        fill="#1D1D1D"
      />
    </svg>
  );
}

export function SvgAngleRightIcon({ className = "arh-stroke-greenColor" }) {
  return (
    <svg
      width="5"
      height="10"
      viewBox="0 0 5 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.34315 4.88611L1.35164 1.08882C1.2526 0.967415 1.09479 0.970901 0.999142 1.09661C0.905833 1.21924 0.905833 1.41365 0.999142 1.53627L3.81441 5.10983L0.999142 8.68339C0.901816 8.80695 0.901816 9.00727 0.999142 9.13083C1.0965 9.25437 1.2543 9.25437 1.35164 9.13083L4.34315 5.33355C4.44048 5.20997 4.44048 5.00967 4.34315 4.88611Z"
        fill="white"
        stroke=""
      />
    </svg>
  );
}

export function SvgThinCloseModalIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.39491 7.33024L14.4185 1.33957C14.7073 1.0537 14.7073 0.590915 14.4185 0.305785C14.1304 0.0199228 13.6625 0.0199228 13.3745 0.305785L7.35601 6.29134L1.28199 0.21659C0.993936 -0.0721966 0.52603 -0.0721966 0.237975 0.21659C-0.0500805 0.506107 -0.0500805 0.974745 0.237975 1.26353L6.3076 7.33389L0.216041 13.3918C-0.0720138 13.6777 -0.0720138 14.1405 0.216041 14.4256C0.504096 14.7115 0.972003 14.7115 1.26006 14.4256L7.3465 8.37279L13.3964 14.4234C13.6844 14.7122 14.1524 14.7122 14.4404 14.4234C14.7285 14.1339 14.7285 13.6653 14.4404 13.3765L8.39491 7.33024Z"
        fill="#121313"
      />
    </svg>
  );
}

export function SvgThinDownloadIcon() {
  return (
    <svg
      width="10"
      height="13"
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.1 13H0V11.7H9.1V13ZM4.55 10.4L0.65 6.5L1.5665 5.5835L3.9 7.9105V0H5.2V7.9105L7.5335 5.5835L8.45 6.5L4.55 10.4Z"
        fill="#5F6568"
      />
    </svg>
  );
}

export function SvgExcelIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2133 1.53429H10.7025V0L0 1.65186V16.1541L10.7025 18V15.725H17.2133C17.6478 15.725 18 15.4076 18 15.0196V2.23971C18 1.85173 17.6478 1.53429 17.2133 1.53429ZM17.319 15.1372H10.6849L10.6732 13.9203H12.2701V12.5036H10.6614L10.6556 11.6688H12.2701V10.2521H10.638L10.6321 9.41737H12.2701V7.99477H10.6262V7.16003H12.2701V5.7433H10.6262V4.90856H12.2701V3.49184H10.6262V2.20444H17.319V15.1372Z"
        fill="#73C7B7"
      />
      <path
        d="M15.9452 3.49219H13.1683V4.90891H15.9452V3.49219Z"
        fill="#73C7B7"
      />
      <path
        d="M15.9452 5.74316H13.1683V7.15989H15.9452V5.74316Z"
        fill="#73C7B7"
      />
      <path
        d="M15.9452 7.99512H13.1683V9.41184H15.9452V7.99512Z"
        fill="#73C7B7"
      />
      <path
        d="M15.9452 10.252H13.1683V11.6687H15.9452V10.252Z"
        fill="#73C7B7"
      />
      <path
        d="M15.9452 12.5039H13.1683V13.9206H15.9452V12.5039Z"
        fill="#73C7B7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.79454 5.57213L4.17419 5.48983L5.04308 7.87651L6.06461 5.39578L7.44426 5.31348L5.77106 8.70537L7.44426 12.1032L5.98828 12.0032L5.00198 9.4108L4.01568 11.9033L2.67712 11.7857L4.2329 8.78179L2.79454 5.57213Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgExcelOrange() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_33143_5766)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.757 1.94905H10.608V0.5L0.5 2.06009V15.7567L10.608 17.5V15.3514H16.757C17.1673 15.3514 17.5 15.0516 17.5 14.6852V2.61528C17.5 2.24886 17.1673 1.94905 16.757 1.94905ZM16.8568 14.7962H10.5913L10.5802 13.647H12.0884V12.3089H10.5691L10.5636 11.5206H12.0884V10.1826H10.547L10.5414 9.39419H12.0884V8.05062H10.5359V7.26225H12.0884V5.92423H10.5359V5.13586H12.0884V3.79784H10.5359V2.58197H16.8568V14.7962Z"
          fill="#F55611"
        />
        <path
          d="M15.5601 3.79761H12.9375V5.13562H15.5601V3.79761Z"
          fill="#F55611"
        />
        <path
          d="M15.5601 5.92407H12.9375V7.26209H15.5601V5.92407Z"
          fill="#F55611"
        />
        <path
          d="M15.5601 8.05054H12.9375V9.38855H15.5601V8.05054Z"
          fill="#F55611"
        />
        <path
          d="M15.5601 10.1824H12.9375V11.5204H15.5601V10.1824Z"
          fill="#F55611"
        />
        <path
          d="M15.5601 12.3088H12.9375V13.6469H15.5601V12.3088Z"
          fill="#F55611"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.14214 5.76308L4.44515 5.68536L5.26576 7.93944L6.23054 5.59653L7.53354 5.5188L5.9533 8.72226L7.53354 11.9313L6.15846 11.8369L5.22695 9.38849L4.29544 11.7425L3.03125 11.6315L4.50059 8.79443L3.14214 5.76308Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_33143_5766">
          <rect
            width="17"
            height="17"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgImportFileIcon() {
  return (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5995 18H1.79992C0.805852 18 0 17.1941 0 16.2001V1.80071C0 0.806637 0.805852 0.000784292 1.79992 0.000784292H8.09965C8.10771 -0.000261431 8.11588 -0.000261431 8.12395 0.000784292H8.12935C8.13785 0.00344643 8.14659 0.00525528 8.15545 0.00618406C8.23481 0.0112717 8.31317 0.0267015 8.38853 0.0520821H8.40203H8.41553H8.42633C8.44294 0.0637147 8.45859 0.0766553 8.47313 0.0907804C8.57118 0.13436 8.66052 0.195342 8.73682 0.270773L14.1366 5.67054C14.212 5.74684 14.273 5.83618 14.3166 5.93423C14.3247 5.95402 14.331 5.97292 14.3373 5.99362L14.3463 6.01882C14.3714 6.09387 14.3862 6.17198 14.3904 6.25101C14.3912 6.25998 14.3933 6.26877 14.3967 6.27711V6.28251C14.3981 6.28841 14.3991 6.29444 14.3994 6.30051V16.2001C14.3994 16.6774 14.2097 17.1353 13.8722 17.4728C13.5346 17.8104 13.0768 18 12.5995 18ZM8.09965 1.80071V6.30051H12.5995L8.09965 1.80071Z"
        fill="#73C7B7"
      />
      <path
        d="M8 12.905C8 12.7945 8.08954 12.705 8.2 12.705H9.795H10.5359C10.7114 12.705 10.8018 12.4952 10.6813 12.3677L7.64539 9.1539C7.56646 9.07036 7.43354 9.07036 7.35461 9.1539L4.31868 12.3677C4.19819 12.4952 4.28861 12.705 4.46406 12.705H5.205H6.8C6.91046 12.705 7 12.7945 7 12.905V16.8C7 16.9105 7.08954 17 7.2 17H7.8C7.91046 17 8 16.9105 8 16.8V12.905Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgList() {
  return (
    <svg
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8571 11.1429C14.8571 10.5857 14.4857 10.2143 13.9286 10.2143H5.57143C5.01429 10.2143 4.64286 10.5857 4.64286 11.1429C4.64286 11.7 5.01429 12.0714 5.57143 12.0714H13.9286C14.4857 12.0714 14.8571 11.7 14.8571 11.1429ZM14.8571 6.5C14.8571 5.94286 14.4857 5.57143 13.9286 5.57143H5.57143C5.01429 5.57143 4.64286 5.94286 4.64286 6.5C4.64286 7.05714 5.01429 7.42857 5.57143 7.42857H13.9286C14.4857 7.42857 14.8571 7.05714 14.8571 6.5ZM14.8571 1.85714C14.8571 1.3 14.4857 0.928571 13.9286 0.928571H5.57143C5.01429 0.928571 4.64286 1.3 4.64286 1.85714C4.64286 2.41429 5.01429 2.78571 5.57143 2.78571H13.9286C14.4857 2.78571 14.8571 2.41429 14.8571 1.85714ZM1.85714 13C2.87857 13 3.71429 12.1643 3.71429 11.1429C3.71429 10.1214 2.87857 9.28571 1.85714 9.28571C0.835714 9.28571 0 10.1214 0 11.1429C0 12.1643 0.835714 13 1.85714 13ZM1.85714 8.35714C2.87857 8.35714 3.71429 7.52143 3.71429 6.5C3.71429 5.47857 2.87857 4.64286 1.85714 4.64286C0.835714 4.64286 0 5.47857 0 6.5C0 7.52143 0.835714 8.35714 1.85714 8.35714ZM1.85714 3.71429C2.87857 3.71429 3.71429 2.87857 3.71429 1.85714C3.71429 0.835714 2.87857 0 1.85714 0C0.835714 0 0 0.835714 0 1.85714C0 2.87857 0.835714 3.71429 1.85714 3.71429Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgExportXLS() {
  return (
    <svg
      width="21"
      height="28"
      viewBox="0 0 21 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0801 8.227H18.5278V5.56221C18.5278 5.54559 18.5252 5.52884 18.5232 5.51189C18.5223 5.4062 18.4884 5.30223 18.4159 5.21992L13.9812 0.154252C13.9799 0.152957 13.9786 0.152498 13.9777 0.151078C13.9513 0.121556 13.9204 0.0970024 13.8879 0.0757479C13.8782 0.0692755 13.8685 0.063847 13.8584 0.0581263C13.8302 0.0428431 13.8002 0.02994 13.7694 0.0207117C13.761 0.0184985 13.7535 0.0150744 13.7452 0.0128613C13.7117 0.00496913 13.6769 0 13.6417 0H2.74329C2.24563 0 1.84133 0.404754 1.84133 0.902001V8.22679H1.28917C0.577253 8.22679 0 8.80379 0 9.51596V16.2199C0 16.9314 0.577253 17.5089 1.28917 17.5089H1.84137V22.098C1.84137 22.5952 2.24567 23 2.74333 23H17.6256C18.1229 23 18.5276 22.5952 18.5276 22.098V17.5089H19.0799C19.7916 17.5089 20.369 16.9316 20.369 16.2199V9.51617C20.3689 8.80379 19.792 8.227 19.0801 8.227ZM2.74329 0.902001H13.1907V5.51661C13.1907 5.76577 13.3928 5.96759 13.6417 5.96759H17.6256V8.227H2.74329V0.902001ZM12.8637 14.7965V16.1045H8.56046V9.21602H10.1247V14.7965H12.8637ZM1.78496 16.1043L3.77804 12.6193L1.85641 9.21602H3.645L4.24793 10.4729C4.4525 10.8917 4.60588 11.2294 4.76948 11.6176H4.78965C4.95359 11.1779 5.08617 10.8713 5.2598 10.4729L5.84248 9.21602H7.62084L5.67875 12.5785L7.72323 16.1044H5.92428L5.30089 14.8576C5.04554 14.3771 4.88181 14.0196 4.68772 13.621H4.66726C4.52399 14.0198 4.35061 14.3776 4.13602 14.8576L3.56349 16.1044L1.78496 16.1043ZM17.6256 21.8538H2.74329V17.5089H17.6256L17.6256 21.8538ZM15.4694 16.2071C14.6828 16.2071 13.9057 16.0023 13.5177 15.7878L13.8342 14.5001C14.2534 14.7145 14.8973 14.9295 15.5619 14.9295C16.2776 14.9295 16.6554 14.633 16.6554 14.1834C16.6554 13.754 16.3284 13.5087 15.5004 13.2123C14.3558 12.8135 13.6096 12.18 13.6096 11.1779C13.6096 10.0025 14.5908 9.10327 16.2164 9.10327C16.9928 9.10327 17.5653 9.26725 17.9741 9.45078L17.6266 10.7081C17.3507 10.575 16.8599 10.3809 16.1856 10.3809C15.5111 10.3809 15.1841 10.6873 15.1841 11.0454C15.1841 11.4849 15.5721 11.6793 16.4615 12.0166C17.6777 12.4663 18.2502 13.0996 18.2502 14.0707C18.2497 15.2259 17.3607 16.2071 15.4694 16.2071Z"
        fill="#73C7B7"
      />
      <path
        d="M10.0285 27.8591C10.0285 27.8591 10.2818 28.1546 10.5471 27.8893C10.9117 27.5241 14.2827 24.0425 14.2827 24.0425C14.2827 24.0425 14.7495 23.5786 14.1309 23.5786C13.5113 23.5786 12.527 23.5786 12.527 23.5786C12.527 23.5786 12.527 23.3098 12.527 22.8996C12.527 21.6323 12.527 19.1663 12.527 18.2214C12.527 18.2214 12.5339 18 12.2486 18C11.9622 18 8.70643 18 8.30531 18C7.90476 18 7.97437 18.2647 7.97437 18.2647C7.97437 19.2347 7.97437 21.6198 7.97437 22.9327C7.97437 23.3908 7.97437 23.6893 7.97437 23.6893C7.97437 23.6893 6.74477 23.6893 6.23695 23.6893C5.72857 23.6893 6.19644 24.132 6.19644 24.132L10.0285 27.8591Z"
        fill="#73C7B7"
      />
    </svg>
  );
}

export function SvgFunnelIcon() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5469 19.7899C11.9214 19.6047 12.1579 19.2261 12.1579 18.812V12.9315C12.1579 12.6415 12.2743 12.3634 12.4816 12.1584L19.2471 5.46636C19.6615 5.05639 19.8947 4.49991 19.8947 3.91938V1.09327C19.8947 0.488693 19.4007 0 18.7895 0H1.10526C0.494053 0 0 0.488693 0 1.09327V3.91938C0 4.49991 0.233211 5.05639 0.647684 5.46636L7.41312 12.1584C7.6204 12.3634 7.73684 12.6415 7.73684 12.9315V19.9053C7.73684 20.718 8.6015 21.2466 9.33639 20.8832L11.5469 19.7899Z"
        fill="#CACACA"
      />
    </svg>
  );
}

export function SvgCheapListIcon() {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4286 14.5714C19.4286 13.8429 18.9429 13.3571 18.2143 13.3571H7.28571C6.55714 13.3571 6.07143 13.8429 6.07143 14.5714C6.07143 15.3 6.55714 15.7857 7.28571 15.7857H18.2143C18.9429 15.7857 19.4286 15.3 19.4286 14.5714ZM19.4286 8.5C19.4286 7.77143 18.9429 7.28571 18.2143 7.28571H7.28571C6.55714 7.28571 6.07143 7.77143 6.07143 8.5C6.07143 9.22857 6.55714 9.71429 7.28571 9.71429H18.2143C18.9429 9.71429 19.4286 9.22857 19.4286 8.5ZM19.4286 2.42857C19.4286 1.7 18.9429 1.21429 18.2143 1.21429H7.28571C6.55714 1.21429 6.07143 1.7 6.07143 2.42857C6.07143 3.15714 6.55714 3.64286 7.28571 3.64286H18.2143C18.9429 3.64286 19.4286 3.15714 19.4286 2.42857ZM2.42857 17C3.76429 17 4.85714 15.9071 4.85714 14.5714C4.85714 13.2357 3.76429 12.1429 2.42857 12.1429C1.09286 12.1429 0 13.2357 0 14.5714C0 15.9071 1.09286 17 2.42857 17ZM2.42857 10.9286C3.76429 10.9286 4.85714 9.83571 4.85714 8.5C4.85714 7.16429 3.76429 6.07143 2.42857 6.07143C1.09286 6.07143 0 7.16429 0 8.5C0 9.83571 1.09286 10.9286 2.42857 10.9286ZM2.42857 4.85714C3.76429 4.85714 4.85714 3.76429 4.85714 2.42857C4.85714 1.09286 3.76429 0 2.42857 0C1.09286 0 0 1.09286 0 2.42857C0 3.76429 1.09286 4.85714 2.42857 4.85714Z"
        fill="#CACACA"
      />
    </svg>
  );
}

export function SvgUpdateAssignationIcon() {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2545 4.56662L11.9299 4.89124L8.35904 1.32039L8.68367 0.995762C9.33291 0.346516 10.2256 0.103049 11.1183 0.346516C12.0111 0.589983 12.6603 1.23923 12.9038 2.13194C13.1472 3.02466 12.9038 3.91737 12.2545 4.56662ZM10.7126 6.10858L8.35904 8.4621L5.19397 11.6272C4.78819 12.033 4.30126 12.2764 3.81432 12.4387L0.730402 13.2503C0.56809 13.3314 0.324623 13.2503 0.243467 13.1691C0 13.0068 0 12.7634 0 12.601L0.811558 9.51712C0.973869 9.03019 1.21734 8.54325 1.62312 8.13747L4.78819 4.9724L7.14171 2.61888L10.7126 6.10858Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgCheckRadio() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="9"
        cy="9"
        r="8.5"
        fill="white"
        stroke="#E7E7E7"
      />
      <circle
        cx="9"
        cy="9"
        r="4.5"
        fill="black"
      />
    </svg>
  );
}

export function SvgAddAssignationIcon() {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 10.2539C2.23858 10.2539 0 8.01533 0 5.25391C0 2.49248 2.23858 0.253906 5 0.253906C7.76142 0.253906 10 2.49248 10 5.25391C10 8.01533 7.76142 10.2539 5 10.2539ZM2 6.25391H4.00001V8.25391H6.00001V6.25391H8V4.25391L6.00001 4.25391V2.25391H4.00001V4.25391L2 4.25391V6.25391Z"
        fill="#292929"
      />
      <path
        d="M18 10.2539H9.89898C10.4849 9.67979 10.9703 9.00351 11.3264 8.25391L18 8.25391C19.1046 8.25391 20 9.14934 20 10.2539V14.2539C20 15.3585 19.1046 16.2539 18 16.2539H2C0.895431 16.2539 0 15.3585 0 14.2539V10.2539C0 10.2209 0.000803171 10.188 0.00238818 10.1553C0.575995 10.7401 1.25143 11.2247 2 11.5803V14.2539L18 14.2539V10.2539Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgUnCheckRadio() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="9"
        cy="9"
        r="8.5"
        fill="white"
        stroke="#E7E7E7"
      />
    </svg>
  );
}

export function SvgCopyPaste() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.74975 12.7498H1.49975C1.1648 12.7614 0.84005 12.6334 0.603059 12.3964C0.366068 12.1595 0.238114 11.8347 0.249754 11.4998V5.24975C0.238114 4.9148 0.366068 4.59005 0.603059 4.35306C0.84005 4.11607 1.1648 3.98811 1.49975 3.99975H3.99975V1.49975C3.98811 1.1648 4.11607 0.84005 4.35306 0.603059C4.59005 0.366068 4.9148 0.238114 5.24975 0.249754H11.4998C11.8347 0.238114 12.1595 0.366068 12.3964 0.603059C12.6334 0.84005 12.7614 1.1648 12.7498 1.49975V7.74975C12.7612 8.08465 12.6332 8.4093 12.3962 8.64624C12.1593 8.88319 11.8347 9.01121 11.4998 8.99975H8.99975V11.4998C9.01121 11.8347 8.88319 12.1593 8.64624 12.3962C8.4093 12.6332 8.08465 12.7612 7.74975 12.7498ZM1.49975 5.24975V11.4998H7.74975V8.99975H5.24975C4.91485 9.01121 4.59021 8.88319 4.35327 8.64624C4.11632 8.4093 3.9883 8.08465 3.99975 7.74975V5.24975H1.49975ZM5.24975 1.49975V7.74975H11.4998V1.49975H5.24975Z"
        fill="#48B19D"
      />
    </svg>
  );
}

export function SvgEmail() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#7f7f7f"
      ></circle>
      <path
        d="M17,22v20h30V22H17z M41.1,25L32,32.1L22.9,25H41.1z M20,39V26.6l12,9.3l12-9.3V39H20z"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgFacebook() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#3b5998"
      ></circle>
      <path
        d="M34.1,47V33.3h4.6l0.7-5.3h-5.3v-3.4c0-1.5,0.4-2.6,2.6-2.6l2.8,0v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2 c-4.1,0-6.9,2.5-6.9,7V28H24v5.3h4.6V47H34.1z"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgMessenger() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#2196F3"
      ></circle>
      <path
        d="M 53.066406 21.871094 C 52.667969 21.339844 51.941406 21.179688 51.359375 21.496094 L 37.492188 29.058594 L 28.867188 21.660156 C 28.339844 21.207031 27.550781 21.238281 27.054688 21.730469 L 11.058594 37.726562 C 10.539062 38.25 10.542969 39.09375 11.0625 39.613281 C 11.480469 40.027344 12.121094 40.121094 12.640625 39.839844 L 26.503906 32.28125 L 35.136719 39.679688 C 35.667969 40.132812 36.457031 40.101562 36.949219 39.609375 L 52.949219 23.613281 C 53.414062 23.140625 53.464844 22.398438 53.066406 21.871094 Z M 53.066406 21.871094"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgTweeter() {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="13.5"
        cy="13.5"
        r="13.5"
        fill="black"
      />
      <path
        d="M4.14783 4.70391L11.4048 14.4072L4.10199 22.2962H5.74578L12.1395 15.3891L17.3051 22.2962H22.8983L15.2327 11.0472L22.0302 4.70391H20.3865L14.4985 11.0649L9.74101 4.70391H4.14783ZM6.56493 5.91481H9.13435L20.4809 21.0856H17.9115L6.56493 5.91481Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgWhatsapp() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#25D366"
      ></circle>
      <path
        d="m42.32286,33.93287c-0.5178,-0.2589 -3.04726,-1.49644 -3.52105,-1.66732c-0.4712,-0.17346 -0.81554,-0.2589 -1.15987,0.2589c-0.34175,0.51004 -1.33075,1.66474 -1.63108,2.00648c-0.30032,0.33658 -0.60064,0.36247 -1.11327,0.12945c-0.5178,-0.2589 -2.17994,-0.80259 -4.14759,-2.56312c-1.53269,-1.37217 -2.56312,-3.05503 -2.86603,-3.57283c-0.30033,-0.5178 -0.03366,-0.80259 0.22524,-1.06149c0.23301,-0.23301 0.5178,-0.59547 0.7767,-0.90616c0.25372,-0.31068 0.33657,-0.5178 0.51262,-0.85437c0.17088,-0.36246 0.08544,-0.64725 -0.04402,-0.90615c-0.12945,-0.2589 -1.15987,-2.79613 -1.58964,-3.80584c-0.41424,-1.00971 -0.84142,-0.88027 -1.15987,-0.88027c-0.29773,-0.02588 -0.64208,-0.02588 -0.98382,-0.02588c-0.34693,0 -0.90616,0.12945 -1.37736,0.62136c-0.4712,0.5178 -1.80194,1.76053 -1.80194,4.27186c0,2.51134 1.84596,4.945 2.10227,5.30747c0.2589,0.33657 3.63497,5.51458 8.80262,7.74113c1.23237,0.5178 2.1903,0.82848 2.94111,1.08738c1.23237,0.38836 2.35599,0.33657 3.24402,0.20712c0.99159,-0.15534 3.04985,-1.24272 3.47963,-2.45956c0.44013,-1.21683 0.44013,-2.22654 0.31068,-2.45955c-0.12945,-0.23301 -0.46601,-0.36247 -0.98382,-0.59548m-9.40068,12.84407l-0.02589,0c-3.05503,0 -6.08417,-0.82849 -8.72495,-2.38189l-0.62136,-0.37023l-6.47252,1.68286l1.73463,-6.29129l-0.41424,-0.64725c-1.70875,-2.71846 -2.6149,-5.85116 -2.6149,-9.07706c0,-9.39809 7.68934,-17.06155 17.15993,-17.06155c4.58253,0 8.88029,1.78642 12.11655,5.02268c3.23625,3.21036 5.02267,7.50812 5.02267,12.06476c-0.0078,9.3981 -7.69712,17.06155 -17.14699,17.06155m14.58906,-31.58846c-3.93529,-3.80584 -9.1133,-5.95471 -14.62789,-5.95471c-11.36055,0 -20.60848,9.2065 -20.61625,20.52564c0,3.61684 0.94757,7.14565 2.75211,10.26282l-2.92557,10.63564l10.93337,-2.85309c3.0136,1.63108 6.4052,2.4958 9.85634,2.49839l0.01037,0c11.36574,0 20.61884,-9.2091 20.62403,-20.53082c0,-5.48093 -2.14111,-10.64081 -6.03239,-14.51915"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgLinkedin() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#007fb1"
      ></circle>
      <path
        d="M20.4,44h5.4V26.6h-5.4V44z M23.1,18c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1 c1.7,0,3.1-1.4,3.1-3.1C26.2,19.4,24.8,18,23.1,18z M39.5,26.2c-2.6,0-4.4,1.4-5.1,2.8h-0.1v-2.4h-5.2V44h5.4v-8.6 c0-2.3,0.4-4.5,3.2-4.5c2.8,0,2.8,2.6,2.8,4.6V44H46v-9.5C46,29.8,45,26.2,39.5,26.2z"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgReddit() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#5f99cf"
      ></circle>
      <path
        d="m 52.8165,31.942362 c 0,-2.4803 -2.0264,-4.4965 -4.5169,-4.4965 -1.2155,0 -2.3171,0.4862 -3.128,1.2682 -3.077,-2.0247 -7.2403,-3.3133 -11.8507,-3.4782 l 2.5211,-7.9373 6.8272,1.5997 -0.0102,0.0986 c 0,2.0281 1.6575,3.6771 3.6958,3.6771 2.0366,0 3.6924,-1.649 3.6924,-3.6771 0,-2.0281 -1.6575,-3.6788 -3.6924,-3.6788 -1.564,0 -2.8968,0.9758 -3.4357,2.3443 l -7.3593,-1.7255 c -0.3213,-0.0782 -0.6477,0.1071 -0.748,0.4233 L 32,25.212062 c -4.8246,0.0578 -9.1953,1.3566 -12.41,3.4425 -0.8058,-0.7446 -1.8751,-1.2104 -3.0583,-1.2104 -2.4905,0 -4.5152,2.0179 -4.5152,4.4982 0,1.649 0.9061,3.0787 2.2389,3.8607 -0.0884,0.4794 -0.1462,0.9639 -0.1462,1.4569 0,6.6487 8.1736,12.0581 18.2223,12.0581 10.0487,0 18.224,-5.4094 18.224,-12.0581 0,-0.4658 -0.0493,-0.9248 -0.1275,-1.377 1.4144,-0.7599 2.3885,-2.2304 2.3885,-3.9406 z m -29.2808,3.0872 c 0,-1.4756 1.207,-2.6775 2.6894,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 -1.4824,0 -2.6894,-1.2002 -2.6894,-2.6758 z m 15.4037,7.9373 c -1.3549,1.3481 -3.4816,2.0043 -6.5008,2.0043 l -0.0221,-0.0051 -0.0221,0.0051 c -3.0209,0 -5.1476,-0.6562 -6.5008,-2.0043 -0.2465,-0.2448 -0.2465,-0.6443 0,-0.8891 0.2465,-0.2465 0.6477,-0.2465 0.8942,0 1.105,1.0999 2.9393,1.6337 5.6066,1.6337 l 0.0221,0.0051 0.0221,-0.0051 c 2.6673,0 4.5016,-0.5355 5.6066,-1.6354 0.2465,-0.2465 0.6477,-0.2448 0.8942,0 0.2465,0.2465 0.2465,0.6443 0,0.8908 z m -0.3213,-5.2615 c -1.4824,0 -2.6877,-1.2002 -2.6877,-2.6758 0,-1.4756 1.2053,-2.6775 2.6877,-2.6775 1.4824,0 2.6877,1.2019 2.6877,2.6775 0,1.4756 -1.2053,2.6758 -2.6877,2.6758 z"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgTelegram() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#37aee2"
      ></circle>
      <path
        d="m45.90873,15.44335c-0.6901,-0.0281 -1.37668,0.14048 -1.96142,0.41265c-0.84989,0.32661 -8.63939,3.33986 -16.5237,6.39174c-3.9685,1.53296 -7.93349,3.06593 -10.98537,4.24067c-3.05012,1.1765 -5.34694,2.05098 -5.4681,2.09312c-0.80775,0.28096 -1.89996,0.63566 -2.82712,1.72788c-0.23354,0.27218 -0.46884,0.62161 -0.58825,1.10275c-0.11941,0.48114 -0.06673,1.09222 0.16682,1.5716c0.46533,0.96052 1.25376,1.35737 2.18443,1.71383c3.09051,0.99037 6.28638,1.93508 8.93263,2.8236c0.97632,3.44171 1.91401,6.89571 2.84116,10.34268c0.30554,0.69185 0.97105,0.94823 1.65764,0.95525l-0.00351,0.03512c0,0 0.53908,0.05268 1.06412,-0.07375c0.52679,-0.12292 1.18879,-0.42846 1.79109,-0.99212c0.662,-0.62161 2.45836,-2.38812 3.47683,-3.38552l7.6736,5.66477l0.06146,0.03512c0,0 0.84989,0.59703 2.09312,0.68132c0.62161,0.04214 1.4399,-0.07726 2.14229,-0.59176c0.70766,-0.51626 1.1765,-1.34683 1.396,-2.29506c0.65673,-2.86224 5.00979,-23.57745 5.75257,-27.00686l-0.02107,0.08077c0.51977,-1.93157 0.32837,-3.70159 -0.87096,-4.74991c-0.60054,-0.52152 -1.2924,-0.7498 -1.98425,-0.77965l0,0.00176zm-0.2072,3.29069c0.04741,0.0439 0.0439,0.0439 0.00351,0.04741c-0.01229,-0.00351 0.14048,0.2072 -0.15804,1.32576l-0.01229,0.04214l-0.00878,0.03863c-0.75858,3.50668 -5.15554,24.40802 -5.74203,26.96472c-0.08077,0.34417 -0.11414,0.31959 -0.09482,0.29852c-0.1756,-0.02634 -0.50045,-0.16506 -0.52679,-0.1756l-13.13468,-9.70175c4.4988,-4.33199 9.09945,-8.25307 13.744,-12.43229c0.8218,-0.41265 0.68483,-1.68573 -0.29852,-1.70681c-1.04305,0.24584 -1.92279,0.99564 -2.8798,1.47502c-5.49971,3.2626 -11.11882,6.13186 -16.55882,9.49279c-2.792,-0.97105 -5.57873,-1.77704 -8.15298,-2.57601c2.2336,-0.89555 4.00889,-1.55579 5.75608,-2.23009c3.05188,-1.1765 7.01687,-2.7042 10.98537,-4.24067c7.94051,-3.06944 15.92667,-6.16346 16.62028,-6.43037l0.05619,-0.02283l0.05268,-0.02283c0.19316,-0.0878 0.30378,-0.09658 0.35471,-0.10009c0,0 -0.01756,-0.05795 -0.00351,-0.04566l-0.00176,0zm-20.91715,22.0638l2.16687,1.60145c-0.93418,0.91311 -1.81743,1.77353 -2.45485,2.38812l0.28798,-3.98957"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgOauth() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#45668e"
      ></circle>
      <path
        d="M44.94,44.84h-0.2c-2.17-.36-3.66-1.92-4.92-3.37C39.1,40.66,38,38.81,36.7,39c-1.85.3-.93,3.52-1.71,4.9-0.62,1.11-3.29.91-5.12,0.71-5.79-.62-8.75-3.77-11.35-7.14A64.13,64.13,0,0,1,11.6,26a10.59,10.59,0,0,1-1.51-4.49C11,20.7,12.56,21,14.11,21c1.31,0,3.36-.29,4.32.2C19,21.46,19.57,23,20,24a37.18,37.18,0,0,0,3.31,5.82c0.56,0.81,1.41,2.35,2.41,2.14s1.06-2.63,1.1-4.18c0-1.77,0-4-.5-4.9S25,22,24.15,21.47c0.73-1.49,2.72-1.63,5.12-1.63,2,0,4.84-.23,5.62,1.12s0.25,3.85.2,5.71c-0.06,2.09-.41,4.25,1,5.21,1.09-.12,1.68-1.2,2.31-2A28,28,0,0,0,41.72,24c0.44-1,.91-2.65,1.71-3,1.21-.47,3.15-0.1,4.92-0.1,1.46,0,4.05-.41,4.52.61,0.39,0.85-.75,3-1.1,3.57a61.88,61.88,0,0,1-4.12,5.61c-0.58.78-1.78,2-1.71,3.27,0.05,0.94,1,1.67,1.71,2.35a33.12,33.12,0,0,1,3.92,4.18c0.47,0.62,1.5,2,1.4,2.76C52.66,45.81,46.88,44.24,44.94,44.84Z"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgApiok() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#f2720c"
      ></circle>
      <path
        d="M39,30c-1,0-3,2-7,2s-6-2-7-2c-1.1,0-2,0.9-2,2c0,1,0.6,1.5,1,1.7c1.2,0.7,5,2.3,5,2.3l-4.3,5.4   c0,0-0.8,0.9-0.8,1.6c0,1.1,0.9,2,2,2c1,0,1.5-0.7,1.5-0.7S32,39,32,39c0,0,4.5,5.3,4.5,5.3S37,45,38,45c1.1,0,2-0.9,2-2   c0-0.6-0.8-1.6-0.8-1.6L35,36c0,0,3.8-1.6,5-2.3c0.4-0.3,1-0.7,1-1.7C41,30.9,40.1,30,39,30z M32,15c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S35.9,15,32,15z M32,25.5   c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5C35.5,23.9,33.9,22.5,35,22.5z "
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgWorkplace() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#3b3d4a"
      ></circle>
      <path
        d="M34.019,10.292c0.21,0.017,0.423,0.034,0.636,0.049 c3.657,0.262,6.976,1.464,9.929,3.635c3.331,2.448,5.635,5.65,6.914,9.584c0.699,2.152,0.983,4.365,0.885,6.623 c-0.136,3.171-1.008,6.13-2.619,8.867c-0.442,0.75-0.908,1.492-1.495,2.141c-0.588,0.651-1.29,1.141-2.146,1.383 c-1.496,0.426-3.247-0.283-3.961-1.642c-0.26-0.494-0.442-1.028-0.654-1.548c-1.156-2.838-2.311-5.679-3.465-8.519 c-0.017-0.042-0.037-0.082-0.065-0.145c-0.101,0.245-0.192,0.472-0.284,0.698c-1.237,3.051-2.475,6.103-3.711,9.155 c-0.466,1.153-1.351,1.815-2.538,2.045c-1.391,0.267-2.577-0.154-3.496-1.247c-0.174-0.209-0.31-0.464-0.415-0.717 c-2.128-5.22-4.248-10.442-6.37-15.665c-0.012-0.029-0.021-0.059-0.036-0.104c0.054-0.003,0.103-0.006,0.15-0.006 c1.498-0.001,2.997,0,4.495-0.004c0.12-0.001,0.176,0.03,0.222,0.146c1.557,3.846,3.117,7.691,4.679,11.536 c0.018,0.046,0.039,0.091,0.067,0.159c0.273-0.673,0.536-1.32,0.797-1.968c1.064-2.627,2.137-5.25,3.19-7.883 c0.482-1.208,1.376-1.917,2.621-2.135c1.454-0.255,2.644,0.257,3.522,1.449c0.133,0.18,0.229,0.393,0.313,0.603 c1.425,3.495,2.848,6.991,4.269,10.488c0.02,0.047,0.04,0.093,0.073,0.172c0.196-0.327,0.385-0.625,0.559-0.935 c0.783-1.397,1.323-2.886,1.614-4.461c0.242-1.312,0.304-2.634,0.187-3.962c-0.242-2.721-1.16-5.192-2.792-7.38 c-2.193-2.939-5.086-4.824-8.673-5.625c-1.553-0.346-3.124-0.405-4.705-0.257c-3.162,0.298-6.036,1.366-8.585,3.258 c-3.414,2.534-5.638,5.871-6.623,10.016c-0.417,1.76-0.546,3.547-0.384,5.348c0.417,4.601,2.359,8.444,5.804,11.517 c2.325,2.073,5.037,3.393,8.094,3.989c1.617,0.317,3.247,0.395,4.889,0.242c1-0.094,1.982-0.268,2.952-0.529 c0.04-0.01,0.081-0.018,0.128-0.028c0,1.526,0,3.047,0,4.586c-0.402,0.074-0.805,0.154-1.21,0.221 c-0.861,0.14-1.728,0.231-2.601,0.258c-0.035,0.002-0.071,0.013-0.108,0.021c-0.493,0-0.983,0-1.476,0 c-0.049-0.007-0.1-0.018-0.149-0.022c-0.315-0.019-0.629-0.033-0.945-0.058c-1.362-0.105-2.702-0.346-4.017-0.716 c-3.254-0.914-6.145-2.495-8.66-4.752c-2.195-1.971-3.926-4.29-5.176-6.963c-1.152-2.466-1.822-5.057-1.993-7.774 c-0.014-0.226-0.033-0.451-0.05-0.676c0-0.502,0-1.003,0-1.504c0.008-0.049,0.02-0.099,0.022-0.148 c0.036-1.025,0.152-2.043,0.338-3.052c0.481-2.616,1.409-5.066,2.8-7.331c2.226-3.625,5.25-6.386,9.074-8.254 c2.536-1.24,5.217-1.947,8.037-2.126c0.23-0.015,0.461-0.034,0.691-0.051C33.052,10.292,33.535,10.292,34.019,10.292z"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgTumblr() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#2c4762"
      ></circle>
      <path
        d="M39.2,41c-0.6,0.3-1.6,0.5-2.4,0.5c-2.4,0.1-2.9-1.7-2.9-3v-9.3h6v-4.5h-6V17c0,0-4.3,0-4.4,0 c-0.1,0-0.2,0.1-0.2,0.2c-0.3,2.3-1.4,6.4-5.9,8.1v3.9h3V39c0,3.4,2.5,8.1,9,8c2.2,0,4.7-1,5.2-1.8L39.2,41z"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgLivejournal() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#21A5D8"
      ></circle>
      <path
        d="M18.3407821,28.1764706 L21.9441341,31.789916 L33.0055865,42.882353 C33.0055865,42.882353 33.0893855,42.9663866 33.0893855,42.9663866 L46.6648046,47 C46.6648046,47 46.6648046,47 46.7486034,47 C46.8324022,47 46.8324022,47 46.9162012,46.9159664 C47,46.8319327 47,46.8319327 47,46.7478991 L42.9776536,33.1344537 C42.9776536,33.1344537 42.9776536,33.1344537 42.8938548,33.0504202 L31.1620111,21.3697479 L31.1620111,21.3697479 L28.1452514,18.2605042 C27.3072626,17.4201681 26.5530726,17 25.7150838,17 C24.2905028,17 23.0335195,18.3445378 21.5251397,19.8571429 C21.273743,20.1092437 20.9385475,20.4453781 20.6871508,20.697479 C20.3519553,21.0336134 20.1005586,21.2857143 19.849162,21.5378151 C18.3407821,22.9663866 17.0837989,24.2268908 17,25.7394958 C17.0837989,26.4957983 17.5027933,27.3361345 18.3407821,28.1764706 Z M39.9012319,39.6134454 C39.7336341,39.4453781 39.4822374,37.6806724 40.2364275,36.8403362 C40.9906174,36.0840337 41.6610084,36 42.1638017,36 C42.3313995,36 42.4989973,36 42.5827961,36 L44.8453659,43.5630253 L43.5883828,44.8235295 L36.0464833,42.5546218 C35.9626843,42.2184874 35.8788855,41.2100841 36.8844722,40.2016807 C37.2196676,39.8655463 37.8900587,39.6134454 38.5604498,39.6134454 C39.147042,39.6134454 39.5660364,39.7815126 39.5660364,39.7815126 C39.6498353,39.8655463 39.8174331,39.8655463 39.8174331,39.7815126 C39.9850307,39.7815126 39.9850307,39.697479 39.9012319,39.6134454 Z"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgMailRu() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#168DE2"
      ></circle>
      <path
        d="M39.7107745,17 C41.6619755,17 43.3204965,18.732852 43.3204965,21.0072202 C43.3204965,23.2815885 41.7595357,25.0144404 39.7107745,25.0144404 C37.7595732,25.0144404 36.1010522,23.2815885 36.1010522,21.0072202 C36.1010522,18.732852 37.7595732,17 39.7107745,17 Z M24.3938451,17 C26.3450463,17 28.0035672,18.732852 28.0035672,21.0072202 C28.0035672,23.2815885 26.4426063,25.0144404 24.3938451,25.0144404 C22.4426439,25.0144404 20.7841229,23.2815885 20.7841229,21.0072202 C20.7841229,18.732852 22.4426439,17 24.3938451,17 Z M51.9057817,43.4259928 C51.7106617,44.0758123 51.4179815,44.6173285 50.9301812,44.9422383 C50.637501,45.1588448 50.2472607,45.267148 49.8570205,45.267148 C49.07654,45.267148 48.3936197,44.833935 48.0033795,44.0758123 L46.2472985,40.7184115 L45.759498,41.2599278 C42.5400162,44.9422383 37.466893,47 32.0035297,47 C26.5401664,47 21.5646034,44.9422383 18.2475614,41.2599278 L17.7597611,40.7184115 L16.00368,44.0758123 C15.6134398,44.833935 14.9305194,45.267148 14.1500389,45.267148 C13.7597986,45.267148 13.3695584,45.1588448 13.0768782,44.9422383 C12.0037176,44.2924187 11.7110374,42.7761733 12.2963978,41.5848375 L16.7841605,33.0288807 C17.1744007,32.270758 17.8573211,31.8375453 18.6378016,31.8375453 C19.0280418,31.8375453 19.4182821,31.9458485 19.7109623,32.1624548 C20.7841229,32.8122743 21.0768031,34.3285197 20.4914427,35.5198555 L20.1012025,36.2779783 L20.2963226,36.602888 C22.4426439,39.9602888 27.0279667,42.234657 31.9059697,42.234657 C36.7839727,42.234657 41.3692955,40.068592 43.5156167,36.602888 L43.7107367,36.2779783 L43.3204965,35.6281587 C43.0278165,35.0866425 42.9302562,34.436823 43.1253765,33.7870035 C43.3204965,33.137184 43.6131767,32.5956678 44.100977,32.270758 C44.3936572,32.0541515 44.7838975,31.9458485 45.1741377,31.9458485 C45.9546182,31.9458485 46.6375385,32.3790613 47.0277787,33.137184 L51.5155415,41.6931408 C52.003342,42.234657 52.100902,42.8844765 51.9057817,43.4259928 Z"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgViber() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#7C529E"
      ></circle>
      <path
        d="m31.0,12.3c9.0,0.2 16.4,6.2 18.0,15.2c0.2,1.5 0.3,3.0 0.4,4.6a1.0,1.0 0 0 1 -0.8,1.2l-0.1,0a1.1,1.1 0 0 1 -1.0,-1.2l0,0c-0.0,-1.2 -0.1,-2.5 -0.3,-3.8a16.1,16.1 0 0 0 -13.0,-13.5c-1.0,-0.1 -2.0,-0.2 -3.0,-0.3c-0.6,-0.0 -1.4,-0.1 -1.6,-0.8a1.1,1.1 0 0 1 0.9,-1.2l0.6,0l0.0,-0.0zm10.6,39.2a19.9,19.9 0 0 1 -2.1,-0.6c-6.9,-2.9 -13.2,-6.6 -18.3,-12.2a47.5,47.5 0 0 1 -7.0,-10.7c-0.8,-1.8 -1.6,-3.7 -2.4,-5.6c-0.6,-1.7 0.3,-3.4 1.4,-4.7a11.3,11.3 0 0 1 3.7,-2.8a2.4,2.4 0 0 1 3.0,0.7a39.0,39.0 0 0 1 4.7,6.5a3.1,3.1 0 0 1 -0.8,4.2c-0.3,0.2 -0.6,0.5 -1.0,0.8a3.3,3.3 0 0 0 -0.7,0.7a2.1,2.1 0 0 0 -0.1,1.9c1.7,4.9 4.7,8.7 9.7,10.8a5.0,5.0 0 0 0 2.5,0.6c1.5,-0.1 2.0,-1.8 3.1,-2.7a2.9,2.9 0 0 1 3.5,-0.1c1.1,0.7 2.2,1.4 3.3,2.2a37.8,37.8 0 0 1 3.1,2.4a2.4,2.4 0 0 1 0.7,3.0a10.4,10.4 0 0 1 -4.4,4.8a10.8,10.8 0 0 1 -1.9,0.6c-0.7,-0.2 0.6,-0.2 0,0l0.0,0l0,-0.0zm3.1,-21.4a4.2,4.2 0 0 1 -0.0,0.6a1.0,1.0 0 0 1 -1.9,0.1a2.7,2.7 0 0 1 -0.1,-0.8a10.9,10.9 0 0 0 -1.4,-5.5a10.2,10.2 0 0 0 -4.2,-4.0a12.3,12.3 0 0 0 -3.4,-1.0c-0.5,-0.0 -1.0,-0.1 -1.5,-0.2a0.9,0.9 0 0 1 -0.9,-1.0l0,-0.1a0.9,0.9 0 0 1 0.9,-0.9l0.1,0a14.1,14.1 0 0 1 5.9,1.5a11.9,11.9 0 0 1 6.5,9.3c0,0.1 0.0,0.3 0.0,0.5c0,0.4 0.0,0.9 0.0,1.5l0,0l0.0,0.0zm-5.6,-0.2a1.1,1.1 0 0 1 -1.2,-0.9l0,-0.1a11.3,11.3 0 0 0 -0.2,-1.4a4.0,4.0 0 0 0 -1.5,-2.3a3.9,3.9 0 0 0 -1.2,-0.5c-0.5,-0.1 -1.1,-0.1 -1.6,-0.2a1.0,1.0 0 0 1 -0.8,-1.1l0,0l0,0a1.0,1.0 0 0 1 1.1,-0.8c3.4,0.2 6.0,2.0 6.3,6.2a2.8,2.8 0 0 1 0,0.8a0.8,0.8 0 0 1 -0.8,0.7l0,0l0.0,-0.0z"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgHatena() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#009ad9"
      ></circle>
      <path
        d="M 36.164062 33.554688 C 34.988281 32.234375 33.347656 31.5 31.253906 31.34375 C 33.125 30.835938 34.476562 30.09375 35.335938 29.09375 C 36.191406 28.09375 36.609375 26.78125 36.609375 25.101562 C 36.628906 23.875 36.332031 22.660156 35.75 21.578125 C 35.160156 20.558594 34.292969 19.71875 33.253906 19.160156 C 32.304688 18.640625 31.175781 18.265625 29.847656 18.042969 C 28.523438 17.824219 26.195312 17.730469 22.867188 17.730469 L 14.769531 17.730469 L 14.769531 47.269531 L 23.113281 47.269531 C 26.46875 47.269531 28.886719 47.15625 30.367188 46.929688 C 31.851562 46.695312 33.085938 46.304688 34.085938 45.773438 C 35.289062 45.148438 36.28125 44.179688 36.933594 42.992188 C 37.597656 41.796875 37.933594 40.402344 37.933594 38.816406 C 37.933594 36.621094 37.347656 34.867188 36.164062 33.554688 Z M 22.257812 24.269531 L 23.984375 24.269531 C 25.988281 24.269531 27.332031 24.496094 28.015625 24.945312 C 28.703125 25.402344 29.042969 26.183594 29.042969 27.285156 C 29.042969 28.390625 28.664062 29.105469 27.9375 29.550781 C 27.210938 29.992188 25.84375 30.199219 23.855469 30.199219 L 22.257812 30.199219 Z M 29.121094 41.210938 C 28.328125 41.691406 26.976562 41.925781 25.078125 41.925781 L 22.257812 41.925781 L 22.257812 35.488281 L 25.195312 35.488281 C 27.144531 35.488281 28.496094 35.738281 29.210938 36.230469 C 29.925781 36.726562 30.304688 37.582031 30.304688 38.832031 C 30.304688 40.078125 29.914062 40.742188 29.105469 41.222656 Z M 29.121094 41.210938 M 46.488281 39.792969 C 44.421875 39.792969 42.742188 41.46875 42.742188 43.535156 C 42.742188 45.605469 44.421875 47.28125 46.488281 47.28125 C 48.554688 47.28125 50.230469 45.605469 50.230469 43.535156 C 50.230469 41.46875 48.554688 39.792969 46.488281 39.792969 Z M 46.488281 39.792969 M 43.238281 17.730469 L 49.738281 17.730469 L 49.738281 37.429688 L 43.238281 37.429688 Z M 43.238281 17.730469 "
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgLine() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#00b800"
      ></circle>
      <path
        d="M52.62 30.138c0 3.693-1.432 7.019-4.42 10.296h.001c-4.326 4.979-14 11.044-16.201 11.972-2.2.927-1.876-.591-1.786-1.112l.294-1.765c.069-.527.142-1.343-.066-1.865-.232-.574-1.146-.872-1.817-1.016-9.909-1.31-17.245-8.238-17.245-16.51 0-9.226 9.251-16.733 20.62-16.733 11.37 0 20.62 7.507 20.62 16.733zM27.81 25.68h-1.446a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-8.985a.402.402 0 0 0-.402-.401zm9.956 0H36.32a.402.402 0 0 0-.402.401v5.338L31.8 25.858a.39.39 0 0 0-.031-.04l-.002-.003-.024-.025-.008-.007a.313.313 0 0 0-.032-.026.255.255 0 0 1-.021-.014l-.012-.007-.021-.012-.013-.006-.023-.01-.013-.005-.024-.008-.014-.003-.023-.005-.017-.002-.021-.003-.021-.002h-1.46a.402.402 0 0 0-.402.401v8.985c0 .221.18.4.402.4h1.446a.401.401 0 0 0 .402-.4v-5.337l4.123 5.568c.028.04.063.072.101.099l.004.003a.236.236 0 0 0 .025.015l.012.006.019.01a.154.154 0 0 1 .019.008l.012.004.028.01.005.001a.442.442 0 0 0 .104.013h1.446a.4.4 0 0 0 .401-.4v-8.985a.402.402 0 0 0-.401-.401zm-13.442 7.537h-3.93v-7.136a.401.401 0 0 0-.401-.401h-1.447a.4.4 0 0 0-.401.401v8.984a.392.392 0 0 0 .123.29c.072.068.17.111.278.111h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401zm21.429-5.287c.222 0 .401-.18.401-.402v-1.446a.401.401 0 0 0-.401-.402h-5.778a.398.398 0 0 0-.279.113l-.005.004-.006.008a.397.397 0 0 0-.111.276v8.984c0 .108.043.206.112.278l.005.006a.401.401 0 0 0 .284.117h5.778a.4.4 0 0 0 .401-.401v-1.447a.401.401 0 0 0-.401-.401h-3.93v-1.519h3.93c.222 0 .401-.18.401-.402V29.85a.401.401 0 0 0-.401-.402h-3.93V27.93h3.93z"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgWeibo() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#CD201F"
      ></circle>
      <path
        d="M40.9756152,15.0217119 C40.5000732,15.0546301 39.9999314,15.1204666 39.5325878,15.2192213 C38.6634928,15.4085016 38.0977589,16.2643757 38.2863368,17.1284787 C38.4667163,18.0008129 39.3194143,18.5686519 40.1885094,18.3793715 C42.8613908,17.8115326 45.7720411,18.6427174 47.7316073,20.8153207 C49.6911735,22.996153 50.2077122,25.975254 49.3714112,28.5840234 C49.1008441,29.4316684 49.5763861,30.3533789 50.4208857,30.6249537 C51.2653852,30.8965286 52.1754769,30.4192153 52.4542425,29.5715703 C53.6349013,25.9011885 52.9133876,21.7699494 50.1585171,18.7085538 C48.0923641,16.4042776 45.2063093,15.1533848 42.3530505,15.0217119 C41.8775084,14.9970227 41.4511594,14.9887937 40.9756152,15.0217119 Z M27.9227762,19.8277737 C24.9957268,20.140498 20.863421,22.4365431 17.2312548,26.0822378 C13.2711279,30.0571148 11,34.2871065 11,37.9328012 C11,44.9032373 19.8713401,49.125 28.5786978,49.125 C39.9917329,49.125 47.600423,42.4261409 47.600423,37.1427636 C47.600423,33.9496952 44.9603397,32.1638816 42.549827,31.4149913 C41.9594976,31.2339421 41.5167516,31.1434164 41.8283133,30.3616079 C42.5006339,28.66632 42.6236176,27.1932286 41.8939054,26.1480742 C40.5328692,24.1894405 36.7203236,24.2881952 32.448635,26.0822378 C32.448635,26.0822378 31.1203949,26.6912261 31.4647526,25.6213825 C32.1206742,23.4981576 32.0304845,21.712342 31.0056075,20.6836478 C30.2840938,19.9512176 29.2510184,19.6878718 27.9227762,19.8277737 Z M42.0906819,20.6836478 C41.6233383,20.6589586 41.1723917,20.716566 40.7132466,20.8153207 C39.9671353,20.9716828 39.4997917,21.7781784 39.6637721,22.5270687 C39.8277525,23.275959 40.5574647,23.7450433 41.303576,23.5804521 C42.1972686,23.3911718 43.2057485,23.6380596 43.8616701,24.3704897 C44.5175916,25.1029198 44.6733735,26.0657797 44.3864073,26.9381118 C44.1486363,27.6705419 44.5093932,28.4770397 45.2391054,28.7156963 C45.9688176,28.9461239 46.780521,28.5922524 47.0100936,27.8598223 C47.584026,26.0740087 47.2396661,24.0248493 45.8950269,22.5270687 C44.886547,21.4078489 43.4845162,20.7494842 42.0906819,20.6836478 Z M29.496988,29.9665891 C35.3100922,30.1723275 39.9917329,33.0691319 40.3852858,37.0769272 C40.8362324,41.6607904 35.5970585,45.9319315 28.6442899,46.6232144 C21.6915214,47.3144973 15.6488446,44.154347 15.197898,39.5787128 C14.7469514,34.9948495 20.059916,30.7237084 27.004486,30.0324256 C27.8735831,29.950131 28.6688875,29.9336709 29.496988,29.9665891 Z M25.5614586,34.3776322 C23.183744,34.5916017 20.9372116,35.9577073 19.9205332,37.9328012 C18.5348994,40.6238672 19.9041362,43.6029661 23.0689567,44.582284 C26.340366,45.5945202 30.1857056,44.0638213 31.5303448,41.1587879 C32.8503864,38.3195909 31.1613894,35.3734082 27.9227762,34.5751416 C27.1438688,34.3776322 26.356763,34.3035667 25.5614586,34.3776322 Z M24.052839,38.7228388 C24.3316067,38.7310678 24.5857748,38.8215935 24.8399449,38.9203482 C25.8648218,39.3400561 26.1845841,40.4428158 25.5614586,41.4221338 C24.9219361,42.3932227 23.5690963,42.8623069 22.5442194,42.4096807 C21.5357395,41.9652856 21.2487754,40.8542948 21.8882979,39.9078951 C22.3638421,39.2001542 23.2247386,38.7146097 24.052839,38.7228388 Z"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgGetpocket() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#EF3F56"
      ></circle>
      <path
        d="M41.084 29.065l-7.528 7.882a2.104 2.104 0 0 1-1.521.666 2.106 2.106 0 0 1-1.522-.666l-7.528-7.882c-.876-.914-.902-2.43-.065-3.384.84-.955 2.228-.987 3.1-.072l6.015 6.286 6.022-6.286c.88-.918 2.263-.883 3.102.071.841.938.82 2.465-.06 3.383l-.015.002zm6.777-10.976C47.463 16.84 46.361 16 45.14 16H18.905c-1.2 0-2.289.82-2.716 2.044-.125.363-.189.743-.189 1.125v10.539l.112 2.096c.464 4.766 2.73 8.933 6.243 11.838.06.053.125.102.19.153l.04.033c1.882 1.499 3.986 2.514 6.259 3.014a14.662 14.662 0 0 0 6.13.052c.118-.042.235-.065.353-.087.03 0 .065-.022.098-.042a15.395 15.395 0 0 0 6.011-2.945l.039-.045.18-.153c3.502-2.902 5.765-7.072 6.248-11.852L48 29.674v-10.52c0-.366-.041-.728-.161-1.08l.022.015z"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgInstapaper() {
  return (
    <svg
      viewBox="0 0 64 64"
      width="32"
      height="32"
    >
      <circle
        cx="32"
        cy="32"
        r="31"
        fill="#1F1F1F"
      ></circle>
      <path
        d="M35.688 43.012c0 2.425.361 2.785 3.912 3.056V48H24.401v-1.932c3.555-.27 3.912-.63 3.912-3.056V20.944c0-2.379-.36-2.785-3.912-3.056V16H39.6v1.888c-3.55.27-3.912.675-3.912 3.056v22.068h.001z"
        fill="white"
      ></path>
    </svg>
  );
}

export function SvgCandidatGroup(color) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8347 8.00781H11.6746C11.7929 8.33154 11.8575 8.68091 11.8575 9.04504V13.4293C11.8575 13.5811 11.831 13.7269 11.783 13.8624H13.7008C14.4172 13.8624 15 13.2796 15 12.5632V10.1731C15 8.97918 14.0286 8.00781 12.8347 8.00781Z"
        fill={color}
      />
      <path
        d="M3.14253 9.04504C3.14253 8.68088 3.20713 8.33154 3.32538 8.00781H2.16534C0.971369 8.00781 0 8.97918 0 10.1731V12.5632C0 13.2796 0.582804 13.8624 1.2992 13.8624H3.21704C3.16896 13.7268 3.14253 13.5811 3.14253 13.4293V9.04504Z"
        fill={color}
      />
      <path
        d="M8.82603 6.87988H6.17401C4.98005 6.87988 4.00868 7.85125 4.00868 9.04522V13.4295C4.00868 13.6687 4.20257 13.8626 4.44175 13.8626H10.5583C10.7975 13.8626 10.9914 13.6687 10.9914 13.4295V9.04522C10.9914 7.85125 10.02 6.87988 8.82603 6.87988Z"
        fill={color}
      />
      <path
        d="M7.5 1.1377C6.0641 1.1377 4.89592 2.30588 4.89592 3.74181C4.89592 4.71579 5.43349 5.56642 6.22738 6.01303C6.60393 6.22484 7.03805 6.3459 7.5 6.3459C7.96196 6.3459 8.39608 6.22484 8.77263 6.01303C9.56655 5.56642 10.1041 4.71576 10.1041 3.74181C10.1041 2.30591 8.9359 1.1377 7.5 1.1377Z"
        fill={color}
      />
      <path
        d="M2.9273 3.56543C1.85342 3.56543 0.979782 4.43906 0.979782 5.51294C0.979782 6.58682 1.85342 7.46046 2.9273 7.46046C3.1997 7.46046 3.45909 7.40403 3.69473 7.3026C4.10213 7.1272 4.43805 6.81671 4.64591 6.4278C4.79181 6.15484 4.87481 5.84344 4.87481 5.51294C4.87481 4.43909 4.00117 3.56543 2.9273 3.56543Z"
        fill={color}
      />
      <path
        d="M12.0728 3.56543C10.9989 3.56543 10.1253 4.43906 10.1253 5.51294C10.1253 5.84347 10.2083 6.15487 10.3542 6.4278C10.562 6.81674 10.8979 7.12723 11.3053 7.3026C11.541 7.40403 11.8004 7.46046 12.0728 7.46046C13.1467 7.46046 14.0203 6.58682 14.0203 5.51294C14.0203 4.43906 13.1467 3.56543 12.0728 3.56543Z"
        fill={color}
      />
    </svg>
  );
}

export function SvgGroupIcon() {
  return (
    // <svg width="30" height="29" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    //   <path d="M29 14.5C29 7.04416 22.9558 1 15.5 1C8.04416 1 2 7.04416 2 14.5C2 21.9558 8.04416 28 15.5 28C22.9558 28 29 21.9558 29 14.5Z" fill="#1A4E63" stroke="white" strokeWidth="2" />
    //   <path d="M11.508 13.9274C12.9382 13.9274 14.0967 12.7689 14.0967 11.3387C14.0967 9.9085 12.9382 8.75 11.508 8.75C10.0778 8.75 8.91927 9.9085 8.91927 11.3387C8.91927 12.7689 10.0778 13.9274 11.508 13.9274Z" fill="white" stroke="#1A4E63" strokeWidth="0.5" />
    //   <path d="M7.75 18.3571V18.6071H8H15.0161H15.2661V18.3571V16.1353C15.2661 14.594 14.1018 13.4297 12.5605 13.4297H10.4556C9.03907 13.4297 7.75 14.5864 7.75 16.1353V18.3571Z" fill="white" stroke="#1A4E63" strokeWidth="0.5" />
    //   <path d="M18.9919 13.9274C20.4221 13.9274 21.5806 12.7689 21.5806 11.3387C21.5806 9.9085 20.4221 8.75 18.9919 8.75C17.5617 8.75 16.4032 9.9085 16.4032 11.3387C16.4032 12.7689 17.5617 13.9274 18.9919 13.9274Z" fill="white" stroke="#1A4E63" strokeWidth="0.5" />
    //   <path d="M15.2339 18.3571V18.6071H15.4839H22.5H22.75V18.3571V16.1353C22.75 14.594 21.5857 13.4297 20.0444 13.4297H17.9395C16.523 13.4297 15.2339 14.5864 15.2339 16.1353V18.3571Z" fill="white" stroke="#1A4E63" strokeWidth="0.5" />
    //   <path d="M17.5886 13.2098C17.5886 14.5019 16.5421 15.5485 15.2499 15.5485C13.9578 15.5485 12.9112 14.5019 12.9112 13.2098C12.9112 11.9177 13.9578 10.8711 15.2499 10.8711C16.5421 10.8711 17.5886 11.9177 17.5886 13.2098Z" fill="white" stroke="#1A4E63" strokeWidth="0.5" />
    //   <path d="M16.3024 15.5508H14.1976C12.9113 15.5508 11.742 16.6032 11.742 18.0064V20.2282H18.7581V18.0064C18.7581 16.6032 17.7057 15.5508 16.3024 15.5508Z" fill="white" stroke="#1A4E63" strokeWidth="0.5" />
    //   <path d="M14 21.5C14 17.9101 11.0899 15 7.5 15C3.91015 15 1 17.9101 1 21.5C1 25.0899 3.91015 28 7.5 28C11.0899 28 14 25.0899 14 21.5Z" fill="#1A4E63" stroke="white" />
    //   <path d="M7.2643 23.6314V21.7504H5.38332C5.32096 21.7504 5.26115 21.7256 5.21706 21.6815C5.17297 21.6375 5.14819 21.5777 5.14819 21.5153C5.14819 21.4529 5.17297 21.3931 5.21706 21.349C5.26115 21.3049 5.32096 21.2802 5.38332 21.2802H7.2643V19.3992C7.2643 19.3368 7.28907 19.277 7.33317 19.2329C7.37726 19.1888 7.43706 19.1641 7.49942 19.1641C7.56178 19.1641 7.62159 19.1888 7.66568 19.2329C7.70977 19.277 7.73455 19.3368 7.73455 19.3992V21.2802H9.61553C9.67789 21.2802 9.73769 21.3049 9.78179 21.349C9.82588 21.3931 9.85065 21.4529 9.85065 21.5153C9.85065 21.5777 9.82588 21.6375 9.78179 21.6815C9.73769 21.7256 9.67789 21.7504 9.61553 21.7504H7.73455V23.6314C7.73455 23.6938 7.70977 23.7536 7.66568 23.7977C7.62159 23.8417 7.56178 23.8665 7.49942 23.8665C7.43706 23.8665 7.37726 23.8417 7.33317 23.7977C7.28907 23.7536 7.2643 23.6938 7.2643 23.6314Z" fill="white" stroke="white" />
    // </svg>
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12.5"
        cy="12.5"
        r="12.5"
        fill="#F5F6F8"
      />
      <path
        d="M17.8465 10.3388C17.8465 11.6309 16.7999 12.6775 15.5077 12.6775C14.2155 12.6775 13.1689 11.6309 13.1689 10.3388C13.1689 9.0466 14.2155 8 15.5077 8C16.7999 8 17.8465 9.0466 17.8465 10.3388Z"
        fill="#808D93"
        stroke="#F5F6F8"
        strokeWidth="0.5"
      />
      <path
        d="M16.5606 12.6797H14.4557C13.1694 12.6797 12 13.7321 12 15.1354V17.3572H19.0163V15.1354C19.0163 13.7321 17.9639 12.6797 16.5606 12.6797Z"
        fill="#808D93"
        stroke="#F5F6F8"
        strokeWidth="0.5"
      />
      <path
        d="M8 14V17H7V14H4V13H7V10H8V13H11V14H8Z"
        fill="#808D93"
        stroke="#808D93"
        strokeWidth="0.3"
      />
    </svg>
  );
}

export function SvgAddAssignation() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.165 11.625C21.165 6.10215 16.6879 1.625 11.165 1.625C5.64219 1.625 1.16504 6.10215 1.16504 11.625C1.16504 17.1478 5.64219 21.625 11.165 21.625C16.6879 21.625 21.165 17.1478 21.165 11.625Z"
        fill="#FCB698"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M10.8045 14.8845V11.9907H7.91067C7.81474 11.9907 7.72273 11.9526 7.6549 11.8848C7.58706 11.8169 7.54895 11.7249 7.54895 11.629C7.54895 11.5331 7.58706 11.441 7.6549 11.3732C7.72273 11.3054 7.81474 11.2673 7.91067 11.2673H10.8045V8.37345C10.8045 8.27751 10.8426 8.1855 10.9104 8.11767C10.9782 8.04983 11.0703 8.01172 11.1662 8.01172C11.2621 8.01172 11.3541 8.04983 11.422 8.11767C11.4898 8.1855 11.5279 8.27751 11.5279 8.37345V11.2673H14.4217C14.5176 11.2673 14.6096 11.3054 14.6775 11.3732C14.7453 11.441 14.7834 11.5331 14.7834 11.629C14.7834 11.7249 14.7453 11.8169 14.6775 11.8848C14.6096 11.9526 14.5176 11.9907 14.4217 11.9907H11.5279V14.8845C11.5279 14.9805 11.4898 15.0725 11.422 15.1403C11.3541 15.2082 11.2621 15.2463 11.1662 15.2463C11.0703 15.2463 10.9782 15.2082 10.9104 15.1403C10.8426 15.0725 10.8045 14.9805 10.8045 14.8845Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function SvgCommentIcon() {
  return (
    <svg
      width="28"
      height="25"
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.04031 24.4328H2.07407L3.46441 23.0425C4.21406 22.2928 4.68219 21.3178 4.80805 20.26C1.59774 18.1533 0 15.1013 0 11.9016C0 5.99874 5.42533 0 13.922 0C22.9233 0 27.75 5.51996 27.75 11.3845C27.75 17.2877 22.8723 22.8039 13.922 22.8039C12.3541 22.8039 10.7181 22.5946 9.25737 22.2106C7.87463 23.6288 6.00113 24.4328 4.04031 24.4328Z"
        fill="#FCB698"
      />
      <path
        d="M13.56 13.12C14.4216 13.12 15.12 12.4216 15.12 11.56C15.12 10.6984 14.4216 10 13.56 10C12.6984 10 12 10.6984 12 11.56C12 12.4216 12.6984 13.12 13.56 13.12Z"
        fill="white"
      />
      <path
        d="M19.56 13.12C20.4216 13.12 21.12 12.4216 21.12 11.56C21.12 10.6984 20.4216 10 19.56 10C18.6984 10 18 10.6984 18 11.56C18 12.4216 18.6984 13.12 19.56 13.12Z"
        fill="white"
      />
      <path
        d="M7.56 13.12C8.42156 13.12 9.12 12.4216 9.12 11.56C9.12 10.6984 8.42156 10 7.56 10C6.69844 10 6 10.6984 6 11.56C6 12.4216 6.69844 13.12 7.56 13.12Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgCommentIconVacance() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5162 14.8285L6.1697 15.1778C7.18245 15.7193 8.31344 16.0017 9.46184 16L9.46485 16C13.331 16 16.4648 12.8661 16.4648 9C16.4648 5.13387 13.331 2 9.46485 2C5.59872 2 2.46485 5.13387 2.46485 9V9.00301C2.46312 10.1514 2.74557 11.2824 3.28701 12.2951L3.63639 12.9486L3.09918 15.3657L5.5162 14.8285ZM0.464854 18L1.52325 13.2381C0.826232 11.9343 0.462628 10.4784 0.464854 9C0.464854 4.0293 4.49415 0 9.46485 0C14.4355 0 18.4648 4.0293 18.4648 9C18.4648 13.9707 14.4355 18 9.46485 18C7.98647 18.0022 6.53051 17.6386 5.22675 16.9416L0.464854 18Z"
        fill="#3F3F51"
      />
    </svg>
  );
}

export function SvgRightArrow(color) {
  return (
    <svg
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.88005 6.33025L11.0021 6.33025L7.56776 9.58349C7.22433 9.90881 7.22433 10.4307 7.56776 10.756C7.73948 10.9187 7.96128 11 8.19024 11C8.41919 11 8.64099 10.9187 8.81271 10.756L13.7424 6.08626C14.0859 5.76094 14.0859 5.23906 13.7424 4.91374L8.81271 0.243993C8.46928 -0.0813309 7.91835 -0.0813309 7.57492 0.243993C7.23148 0.569316 7.23148 1.09119 7.57492 1.41651L11.0093 4.66975L0.88005 4.66975C0.393518 4.66975 0 5.04251 0 5.50339C0 5.96426 0.393518 6.33025 0.88005 6.33025Z"
        fill={color}
      />
    </svg>
  );
}

export function SvgResetFilter({ color = "#121313" }) {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.53628 4.00419L7.00219 1.549C7.12041 1.43185 7.12041 1.24218 7.00219 1.12532C6.88427 1.00817 6.69272 1.00817 6.57479 1.12532L4.11098 3.57842L1.62443 1.08877C1.5065 0.970411 1.31495 0.970411 1.19703 1.08877C1.07911 1.20742 1.07911 1.39949 1.19703 1.51784L3.68179 4.00569L1.18805 6.48845C1.07013 6.60561 1.07013 6.79528 1.18805 6.91213C1.30597 7.02929 1.49752 7.02929 1.61545 6.91213L4.10709 4.43147L6.58377 6.91123C6.70169 7.02959 6.89324 7.02959 7.01117 6.91123C7.12909 6.79258 7.12909 6.60051 7.01117 6.48216L4.53628 4.00419Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function SvgHome({ color = "#EF214B" }) {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.28711 12.2738H10.8907"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 10.3558C1 5.89793 1.48608 6.20905 4.10254 3.78259C5.24729 2.86109 7.02854 1.08301 8.56675 1.08301C10.1042 1.08301 11.921 2.85238 13.0761 3.78259C15.6925 6.20905 16.1778 5.89793 16.1778 10.3558C16.1778 16.9163 14.627 16.9163 8.58892 16.9163C2.55088 16.9163 1 16.9163 1 10.3558Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgHomeShiftHour() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6476 5.0026L6.33243 0.159454C6.09914 -0.053159 5.74733 -0.0531358 5.51412 0.159431L0.198939 5.00263C0.0120558 5.17292 -0.0496758 5.4353 0.0416258 5.67105C0.132951 5.9068 0.355304 6.05912 0.608131 6.05912H1.45705V10.9116C1.45705 11.104 1.61305 11.26 1.80544 11.26H4.71881C4.9112 11.26 5.06719 11.104 5.06719 10.9116V7.96532H6.77943V10.9116C6.77943 11.104 6.93543 11.26 7.12782 11.26H10.041C10.2334 11.26 10.3894 11.104 10.3894 10.9116V6.05912H11.2385C11.4913 6.05912 11.7137 5.90678 11.805 5.67105C11.8962 5.43528 11.8345 5.17292 11.6476 5.0026Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgPlace() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <script
        async={false}
        type="text/javascript"
        src="moz-extension://1622aff5-5d07-49cd-8eff-1dd2ebad9d0d/in-page.js"
      /> */}
      <path
        d="M9.40697 5.29399C8.70075 5.82363 7.83864 6.19134 6.90035 6.37276C6.80559 7.04391 6.22771 7.56194 5.5308 7.56194C4.8339 7.56194 4.25602 7.04391 4.16126 6.37276C3.22297 6.19134 2.36085 5.82363 1.65464 5.29399C0.587626 4.49373 0 3.42101 0 2.27344V8.16072C0 9.04078 0.716001 9.75676 1.59605 9.75676H9.46556C10.3456 9.75676 11.0616 9.04078 11.0616 8.16072V2.27344C11.0616 3.42101 10.474 4.49373 9.40697 5.29399Z"
        fill="#DA5014"
      />
      <path
        d="M4.14764 5.71094V5.12228C4.14764 4.94331 4.29274 4.79821 4.47171 4.79821H6.59049C6.76946 4.79821 6.91456 4.94331 6.91456 5.12228V5.71094C8.93518 5.27235 10.4138 3.89885 10.4138 2.27659V1.95252H7.80769V1.30853C7.80769 0.587 7.22067 0 6.49916 0H4.56306C3.84155 0 3.25453 0.587 3.25453 1.30853V1.95252H0.648438V2.27659C0.648438 3.89885 2.12702 5.27235 4.14764 5.71094ZM3.90265 1.30853C3.90265 0.944385 4.19891 0.648141 4.56304 0.648141H6.49914C6.86327 0.648141 7.15953 0.944385 7.15953 1.30853V1.95252H3.90262V1.30853H3.90265Z"
        fill="#DA5014"
      />
      <path
        d="M6.26751 5.44531H4.79688V6.18063C4.79688 6.58608 5.12676 6.91594 5.53219 6.91594C5.93762 6.91594 6.26751 6.58608 6.26751 6.18063V5.44531Z"
        fill="#DA5014"
      />
    </svg>
  );
}

export function SvgPlace2({ color = "#292929" }) {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.69745 12.6649V10.5312"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1089 8.57422L16.0854 8.59127C14.119 9.80262 11.5225 10.5341 8.69388 10.5341C5.86523 10.5341 3.27609 9.80262 1.31049 8.59127L1.28613 8.57422"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.21924 10.0936C1.21924 5.0988 3.08904 3.43359 8.69763 3.43359C14.307 3.43359 16.176 5.0988 16.176 10.0936C16.176 15.0884 14.307 16.7536 8.69763 16.7536C3.08904 16.7536 1.21924 15.0884 1.21924 10.0936Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3465 3.61407V3.10257C11.3465 2.07634 10.5971 1.24414 9.67395 1.24414H7.72134C6.79821 1.24414 6.04883 2.07634 6.04883 3.10257V3.61407"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TempSvgHome() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7164 5.89116L7.4572 0.187776C7.18246 -0.0626011 6.76817 -0.0625738 6.49354 0.187749L0.234275 5.89119C0.0141971 6.09173 -0.0584991 6.40072 0.0490194 6.67834C0.156565 6.95597 0.418414 7.13534 0.716147 7.13534H1.71586V12.8497C1.71586 13.0763 1.89956 13.26 2.12612 13.26H5.55696C5.78352 13.26 5.96723 13.0763 5.96723 12.8497V9.38012H7.98359V12.8497C7.98359 13.0763 8.1673 13.26 8.39386 13.26H11.8245C12.0511 13.26 12.2348 13.0763 12.2348 12.8497V7.13534H13.2347C13.5324 7.13534 13.7943 6.95594 13.9018 6.67834C14.0092 6.40069 13.9365 6.09173 13.7164 5.89116Z"
        fill="white"
      />
      <path
        d="M12.1273 0.818848H9.37207L12.5376 3.69716V1.22909C12.5376 1.00252 12.3539 0.818848 12.1273 0.818848Z"
        fill="white"
      />
    </svg>
  );
}

export function TempSvgPlace() {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3345 6.38263C10.4835 7.02079 9.44478 7.46385 8.31423 7.68243C8.20006 8.4911 7.50376 9.11529 6.66407 9.11529C5.82437 9.11529 5.12808 8.4911 5.0139 7.68243C3.88335 7.46385 2.84459 7.02079 1.99367 6.38263C0.708031 5.4184 0 4.12588 0 2.74316V9.83675C0 10.8971 0.86271 11.7598 1.92308 11.7598H11.4051C12.4654 11.7598 13.3281 10.8971 13.3281 9.83675V2.74316C13.3281 4.12588 12.6201 5.4184 11.3345 6.38263Z"
        fill="white"
      />
      <path
        d="M4.99744 6.88112V6.17184C4.99744 5.95619 5.17227 5.78136 5.38792 5.78136H7.94083C8.15647 5.78136 8.3313 5.95619 8.3313 6.17184V6.88112C10.7659 6.35265 12.5475 4.69772 12.5475 2.74307V2.3526H9.40744V1.57665C9.40744 0.707276 8.70014 0 7.83079 0H5.49798C4.62863 0 3.92133 0.707276 3.92133 1.57665V2.3526H0.78125V2.74307C0.78125 4.69772 2.56279 6.35265 4.99744 6.88112ZM4.70225 1.57665C4.70225 1.13789 5.05922 0.780945 5.49795 0.780945H7.83076C8.2695 0.780945 8.62647 1.13789 8.62647 1.57665V2.3526H4.70222V1.57665H4.70225Z"
        fill="white"
      />
      <path
        d="M7.55126 6.56226H5.7793V7.44824C5.7793 7.93677 6.17677 8.33422 6.66528 8.33422C7.15379 8.33422 7.55126 7.93677 7.55126 7.44824V6.56226Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgLocation() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.30542 2.56867C8.42283 0.99766 6.85516 0.0378662 5.11188 0.00118652C5.03746 -0.000395507 4.96256 -0.000395507 4.88811 0.00118652C3.14486 0.0378662 1.57719 0.99766 0.694571 2.56867C-0.207592 4.17449 -0.232275 6.1034 0.628532 7.72852L4.23477 12.5367C4.23639 12.5397 4.23801 12.5428 4.23968 12.5458C4.39835 12.8302 4.68258 13 5.00005 13C5.31749 13 5.60173 12.8302 5.76037 12.5458C5.76204 12.5428 5.76366 12.5397 5.76528 12.5367L9.37152 7.72852C10.2323 6.1034 10.2076 4.17449 9.30542 2.56867ZM5 6.79688C3.87234 6.79688 2.95492 5.85062 2.95492 4.68751C2.95492 3.5244 3.87234 2.57814 5 2.57814C6.12766 2.57814 7.04507 3.5244 7.04507 4.68751C7.04507 5.85062 6.12769 6.79688 5 6.79688Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgDeleteParcours() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="20"
        cy="20"
        r="20"
        fill="#F5F6F8"
      />
      <path
        d="M24.195 15.3848L20.513 19.0668L16.8309 15.3848L15.3848 16.8309L19.0668 20.513L15.3848 24.195L16.8309 25.6412L20.513 21.9591L24.195 25.6412L25.6412 24.195L21.9591 20.513L25.6412 16.8309L24.195 15.3848Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function SvgHierarchique() {
  return (
    <svg
      width="87"
      height="52"
      viewBox="0 0 87 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.6416 21.0723V21.0723C4.6416 15.5494 9.11875 10.9941 14.6416 10.9941L35.7924 10.9941"
        stroke="var(--greenSwitch)"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75177 22.4557C1.41109 21.7903 1.89433 21 2.64189 21L6.06053 21C6.80809 21 7.29133 21.7903 6.95064 22.4557L5.24133 25.7943C4.86978 26.52 3.83264 26.52 3.46109 25.7943L1.75177 22.4557Z"
        fill="var(--greenColor)"
      />
      <path
        d="M82.0615 21.0723V21.0723C82.0615 15.5494 77.5844 10.9941 72.0615 10.9941L50.9107 10.9941"
        stroke="var(--greenSwitch)"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.9514 22.4557C85.292 21.7903 84.8088 21 84.0612 21L80.6426 21C79.895 21 79.4118 21.7903 79.7525 22.4557L81.4618 25.7943C81.8333 26.52 82.8705 26.52 83.242 25.7943L84.9514 22.4557Z"
        fill="var(--greenColor)"
      />
      <path
        d="M43.3909 5.26823C44.8457 5.26823 46.0251 4.08889 46.0251 2.63411C46.0251 1.17933 44.8457 0 43.3909 0C41.9362 0 40.7568 1.17933 40.7568 2.63411C40.7568 4.08889 41.9362 5.26823 43.3909 5.26823Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M44.4877 6.14648H42.2926C40.4777 6.14648 39 7.62334 39 9.43913V13.0672C39 13.6528 39.3258 14.1797 39.8499 14.4413L40.6358 14.8338C40.7095 14.8715 40.7561 14.9471 40.7561 15.0305V19.5366C40.7561 20.3839 41.4453 21.0731 42.2926 21.0731H44.4877C45.335 21.0731 46.0243 20.3839 46.0243 19.5366V15.0305C46.0243 14.9471 46.0708 14.8715 46.1455 14.8338L46.9313 14.4413C47.4546 14.1797 47.7804 13.6528 47.7804 13.0672V9.43913C47.7804 7.62334 46.3026 6.14648 44.4877 6.14648Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M4.39095 35.2682C5.84573 35.2682 7.02506 34.0889 7.02506 32.6341C7.02506 31.1793 5.84573 30 4.39095 30C2.93617 30 1.75684 31.1793 1.75684 32.6341C1.75684 34.0889 2.93617 35.2682 4.39095 35.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M5.48774 36.1465H3.29264C1.47774 36.1465 0 37.6233 0 39.4391V43.0672C0 43.6528 0.325752 44.1797 0.849941 44.4413L1.63578 44.8338C1.70954 44.8715 1.75608 44.9471 1.75608 45.0305V49.5366C1.75608 50.3839 2.44534 51.0731 3.29264 51.0731H5.48774C6.33504 51.0731 7.0243 50.3839 7.0243 49.5366V45.0305C7.0243 44.9471 7.07084 44.8715 7.14547 44.8338L7.93132 44.4413C8.45463 44.1797 8.78038 43.6528 8.78038 43.0672V39.4391C8.78038 37.6233 7.30264 36.1465 5.48774 36.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M82.3909 35.2682C83.8457 35.2682 85.0251 34.0889 85.0251 32.6341C85.0251 31.1793 83.8457 30 82.3909 30C80.9362 30 79.7568 31.1793 79.7568 32.6341C79.7568 34.0889 80.9362 35.2682 82.3909 35.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M83.4877 36.1465H81.2926C79.4777 36.1465 78 37.6233 78 39.4391V43.0672C78 43.6528 78.3258 44.1797 78.8499 44.4413L79.6358 44.8338C79.7095 44.8715 79.7561 44.9471 79.7561 45.0305V49.5366C79.7561 50.3839 80.4453 51.0731 81.2926 51.0731H83.4877C84.335 51.0731 85.0243 50.3839 85.0243 49.5366V45.0305C85.0243 44.9471 85.0708 44.8715 85.1455 44.8338L85.9313 44.4413C86.4546 44.1797 86.7804 43.6528 86.7804 43.0672V39.4391C86.7804 37.6233 85.3026 36.1465 83.4877 36.1465Z"
        fill="var(--greenSwitch)"
      />
    </svg>
  );
}

export function SvgMatricielle() {
  return (
    <svg
      width="141"
      height="33"
      viewBox="0 0 141 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.39095 9.26823C5.84573 9.26823 7.02506 8.08889 7.02506 6.63411C7.02506 5.17933 5.84573 4 4.39095 4C2.93617 4 1.75684 5.17933 1.75684 6.63411C1.75684 8.08889 2.93617 9.26823 4.39095 9.26823Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M5.48774 10.1465H3.29264C1.47774 10.1465 0 11.6233 0 13.4391V17.0672C0 17.6528 0.325752 18.1797 0.849941 18.4413L1.63578 18.8338C1.70954 18.8715 1.75608 18.9471 1.75608 19.0305V23.5366C1.75608 24.3839 2.44534 25.0731 3.29264 25.0731H5.48774C6.33504 25.0731 7.0243 24.3839 7.0243 23.5366V19.0305C7.0243 18.9471 7.07084 18.8715 7.14547 18.8338L7.93132 18.4413C8.45463 18.1797 8.78038 17.6528 8.78038 17.0672V13.4391C8.78038 11.6233 7.30264 10.1465 5.48774 10.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M70.3909 9.26823C71.8457 9.26823 73.0251 8.08889 73.0251 6.63411C73.0251 5.17933 71.8457 4 70.3909 4C68.9362 4 67.7568 5.17933 67.7568 6.63411C67.7568 8.08889 68.9362 9.26823 70.3909 9.26823Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M71.4877 10.1465H69.2926C67.4777 10.1465 66 11.6233 66 13.4391V17.0672C66 17.6528 66.3258 18.1797 66.8499 18.4413L67.6358 18.8338C67.7095 18.8715 67.7561 18.9471 67.7561 19.0305V23.5366C67.7561 24.3839 68.4453 25.0731 69.2926 25.0731H71.4877C72.335 25.0731 73.0243 24.3839 73.0243 23.5366V19.0305C73.0243 18.9471 73.0708 18.8715 73.1455 18.8338L73.9313 18.4413C74.4546 18.1797 74.7804 17.6528 74.7804 17.0672V13.4391C74.7804 11.6233 73.3026 10.1465 71.4877 10.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M136.391 9.26823C137.846 9.26823 139.025 8.08889 139.025 6.63411C139.025 5.17933 137.846 4 136.391 4C134.936 4 133.757 5.17933 133.757 6.63411C133.757 8.08889 134.936 9.26823 136.391 9.26823Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M137.488 10.1465H135.293C133.478 10.1465 132 11.6233 132 13.4391V17.0672C132 17.6528 132.326 18.1797 132.85 18.4413L133.636 18.8338C133.71 18.8715 133.756 18.9471 133.756 19.0305V23.5366C133.756 24.3839 134.445 25.0731 135.293 25.0731H137.488C138.335 25.0731 139.024 24.3839 139.024 23.5366V19.0305C139.024 18.9471 139.071 18.8715 139.145 18.8338L139.931 18.4413C140.455 18.1797 140.78 17.6528 140.78 17.0672V13.4391C140.78 11.6233 139.303 10.1465 137.488 10.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M89.0566 16.2852L119.625 16.2852"
        stroke="var(--greenSwitch)"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.48 13.8957C116.815 13.555 116.024 14.0383 116.024 14.7858L116.024 18.665C116.024 19.4125 116.815 19.8958 117.48 19.5551L121.268 17.6155C121.994 17.244 121.994 16.2068 121.268 15.8353L117.48 13.8957Z"
        fill="var(--greenColor)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.5267 19.4051C90.1921 19.7458 90.9824 19.2625 90.9824 18.515L90.9824 14.6358C90.9824 13.8883 90.1921 13.405 89.5267 13.7457L85.7384 15.6853C85.0127 16.0568 85.0127 17.094 85.7384 17.4655L89.5267 19.4051Z"
        fill="var(--greenColor)"
      />
      <path
        d="M23.0566 16.2852L53.6252 16.2852"
        stroke="var(--greenSwitch)"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.4801 13.8957C50.8147 13.555 50.0244 14.0383 50.0244 14.7858L50.0244 18.665C50.0244 19.4125 50.8147 19.8958 51.4801 19.5551L55.2684 17.6155C55.9941 17.244 55.9941 16.2068 55.2684 15.8353L51.4801 13.8957Z"
        fill="var(--greenColor)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5267 19.4051C24.1921 19.7458 24.9824 19.2625 24.9824 18.515L24.9824 14.6358C24.9824 13.8883 24.1921 13.405 23.5267 13.7457L19.7384 15.6853C19.0127 16.0568 19.0127 17.094 19.7384 17.4655L23.5267 19.4051Z"
        fill="var(--greenColor)"
      />
    </svg>
  );
}

export function SvgReseaux() {
  return (
    <svg
      width="102"
      height="68"
      viewBox="0 0 102 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.39095 26.2682C5.84573 26.2682 7.02506 25.0889 7.02506 23.6341C7.02506 22.1793 5.84573 21 4.39095 21C2.93617 21 1.75684 22.1793 1.75684 23.6341C1.75684 25.0889 2.93617 26.2682 4.39095 26.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M5.48774 27.1465H3.29264C1.47774 27.1465 0 28.6233 0 30.4391V34.0672C0 34.6528 0.325752 35.1797 0.849941 35.4413L1.63578 35.8338C1.70954 35.8715 1.75608 35.9471 1.75608 36.0305V40.5366C1.75608 41.3839 2.44534 42.0731 3.29264 42.0731H5.48774C6.33504 42.0731 7.0243 41.3839 7.0243 40.5366V36.0305C7.0243 35.9471 7.07084 35.8715 7.14547 35.8338L7.93132 35.4413C8.45463 35.1797 8.78038 34.6528 8.78038 34.0672V30.4391C8.78038 28.6233 7.30264 27.1465 5.48774 27.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M50.3909 5.26823C51.8457 5.26823 53.0251 4.08889 53.0251 2.63411C53.0251 1.17933 51.8457 0 50.3909 0C48.9362 0 47.7568 1.17933 47.7568 2.63411C47.7568 4.08889 48.9362 5.26823 50.3909 5.26823Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M51.4877 6.14648H49.2926C47.4777 6.14648 46 7.62334 46 9.43913V13.0672C46 13.6528 46.3258 14.1797 46.8499 14.4413L47.6358 14.8338C47.7095 14.8715 47.7561 14.9471 47.7561 15.0305V19.5366C47.7561 20.3839 48.4453 21.0731 49.2926 21.0731H51.4877C52.335 21.0731 53.0243 20.3839 53.0243 19.5366V15.0305C53.0243 14.9471 53.0708 14.8715 53.1455 14.8338L53.9313 14.4413C54.4546 14.1797 54.7804 13.6528 54.7804 13.0672V9.43913C54.7804 7.62334 53.3026 6.14648 51.4877 6.14648Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M50.3909 49.2682C51.8457 49.2682 53.0251 48.0889 53.0251 46.6341C53.0251 45.1793 51.8457 44 50.3909 44C48.9362 44 47.7568 45.1793 47.7568 46.6341C47.7568 48.0889 48.9362 49.2682 50.3909 49.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M51.4877 50.1465H49.2926C47.4777 50.1465 46 51.6233 46 53.4391V57.0672C46 57.6528 46.3258 58.1797 46.8499 58.4413L47.6358 58.8338C47.7095 58.8715 47.7561 58.9471 47.7561 59.0305V63.5366C47.7561 64.3839 48.4453 65.0731 49.2926 65.0731H51.4877C52.335 65.0731 53.0243 64.3839 53.0243 63.5366V59.0305C53.0243 58.9471 53.0708 58.8715 53.1455 58.8338L53.9313 58.4413C54.4546 58.1797 54.7804 57.6528 54.7804 57.0672V53.4391C54.7804 51.6233 53.3026 50.1465 51.4877 50.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M97.3909 26.2682C98.8457 26.2682 100.025 25.0889 100.025 23.6341C100.025 22.1793 98.8457 21 97.3909 21C95.9362 21 94.7568 22.1793 94.7568 23.6341C94.7568 25.0889 95.9362 26.2682 97.3909 26.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M98.4877 27.1465H96.2926C94.4777 27.1465 93 28.6233 93 30.4391V34.0672C93 34.6528 93.3258 35.1797 93.8499 35.4413L94.6358 35.8338C94.7095 35.8715 94.7561 35.9471 94.7561 36.0305V40.5366C94.7561 41.3839 95.4453 42.0731 96.2926 42.0731H98.4877C99.335 42.0731 100.024 41.3839 100.024 40.5366V36.0305C100.024 35.9471 100.071 35.8715 100.145 35.8338L100.931 35.4413C101.455 35.1797 101.78 34.6528 101.78 34.0672V30.4391C101.78 28.6233 100.303 27.1465 98.4877 27.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M61.1768 14.1641L87.5055 29.6958"
        stroke="var(--greenSwitch)"
        strokeWidth="1.5"
        stroke-dasharray="2 2"
      />
      <path
        d="M15.2285 30.1133L41.4541 14.408"
        stroke="var(--greenSwitch)"
        strokeWidth="1.5"
        stroke-dasharray="2 2"
      />
      <path
        d="M61.1768 54.0625L87.5055 38.5308"
        stroke="var(--greenSwitch)"
        strokeWidth="1.5"
        stroke-dasharray="2 2"
      />
      <path
        d="M15.2285 38.1133L41.4541 53.8185"
        stroke="var(--greenSwitch)"
        strokeWidth="1.5"
        stroke-dasharray="2 2"
      />
    </svg>
  );
}

export function SvgMatricielleAndReseaux() {
  return (
    <svg
      width="136"
      height="67"
      viewBox="0 0 136 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0576 56.2852L29.6262 56.2852"
        stroke="var(--greenSwitch)"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.7279 53.3727C28.3952 53.2023 28 53.4439 28 53.8177L28 58.3323C28 58.7061 28.3952 58.9477 28.7279 58.7773L33.1367 56.5201C33.4995 56.3343 33.4995 55.8157 33.1367 55.6299L28.7279 53.3727Z"
        fill="var(--greenColor)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.278 58.7777C16.6107 58.9481 17.0059 58.7065 17.0059 58.3327L17.0059 53.8181C17.0059 53.4443 16.6107 53.2027 16.278 53.3731L11.8692 55.6303C11.5063 55.8161 11.5063 56.3347 11.8692 56.5204L16.278 58.7777Z"
        fill="var(--greenColor)"
      />
      <path
        d="M107.058 56.2852L121.626 56.2852"
        stroke="var(--greenSwitch)"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.728 53.3727C120.395 53.2023 120 53.4439 120 53.8177L120 58.3323C120 58.7061 120.395 58.9477 120.728 58.7773L125.137 56.5201C125.5 56.3343 125.5 55.8157 125.137 55.6299L120.728 53.3727Z"
        fill="var(--greenColor)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.278 58.7777C108.611 58.9481 109.006 58.7065 109.006 58.3327L109.006 53.8181C109.006 53.4443 108.611 53.2027 108.278 53.3731L103.869 55.6303C103.506 55.8161 103.506 56.3347 103.869 56.5204L108.278 58.7777Z"
        fill="var(--greenColor)"
      />
      <path
        d="M21.3909 26.2682C22.8457 26.2682 24.0251 25.0889 24.0251 23.6341C24.0251 22.1793 22.8457 21 21.3909 21C19.9362 21 18.7568 22.1793 18.7568 23.6341C18.7568 25.0889 19.9362 26.2682 21.3909 26.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M22.4877 27.1465H20.2926C18.4777 27.1465 17 28.6233 17 30.4391V34.0672C17 34.6528 17.3258 35.1797 17.8499 35.4413L18.6358 35.8338C18.7095 35.8715 18.7561 35.9471 18.7561 36.0305V40.5366C18.7561 41.3839 19.4453 42.0731 20.2926 42.0731H22.4877C23.335 42.0731 24.0243 41.3839 24.0243 40.5366V36.0305C24.0243 35.9471 24.0708 35.8715 24.1455 35.8338L24.9313 35.4413C25.4546 35.1797 25.7804 34.6528 25.7804 34.0672V30.4391C25.7804 28.6233 24.3026 27.1465 22.4877 27.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M67.3909 5.26823C68.8457 5.26823 70.0251 4.08889 70.0251 2.63411C70.0251 1.17933 68.8457 0 67.3909 0C65.9362 0 64.7568 1.17933 64.7568 2.63411C64.7568 4.08889 65.9362 5.26823 67.3909 5.26823Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M68.4877 6.14648H66.2926C64.4777 6.14648 63 7.62334 63 9.43913V13.0672C63 13.6528 63.3258 14.1797 63.8499 14.4413L64.6358 14.8338C64.7095 14.8715 64.7561 14.9471 64.7561 15.0305V19.5366C64.7561 20.3839 65.4453 21.0731 66.2926 21.0731H68.4877C69.335 21.0731 70.0243 20.3839 70.0243 19.5366V15.0305C70.0243 14.9471 70.0708 14.8715 70.1455 14.8338L70.9313 14.4413C71.4546 14.1797 71.7804 13.6528 71.7804 13.0672V9.43913C71.7804 7.62334 70.3026 6.14648 68.4877 6.14648Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M114.391 26.2682C115.846 26.2682 117.025 25.0889 117.025 23.6341C117.025 22.1793 115.846 21 114.391 21C112.936 21 111.757 22.1793 111.757 23.6341C111.757 25.0889 112.936 26.2682 114.391 26.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M115.488 27.1465H113.293C111.478 27.1465 110 28.6233 110 30.4391V34.0672C110 34.6528 110.326 35.1797 110.85 35.4413L111.636 35.8338C111.71 35.8715 111.756 35.9471 111.756 36.0305V40.5366C111.756 41.3839 112.445 42.0731 113.293 42.0731H115.488C116.335 42.0731 117.024 41.3839 117.024 40.5366V36.0305C117.024 35.9471 117.071 35.8715 117.145 35.8338L117.931 35.4413C118.455 35.1797 118.78 34.6528 118.78 34.0672V30.4391C118.78 28.6233 117.303 27.1465 115.488 27.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M78.1768 14.1641L104.505 29.6958"
        stroke="var(--greenSwitch)"
        strokeWidth="1.5"
        stroke-dasharray="2 2"
      />
      <path
        d="M32.2285 30.1133L58.4541 14.408"
        stroke="var(--greenSwitch)"
        strokeWidth="1.5"
        stroke-dasharray="2 2"
      />
      <path
        d="M4.39095 50.2682C5.84573 50.2682 7.02506 49.0889 7.02506 47.6341C7.02506 46.1793 5.84573 45 4.39095 45C2.93617 45 1.75684 46.1793 1.75684 47.6341C1.75684 49.0889 2.93617 50.2682 4.39095 50.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M5.48774 51.1465H3.29264C1.47774 51.1465 0 52.6233 0 54.4391V58.0672C0 58.6528 0.325752 59.1797 0.849941 59.4413L1.63578 59.8338C1.70954 59.8715 1.75608 59.9471 1.75608 60.0305V64.5366C1.75608 65.3839 2.44534 66.0731 3.29264 66.0731H5.48774C6.33504 66.0731 7.0243 65.3839 7.0243 64.5366V60.0305C7.0243 59.9471 7.07084 59.8715 7.14547 59.8338L7.93132 59.4413C8.45463 59.1797 8.78038 58.6528 8.78038 58.0672V54.4391C8.78038 52.6233 7.30264 51.1465 5.48774 51.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M39.3909 50.2682C40.8457 50.2682 42.0251 49.0889 42.0251 47.6341C42.0251 46.1793 40.8457 45 39.3909 45C37.9362 45 36.7568 46.1793 36.7568 47.6341C36.7568 49.0889 37.9362 50.2682 39.3909 50.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M40.4877 51.1465H38.2926C36.4777 51.1465 35 52.6233 35 54.4391V58.0672C35 58.6528 35.3258 59.1797 35.8499 59.4413L36.6358 59.8338C36.7095 59.8715 36.7561 59.9471 36.7561 60.0305V64.5366C36.7561 65.3839 37.4453 66.0731 38.2926 66.0731H40.4877C41.335 66.0731 42.0243 65.3839 42.0243 64.5366V60.0305C42.0243 59.9471 42.0708 59.8715 42.1455 59.8338L42.9313 59.4413C43.4546 59.1797 43.7804 58.6528 43.7804 58.0672V54.4391C43.7804 52.6233 42.3026 51.1465 40.4877 51.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M96.3909 50.2682C97.8457 50.2682 99.0251 49.0889 99.0251 47.6341C99.0251 46.1793 97.8457 45 96.3909 45C94.9362 45 93.7568 46.1793 93.7568 47.6341C93.7568 49.0889 94.9362 50.2682 96.3909 50.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M97.4877 51.1465H95.2926C93.4777 51.1465 92 52.6233 92 54.4391V58.0672C92 58.6528 92.3258 59.1797 92.8499 59.4413L93.6358 59.8338C93.7095 59.8715 93.7561 59.9471 93.7561 60.0305V64.5366C93.7561 65.3839 94.4453 66.0731 95.2926 66.0731H97.4877C98.335 66.0731 99.0243 65.3839 99.0243 64.5366V60.0305C99.0243 59.9471 99.0708 59.8715 99.1455 59.8338L99.9313 59.4413C100.455 59.1797 100.78 58.6528 100.78 58.0672V54.4391C100.78 52.6233 99.3026 51.1465 97.4877 51.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M131.391 50.2682C132.846 50.2682 134.025 49.0889 134.025 47.6341C134.025 46.1793 132.846 45 131.391 45C129.936 45 128.757 46.1793 128.757 47.6341C128.757 49.0889 129.936 50.2682 131.391 50.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M132.488 51.1465H130.293C128.478 51.1465 127 52.6233 127 54.4391V58.0672C127 58.6528 127.326 59.1797 127.85 59.4413L128.636 59.8338C128.71 59.8715 128.756 59.9471 128.756 60.0305V64.5366C128.756 65.3839 129.445 66.0731 130.293 66.0731H132.488C133.335 66.0731 134.024 65.3839 134.024 64.5366V60.0305C134.024 59.9471 134.071 59.8715 134.145 59.8338L134.931 59.4413C135.455 59.1797 135.78 58.6528 135.78 58.0672V54.4391C135.78 52.6233 134.303 51.1465 132.488 51.1465Z"
        fill="var(--greenSwitch)"
      />
    </svg>
  );
}

export function SvgHolacratique() {
  return (
    <svg
      width="131"
      height="79"
      viewBox="0 0 131 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M67.1712 5.26823C68.626 5.26823 69.8053 4.08889 69.8053 2.63411C69.8053 1.17933 68.626 0 67.1712 0C65.7164 0 64.5371 1.17933 64.5371 2.63411C64.5371 4.08889 65.7164 5.26823 67.1712 5.26823Z"
        fill="var(--greenColor)"
      />
      <path
        d="M68.268 6.14648H66.0729C64.258 6.14648 62.7803 7.62334 62.7803 9.43913V13.0672C62.7803 13.6528 63.106 14.1797 63.6302 14.4413L64.4161 14.8338C64.4898 14.8715 64.5363 14.9471 64.5363 15.0305V19.5366C64.5363 20.3839 65.2256 21.0731 66.0729 21.0731H68.268C69.1153 21.0731 69.8046 20.3839 69.8046 19.5366V15.0305C69.8046 14.9471 69.8511 14.8715 69.9257 14.8338L70.7116 14.4413C71.2349 14.1797 71.5607 13.6528 71.5607 13.0672V9.43913C71.5607 7.62334 70.0829 6.14648 68.268 6.14648Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M52.3909 11.2682C53.8457 11.2682 55.0251 10.0889 55.0251 8.63411C55.0251 7.17933 53.8457 6 52.3909 6C50.9362 6 49.7568 7.17933 49.7568 8.63411C49.7568 10.0889 50.9362 11.2682 52.3909 11.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M53.4877 12.1465H51.2926C49.4777 12.1465 48 13.6233 48 15.4391V19.0672C48 19.6528 48.3258 20.1797 48.8499 20.4413L49.6358 20.8338C49.7095 20.8715 49.7561 20.9471 49.7561 21.0305V25.5366C49.7561 26.3839 50.4453 27.0731 51.2926 27.0731H53.4877C54.335 27.0731 55.0243 26.3839 55.0243 25.5366V21.0305C55.0243 20.9471 55.0708 20.8715 55.1455 20.8338L55.9313 20.4413C56.4546 20.1797 56.7804 19.6528 56.7804 19.0672V15.4391C56.7804 13.6233 55.3026 12.1465 53.4877 12.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M81.9515 11.2682C83.4063 11.2682 84.5856 10.0889 84.5856 8.63411C84.5856 7.17933 83.4063 6 81.9515 6C80.4967 6 79.3174 7.17933 79.3174 8.63411C79.3174 10.0889 80.4967 11.2682 81.9515 11.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M83.0483 12.1465H80.8532C79.0383 12.1465 77.5605 13.6233 77.5605 15.4391V19.0672C77.5605 19.6528 77.8863 20.1797 78.4105 20.4413L79.1963 20.8338C79.2701 20.8715 79.3166 20.9471 79.3166 21.0305V25.5366C79.3166 26.3839 80.0059 27.0731 80.8532 27.0731H83.0483C83.8956 27.0731 84.5848 26.3839 84.5848 25.5366V21.0305C84.5848 20.9471 84.6314 20.8715 84.706 20.8338L85.4919 20.4413C86.0152 20.1797 86.3409 19.6528 86.3409 19.0672V15.4391C86.3409 13.6233 84.8632 12.1465 83.0483 12.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M19.1712 56.2682C20.626 56.2682 21.8053 55.0889 21.8053 53.6341C21.8053 52.1793 20.626 51 19.1712 51C17.7164 51 16.5371 52.1793 16.5371 53.6341C16.5371 55.0889 17.7164 56.2682 19.1712 56.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M20.268 57.1465H18.0729C16.258 57.1465 14.7803 58.6233 14.7803 60.4391V64.0672C14.7803 64.6528 15.106 65.1797 15.6302 65.4413L16.4161 65.8338C16.4898 65.8715 16.5363 65.9471 16.5363 66.0305V70.5366C16.5363 71.3839 17.2256 72.0731 18.0729 72.0731H20.268C21.1153 72.0731 21.8046 71.3839 21.8046 70.5366V66.0305C21.8046 65.9471 21.8511 65.8715 21.9257 65.8338L22.7116 65.4413C23.2349 65.1797 23.5607 64.6528 23.5607 64.0672V60.4391C23.5607 58.6233 22.0829 57.1465 20.268 57.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M4.39095 62.2682C5.84573 62.2682 7.02506 61.0889 7.02506 59.6341C7.02506 58.1793 5.84573 57 4.39095 57C2.93617 57 1.75684 58.1793 1.75684 59.6341C1.75684 61.0889 2.93617 62.2682 4.39095 62.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M5.48774 63.1465H3.29264C1.47774 63.1465 0 64.6233 0 66.4391V70.0672C0 70.6528 0.325752 71.1797 0.849941 71.4413L1.63578 71.8338C1.70954 71.8715 1.75608 71.9471 1.75608 72.0305V76.5366C1.75608 77.3839 2.44534 78.0731 3.29264 78.0731H5.48774C6.33504 78.0731 7.0243 77.3839 7.0243 76.5366V72.0305C7.0243 71.9471 7.07084 71.8715 7.14547 71.8338L7.93132 71.4413C8.45463 71.1797 8.78038 70.6528 8.78038 70.0672V66.4391C8.78038 64.6233 7.30264 63.1465 5.48774 63.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M33.9515 62.2682C35.4063 62.2682 36.5856 61.0889 36.5856 59.6341C36.5856 58.1793 35.4063 57 33.9515 57C32.4967 57 31.3174 58.1793 31.3174 59.6341C31.3174 61.0889 32.4967 62.2682 33.9515 62.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M35.0483 63.1465H32.8532C31.0383 63.1465 29.5605 64.6233 29.5605 66.4391V70.0672C29.5605 70.6528 29.8863 71.1797 30.4105 71.4413L31.1963 71.8338C31.2701 71.8715 31.3166 71.9471 31.3166 72.0305V76.5366C31.3166 77.3839 32.0059 78.0731 32.8532 78.0731H35.0483C35.8956 78.0731 36.5848 77.3839 36.5848 76.5366V72.0305C36.5848 71.9471 36.6314 71.8715 36.706 71.8338L37.4919 71.4413C38.0152 71.1797 38.3409 70.6528 38.3409 70.0672V66.4391C38.3409 64.6233 36.8632 63.1465 35.0483 63.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M111.171 56.2682C112.626 56.2682 113.805 55.0889 113.805 53.6341C113.805 52.1793 112.626 51 111.171 51C109.716 51 108.537 52.1793 108.537 53.6341C108.537 55.0889 109.716 56.2682 111.171 56.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M112.268 57.1465H110.073C108.258 57.1465 106.78 58.6233 106.78 60.4391V64.0672C106.78 64.6528 107.106 65.1797 107.63 65.4413L108.416 65.8338C108.49 65.8715 108.536 65.9471 108.536 66.0305V70.5366C108.536 71.3839 109.226 72.0731 110.073 72.0731H112.268C113.115 72.0731 113.805 71.3839 113.805 70.5366V66.0305C113.805 65.9471 113.851 65.8715 113.926 65.8338L114.712 65.4413C115.235 65.1797 115.561 64.6528 115.561 64.0672V60.4391C115.561 58.6233 114.083 57.1465 112.268 57.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M96.3909 62.2682C97.8457 62.2682 99.0251 61.0889 99.0251 59.6341C99.0251 58.1793 97.8457 57 96.3909 57C94.9362 57 93.7568 58.1793 93.7568 59.6341C93.7568 61.0889 94.9362 62.2682 96.3909 62.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M97.4877 63.1465H95.2926C93.4777 63.1465 92 64.6233 92 66.4391V70.0672C92 70.6528 92.3258 71.1797 92.8499 71.4413L93.6358 71.8338C93.7095 71.8715 93.7561 71.9471 93.7561 72.0305V76.5366C93.7561 77.3839 94.4453 78.0731 95.2926 78.0731H97.4877C98.335 78.0731 99.0243 77.3839 99.0243 76.5366V72.0305C99.0243 71.9471 99.0708 71.8715 99.1455 71.8338L99.9313 71.4413C100.455 71.1797 100.78 70.6528 100.78 70.0672V66.4391C100.78 64.6233 99.3026 63.1465 97.4877 63.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M125.951 62.2682C127.406 62.2682 128.586 61.0889 128.586 59.6341C128.586 58.1793 127.406 57 125.951 57C124.497 57 123.317 58.1793 123.317 59.6341C123.317 61.0889 124.497 62.2682 125.951 62.2682Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M127.048 63.1465H124.853C123.038 63.1465 121.561 64.6233 121.561 66.4391V70.0672C121.561 70.6528 121.886 71.1797 122.41 71.4413L123.196 71.8338C123.27 71.8715 123.317 71.9471 123.317 72.0305V76.5366C123.317 77.3839 124.006 78.0731 124.853 78.0731H127.048C127.896 78.0731 128.585 77.3839 128.585 76.5366V72.0305C128.585 71.9471 128.631 71.8715 128.706 71.8338L129.492 71.4413C130.015 71.1797 130.341 70.6528 130.341 70.0672V66.4391C130.341 64.6233 128.863 63.1465 127.048 63.1465Z"
        fill="var(--greenSwitch)"
      />
      <path
        d="M67.3174 34.0547L67.3174 49.8439C67.3174 55.6573 62.6047 60.3701 56.7912 60.3701V60.3701"
        stroke="var(--greenSwitch)"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.2845 63.3826C55.9499 63.7233 56.7402 63.24 56.7402 62.4925L56.7402 58.2488C56.7402 57.5012 55.9499 57.018 55.2845 57.3587L51.1402 59.4805C50.4145 59.8521 50.4145 60.8892 51.1402 61.2607L55.2845 63.3826Z"
        fill="var(--greenColor)"
      />
      <path
        d="M67.3174 34.0547L67.3174 49.8439C67.3174 55.6573 72.0301 60.3701 77.8435 60.3701V60.3701"
        stroke="var(--greenSwitch)"
        strokeWidth="1.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.3576 36.2845C64.017 36.9499 64.5002 37.7402 65.2478 37.7402L69.4914 37.7402C70.239 37.7402 70.7222 36.9499 70.3816 36.2845L68.2597 32.1402C67.8882 31.4145 66.851 31.4145 66.4795 32.1402L64.3576 36.2845Z"
        fill="var(--greenColor)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.4557 63.3826C78.7903 63.7233 78 63.24 78 62.4925L78 58.2488C78 57.5012 78.7903 57.018 79.4557 57.3587L83.6 59.4805C84.3257 59.8521 84.3257 60.8892 83.6 61.2607L79.4557 63.3826Z"
        fill="var(--greenColor)"
      />
    </svg>
  );
}

export function SvgPauseRepas() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4964 1.23021e-05C15.3885 -0.000814392 18.1914 1.00124 20.4275 2.83542C22.6636 4.66961 24.1945 7.22241 24.7593 10.0588C25.3241 12.8953 24.8879 15.8398 23.525 18.3906C22.1621 20.9414 19.9568 22.9408 17.285 24.0479C14.6132 25.155 11.6402 25.3014 8.87252 24.4621C6.10487 23.6228 3.71389 21.8498 2.107 19.4452C0.500108 17.0405 -0.223247 14.1531 0.0601966 11.2749C0.34364 8.39675 1.61634 5.7059 3.66143 3.66093C4.82005 2.49844 6.19711 1.57653 7.71337 0.948249C9.22962 0.319965 10.8552 -0.00229495 12.4964 1.23021e-05ZM10.6883 11.8817C11.2822 11.4749 11.5812 10.9441 11.5304 9.72991V6.60796C11.5304 6.17272 10.7331 6.11984 10.6944 6.60796L10.6639 9.1401C10.6639 9.23449 10.6264 9.32502 10.5597 9.39177C10.4929 9.45852 10.4024 9.49602 10.308 9.49602C10.2136 9.49602 10.1231 9.45852 10.0563 9.39177C9.98959 9.32502 9.95209 9.23449 9.95209 9.1401L9.9826 6.52051C9.9826 6.05273 9.21584 6.00595 9.20771 6.52051C9.20771 7.24863 9.1772 8.41402 9.1772 9.1401C9.18445 9.18433 9.18199 9.22962 9.16999 9.27281C9.158 9.316 9.13675 9.35607 9.10773 9.39023C9.07871 9.42439 9.04261 9.45184 9.00192 9.47066C8.96124 9.48948 8.91695 9.49923 8.87212 9.49923C8.8273 9.49923 8.78301 9.48948 8.74232 9.47066C8.70164 9.45184 8.66554 9.42439 8.63652 9.39023C8.60749 9.35607 8.58625 9.316 8.57425 9.27281C8.56226 9.22962 8.5598 9.18433 8.56705 9.1401L8.59756 6.53881C8.59116 6.46466 8.5654 6.39349 8.52286 6.33242C8.48033 6.27135 8.4225 6.22251 8.35517 6.1908C8.28783 6.15909 8.21335 6.14562 8.13918 6.15172C8.065 6.15783 7.99373 6.18331 7.93249 6.2256C7.65182 6.40458 7.70877 6.76457 7.69656 7.06965L7.59894 10.0574C7.61318 10.9258 7.84097 11.6316 8.5223 11.9326C8.653 11.9845 8.78963 12.02 8.92907 12.0383L8.69925 18.1521C8.69655 18.2533 8.71399 18.3541 8.75058 18.4486C8.78716 18.5431 8.84215 18.6293 8.91235 18.7024C8.98256 18.7754 9.06657 18.8338 9.15952 18.8741C9.25247 18.9144 9.3525 18.9358 9.4538 18.9371H9.54736C9.66113 18.9353 9.77342 18.9109 9.87774 18.8655C9.98206 18.82 10.0764 18.7544 10.1552 18.6724C10.234 18.5903 10.2959 18.4935 10.3371 18.3874C10.3783 18.2814 10.3982 18.1682 10.3955 18.0544L10.1921 12.0363C10.3667 12.0178 10.536 11.9653 10.6904 11.8817H10.6883ZM14.3493 17.9324L14.3391 12.561C12.0429 11.235 12.7751 6.12594 15.0713 6.15442C17.8617 6.18696 18.1932 11.9122 15.7933 12.5407L15.9702 17.9588C16.0048 19.2056 14.3432 19.3215 14.3432 17.9324H14.3493ZM20.1945 4.79785C18.4123 3.01886 16.0684 1.91281 13.5622 1.66815C11.0559 1.42349 8.54238 2.05534 6.44975 3.45605C4.35712 4.85677 2.81487 6.9397 2.08574 9.34999C1.35661 11.7603 1.48571 14.3488 2.45104 16.6746C3.41638 19.0004 5.15823 20.9195 7.37984 22.1051C9.60146 23.2906 12.1654 23.6692 14.6349 23.1764C17.1043 22.6836 19.3265 21.3498 20.9229 19.4023C22.5193 17.4548 23.391 15.0141 23.3897 12.4959C23.3907 11.0655 23.1089 9.64905 22.5606 8.32793C22.0122 7.0068 21.2081 5.80711 20.1945 4.79785Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgModalPauseRepas() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.49786 7.38124e-06C9.23312 -0.000488635 10.9149 0.600745 12.2565 1.70125C13.5982 2.80176 14.5167 4.33345 14.8556 6.0353C15.1945 7.73715 14.9327 9.50386 14.115 11.0344C13.2973 12.5649 11.9741 13.7645 10.371 14.4287C8.76793 15.093 6.9841 15.1808 5.32351 14.6772C3.66292 14.1737 2.22833 13.1099 1.2642 11.6671C0.300065 10.2243 -0.133948 8.49187 0.036118 6.76496C0.206184 5.03805 0.969805 3.42354 2.19686 2.19656C2.89203 1.49906 3.71826 0.94592 4.62802 0.56895C5.53777 0.191979 6.51309 -0.00137697 7.49786 7.38124e-06ZM6.41301 7.12903C6.76933 6.88497 6.94872 6.56647 6.91821 5.83795V3.96478C6.91821 3.70363 6.43985 3.67191 6.41667 3.96478L6.39836 5.48406C6.39836 5.5407 6.37586 5.59501 6.33581 5.63506C6.29576 5.67511 6.24145 5.69761 6.18481 5.69761C6.12817 5.69761 6.07385 5.67511 6.0338 5.63506C5.99375 5.59501 5.97126 5.5407 5.97126 5.48406L5.98956 3.91231C5.98956 3.63164 5.52951 3.60357 5.52462 3.91231C5.52462 4.34917 5.50632 5.04841 5.50632 5.48406C5.51067 5.5106 5.50919 5.53777 5.502 5.56369C5.4948 5.5896 5.48205 5.61364 5.46464 5.63414C5.44723 5.65464 5.42556 5.6711 5.40115 5.68239C5.37674 5.69369 5.35017 5.69954 5.32327 5.69954C5.29638 5.69954 5.2698 5.69369 5.24539 5.68239C5.22098 5.6711 5.19932 5.65464 5.18191 5.63414C5.1645 5.61364 5.15175 5.5896 5.14455 5.56369C5.13736 5.53777 5.13588 5.5106 5.14023 5.48406L5.15853 3.92329C5.15469 3.8788 5.13924 3.8361 5.11372 3.79945C5.08819 3.76281 5.0535 3.73351 5.0131 3.71448C4.9727 3.69545 4.92801 3.68737 4.88351 3.69103C4.839 3.6947 4.79624 3.70998 4.75949 3.73536C4.59109 3.84275 4.62526 4.05874 4.61794 4.24179L4.55936 6.03442C4.56791 6.55549 4.70458 6.97893 5.11338 7.15954C5.1918 7.19069 5.27378 7.212 5.35744 7.22299L5.21955 10.8912C5.21793 10.952 5.22839 11.0125 5.25034 11.0692C5.27229 11.1258 5.30529 11.1776 5.34741 11.2214C5.38953 11.2653 5.43994 11.3003 5.49571 11.3244C5.55148 11.3486 5.6115 11.3615 5.67228 11.3623H5.72842C5.79668 11.3612 5.86405 11.3466 5.92664 11.3193C5.98924 11.292 6.04581 11.2526 6.09312 11.2034C6.14042 11.1542 6.17751 11.0961 6.20225 11.0324C6.227 10.9688 6.2389 10.9009 6.23728 10.8327L6.11525 7.22177C6.22001 7.21068 6.32158 7.17917 6.41423 7.12903H6.41301ZM8.60955 10.7594L8.60345 7.53661C7.22573 6.74097 7.66504 3.67557 9.04276 3.69265C10.717 3.71218 10.9159 7.14733 9.47597 7.52441L9.58213 10.7753C9.60288 11.5233 8.60589 11.5929 8.60589 10.7594H8.60955ZM12.1167 2.87871C11.0474 1.81131 9.64104 1.14769 8.1373 1.00089C6.63355 0.854091 5.12543 1.2332 3.86985 2.07363C2.61427 2.91406 1.68892 4.16382 1.25144 5.60999C0.813964 7.05617 0.891424 8.60928 1.47062 10.0048C2.04983 11.4002 3.09494 12.5517 4.42791 13.263C5.76087 13.9744 7.29924 14.2015 8.78091 13.9058C10.2626 13.6101 11.5959 12.8099 12.5537 11.6414C13.5116 10.4729 14.0346 9.00846 14.0338 7.49756C14.0344 6.63932 13.8653 5.78943 13.5363 4.99676C13.2073 4.20408 12.7249 3.48427 12.1167 2.87871Z"
        fill="#7A858A"
      />
    </svg>
  );
}

export function SvgDesignationsDetails() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10"
        cy="10"
        r="10"
        fill="#3F3F51"
      />
      <path
        d="M11.1135 15.294H6.93052C6.35296 15.294 5.88477 14.8258 5.88477 14.2483V6.92801C5.88477 6.35046 6.35296 5.88226 6.93052 5.88226H14.2508C14.8283 5.88226 15.2965 6.35046 15.2965 6.92801V11.111C15.2963 11.1171 15.2952 11.123 15.2934 11.1288C15.2919 11.1336 15.2908 11.1385 15.2903 11.1434C15.2873 11.1896 15.2783 11.2351 15.2636 11.2789L15.2589 11.293C15.2554 11.3048 15.251 11.3163 15.2458 11.3275C15.2205 11.3845 15.1851 11.4364 15.1412 11.4807L11.4811 15.1408C11.3836 15.2384 11.2515 15.2934 11.1135 15.294ZM6.93052 6.92801V14.2483H10.5906V11.111C10.5906 10.8222 10.8247 10.5881 11.1135 10.5881H14.2508V6.92801H6.93052ZM11.6364 11.6339V13.5095L13.5114 11.6339H11.6364Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgPasswordNoView() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5303 1.28033C18.8232 0.987437 18.8232 0.512563 18.5303 0.21967C18.2374 -0.0732233 17.7626 -0.0732233 17.4697 0.21967L1.46967 16.2197C1.17678 16.5126 1.17678 16.9874 1.46967 17.2803C1.76256 17.5732 2.23744 17.5732 2.53033 17.2803L5.37723 14.4334C6.74353 15.0766 8.31719 15.5 10 15.5C12.684 15.5 15.0903 14.4229 16.8206 13.095C17.6874 12.4297 18.4032 11.6876 18.9089 10.9589C19.4006 10.2503 19.75 9.4727 19.75 8.75C19.75 8.0273 19.4006 7.24971 18.9089 6.54115C18.4032 5.81244 17.6874 5.07028 16.8206 4.40503C16.5585 4.20385 16.2808 4.00842 15.989 3.82163L18.5303 1.28033ZM14.8995 4.91113L13.1287 6.68196C13.5213 7.27478 13.75 7.98569 13.75 8.75C13.75 10.8211 12.0711 12.5 10 12.5C9.23569 12.5 8.52478 12.2713 7.93196 11.8787L6.51524 13.2954C7.58077 13.7295 8.76212 14 10 14C12.2865 14 14.3802 13.0771 15.9073 11.905C16.6692 11.3203 17.2714 10.6874 17.6766 10.1036C18.0957 9.49971 18.25 9.0273 18.25 8.75C18.25 8.4727 18.0957 8.00029 17.6766 7.39635C17.2714 6.81256 16.6692 6.17972 15.9073 5.59497C15.5941 5.35461 15.2571 5.12472 14.8995 4.91113ZM9.02994 10.7807C9.32366 10.9213 9.65264 11 10 11C11.2426 11 12.25 9.99264 12.25 8.75C12.25 8.40264 12.1713 8.07366 12.0307 7.77994L9.02994 10.7807Z"
        fill="#292929"
      />
      <path
        d="M10 2C11.0323 2 12.0236 2.15934 12.9511 2.43101C13.1296 2.48328 13.1827 2.70662 13.0513 2.8381L12.2267 3.66265C12.1648 3.72451 12.0752 3.74928 11.99 3.72967C11.3506 3.58257 10.6839 3.5 10 3.5C7.71345 3.5 5.61978 4.42292 4.09267 5.59497C3.33078 6.17972 2.72857 6.81256 2.32343 7.39635C1.90431 8.00029 1.75 8.4727 1.75 8.75C1.75 9.0273 1.90431 9.49971 2.32343 10.1036C2.67725 10.6135 3.18138 11.1607 3.81091 11.6807C3.92677 11.7764 3.93781 11.9515 3.83156 12.0578L3.12265 12.7667C3.03234 12.857 2.88823 12.8649 2.79037 12.7829C2.09739 12.2017 1.51902 11.5755 1.0911 10.9589C0.599371 10.2503 0.25 9.4727 0.25 8.75C0.25 8.0273 0.599371 7.24971 1.0911 6.54115C1.59681 5.81244 2.31262 5.07028 3.17941 4.40503C4.90965 3.07708 7.31598 2 10 2Z"
        fill="#292929"
      />
      <path
        d="M10 5C10.1185 5 10.2357 5.00549 10.3513 5.01624C10.5482 5.03453 10.6194 5.26991 10.4796 5.4097L9.26739 6.62196C8.61408 6.84683 8.09683 7.36408 7.87196 8.01739L6.6597 9.22965C6.51991 9.36945 6.28453 9.29818 6.26624 9.10132C6.25549 8.98566 6.25 8.86847 6.25 8.75C6.25 6.67893 7.92893 5 10 5Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgPasswordView() {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 6.75C6 4.67893 7.67893 3 9.75 3C11.8211 3 13.5 4.67893 13.5 6.75C13.5 8.82107 11.8211 10.5 9.75 10.5C7.67893 10.5 6 8.82107 6 6.75ZM9.75 4.5C8.50736 4.5 7.5 5.50736 7.5 6.75C7.5 7.99264 8.50736 9 9.75 9C10.9926 9 12 7.99264 12 6.75C12 5.50736 10.9926 4.5 9.75 4.5Z"
        fill="#292929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.07343 5.39635C1.65431 6.00029 1.5 6.4727 1.5 6.75C1.5 7.0273 1.65431 7.49971 2.07343 8.10365C2.47857 8.68744 3.08078 9.32028 3.84267 9.90503C5.36978 11.0771 7.46345 12 9.75 12C12.0365 12 14.1302 11.0771 15.6573 9.90503C16.4192 9.32028 17.0214 8.68744 17.4266 8.10365C17.8457 7.49971 18 7.0273 18 6.75C18 6.4727 17.8457 6.00029 17.4266 5.39635C17.0214 4.81256 16.4192 4.17972 15.6573 3.59497C14.1302 2.42292 12.0365 1.5 9.75 1.5C7.46345 1.5 5.36978 2.42292 3.84267 3.59497C3.08078 4.17972 2.47857 4.81256 2.07343 5.39635ZM2.92941 2.40503C4.65965 1.07708 7.06598 0 9.75 0C12.434 0 14.8403 1.07708 16.5706 2.40503C17.4374 3.07028 18.1532 3.81244 18.6589 4.54115C19.1506 5.24971 19.5 6.0273 19.5 6.75C19.5 7.4727 19.1506 8.25029 18.6589 8.95885C18.1532 9.68756 17.4374 10.4297 16.5706 11.095C14.8403 12.4229 12.434 13.5 9.75 13.5C7.06598 13.5 4.65965 12.4229 2.92941 11.095C2.06262 10.4297 1.34681 9.68756 0.841103 8.95885C0.349371 8.25029 0 7.4727 0 6.75C0 6.0273 0.349371 5.24971 0.841103 4.54115C1.34681 3.81244 2.06262 3.07028 2.92941 2.40503Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgLocationInput() {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.22094 16C5.09845 15.0425 4.058 13.9929 3.11047 12.862C1.68854 11.1637 7.85316e-07 8.63441 7.85316e-07 6.22424C-0.00125954 3.70702 1.51457 1.43713 3.84016 0.473778C6.16574 -0.489573 8.84268 0.0435046 10.6218 1.82426C11.7918 2.989 12.4471 4.57337 12.4419 6.22424C12.4419 8.63441 10.7533 11.1637 9.33141 12.862C8.38389 13.9929 7.34344 15.0425 6.22094 16ZM6.22094 3.55812C5.26843 3.55812 4.38827 4.06628 3.91202 4.89118C3.43576 5.71608 3.43576 6.7324 3.91202 7.5573C4.38827 8.3822 5.26843 8.89036 6.22094 8.89036C7.6934 8.89036 8.88706 7.69669 8.88706 6.22424C8.88706 4.75178 7.6934 3.55812 6.22094 3.55812Z"
        fill="#2E3A59"
      />
    </svg>
  );
}

export function SvgSuccess() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0814 8.67214C20.2745 8.89867 20.3736 9.19043 20.3585 9.48767C20.3434 9.78491 20.2152 10.0651 20.0002 10.2709L11.4392 18.2859C11.1651 18.523 10.8092 18.6436 10.4475 18.6219C10.0857 18.6002 9.74681 18.4379 9.50304 18.1697L6.00304 15.0435C5.88813 14.9417 5.79441 14.8182 5.72723 14.6801C5.66005 14.5421 5.62072 14.3921 5.61149 14.2388C5.60226 14.0856 5.62331 13.932 5.67344 13.7868C5.72356 13.6417 5.80179 13.5078 5.90364 13.3929C6.00549 13.278 6.12898 13.1843 6.26705 13.1171C6.40513 13.0499 6.55508 13.0106 6.70835 13.0014C6.86163 12.9922 7.01522 13.0132 7.16035 13.0633C7.30549 13.1135 7.43933 13.1917 7.55424 13.2935L10.6692 15.9297L18.463 8.57974C18.6921 8.38228 18.989 8.28153 19.2909 8.29877C19.5929 8.31601 19.8763 8.44988 20.0814 8.67214Z"
        fill="#45BF55"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0057 2.50959C10.929 2.50959 8.8989 3.1254 7.17219 4.27916C5.44547 5.43291 4.09966 7.07279 3.30494 8.99141C2.51022 10.91 2.30228 13.0212 2.70743 15.058C3.11257 17.0948 4.1126 18.9658 5.58105 20.4342C7.0495 21.9027 8.92043 22.9027 10.9572 23.3078C12.994 23.713 15.1052 23.505 17.0239 22.7103C18.9425 21.9156 20.5824 20.5698 21.7361 18.8431C22.8899 17.1164 23.5057 15.0863 23.5057 13.0096C23.5057 11.6307 23.2341 10.2653 22.7064 8.99141C22.1787 7.71749 21.4053 6.55998 20.4303 5.58497C19.4553 4.60995 18.2978 3.83653 17.0239 3.30885C15.7499 2.78118 14.3846 2.50959 13.0057 2.50959ZM0.171875 13.0096C0.171875 10.4713 0.924564 7.99002 2.33476 5.87951C3.74496 3.769 5.74932 2.12406 8.09439 1.1527C10.4395 0.181342 13.0199 -0.0728101 15.5094 0.422385C17.9989 0.91758 20.2857 2.13988 22.0805 3.93472C23.8754 5.72956 25.0977 8.01632 25.5929 10.5058C26.0881 12.9953 25.8339 15.5758 24.8626 17.9209C23.8912 20.2659 22.2463 22.2703 20.1358 23.6805C18.0252 25.0907 15.544 25.8434 13.0057 25.8434C9.60194 25.8434 6.33761 24.4913 3.93081 22.0845C1.524 19.6776 0.171875 16.4133 0.171875 13.0096Z"
        fill="#45BF55"
      />
    </svg>
  );
}

export function SvgNotifWarning() {
  return (
    <svg
      width="28"
      height="23"
      viewBox="0 0 28 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.571 9.54994C12.571 9.30275 12.6696 9.06569 12.845 8.8909C13.0204 8.71611 13.2583 8.61792 13.5064 8.61792C13.7544 8.61792 13.9923 8.71611 14.1677 8.8909C14.3431 9.06569 14.4417 9.30275 14.4417 9.54994V15.0705C14.4417 15.3177 14.3431 15.5547 14.1677 15.7295C13.9923 15.9043 13.7544 16.0025 13.5064 16.0025C13.2583 16.0025 13.0204 15.9043 12.845 15.7295C12.6696 15.5547 12.571 15.3177 12.571 15.0705V9.54994Z"
        fill="#FFB201"
      />
      <path
        d="M13.5062 19.3287C14.152 19.3287 14.6755 18.8071 14.6755 18.1636C14.6755 17.5201 14.152 16.9984 13.5062 16.9984C12.8604 16.9984 12.3369 17.5201 12.3369 18.1636C12.3369 18.8071 12.8604 19.3287 13.5062 19.3287Z"
        fill="#FFB201"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7267 3.5041C13.7064 3.46894 13.6748 3.43932 13.6355 3.4186C13.5962 3.39788 13.5508 3.38689 13.5045 3.38689C13.4582 3.38689 13.4129 3.39788 13.3736 3.4186C13.3343 3.43932 13.3027 3.46894 13.2823 3.5041L3.24388 20.6505C3.22488 20.6824 3.21589 20.718 3.21778 20.7537C3.21966 20.7895 3.23236 20.8242 3.25465 20.8546C3.27694 20.885 3.30808 20.9101 3.34509 20.9274C3.38211 20.9447 3.42376 20.9537 3.46607 20.9536H23.6511C23.6934 20.9537 23.7351 20.9447 23.7721 20.9274C23.8091 20.9101 23.8403 20.885 23.8626 20.8546C23.8849 20.8242 23.8975 20.7895 23.8994 20.7537C23.9013 20.718 23.8923 20.6824 23.8733 20.6505L13.7267 3.5041ZM12.1714 0.696258C12.294 0.487191 12.4831 0.311227 12.7176 0.188206C12.9522 0.0651852 13.2226 0 13.4986 0C13.7746 0 14.0451 0.0651852 14.2796 0.188206C14.5141 0.311227 14.7033 0.487191 14.8258 0.696258L26.9721 21.2253C27.0748 21.4145 27.1201 21.6224 27.1039 21.8301C27.0878 22.0378 27.0106 22.2388 26.8794 22.4149C26.7483 22.5911 26.5673 22.7368 26.3528 22.839C26.1382 22.9411 25.897 22.9965 25.6508 23H1.48119C1.22883 23.0017 0.980204 22.9484 0.759266 22.8453C0.538328 22.7422 0.352526 22.5927 0.219763 22.4112C0.0870002 22.2297 0.0117518 22.0224 0.00126853 21.8092C-0.00921478 21.5961 0.0454203 21.3842 0.159909 21.194L12.1714 0.696258Z"
        fill="#FFB201"
      />
    </svg>
  );
}

export function SvgBtnCloseWarning() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="25"
        height="25"
        rx="12.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="25"
        height="25"
        rx="12.5"
        fill="#FFB201"
      />
      <rect
        x="0.5"
        y="0.5"
        width="25"
        height="25"
        rx="12.5"
        stroke="#FFB201"
      />
      <path
        d="M9.53349 10.2577L9.63956 10.1517L9.53349 10.2577L12.4317 13.1559L9.53349 16.0541C9.33327 16.2543 9.33327 16.5782 9.53349 16.7785C9.63333 16.8783 9.76469 16.9285 9.89568 16.9285C10.0267 16.9285 10.158 16.8783 10.2579 16.7785L13.156 13.8803L16.0542 16.7785C16.154 16.8783 16.2854 16.9285 16.4164 16.9285C16.5474 16.9285 16.6787 16.8783 16.7786 16.7785C16.9788 16.5782 16.9788 16.2543 16.7786 16.0541L13.8804 13.1559L16.7786 10.2577C16.9788 10.0575 16.9788 9.73359 16.7786 9.53337C16.5784 9.33315 16.2544 9.33315 16.0542 9.53337L13.156 12.4315L10.2579 9.53337C10.0576 9.33315 9.73372 9.33315 9.53349 9.53337C9.33327 9.73359 9.33327 10.0575 9.53349 10.2577Z"
        fill="white"
        stroke="white"
        strokeWidth="0.3"
      />
    </svg>
  );
}

export function SvgBtnClose() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="14.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="14.5"
        fill="#45BF55"
      />
      <rect
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="14.5"
        stroke="#328B3E"
      />
      <path
        d="M20.0257 9.97385C19.8233 9.77141 19.4961 9.77141 19.2936 9.97385L14.9999 14.2676L10.7062 9.97385C10.5038 9.77141 10.1765 9.77141 9.9741 9.97385C9.77166 10.1763 9.77166 10.5035 9.9741 10.706L14.2678 14.9997L9.9741 19.2934C9.77166 19.4958 9.77166 19.823 9.9741 20.0255C10.0751 20.1264 10.2076 20.1772 10.3401 20.1772C10.4727 20.1772 10.6052 20.1264 10.7062 20.0255L14.9999 15.7318L19.2936 20.0255C19.3946 20.1264 19.5271 20.1772 19.6597 20.1772C19.7922 20.1772 19.9248 20.1264 20.0257 20.0255C20.2282 19.823 20.2282 19.4958 20.0257 19.2934L15.732 14.9997L20.0257 10.706C20.2282 10.5035 20.2282 10.1763 20.0257 9.97385Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgBtnCloseRed() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="14.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="14.5"
        fill="#FF7868"
      />
      <rect
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="14.5"
        stroke="#CC3638"
      />
      <path
        d="M20.0257 9.9741C19.8233 9.77166 19.4961 9.77166 19.2936 9.9741L14.9999 14.2678L10.7062 9.9741C10.5038 9.77166 10.1765 9.77166 9.9741 9.9741C9.77166 10.1765 9.77166 10.5038 9.9741 10.7062L14.2678 14.9999L9.9741 19.2936C9.77166 19.4961 9.77166 19.8233 9.9741 20.0257C10.0751 20.1267 10.2076 20.1774 10.3401 20.1774C10.4727 20.1774 10.6052 20.1267 10.7062 20.0257L14.9999 15.732L19.2936 20.0257C19.3946 20.1267 19.5271 20.1774 19.6597 20.1774C19.7922 20.1774 19.9248 20.1267 20.0257 20.0257C20.2282 19.8233 20.2282 19.4961 20.0257 19.2936L15.732 14.9999L20.0257 10.7062C20.2282 10.5038 20.2282 10.1765 20.0257 9.9741Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgBlueBtnClose() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="14.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="14.5"
        fill="#1170FF"
      />
      <rect
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="14.5"
        stroke="#1D4E98"
      />
      <path
        d="M20.0257 9.97385C19.8233 9.77141 19.4961 9.77141 19.2936 9.97385L14.9999 14.2676L10.7062 9.97385C10.5038 9.77141 10.1765 9.77141 9.9741 9.97385C9.77166 10.1763 9.77166 10.5035 9.9741 10.706L14.2678 14.9997L9.9741 19.2934C9.77166 19.4958 9.77166 19.823 9.9741 20.0255C10.0751 20.1264 10.2076 20.1772 10.3401 20.1772C10.4727 20.1772 10.6052 20.1264 10.7062 20.0255L14.9999 15.7318L19.2936 20.0255C19.3946 20.1264 19.5271 20.1772 19.6597 20.1772C19.7922 20.1772 19.9248 20.1264 20.0257 20.0255C20.2282 19.823 20.2282 19.4958 20.0257 19.2934L15.732 14.9997L20.0257 10.706C20.2282 10.5035 20.2282 10.1763 20.0257 9.97385Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgWarning() {
  return (
    <svg
      width="30"
      height="26"
      viewBox="0 0 30 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9131 10.5705C13.9131 10.297 14.0221 10.0346 14.2163 9.84118C14.4104 9.64774 14.6737 9.53906 14.9482 9.53906C15.2228 9.53906 15.4861 9.64774 15.6802 9.84118C15.8743 10.0346 15.9834 10.297 15.9834 10.5705V16.6803C15.9834 16.9538 15.8743 17.2162 15.6802 17.4096C15.4861 17.6031 15.2228 17.7117 14.9482 17.7117C14.6737 17.7117 14.4104 17.6031 14.2163 17.4096C14.0221 17.2162 13.9131 16.9538 13.9131 16.6803V10.5705Z"
        fill="#F60A20"
      />
      <path
        d="M14.9474 21.3905C15.6621 21.3905 16.2415 20.8132 16.2415 20.101C16.2415 19.3889 15.6621 18.8115 14.9474 18.8115C14.2327 18.8115 13.6533 19.3889 13.6533 20.101C13.6533 20.8132 14.2327 21.3905 14.9474 21.3905Z"
        fill="#F60A20"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1916 3.87806C15.1691 3.83915 15.1341 3.80636 15.0907 3.78343C15.0472 3.7605 14.997 3.74834 14.9457 3.74834C14.8945 3.74834 14.8443 3.7605 14.8008 3.78343C14.7573 3.80636 14.7224 3.83915 14.6998 3.87806L3.59007 22.8543C3.56904 22.8897 3.55909 22.929 3.56118 22.9686C3.56326 23.0081 3.57731 23.0466 3.60198 23.0802C3.62665 23.1139 3.66111 23.1416 3.70208 23.1608C3.74305 23.1799 3.78914 23.1899 3.83597 23.1897H26.1752C26.222 23.1899 26.2681 23.1799 26.3091 23.1608C26.35 23.1416 26.3845 23.1139 26.4092 23.0802C26.4338 23.0466 26.4479 23.0081 26.45 22.9686C26.4521 22.929 26.4421 22.8897 26.4211 22.8543L15.1916 3.87806ZM13.4703 0.770562C13.606 0.539184 13.8153 0.344441 14.0749 0.208291C14.3344 0.0721417 14.6338 0 14.9392 0C15.2446 0 15.544 0.0721417 15.8035 0.208291C16.063 0.344441 16.2724 0.539184 16.408 0.770562L29.8506 23.4905C29.9642 23.6999 30.0144 23.9299 29.9965 24.1598C29.9786 24.3896 29.8932 24.6121 29.748 24.8071C29.6029 25.002 29.4025 25.1633 29.1651 25.2763C28.9277 25.3894 28.6607 25.4506 28.3883 25.4545H1.63926C1.35997 25.4564 1.08481 25.3974 0.840294 25.2833C0.595778 25.1692 0.390147 25.0037 0.243216 24.8029C0.0962848 24.6021 0.013006 24.3727 0.0014039 24.1367C-0.0101982 23.9008 0.0502676 23.6663 0.176975 23.4558L13.4703 0.770562Z"
        fill="#F60A20"
      />
    </svg>
  );
}

export function SvgIconInfo() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 1.24948C12.2804 1.24948 9.62191 2.05593 7.36065 3.56686C5.09939 5.07778 3.33695 7.22532 2.29621 9.73789C1.25547 12.2505 0.983164 15.0152 1.51373 17.6826C2.0443 20.3499 3.3539 22.8 5.27695 24.7231C7.19999 26.6461 9.65009 27.9557 12.3174 28.4863C14.9848 29.0168 17.7495 28.7445 20.2621 27.7038C22.7747 26.663 24.9222 24.9006 26.4331 22.6393C27.9441 20.3781 28.7505 17.7196 28.7505 15C28.7505 13.1942 28.3948 11.4062 27.7038 9.73789C27.0128 8.0696 25.9999 6.55376 24.7231 5.27691C23.4462 4.00006 21.9304 2.9872 20.2621 2.29618C18.5938 1.60515 16.8058 1.24948 15 1.24948ZM15 26.25C12.775 26.25 10.5999 25.5902 8.74985 24.354C6.8998 23.1178 5.45786 21.3608 4.60637 19.3052C3.75489 17.2495 3.5321 14.9875 3.96618 12.8052C4.40027 10.6229 5.47172 8.61837 7.04507 7.04503C8.61841 5.47169 10.623 4.40023 12.8053 3.96615C14.9875 3.53206 17.2495 3.75485 19.3052 4.60634C21.3609 5.45782 23.1179 6.89976 24.354 8.74982C25.5902 10.5999 26.25 12.7749 26.25 15C26.25 16.4774 25.959 17.9403 25.3937 19.3052C24.8283 20.6701 23.9996 21.9103 22.955 22.9549C21.9103 23.9996 20.6701 24.8283 19.3052 25.3936C17.9403 25.959 16.4774 26.25 15 26.25Z"
        fill="#0066FF"
      />
      <path
        d="M15 21.249C14.6687 21.2486 14.3511 21.1168 14.1169 20.8826C13.8827 20.6483 13.7509 20.3308 13.7505 19.9995V13.536C13.7505 13.2044 13.8822 12.8864 14.1167 12.6519C14.3511 12.4175 14.6692 12.2857 15.0007 12.2857C15.3323 12.2857 15.6503 12.4175 15.8848 12.6519C16.1193 12.8864 16.251 13.2044 16.251 13.536V19.998C16.251 20.3298 16.1192 20.648 15.8846 20.8826C15.65 21.1172 15.3318 21.249 15 21.249Z"
        fill="#0066FF"
      />
      <path
        d="M15 11.304C14.8383 11.3107 14.6769 11.2846 14.5256 11.2273C14.3742 11.17 14.236 11.0827 14.1193 10.9706C14.0026 10.8585 13.9097 10.7239 13.8463 10.575C13.783 10.4261 13.7504 10.2659 13.7505 10.104V9.99753C13.7505 9.66595 13.8822 9.34794 14.1167 9.11347C14.3511 8.87901 14.6692 8.74728 15.0007 8.74728C15.3323 8.74728 15.6503 8.87901 15.8848 9.11347C16.1193 9.34794 16.251 9.66595 16.251 9.99753C16.2536 10.3353 16.1243 10.6607 15.8907 10.9047C15.6571 11.1487 15.3375 11.2919 15 11.304Z"
        fill="#0066FF"
      />
    </svg>
  );
}

export function SvgNewUserRecrutement(color) {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33186 6.70246C7.16824 6.70246 8.64028 5.21137 8.64028 3.35123C8.64028 1.49109 7.16824 0 5.33186 0C3.49548 0 2.02344 1.49109 2.02344 3.35123C2.02344 5.21137 3.49548 6.70246 5.33186 6.70246ZM5.33203 8.34375C2.63485 8.34375 0.332031 8.77499 0.332031 10.4979C0.332031 12.2202 2.62083 12.667 5.33203 12.667C8.02855 12.667 10.332 12.2357 10.332 10.5128C10.332 8.78986 8.04323 8.34375 5.33203 8.34375ZM12.2627 4.72492H13.0647C13.3949 4.72492 13.6641 4.99788 13.6641 5.33266C13.6641 5.66744 13.3949 5.9404 13.0647 5.9404H12.2627V6.72526C12.2627 7.06004 11.9942 7.33301 11.6634 7.33301C11.3332 7.33301 11.0641 7.06004 11.0641 6.72526V5.9404H10.2634C9.93256 5.9404 9.66406 5.66744 9.66406 5.33266C9.66406 4.99788 9.93256 4.72492 10.2634 4.72492H11.0641V3.94075C11.0641 3.60597 11.3332 3.33301 11.6634 3.33301C11.9942 3.33301 12.2627 3.60597 12.2627 3.94075V4.72492Z"
        fill={color}
      />
    </svg>
  );
}

export function SvgSalaireInParcours() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <mask
        id="mask0_828_2652"
        style={{maskType:"alpha"}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="3"
        width="17"
        height="15"
      > */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00195312 3.88086H16.7526V17.7201H0.00195312V3.88086Z"
        fill="white"
      />
      {/* </mask> */}
      <g mask="url(#mask0_828_2652)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.03483 5.16397C3.65767 5.16397 2.39704 5.3162 2.03527 7.26958L1.37503 12.401C1.16036 13.8404 1.32628 14.8821 1.86936 15.5124C2.40559 16.135 3.36518 16.4378 4.80199 16.4378H11.9416C12.8379 16.4378 14.0617 16.259 14.8006 15.4055C15.3873 14.729 15.5892 13.7215 15.401 12.4104L14.7348 7.23451C14.4508 5.95934 13.7016 5.16397 12.7404 5.16397H4.03483ZM11.9416 17.7204H4.80203C2.96925 17.7204 1.69237 17.2714 0.897847 16.3486C0.0999048 15.4232 -0.166931 14.0352 0.105036 12.2238L0.768705 7.07006C1.20488 4.70702 2.79991 3.88086 4.03488 3.88086H12.7404C13.9805 3.88086 15.4883 4.70446 15.9972 7.01447L16.672 12.2374C16.914 13.9231 16.6112 15.2753 15.7705 16.2451C14.9341 17.2098 13.6102 17.7204 11.9416 17.7204Z"
          fill="black"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0587 4.97752C11.7046 4.97752 11.4173 4.69015 11.4173 4.33608C11.4173 2.65211 10.0472 1.28287 8.36405 1.28287H8.35122C7.54644 1.28287 6.76218 1.607 6.19344 2.17232C5.62214 2.74105 5.29458 3.53044 5.29458 4.33608C5.29458 4.69015 5.00722 4.97752 4.65315 4.97752C4.29908 4.97752 4.01172 4.69015 4.01172 4.33608C4.01172 3.19091 4.47697 2.0714 5.28774 1.26319C6.09595 0.460121 7.21033 0 8.34866 0H8.36662C10.7553 0 12.7001 1.94482 12.7001 4.33608C12.7001 4.69015 12.4128 4.97752 12.0587 4.97752Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9005 8.82974H10.8612C10.5071 8.82974 10.2197 8.54238 10.2197 8.18831C10.2197 7.83424 10.5071 7.54688 10.8612 7.54688C11.2152 7.54688 11.5223 7.83424 11.5223 8.18831C11.5223 8.54238 11.2546 8.82974 10.9005 8.82974Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.91332 8.82974H5.87483C5.52076 8.82974 5.2334 8.54238 5.2334 8.18831C5.2334 7.83424 5.52076 7.54688 5.87483 7.54688C6.2289 7.54688 6.53593 7.83424 6.53593 8.18831C6.53593 8.54238 6.26739 8.82974 5.91332 8.82974Z"
        fill="black"
      />
    </svg>
  );
}

export function SvgViewDetails() {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7C6 4.92893 7.67893 3.25 9.75 3.25C11.8211 3.25 13.5 4.92893 13.5 7C13.5 9.07107 11.8211 10.75 9.75 10.75C7.67893 10.75 6 9.07107 6 7ZM9.75 4.75C8.50736 4.75 7.5 5.75736 7.5 7C7.5 8.24264 8.50736 9.25 9.75 9.25C10.9926 9.25 12 8.24264 12 7C12 5.75736 10.9926 4.75 9.75 4.75Z"
        fill="#292929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.07343 5.64635C1.65431 6.25029 1.5 6.7227 1.5 7C1.5 7.2773 1.65431 7.74971 2.07343 8.35365C2.47857 8.93744 3.08078 9.57028 3.84267 10.155C5.36978 11.3271 7.46345 12.25 9.75 12.25C12.0365 12.25 14.1302 11.3271 15.6573 10.155C16.4192 9.57028 17.0214 8.93744 17.4266 8.35365C17.8457 7.74971 18 7.2773 18 7C18 6.7227 17.8457 6.25029 17.4266 5.64635C17.0214 5.06256 16.4192 4.42972 15.6573 3.84497C14.1302 2.67292 12.0365 1.75 9.75 1.75C7.46345 1.75 5.36978 2.67292 3.84267 3.84497C3.08078 4.42972 2.47857 5.06256 2.07343 5.64635ZM2.92941 2.65503C4.65965 1.32708 7.06598 0.25 9.75 0.25C12.434 0.25 14.8403 1.32708 16.5706 2.65503C17.4374 3.32028 18.1532 4.06244 18.6589 4.79115C19.1506 5.49971 19.5 6.2773 19.5 7C19.5 7.7227 19.1506 8.50029 18.6589 9.20885C18.1532 9.93756 17.4374 10.6797 16.5706 11.345C14.8403 12.6729 12.434 13.75 9.75 13.75C7.06598 13.75 4.65965 12.6729 2.92941 11.345C2.06262 10.6797 1.34681 9.93756 0.841103 9.20885C0.349371 8.50029 0 7.7227 0 7C0 6.2773 0.349371 5.49971 0.841103 4.79115C1.34681 4.06244 2.06262 3.32028 2.92941 2.65503Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgEditColor() {
  return (
    <svg
      width="17"
      height="22"
      viewBox="0 0 17 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9996 2.25168C16.9996 1.64997 16.7653 1.08423 16.3398 0.658744C15.4615 -0.219517 14.0323 -0.219646 13.1539 0.658744L10.9838 2.82881L9.99858 1.84355C9.83074 1.67575 9.55875 1.67575 9.39086 1.84355L8.10177 3.13265C7.93397 3.30044 7.93397 3.57253 8.10177 3.74037L9.08702 4.72563L2.87169 10.941C2.82451 10.9881 2.78897 11.0456 2.76787 11.1089L2.37027 12.3018L2.01229 12.6598C1.37092 13.3012 1.37088 14.3448 2.01229 14.9863C2.6537 15.6277 3.69736 15.6276 4.33877 14.9863L4.69675 14.6283L5.88959 14.2307C5.95289 14.2096 6.01038 14.1741 6.05756 14.1269L12.2729 7.9115L13.2582 8.89675C13.426 9.06455 13.6981 9.06455 13.8659 8.89675L15.155 7.60766C15.3228 7.43986 15.3228 7.16778 15.155 6.99993L14.1698 6.01468L16.3398 3.84461C16.7653 3.41913 16.9996 2.85343 16.9996 2.25168ZM9.08702 9.88197H5.14604L9.69475 5.33331L11.6652 7.30377L9.08702 9.88197ZM13.562 7.98519L9.01333 3.43649L9.6947 2.75507L14.2434 7.30377L13.562 7.98519ZM15.7321 3.23694L13.562 5.407L11.5915 3.43649L13.7616 1.26642C14.3049 0.723156 15.1889 0.723113 15.7321 1.26642C16.2727 1.78507 16.2726 2.71829 15.7321 3.23694Z"
        fill="#292929"
      />
      <path
        d="M2.57818 15.9844C2.43702 15.9844 2.30485 16.0537 2.22462 16.1698C1.92487 16.6038 0.429688 18.8206 0.429688 19.8517C0.429688 21.0363 1.3935 22.0002 2.57818 22.0002C3.76286 22.0002 4.72667 21.0363 4.72667 19.8517C4.72667 18.8206 3.23149 16.6038 2.93174 16.1698C2.85151 16.0537 2.71934 15.9844 2.57818 15.9844ZM2.57818 21.1408C1.86737 21.1408 1.28908 20.5625 1.28908 19.8517C1.28908 19.3823 1.95972 18.1575 2.57818 17.1911C3.19665 18.1575 3.86728 19.3823 3.86728 19.8517C3.86728 20.5625 3.28899 21.1408 2.57818 21.1408Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgGreyDelete() {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="17.5"
        cy="17.5"
        r="17.5"
        fill="#F5F6F8"
      />
      <path
        d="M13.3049 22.4327C13.3061 22.8188 13.4501 23.1887 13.7054 23.4617C13.9607 23.7347 14.3066 23.8887 14.6677 23.89H20.1206C20.4825 23.89 20.8296 23.7367 21.0859 23.4635C21.3422 23.1903 21.4869 22.8196 21.4881 22.4327V13.6853H13.3049V22.4327ZM22.1652 11.4987H19.7792L19.0983 10.7695H15.69L15.0091 11.4987H12.623V12.9561H22.1652V11.4987Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function SvgMicrosoft() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 21"
    >
      <path
        fill="#f35325"
        d="M0 0h10v10H0z"
      />
      <path
        fill="#81bc06"
        d="M11 0h10v10H11z"
      />
      <path
        fill="#05a6f0"
        d="M0 11h10v10H0z"
      />
      <path
        fill="#ffba08"
        d="M11 11h10v10H11z"
      />
    </svg>
  );
}

export function SvgGoogle() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.3443 12.7489C23.3443 11.7771 23.2579 11.0645 23.0852 10.3086H11.8984V14.7358H18.4636C18.3341 15.8372 17.6214 17.4785 16.0233 18.6015L16.0017 18.7526L19.5434 21.4953L19.781 21.5169C22.0486 19.4437 23.3443 16.3771 23.3443 12.7489Z"
        fill="#4877BB"
      />
      <path
        d="M11.8987 24.4088C15.1165 24.4088 17.816 23.3506 19.7812 21.515L16.0235 18.5995C15.0085 19.2906 13.6696 19.7873 11.8987 19.7873C8.74567 19.7873 6.06776 17.7141 5.11753 14.8418L4.98796 14.8634L1.31663 17.7141L1.27344 17.8436C3.21708 21.7309 7.23394 24.4088 11.8987 24.4088Z"
        fill="#21A849"
      />
      <path
        d="M5.11826 14.8428C4.85911 14.1086 4.72953 13.3095 4.72953 12.4889C4.72953 11.6682 4.88071 10.8692 5.11826 10.1349V9.98372L1.40374 7.08984L1.27416 7.15464C0.475111 8.77434 0 10.5884 0 12.5104C0 14.4325 0.453515 16.2466 1.27416 17.8663L5.11826 14.8428Z"
        fill="#FBBA10"
      />
      <path
        d="M11.8988 5.1898C14.1448 5.1898 15.6349 6.16162 16.4987 6.96067L19.8677 3.67807C17.7945 1.75603 15.1166 0.589844 11.8988 0.589844C7.23405 0.589844 3.21719 3.26775 1.25195 7.15504L5.09604 10.1569C6.06787 7.26301 8.74577 5.1898 11.8988 5.1898Z"
        fill="#E73830"
      />
    </svg>
  );
}

export function SvgBackArrow() {
  return (
    <svg
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1882 3.8207L2.45193 3.8207L5.26185 1.15896C5.54284 0.89279 5.54284 0.465803 5.26185 0.19963C5.12135 0.0665428 4.93988 -7.84036e-07 4.75255 -8.00412e-07C4.56523 -8.16789e-07 4.38375 0.0665427 4.24326 0.19963L0.209853 4.02033C-0.0711389 4.28651 -0.071139 4.71349 0.209853 4.97967L4.24326 8.80037C4.52425 9.06654 4.975 9.06654 5.256 8.80037C5.53699 8.5342 5.53699 8.10721 5.256 7.84103L2.44608 5.1793L13.1882 5.1793C13.5862 5.1793 13.9082 4.87431 13.9082 4.49723C13.9082 4.12015 13.5862 3.8207 13.1882 3.8207Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgOrangeCroix() {
  return (
    <svg
      width="39"
      height="39"
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="38"
        height="38"
        rx="19"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="38"
        height="38"
        rx="19"
        fill="#FCB698"
      />
      <rect
        x="0.5"
        y="0.5"
        width="38"
        height="38"
        rx="19"
        stroke="#FA966B"
      />
      <path
        d="M26.0339 12.9664C25.7708 12.7032 25.3454 12.7032 25.0822 12.9664L19.5004 18.5482L13.9186 12.9664C13.6555 12.7032 13.2301 12.7032 12.9669 12.9664C12.7037 13.2295 12.7037 13.6549 12.9669 13.9181L18.5487 19.4999L12.9669 25.0817C12.7037 25.3449 12.7037 25.7703 12.9669 26.0335C13.0982 26.1647 13.2705 26.2307 13.4428 26.2307C13.6151 26.2307 13.7874 26.1647 13.9186 26.0335L19.5004 20.4516L25.0822 26.0335C25.2135 26.1647 25.3858 26.2307 25.5581 26.2307C25.7304 26.2307 25.9027 26.1647 26.0339 26.0335C26.2971 25.7703 26.2971 25.3449 26.0339 25.0817L20.4522 19.4999L26.0339 13.9181C26.2971 13.6549 26.2971 13.2295 26.0339 12.9664Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgCalendarHour() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2939 2.85234C16.0403 2.60656 15.7394 2.48366 15.3921 2.48366H14.1095V1.55227C14.1095 1.12548 13.9524 0.760028 13.6385 0.456044C13.3243 0.15206 12.9471 0 12.506 0H11.8648C11.4238 0 11.0464 0.15206 10.7324 0.456078C10.4183 0.760028 10.2613 1.12552 10.2613 1.5523V2.48369H6.41353V1.5523C6.41353 1.12552 6.25646 0.760062 5.94244 0.456078C5.62849 0.15206 5.25104 0 4.81003 0H4.16875C3.72785 0 3.35037 0.15206 3.03634 0.456078C2.72239 0.760028 2.56529 1.12552 2.56529 1.5523V2.48369H1.28273C0.935262 2.48369 0.634681 2.6066 0.380815 2.85237C0.12695 3.09811 0 3.38925 0 3.72555V16.1436C0 16.4797 0.12695 16.7707 0.380815 17.0166C0.634645 17.2624 0.935227 17.3853 1.28273 17.3853H15.3918C15.7392 17.3853 16.0401 17.2624 16.2936 17.0166C16.5475 16.7708 16.6745 16.4796 16.6745 16.1436V3.72552C16.6745 3.38912 16.5476 3.09811 16.2939 2.85234ZM11.5442 1.5524C11.5442 1.46178 11.574 1.38733 11.634 1.32926C11.6941 1.27112 11.7709 1.242 11.8646 1.242H12.5058C12.5995 1.242 12.6761 1.27102 12.7364 1.32926C12.7965 1.38743 12.8265 1.46188 12.8265 1.5524V4.34636C12.8265 4.43695 12.7965 4.51127 12.7364 4.56951C12.6761 4.62758 12.5995 4.65677 12.5058 4.65677H11.8646C11.7709 4.65677 11.6941 4.62772 11.634 4.56951C11.574 4.51124 11.5442 4.43695 11.5442 4.34636V1.5524ZM3.84813 1.5524C3.84813 1.46178 3.87814 1.38733 3.93826 1.32926C3.99842 1.27112 4.07518 1.242 4.16875 1.242H4.81003C4.90364 1.242 4.98054 1.27102 5.04052 1.32926C5.10057 1.38743 5.13072 1.46188 5.13072 1.5524V4.34636C5.13072 4.43695 5.10071 4.51137 5.04052 4.56951C4.9804 4.62758 4.90364 4.65677 4.81003 4.65677H4.16875C4.07518 4.65677 3.99832 4.62772 3.93826 4.56951C3.87828 4.51124 3.84813 4.43695 3.84813 4.34636V1.5524ZM15.3918 16.1434H1.28273V6.20907H15.3918V16.1434Z"
        fill="#FA966B"
      />
      <rect
        x="2.15234"
        y="7.72681"
        width="3.59149"
        height="3.09071"
        fill="#FA966B"
      //FA966B
      />
      <rect
        x="6.54199"
        y="7.72681"
        width="3.59149"
        height="3.09071"
        fill="#FA966B"
      />
      <rect
        x="10.9307"
        y="7.72681"
        width="3.59149"
        height="3.09071"
        fill="#FA966B"
      />
      <rect
        x="2.15234"
        y="11.5901"
        width="3.59149"
        height="3.09071"
        fill="#FA966B"
      />
      <rect
        x="6.54199"
        y="11.5901"
        width="3.59149"
        height="3.09071"
        fill="#FA966B"
      />
      <rect
        x="10.9307"
        y="11.5901"
        width="3.59149"
        height="3.09071"
        fill="#FA966B"
      />
    </svg>
  );
}

export function SvgCalendarBlack() {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 20H2C0.89543 20 0 19.1046 0 18V4C0 2.89543 0.89543 2 2 2H4V0H6V2H12V0H14V2H16C17.1046 2 18 2.89543 18 4V18C18 19.1046 17.1046 20 16 20ZM2 8V18H16V8H2ZM2 4V6H16V4H2ZM14 16H12V14H14V16ZM10 16H8V14H10V16ZM6 16H4V14H6V16ZM14 12H12V10H14V12ZM10 12H8V10H10V12ZM6 12H4V10H6V12Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgHourBlack() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.88095 20C4.42385 20 0 15.5228 0 10C0 4.47715 4.42385 0 9.88095 0C15.338 0 19.7619 4.47715 19.7619 10C19.7559 15.5203 15.3356 19.9939 9.88095 20ZM9.88095 2C5.51527 2 1.97619 5.58172 1.97619 10C1.97619 14.4183 5.51527 18 9.88095 18C14.2466 18 17.7857 14.4183 17.7857 10C17.7808 5.58378 14.2446 2.00496 9.88095 2ZM14.8214 11H8.89285V5H10.869V9H14.8214V11Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgCreateHour() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99967 3.21332C5.8043 3.21332 3.21387 5.80352 3.21387 8.99871C3.21387 12.1945 5.8043 14.7849 8.99967 14.7849C12.1949 14.7849 14.7853 12.1945 14.7853 8.99871C14.7853 5.80352 12.1949 3.21332 8.99967 3.21332ZM12.0871 9.75002H8.99967C8.59391 9.75002 8.24877 9.40489 8.24877 8.9989V4.7511C8.24877 4.34537 8.59391 4.01645 8.99967 4.01645C9.40547 4.01645 9.75061 4.34533 9.75061 4.7511V8.24818H12.0871C12.4927 8.24818 12.822 8.59336 12.822 8.99894C12.8219 9.40489 12.4927 9.75002 12.0871 9.75002Z"
        fill="#FA966B"
      />
      <path
        d="M8.99998 0C4.03755 0 0 4.03737 0 8.99998C0 13.9623 4.03755 17.9996 8.99998 17.9996C13.9624 17.9996 18 13.9622 18 8.99998C18 4.03737 13.9624 0 8.99998 0ZM8.99998 15.9485C5.16842 15.9485 2.05089 12.8314 2.05089 8.99998C2.05089 5.1682 5.16842 2.05093 8.99998 2.05093C12.8316 2.05093 15.9489 5.16823 15.9489 8.99998C15.9489 12.8314 12.8316 15.9485 8.99998 15.9485Z"
        fill="#FA966B"
      />
    </svg>
  );
}

export function SvgDeleteEtiquetteCandidate() {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.8875 4.5L1.13125 1.74375C0.95625 1.56875 0.95625 1.30625 1.13125 1.13125C1.30625 0.95625 1.56875 0.95625 1.74375 1.13125L4.5 3.8875L7.25625 1.13125C7.43125 0.95625 7.69375 0.95625 7.86875 1.13125C8.04375 1.30625 8.04375 1.56875 7.86875 1.74375L5.1125 4.5L7.86875 7.25625C8.04375 7.43125 8.04375 7.69375 7.86875 7.86875C7.69375 8.04375 7.43125 8.04375 7.25625 7.86875L4.5 5.1125L1.74375 7.86875C1.56875 8.04375 1.30625 8.04375 1.13125 7.86875C0.95625 7.69375 0.95625 7.43125 1.13125 7.25625L3.8875 4.5Z"
        fill="#525451"
        stroke="#525451"
        strokeWidth="0.5"
      />
    </svg>
  );
}

/* New design tailwindcss */

// Form Group : les champs avec les input
export function Loupe() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.585 17.3039L9.87 11.5879C7.32767 13.3954 3.82444 12.9533 1.81087 10.5708C-0.202691 8.18843 -0.0548406 4.66051 2.151 2.45492C4.35626 0.248366 7.88453 0.0998755 10.2674 2.11333C12.6503 4.12679 13.0926 7.63037 11.285 10.1729L17 15.8889L15.586 17.3029L15.585 17.3039ZM6.393 2.6969C4.4967 2.69648 2.86069 4.02759 2.47547 5.88435C2.09026 7.74111 3.06171 9.61319 4.80168 10.3672C6.54164 11.1211 8.5719 10.5497 9.66324 8.99897C10.7546 7.44819 10.6071 5.34423 9.31 3.96092L9.915 4.56092L9.233 3.88092L9.221 3.86892C8.47279 3.1161 7.45439 2.69405 6.393 2.6969Z"
        fill="#2E3A59"
      />
    </svg>
  );
}

export function LoadSearch({ className }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : ""}
    >
      <path
        d="M10 3.70959C9.45164 3.70959 9.03229 3.29025 9.03229 2.74187V0.96772C9.03229 0.419345 9.45164 0 10 0C10.5484 0 10.9678 0.419345 10.9678 0.96772V2.74187C10.9678 3.25799 10.5484 3.70959 10 3.70959Z"
        fill="#292929"
        fill-opacity="0.3"
      />
      <path
        d="M9.99997 19.9996C9.45158 19.9996 9.03223 19.5803 9.03223 19.0319V17.2578C9.03223 16.7094 9.45158 16.29 9.99997 16.29C10.5484 16.29 10.9677 16.7094 10.9677 17.2578V19.0319C10.9677 19.5803 10.5484 19.9996 9.99997 19.9996Z"
        fill="#292929"
        fill-opacity="0.8"
      />
      <path
        d="M6.35481 4.67711C6.03223 4.67711 5.70965 4.51582 5.5161 4.19325L4.64513 2.67715C4.38707 2.22555 4.54836 1.61266 4.99997 1.3546C5.45159 1.09654 6.06449 1.25783 6.32255 1.70943L7.19352 3.22553C7.45159 3.67713 7.2903 4.29002 6.83868 4.54808C6.70965 4.6126 6.5161 4.67711 6.35481 4.67711Z"
        fill="#292929"
        fill-opacity="0.2"
      />
      <path
        d="M14.5162 18.7748C14.1936 18.7748 13.871 18.6135 13.6775 18.2909L12.8065 16.7748C12.5484 16.3232 12.7097 15.7103 13.1613 15.4523C13.613 15.1942 14.2259 15.3555 14.4839 15.8071L15.3549 17.3232C15.613 17.7748 15.4517 18.3877 15.0001 18.6457C14.8388 18.7425 14.6775 18.7748 14.5162 18.7748Z"
        fill="#292929"
        fill-opacity="0.7"
      />
      <path
        d="M3.70969 7.322C3.5484 7.322 3.38711 7.28975 3.22582 7.19297L1.70969 6.32202C1.25808 6.06397 1.09679 5.45108 1.35485 4.99947C1.61291 4.54787 2.22582 4.38658 2.67743 4.64464L4.19356 5.51559C4.64517 5.77365 4.80646 6.38654 4.5484 6.83814C4.35485 7.16072 4.03227 7.322 3.70969 7.322Z"
        fill="#292929"
        fill-opacity="0.1"
      />
      <path
        d="M17.8386 15.4841C17.6773 15.4841 17.516 15.4519 17.3548 15.3551L15.8064 14.4841C15.3548 14.2261 15.1935 13.6132 15.4515 13.1616C15.7096 12.71 16.3225 12.5487 16.7741 12.8068L18.2902 13.6777C18.7419 13.9358 18.9031 14.5486 18.6451 15.0002C18.4838 15.3228 18.1612 15.4841 17.8386 15.4841Z"
        fill="#292929"
        fill-opacity="0.7"
      />
      <path
        d="M2.74194 10.9677H0.967742C0.419355 10.9677 0 10.5483 0 9.99995C0 9.45157 0.419355 9.03223 0.967742 9.03223H2.74194C3.29032 9.03223 3.70968 9.45157 3.70968 9.99995C3.70968 10.5483 3.25806 10.9677 2.74194 10.9677Z"
        fill="#292929"
        fill-opacity="0.09"
      />
      <path
        d="M19.0322 10.9677H17.258C16.7096 10.9677 16.2903 10.5483 16.2903 9.99995C16.2903 9.45157 16.7096 9.03223 17.258 9.03223H19.0322C19.5806 9.03223 20 9.45157 20 9.99995C20 10.5483 19.5806 10.9677 19.0322 10.9677Z"
        fill="#292929"
        fill-opacity="0.6"
      />
      <path
        d="M2.16133 15.4841C1.83875 15.4841 1.51617 15.3228 1.32262 15.0002C1.06456 14.5486 1.22585 13.9358 1.67746 13.6777L3.19359 12.8068C3.64521 12.5487 4.25811 12.71 4.51617 13.1616C4.77424 13.6132 4.61295 14.2261 4.16133 14.4841L2.6452 15.3551C2.51617 15.4519 2.35488 15.4841 2.16133 15.4841Z"
        fill="#292929"
      />
      <path
        d="M16.2902 7.322C15.9677 7.322 15.6451 7.16072 15.4515 6.83814C15.1935 6.38654 15.3548 5.77365 15.8064 5.51559L17.3225 4.64464C17.7741 4.38658 18.387 4.54787 18.6451 4.99947C18.9031 5.45108 18.7419 6.06397 18.2902 6.32202L16.7741 7.19297C16.6128 7.28975 16.4515 7.322 16.2902 7.322Z"
        fill="#292929"
        fill-opacity="0.5"
      />
      <path
        d="M5.48384 18.7748C5.32255 18.7748 5.16126 18.7425 4.99997 18.6457C4.54836 18.3877 4.38707 17.7748 4.64513 17.3232L5.5161 15.8071C5.77417 15.3555 6.38707 15.1942 6.83868 15.4523C7.2903 15.7103 7.45159 16.3232 7.19352 16.7748L6.32255 18.2909C6.129 18.6135 5.80642 18.7748 5.48384 18.7748Z"
        fill="#292929"
        fill-opacity="0.9"
      />
      <path
        d="M13.6452 4.67711C13.4839 4.67711 13.3226 4.64485 13.1613 4.54808C12.7097 4.29002 12.5484 3.67713 12.8065 3.22553L13.6775 1.70943C13.9355 1.25783 14.5484 1.09654 15.0001 1.3546C15.4517 1.61266 15.613 2.22555 15.3549 2.67715L14.4839 4.19325C14.2904 4.48357 13.9678 4.67711 13.6452 4.67711Z"
        fill="#292929"
        fill-opacity="0.4"
      />
    </svg>
  );
}

export function Delete() {
  return (
    <svg
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00945 4.00441L7.88634 1.14001C8.02427 1.00333 8.02427 0.782053 7.88634 0.64572C7.74876 0.509038 7.52529 0.509038 7.38771 0.64572L4.51327 3.50766L1.61229 0.603072C1.47471 0.464992 1.25123 0.464992 1.11366 0.603072C0.976081 0.741503 0.976081 0.965578 1.11366 1.10366L4.01255 4.00615L1.10318 6.90271C0.965606 7.03939 0.965606 7.26067 1.10318 7.397C1.24076 7.53368 1.46423 7.53368 1.60181 7.397L4.50873 4.50289L7.39819 7.39595C7.53577 7.53403 7.75924 7.53403 7.89682 7.39595C8.03439 7.25752 8.03439 7.03345 7.89682 6.89536L5.00945 4.00441Z"
        fill="#7A858A"
        stroke="#7A858A"
      />
    </svg>
  );
}

export function View() {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 7C6.5 4.92893 8.17893 3.25 10.25 3.25C12.3211 3.25 14 4.92893 14 7C14 9.07107 12.3211 10.75 10.25 10.75C8.17893 10.75 6.5 9.07107 6.5 7ZM10.25 4.75C9.00736 4.75 8 5.75736 8 7C8 8.24264 9.00736 9.25 10.25 9.25C11.4926 9.25 12.5 8.24264 12.5 7C12.5 5.75736 11.4926 4.75 10.25 4.75Z"
        fill="#292929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.57343 5.64635C2.15431 6.25029 2 6.7227 2 7C2 7.2773 2.15431 7.74971 2.57343 8.35365C2.97857 8.93744 3.58078 9.57028 4.34267 10.155C5.86978 11.3271 7.96345 12.25 10.25 12.25C12.5365 12.25 14.6302 11.3271 16.1573 10.155C16.9192 9.57028 17.5214 8.93744 17.9266 8.35365C18.3457 7.74971 18.5 7.2773 18.5 7C18.5 6.7227 18.3457 6.25029 17.9266 5.64635C17.5214 5.06256 16.9192 4.42972 16.1573 3.84497C14.6302 2.67292 12.5365 1.75 10.25 1.75C7.96345 1.75 5.86978 2.67292 4.34267 3.84497C3.58078 4.42972 2.97857 5.06256 2.57343 5.64635ZM3.42941 2.65503C5.15965 1.32708 7.56598 0.25 10.25 0.25C12.934 0.25 15.3403 1.32708 17.0706 2.65503C17.9374 3.32028 18.6532 4.06244 19.1589 4.79115C19.6506 5.49971 20 6.2773 20 7C20 7.7227 19.6506 8.50029 19.1589 9.20885C18.6532 9.93756 17.9374 10.6797 17.0706 11.345C15.3403 12.6729 12.934 13.75 10.25 13.75C7.56598 13.75 5.15965 12.6729 3.42941 11.345C2.56262 10.6797 1.84681 9.93756 1.3411 9.20885C0.849371 8.50029 0.5 7.7227 0.5 7C0.5 6.2773 0.849371 5.49971 1.3411 4.79115C1.84681 4.06244 2.56262 3.32028 3.42941 2.65503Z"
        fill="#292929"
      />
    </svg>
  );
}

export function NoView() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7803 1.53033C19.0732 1.23744 19.0732 0.762563 18.7803 0.46967C18.4874 0.176777 18.0126 0.176777 17.7197 0.46967L1.71967 16.4697C1.42678 16.7626 1.42678 17.2374 1.71967 17.5303C2.01256 17.8232 2.48744 17.8232 2.78033 17.5303L5.62723 14.6834C6.99353 15.3266 8.56719 15.75 10.25 15.75C12.934 15.75 15.3403 14.6729 17.0706 13.345C17.9374 12.6797 18.6532 11.9376 19.1589 11.2089C19.6506 10.5003 20 9.7227 20 9C20 8.2773 19.6506 7.49971 19.1589 6.79115C18.6532 6.06244 17.9374 5.32028 17.0706 4.65503C16.8085 4.45385 16.5308 4.25842 16.239 4.07163L18.7803 1.53033ZM15.1495 5.16113L13.3787 6.93196C13.7713 7.52478 14 8.23569 14 9C14 11.0711 12.3211 12.75 10.25 12.75C9.48569 12.75 8.77478 12.5213 8.18196 12.1287L6.76524 13.5454C7.83077 13.9795 9.01212 14.25 10.25 14.25C12.5365 14.25 14.6302 13.3271 16.1573 12.155C16.9192 11.5703 17.5214 10.9374 17.9266 10.3536C18.3457 9.74971 18.5 9.2773 18.5 9C18.5 8.7227 18.3457 8.25029 17.9266 7.64635C17.5214 7.06256 16.9192 6.42972 16.1573 5.84497C15.8441 5.60461 15.5071 5.37472 15.1495 5.16113ZM9.27994 11.0307C9.57366 11.1713 9.90264 11.25 10.25 11.25C11.4926 11.25 12.5 10.2426 12.5 9C12.5 8.65264 12.4213 8.32366 12.2807 8.02994L9.27994 11.0307Z"
        fill="#292929"
      />
      <path
        d="M10.25 2.25C11.2823 2.25 12.2736 2.40934 13.2011 2.68101C13.3796 2.73328 13.4327 2.95662 13.3013 3.0881L12.4767 3.91265C12.4148 3.97451 12.3252 3.99928 12.24 3.97967C11.6006 3.83257 10.9339 3.75 10.25 3.75C7.96345 3.75 5.86978 4.67292 4.34267 5.84497C3.58078 6.42972 2.97857 7.06256 2.57343 7.64635C2.15431 8.25029 2 8.7227 2 9C2 9.2773 2.15431 9.74971 2.57343 10.3536C2.92725 10.8635 3.43138 11.4107 4.06091 11.9307C4.17677 12.0264 4.18781 12.2015 4.08156 12.3078L3.37265 13.0167C3.28234 13.107 3.13823 13.1149 3.04037 13.0329C2.34739 12.4517 1.76902 11.8255 1.3411 11.2089C0.849371 10.5003 0.5 9.7227 0.5 9C0.5 8.2773 0.849371 7.49971 1.3411 6.79115C1.84681 6.06244 2.56262 5.32028 3.42941 4.65503C5.15965 3.32708 7.56598 2.25 10.25 2.25Z"
        fill="#292929"
      />
      <path
        d="M10.25 5.25C10.3685 5.25 10.4857 5.25549 10.6013 5.26624C10.7982 5.28453 10.8694 5.51991 10.7296 5.6597L9.51739 6.87196C8.86408 7.09683 8.34683 7.61408 8.12196 8.26739L6.9097 9.47965C6.76991 9.61945 6.53453 9.54818 6.51624 9.35132C6.50549 9.23566 6.5 9.11847 6.5 9C6.5 6.92893 8.17893 5.25 10.25 5.25Z"
        fill="#292929"
      />
    </svg>
  );
}

export function Calendar() {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 20H2C0.89543 20 0 19.1046 0 18V4C0 2.89543 0.89543 2 2 2H4V0H6V2H12V0H14V2H16C17.1046 2 18 2.89543 18 4V18C18 19.1046 17.1046 20 16 20ZM2 8V18H16V8H2ZM2 4V6H16V4H2ZM14 16H12V14H14V16ZM10 16H8V14H10V16ZM6 16H4V14H6V16ZM14 12H12V10H14V12ZM10 12H8V10H10V12ZM6 12H4V10H6V12Z"
        fill="#292929"
      />
    </svg>
  );
}

// Svg Tailwind
export function SvgBtnConnected() {
  return (
    <svg
      width="18"
      height="9"
      viewBox="0 0 18 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 9H10.8V7.2H13.5C14.9912 7.2 16.2 5.99117 16.2 4.5C16.2 3.00883 14.9912 1.8 13.5 1.8H10.8V0H13.5C15.9853 0 18 2.01472 18 4.5C18 6.98528 15.9853 9 13.5 9ZM7.2 9H4.5C2.01472 9 0 6.98528 0 4.5C0 2.01472 2.01472 0 4.5 0H7.2V1.8H4.5C3.00883 1.8 1.8 3.00883 1.8 4.5C1.8 5.99117 3.00883 7.2 4.5 7.2H7.2V9ZM13.5 5.4H4.5V3.6H13.5V5.4Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgBtnNotConnected() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4078 18.2049L8.60052 10.3967H4.48791V8.60315H6.80697L5.01342 6.80959H4.48791C3.00208 6.80959 1.79758 8.01409 1.79758 9.49992C1.79758 10.9857 3.00208 12.1902 4.48791 12.1902H7.17823V13.9838H4.48791C2.22943 13.9857 0.322062 12.3075 0.0363566 10.0671C-0.249348 7.82681 1.17579 5.72365 3.36245 5.15863L0.265887 2.06296L1.53482 0.794922L17.6768 16.9369L16.4087 18.204L16.4078 18.2049ZM16.2679 12.9911L14.9874 11.7114C15.9545 11.0413 16.374 9.82054 16.0231 8.69752C15.6722 7.57449 14.6322 6.80978 13.4557 6.80959H10.7653V5.01604H13.4557C15.3568 5.01627 17.0512 6.21543 17.6836 8.00832C18.3161 9.80121 17.7491 11.798 16.2688 12.9911H16.2679Z"
        fill="#292929"
      />
    </svg>
  );
}

// End Svg Tailwind
export function ArrowRigth() {
  return (
    <svg
      width="7"
      height="8"
      viewBox="0 0 7 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.871582 1.37476C0.871582 0.673886 1.78363 0.279642 2.48108 0.630081L5.93851 3.25838C6.63596 3.60881 6.63596 4.44111 5.93851 4.74774L2.48108 7.37604C1.78363 7.72647 0.871582 7.28843 0.871582 6.63135L0.871582 1.37476Z"
        fill="#292929"
      />
    </svg>
  );
}

export function PlusIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.45949 10.8854V6.54468H1.11876C0.974859 6.54468 0.836849 6.48751 0.735093 6.38576C0.633338 6.284 0.576172 6.14599 0.576172 6.00209C0.576172 5.85818 0.633338 5.72017 0.735093 5.61842C0.836849 5.51666 0.974859 5.45949 1.11876 5.45949H5.45949V1.11876C5.45949 0.974859 5.51666 0.836849 5.61842 0.735093C5.72017 0.633338 5.85818 0.576172 6.00209 0.576172C6.14599 0.576172 6.284 0.633338 6.38576 0.735093C6.48751 0.836849 6.54468 0.974859 6.54468 1.11876V5.45949H10.8854C11.0293 5.45949 11.1673 5.51666 11.2691 5.61842C11.3708 5.72017 11.428 5.85818 11.428 6.00209C11.428 6.14599 11.3708 6.284 11.2691 6.38576C11.1673 6.48751 11.0293 6.54468 10.8854 6.54468H6.54468V10.8854C6.54468 11.0293 6.48751 11.1673 6.38576 11.2691C6.284 11.3708 6.14599 11.428 6.00209 11.428C5.85818 11.428 5.72017 11.3708 5.61842 11.2691C5.51666 11.1673 5.45949 11.0293 5.45949 10.8854Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function CloseSmall() {
  return (
    <svg
      width="7"
      height="7"
      viewBox="0 0 7 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.91356 0.847656L3.79637 2.96484L1.67919 0.847656L0.847656 1.67919L2.96484 3.79637L0.847656 5.91356L1.67919 6.74509L3.79637 4.62791L5.91356 6.74509L6.74509 5.91356L4.62791 3.79637L6.74509 1.67919L5.91356 0.847656Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function Caret({ className, color = "#292929" }) {
  return (
    <svg
      width="6"
      height="8"
      viewBox="0 0 6 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.410156 1.37476C0.410156 0.673886 1.3222 0.279642 2.01965 0.630081L5.47709 3.25838C6.17454 3.60881 6.17454 4.44111 5.47709 4.74774L2.01965 7.37604C1.3222 7.72647 0.410156 7.28843 0.410156 6.63135L0.410156 1.37476Z"
        fill={color}
      />
    </svg>
  );
}

export function CaretFine({ className, color = "#292929" }) {
  return (
    <svg
      width="9"
      height="6"
      viewBox="0 0 9 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill={color}
        d="M4.6702 4.67189L7.92389 1.68037C8.02792 1.58134 8.02493 1.42352 7.91722 1.32788C7.81214 1.23457 7.64556 1.23457 7.5405 1.32788L4.47851 4.14314L1.41651 1.32788C1.31064 1.23055 1.139 1.23055 1.03312 1.32788C0.927268 1.42523 0.927268 1.58303 1.03312 1.68037L4.28681 4.67189C4.3927 4.76921 4.56433 4.76921 4.6702 4.67189Z"
        // fill="white"
        stroke="#F55611"
      />
    </svg>
  );
}

export function PaperUpload({ color }) {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4257_1927"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.193359 0.0791016H13.8077V15.93H0.193359V0.0791016Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4257_1927)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.84449 1.27599C2.52155 1.27599 1.42296 2.34743 1.39182 3.66877V12.2267C1.36308 13.5848 2.43293 14.7026 3.77822 14.7321H10.2316C11.5641 14.6842 12.6188 13.5848 12.61 12.2307V5.13063L8.91029 1.27599H3.85407H3.84449ZM3.85405 15.9304H3.75345C1.74788 15.8873 0.151099 14.2202 0.194212 12.2147V3.6551C0.241317 1.67429 1.87643 0.0791016 3.84207 0.0791016H3.85644H9.16496C9.32783 0.0791016 9.48351 0.145368 9.59689 0.262732L13.6415 4.47585C13.7477 4.58683 13.8076 4.73613 13.8076 4.89022V12.2274C13.8204 14.2306 12.2587 15.8585 10.2524 15.9304H3.85405Z"
          fill={color}
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2053 5.64629H11.0065C9.54463 5.6423 8.35742 4.45109 8.35742 2.99163V0.669107C8.35742 0.338573 8.62568 0.0703125 8.95622 0.0703125C9.28675 0.0703125 9.55501 0.338573 9.55501 0.669107V2.99163C9.55501 3.79322 10.2065 4.4463 11.0081 4.4487H13.2053C13.5358 4.4487 13.8041 4.71696 13.8041 5.04749C13.8041 5.37803 13.5358 5.64629 13.2053 5.64629Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.69254 11.8058C6.36201 11.8058 6.09375 11.5376 6.09375 11.207V6.38395C6.09375 6.05342 6.36201 5.78516 6.69254 5.78516C7.02308 5.78516 7.29134 6.05342 7.29134 6.38395V11.207C7.29134 11.5376 7.02308 11.8058 6.69254 11.8058Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.82125 8.86361C4.66876 8.86361 4.51547 8.80533 4.3989 8.68876C4.16497 8.45563 4.16338 8.07719 4.39731 7.84246L6.26874 5.96145C6.49389 5.73551 6.89308 5.73551 7.11743 5.96145L8.99046 7.84246C9.22359 8.07719 9.22279 8.45563 8.98886 8.68876C8.75414 8.92189 8.3749 8.92189 8.14177 8.68716L6.69348 7.23249L5.2452 8.68716C5.12863 8.80533 4.97454 8.86361 4.82125 8.86361Z"
        fill={color}
      />
    </svg>
  );
}

export function PaperDownload({ color = "#48B19D" }) {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3721_27613"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="15"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.693359 0.0791016H14.3077V15.93H0.693359V0.0791016Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3721_27613)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.34449 1.27599C3.02155 1.27599 1.92296 2.34743 1.89182 3.66877V12.2267C1.86308 13.5848 2.93293 14.7026 4.27822 14.7321H10.7316C12.0641 14.6842 13.1188 13.5848 13.11 12.2307V5.13063L9.41029 1.27599H4.35407H4.34449ZM4.35405 15.9304H4.25345C2.24788 15.8873 0.651099 14.2202 0.694212 12.2147V3.6551C0.741317 1.67429 2.37643 0.0791016 4.34207 0.0791016H4.35644H9.66496C9.82783 0.0791016 9.98351 0.145368 10.0969 0.262732L14.1415 4.47585C14.2477 4.58683 14.3076 4.73613 14.3076 4.89022V12.2274C14.3204 14.2306 12.7587 15.8585 10.7524 15.9304H4.35405Z"
          fill={color}
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7053 5.64629H11.5065C10.0446 5.6423 8.85742 4.45109 8.85742 2.99163V0.669107C8.85742 0.338573 9.12568 0.0703125 9.45622 0.0703125C9.78675 0.0703125 10.055 0.338573 10.055 0.669107V2.99163C10.055 3.79322 10.7065 4.4463 11.5081 4.4487H13.7053C14.0358 4.4487 14.3041 4.71696 14.3041 5.04749C14.3041 5.37803 14.0358 5.64629 13.7053 5.64629Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.19254 5.78596C6.86201 5.78596 6.59375 6.05422 6.59375 6.38475V11.2078C6.59375 11.5384 6.86201 11.8066 7.19254 11.8066C7.52308 11.8066 7.79134 11.5384 7.79134 11.2078V6.38475C7.79134 6.05422 7.52308 5.78596 7.19254 5.78596Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.32125 8.72721C5.16876 8.72721 5.01547 8.78549 4.8989 8.90206C4.66497 9.13519 4.66338 9.51363 4.89731 9.74836L6.76874 11.6294C6.99389 11.8553 7.39308 11.8553 7.61743 11.6294L9.49046 9.74836C9.72359 9.51363 9.72279 9.13519 9.48886 8.90206C9.25414 8.66893 8.8749 8.66893 8.64177 8.90366L7.19348 10.3583L5.7452 8.90366C5.62863 8.78549 5.47454 8.72721 5.32125 8.72721Z"
        fill={color}
      />
    </svg>
  );
}

export function ReturnPipeline() {
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.95777 2.54293V0.571246C6.78052 -0.253461 6.10523 0.248981 6.10523 0.248981L1.4148 4.29927C0.383551 5.01558 1.34449 5.55465 1.34449 5.55465L5.96461 9.56978C6.88892 10.2509 6.95923 9.2109 6.95923 9.2109V7.38277C11.6497 5.91207 13.5686 11.7934 13.5686 11.7934C13.7459 12.1157 13.8528 11.7934 13.8528 11.7934C15.6648 2.97359 6.95777 2.54293 6.95777 2.54293Z"
        fill="#48B19D"
      />
    </svg>
  );
}

export function BackIcon() {
  return (
    <svg
      width="17"
      height="11"
      viewBox="0 0 17 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.12 4.66975L2.99789 4.66975L6.43224 1.41651C6.77567 1.09119 6.77567 0.569318 6.43224 0.243994C6.26052 0.0813322 6.03872 9.49083e-07 5.80976 9.29067e-07C5.58081 9.09051e-07 5.35901 0.0813321 5.18729 0.243994L0.257575 4.91374C-0.0858607 5.23906 -0.0858607 5.76094 0.257575 6.08626L5.18729 10.756C5.53072 11.0813 6.08165 11.0813 6.42508 10.756C6.76852 10.4307 6.76852 9.90881 6.42508 9.58349L2.99074 6.33025L16.12 6.33025C16.6065 6.33025 17 5.95749 17 5.49661C17 5.03574 16.6065 4.66975 16.12 4.66975Z"
        fill="#292929"
      />
    </svg>
  );
}

// End Form Group
// OnBoarding || OffBoarding
export function ArrowFlowUp() {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 3.2L2.2 5.7C1.8 6.1 1.20001 6.1 0.800006 5.7C0.400007 5.3 0.400007 4.7 0.800006 4.3L4.40001 0.399999C4.70001 0.199999 5.1 -4.72083e-07 5.5 -4.37114e-07C5.9 -4.02145e-07 6.3 0.199999 6.6 0.399999L10.2 4.2C10.6 4.6 10.6 5.2 10.2 5.6C9.8 6 9.20001 6 8.80001 5.6L6.5 3.1L6.5 10C6.5 10.6 6.1 11 5.5 11C5 11 4.5 10.6 4.5 10L4.5 3.2Z"
        fill="#FB5A57"
      />
    </svg>
  );
}

export function ArrowFlowDown() {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7.8L8.3 5.3C8.7 4.9 9.29999 4.9 9.69999 5.3C10.1 5.7 10.1 6.3 9.69999 6.7L6.1 10.6C5.8 10.8 5.4 11 5 11C4.6 11 4.2 10.8 3.9 10.6L0.3 6.8C-0.1 6.4 -0.1 5.8 0.3 5.4C0.7 5 1.29999 5 1.69999 5.4L4 7.9L4 1C4 0.4 4.4 0 5 0C5.5 0 6 0.4 6 1L6 7.8Z"
        fill="#0FBDB0"
      />
    </svg>
  );
}

export function AddTask() {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36C28.165 36 36 28.165 36 18.5Z"
        fill="#73C7B7"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M17.8691 24.1993V19.1351H12.8049C12.637 19.1351 12.476 19.0684 12.3573 18.9497C12.2386 18.831 12.1719 18.67 12.1719 18.5021C12.1719 18.3342 12.2386 18.1732 12.3573 18.0545C12.476 17.9358 12.637 17.8691 12.8049 17.8691H17.8691V12.8049C17.8691 12.637 17.9358 12.476 18.0545 12.3573C18.1732 12.2386 18.3342 12.1719 18.5021 12.1719C18.67 12.1719 18.831 12.2386 18.9497 12.3573C19.0684 12.476 19.1351 12.637 19.1351 12.8049V17.8691H24.1993C24.3672 17.8691 24.5282 17.9358 24.6469 18.0545C24.7656 18.1732 24.8323 18.3342 24.8323 18.5021C24.8323 18.67 24.7656 18.831 24.6469 18.9497C24.5282 19.0684 24.3672 19.1351 24.1993 19.1351H19.1351V24.1993C19.1351 24.3672 19.0684 24.5282 18.9497 24.6469C18.831 24.7656 18.67 24.8323 18.5021 24.8323C18.3342 24.8323 18.1732 24.7656 18.0545 24.6469C17.9358 24.5282 17.8691 24.3672 17.8691 24.1993Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function AddButtonTransparent() {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36C28.165 36 36 28.165 36 18.5Z"
        fill="transparent"
        stroke="transparent"
        strokeWidth="2"
      />
      <path
        d="M17.8691 24.1993V19.1351H12.8049C12.637 19.1351 12.476 19.0684 12.3573 18.9497C12.2386 18.831 12.1719 18.67 12.1719 18.5021C12.1719 18.3342 12.2386 18.1732 12.3573 18.0545C12.476 17.9358 12.637 17.8691 12.8049 17.8691H17.8691V12.8049C17.8691 12.637 17.9358 12.476 18.0545 12.3573C18.1732 12.2386 18.3342 12.1719 18.5021 12.1719C18.67 12.1719 18.831 12.2386 18.9497 12.3573C19.0684 12.476 19.1351 12.637 19.1351 12.8049V17.8691H24.1993C24.3672 17.8691 24.5282 17.9358 24.6469 18.0545C24.7656 18.1732 24.8323 18.3342 24.8323 18.5021C24.8323 18.67 24.7656 18.831 24.6469 18.9497C24.5282 19.0684 24.3672 19.1351 24.1993 19.1351H19.1351V24.1993C19.1351 24.3672 19.0684 24.5282 18.9497 24.6469C18.831 24.7656 18.67 24.8323 18.5021 24.8323C18.3342 24.8323 18.1732 24.7656 18.0545 24.6469C17.9358 24.5282 17.8691 24.3672 17.8691 24.1993Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function ShapeCompletDropdown() {
  return (
    <svg
      width="5"
      height="10"
      viewBox="0 0 5 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.93018 5.17507L0.252785 0.889378C0.22855 0.867199 0.200211 0.854252 0.170835 0.851938C0.141458 0.849624 0.112166 0.858032 0.0861286 0.876251C0.0600914 0.894471 0.0383022 0.921806 0.0231206 0.955299C0.00793902 0.988791 -5.63741e-05 1.02716 2.98393e-07 1.06626L2.66355e-07 9.63764C5.0526e-05 9.67667 0.00812361 9.71495 0.0233481 9.74833C0.0385726 9.78171 0.0603702 9.80893 0.0863882 9.82705C0.112406 9.84518 0.141656 9.85352 0.170981 9.85118C0.200306 9.84883 0.228591 9.83589 0.252785 9.81375L4.93018 5.52728C4.95171 5.50758 4.96932 5.48122 4.98148 5.45048C4.99365 5.41973 5 5.38552 5 5.35078C5 5.31605 4.99365 5.28184 4.98148 5.25109C4.96932 5.22035 4.95171 5.19477 4.93018 5.17507Z"
        fill="#292929"
      />
    </svg>
  );
}

export function CloseModal() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.24806 6.33018L12.4487 1.15791C12.6981 0.911098 12.6981 0.511532 12.4487 0.265354C12.2 0.0185438 11.796 0.0185438 11.5473 0.265354L6.35109 5.43321L1.10686 0.188344C0.858153 -0.0609909 0.454168 -0.0609909 0.205464 0.188344C-0.0432389 0.438309 -0.0432389 0.842926 0.205464 1.09226L5.44591 6.33334L0.186527 11.5637C-0.0621758 11.8105 -0.0621758 12.2101 0.186527 12.4562C0.435231 12.703 0.839216 12.703 1.08792 12.4562L6.34288 7.23031L11.5663 12.4543C11.815 12.7037 12.219 12.7037 12.4677 12.4543C12.7164 12.2044 12.7164 11.7998 12.4677 11.5504L7.24806 6.33018Z"
        fill="#121313"
      />
    </svg>
  );
}

export function DeleteFile() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.24806 6.33018L12.4487 1.15791C12.6981 0.911098 12.6981 0.511532 12.4487 0.265354C12.2 0.0185438 11.796 0.0185438 11.5473 0.265354L6.35109 5.43321L1.10686 0.188344C0.858153 -0.0609909 0.454168 -0.0609909 0.205464 0.188344C-0.0432389 0.438309 -0.0432389 0.842926 0.205464 1.09226L5.44591 6.33334L0.186527 11.5637C-0.0621758 11.8105 -0.0621758 12.2101 0.186527 12.4562C0.435231 12.703 0.839216 12.703 1.08792 12.4562L6.34288 7.23031L11.5663 12.4543C11.815 12.7037 12.219 12.7037 12.4677 12.4543C12.7164 12.2044 12.7164 11.7998 12.4677 11.5504L7.24806 6.33018Z"
        fill="#121313"
      />
    </svg>
  );
}

export function WhiteCloseModal() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.24806 6.33018L12.4487 1.15791C12.6981 0.911098 12.6981 0.511532 12.4487 0.265354C12.2 0.0185438 11.796 0.0185438 11.5473 0.265354L6.35109 5.43321L1.10686 0.188344C0.858153 -0.0609909 0.454168 -0.0609909 0.205464 0.188344C-0.0432389 0.438309 -0.0432389 0.842926 0.205464 1.09226L5.44591 6.33334L0.186527 11.5637C-0.0621758 11.8105 -0.0621758 12.2101 0.186527 12.4562C0.435231 12.703 0.839216 12.703 1.08792 12.4562L6.34288 7.23031L11.5663 12.4543C11.815 12.7037 12.219 12.7037 12.4677 12.4543C12.7164 12.2044 12.7164 11.7998 12.4677 11.5504L7.24806 6.33018Z"
        fill="white"
      />
    </svg>
  );
}

export function Citation() {
  return (
    <svg
      width="16"
      height="11"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 14L2 13.99C0.899324 13.99 0.00550338 13.1007 0 12V2C0.00550338 0.899338 0.899324 0.00998654 2 0.0100003L13 1.47332e-07C13.6472 -0.000247907 14.2546 0.312743 14.63 0.84L19 7L14.63 13.16C14.2546 13.6873 13.6472 14.0002 13 14ZM2 2V12H13L16.55 7L13 2H2Z"
        fill="#2E3A59"
      />
    </svg>
  );
}

export function MenuAssignedTask({ color = "#292929" }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.38281 10.4596L8.62849 12.7043L13.1179 8.21484"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 10.46C1 17.022 3.18797 19.21 9.75 19.21C16.312 19.21 18.5 17.022 18.5 10.46C18.5 3.89793 16.312 1.70996 9.75 1.70996C3.18797 1.70996 1 3.89793 1 10.46Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MenuOrganisator({ color = "#292929" }) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.89949 12.9068L10.5717 15.579L15.916 10.2346M20.815 12.9068C20.815 17.8261 16.8271 21.8141 11.9078 21.8141C6.98841 21.8141 3.00049 17.8261 3.00049 12.9068C3.00049 7.98743 6.98841 3.99951 11.9078 3.99951C16.8271 3.99951 20.815 7.98743 20.815 12.9068Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Archived() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.875 10.875L0.875 2.125C0.875 1.43464 1.43464 0.875 2.125 0.875L4.625 0.875L4.625 2.125L2.125 2.125L2.125 10.875L10.875 10.875L10.875 2.125L8.375 2.125L8.375 0.875L10.875 0.875C11.5654 0.875 12.125 1.43464 12.125 2.125L12.125 10.875C12.125 11.5654 11.5654 12.125 10.875 12.125L2.125 12.125C1.43464 12.125 0.875 11.5654 0.875 10.875ZM4 5.875L5.875 5.875L5.875 0.875L7.125 0.875L7.125 5.875L9 5.875L6.5 9L4 5.875Z"
        fill="#2E3A59"
      />
    </svg>
  );
}

export function Close() {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.10122 5.32744L10.479 0.973565C10.6889 0.765807 10.6889 0.429463 10.479 0.222237C10.2696 0.0144794 9.92959 0.0144794 9.72023 0.222237L5.34617 4.57239L0.931721 0.157412C0.722369 -0.0524707 0.382306 -0.0524707 0.172954 0.157412C-0.0363973 0.367826 -0.0363973 0.708421 0.172954 0.918304L4.58421 5.3301L0.157014 9.73286C-0.0523379 9.94061 -0.0523379 10.277 0.157014 10.4842C0.366365 10.6919 0.706429 10.6919 0.91578 10.4842L5.33926 6.08514L9.73617 10.4826C9.94553 10.6925 10.2856 10.6925 10.4949 10.4826C10.7043 10.2722 10.7043 9.93158 10.4949 9.7217L6.10122 5.32744Z"
        fill="#121313"
      />
    </svg>
  );
}

export function PaperDownloadFile() {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4096_10612"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0.0107422H16.8061V19.037H0V0.0107422Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4096_10612)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.50688 1.44824C2.87379 1.44824 1.51765 2.73433 1.47921 4.32037V14.5927C1.44373 16.2229 2.7644 17.5645 4.42508 17.6H12.3914C14.0364 17.5425 15.3383 16.2229 15.3274 14.5975V6.07508L10.7603 1.44824H4.51871H4.50688ZM4.5189 19.0375H4.39472C1.91897 18.9857 -0.0521679 16.9847 0.00105286 14.5774V4.30312C0.0592015 1.92549 2.07765 0.0107422 4.50412 0.0107422H4.52186H11.0749C11.276 0.0107422 11.4682 0.0902838 11.6081 0.231159L16.601 5.28828C16.7321 5.42149 16.806 5.6007 16.806 5.78566V14.5927C16.8218 16.9972 14.894 18.9512 12.4173 19.0375H4.5189Z"
          fill="#4CA090"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0625 6.693H13.3482C11.5437 6.68821 10.0781 5.25837 10.0781 3.50654V0.71875C10.0781 0.322 10.4093 0 10.8173 0C11.2253 0 11.5565 0.322 11.5565 0.71875V3.50654C11.5565 4.46871 12.3607 5.25262 13.3502 5.2555H16.0625C16.4705 5.2555 16.8017 5.5775 16.8017 5.97425C16.8017 6.371 16.4705 6.693 16.0625 6.693Z"
        fill="#4CA090"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.02433 14.0871C7.61631 14.0871 7.28516 13.7651 7.28516 13.3684V7.5791C7.28516 7.18235 7.61631 6.86035 8.02433 6.86035C8.43236 6.86035 8.76351 7.18235 8.76351 7.5791V13.3684C8.76351 13.7651 8.43236 14.0871 8.02433 14.0871Z"
        fill="#4CA090"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.02433 14.0867C7.8282 14.0867 7.63897 14.011 7.50099 13.8749L5.18983 11.619C4.90205 11.3373 4.90303 10.882 5.19181 10.6022C5.48156 10.3224 5.94971 10.3224 6.23749 10.6041L8.02433 12.3502L9.81117 10.6041C10.099 10.3224 10.5671 10.3224 10.8569 10.6022C11.1456 10.882 11.1466 11.3373 10.8588 11.619L8.54767 13.8749C8.40969 14.011 8.22046 14.0867 8.02433 14.0867Z"
        fill="#4CA090"
      />
    </svg>
  );
}

export function PaperUploadFile() {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4096_10623"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0.0107422H16.8061V19.037H0V0.0107422Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4096_10623)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.50688 1.44824C2.87379 1.44824 1.51765 2.73433 1.47921 4.32037V14.5927C1.44373 16.2229 2.7644 17.5645 4.42508 17.6H12.3914C14.0364 17.5425 15.3383 16.2229 15.3274 14.5975V6.07508L10.7603 1.44824H4.51871H4.50688ZM4.5189 19.0375H4.39472C1.91897 18.9857 -0.0521679 16.9847 0.00105286 14.5774V4.30312C0.0592015 1.92549 2.07765 0.0107422 4.50412 0.0107422H4.52186H11.0749C11.276 0.0107422 11.4682 0.0902838 11.6081 0.231159L16.601 5.28828C16.7321 5.42149 16.806 5.6007 16.806 5.78566V14.5927C16.8218 16.9972 14.894 18.9512 12.4173 19.0375H4.5189Z"
          fill="#4CA090"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0625 6.693H13.3482C11.5437 6.68821 10.0781 5.25837 10.0781 3.50654V0.71875C10.0781 0.322 10.4093 0 10.8173 0C11.2253 0 11.5565 0.322 11.5565 0.71875V3.50654C11.5565 4.46871 12.3607 5.25262 13.3502 5.2555H16.0625C16.4705 5.2555 16.8017 5.5775 16.8017 5.97425C16.8017 6.371 16.4705 6.693 16.0625 6.693Z"
        fill="#4CA090"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.0245 6.86012C8.43252 6.86012 8.76367 7.18212 8.76367 7.57887L8.76367 13.3682C8.76367 13.7649 8.43252 14.0869 8.02449 14.0869C7.61647 14.0869 7.28532 13.7649 7.28532 13.3682L7.28532 7.57887C7.28532 7.18212 7.61647 6.86012 8.0245 6.86012Z"
        fill="#4CA090"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.0245 6.86055C8.22062 6.86055 8.40985 6.93626 8.54783 7.07234L10.859 9.32826C11.1468 9.61001 11.1458 10.0652 10.857 10.3451C10.5673 10.6249 10.0991 10.6249 9.81133 10.3431L8.0245 8.59705L6.23766 10.3431C5.94987 10.6249 5.48173 10.6249 5.19197 10.3451C4.9032 10.0652 4.90221 9.61001 5.19 9.32826L7.50116 7.07234C7.63914 6.93626 7.82837 6.86055 8.0245 6.86055Z"
        fill="#4CA090"
      />
    </svg>
  );
}

// OnBoarding || OffBoarding
/* New design tailwindcss */
export function UserWithCircle() {
  return (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.03687 21.1509C3.7807 21.1509 1 20.6515 1 18.6513C1 16.6511 3.76306 14.8047 7.03687 14.8047C10.2931 14.8047 13.0737 16.6332 13.0737 18.6334C13.0737 20.6328 10.3107 21.1509 7.03687 21.1509Z"
        stroke="#393C40"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.03365 12.0336C9.17049 12.0336 10.9024 10.3265 10.9024 8.22032C10.9024 6.11412 9.17049 4.40625 7.03365 4.40625C4.89681 4.40625 3.16409 6.11412 3.16409 8.22032C3.15687 10.3194 4.87676 12.0265 7.00639 12.0336C7.01601 12.0336 7.02483 12.0336 7.03365 12.0336Z"
        stroke="#393C40"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5666 5.5792C22.5666 8.02432 20.5844 10.007 18.1388 10.007C15.6937 10.007 13.7109 8.02432 13.7109 5.5792C13.7109 3.1336 15.6937 1.15137 18.1388 1.15137C20.5844 1.15137 22.5666 3.1336 22.5666 5.5792Z"
        stroke="#393C40"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.145 5.94643L17.9766 5.91101V3.59082"
        stroke="#393C40"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DisciplinaryIcon() {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3307 9.67057V6.27891C16.3307 4.73876 16.3307 3.96869 16.031 3.38043C15.7673 2.86299 15.3466 2.44229 14.8292 2.17864C14.2409 1.87891 13.4709 1.87891 11.9307 1.87891H6.06406C4.52392 1.87891 3.75385 1.87891 3.16559 2.17864C2.64814 2.44229 2.22745 2.86299 1.96379 3.38043C1.66406 3.96869 1.66406 4.73876 1.66406 6.27891V15.8122C1.66406 17.3524 1.66406 18.1225 1.96379 18.7107C2.22745 19.2282 2.64814 19.6489 3.16559 19.9125C3.75385 20.2122 4.52392 20.2122 6.06406 20.2122H8.53906M18.1641 20.2122L16.7891 18.8372M17.7057 16.5456C17.7057 18.3175 16.2693 19.7539 14.4974 19.7539C12.7255 19.7539 11.2891 18.3175 11.2891 16.5456C11.2891 14.7737 12.7255 13.3372 14.4974 13.3372C16.2693 13.3372 17.7057 14.7737 17.7057 16.5456Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DepartureIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7467 2.81274C18.7114 1.81626 20.3055 1.80337 21.2862 2.78411C22.2401 3.73799 22.2578 5.27896 21.3262 6.25456L18.5475 9.16433C18.3297 9.3924 18.2208 9.50644 18.1537 9.64C18.0943 9.75823 18.059 9.88708 18.0497 10.0191C18.0393 10.1682 18.0747 10.3218 18.1457 10.6291L19.8735 18.1167C19.9463 18.4321 19.9827 18.5898 19.971 18.7423C19.9606 18.8774 19.9229 19.0089 19.8601 19.1289C19.7892 19.2645 19.6748 19.3789 19.4459 19.6078L19.0751 19.9786C18.469 20.5847 18.1659 20.8878 17.8557 20.9427C17.5849 20.9906 17.3062 20.9248 17.0854 20.7608C16.8325 20.573 16.6969 20.1664 16.4259 19.3532L14.4161 13.3239L11.0708 16.6692C10.8711 16.8689 10.7712 16.9687 10.7045 17.0863C10.6453 17.1905 10.6053 17.3044 10.5865 17.4227C10.5652 17.5563 10.5807 17.6966 10.6119 17.9773L10.7956 19.6307C10.8268 19.9113 10.8424 20.0517 10.8211 20.1852C10.8023 20.3035 10.7623 20.4174 10.7031 20.5216C10.6363 20.6392 10.5365 20.739 10.3368 20.9387L10.1393 21.1362C9.66623 21.6093 9.4297 21.8458 9.16686 21.9143C8.93631 21.9744 8.69189 21.9502 8.4776 21.8461C8.23329 21.7273 8.04774 21.449 7.67664 20.8924L6.10832 18.5399C6.04202 18.4404 6.00887 18.3907 5.97038 18.3456C5.9362 18.3056 5.8989 18.2683 5.85884 18.2341C5.81374 18.1956 5.76401 18.1624 5.66456 18.0961L3.31208 16.5278C2.75543 16.1567 2.4771 15.9712 2.35839 15.7269C2.25425 15.5126 2.23005 15.2681 2.29014 15.0376C2.35864 14.7747 2.59517 14.5382 3.06823 14.0652L3.26573 13.8677C3.46542 13.668 3.56526 13.5681 3.68284 13.5013C3.787 13.4422 3.90095 13.4022 4.01925 13.3833C4.15278 13.362 4.29312 13.3776 4.57379 13.4088L6.22718 13.5925C6.50785 13.6237 6.64819 13.6393 6.78172 13.618C6.90002 13.5991 7.01397 13.5592 7.11813 13.5C7.23571 13.4332 7.33555 13.3334 7.53524 13.1337L10.8806 9.78835L4.85128 7.77859C4.03806 7.50752 3.63144 7.37198 3.44365 7.11907C3.27966 6.89823 3.21389 6.6196 3.2618 6.34874C3.31666 6.03855 3.61973 5.73547 4.22588 5.12933L4.59665 4.75856C4.82554 4.52967 4.93999 4.41522 5.07558 4.34433C5.19559 4.28158 5.3271 4.24387 5.46212 4.23347C5.61467 4.22172 5.77238 4.25812 6.08779 4.3309L13.5469 6.05224C13.8569 6.12377 14.0119 6.15953 14.1615 6.14889C14.306 6.13862 14.4465 6.09709 14.5733 6.02718C14.7047 5.95476 14.8153 5.84049 15.0366 5.61196L17.7467 2.81274Z"
        stroke="#393C40"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function jobBag() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1464 17.6611H1.95185C1.427 17.6611 1 17.2341 1 16.7092V10.0791H8.81465L8.80431 10.3876C8.80372 10.4069 8.80153 10.4254 8.79894 10.444C8.79934 11.1175 9.35999 11.6779 10.0493 11.6779C10.7345 11.6779 11.2927 11.1238 11.2991 10.4401C11.2961 10.4198 11.2945 10.4023 11.2941 10.3842L11.2873 10.0791H19.0982V16.7092C19.0982 17.2339 18.6712 17.6611 18.1464 17.6611ZM1.59664 10.6757V16.7092C1.59664 16.9051 1.75595 17.0644 1.95185 17.0644H18.1464C18.3423 17.0644 18.5016 16.9051 18.5016 16.7092V10.6757H11.879C11.7579 11.5771 10.9833 12.2746 10.0491 12.2746C9.11496 12.2746 8.34052 11.5771 8.2192 10.6757H1.59664Z"
        fill="#393C40"
        stroke="#393C40"
        strokeWidth="0.6"
      />
      <path
        d="M18.1464 3.78991H12.8539V3.51168C12.8539 2.12686 11.7273 1 10.3423 1H9.75616C8.37135 1 7.24448 2.12686 7.24448 3.51168V3.78991H1.95185C1.427 3.78991 1 4.21691 1 4.74176V8.84986H19.0982V4.74176C19.0982 4.21691 18.6712 3.78991 18.1464 3.78991ZM7.84113 3.51168C7.84113 2.45561 8.7001 1.59664 9.75616 1.59664H10.3423C11.3983 1.59664 12.2573 2.45561 12.2573 3.51168V3.78991H7.84113V3.51168ZM18.5016 8.25301H1.59664V4.74176C1.59664 4.54606 1.75595 4.38656 1.95185 4.38656H18.1464C18.3423 4.38656 18.5016 4.54586 18.5016 4.74176V8.25301Z"
        fill="#393C40"
        stroke="#393C40"
        strokeWidth="0.6"
      />
    </svg>
  );
}

export function flag() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2753_20018)">
        <path
          d="M8.28125 1.12109V10.1134H18.5571L15.9668 5.61725L18.5571 1.12109H8.28125Z"
          fill="#393C40"
        />
        <path
          d="M4.62109 0H7.10812V15.9822H4.62109V0Z"
          fill="#393C40"
        />
        <path
          d="M8.94196 17.1543H2.79617V18.8283H1.48438V20.0002H10.2539V18.8283H8.94196V17.1543Z"
          fill="#393C40"
        />
      </g>
      <defs>
        <clipPath id="clip0_2753_20018">
          <rect
            width="20"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function sunLight() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.998 20H9.99805V17H11.998V20ZM17.362 17.778L15.241 15.657L16.655 14.243L18.777 16.365L17.364 17.778H17.362ZM4.63405 17.778L3.21905 16.364L5.33905 14.242L6.75405 15.656L4.63405 17.777V17.778ZM10.998 15.007C8.23302 15.0059 5.99231 12.7637 5.99305 9.99867C5.99378 7.23364 8.23568 4.99263 11.0007 4.993C13.7657 4.99337 16.007 7.23497 16.007 10C16.0043 12.7649 13.763 15.0053 10.998 15.007ZM10.998 6.993C9.33759 6.9941 7.99231 8.34087 7.99305 10.0013C7.99378 11.6618 9.34025 13.0074 11.0007 13.007C12.6612 13.0066 14.007 11.6605 14.007 10C14.0054 8.33918 12.6589 6.99355 10.998 6.993ZM20.998 11H17.998V9H20.998V11ZM3.99805 11H0.998047V9H3.99805V11ZM16.654 5.758L15.241 4.343L17.362 2.221L18.777 3.636L16.655 5.757L16.654 5.758ZM5.34105 5.758L3.22105 3.637L4.63605 2.223L6.75605 4.345L5.34205 5.757L5.34105 5.758ZM11.998 3H9.99805V0H11.998V3Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function checkGrey() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="1.1792"
        width="17"
        height="17"
        rx="3.5"
        fill="white"
        stroke="#DFDEDE"
      />
    </svg>
  );
}

export function checked() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="1.1582"
        width="17"
        height="16.9961"
        rx="8.49804"
        fill="white"
        stroke="#D7D7D7"
      />
      <rect
        x="0.5"
        y="1.1582"
        width="17"
        height="17"
        rx="3.5"
        fill="white"
        stroke="#DFDEDE"
      />
      <rect
        x="4"
        y="4.6582"
        width="10"
        height="10"
        rx="2"
        fill="#73C7B7"
      />
    </svg>
  );
}

export function NewSvgLogout() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6676 21.96H7.3853C5.24326 21.96 3.5 20.1699 3.5 17.9685V7.95236C3.5 5.75096 5.24326 3.95996 7.3853 3.95996H11.658C13.8018 3.95996 15.5459 5.75096 15.5459 7.95236V8.79116C15.5459 9.16376 15.2514 9.46616 14.8886 9.46616C14.5257 9.46616 14.2312 9.16376 14.2312 8.79116V7.95236C14.2312 6.49436 13.077 5.30996 11.658 5.30996H7.3853C5.96808 5.30996 4.81467 6.49436 4.81467 7.95236V17.9685C4.81467 19.4256 5.96808 20.61 7.3853 20.61H11.6676C13.0805 20.61 14.2312 19.4292 14.2312 17.9784V17.1297C14.2312 16.7571 14.5257 16.4547 14.8886 16.4547C15.2514 16.4547 15.5459 16.7571 15.5459 17.1297V17.9784C15.5459 20.1744 13.8053 21.96 11.6676 21.96Z"
        fill="#11142D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8416 13.6346H10.2883C9.92548 13.6346 9.63099 13.3322 9.63099 12.9596C9.63099 12.587 9.92548 12.2846 10.2883 12.2846H20.8416C21.2045 12.2846 21.499 12.587 21.499 12.9596C21.499 13.3322 21.2045 13.6346 20.8416 13.6346Z"
        fill="#11142D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2764 16.2594C18.1081 16.2594 17.939 16.1937 17.811 16.0605C17.5551 15.7959 17.556 15.3693 17.8128 15.1065L19.911 12.96L17.8128 10.8144C17.556 10.5516 17.5542 10.125 17.811 9.86042C18.067 9.59583 18.4824 9.59583 18.7401 9.85863L21.3063 12.4821C21.4308 12.6081 21.5 12.7809 21.5 12.96C21.5 13.1391 21.4308 13.3119 21.3063 13.4379L18.7401 16.0623C18.6121 16.1937 18.4438 16.2594 18.2764 16.2594Z"
        fill="#11142D"
      />
    </svg>
  );
}

export function dropGroup() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="17"
        height="16.9961"
        rx="8.49804"
        fill="white"
        stroke="#D7D7D7"
      />
      <rect
        x="0.5"
        y="0.5"
        width="17"
        height="17"
        rx="3.5"
        fill="white"
        stroke="#DFDEDE"
      />
      <line
        x1="5.8"
        y1="9.2"
        x2="12.2"
        y2="9.2"
        stroke="#DFDEDE"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function ArrowSidebar({ className = "" }) {
  return (
    <svg
      width="7"
      height="11"
      viewBox="0 0 7 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.55736 10.2076C0.235177 9.8854 0.235177 9.36304 0.55736 9.04086L4.374 5.22422L0.557361 1.40758C0.235178 1.0854 0.235178 0.563038 0.557361 0.240856C0.879543 -0.081327 1.4019 -0.0813269 1.72409 0.240856L6.12409 4.64086C6.44627 4.96304 6.44627 5.4854 6.12409 5.80758L1.72409 10.2076C1.4019 10.5298 0.879542 10.5298 0.55736 10.2076Z"
        fill="#292929"
      />
    </svg>
  );
}

export function ViewEmployerPosteGroupe() {
  return (
    <svg
      width="17"
      height="12"
      viewBox="0 0 17 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.50024 6.00011C5.50024 4.23586 6.93044 2.80566 8.69469 2.80566C10.459 2.80566 11.8891 4.23586 11.8891 6.00011C11.8891 7.76435 10.459 9.19455 8.69469 9.19455C6.93044 9.19455 5.50024 7.76435 5.50024 6.00011ZM8.69469 4.08344C7.63614 4.08344 6.77802 4.94156 6.77802 6.00011C6.77802 7.05865 7.63614 7.91677 8.69469 7.91677C9.7532 7.91677 10.6114 7.05865 10.6114 6.00011C10.6114 4.94156 9.7532 4.08344 8.69469 4.08344Z"
        fill="#1A4E63"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.15517 4.84689C1.79814 5.36136 1.66669 5.76378 1.66669 6C1.66669 6.23622 1.79814 6.63864 2.15517 7.15311C2.50029 7.65041 3.01328 8.1895 3.6623 8.68762C4.96317 9.68605 6.74667 10.4722 8.69447 10.4722C10.6422 10.4722 12.4258 9.68605 13.7266 8.68762C14.3756 8.1895 14.8886 7.65041 15.2338 7.15311C15.5908 6.63864 15.7222 6.23622 15.7222 6C15.7222 5.76378 15.5908 5.36136 15.2338 4.84689C14.8886 4.34959 14.3756 3.8105 13.7266 3.31238C12.4258 2.31397 10.6422 1.52778 8.69447 1.52778C6.74667 1.52778 4.96317 2.31397 3.6623 3.31238C3.01328 3.8105 2.50029 4.34959 2.15517 4.84689ZM2.88434 2.29873C4.35825 1.16751 6.40808 0.25 8.69447 0.25C10.9808 0.25 13.0307 1.16751 14.5046 2.29873C15.243 2.86542 15.8528 3.49763 16.2835 4.11839C16.7024 4.72198 17 5.38437 17 6C17 6.61563 16.7024 7.27803 16.2835 7.88161C15.8528 8.50237 15.243 9.13456 14.5046 9.7013C13.0307 10.8325 10.9808 11.75 8.69447 11.75C6.40808 11.75 4.35825 10.8325 2.88434 9.7013C2.14596 9.13456 1.5362 8.50237 1.10541 7.88161C0.686528 7.27803 0.388916 6.61563 0.388916 6C0.388916 5.38437 0.686528 4.72198 1.10541 4.11839C1.5362 3.49763 2.14596 2.86542 2.88434 2.29873Z"
        fill="#1A4E63"
      />
    </svg>
  );
}

export function takePicture() {
  return (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="21.4156"
        cy="21.606"
        r="20.1421"
        fill="#73C7B7"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M29.4877 16.1452C29.037 15.6946 28.4933 15.4692 27.8563 15.4692H25.8373L25.3776 14.2434C25.2634 13.949 25.0547 13.6951 24.7511 13.4817C24.4476 13.2684 24.1367 13.1616 23.8181 13.1616H19.2031C18.8846 13.1616 18.5736 13.2684 18.2701 13.4817C17.9666 13.6951 17.7578 13.949 17.6436 14.2434L17.184 15.4692H15.1649C14.5278 15.4692 13.9841 15.6946 13.5334 16.1452C13.0827 16.5959 12.8574 17.1397 12.8574 17.7767V25.853C12.8574 26.49 13.0827 27.0338 13.5334 27.4844C13.9841 27.9351 14.5279 28.1605 15.1649 28.1605H27.8561C28.4931 28.1605 29.0367 27.9351 29.4875 27.4844C29.9381 27.0338 30.1635 26.49 30.1635 25.853V17.7767C30.1636 17.1397 29.9383 16.5959 29.4877 16.1452ZM24.3633 24.6678C23.5731 25.458 22.6223 25.8532 21.5105 25.8532C20.3987 25.8532 19.448 25.458 18.6577 24.6678C17.8674 23.8777 17.4724 22.9266 17.4724 21.8151C17.4724 20.7032 17.8676 19.7524 18.6577 18.9622C19.4479 18.1719 20.3988 17.7769 21.5105 17.7769C22.6223 17.7769 23.5731 18.172 24.3633 18.9622C25.1536 19.7523 25.5487 20.7032 25.5487 21.8151C25.5487 22.9266 25.1536 23.8776 24.3633 24.6678Z"
        fill="white"
      />
      <path
        d="M21.514 19.2207C20.7989 19.2207 20.1874 19.4746 19.6796 19.9824C19.1719 20.4902 18.918 21.1016 18.918 21.8168C18.918 22.5318 19.1719 23.1433 19.6796 23.6511C20.1874 24.1587 20.7988 24.4126 21.514 24.4126C22.229 24.4126 22.8405 24.1587 23.3483 23.6511C23.8561 23.1433 24.11 22.5319 24.11 21.8168C24.11 21.1016 23.8561 20.4903 23.3483 19.9824C22.8405 19.4746 22.229 19.2207 21.514 19.2207Z"
        fill="white"
      />
    </svg>
  );
}

export function arrowArrival() {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 8.3L8.3 5.8C8.7 5.4 9.29999 5.4 9.69999 5.8C10.1 6.2 10.1 6.8 9.69999 7.2L6.1 11.1C5.8 11.3 5.4 11.5 5 11.5C4.6 11.5 4.2 11.3 3.9 11.1L0.3 7.3C-0.1 6.9 -0.1 6.3 0.3 5.9C0.7 5.5 1.29999 5.5 1.69999 5.9L4 8.4L4 1.5C4 0.9 4.4 0.5 5 0.5C5.5 0.5 6 0.9 6 1.5L6 8.3Z"
        fill="#0FBDB0"
      />
    </svg>
  );
}

// Dossier employer
export function couriel() {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6287 15.67H1.95875C0.876962 15.67 0 14.793 0 13.7113V1.87355C0.0456471 0.825171 0.909382 -0.000991496 1.95875 8.93103e-07H17.6287C18.7105 8.93103e-07 19.5875 0.876964 19.5875 1.95875V13.7113C19.5875 14.793 18.7105 15.67 17.6287 15.67ZM1.95875 3.78822V13.7113H17.6287V3.78822L9.79375 9.01025L1.95875 3.78822ZM2.74225 1.95875L9.79375 6.65975L16.8453 1.95875H2.74225Z"
        fill="#292929"
      />
    </svg>
  );
}

export function adresseSection() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9444 19H1.05556C0.472588 19 0 18.5274 0 17.9444V10.2389C0 9.9348 0.131227 9.6455 0.359944 9.44511L2.11111 7.91667V1.05556C2.11111 0.472588 2.5837 0 3.16667 0H17.9444C18.5274 0 19 0.472588 19 1.05556V17.9444C19 18.5274 18.5274 19 17.9444 19ZM6.33333 4.5695C6.58891 4.5698 6.8357 4.66281 7.02789 4.83128L12.3057 9.44933C12.5337 9.64856 12.6651 9.93611 12.6667 10.2389V16.8889H16.8889V2.11111H4.22222V6.06944L5.63772 4.83022C5.83034 4.6619 6.07753 4.56925 6.33333 4.5695ZM5.27778 13.7222H7.38889V16.8889H10.5556V10.7213L6.33333 7.02683L2.11111 10.7213V16.8889H5.27778V13.7222Z"
        fill="#292929"
      />
    </svg>
  );
}

export function contactUrgence() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0001 20C8.48816 20.0043 6.99532 19.6622 5.6361 19C5.13865 18.758 4.66203 18.4754 4.2111 18.155L4.0741 18.055C2.83392 17.1396 1.81997 15.9522 1.1101 14.584C0.375836 13.1679 -0.00499271 11.5952 4.94229e-05 10C4.94229e-05 4.47715 4.47725 0 10.0001 0C15.5229 0 20.0001 4.47715 20.0001 10C20.0051 11.5944 19.6247 13.1664 18.8911 14.582C18.1822 15.9494 17.1697 17.1364 15.9311 18.052C15.4639 18.394 14.968 18.6951 14.4491 18.952L14.3691 18.992C13.009 19.6577 11.5144 20.0026 10.0001 20ZM10.0001 15C8.50158 14.9971 7.12776 15.834 6.4431 17.167C8.68449 18.2772 11.3157 18.2772 13.5571 17.167V17.162C12.8716 15.8305 11.4977 14.9954 10.0001 15ZM10.0001 13C12.1662 13.0028 14.1635 14.1701 15.2291 16.056L15.2441 16.043L15.2581 16.031L15.2411 16.046L15.2311 16.054C17.7601 13.8691 18.6644 10.3423 17.4987 7.21011C16.3331 4.07788 13.3432 2.00032 10.0011 2.00032C6.65901 2.00032 3.66909 4.07788 2.50345 7.21011C1.33781 10.3423 2.2421 13.8691 4.7711 16.054C5.83736 14.169 7.83446 13.0026 10.0001 13ZM10.0001 12C7.79096 12 6.0001 10.2091 6.0001 8C6.0001 5.79086 7.79096 4 10.0001 4C12.2092 4 14.0001 5.79086 14.0001 8C14.0001 9.06087 13.5787 10.0783 12.8285 10.8284C12.0784 11.5786 11.061 12 10.0001 12ZM10.0001 6C8.89553 6 8.0001 6.89543 8.0001 8C8.0001 9.10457 8.89553 10 10.0001 10C11.1047 10 12.0001 9.10457 12.0001 8C12.0001 6.89543 11.1047 6 10.0001 6Z"
        fill="#292929"
      />
    </svg>
  );
}

export function contactUrgence2() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.58333 12.417C11.7004 12.417 13.4167 10.7008 13.4167 8.58366C13.4167 6.46657 11.7004 4.75033 9.58333 4.75033C7.46624 4.75033 5.75 6.46657 5.75 8.58366C5.75 10.7008 7.46624 12.417 9.58333 12.417ZM9.58333 6.66699C10.6419 6.66699 11.5 7.52511 11.5 8.58366C11.5 9.64221 10.6419 10.5003 9.58333 10.5003C8.52479 10.5003 7.66667 9.64221 7.66667 8.58366C7.66667 7.52511 8.52479 6.66699 9.58333 6.66699Z"
        fill="#292929"
      />
      <path
        d="M1.91667 20.0837C0.858121 20.0837 0 19.2255 0 18.167V2.83366C0 1.77511 0.858121 0.916992 1.91667 0.916992H17.25C18.3085 0.916992 19.1667 1.77511 19.1667 2.83366V18.167C19.1667 19.2255 18.3085 20.0837 17.25 20.0837H1.91667ZM1.91667 2.83366V18.167H4.79167C4.79167 15.5206 6.93697 13.3753 9.58333 13.3753C12.2297 13.3753 14.375 15.5206 14.375 18.167H17.25V2.83366H1.91667ZM12.4583 18.167C12.4583 16.5792 11.1712 15.292 9.58333 15.292C7.99551 15.292 6.70833 16.5792 6.70833 18.167H12.4583Z"
        fill="#292929"
      />
    </svg>
  );
}

export function emploi() {
  return (
    <svg
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1464 14.5684H1.95185C1.427 14.5684 1 14.207 1 13.7628V8.15137H8.81465L8.80431 8.41244C8.80372 8.42876 8.80153 8.44442 8.79894 8.46024C8.79934 9.03019 9.35999 9.50452 10.0493 9.50452C10.7345 9.50452 11.2927 9.03557 11.2991 8.45687C11.2961 8.43971 11.2945 8.42489 11.2941 8.40958L11.2873 8.15137H19.0982V13.7628C19.0982 14.2068 18.6712 14.5684 18.1464 14.5684ZM1.59664 8.65634V13.7628C1.59664 13.9286 1.75595 14.0634 1.95185 14.0634H18.1464C18.3423 14.0634 18.5016 13.9286 18.5016 13.7628V8.65634H11.879C11.7579 9.41918 10.9833 10.0095 10.0491 10.0095C9.11496 10.0095 8.34052 9.41918 8.2192 8.65634H1.59664Z"
        fill="#393C40"
        stroke="#393C40"
        strokeWidth="0.6"
      />
      <path
        d="M18.1464 2.82902H12.8539V2.59353C12.8539 1.4215 11.7273 0.467773 10.3423 0.467773H9.75616C8.37135 0.467773 7.24448 1.4215 7.24448 2.59353V2.82902H1.95185C1.427 2.82902 1 3.19041 1 3.63462V7.11151H19.0982V3.63462C19.0982 3.19041 18.6712 2.82902 18.1464 2.82902ZM7.84113 2.59353C7.84113 1.69973 8.7001 0.972745 9.75616 0.972745H10.3423C11.3983 0.972745 12.2573 1.69973 12.2573 2.59353V2.82902H7.84113V2.59353ZM18.5016 6.60637H1.59664V3.63462C1.59664 3.46899 1.75595 3.33399 1.95185 3.33399H18.1464C18.3423 3.33399 18.5016 3.46882 18.5016 3.63462V6.60637Z"
        fill="#393C40"
        stroke="#393C40"
        strokeWidth="0.6"
      />
    </svg>
  );
}

export function holidays() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.998 20H9.99805V17H11.998V20ZM17.362 17.778L15.241 15.657L16.655 14.243L18.777 16.365L17.364 17.778H17.362ZM4.63405 17.778L3.21905 16.364L5.33905 14.242L6.75405 15.656L4.63405 17.777V17.778ZM10.998 15.007C8.23302 15.0059 5.99231 12.7637 5.99305 9.99867C5.99378 7.23364 8.23568 4.99263 11.0007 4.993C13.7657 4.99337 16.007 7.23497 16.007 10C16.0043 12.7649 13.763 15.0053 10.998 15.007ZM10.998 6.993C9.33759 6.9941 7.99231 8.34087 7.99305 10.0013C7.99378 11.6618 9.34025 13.0074 11.0007 13.007C12.6612 13.0066 14.007 11.6605 14.007 10C14.0054 8.33918 12.6589 6.99355 10.998 6.993ZM20.998 11H17.998V9H20.998V11ZM3.99805 11H0.998047V9H3.99805V11ZM16.654 5.758L15.241 4.343L17.362 2.221L18.777 3.636L16.655 5.757L16.654 5.758ZM5.34105 5.758L3.22105 3.637L4.63605 2.223L6.75605 4.345L5.34205 5.757L5.34105 5.758ZM11.998 3H9.99805V0H11.998V3Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function documentDossier() {
  return (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 17.0001H1C0.73459 17.0027 0.479352 16.898 0.292329 16.7097C0.105306 16.5214 0.00239561 16.2654 0.007 16H0V2C0 0.89543 0.89543 0 2 0H8C8.22336 0.00021299 8.44022 0.0751979 8.616 0.213L10.9 2H16C17.1046 2 18 2.89543 18 4V8H19C19.3361 8.00004 19.6498 8.16895 19.8348 8.44959C20.0198 8.73023 20.0514 9.08505 19.919 9.394L16.919 16.394C16.7614 16.7616 16.4 17.0001 16 17.0001ZM4.66 10L2.517 15H15.341L17.484 10H4.66ZM2 4V11.13L3.081 8.606C3.23858 8.2384 3.60004 8.00004 4 8H16V4H2Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function notesDossier() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 18H2C0.89543 18 0 17.1046 0 16V2C0 0.89543 0.89543 0 2 0H16C17.1046 0 18 0.89543 18 2V10C17.9996 10.0116 17.9975 10.023 17.994 10.034C17.9911 10.0431 17.9891 10.0525 17.988 10.062C17.9823 10.1502 17.9652 10.2373 17.937 10.321L17.928 10.348C17.9213 10.3706 17.9129 10.3926 17.903 10.414C17.8546 10.5229 17.7868 10.6222 17.703 10.707L10.703 17.707C10.5165 17.8936 10.2638 17.9989 10 18ZM2 2V16H9V10C9 9.44772 9.44772 9 10 9H16V2H2ZM11 11V14.587L14.586 11H11Z"
        fill="#292929"
      />
    </svg>
  );
}

export function certificationFormation() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0256 16.2074C14.3001 16.2511 14.5804 16.1841 14.8053 16.0196C15.0272 15.8594 15.182 15.6118 15.2229 15.3365L15.4697 13.7009C15.5193 13.3717 15.7252 13.0921 16.0231 12.9421L17.5081 12.2022C17.7592 12.0755 17.9476 11.8585 18.0323 11.5948C18.1199 11.3283 18.0921 11.0428 17.9666 10.7953L17.2014 9.31986C17.051 9.03148 17.051 8.68048 17.2014 8.38919L17.9666 6.91525C18.0921 6.66766 18.1184 6.38219 18.0323 6.11566C17.9461 5.85058 17.7578 5.63503 17.5081 5.50832L16.0231 4.76844C15.7252 4.61842 15.5193 4.33878 15.4697 4.00962L15.2229 2.37402C15.182 2.09875 15.0272 1.85261 14.8053 1.6924C14.5804 1.52637 14.3001 1.45937 14.0256 1.50452L12.3829 1.77833C12.0573 1.83222 11.7273 1.72444 11.4936 1.48995L10.327 0.307313C10.1298 0.110691 9.86555 0 9.5852 0C9.30923 0 9.03909 0.112148 8.84343 0.307313L7.67676 1.48995C7.44459 1.7259 7.11313 1.83222 6.78752 1.77833L5.14775 1.50889C4.87324 1.46374 4.59288 1.53074 4.36656 1.69677C4.14315 1.85698 3.98984 2.10312 3.94895 2.37839L3.70364 4.01399C3.65254 4.34315 3.44811 4.62279 3.15024 4.77281L1.66379 5.51269C1.41702 5.6394 1.22574 5.85495 1.14105 6.12003C1.0549 6.38656 1.07972 6.67203 1.2053 6.91962L1.97042 8.39356C2.12228 8.68339 2.12228 9.0344 1.97042 9.32423L1.2053 10.7996C1.07972 11.0472 1.0549 11.3327 1.14105 11.5992C1.2272 11.8628 1.41556 12.0798 1.66379 12.2066L3.15024 12.9464C3.44811 13.0965 3.65254 13.3761 3.70364 13.7053L3.94895 15.3409C3.98984 15.6147 4.14315 15.8623 4.36656 16.0239C4.59142 16.1885 4.87178 16.2555 5.14775 16.2118L6.78752 15.9424C7.11313 15.8856 7.44459 15.9948 7.67676 16.2293L8.84343 17.409C9.04056 17.61 9.30777 17.7207 9.5852 17.7207C9.86409 17.7207 10.1313 17.61 10.327 17.409L11.4936 16.2293C11.7273 15.9948 12.0587 15.8856 12.3829 15.9424L14.0256 16.2074ZM9.58374 15.0132C6.09394 15.0132 3.25683 12.1833 3.25683 8.70378C3.25683 5.22431 6.0954 2.3915 9.58374 2.3915C13.0735 2.3915 15.9106 5.22577 15.9106 8.70378C15.9106 12.1818 13.075 15.0132 9.58374 15.0132Z"
        fill="#3D3F3C"
      />
      <path
        d="M9.58525 3.30176C6.60505 3.30176 4.17825 5.71948 4.17825 8.69356C4.17825 11.6676 6.60651 14.0854 9.58525 14.0854C12.5684 14.0854 14.9923 11.6676 14.9923 8.69356C14.9923 5.71948 12.5684 3.30176 9.58525 3.30176Z"
        fill="#3D3F3C"
      />
      <path
        d="M19.0077 17.3886L16.0654 14.4523L15.9165 15.4427C15.8464 15.8986 15.5923 16.3195 15.2171 16.589C14.8447 16.8599 14.3789 16.9749 13.9146 16.8992L12.2704 16.6312C12.1347 16.6225 12.0529 16.6603 11.993 16.7215L11.7127 17.0026L15.5558 20.8345C15.7048 20.9831 15.9194 21.0355 16.118 20.9758C16.3166 20.9132 16.4626 20.7486 16.5035 20.5432L16.8495 18.6834L18.72 18.3338C18.9244 18.2959 19.0894 18.1488 19.1493 17.9493C19.2106 17.7498 19.1551 17.5328 19.0077 17.3886Z"
        fill="#3D3F3C"
      />
      <path
        d="M6.95251 16.6239L5.25872 16.8992C4.78416 16.972 4.32421 16.8584 3.95041 16.5846C3.57806 16.3166 3.32399 15.8972 3.2539 15.4384L3.10497 14.4523L0.164191 17.3886C0.0181739 17.5342 -0.0358519 17.7498 0.0240149 17.9478C0.0868021 18.1474 0.253261 18.2916 0.454764 18.3323L2.32378 18.6804L2.67422 20.5432C2.71218 20.7486 2.85966 20.9132 3.05824 20.9758C3.25537 21.0355 3.47147 20.9831 3.61749 20.836L7.45919 17.0026L7.17883 16.7201C7.11751 16.6574 7.03574 16.6239 6.95251 16.6239Z"
        fill="#3D3F3C"
      />
    </svg>
  );
}

export function certificationsItems() {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3577 15.4357C13.6191 15.4773 13.8861 15.4135 14.1003 15.2567C14.3117 15.1041 14.4591 14.8683 14.498 14.6062L14.733 13.0485C14.7803 12.735 14.9764 12.4687 15.2601 12.3258L16.6743 11.6211C16.9135 11.5005 17.0929 11.2938 17.1736 11.0427C17.257 10.7889 17.2306 10.517 17.111 10.2812L16.3823 8.87606C16.2391 8.60141 16.2391 8.26712 16.3823 7.9897L17.111 6.58596C17.2306 6.35015 17.2556 6.07828 17.1736 5.82444C17.0915 5.57199 16.9121 5.36669 16.6743 5.24602L15.2601 4.54137C14.9764 4.3985 14.7803 4.13217 14.733 3.81869L14.498 2.26097C14.4591 1.99881 14.3117 1.76439 14.1003 1.61181C13.8861 1.45368 13.6191 1.38988 13.3577 1.43288L11.7932 1.69365C11.4831 1.74497 11.1688 1.64233 10.9463 1.419L9.8352 0.292679C9.64747 0.10542 9.39576 0 9.12876 0C8.86593 0 8.60866 0.106807 8.42232 0.292679L7.3112 1.419C7.09009 1.64371 6.77441 1.74497 6.4643 1.69365L4.90262 1.43704C4.64118 1.39404 4.37418 1.45784 4.15863 1.61597C3.94586 1.76855 3.79984 2.00297 3.76091 2.26514L3.52728 3.82285C3.47861 4.13633 3.28392 4.40266 3.00023 4.54553L1.58456 5.25018C1.34954 5.37085 1.16737 5.57615 1.08671 5.8286C1.00467 6.08244 1.02831 6.35431 1.1479 6.59012L1.87659 7.99386C2.02122 8.2699 2.02122 8.60419 1.87659 8.88022L1.1479 10.2854C1.02831 10.5212 1.00467 10.793 1.08671 11.0469C1.16876 11.2979 1.34815 11.5046 1.58456 11.6253L3.00023 12.3299C3.28392 12.4728 3.47861 12.7391 3.52728 13.0526L3.76091 14.6103C3.79984 14.8711 3.94586 15.1069 4.15863 15.2609C4.37279 15.4176 4.63979 15.4814 4.90262 15.4398L6.4643 15.1832C6.77441 15.1291 7.09009 15.2331 7.3112 15.4565L8.42232 16.58C8.61005 16.7714 8.86454 16.8769 9.12876 16.8769C9.39437 16.8769 9.64886 16.7714 9.8352 16.58L10.9463 15.4565C11.1688 15.2331 11.4845 15.1291 11.7932 15.1832L13.3577 15.4357ZM9.12737 14.2982C5.80375 14.2982 3.10174 11.6031 3.10174 8.28932C3.10174 4.97553 5.80514 2.27762 9.12737 2.27762C12.451 2.27762 15.153 4.97692 15.153 8.28932C15.153 11.6017 12.4524 14.2982 9.12737 14.2982Z"
        fill="#3D3F3C"
      />
      <path
        d="M9.12881 3.14453C6.29052 3.14453 3.97929 5.44712 3.97929 8.27958C3.97929 11.112 6.29192 13.4146 9.12881 13.4146C11.9699 13.4146 14.2783 11.112 14.2783 8.27958C14.2783 5.44712 11.9699 3.14453 9.12881 3.14453Z"
        fill="#3D3F3C"
      />
      <path
        d="M18.1025 16.5605L15.3004 13.7641L15.1586 14.7074C15.0918 15.1415 14.8498 15.5424 14.4924 15.799C14.1378 16.057 13.6942 16.1666 13.252 16.0945L11.6861 15.8392C11.5568 15.8309 11.4789 15.867 11.4219 15.9252L11.1549 16.193L14.8151 19.8424C14.9569 19.9839 15.1613 20.0338 15.3505 19.977C15.5396 19.9173 15.6787 19.7606 15.7176 19.565L16.0472 17.7937L17.8286 17.4608C18.0233 17.4247 18.1804 17.2846 18.2374 17.0946C18.2958 16.9045 18.243 16.6979 18.1025 16.5605Z"
        fill="#3D3F3C"
      />
      <path
        d="M6.62144 15.8323L5.0083 16.0945C4.55634 16.1638 4.11829 16.0556 3.76229 15.7949C3.40768 15.5396 3.16571 15.1401 3.09896 14.7032L2.95711 13.7641L0.156372 16.5605C0.0173084 16.6992 -0.0341447 16.9045 0.0228714 17.0932C0.0826687 17.2832 0.241201 17.4205 0.433109 17.4594L2.21312 17.7909L2.54687 19.565C2.58303 19.7606 2.72349 19.9173 2.91261 19.977C3.10035 20.0338 3.30616 19.9839 3.44523 19.8438L7.10399 16.193L6.83698 15.9239C6.77858 15.8642 6.7007 15.8323 6.62144 15.8323Z"
        fill="#3D3F3C"
      />
    </svg>
  );
}

export function Formations() {
  return (
    <svg
      width="25"
      height="15"
      viewBox="0 0 25 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5198 1.51767L12.7139 0.959961L12.5198 1.51767L22.9698 5.15246L12.512 8.78997C12.388 8.83309 12.2532 8.83368 12.1289 8.79165L1.59058 5.2294L12.1298 1.51842C12.2559 1.47398 12.3935 1.47372 12.5198 1.51767ZM23.2869 4.99513C23.2877 4.99327 23.2882 4.99232 23.2882 4.99232C23.2883 4.99231 23.2879 4.99323 23.2869 4.99513ZM1.00002 5.00088C1.00022 5.00093 1.00209 5.00327 1.00503 5.00776C1.00129 5.00309 0.999816 5.00084 1.00002 5.00088ZM23.236 13.387C23.2974 13.679 23.0747 13.9534 22.7764 13.9534C22.4781 13.9534 22.2552 13.679 22.3167 13.387L22.5565 12.248C22.5645 12.2456 22.5744 12.2431 22.5866 12.241C22.6139 12.2363 22.6465 12.2347 22.6815 12.2379C22.8209 12.2504 22.9325 12.2792 22.9985 12.3123C23.0034 12.3147 23.0076 12.317 23.0112 12.319L23.236 13.387ZM6.38042 9.83864C6.38042 9.43188 6.78206 9.14693 7.16598 9.2813L11.733 10.8798C12.1164 11.014 12.5344 11.0123 12.9166 10.875L17.3126 9.29701C17.6974 9.15892 18.1025 9.44403 18.1025 9.85278V11.8607C18.1025 12.0461 18.0218 12.1964 17.9058 12.2789C14.816 14.4779 9.81423 14.7673 6.56472 12.2907C6.45578 12.2077 6.38042 12.0617 6.38042 11.8831V9.83864ZM22.8392 10.4607C22.8392 10.4954 22.8111 10.5235 22.7764 10.5235C22.7417 10.5235 22.7136 10.4954 22.7136 10.4607C22.7136 10.426 22.7417 10.3979 22.7764 10.3979C22.8111 10.3979 22.8392 10.426 22.8392 10.4607Z"
        fill="#3D3F3C"
      />
      <path
        d="M12.5198 1.51767L12.7139 0.959961L12.5198 1.51767ZM12.5198 1.51767L22.9698 5.15246L12.512 8.78997C12.388 8.83309 12.2532 8.83368 12.1289 8.79165L1.59058 5.2294L12.1298 1.51842C12.2559 1.47398 12.3935 1.47372 12.5198 1.51767ZM23.2869 4.99513C23.2877 4.99327 23.2882 4.99232 23.2882 4.99232C23.2883 4.99231 23.2879 4.99323 23.2869 4.99513ZM1.00002 5.00088C1.00022 5.00093 1.00209 5.00327 1.00503 5.00776C1.00129 5.00309 0.999816 5.00084 1.00002 5.00088ZM23.236 13.387C23.2974 13.679 23.0747 13.9534 22.7764 13.9534C22.4781 13.9534 22.2552 13.679 22.3167 13.387L22.5565 12.248C22.5645 12.2456 22.5744 12.2431 22.5866 12.241C22.6139 12.2363 22.6465 12.2347 22.6815 12.2379C22.8209 12.2504 22.9325 12.2792 22.9985 12.3123C23.0034 12.3147 23.0076 12.317 23.0112 12.319L23.236 13.387ZM6.38042 9.83864C6.38042 9.43188 6.78206 9.14693 7.16598 9.2813L11.733 10.8798C12.1164 11.014 12.5344 11.0123 12.9166 10.875L17.3126 9.29701C17.6974 9.15892 18.1025 9.44403 18.1025 9.85278V11.8607C18.1025 12.0461 18.0218 12.1964 17.9058 12.2789C14.816 14.4779 9.81423 14.7673 6.56472 12.2907C6.45578 12.2077 6.38042 12.0617 6.38042 11.8831V9.83864ZM22.8392 10.4607C22.8392 10.4954 22.8111 10.5235 22.7764 10.5235C22.7417 10.5235 22.7136 10.4954 22.7136 10.4607C22.7136 10.426 22.7417 10.3979 22.7764 10.3979C22.8111 10.3979 22.8392 10.426 22.8392 10.4607Z"
        stroke="#3D3F3C"
      />
    </svg>
  );
}

export function FormationsItems() {
  return (
    <svg
      width="23"
      height="14"
      viewBox="0 0 23 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6391 1.47601L11.8183 0.960938L11.6391 1.47601L21.2902 4.83291L11.6319 8.19232C11.5174 8.23214 11.3929 8.23269 11.2781 8.19387L1.54543 4.90397L11.2789 1.4767C11.3954 1.43566 11.5224 1.43542 11.6391 1.47601ZM21.583 4.68761C21.5838 4.68589 21.5842 4.68501 21.5842 4.68501C21.5843 4.685 21.5839 4.68585 21.583 4.68761ZM1.00002 4.69292C1.0002 4.69296 1.00193 4.69512 1.00465 4.69928C1.00119 4.69496 0.99983 4.69288 1.00002 4.69292ZM21.536 12.4379C21.5927 12.7076 21.387 12.961 21.1115 12.961C20.836 12.961 20.6302 12.7076 20.687 12.4379L20.9084 11.386C20.9158 11.3837 20.925 11.3814 20.9362 11.3795C20.9614 11.3752 20.9915 11.3737 21.0239 11.3766C21.1526 11.3882 21.2557 11.4148 21.3167 11.4453C21.3211 11.4476 21.3251 11.4497 21.3283 11.4516L21.536 12.4379ZM5.96907 9.16082C5.96907 8.78515 6.34001 8.52199 6.69458 8.64609L10.9124 10.1223C11.2665 10.2463 11.6525 10.2447 12.0056 10.118L16.0655 8.6606C16.4208 8.53306 16.795 8.79638 16.795 9.17387V11.0283C16.795 11.1995 16.7204 11.3383 16.6133 11.4145C13.7597 13.4454 9.14036 13.7126 6.13929 11.4254C6.03867 11.3488 5.96907 11.2139 5.96907 11.049V9.16082ZM21.1695 9.73533C21.1695 9.76738 21.1436 9.79336 21.1115 9.79336C21.0795 9.79336 21.0535 9.76738 21.0535 9.73533C21.0535 9.70328 21.0795 9.6773 21.1115 9.6773C21.1436 9.6773 21.1695 9.70328 21.1695 9.73533Z"
        fill="#3D3F3C"
      />
      <path
        d="M11.6391 1.47601L11.8183 0.960938L11.6391 1.47601ZM11.6391 1.47601L21.2902 4.83291L11.6319 8.19232C11.5174 8.23214 11.3929 8.23269 11.2781 8.19387L1.54543 4.90397L11.2789 1.4767C11.3954 1.43566 11.5224 1.43542 11.6391 1.47601ZM21.583 4.68761C21.5838 4.68589 21.5842 4.68501 21.5842 4.68501C21.5843 4.685 21.5839 4.68585 21.583 4.68761ZM1.00002 4.69292C1.0002 4.69296 1.00193 4.69512 1.00465 4.69928C1.00119 4.69496 0.99983 4.69288 1.00002 4.69292ZM21.536 12.4379C21.5927 12.7076 21.387 12.961 21.1115 12.961C20.836 12.961 20.6302 12.7076 20.687 12.4379L20.9084 11.386C20.9158 11.3837 20.925 11.3814 20.9362 11.3795C20.9614 11.3752 20.9915 11.3737 21.0239 11.3766C21.1526 11.3882 21.2557 11.4148 21.3167 11.4453C21.3211 11.4476 21.3251 11.4497 21.3283 11.4516L21.536 12.4379ZM5.96907 9.16082C5.96907 8.78515 6.34001 8.52199 6.69458 8.64609L10.9124 10.1223C11.2665 10.2463 11.6525 10.2447 12.0056 10.118L16.0655 8.6606C16.4208 8.53306 16.795 8.79638 16.795 9.17387V11.0283C16.795 11.1995 16.7204 11.3383 16.6133 11.4145C13.7597 13.4454 9.14035 13.7126 6.13929 11.4254C6.03867 11.3488 5.96907 11.2139 5.96907 11.049V9.16082ZM21.1695 9.73533C21.1695 9.76738 21.1436 9.79336 21.1115 9.79336C21.0795 9.79336 21.0535 9.76738 21.0535 9.73533C21.0535 9.70328 21.0795 9.6773 21.1115 9.6773C21.1436 9.6773 21.1695 9.70328 21.1695 9.73533Z"
        stroke="#3D3F3C"
      />
    </svg>
  );
}

// End Dossier employer
export function arrowStarting() {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3.7L1.7 6.2C1.3 6.6 0.700006 6.6 0.300006 6.2C-0.0999932 5.8 -0.0999932 5.2 0.300006 4.8L3.90001 0.899999C4.20001 0.699999 4.6 0.5 5 0.5C5.4 0.5 5.8 0.699999 6.1 0.899999L9.7 4.7C10.1 5.1 10.1 5.7 9.7 6.1C9.3 6.5 8.70001 6.5 8.30001 6.1L6 3.6L6 10.5C6 11.1 5.6 11.5 5 11.5C4.5 11.5 4 11.1 4 10.5L4 3.7Z"
        fill="#FB5A57"
      />
    </svg>
  );
}

export function CloseMiddle() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.1704 0.461914L4.94861 3.68371L1.72681 0.461914L0.461426 1.7273L3.68322 4.94909L0.461426 8.17089L1.72681 9.43627L4.94861 6.21448L8.1704 9.43627L9.43578 8.17089L6.21399 4.94909L9.43578 1.7273L8.1704 0.461914Z"
        fill="#292929"
      />
    </svg>
  );
}

export function ArrowUp() {
  return (
    <svg
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.991952 5.59961C0.291074 5.59961 -0.103171 4.68593 0.247269 3.98724L2.87556 0.52363C3.226 -0.175064 4.05829 -0.175064 4.36493 0.52363L6.99322 3.98724C7.34366 4.68593 6.90561 5.59961 6.24854 5.59961L0.991952 5.59961Z"
        fill="#292929"
      />
    </svg>
  );
}

export function ArrowDown() {
  return (
    <svg
      width="8"
      height="7"
      viewBox="0 0 8 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.24242 0.599609C6.9433 0.599609 7.33755 1.51329 6.98711 2.21198L4.35881 5.67559C4.00837 6.37428 3.17608 6.37428 2.86945 5.67559L0.241152 2.21198C-0.109287 1.51329 0.328762 0.599609 0.985835 0.599609L6.24242 0.599609Z"
        fill="#292929"
      />
    </svg>
  );
}

export function NewCommentIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 0C15.1046 0 16 0.895431 16 2L2 2L2 13.1765C0.895432 13.1765 0 12.281 0 11.1765V2C0 0.895428 0.895431 0 2 0H14Z"
        fill="#292929"
      />
      <path
        d="M12 20L9.33333 17.1765H6C4.89543 17.1765 4 16.281 4 15.1765V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V15.1765C20 16.281 19.1046 17.1765 18 17.1765H14.6667L12 20ZM13.8046 15.1765L18 15.1765V6L6 6V15.1765H10.1954L12 17.0872L13.8046 15.1765Z"
        fill="#292929"
      />
    </svg>
  );
}

export function UserSlash() {
  return (
    <svg
      width="21"
      height="23"
      viewBox="0 0 21 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0_7419_26689)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.9306 13.9234C5.69137 13.9234 3.54241 14.6516 3.54241 16.0892C3.54241 17.5398 5.69137 18.275 9.9306 18.275C14.1688 18.275 16.3168 17.5468 16.3168 16.1091C16.3168 14.6586 14.1688 13.9234 9.9306 13.9234ZM9.93131 19.766C7.98232 19.766 2.05078 19.766 2.05078 16.0879C2.05078 12.8087 6.54868 12.4297 9.93131 12.4297C11.8803 12.4297 17.8098 12.4297 17.8098 16.1078C17.8098 19.387 13.3129 19.766 9.93131 19.766Z"
          fill="black"
        />
      </g>
      <g mask="url(#mask1_7419_26689)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.92968 1.42411C7.79962 1.42411 6.06652 3.15621 6.06652 5.28627C6.05956 7.40937 7.77972 9.14048 9.90083 9.14844L9.92968 9.85879V9.14844C12.0587 9.14844 13.7909 7.41534 13.7909 5.28627C13.7909 3.15621 12.0587 1.42411 9.92968 1.42411ZM9.93038 10.5647H9.89854C6.99147 10.5558 4.63657 8.18497 4.64652 5.27988C4.64652 2.36983 7.01635 0 9.93038 0C12.8434 0 15.2123 2.36983 15.2123 5.28287C15.2123 8.19591 12.8434 10.5647 9.93038 10.5647Z"
          fill="black"
        />
      </g>
      <path
        d="M0.867713 20.2207L0.867789 20.2206L18.0099 2.02383C18.0101 2.02363 18.0103 2.02342 18.0105 2.02322C18.5223 1.47659 19.382 1.45108 19.9276 1.96102C20.4756 2.47213 20.5026 3.33013 19.9894 3.87508L19.9894 3.87516L2.84614 22.0731C2.84609 22.0732 2.84605 22.0732 2.846 22.0733C2.578 22.3579 2.21675 22.5 1.85689 22.5C1.52546 22.5 1.19177 22.3794 0.92958 22.1348L0.867713 20.2207ZM0.867713 20.2207C0.354635 20.7656 0.381504 21.6235 0.929418 22.1346L0.867713 20.2207Z"
        fill="black"
        stroke="white"
      />
    </svg>
  );
}

export function CandidateSource() {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.04575 10.8191L7.04575 0.634378C7.04575 0.284201 7.33081 -4.27948e-08 7.68205 -2.75739e-08C8.03329 -1.23531e-08 8.31836 0.284201 8.31836 0.634378L8.31836 10.8191C8.31836 11.1693 8.03329 11.4535 7.68205 11.4535C7.33081 11.4535 7.04575 11.1693 7.04575 10.8191Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.50023 8.28695C4.50023 8.12144 4.5636 7.95506 4.69206 7.8292C4.94725 7.57662 5.35868 7.57834 5.61213 7.83093L7.68143 9.89469L9.7516 7.83093C10.0051 7.57834 10.4165 7.57662 10.6717 7.8292C10.9269 8.08178 10.9269 8.4904 10.6734 8.74298L8.14234 11.2679C8.02082 11.3904 7.85416 11.4585 7.68143 11.4585C7.5087 11.4585 7.34205 11.3904 7.22053 11.2679L4.69032 8.74298C4.5636 8.61712 4.50023 8.45161 4.50023 8.28695Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.409 17.5769L15.409 7.39219C15.409 7.04201 15.6941 6.75781 16.0453 6.75781C16.3966 6.75781 16.6816 7.04201 16.6816 7.39219L16.6816 17.5769C16.6816 17.9271 16.3966 18.2113 16.0453 18.2113C15.6941 18.2113 15.409 17.9271 15.409 17.5769Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8635 15.0448C12.8635 14.8793 12.9269 14.7129 13.0553 14.587C13.3105 14.3344 13.722 14.3362 13.9754 14.5887L16.0447 16.6525L18.1149 14.5887C18.3683 14.3362 18.7798 14.3344 19.035 14.587C19.2901 14.8396 19.2901 15.2482 19.0367 15.5008L16.5056 18.0258C16.3841 18.1482 16.2174 18.2163 16.0447 18.2163C15.872 18.2163 15.7053 18.1482 15.5838 18.0258L13.0536 15.5008C12.9269 15.3749 12.8635 15.2094 12.8635 15.0448Z"
        fill="black"
      />
      <path
        d="M1 16L3.95455 22.5H21.6818"
        stroke="black"
        strokeWidth="1.5"
      />
      <path
        d="M25.2266 16L22.272 22.5H4.54475"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function NewSvgWorld() {
  return (
    <svg
      width="34"
      height="32"
      viewBox="0 0 34 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31C24.2842 31 31 24.2843 31 16C31 7.71573 24.2842 1 16 1ZM29.0786 10.8428H25.1905C24.4405 6.92238 22.7959 4.45994 21.5072 3.06184C24.955 4.53503 27.6958 7.34861 29.0786 10.8428ZM24.6842 15.3298C24.6842 17.1572 24.5174 18.7791 24.2459 20.2188H16.4688V11.7803H24.42C24.5861 12.855 24.6842 14.0332 24.6842 15.3298ZM19.2753 29.6733C18.3702 29.8902 17.4318 30.0188 16.4688 30.0506V21.1562H24.0502C22.6801 27.0326 19.5425 29.4748 19.2753 29.6733ZM13.2131 29.6876C13.1996 29.678 11.8412 28.7157 10.5009 26.4787C9.77186 25.2619 8.96256 23.5055 8.41797 21.1562H15.5312V30.0506C14.7794 30.0258 14.0424 29.9429 13.3246 29.804C13.2944 29.7605 13.2591 29.7196 13.2131 29.6876ZM7.78427 15.3298C7.78427 14.0338 7.87187 12.8555 8.02005 11.7803H15.5312V20.2188H8.2218C7.95344 18.7889 7.78427 17.1664 7.78427 15.3298ZM12.4977 2.37911C13.4721 2.12847 14.488 1.98381 15.5312 1.94941V10.8428H8.16962C9.20022 5.16536 11.9838 2.77633 12.4977 2.37911ZM16.4688 10.8428V1.94941C17.4338 1.98119 18.3742 2.11028 19.281 2.32792C19.2818 2.32844 19.2822 2.32933 19.2831 2.3298C19.3277 2.35623 22.9811 4.60384 24.2521 10.8428H16.4688ZM10.5357 3.04263C9.38627 4.43416 7.90727 6.90189 7.23466 10.8428H2.92131C4.30989 7.33398 7.0675 4.51075 10.5357 3.04263ZM2.58517 11.7803H7.09239C6.95237 12.8605 6.87194 14.0407 6.87194 15.3298C6.87194 17.148 7.02784 18.7702 7.28514 20.2188H2.58489C2.16494 18.8863 1.9375 17.4693 1.9375 16C1.9375 14.5303 2.16503 13.113 2.58517 11.7803ZM2.92098 21.1562H7.47138C8.40306 25.3997 10.2204 27.9746 11.4488 29.3024C7.55477 27.9663 4.429 24.9677 2.92098 21.1562ZM21.2557 29.0397C22.4715 27.6479 24.1237 25.1357 24.9975 21.1562H29.079C27.663 24.735 24.8212 27.5973 21.2557 29.0397ZM29.4151 20.2188H25.1837C25.441 18.7702 25.597 17.148 25.597 15.3298C25.597 14.0408 25.5069 12.8605 25.3499 11.7803H29.4148C29.8349 13.113 30.0625 14.5303 30.0625 16C30.0625 17.4693 29.835 18.8863 29.4151 20.2188Z"
        fill="#292929"
        stroke="#292929"
        strokeWidth="0.6"
      />
      <circle
        cx="24.5709"
        cy="21.7144"
        r="9.28572"
        fill="#292929"
      />
      <path
        d="M24.5709 31.0001C19.4425 31.0001 15.2852 26.8428 15.2852 21.7144C15.2852 16.5861 19.4425 12.4287 24.5709 12.4287C29.6992 12.4287 33.8566 16.5861 33.8566 21.7144C33.851 26.8405 29.6969 30.9945 24.5709 31.0001ZM24.5709 14.2859C20.4682 14.2859 17.1423 17.6117 17.1423 21.7144C17.1423 25.8171 20.4682 29.143 24.5709 29.143C28.6736 29.143 31.9994 25.8171 31.9994 21.7144C31.9948 17.6136 28.6716 14.2905 24.5709 14.2859ZM29.2137 22.643H23.6423V17.0716H25.4994V20.7859H29.2137V22.643Z"
        fill="#F9FAFC"
      />
    </svg>
  );
}

export function filesIcones() {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2 16H1.6C0.716344 16 0 15.2837 0 14.4V1.6C0 0.716344 0.716344 0 1.6 0H7.2C7.20872 0.000377855 7.21734 0.00199405 7.2256 0.0048C7.23341 0.00721379 7.24146 0.00882216 7.2496 0.0096C7.32015 0.0141226 7.3898 0.0278385 7.4568 0.0504L7.4792 0.0576C7.49733 0.0637456 7.51498 0.0712329 7.532 0.08C7.61915 0.118739 7.69857 0.172948 7.7664 0.24L12.5664 5.04C12.6335 5.10783 12.6877 5.18724 12.7264 5.2744C12.7344 5.292 12.74 5.3104 12.7464 5.3288L12.7536 5.3496C12.7759 5.41631 12.7891 5.48574 12.7928 5.556C12.794 5.56335 12.7959 5.57057 12.7984 5.5776C12.7998 5.58498 12.8004 5.5925 12.8001 5.6V14.4C12.8001 15.2837 12.0837 16 11.2 16ZM1.6 1.6V14.4H11.2V6.4H7.2C6.75817 6.4 6.4 6.04183 6.4 5.6V1.6H1.6ZM8 2.7312V4.8H10.0688L8 2.7312Z"
        fill="#2E3A59"
      />
    </svg>
  );
}

export function ArrowDropdown() {
  return (
    <svg
      width="6"
      height="8"
      viewBox="0 0 6 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.979492 0.907968C0.979492 0.207089 1.74219 -0.187155 2.32542 0.163284L5.21668 2.79158C5.79991 3.14202 5.79991 3.97431 5.21668 4.28094L2.32542 6.90924C1.74219 7.25968 0.979492 6.82163 0.979492 6.16456L0.979492 0.907968Z"
        fill="#292929"
      />
    </svg>
  );
}

export function ClockBlack() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1192 20C4.66213 20 0.238281 15.5228 0.238281 10C0.238281 4.47715 4.66213 0 10.1192 0C15.5763 0 20.0002 4.47715 20.0002 10C19.9942 15.5203 15.5739 19.9939 10.1192 20ZM10.1192 2C5.75355 2 2.21447 5.58172 2.21447 10C2.21447 14.4183 5.75355 18 10.1192 18C14.4849 18 18.024 14.4183 18.024 10C18.0191 5.58378 14.4829 2.00496 10.1192 2ZM15.0597 11H9.13114V5H11.1073V9H15.0597V11Z"
        fill="#292929"
      />
    </svg>
  );
}

export function IconRepasRounded() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.5 14.1667C15.1988 14.1667 13.3333 12.3012 13.3333 10C13.3333 7.69881 15.1988 5.83333 17.5 5.83333M17.5 17.5C13.3579 17.5 10 14.1421 10 10C10 5.85786 13.3579 2.5 17.5 2.5M5 9.16667L5 17.5M5 2.5L5 6.66667M2.91667 6.66667H7.08333M7.5 2.5L7.5 6.12687C7.5 10.18 2.5 10.1799 2.5 6.12673V2.5" stroke="#141B34" stroke-width="1.3" stroke-linecap="round"/>
    </svg>
  );
}

export function SvgAddNewCandidate() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.52954 0C4.55197 0 2.94883 1.60314 2.94883 3.58072C2.94883 5.55829 4.55197 7.16143 6.52954 7.16143C8.50712 7.16143 10.1103 5.55829 10.1103 3.58072C10.1103 1.60314 8.50712 0 6.52954 0ZM4.21261 3.58072C4.21261 2.30111 5.24994 1.26378 6.52954 1.26378C7.80915 1.26378 8.84648 2.30111 8.84648 3.58072C8.84648 4.86032 7.80915 5.89765 6.52954 5.89765C5.24994 5.89765 4.21261 4.86032 4.21261 3.58072Z"
        fill="#292929"
      />
      <path
        d="M1.26378 11.5847C1.26378 10.5377 2.1125 9.689 3.15946 9.689H3.44665C3.46885 9.689 3.49092 9.69251 3.51203 9.6994L4.24124 9.93751C4.81376 10.1245 5.40346 10.2394 5.99711 10.2824C6.12203 10.2914 6.23167 10.2037 6.2599 10.0817C6.32357 9.80642 6.40651 9.53854 6.50722 9.27953C6.55168 9.16519 6.46814 9.03879 6.34552 9.0351C5.76706 9.01767 5.19048 8.91802 4.63352 8.73615L3.90431 8.49804C3.75655 8.44979 3.60208 8.42522 3.44665 8.42522H3.15946C1.41454 8.42522 0 9.83975 0 11.5847V12.5858C0 13.2204 0.459919 13.7615 1.08624 13.8638C2.90452 14.1607 4.74102 14.3078 6.57736 14.3052C6.7055 14.305 6.78598 14.1666 6.72863 14.052C6.60491 13.8048 6.49805 13.5476 6.40956 13.2821C6.36224 13.1401 6.23203 13.0404 6.08235 13.0384C4.47923 13.0163 2.87734 12.8757 1.28988 12.6165C1.27483 12.6141 1.26378 12.6011 1.26378 12.5858V11.5847Z"
        fill="#292929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0059 16.05C14.5652 16.05 16.6398 13.9753 16.6398 11.4161C16.6398 8.85692 14.5652 6.78226 12.0059 6.78226C9.44672 6.78226 7.37206 8.85692 7.37206 11.4161C7.37206 13.9753 9.44672 16.05 12.0059 16.05ZM12.0059 14.7862C13.8672 14.7862 15.376 13.2774 15.376 11.4161C15.376 9.55488 13.8672 8.04604 12.0059 8.04604C10.1447 8.04604 8.63585 9.55488 8.63585 11.4161C8.63585 13.2774 10.1447 14.7862 12.0059 14.7862Z"
        fill="#292929"
      />
      <path
        d="M12.0586 8.8288C12.4076 8.8288 12.6905 9.1117 12.6905 9.46069V10.9351H14.1649C14.5139 10.9351 14.7968 11.218 14.7968 11.567C14.7968 11.916 14.5139 12.1989 14.1649 12.1989H12.6905V13.6733C12.6905 14.0223 12.4076 14.3052 12.0586 14.3052C11.7096 14.3052 11.4267 14.0223 11.4267 13.6733V12.1989H9.95229C9.6033 12.1989 9.3204 11.916 9.3204 11.567C9.3204 11.218 9.6033 10.9351 9.95229 10.9351H11.4267V9.46069C11.4267 9.1117 11.7096 8.8288 12.0586 8.8288Z"
        fill="#292929"
      />
    </svg>
  );
}

export function paramEnterprise() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_20350_45865)">
        <path
          d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
          stroke="#2A353D"
          strokeWidth="1.5"
        />
        <path
          d="M12.2422 17V12C12.2422 11.5286 12.2422 11.2929 12.0957 11.1464C11.9493 11 11.7136 11 11.2422 11"
          stroke="#2A353D"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.992 8H12.001"
          stroke="#2A353D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_20350_45865">
          <rect
            width="23.8163"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function paramEmplacement() {
  return (
    <svg
      width="14"
      height="19"
      viewBox="0 0 14 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 18.9998C5.73693 17.9224 4.56619 16.7413 3.5 15.4688C1.9 13.5578 8.83662e-07 10.7118 8.83662e-07 7.99981C-0.00141728 5.16735 1.70425 2.6132 4.32107 1.5292C6.93789 0.445211 9.95007 1.04505 11.952 3.04881C13.2685 4.35941 14.0059 6.14219 14 7.99981C14 10.7118 12.1 13.5578 10.5 15.4688C9.43382 16.7413 8.26307 17.9224 7 18.9998ZM7 2.99981C4.23995 3.00311 2.00331 5.23975 2 7.99981C2 9.16581 2.527 11.1848 5.035 14.1858C5.65314 14.9239 6.30902 15.6295 7 16.2998C7.69105 15.6303 8.34724 14.9257 8.966 14.1888C11.473 11.1838 12 9.16481 12 7.99981C11.9967 5.23975 9.76006 3.00311 7 2.99981ZM7 10.9998C5.34315 10.9998 4 9.65666 4 7.99981C4 6.34295 5.34315 4.99981 7 4.99981C8.65686 4.99981 10 6.34295 10 7.99981C10 8.79546 9.68393 9.55852 9.12132 10.1211C8.55871 10.6837 7.79565 10.9998 7 10.9998Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function paramCouriel() {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3333 15.3337H2.66659C1.65406 15.3337 0.833252 14.5128 0.833252 13.5003V2.42058C0.875976 1.43933 1.68441 0.666064 2.66659 0.666993H17.3333C18.3458 0.666993 19.1666 1.48781 19.1666 2.50033V13.5003C19.1666 14.5128 18.3458 15.3337 17.3333 15.3337ZM2.66659 4.21266V13.5003H17.3333V4.21266L9.99992 9.10033L2.66659 4.21266ZM3.39992 2.50033L9.99992 6.90033L16.5999 2.50033H3.39992Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function paramPosts() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1464 17.6611H1.95185C1.427 17.6611 1 17.2341 1 16.7092V10.0791H8.81465L8.80431 10.3876C8.80372 10.4069 8.80153 10.4254 8.79894 10.444C8.79934 11.1175 9.35999 11.6779 10.0493 11.6779C10.7345 11.6779 11.2927 11.1238 11.2991 10.4401C11.2961 10.4198 11.2945 10.4023 11.2941 10.3842L11.2873 10.0791H19.0982V16.7092C19.0982 17.2339 18.6712 17.6611 18.1464 17.6611ZM1.59664 10.6757V16.7092C1.59664 16.9051 1.75595 17.0644 1.95185 17.0644H18.1464C18.3423 17.0644 18.5016 16.9051 18.5016 16.7092V10.6757H11.879C11.7579 11.5771 10.9833 12.2746 10.0491 12.2746C9.11496 12.2746 8.34052 11.5771 8.2192 10.6757H1.59664Z"
        fill="#393C40"
        stroke="#393C40"
        strokeWidth="0.6"
      />
      <path
        d="M18.1464 3.78991H12.8539V3.51168C12.8539 2.12686 11.7273 1 10.3423 1H9.75616C8.37135 1 7.24448 2.12686 7.24448 3.51168V3.78991H1.95185C1.427 3.78991 1 4.21691 1 4.74176V8.84986H19.0982V4.74176C19.0982 4.21691 18.6712 3.78991 18.1464 3.78991ZM7.84113 3.51168C7.84113 2.45561 8.7001 1.59664 9.75616 1.59664H10.3423C11.3983 1.59664 12.2573 2.45561 12.2573 3.51168V3.78991H7.84113V3.51168ZM18.5016 8.25301H1.59664V4.74176C1.59664 4.54606 1.75595 4.38656 1.95185 4.38656H18.1464C18.3423 4.38656 18.5016 4.54586 18.5016 4.74176V8.25301Z"
        fill="#393C40"
        stroke="#393C40"
        strokeWidth="0.6"
      />
    </svg>
  );
}

export function paramSynch() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="sync-svgrepo-com 1">
        <path
          id="Vector"
          d="M16.5891 12.9248H12.8141C12.593 12.9248 12.3811 13.0126 12.2248 13.1689C12.0685 13.3252 11.9807 13.5372 11.9807 13.7582C11.9807 13.9792 12.0685 14.1911 12.2248 14.3474C12.3811 14.5037 12.593 14.5915 12.8141 14.5915H14.8141C13.8948 15.5521 12.7094 16.2159 11.41 16.4977C10.1107 16.7794 8.75674 16.6662 7.52221 16.1725C6.28768 15.6789 5.22895 14.8274 4.48205 13.7275C3.73516 12.6275 3.33421 11.3294 3.33073 9.99984C3.33073 9.77882 3.24293 9.56686 3.08665 9.41058C2.93037 9.2543 2.71841 9.1665 2.4974 9.1665C2.27638 9.1665 2.06442 9.2543 1.90814 9.41058C1.75186 9.56686 1.66406 9.77882 1.66406 9.99984C1.66847 11.6272 2.14925 13.2176 3.04707 14.5749C3.94488 15.9321 5.22045 16.9968 6.71635 17.6375C8.21224 18.2782 9.863 18.467 11.4649 18.1804C13.0668 17.8938 14.5498 17.1444 15.7307 16.0248V17.4998C15.7307 17.7208 15.8185 17.9328 15.9748 18.0891C16.1311 18.2454 16.343 18.3332 16.5641 18.3332C16.7851 18.3332 16.997 18.2454 17.1533 18.0891C17.3096 17.9328 17.3974 17.7208 17.3974 17.4998V13.7498C17.3953 13.5345 17.31 13.3284 17.1593 13.1746C17.0086 13.0208 16.8043 12.9313 16.5891 12.9248ZM9.99739 1.6665C7.86105 1.6726 5.80864 2.49893 4.26406 3.97484V2.49984C4.26406 2.27882 4.17626 2.06686 4.01998 1.91058C3.8637 1.7543 3.65174 1.6665 3.43073 1.6665C3.20972 1.6665 2.99775 1.7543 2.84147 1.91058C2.68519 2.06686 2.5974 2.27882 2.5974 2.49984V6.24984C2.5974 6.47085 2.68519 6.68281 2.84147 6.83909C2.99775 6.99537 3.20972 7.08317 3.43073 7.08317H7.18073C7.40174 7.08317 7.6137 6.99537 7.76998 6.83909C7.92626 6.68281 8.01406 6.47085 8.01406 6.24984C8.01406 6.02882 7.92626 5.81686 7.76998 5.66058C7.6137 5.5043 7.40174 5.4165 7.18073 5.4165H5.18073C6.09945 4.4564 7.28414 3.79275 8.58273 3.51076C9.88132 3.22877 11.2346 3.34129 12.4687 3.83389C13.7029 4.32649 14.7617 5.17668 15.5093 6.27534C16.2568 7.374 16.6589 8.67099 16.6641 9.99984C16.6641 10.2208 16.7519 10.4328 16.9081 10.5891C17.0644 10.7454 17.2764 10.8332 17.4974 10.8332C17.7184 10.8332 17.9304 10.7454 18.0866 10.5891C18.2429 10.4328 18.3307 10.2208 18.3307 9.99984C18.3307 8.90549 18.1152 7.82185 17.6964 6.81081C17.2776 5.79976 16.6638 4.8811 15.8899 4.10728C15.1161 3.33346 14.1975 2.71963 13.1864 2.30084C12.1754 1.88205 11.0917 1.6665 9.99739 1.6665Z"
          fill="#2A353D"
        />
      </g>
    </svg>
  );
}

export function paramGroupes() {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.875 0.625C4.45875 0.625 2.5 2.58375 2.5 5C2.5 7.41625 4.45875 9.375 6.875 9.375C9.29125 9.375 11.25 7.41625 11.25 5C11.25 2.58375 9.29125 0.625 6.875 0.625ZM4.25 5C4.25 3.55025 5.42525 2.375 6.875 2.375C8.32475 2.375 9.5 3.55025 9.5 5C9.5 6.44975 8.32475 7.625 6.875 7.625C5.42525 7.625 4.25 6.44975 4.25 5Z"
        fill="#393C40"
      />
      <path
        d="M13.7949 5.19099C13.5487 5.06548 13.2763 5.00005 13 5.00005V3.25005C13.5526 3.25005 14.0974 3.38087 14.5898 3.63189C14.644 3.65954 14.6974 3.68856 14.75 3.71891C15.1747 3.96412 15.5438 4.29623 15.8326 4.69424C16.1572 5.14151 16.3713 5.65929 16.4573 6.2052C16.5434 6.75111 16.4989 7.30963 16.3276 7.83505C16.1562 8.36047 15.8629 8.83785 15.4716 9.22811C15.0803 9.61838 14.6022 9.91044 14.0763 10.0804C13.6084 10.2316 13.1145 10.2823 12.6269 10.2301C12.5665 10.2236 12.5062 10.2155 12.4461 10.2059C11.9008 10.1185 11.3839 9.90331 10.9377 9.57791L10.9368 9.57724L11.9684 8.16362C12.1916 8.3265 12.4502 8.43417 12.7231 8.4779C12.9959 8.52162 13.2752 8.50012 13.5381 8.41515C13.8011 8.33017 14.0401 8.18415 14.2358 7.98902C14.4314 7.79389 14.5781 7.55521 14.6637 7.29251C14.7494 7.02981 14.7716 6.75055 14.7286 6.47761C14.6856 6.20466 14.5786 5.94578 14.4163 5.72215C14.254 5.49852 14.041 5.3165 13.7949 5.19099Z"
        fill="#393C40"
      />
      <path
        d="M16.4983 16.375C16.4983 15.9156 16.4079 15.4607 16.232 15.0362C16.0562 14.6118 15.7986 14.2262 15.4737 13.9013C15.1489 13.5764 14.7632 13.3188 14.3388 13.143C13.9143 12.9671 13.4594 12.8767 13 12.8767V11.125C13.5968 11.125 14.1886 11.2268 14.75 11.4253C14.8371 11.4561 14.9235 11.4892 15.0091 11.5246C15.646 11.7885 16.2248 12.1752 16.7123 12.6627C17.1998 13.1502 17.5865 13.729 17.8504 14.3659C17.8858 14.4515 17.9189 14.5379 17.9498 14.625C18.1482 15.1864 18.25 15.7782 18.25 16.375H16.4983Z"
        fill="#393C40"
      />
      <path
        d="M13 16.375H11.25C11.25 13.9588 9.29125 12 6.875 12C4.45875 12 2.5 13.9588 2.5 16.375H0.75C0.75 12.9923 3.49226 10.25 6.875 10.25C10.2577 10.25 13 12.9923 13 16.375Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function paramRole() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5226 20H7.88256C7.41267 20 7.00611 19.673 6.90556 19.214L6.49856 17.33C5.95561 17.0921 5.44078 16.7946 4.96356 16.443L3.12656 17.028C2.67856 17.1709 2.19154 16.9823 1.95656 16.575L0.132555 13.424C-0.099857 13.0165 -0.0197863 12.5025 0.325555 12.185L1.75056 10.885C1.68575 10.2961 1.68575 9.70189 1.75056 9.113L0.325555 7.816C-0.020295 7.49837 -0.100397 6.98372 0.132555 6.576L1.95256 3.423C2.18754 3.0157 2.67456 2.82714 3.12256 2.97L4.95956 3.555C5.20362 3.37416 5.45769 3.20722 5.72056 3.055C5.97289 2.91269 6.23259 2.78385 6.49856 2.669L6.90656 0.787C7.00662 0.327969 7.41274 0.000494393 7.88256 0H11.5226C11.9924 0.000494393 12.3985 0.327969 12.4986 0.787L12.9106 2.67C13.1913 2.79352 13.4648 2.93308 13.7296 3.088C13.9765 3.23081 14.2152 3.38739 14.4446 3.557L16.2826 2.972C16.7303 2.82967 17.2167 3.01816 17.4516 3.425L19.2716 6.578C19.504 6.98548 19.4239 7.49951 19.0786 7.817L17.6536 9.117C17.7184 9.70589 17.7184 10.3001 17.6536 10.889L19.0786 12.189C19.4239 12.5065 19.504 13.0205 19.2716 13.428L17.4516 16.581C17.2167 16.9878 16.7303 17.1763 16.2826 17.034L14.4446 16.449C14.212 16.6203 13.9703 16.7789 13.7206 16.924C13.4584 17.0759 13.188 17.2131 12.9106 17.335L12.4986 19.214C12.3981 19.6726 11.9921 19.9996 11.5226 20ZM5.32256 14.229L6.14256 14.829C6.32741 14.9652 6.52007 15.0904 6.71956 15.204C6.90726 15.3127 7.10052 15.4115 7.29856 15.5L8.23155 15.909L8.68855 18H10.7186L11.1756 15.908L12.1086 15.499C12.5159 15.3194 12.9025 15.0961 13.2616 14.833L14.0826 14.233L16.1236 14.883L17.1386 13.125L15.5556 11.682L15.6676 10.67C15.7168 10.2274 15.7168 9.78064 15.6676 9.338L15.5556 8.326L17.1396 6.88L16.1236 5.121L14.0826 5.771L13.2616 5.171C12.9023 4.90671 12.5158 4.68175 12.1086 4.5L11.1756 4.091L10.7186 2H8.68855L8.22956 4.092L7.29856 4.5C7.10036 4.58704 6.90707 4.68486 6.71956 4.793C6.52129 4.90633 6.32965 5.03086 6.14556 5.166L5.32456 5.766L3.28456 5.116L2.26756 6.88L3.85056 8.321L3.73856 9.334C3.68936 9.77664 3.68936 10.2234 3.73856 10.666L3.85056 11.678L2.26756 13.121L3.28256 14.879L5.32256 14.229ZM9.69855 14C7.48942 14 5.69855 12.2091 5.69855 10C5.69855 7.79086 7.48942 6 9.69855 6C11.9077 6 13.6986 7.79086 13.6986 10C13.6958 12.208 11.9066 13.9972 9.69855 14ZM9.69855 8C8.60595 8.00111 7.71644 8.87885 7.70079 9.97134C7.68513 11.0638 8.54912 11.9667 9.64124 11.9991C10.7334 12.0315 11.6494 11.1815 11.6986 10.09V10.49V10C11.6986 8.89543 10.8031 8 9.69855 8Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function paramOrganigramme() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 15.75H1.75C0.783502 15.75 0 14.9665 0 14V10.5H1.75V14H14V1.75H1.75V5.25H0V1.75C0 0.783502 0.783502 0 1.75 0H14C14.9665 0 15.75 0.783502 15.75 1.75V14C15.75 14.9665 14.9665 15.75 14 15.75ZM7 11.375V8.75H0V7H7V4.375L11.375 7.875L7 11.375Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function SvgExpensesNotes({ color = "#292929" }) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_8980_11618"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="19"
        height="19"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0.0297852H18.0044V18.8898H0V0.0297852Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_8980_11618)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.795 1.44877L5.17386 1.45256C2.86641 1.46582 1.48669 2.8299 1.48669 5.1024V13.8135C1.48669 16.1012 2.87929 17.4671 5.20954 17.4671L12.8307 17.4643C15.1381 17.451 16.5178 16.0851 16.5178 13.8135V5.1024C16.5178 2.81474 15.1262 1.44877 12.795 1.44877ZM5.2106 18.89C2.09435 18.89 0 16.8505 0 13.8154V5.10432C0 2.04179 2.02893 0.0515724 5.16897 0.0335742L12.7941 0.0297852H12.7951C15.9113 0.0297852 18.0047 2.06926 18.0047 5.10432V13.8154C18.0047 16.877 15.9757 18.8682 12.8357 18.8871L5.2106 18.89Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6028 14.2134H5.4465C5.03616 14.2134 4.70312 13.8951 4.70312 13.5029C4.70312 13.1108 5.03616 12.7925 5.4465 12.7925H12.6028C13.0131 12.7925 13.3462 13.1108 13.3462 13.5029C13.3462 13.8951 13.0131 14.2134 12.6028 14.2134Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6028 10.2481H5.4465C5.03616 10.2481 4.70312 9.92977 4.70312 9.5376C4.70312 9.14543 5.03616 8.82715 5.4465 8.82715H12.6028C13.0131 8.82715 13.3462 9.14543 13.3462 9.5376C13.3462 9.92977 13.0131 10.2481 12.6028 10.2481Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.17719 6.29249H5.4465C5.03616 6.29249 4.70312 5.97421 4.70312 5.58204C4.70312 5.18987 5.03616 4.87158 5.4465 4.87158H8.17719C8.58753 4.87158 8.92057 5.18987 8.92057 5.58204C8.92057 5.97421 8.58753 6.29249 8.17719 6.29249Z"
          fill={color}
        />
      </g>
    </svg>
  );
}

export function SvgNewFile() {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2 16H1.6C0.716344 16 0 15.2837 0 14.4V1.6C0 0.716344 0.716344 0 1.6 0H7.2C7.20872 0.000377855 7.21734 0.00199405 7.2256 0.0048C7.23341 0.00721379 7.24146 0.00882216 7.2496 0.0096C7.32015 0.0141226 7.3898 0.0278385 7.4568 0.0504L7.4792 0.0576C7.49733 0.0637456 7.51498 0.0712329 7.532 0.08C7.61915 0.118739 7.69857 0.172948 7.7664 0.24L12.5664 5.04C12.6335 5.10783 12.6877 5.18724 12.7264 5.2744C12.7344 5.292 12.74 5.3104 12.7464 5.3288L12.7536 5.3496C12.7759 5.41631 12.7891 5.48574 12.7928 5.556C12.794 5.56335 12.7959 5.57057 12.7984 5.5776C12.7998 5.58498 12.8004 5.5925 12.8001 5.6V14.4C12.8001 15.2837 12.0837 16 11.2 16ZM1.6 1.6V14.4H11.2V6.4H7.2C6.75817 6.4 6.4 6.04183 6.4 5.6V1.6H1.6ZM8 2.7312V4.8H10.0688L8 2.7312Z"
        fill="#2E3A59"
      />
    </svg>
  );
}

export function SvgMenuExpenses() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7161 16.9737H8.49609C8.08209 16.9737 7.74609 16.6377 7.74609 16.2237C7.74609 15.8097 8.08209 15.4737 8.49609 15.4737H15.7161C16.1301 15.4737 16.4661 15.8097 16.4661 16.2237C16.4661 16.6377 16.1301 16.9737 15.7161 16.9737Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7161 12.7872H8.49609C8.08209 12.7872 7.74609 12.4512 7.74609 12.0372C7.74609 11.6232 8.08209 11.2872 8.49609 11.2872H15.7161C16.1301 11.2872 16.4661 11.6232 16.4661 12.0372C16.4661 12.4512 16.1301 12.7872 15.7161 12.7872Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2511 8.61041H8.49609C8.08209 8.61041 7.74609 8.27441 7.74609 7.86041C7.74609 7.44641 8.08209 7.11041 8.49609 7.11041H11.2511C11.6651 7.11041 12.0011 7.44641 12.0011 7.86041C12.0011 8.27441 11.6651 8.61041 11.2511 8.61041Z"
        fill="black"
      />
      <mask
        id="mask0_8942_39157"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="2"
        width="19"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 2.00018H21.1647V21.91H3V2.00018Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_8942_39157)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.909 3.5L8.22 3.504C5.892 3.518 4.5 4.958 4.5 7.357V16.553C4.5 18.968 5.905 20.41 8.256 20.41L15.945 20.407C18.273 20.393 19.665 18.951 19.665 16.553V7.357C19.665 4.942 18.261 3.5 15.909 3.5ZM8.257 21.91C5.113 21.91 3 19.757 3 16.553V7.357C3 4.124 5.047 2.023 8.215 2.004L15.908 2H15.909C19.053 2 21.165 4.153 21.165 7.357V16.553C21.165 19.785 19.118 21.887 15.95 21.907L8.257 21.91Z"
          fill="black"
        />
      </g>
    </svg>
  );
}

export function uploadFile() {
  return (
    <svg
      width="29"
      height="30"
      viewBox="0 0 29 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="14.4963"
        cy="15.2346"
        r="13.9959"
        transform="rotate(-180 14.4963 15.2346)"
        fill="#FEFEFE"
        stroke="#E9E9E9"
      />
      <path
        d="M14.427 10.0139L17.6826 13.3529L16.9175 14.1376L14.9696 12.1453L14.9696 18.918L13.8843 18.918L13.8843 12.1453L11.9364 14.1376L11.1713 13.3529L14.427 10.0139Z"
        fill="#292929"
      />
      <path
        d="M18.2236 19.5042L10.6271 19.5042L10.6271 20.6172L18.2236 20.6172L18.2236 19.5042Z"
        fill="#292929"
      />
    </svg>
  );
}

export function fileUpload() {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.58271 11.7668H4.14317C3.83127 11.7668 3.57812 11.5137 3.57812 11.2018C3.57812 10.8899 3.83127 10.6367 4.14317 10.6367H9.58271C9.89461 10.6367 10.1478 10.8899 10.1478 11.2018C10.1478 11.5137 9.89461 11.7668 9.58271 11.7668Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.58271 8.61154H4.14317C3.83127 8.61154 3.57812 8.3584 3.57812 8.04649C3.57812 7.73459 3.83127 7.48145 4.14317 7.48145H9.58271C9.89461 7.48145 10.1478 7.73459 10.1478 8.04649C10.1478 8.3584 9.89461 8.61154 9.58271 8.61154Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.21878 5.46994H4.14317C3.83127 5.46994 3.57812 5.2168 3.57812 4.90489C3.57812 4.59299 3.83127 4.33984 4.14317 4.33984H6.21878C6.53069 4.33984 6.78383 4.59299 6.78383 4.90489C6.78383 5.2168 6.53069 5.46994 6.21878 5.46994Z"
        fill="black"
      />
      <mask
        id="mask0_29951_18430"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0.486328H13.6852V15.4863H0V0.486328Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_29951_18430)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.72763 1.61319L3.93475 1.61621C2.18084 1.62676 1.13212 2.71165 1.13212 4.51905V11.4473C1.13212 13.2668 2.19064 14.3532 3.96188 14.3532L9.75475 14.3509C11.5087 14.3403 12.5574 13.2539 12.5574 11.4473V4.51905C12.5574 2.69959 11.4996 1.61319 9.72763 1.61319ZM3.96061 15.4865C1.59193 15.4865 0 13.8644 0 11.4505V4.52228C0 2.08655 1.54221 0.503656 3.92897 0.489342L9.72486 0.486328H9.72561C12.0943 0.486328 13.6855 2.10839 13.6855 4.52228V11.4505C13.6855 13.8855 12.1433 15.4692 9.7565 15.4842L3.96061 15.4865Z"
          fill="black"
        />
      </g>
    </svg>
  );
}

export function pinkEditHour() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="7.81823"
        cy="7.65917"
        r="6.47753"
        fill="#ED6581"
        stroke="white"
      />
      <path
        d="M5.37144 10.4284C5.28082 10.4283 5.19444 10.39 5.13336 10.3231C5.07116 10.2567 5.04025 10.1669 5.0484 10.0763L5.12755 9.20606L8.78364 5.55125L9.92621 6.6935L6.27109 10.348L5.40083 10.4271C5.39082 10.4281 5.38081 10.4284 5.37144 10.4284ZM10.1543 6.46511L9.01203 5.32287L9.69718 4.63771C9.75777 4.57705 9.83999 4.54297 9.92573 4.54297C10.0115 4.54297 10.0937 4.57705 10.1543 4.63771L10.8394 5.32287C10.9001 5.38346 10.9342 5.46568 10.9342 5.55141C10.9342 5.63715 10.9001 5.71937 10.8394 5.77996L10.1546 6.46479L10.1543 6.46511Z"
        fill="white"
      />
    </svg>
  );
}

export function orangeEditHour() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="7.67547"
        cy="7.65752"
        r="6.47783"
        fill="#F97F4A"
        stroke="white"
      />
      <path
        d="M5.22851 10.4267C5.13789 10.4266 5.0515 10.3883 4.99042 10.3214C4.92822 10.255 4.89731 10.1652 4.90546 10.0746L4.98461 9.2043L8.64086 5.54934L9.78348 6.69164L6.1282 10.3463L5.2579 10.4254C5.24789 10.4264 5.23788 10.4267 5.22851 10.4267ZM10.0116 6.46324L8.86926 5.32095L9.55444 4.63576C9.61503 4.5751 9.69726 4.54102 9.783 4.54102C9.86874 4.54102 9.95096 4.5751 10.0116 4.63576L10.6967 5.32095C10.7574 5.38154 10.7915 5.46376 10.7915 5.5495C10.7915 5.63524 10.7574 5.71747 10.6967 5.77806L10.0119 6.46292L10.0116 6.46324Z"
        fill="white"
      />
    </svg>
  );
}

export function usersIcon() {
  return (
    <svg
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.74781 2.55964C9.40713 2.97303 9.86946 3.67257 9.95363 4.48458C10.2225 4.61021 10.5209 4.68246 10.8373 4.68246C11.9925 4.68246 12.9287 3.74624 12.9287 2.59132C12.9287 1.43622 11.9925 0.5 10.8373 0.5C9.69328 0.500356 8.76525 1.41985 8.74781 2.55964ZM7.37774 6.84158C8.53284 6.84158 9.46906 5.90519 9.46906 4.75026C9.46906 3.59534 8.53266 2.65912 7.37774 2.65912C6.22281 2.65912 5.28606 3.59552 5.28606 4.75044C5.28606 5.90537 6.22281 6.84158 7.37774 6.84158ZM8.26484 6.98413H6.49028C5.01379 6.98413 3.8126 8.1855 3.8126 9.66198V11.8321L3.81811 11.8661L3.9676 11.9129C5.37664 12.3532 6.60079 12.5 7.60837 12.5C9.57636 12.5 10.7171 11.9389 10.7873 11.9031L10.927 11.8325H10.942V9.66198C10.9425 8.1855 9.74133 6.98413 8.26484 6.98413ZM11.7248 4.82518H9.96395C9.94491 5.5297 9.64417 6.16411 9.16849 6.62039C10.4809 7.01064 11.4411 8.22767 11.4411 9.66519V10.3339C13.1798 10.2702 14.1816 9.77748 14.2477 9.74438L14.3874 9.67355H14.4023V7.50268C14.4023 6.02637 13.2011 4.82518 11.7248 4.82518ZM3.70814 4.68282C4.11726 4.68282 4.4979 4.56341 4.82035 4.36001C4.92286 3.69143 5.28126 3.10721 5.79323 2.7093C5.79537 2.67015 5.7991 2.63136 5.7991 2.59185C5.7991 1.43675 4.86271 0.500534 3.70814 0.500534C2.55286 0.500534 1.61682 1.43675 1.61682 2.59185C1.61682 3.74642 2.55286 4.68282 3.70814 4.68282ZM5.58627 6.62039C5.11291 6.16642 4.81324 5.5354 4.79135 4.83515C4.72604 4.83034 4.66144 4.82518 4.59489 4.82518H2.8205C1.34401 4.82518 0.142822 6.02637 0.142822 7.50268V9.67319L0.148339 9.70665L0.297821 9.75381C1.42819 10.1067 2.43701 10.2693 3.31326 10.3206V9.66519C3.31361 8.22767 4.2735 7.011 5.58627 6.62039Z"
        fill="#DA5014"
      />
    </svg>
  );
}

export function userIcone(color = "#4472A3") {
  return (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.60547 7.68457C7.10242 7.68459 9.21073 8.09594 9.21094 9.68262C9.21094 11.2695 7.08902 11.667 4.60547 11.667C2.10831 11.667 0 11.2552 0 9.66895C0.000187575 8.08221 2.12132 7.68457 4.60547 7.68457ZM10.4404 3.07227C10.7451 3.07229 10.9922 3.32448 10.9922 3.63281V4.35449H11.7314C12.0353 4.35467 12.283 4.60596 12.2832 4.91406C12.2832 5.22231 12.0354 5.47443 11.7314 5.47461H10.9922V6.19727C10.9921 6.5055 10.745 6.75681 10.4404 6.75684C10.1364 6.75684 9.8888 6.50551 9.88867 6.19727V5.47461H9.15137C8.84666 5.47461 8.59863 5.22241 8.59863 4.91406C8.5988 4.60585 8.84676 4.35449 9.15137 4.35449H9.88867V3.63281C9.88867 3.32446 10.1364 3.07227 10.4404 3.07227ZM4.6084 0C6.29981 0 7.65625 1.37362 7.65625 3.08691C7.65612 4.80009 6.29972 6.17285 4.6084 6.17285C2.91722 6.17268 1.56166 4.79998 1.56152 3.08691C1.56152 1.37373 2.91714 0.000169844 4.6084 0Z" fill={color} />
    </svg>

  );
}
export function editNote() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33407 15H1.6674C0.746924 15 0.000732422 14.2538 0.000732422 13.3333V1.66667C0.000732422 0.746192 0.746924 0 1.6674 0H13.3341C14.2545 0 15.0007 0.746192 15.0007 1.66667V8.33333C15.0004 8.34296 14.9987 8.35249 14.9957 8.36167C14.9933 8.36927 14.9917 8.37708 14.9907 8.385C14.986 8.45849 14.9717 8.53105 14.9482 8.60083L14.9407 8.62333C14.9351 8.64215 14.9282 8.66053 14.9199 8.67833C14.8795 8.76912 14.8231 8.85184 14.7532 8.9225L8.9199 14.7558C8.76447 14.9113 8.55391 14.9991 8.33407 15ZM1.6674 1.66667V13.3333H7.50073V8.33333C7.50073 7.8731 7.87383 7.5 8.33407 7.5H13.3341V1.66667H1.6674ZM9.1674 9.16667V12.1558L12.1557 9.16667H9.1674Z"
        fill="#292929"
      />
    </svg>
  );
}

export function filledNote() {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35C27.165 35 35 27.165 35 17.5Z"
        fill="#73C7B7"
      />
      <path
        d="M18.3343 25H11.6676C10.7472 25 10.001 24.2538 10.001 23.3333V11.6667C10.001 10.7462 10.7472 10 11.6676 10H23.3343C24.2548 10 25.001 10.7462 25.001 11.6667V18.3333C25.0006 18.343 24.9989 18.3525 24.996 18.3617C24.9936 18.3693 24.9919 18.3771 24.991 18.385C24.9863 18.4585 24.972 18.531 24.9485 18.6008L24.941 18.6233C24.9354 18.6421 24.9284 18.6605 24.9201 18.6783C24.8798 18.7691 24.8233 18.8518 24.7535 18.9225L18.9201 24.7558C18.7647 24.9113 18.5541 24.9991 18.3343 25ZM11.6676 11.6667V23.3333H17.501V18.3333C17.501 17.8731 17.8741 17.5 18.3343 17.5H23.3343V11.6667H11.6676ZM19.1676 19.1667V22.1558L22.156 19.1667H19.1676Z"
        fill="white"
      />
    </svg>
  );
}

export function iconEditNote() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.315 3.9718L11.0153 4.27076L7.71819 0.982176L8.01793 0.683214C8.6174 0.0852891 9.44167 -0.138933 10.2659 0.0852891C11.0902 0.309511 11.6897 0.907435 11.9145 1.72958C12.1393 2.55173 11.9145 3.37387 11.315 3.9718ZM9.89127 5.39187L7.71819 7.55935L4.79577 10.4742C4.4211 10.8479 3.9715 11.0722 3.52189 11.2216L0.674405 11.969C0.524537 12.0438 0.299736 11.969 0.224802 11.8943C0 11.7448 0 11.5206 0 11.3711L0.749339 8.53097C0.899207 8.08253 1.12401 7.63409 1.49868 7.26038L4.4211 4.3455L6.59418 2.17803L9.89127 5.39187Z"
        fill="#292929"
      />
    </svg>
  );
}

export function checkedRadio() {
  return (
    <svg
      width="13"
      height="10"
      viewBox="0 0 13 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.85448 9.6557L0.78125 5.58248L1.94479 4.41893L4.85571 7.32656L4.85448 7.32779L11.8366 0.345703L13.0001 1.50925L6.01802 8.49216L4.8553 9.65488L4.85448 9.6557Z"
        fill="#F55611"
      />
    </svg>
  );
}

export function SvgReimbursment({ color = "#292929" }) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_9819_15980"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="19"
        height="19"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0.0299683H18.0044V18.89H0V0.0299683Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_9819_15980)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.795 1.44896L5.17386 1.45275C2.86641 1.46601 1.48669 2.83008 1.48669 5.10258V13.8137C1.48669 16.1014 2.87929 17.4673 5.20954 17.4673L12.8307 17.4645C15.1381 17.4512 16.5178 16.0853 16.5178 13.8137V5.10258C16.5178 2.81492 15.1262 1.44896 12.795 1.44896ZM5.2106 18.8902C2.09435 18.8902 0 16.8507 0 13.8156V5.1045C0 2.04197 2.02893 0.0517555 5.16897 0.0337573L12.7941 0.0299683H12.7951C15.9113 0.0299683 18.0047 2.06944 18.0047 5.1045V13.8156C18.0047 16.8772 15.9757 18.8684 12.8357 18.8873L5.2106 18.8902Z"
          fill={color}
        />
        <path
          d="M12.1158 11.2281C12.1158 11.6948 11.9992 12.1334 11.7658 12.5441C11.5418 12.9548 11.2058 13.3001 10.7578 13.5801C10.3192 13.8601 9.79651 14.0281 9.18984 14.0841V15.2181H8.27984V14.0841C7.40251 14.0001 6.69318 13.7248 6.15184 13.2581C5.61051 12.7914 5.33984 12.1754 5.33984 11.4101H7.04784C7.07584 11.7741 7.19251 12.0774 7.39784 12.3201C7.60318 12.5534 7.89718 12.7028 8.27984 12.7681V9.68811C7.65451 9.52944 7.14584 9.37078 6.75384 9.21211C6.36184 9.04411 6.02584 8.78278 5.74584 8.42811C5.47518 8.07344 5.33984 7.58811 5.33984 6.97211C5.33984 6.19744 5.61051 5.55811 6.15184 5.05411C6.69318 4.54078 7.40251 4.24211 8.27984 4.15811V3.02411H9.18984V4.15811C10.0112 4.23278 10.6692 4.49411 11.1638 4.94211C11.6678 5.38078 11.9525 5.98744 12.0178 6.76211H10.3098C10.2818 6.47278 10.1698 6.21611 9.97384 5.99211C9.77784 5.75878 9.51651 5.60011 9.18984 5.51611V8.54011C9.81518 8.68944 10.3238 8.84811 10.7158 9.01611C11.1078 9.17478 11.4392 9.43144 11.7098 9.78611C11.9805 10.1314 12.1158 10.6121 12.1158 11.2281ZM6.96384 6.88811C6.96384 7.27078 7.07584 7.56944 7.29984 7.78411C7.53318 7.99878 7.85984 8.17144 8.27984 8.30211V5.47411C7.87851 5.52078 7.55651 5.66544 7.31384 5.90811C7.08051 6.15078 6.96384 6.47744 6.96384 6.88811ZM9.18984 12.7681C9.60051 12.7028 9.92251 12.5394 10.1558 12.2781C10.3892 12.0074 10.5058 11.6854 10.5058 11.3121C10.5058 10.9388 10.3892 10.6494 10.1558 10.4441C9.93184 10.2294 9.60984 10.0568 9.18984 9.92611V12.7681Z"
          fill={color}
        />
      </g>
    </svg>
  );
}

export function SvgPrint() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9793_36766)">
        <path
          d="M19 8H5C3.34 8 2 9.34 2 11V17H6V21H18V17H22V11C22 9.34 20.66 8 19 8ZM16 19H8V14H16V19ZM19 12C18.45 12 18 11.55 18 11C18 10.45 18.45 10 19 10C19.55 10 20 10.45 20 11C20 11.55 19.55 12 19 12ZM18 3H6V7H18V3Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_9793_36766">
          <rect
            width="24"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgNoSupportedFile() {
  return (
    <svg
      width="250"
      height="260"
      viewBox="0 0 250 260"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="12"
        y="21.2775"
        width="238"
        height="238"
        rx="119"
        fill="#323639"
        fill-opacity="0.8"
      />
      <g clipPath="url(#clip0_9794_37255)">
        <path
          d="M104.662 1.73526L97.8686 5.45495L14.1754 51.2823L7.38224 55.002C4.08598 56.8117 1.63964 59.8598 0.579925 63.4773C-0.47979 67.0949 -0.0663417 70.9867 1.72957 74.2987L64.054 188.932C65.8573 192.24 68.8945 194.695 72.4993 195.758C76.104 196.822 79.9819 196.407 83.2822 194.604L83.2998 194.595L180.544 141.347L180.562 141.338C183.858 139.528 186.304 136.48 187.364 132.862C188.424 129.245 188.01 125.353 186.214 122.041L123.89 7.4081C122.087 4.1001 119.05 1.64505 115.445 0.581558C111.84 -0.481938 107.962 -0.067027 104.662 1.73526Z"
          fill="#323639"
        />
        <path
          d="M106.616 5.32934L98.57 9.73505L17.3823 54.1905L9.33634 58.5961C6.98899 59.8849 5.24688 62.0554 4.49223 64.6316C3.73758 67.2078 4.03201 69.9792 5.31092 72.3378L67.6353 186.971C68.9195 189.326 71.0824 191.075 73.6494 191.832C76.2164 192.589 78.978 192.294 81.3282 191.01L81.3457 191.001L178.59 137.753L178.608 137.744C180.955 136.455 182.697 134.284 183.452 131.708C184.207 129.132 183.912 126.361 182.633 124.002L120.309 9.36914C119.025 7.01345 116.862 5.26515 114.295 4.50781C111.728 3.75046 108.966 4.04591 106.616 5.32934Z"
          fill="#484C4F"
        />
        <path
          d="M107.956 40.9114L71.6876 60.7707C71.1382 61.0716 70.4921 61.1411 69.8916 60.9639C69.2911 60.7867 68.7854 60.3774 68.4856 59.826C68.1858 59.2746 68.1165 58.6263 68.2931 58.0237C68.4696 57.421 68.8775 56.9135 69.4269 56.6126L105.695 36.7533C106.245 36.4525 106.891 36.383 107.491 36.5601C108.092 36.7373 108.598 37.1466 108.897 37.698C109.197 38.2494 109.266 38.8977 109.09 39.5004C108.913 40.103 108.506 40.6106 107.956 40.9114H107.956Z"
          fill="#323639"
        />
        <path
          d="M120.318 43.2489L75.504 67.7875C74.9546 68.0883 74.3085 68.1578 73.708 67.9806C73.1075 67.8035 72.6018 67.3942 72.302 66.8428C72.0022 66.2914 71.933 65.6431 72.1095 65.0404C72.286 64.4378 72.6939 63.9302 73.2433 63.6294L118.057 39.0908C118.329 38.9418 118.628 38.8481 118.936 38.8149C119.244 38.7818 119.556 38.8099 119.853 38.8976C120.151 38.9853 120.428 39.131 120.669 39.3262C120.91 39.5214 121.111 39.7624 121.259 40.0355C121.408 40.3085 121.501 40.6082 121.534 40.9174C121.567 41.2267 121.539 41.5394 121.452 41.8378C121.365 42.1362 121.219 42.4144 121.025 42.6565C120.83 42.8986 120.59 43.0999 120.318 43.2489H120.318Z"
          fill="#323639"
        />
        <path
          d="M56.7784 52.504L23.341 70.8131C23.0778 70.9573 22.8824 71.2005 22.7979 71.4893C22.7133 71.778 22.7464 72.0886 22.89 72.3528L37.1285 98.5416C37.2722 98.8058 37.5145 99.0019 37.8022 99.0867C38.0899 99.1716 38.3995 99.1384 38.6628 98.9943L72.1002 80.6852C72.3634 80.541 72.5588 80.2978 72.6433 80.009C72.7279 79.7203 72.6948 79.4097 72.5512 79.1455L58.3127 52.9567C58.169 52.6925 57.9267 52.4965 57.639 52.4116C57.3512 52.3267 57.0417 52.3599 56.7784 52.504Z"
          fill="#323639"
        />
        <path
          d="M125.954 74.1407L76.7599 101.077C76.4878 101.226 76.1892 101.32 75.881 101.353C75.5729 101.386 75.2612 101.358 74.9639 101.271C74.6666 101.183 74.3894 101.037 74.1481 100.842C73.9069 100.647 73.7063 100.406 73.5578 100.133C73.4094 99.8597 73.316 99.56 73.283 99.2507C73.2499 98.9415 73.2779 98.6287 73.3653 98.3303C73.4528 98.0319 73.5979 97.7537 73.7924 97.5116C73.987 97.2695 74.2271 97.0682 74.4992 96.9193L123.693 69.9826C124.242 69.6818 124.888 69.6123 125.489 69.7895C126.089 69.9666 126.595 70.3759 126.895 70.9273C127.195 71.4787 127.264 72.127 127.087 72.7297C126.911 73.3323 126.503 73.8399 125.953 74.1407H125.954Z"
          fill="#323639"
        />
        <path
          d="M138.314 76.4783L80.5743 108.094C80.0249 108.395 79.3789 108.465 78.7784 108.287C78.1779 108.11 77.6721 107.701 77.3723 107.15C77.0725 106.598 77.0033 105.95 77.1798 105.347C77.3563 104.745 77.7642 104.237 78.3136 103.936L136.053 72.3202C136.602 72.0193 137.248 71.9498 137.849 72.127C138.449 72.3041 138.955 72.7134 139.255 73.2648C139.555 73.8162 139.624 74.4646 139.447 75.0672C139.271 75.6698 138.863 76.1774 138.314 76.4783H138.314Z"
          fill="#323639"
        />
        <path
          d="M58.024 123.138C63.5536 123.138 68.0363 118.639 68.0363 113.09C68.0363 107.54 63.5536 103.042 58.024 103.042C52.4944 103.042 48.0117 107.54 48.0117 113.09C48.0117 118.639 52.4944 123.138 58.024 123.138Z"
          fill="#323639"
        />
        <path
          d="M207.827 48.9694H97.0097C93.2524 48.9737 89.6502 50.4735 86.9934 53.1397C84.3366 55.806 82.8421 59.421 82.8379 63.1917V193.778C82.8421 197.548 84.3366 201.163 86.9934 203.83C89.6502 206.496 93.2524 207.996 97.0097 208H207.827C211.585 207.996 215.187 206.496 217.844 203.83C220.501 201.163 221.995 197.548 221.999 193.778V63.1917C221.995 59.421 220.501 55.806 217.844 53.1397C215.187 50.4735 211.585 48.9737 207.827 48.9694Z"
          fill="#323639"
        />
        <path
          d="M207.828 53.0637H97.01C94.3344 53.0667 91.7692 54.1347 89.8772 56.0335C87.9852 57.9322 86.921 60.5065 86.918 63.1917V193.778C86.921 196.463 87.9852 199.037 89.8772 200.936C91.7692 202.835 94.3344 203.903 97.01 203.906H207.828C210.504 203.903 213.069 202.835 214.961 200.936C216.853 199.037 217.917 196.463 217.92 193.778V63.1917C217.917 60.5065 216.853 57.9322 214.961 56.0335C213.069 54.1348 210.504 53.0668 207.828 53.0637Z"
          fill="#484C4F"
        />
        <path
          d="M192.023 84.9437H150.708C150.082 84.9437 149.481 84.6942 149.039 84.25C148.596 83.8058 148.348 83.2034 148.348 82.5753C148.348 81.9472 148.596 81.3447 149.039 80.9006C149.481 80.4564 150.082 80.2069 150.708 80.2069H192.023C192.334 80.2066 192.641 80.2676 192.927 80.3864C193.214 80.5053 193.475 80.6797 193.694 80.8997C193.913 81.1196 194.087 81.3808 194.206 81.6683C194.325 81.9559 194.386 82.264 194.386 82.5753C194.386 82.8865 194.325 83.1947 194.206 83.4822C194.087 83.7698 193.913 84.031 193.694 84.2509C193.475 84.4709 193.214 84.6453 192.927 84.7642C192.641 84.883 192.334 84.944 192.023 84.9437Z"
          fill="#323639"
        />
        <path
          d="M201.758 92.937H150.708C150.082 92.937 149.481 92.6874 149.039 92.2433C148.596 91.7991 148.348 91.1967 148.348 90.5686C148.348 89.9404 148.596 89.338 149.039 88.8939C149.481 88.4497 150.082 88.2002 150.708 88.2002H201.758C202.384 88.2002 202.985 88.4497 203.427 88.8939C203.87 89.338 204.118 89.9404 204.118 90.5686C204.118 91.1967 203.87 91.7991 203.427 92.2433C202.985 92.6874 202.384 92.937 201.758 92.937Z"
          fill="#323639"
        />
        <path
          d="M141.565 70.52H103.475C103.175 70.5201 102.887 70.6397 102.675 70.8525C102.463 71.0653 102.344 71.3539 102.344 71.6548V101.488C102.344 101.789 102.463 102.078 102.675 102.291C102.887 102.503 103.175 102.623 103.475 102.623H141.565C141.865 102.623 142.153 102.503 142.365 102.291C142.577 102.078 142.696 101.789 142.696 101.488V71.6548C142.696 71.3539 142.577 71.0653 142.365 70.8525C142.153 70.6397 141.865 70.5201 141.565 70.52Z"
          fill="#323639"
        />
        <path
          d="M191.962 122.763H135.922C135.613 122.763 135.306 122.702 135.019 122.583C134.733 122.464 134.473 122.29 134.254 122.07C134.035 121.85 133.861 121.589 133.742 121.301C133.624 121.014 133.562 120.706 133.562 120.395C133.562 120.084 133.624 119.776 133.742 119.489C133.861 119.201 134.035 118.94 134.254 118.72C134.473 118.5 134.733 118.326 135.019 118.207C135.306 118.088 135.613 118.027 135.922 118.027H191.962C192.588 118.027 193.187 118.277 193.629 118.721C194.071 119.165 194.32 119.767 194.32 120.395C194.32 121.023 194.071 121.625 193.629 122.069C193.187 122.513 192.588 122.763 191.962 122.763Z"
          fill="#323639"
        />
        <path
          d="M201.696 130.757H135.921C135.611 130.757 135.304 130.696 135.017 130.577C134.731 130.458 134.47 130.284 134.251 130.064C134.031 129.844 133.857 129.583 133.738 129.295C133.62 129.008 133.559 128.7 133.559 128.388C133.559 128.077 133.62 127.769 133.738 127.481C133.857 127.194 134.031 126.933 134.251 126.713C134.47 126.493 134.731 126.318 135.017 126.199C135.304 126.081 135.611 126.02 135.921 126.02H201.696C202.006 126.02 202.313 126.081 202.6 126.199C202.887 126.318 203.147 126.493 203.366 126.713C203.586 126.933 203.76 127.194 203.879 127.481C203.997 127.769 204.059 128.077 204.059 128.388C204.059 128.7 203.997 129.008 203.879 129.295C203.76 129.583 203.586 129.844 203.366 130.064C203.147 130.284 202.887 130.458 202.6 130.577C202.313 130.696 202.006 130.757 201.696 130.757Z"
          fill="#323639"
        />
        <path
          d="M191.962 151.493H135.922C135.297 151.493 134.696 151.243 134.254 150.799C133.811 150.355 133.563 149.752 133.562 149.124C133.563 148.496 133.811 147.894 134.254 147.45C134.696 147.005 135.297 146.756 135.922 146.756H191.962C192.588 146.756 193.188 147.005 193.631 147.45C194.074 147.894 194.322 148.496 194.322 149.124C194.322 149.752 194.074 150.355 193.631 150.799C193.188 151.243 192.588 151.493 191.962 151.493Z"
          fill="#323639"
        />
        <path
          d="M201.697 159.486H135.922C135.297 159.486 134.696 159.236 134.254 158.792C133.811 158.348 133.562 157.746 133.562 157.118C133.562 156.489 133.811 155.887 134.254 155.443C134.696 154.999 135.297 154.749 135.922 154.749H201.697C202.323 154.749 202.923 154.999 203.366 155.443C203.809 155.887 204.057 156.489 204.057 157.118C204.057 157.746 203.809 158.348 203.366 158.792C202.923 159.236 202.323 159.486 201.697 159.486Z"
          fill="#323639"
        />
        <path
          d="M113.743 134.351C119.272 134.351 123.755 129.852 123.755 124.303C123.755 118.753 119.272 114.255 113.743 114.255C108.213 114.255 103.73 118.753 103.73 124.303C103.73 129.852 108.213 134.351 113.743 134.351Z"
          fill="#323639"
        />
        <path
          d="M113.743 163.312C119.272 163.312 123.755 158.814 123.755 153.264C123.755 147.715 119.272 143.216 113.743 143.216C108.213 143.216 103.73 147.715 103.73 153.264C103.73 158.814 108.213 163.312 113.743 163.312Z"
          fill="#323639"
        />
        <path
          d="M191.962 180.454H135.922C135.297 180.454 134.696 180.205 134.254 179.76C133.811 179.316 133.563 178.714 133.562 178.086C133.563 177.458 133.811 176.855 134.254 176.411C134.696 175.967 135.297 175.717 135.922 175.717H191.962C192.588 175.717 193.188 175.967 193.631 176.411C194.074 176.855 194.322 177.458 194.322 178.086C194.322 178.714 194.074 179.316 193.631 179.76C193.188 180.205 192.588 180.454 191.962 180.454Z"
          fill="#323639"
        />
        <path
          d="M201.697 188.448H135.922C135.297 188.448 134.696 188.198 134.254 187.754C133.811 187.31 133.562 186.707 133.562 186.079C133.562 185.451 133.811 184.849 134.254 184.404C134.696 183.96 135.297 183.711 135.922 183.711H201.697C202.323 183.711 202.923 183.96 203.366 184.404C203.809 184.849 204.057 185.451 204.057 186.079C204.057 186.707 203.809 187.31 203.366 187.754C202.923 188.198 202.323 188.448 201.697 188.448Z"
          fill="#323639"
        />
        <path
          d="M113.743 192.274C119.272 192.274 123.755 187.775 123.755 182.226C123.755 176.677 119.272 172.178 113.743 172.178C108.213 172.178 103.73 176.677 103.73 182.226C103.73 187.775 108.213 192.274 113.743 192.274Z"
          fill="#323639"
        />
      </g>
      <defs>
        <clipPath id="clip0_9794_37255">
          <rect
            width="222"
            height="208"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgIndicatorResponse() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="17"
        height="17"
        rx="8.5"
        fill="#73C7B7"
      />
      <path
        d="M6.54683 6.17457L7.93444 4.8656L8.01154 4.79287L7.93445 4.72012L7.54028 4.34817L7.47166 4.28342L7.40303 4.34816L5.16167 6.46242L5.08456 6.53516L5.16166 6.6079L7.44193 8.75918L7.51055 8.82392L7.57918 8.75919L7.97349 8.38723L8.0506 8.3145L7.9735 8.24176L6.55199 6.90041L9.61087 6.91435V6.9166H9.71087H10.1117C11.1646 6.9166 12.0115 7.7235 12.0115 8.7032C12.0115 9.68255 11.1646 10.4896 10.1117 10.4896H5.23029H5.13029V10.5896V11.1157V11.2157H5.23029H10.1114C11.5713 11.2157 12.7689 10.0941 12.7689 8.7032C12.7689 7.31201 11.5713 6.19052 10.1114 6.19052H10.0924V6.19042L9.99286 6.18998L6.54683 6.17457Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
      />
    </svg>
  );
}

export function SvgRotateContent() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33938 6.41001L0.859375 12.9L7.34937 19.38L13.8394 12.9L7.33938 6.41001ZM3.68937 12.9L7.34937 9.24001L10.9994 12.9L7.33938 16.56L3.68937 12.9ZM19.3594 6.64001C17.6094 4.88001 15.2994 4.00001 12.9994 4.00001V0.76001L8.75938 5.00001L12.9994 9.24001V6.00001C14.7894 6.00001 16.5794 6.68001 17.9494 8.05001C20.6794 10.78 20.6794 15.22 17.9494 17.95C16.5794 19.32 14.7894 20 12.9994 20C12.0294 20 11.0594 19.79 10.1594 19.39L8.66937 20.88C10.0194 21.62 11.5094 22 12.9994 22C15.2994 22 17.6094 21.12 19.3594 19.36C22.8794 15.85 22.8794 10.15 19.3594 6.64001Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgNotifRequestRecrutement({ color = "#292929" }) {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.59994 14C4.82675 14 4.19995 13.3732 4.19995 12.6H6.99992C6.99992 13.3732 6.37313 14 5.59994 14ZM11.1999 11.9H0V10.5L1.39998 9.80005V5.95009C1.36311 4.96249 1.58614 3.9825 2.04678 3.10812C2.5053 2.29719 3.28905 1.72135 4.19995 1.52614V0.000159488H6.75212C5.8424 1.01685 5.69058 2.50361 6.37601 3.6832C7.06145 4.86279 8.42833 5.46705 9.76209 5.1801C9.78659 5.43 9.79849 5.68899 9.79849 5.95009V9.80005L11.1985 10.5V11.9H11.1999ZM9.0999 4.20011C7.98671 4.19838 7.06829 3.32831 7.00642 2.21684C6.94456 1.10537 7.76075 0.138749 8.86687 0.0134971C9.97299 -0.111754 10.9847 0.647892 11.1729 1.74505C11.3611 2.84221 10.6605 3.89562 9.57589 4.14621C9.41977 4.18207 9.26009 4.20015 9.0999 4.20011Z"
        fill={color}
      />
    </svg>
  );
}

export function SvgShowMore({ color = "#48B19D" }) {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5339 0C14.9729 0 15.3296 0.356694 15.3296 0.795731C15.3296 1.23477 14.9729 1.59146 14.5339 1.59146L0.795736 1.60816C0.356696 1.60816 0 1.25109 0 0.812048C0 0.37339 0.356696 0.0163169 0.795736 0.0163169L14.5339 0ZM9.98826 11.7455C9.6881 11.4438 9.69 10.9551 9.99129 10.6549C10.2926 10.3548 10.7817 10.3566 11.0819 10.6579L13.7943 13.3711L13.8064 5.53027C13.8064 5.10528 14.1514 4.75997 14.5764 4.75997C15.0014 4.75997 15.3467 5.10528 15.3467 5.53027L15.3345 13.3624L18.1092 10.5877C18.4105 10.2864 18.9011 10.2864 19.2024 10.5877C19.5041 10.8894 19.5041 11.3801 19.2024 11.6813L15.108 15.7757C14.8037 16.0759 14.3149 16.0744 14.0148 15.7727L9.98826 11.7455ZM6.51237 12.8679C6.95141 12.8679 7.3081 13.2246 7.3081 13.6637C7.3081 14.1027 6.95141 14.4594 6.51237 14.4594L0.795736 14.4655C0.356696 14.4655 0 14.1088 0 13.6697C0 13.2311 0.356696 12.874 0.795736 12.874L6.51237 12.8679ZM8.08069 6.39051C8.51973 6.39051 8.87643 6.74721 8.87643 7.18625C8.87643 7.62528 8.51973 7.98198 8.08069 7.98198L0.795736 7.9907C0.356696 7.9907 0 7.63363 0 7.19459C0 6.75594 0.356696 6.39886 0.795736 6.39886L8.08069 6.39051Z"
        fill={color}
      />
    </svg>
  );
}

export function SvgFlag() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.21094 0.882324V7.62656H13.9178L11.9751 4.25444L13.9178 0.882324H6.21094Z"
        fill="#3D3F3C"
      />
      <path
        d="M3.4668 0.882324H5.33207V12.869H3.4668V0.882324Z"
        fill="#3D3F3C"
      />
      <path
        d="M6.70647 12.353H2.09713V13.6086H1.11328V14.4875H7.69043V13.6086H6.70647V12.353Z"
        fill="#3D3F3C"
      />
    </svg>
  );
}

export function WhiteFlag({ stroke = "black", width = "18", height = "22" } = {}) {
  return (
    <svg width={width} height={height} viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 14C1 14 2 13 5 13C8 13 10 15 13 15C16 15 17 14 17 14V2C17 2 16 3 13 3C10 3 8 1 5 1C2 1 1 2 1 2L1 21" stroke={stroke} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}

export function SvgMileinage() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 13.5007H1.5658V15.8494H17.2236V13.5007H18.7895V17.4152H0V13.5007ZM2.27694 0.785156V7.09391H2.30616L2.81768 6.24982L4.26456 4.14639H6.93909L4.38145 6.9795L7.30445 11.1428H4.57147L2.83226 8.26712L2.27694 8.95387V11.1428H0.103095V0.785156H2.27694ZM8.00006 11.1428V6.37858L7.94161 4.14639H9.82693L9.9146 5.1008H9.95846C10.1084 4.85737 10.3607 4.61756 10.7153 4.38121C11.0699 4.14486 11.5562 4.01788 12.1741 4.00028C12.6484 4.00468 13.055 4.11227 13.3938 4.32301C13.7327 4.53375 13.9807 4.82123 14.1381 5.18545H14.1673C14.4421 4.81861 14.7464 4.53642 15.08 4.33888C15.4516 4.12023 15.8861 4.00735 16.3838 4.00028C17.0806 3.99548 17.6513 4.23782 18.096 4.72733C18.5407 5.2168 18.7705 5.98202 18.7853 7.02306V11.1428H16.6223V7.33773C16.6232 6.82666 16.5408 6.43267 16.3752 6.15582C16.2095 5.87898 15.9554 5.73895 15.6128 5.73568C15.3601 5.74132 15.1504 5.81583 14.9837 5.95913C14.8169 6.10247 14.6948 6.28068 14.6174 6.49374L14.5473 7.05164V11.1428H12.3843V7.20902C12.3858 6.76584 12.3001 6.41121 12.1272 6.14509C11.9543 5.87898 11.6848 5.74251 11.3186 5.73568C11.0266 5.74641 10.7928 5.8322 10.617 5.9931C10.4413 6.15404 10.32 6.32567 10.2531 6.50808C10.1856 6.68687 10.1556 6.87284 10.1631 7.06593V11.1428H8.00006Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function SvgItinerary() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.66732 12.7493L0.708984 15.5827V4.24935L5.66732 1.41602M5.66732 12.7493L11.334 15.5827M5.66732 12.7493V1.41602M11.334 15.5827L16.2923 12.7493V1.41602L11.334 4.24935M11.334 15.5827V4.24935M11.334 4.24935L5.66732 1.41602"
        stroke="#292929"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgAssesment({ color = "#292929" }) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_12447_25049"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="19"
        height="19"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0.03125H18.0044V18.8913H0V0.03125Z"
          fill={color}
        />
      </mask>
      <g mask="url(#mask0_12447_25049)">
        <path
          d="M8.49923 -0.0390625C6.0046 -0.0390625 3.96517 1.93836 3.96517 4.35541C3.96517 5.77048 4.66714 7.03068 5.7474 7.83553C3.53613 8.84081 2.00001 11.0109 2.00001 13.5326V15.2017C1.99914 15.4032 2.08146 15.5967 2.22869 15.7394C2.3757 15.8818 2.57564 15.9616 2.78364 15.9609H14.2225C14.6535 15.9592 15.0018 15.6193 15 15.2017V13.5325C15 11.0104 13.4639 8.84057 11.2526 7.83552C12.3329 7.03072 13.0348 5.77047 13.0348 4.3554C13.0348 1.9384 10.9939 -0.0390625 8.49923 -0.0390625ZM8.49923 1.47352C10.1503 1.47352 11.4737 2.75564 11.4737 4.35541C11.4737 5.95513 10.1504 7.2358 8.49923 7.2358C6.84808 7.2358 5.52633 5.95513 5.52633 4.35541C5.52633 2.7557 6.84813 1.47352 8.49923 1.47352ZM8.49923 8.74848C11.2493 8.74848 13.4434 10.8684 13.4434 13.5329V14.4487H3.56128V13.5329C3.56128 10.8681 5.74913 8.74848 8.49923 8.74848Z"
          fill={color}
        />
        <path
          d="M13.3516 10.3487C13.4406 10.1104 13.6866 9.95334 13.9584 9.96122C13.9794 9.96199 14.0001 9.96377 14.0208 9.96665C14.2527 9.99549 14.4474 10.1425 14.5246 10.3472L15.2011 12.1541L17.2654 12.1945C17.53 12.1993 17.7623 12.3588 17.8444 12.592C17.9263 12.8249 17.8402 13.0807 17.6297 13.2291L15.9821 14.3862L16.5816 16.2173C16.6581 16.4524 16.5657 16.7063 16.3514 16.8505C16.1372 16.9944 15.8479 16.9969 15.6308 16.8566L13.9367 15.7641L12.241 16.8579C12.0235 16.998 11.7338 16.995 11.5198 16.8502C11.3055 16.7055 11.2141 16.451 11.2916 16.2161L11.8898 14.385L10.2435 13.2279C10.0343 13.0792 9.94903 12.8245 10.0305 12.5923C10.1123 12.3599 10.3431 12.2006 10.6065 12.1946L12.6722 12.1556L13.3516 10.3487Z"
          fill={color}
          stroke="white"
          strokeWidth="0.6"
        />
      </g>
    </svg>
  );
}

export function SvgAmount() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.06651 3.11852C9.22395 0.960078 12.723 0.960911 14.8813 3.11852C17.0396 5.27612 17.0396 8.77546 14.8813 10.9339M12.553 10.9731C12.553 14.0255 10.0787 16.5 7.02651 16.5C3.9743 16.5 1.5 14.0255 1.5 10.9731C1.5 7.92062 3.9743 5.44613 7.02651 5.44613C10.0787 5.44613 12.553 7.92062 12.553 10.9731Z"
        stroke="#101828"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgJoinFile(color = "white") {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.875 10.125V12.9583C13.875 13.3341 13.7257 13.6944 13.4601 13.9601C13.1944 14.2257 12.8341 14.375 12.4583 14.375H2.54167C2.16594 14.375 1.80561 14.2257 1.53993 13.9601C1.27426 13.6944 1.125 13.3341 1.125 12.9583V10.125M11.0417 5.16667L7.5 1.625M7.5 1.625L3.95833 5.16667M7.5 1.625V10.125"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgStatCircle() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.98865 15.95C3.73118 15.9463 0.223337 12.607 0.0101865 8.3549C-0.202964 4.10277 2.95335 0.42942 7.18911 0V3.23014C4.78299 3.63676 3.06661 5.78643 3.20272 8.22287C3.33883 10.6593 5.28395 12.6044 7.72039 12.7405C10.1568 12.8767 12.3065 11.1603 12.7131 8.75415H15.9433C15.5273 12.837 12.0919 15.9445 7.98785 15.95H7.98865ZM15.9441 7.15507H12.7139C12.3737 5.14479 10.7985 3.56999 8.78819 3.23014V0C12.5677 0.386962 15.5559 3.37484 15.9433 7.15427L15.9441 7.15507Z"
        fill="#73C7B7"
      />
    </svg>
  );
}

export function SvgDocumentation({ color = "#292929" }) {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5787 19.1729H8.20602C7.98396 19.1729 7.77099 19.0847 7.61398 18.9277C7.45696 18.7707 7.36874 18.5577 7.36874 18.3357V8.28838C7.36874 8.06633 7.45696 7.85336 7.61398 7.69634C7.77099 7.53932 7.98396 7.45111 8.20602 7.45111H16.5787C16.8008 7.45111 17.0138 7.53932 17.1708 7.69634C17.3278 7.85336 17.416 8.06633 17.416 8.28838V18.3357C17.416 18.5577 17.3278 18.7707 17.1708 18.9277C17.0138 19.0847 16.8008 19.1729 16.5787 19.1729ZM15.7415 9.62566C15.7415 9.34951 15.5176 9.12566 15.2415 9.12566H9.54329C9.26715 9.12566 9.04329 9.34951 9.04329 9.62566V16.9984C9.04329 17.2745 9.26715 17.4984 9.54329 17.4984H15.2415C15.5176 17.4984 15.7415 17.2745 15.7415 16.9984V9.62566ZM5.6942 14.9866V6.27657C5.6942 6.00042 5.91806 5.77657 6.1942 5.77657H13.2297C13.4517 5.77657 13.6647 5.68835 13.8217 5.53133C13.9787 5.37432 14.0669 5.16135 14.0669 4.93929C14.0669 4.71723 13.9787 4.50427 13.8217 4.34725C13.6647 4.19023 13.4517 4.10202 13.2297 4.10202H4.85693C4.63487 4.10202 4.4219 4.19023 4.26488 4.34725C4.10787 4.50427 4.01965 4.71723 4.01965 4.93929V14.9866C4.01965 15.2086 4.10787 15.4216 4.26488 15.5786C4.4219 15.7356 4.63487 15.8238 4.85693 15.8238C5.07898 15.8238 5.29195 15.7356 5.44897 15.5786C5.60599 15.4216 5.6942 15.2086 5.6942 14.9866ZM0.670563 1.5902V12.4747C0.670563 12.6968 0.758776 12.9098 0.915794 13.0668C1.07281 13.2238 1.28578 13.312 1.50784 13.312C1.72989 13.312 1.94286 13.2238 2.09988 13.0668C2.2569 12.9098 2.34511 12.6968 2.34511 12.4747V2.92748C2.34511 2.65133 2.56897 2.42748 2.84511 2.42748H9.88056C10.1026 2.42748 10.3156 2.33926 10.4726 2.18224C10.6296 2.02522 10.7178 1.81226 10.7178 1.5902C10.7178 1.36814 10.6296 1.15518 10.4726 0.998161C10.3156 0.841142 10.1026 0.75293 9.88056 0.75293H1.50784C1.28578 0.75293 1.07281 0.841142 0.915794 0.998161C0.758776 1.15518 0.670563 1.36814 0.670563 1.5902Z"
        fill={color}
      />
    </svg>
  );
}

export function ShapeTable() {
  return (
    <svg
      width="12"
      height="6"
      viewBox="0 0 12 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 0.75L6 5.25L10.5 0.75"
        stroke="#292929"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgAddCriteria() {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8995 17H1.69993C0.761083 17 0 16.2389 0 15.3001V1.70067C0 0.761823 0.761083 0.00074072 1.69993 0.00074072H7.64967C7.65728 -0.000246907 7.665 -0.000246907 7.67262 0.00074072H7.67772C7.68574 0.00325496 7.694 0.00496332 7.70236 0.0058405C7.77732 0.0106455 7.85133 0.0252181 7.92251 0.0491886H7.93526H7.948H7.9582C7.97389 0.060175 7.98867 0.0723967 8.0024 0.085737C8.095 0.126895 8.17938 0.18449 8.25144 0.25573L13.3512 5.35551C13.4225 5.42757 13.4801 5.51195 13.5212 5.60455C13.5289 5.62325 13.5348 5.6411 13.5408 5.66064V5.67254V5.68444C13.5645 5.75532 13.5785 5.82909 13.5824 5.90373C13.5831 5.9122 13.5852 5.92051 13.5884 5.92838V5.93348C13.5927 5.93871 13.5964 5.94441 13.5994 5.95048V15.3001C13.5994 16.2389 12.8383 17 11.8995 17ZM1.69993 1.70067V15.3001H11.8995V6.80044H7.64967C7.18025 6.80044 6.7997 6.4199 6.7997 5.95048V1.70067H1.69993ZM8.49963 2.90251V5.10052H10.6976L8.49963 2.90251ZM7.64967 13.6001H5.94974V11.9002H4.24981V10.2003H5.94974V8.50037H7.64967V10.2003H9.34959V11.9002H7.64967V13.6001Z"
        fill="#292929"
      />
    </svg>
  );
}

export function Target() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13592_83373)">
        <path
          d="M11.0026 20.1667C16.0652 20.1667 20.1693 16.0627 20.1693 11C20.1693 5.93743 16.0652 1.83337 11.0026 1.83337C5.93999 1.83337 1.83594 5.93743 1.83594 11C1.83594 16.0627 5.93999 20.1667 11.0026 20.1667Z"
          stroke="#101828"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0026 16.5C14.0402 16.5 16.5026 14.0376 16.5026 11C16.5026 7.96247 14.0402 5.50004 11.0026 5.50004C7.96504 5.50004 5.5026 7.96247 5.5026 11C5.5026 14.0376 7.96504 16.5 11.0026 16.5Z"
          stroke="#101828"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0026 12.8334C12.0151 12.8334 12.8359 12.0126 12.8359 11C12.8359 9.98752 12.0151 9.16671 11.0026 9.16671C9.99008 9.16671 9.16927 9.98752 9.16927 11C9.16927 12.0126 9.99008 12.8334 11.0026 12.8334Z"
          stroke="#101828"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_13592_83373">
          <rect
            width="22"
            height="22"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Exp() {
  return (
    <svg
      width="961"
      height="79"
      viewBox="0 0 961 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="8"
        width="961"
        height="71"
        fill="white"
      />
      <path
        d="M97.5423 4.322H93.4173V12H97.5423V11.175H94.4183V8.535H97.2123V7.71H94.4183V5.147H97.5423V4.322ZM103.358 12H104.348V8.447C104.348 6.72 103.281 5.862 101.884 5.862C101.07 5.862 100.344 6.203 99.948 6.83V5.972H98.947V12H99.948V8.667C99.948 7.369 100.652 6.731 101.675 6.731C102.687 6.731 103.358 7.358 103.358 8.59V12ZM108.883 12H109.884V6.797H111.149V5.972H109.884V5.543C109.884 4.762 110.181 4.432 111.083 4.432V3.596C109.543 3.596 108.883 4.201 108.883 5.543V5.972H108.102V6.797H108.883V12ZM117.926 8.975C117.926 7.072 116.595 5.873 114.879 5.873C113.174 5.873 111.832 7.072 111.832 8.975C111.832 10.889 113.13 12.099 114.835 12.099C116.551 12.099 117.926 10.889 117.926 8.975ZM112.855 8.975C112.855 7.457 113.812 6.742 114.868 6.742C115.902 6.742 116.903 7.457 116.903 8.975C116.903 10.504 115.88 11.219 114.835 11.219C113.79 11.219 112.855 10.504 112.855 8.975ZM120.133 8.722C120.133 7.325 120.859 6.896 121.816 6.896H122.08V5.862C121.123 5.862 120.474 6.28 120.133 6.951V5.972H119.132V12H120.133V8.722ZM131.826 12H132.816V8.447C132.816 6.72 131.749 5.862 130.374 5.862C129.45 5.862 128.592 6.335 128.24 7.204C127.844 6.302 127.019 5.862 126.029 5.862C125.237 5.862 124.522 6.203 124.126 6.841V5.972H123.125V12H124.126V8.678C124.126 7.38 124.819 6.731 125.831 6.731C126.821 6.731 127.481 7.358 127.481 8.59V12H128.471V8.678C128.471 7.38 129.164 6.731 130.176 6.731C131.166 6.731 131.826 7.358 131.826 8.59V12ZM133.974 8.964C133.974 10.834 135.217 12.099 136.823 12.099C137.934 12.099 138.715 11.527 139.078 10.878V12H140.09V5.972H139.078V7.072C138.726 6.445 137.956 5.873 136.834 5.873C135.217 5.873 133.974 7.083 133.974 8.964ZM139.078 8.975C139.078 10.394 138.132 11.219 137.032 11.219C135.932 11.219 134.997 10.383 134.997 8.964C134.997 7.545 135.932 6.742 137.032 6.742C138.132 6.742 139.078 7.578 139.078 8.975ZM141.892 10.35C141.892 11.56 142.497 12 143.564 12H144.466V11.153H143.729C143.113 11.153 142.893 10.944 142.893 10.35V6.797H144.466V5.972H142.893V4.454H141.892V5.972H141.111V6.797H141.892V10.35ZM145.569 12H146.57V5.972H145.569V12ZM146.086 4.993C146.449 4.993 146.746 4.696 146.746 4.311C146.746 3.926 146.449 3.629 146.086 3.629C145.701 3.629 145.404 3.926 145.404 4.311C145.404 4.696 145.701 4.993 146.086 4.993ZM153.886 8.975C153.886 7.072 152.555 5.873 150.839 5.873C149.134 5.873 147.792 7.072 147.792 8.975C147.792 10.889 149.09 12.099 150.795 12.099C152.511 12.099 153.886 10.889 153.886 8.975ZM148.815 8.975C148.815 7.457 149.772 6.742 150.828 6.742C151.862 6.742 152.863 7.457 152.863 8.975C152.863 10.504 151.84 11.219 150.795 11.219C149.75 11.219 148.815 10.504 148.815 8.975ZM159.503 12H160.493V8.447C160.493 6.72 159.426 5.862 158.029 5.862C157.215 5.862 156.489 6.203 156.093 6.83V5.972H155.092V12H156.093V8.667C156.093 7.369 156.797 6.731 157.82 6.731C158.832 6.731 159.503 7.358 159.503 8.59V12Z"
        fill="#292929"
      />
      <path
        d="M347.899 9.998C347.899 10.636 347.58 11.186 346.788 11.186C345.996 11.186 345.666 10.625 345.655 9.921H344.654C344.654 11.263 345.512 12.077 346.788 12.077C348.053 12.077 348.911 11.274 348.911 9.998V4.333H347.899V9.998ZM356.119 5.972H355.118V9.283C355.118 10.581 354.425 11.219 353.391 11.219C352.379 11.219 351.708 10.592 351.708 9.371V5.972H350.718V9.503C350.718 11.23 351.807 12.088 353.193 12.088C353.996 12.088 354.733 11.736 355.118 11.109V12H356.119V5.972ZM362.11 12H363.1V8.447C363.1 6.72 362.033 5.862 360.636 5.862C359.822 5.862 359.096 6.203 358.7 6.83V5.972H357.699V12H358.7V8.667C358.7 7.369 359.404 6.731 360.427 6.731C361.439 6.731 362.11 7.358 362.11 8.59V12ZM364.625 12H365.626V5.972H364.625V12ZM365.142 4.993C365.505 4.993 365.802 4.696 365.802 4.311C365.802 3.926 365.505 3.629 365.142 3.629C364.757 3.629 364.46 3.926 364.46 4.311C364.46 4.696 364.757 4.993 365.142 4.993ZM372.942 8.975C372.942 7.072 371.611 5.873 369.895 5.873C368.19 5.873 366.848 7.072 366.848 8.975C366.848 10.889 368.146 12.099 369.851 12.099C371.567 12.099 372.942 10.889 372.942 8.975ZM367.871 8.975C367.871 7.457 368.828 6.742 369.884 6.742C370.918 6.742 371.919 7.457 371.919 8.975C371.919 10.504 370.896 11.219 369.851 11.219C368.806 11.219 367.871 10.504 367.871 8.975ZM375.15 8.722C375.15 7.325 375.876 6.896 376.833 6.896H377.097V5.862C376.14 5.862 375.491 6.28 375.15 6.951V5.972H374.149V12H375.15V8.722Z"
        fill="#292929"
      />
      <path
        d="M555.394 12H556.395V4.333H555.394V12ZM562.402 12H563.392V8.447C563.392 6.72 562.325 5.862 560.928 5.862C560.114 5.862 559.388 6.203 558.992 6.83V5.972H557.991V12H558.992V8.667C558.992 7.369 559.696 6.731 560.719 6.731C561.731 6.731 562.402 7.358 562.402 8.59V12ZM565.137 10.35C565.137 11.56 565.742 12 566.809 12H567.711V11.153H566.974C566.358 11.153 566.138 10.944 566.138 10.35V6.797H567.711V5.972H566.138V4.454H565.137V5.972H564.356V6.797H565.137V10.35ZM571.377 6.72C572.411 6.72 573.291 7.369 573.28 8.546H569.474C569.584 7.369 570.398 6.72 571.377 6.72ZM574.193 10.141H573.115C572.895 10.79 572.323 11.252 571.421 11.252C570.398 11.252 569.54 10.581 569.463 9.36H574.281C574.303 9.151 574.314 8.975 574.314 8.755C574.314 7.105 573.17 5.873 571.421 5.873C569.661 5.873 568.44 7.072 568.44 8.975C568.44 10.889 569.705 12.099 571.421 12.099C572.917 12.099 573.885 11.241 574.193 10.141ZM576.526 8.722C576.526 7.325 577.252 6.896 578.209 6.896H578.473V5.862C577.516 5.862 576.867 6.28 576.526 6.951V5.972H575.525V12H576.526V8.722ZM588.22 12H589.21V8.447C589.21 6.72 588.143 5.862 586.768 5.862C585.844 5.862 584.986 6.335 584.634 7.204C584.238 6.302 583.413 5.862 582.423 5.862C581.631 5.862 580.916 6.203 580.52 6.841V5.972H579.519V12H580.52V8.678C580.52 7.38 581.213 6.731 582.225 6.731C583.215 6.731 583.875 7.358 583.875 8.59V12H584.865V8.678C584.865 7.38 585.558 6.731 586.57 6.731C587.56 6.731 588.22 7.358 588.22 8.59V12ZM593.305 6.72C594.339 6.72 595.219 7.369 595.208 8.546H591.402C591.512 7.369 592.326 6.72 593.305 6.72ZM596.121 10.141H595.043C594.823 10.79 594.251 11.252 593.349 11.252C592.326 11.252 591.468 10.581 591.391 9.36H596.209C596.231 9.151 596.242 8.975 596.242 8.755C596.242 7.105 595.098 5.873 593.349 5.873C591.589 5.873 590.368 7.072 590.368 8.975C590.368 10.889 591.633 12.099 593.349 12.099C594.845 12.099 595.813 11.241 596.121 10.141ZM592.04 4.773V5.521L594.383 4.267V3.398L592.04 4.773ZM597.079 8.964C597.079 10.834 598.322 12.099 599.939 12.099C601.039 12.099 601.82 11.538 602.183 10.867V12H603.195V3.86H602.183V7.05C601.765 6.357 600.896 5.873 599.95 5.873C598.322 5.873 597.079 7.083 597.079 8.964ZM602.183 8.975C602.183 10.394 601.237 11.219 600.137 11.219C599.037 11.219 598.102 10.383 598.102 8.964C598.102 7.545 599.037 6.742 600.137 6.742C601.237 6.742 602.183 7.578 602.183 8.975ZM604.777 12H605.778V5.972H604.777V12ZM605.294 4.993C605.657 4.993 605.954 4.696 605.954 4.311C605.954 3.926 605.657 3.629 605.294 3.629C604.909 3.629 604.612 3.926 604.612 4.311C604.612 4.696 604.909 4.993 605.294 4.993ZM607 8.964C607 10.834 608.243 12.099 609.849 12.099C610.96 12.099 611.741 11.527 612.104 10.878V12H613.116V5.972H612.104V7.072C611.752 6.445 610.982 5.873 609.86 5.873C608.243 5.873 607 7.083 607 8.964ZM612.104 8.975C612.104 10.394 611.158 11.219 610.058 11.219C608.958 11.219 608.023 10.383 608.023 8.964C608.023 7.545 608.958 6.742 610.058 6.742C611.158 6.742 612.104 7.578 612.104 8.975ZM614.697 12H615.698V5.972H614.697V12ZM615.214 4.993C615.577 4.993 615.874 4.696 615.874 4.311C615.874 3.926 615.577 3.629 615.214 3.629C614.829 3.629 614.532 3.926 614.532 4.311C614.532 4.696 614.829 4.993 615.214 4.993ZM618.295 8.722C618.295 7.325 619.021 6.896 619.978 6.896H620.242V5.862C619.285 5.862 618.636 6.28 618.295 6.951V5.972H617.294V12H618.295V8.722ZM623.851 6.72C624.885 6.72 625.765 7.369 625.754 8.546H621.948C622.058 7.369 622.872 6.72 623.851 6.72ZM626.667 10.141H625.589C625.369 10.79 624.797 11.252 623.895 11.252C622.872 11.252 622.014 10.581 621.937 9.36H626.755C626.777 9.151 626.788 8.975 626.788 8.755C626.788 7.105 625.644 5.873 623.895 5.873C622.135 5.873 620.914 7.072 620.914 8.975C620.914 10.889 622.179 12.099 623.895 12.099C625.391 12.099 626.359 11.241 626.667 10.141Z"
        fill="#292929"
      />
      <path
        d="M800.785 4.322H796.66V12H800.785V11.175H797.661V8.535H800.455V7.71H797.661V5.147H800.785V4.322ZM805.335 12H806.468L804.521 8.953L806.457 5.972H805.412L804.048 8.205L802.618 5.972H801.485L803.432 9.008L801.485 12H802.53L803.905 9.756L805.335 12ZM808.344 7.083V5.972H807.343V14.86H808.344V10.889C808.718 11.505 809.499 12.099 810.599 12.099C812.216 12.099 813.459 10.834 813.459 8.964C813.459 7.083 812.216 5.873 810.599 5.873C809.499 5.873 808.707 6.445 808.344 7.083ZM812.436 8.964C812.436 10.383 811.501 11.219 810.39 11.219C809.301 11.219 808.344 10.394 808.344 8.975C808.344 7.578 809.301 6.742 810.39 6.742C811.501 6.742 812.436 7.545 812.436 8.964ZM817.229 6.72C818.263 6.72 819.143 7.369 819.132 8.546H815.326C815.436 7.369 816.25 6.72 817.229 6.72ZM820.045 10.141H818.967C818.747 10.79 818.175 11.252 817.273 11.252C816.25 11.252 815.392 10.581 815.315 9.36H820.133C820.155 9.151 820.166 8.975 820.166 8.755C820.166 7.105 819.022 5.873 817.273 5.873C815.513 5.873 814.292 7.072 814.292 8.975C814.292 10.889 815.557 12.099 817.273 12.099C818.769 12.099 819.737 11.241 820.045 10.141ZM815.964 4.773V5.521L818.307 4.267V3.398L815.964 4.773ZM822.379 8.722C822.379 7.325 823.105 6.896 824.062 6.896H824.326V5.862C823.369 5.862 822.72 6.28 822.379 6.951V5.972H821.378V12H822.379V8.722ZM825.371 12H826.372V5.972H825.371V12ZM825.888 4.993C826.251 4.993 826.548 4.696 826.548 4.311C826.548 3.926 826.251 3.629 825.888 3.629C825.503 3.629 825.206 3.926 825.206 4.311C825.206 4.696 825.503 4.993 825.888 4.993ZM836.669 12H837.659V8.447C837.659 6.72 836.592 5.862 835.217 5.862C834.293 5.862 833.435 6.335 833.083 7.204C832.687 6.302 831.862 5.862 830.872 5.862C830.08 5.862 829.365 6.203 828.969 6.841V5.972H827.968V12H828.969V8.678C828.969 7.38 829.662 6.731 830.674 6.731C831.664 6.731 832.324 7.358 832.324 8.59V12H833.314V8.678C833.314 7.38 834.007 6.731 835.019 6.731C836.009 6.731 836.669 7.358 836.669 8.59V12ZM841.754 6.72C842.788 6.72 843.668 7.369 843.657 8.546H839.851C839.961 7.369 840.775 6.72 841.754 6.72ZM844.57 10.141H843.492C843.272 10.79 842.7 11.252 841.798 11.252C840.775 11.252 839.917 10.581 839.84 9.36H844.658C844.68 9.151 844.691 8.975 844.691 8.755C844.691 7.105 843.547 5.873 841.798 5.873C840.038 5.873 838.817 7.072 838.817 8.975C838.817 10.889 840.082 12.099 841.798 12.099C843.294 12.099 844.262 11.241 844.57 10.141ZM850.314 12H851.304V8.447C851.304 6.72 850.237 5.862 848.84 5.862C848.026 5.862 847.3 6.203 846.904 6.83V5.972H845.903V12H846.904V8.667C846.904 7.369 847.608 6.731 848.631 6.731C849.643 6.731 850.314 7.358 850.314 8.59V12ZM853.049 10.35C853.049 11.56 853.654 12 854.721 12H855.623V11.153H854.886C854.27 11.153 854.05 10.944 854.05 10.35V6.797H855.623V5.972H854.05V4.454H853.049V5.972H852.268V6.797H853.049V10.35ZM859.289 6.72C860.323 6.72 861.203 7.369 861.192 8.546H857.386C857.496 7.369 858.31 6.72 859.289 6.72ZM862.105 10.141H861.027C860.807 10.79 860.235 11.252 859.333 11.252C858.31 11.252 857.452 10.581 857.375 9.36H862.193C862.215 9.151 862.226 8.975 862.226 8.755C862.226 7.105 861.082 5.873 859.333 5.873C857.573 5.873 856.352 7.072 856.352 8.975C856.352 10.889 857.617 12.099 859.333 12.099C860.829 12.099 861.797 11.241 862.105 10.141ZM858.024 4.773V5.521L860.367 4.267V3.398L858.024 4.773Z"
        fill="#292929"
      />
      <line
        x1="172.234"
        y1="34"
        x2="172.234"
        y2="54"
        stroke="white"
        stroke-dasharray="2 2"
      />
      <line
        x1="99.1562"
        y1="34"
        x2="99.1562"
        y2="54"
        stroke="white"
        stroke-dasharray="2 2"
      />
      <path
        d="M24.3594 44C24.3594 38.4772 28.8365 34 34.3594 34H926.639C932.162 34 936.639 38.4772 936.639 44V44C936.639 49.5228 932.162 54 926.639 54H34.3594C28.8365 54 24.3594 49.5228 24.3594 44V44Z"
        fill="url(#paint0_linear_13592_84858)"
      />
      <line
        x1="329.5"
        y1="34"
        x2="329.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="228.5"
        y1="34"
        x2="228.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="127.5"
        y1="34"
        x2="127.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="27.5"
        y1="34"
        x2="27.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="630.5"
        y1="34"
        x2="630.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="429.5"
        y1="34"
        x2="429.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="530.5"
        y1="34"
        x2="530.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="932.5"
        y1="34"
        x2="932.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="731.5"
        y1="34"
        x2="731.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="832.5"
        y1="34"
        x2="832.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13592_84858"
          x1="936.639"
          y1="34"
          x2="24.3594"
          y2="34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#A7EBDE" />
          <stop
            offset="0.391525"
            stop-color="#D3F0C9"
          />
          <stop
            offset="0.559254"
            stop-color="#F8F1B6"
          />
          <stop
            offset="0.750999"
            stop-color="#F7F7F7"
          />
          <stop
            offset="1"
            stop-color="#F7F7F7"
          />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function Intermediaire() {
  return (
    <svg
      width="961"
      height="79"
      viewBox="0 0 961 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="8"
        width="961"
        height="71"
        fill="white"
      />
      <path
        d="M97.5423 4.322H93.4173V12H97.5423V11.175H94.4183V8.535H97.2123V7.71H94.4183V5.147H97.5423V4.322ZM103.358 12H104.348V8.447C104.348 6.72 103.281 5.862 101.884 5.862C101.07 5.862 100.344 6.203 99.948 6.83V5.972H98.947V12H99.948V8.667C99.948 7.369 100.652 6.731 101.675 6.731C102.687 6.731 103.358 7.358 103.358 8.59V12ZM108.883 12H109.884V6.797H111.149V5.972H109.884V5.543C109.884 4.762 110.181 4.432 111.083 4.432V3.596C109.543 3.596 108.883 4.201 108.883 5.543V5.972H108.102V6.797H108.883V12ZM117.926 8.975C117.926 7.072 116.595 5.873 114.879 5.873C113.174 5.873 111.832 7.072 111.832 8.975C111.832 10.889 113.13 12.099 114.835 12.099C116.551 12.099 117.926 10.889 117.926 8.975ZM112.855 8.975C112.855 7.457 113.812 6.742 114.868 6.742C115.902 6.742 116.903 7.457 116.903 8.975C116.903 10.504 115.88 11.219 114.835 11.219C113.79 11.219 112.855 10.504 112.855 8.975ZM120.133 8.722C120.133 7.325 120.859 6.896 121.816 6.896H122.08V5.862C121.123 5.862 120.474 6.28 120.133 6.951V5.972H119.132V12H120.133V8.722ZM131.826 12H132.816V8.447C132.816 6.72 131.749 5.862 130.374 5.862C129.45 5.862 128.592 6.335 128.24 7.204C127.844 6.302 127.019 5.862 126.029 5.862C125.237 5.862 124.522 6.203 124.126 6.841V5.972H123.125V12H124.126V8.678C124.126 7.38 124.819 6.731 125.831 6.731C126.821 6.731 127.481 7.358 127.481 8.59V12H128.471V8.678C128.471 7.38 129.164 6.731 130.176 6.731C131.166 6.731 131.826 7.358 131.826 8.59V12ZM133.974 8.964C133.974 10.834 135.217 12.099 136.823 12.099C137.934 12.099 138.715 11.527 139.078 10.878V12H140.09V5.972H139.078V7.072C138.726 6.445 137.956 5.873 136.834 5.873C135.217 5.873 133.974 7.083 133.974 8.964ZM139.078 8.975C139.078 10.394 138.132 11.219 137.032 11.219C135.932 11.219 134.997 10.383 134.997 8.964C134.997 7.545 135.932 6.742 137.032 6.742C138.132 6.742 139.078 7.578 139.078 8.975ZM141.892 10.35C141.892 11.56 142.497 12 143.564 12H144.466V11.153H143.729C143.113 11.153 142.893 10.944 142.893 10.35V6.797H144.466V5.972H142.893V4.454H141.892V5.972H141.111V6.797H141.892V10.35ZM145.569 12H146.57V5.972H145.569V12ZM146.086 4.993C146.449 4.993 146.746 4.696 146.746 4.311C146.746 3.926 146.449 3.629 146.086 3.629C145.701 3.629 145.404 3.926 145.404 4.311C145.404 4.696 145.701 4.993 146.086 4.993ZM153.886 8.975C153.886 7.072 152.555 5.873 150.839 5.873C149.134 5.873 147.792 7.072 147.792 8.975C147.792 10.889 149.09 12.099 150.795 12.099C152.511 12.099 153.886 10.889 153.886 8.975ZM148.815 8.975C148.815 7.457 149.772 6.742 150.828 6.742C151.862 6.742 152.863 7.457 152.863 8.975C152.863 10.504 151.84 11.219 150.795 11.219C149.75 11.219 148.815 10.504 148.815 8.975ZM159.503 12H160.493V8.447C160.493 6.72 159.426 5.862 158.029 5.862C157.215 5.862 156.489 6.203 156.093 6.83V5.972H155.092V12H156.093V8.667C156.093 7.369 156.797 6.731 157.82 6.731C158.832 6.731 159.503 7.358 159.503 8.59V12Z"
        fill="#292929"
      />
      <path
        d="M347.899 9.998C347.899 10.636 347.58 11.186 346.788 11.186C345.996 11.186 345.666 10.625 345.655 9.921H344.654C344.654 11.263 345.512 12.077 346.788 12.077C348.053 12.077 348.911 11.274 348.911 9.998V4.333H347.899V9.998ZM356.119 5.972H355.118V9.283C355.118 10.581 354.425 11.219 353.391 11.219C352.379 11.219 351.708 10.592 351.708 9.371V5.972H350.718V9.503C350.718 11.23 351.807 12.088 353.193 12.088C353.996 12.088 354.733 11.736 355.118 11.109V12H356.119V5.972ZM362.11 12H363.1V8.447C363.1 6.72 362.033 5.862 360.636 5.862C359.822 5.862 359.096 6.203 358.7 6.83V5.972H357.699V12H358.7V8.667C358.7 7.369 359.404 6.731 360.427 6.731C361.439 6.731 362.11 7.358 362.11 8.59V12ZM364.625 12H365.626V5.972H364.625V12ZM365.142 4.993C365.505 4.993 365.802 4.696 365.802 4.311C365.802 3.926 365.505 3.629 365.142 3.629C364.757 3.629 364.46 3.926 364.46 4.311C364.46 4.696 364.757 4.993 365.142 4.993ZM372.942 8.975C372.942 7.072 371.611 5.873 369.895 5.873C368.19 5.873 366.848 7.072 366.848 8.975C366.848 10.889 368.146 12.099 369.851 12.099C371.567 12.099 372.942 10.889 372.942 8.975ZM367.871 8.975C367.871 7.457 368.828 6.742 369.884 6.742C370.918 6.742 371.919 7.457 371.919 8.975C371.919 10.504 370.896 11.219 369.851 11.219C368.806 11.219 367.871 10.504 367.871 8.975ZM375.15 8.722C375.15 7.325 375.876 6.896 376.833 6.896H377.097V5.862C376.14 5.862 375.491 6.28 375.15 6.951V5.972H374.149V12H375.15V8.722Z"
        fill="#292929"
      />
      <path
        d="M555.394 12H556.395V4.333H555.394V12ZM562.402 12H563.392V8.447C563.392 6.72 562.325 5.862 560.928 5.862C560.114 5.862 559.388 6.203 558.992 6.83V5.972H557.991V12H558.992V8.667C558.992 7.369 559.696 6.731 560.719 6.731C561.731 6.731 562.402 7.358 562.402 8.59V12ZM565.137 10.35C565.137 11.56 565.742 12 566.809 12H567.711V11.153H566.974C566.358 11.153 566.138 10.944 566.138 10.35V6.797H567.711V5.972H566.138V4.454H565.137V5.972H564.356V6.797H565.137V10.35ZM571.377 6.72C572.411 6.72 573.291 7.369 573.28 8.546H569.474C569.584 7.369 570.398 6.72 571.377 6.72ZM574.193 10.141H573.115C572.895 10.79 572.323 11.252 571.421 11.252C570.398 11.252 569.54 10.581 569.463 9.36H574.281C574.303 9.151 574.314 8.975 574.314 8.755C574.314 7.105 573.17 5.873 571.421 5.873C569.661 5.873 568.44 7.072 568.44 8.975C568.44 10.889 569.705 12.099 571.421 12.099C572.917 12.099 573.885 11.241 574.193 10.141ZM576.526 8.722C576.526 7.325 577.252 6.896 578.209 6.896H578.473V5.862C577.516 5.862 576.867 6.28 576.526 6.951V5.972H575.525V12H576.526V8.722ZM588.22 12H589.21V8.447C589.21 6.72 588.143 5.862 586.768 5.862C585.844 5.862 584.986 6.335 584.634 7.204C584.238 6.302 583.413 5.862 582.423 5.862C581.631 5.862 580.916 6.203 580.52 6.841V5.972H579.519V12H580.52V8.678C580.52 7.38 581.213 6.731 582.225 6.731C583.215 6.731 583.875 7.358 583.875 8.59V12H584.865V8.678C584.865 7.38 585.558 6.731 586.57 6.731C587.56 6.731 588.22 7.358 588.22 8.59V12ZM593.305 6.72C594.339 6.72 595.219 7.369 595.208 8.546H591.402C591.512 7.369 592.326 6.72 593.305 6.72ZM596.121 10.141H595.043C594.823 10.79 594.251 11.252 593.349 11.252C592.326 11.252 591.468 10.581 591.391 9.36H596.209C596.231 9.151 596.242 8.975 596.242 8.755C596.242 7.105 595.098 5.873 593.349 5.873C591.589 5.873 590.368 7.072 590.368 8.975C590.368 10.889 591.633 12.099 593.349 12.099C594.845 12.099 595.813 11.241 596.121 10.141ZM592.04 4.773V5.521L594.383 4.267V3.398L592.04 4.773ZM597.079 8.964C597.079 10.834 598.322 12.099 599.939 12.099C601.039 12.099 601.82 11.538 602.183 10.867V12H603.195V3.86H602.183V7.05C601.765 6.357 600.896 5.873 599.95 5.873C598.322 5.873 597.079 7.083 597.079 8.964ZM602.183 8.975C602.183 10.394 601.237 11.219 600.137 11.219C599.037 11.219 598.102 10.383 598.102 8.964C598.102 7.545 599.037 6.742 600.137 6.742C601.237 6.742 602.183 7.578 602.183 8.975ZM604.777 12H605.778V5.972H604.777V12ZM605.294 4.993C605.657 4.993 605.954 4.696 605.954 4.311C605.954 3.926 605.657 3.629 605.294 3.629C604.909 3.629 604.612 3.926 604.612 4.311C604.612 4.696 604.909 4.993 605.294 4.993ZM607 8.964C607 10.834 608.243 12.099 609.849 12.099C610.96 12.099 611.741 11.527 612.104 10.878V12H613.116V5.972H612.104V7.072C611.752 6.445 610.982 5.873 609.86 5.873C608.243 5.873 607 7.083 607 8.964ZM612.104 8.975C612.104 10.394 611.158 11.219 610.058 11.219C608.958 11.219 608.023 10.383 608.023 8.964C608.023 7.545 608.958 6.742 610.058 6.742C611.158 6.742 612.104 7.578 612.104 8.975ZM614.697 12H615.698V5.972H614.697V12ZM615.214 4.993C615.577 4.993 615.874 4.696 615.874 4.311C615.874 3.926 615.577 3.629 615.214 3.629C614.829 3.629 614.532 3.926 614.532 4.311C614.532 4.696 614.829 4.993 615.214 4.993ZM618.295 8.722C618.295 7.325 619.021 6.896 619.978 6.896H620.242V5.862C619.285 5.862 618.636 6.28 618.295 6.951V5.972H617.294V12H618.295V8.722ZM623.851 6.72C624.885 6.72 625.765 7.369 625.754 8.546H621.948C622.058 7.369 622.872 6.72 623.851 6.72ZM626.667 10.141H625.589C625.369 10.79 624.797 11.252 623.895 11.252C622.872 11.252 622.014 10.581 621.937 9.36H626.755C626.777 9.151 626.788 8.975 626.788 8.755C626.788 7.105 625.644 5.873 623.895 5.873C622.135 5.873 620.914 7.072 620.914 8.975C620.914 10.889 622.179 12.099 623.895 12.099C625.391 12.099 626.359 11.241 626.667 10.141Z"
        fill="#292929"
      />
      <path
        d="M800.785 4.322H796.66V12H800.785V11.175H797.661V8.535H800.455V7.71H797.661V5.147H800.785V4.322ZM805.335 12H806.468L804.521 8.953L806.457 5.972H805.412L804.048 8.205L802.618 5.972H801.485L803.432 9.008L801.485 12H802.53L803.905 9.756L805.335 12ZM808.344 7.083V5.972H807.343V14.86H808.344V10.889C808.718 11.505 809.499 12.099 810.599 12.099C812.216 12.099 813.459 10.834 813.459 8.964C813.459 7.083 812.216 5.873 810.599 5.873C809.499 5.873 808.707 6.445 808.344 7.083ZM812.436 8.964C812.436 10.383 811.501 11.219 810.39 11.219C809.301 11.219 808.344 10.394 808.344 8.975C808.344 7.578 809.301 6.742 810.39 6.742C811.501 6.742 812.436 7.545 812.436 8.964ZM817.229 6.72C818.263 6.72 819.143 7.369 819.132 8.546H815.326C815.436 7.369 816.25 6.72 817.229 6.72ZM820.045 10.141H818.967C818.747 10.79 818.175 11.252 817.273 11.252C816.25 11.252 815.392 10.581 815.315 9.36H820.133C820.155 9.151 820.166 8.975 820.166 8.755C820.166 7.105 819.022 5.873 817.273 5.873C815.513 5.873 814.292 7.072 814.292 8.975C814.292 10.889 815.557 12.099 817.273 12.099C818.769 12.099 819.737 11.241 820.045 10.141ZM815.964 4.773V5.521L818.307 4.267V3.398L815.964 4.773ZM822.379 8.722C822.379 7.325 823.105 6.896 824.062 6.896H824.326V5.862C823.369 5.862 822.72 6.28 822.379 6.951V5.972H821.378V12H822.379V8.722ZM825.371 12H826.372V5.972H825.371V12ZM825.888 4.993C826.251 4.993 826.548 4.696 826.548 4.311C826.548 3.926 826.251 3.629 825.888 3.629C825.503 3.629 825.206 3.926 825.206 4.311C825.206 4.696 825.503 4.993 825.888 4.993ZM836.669 12H837.659V8.447C837.659 6.72 836.592 5.862 835.217 5.862C834.293 5.862 833.435 6.335 833.083 7.204C832.687 6.302 831.862 5.862 830.872 5.862C830.08 5.862 829.365 6.203 828.969 6.841V5.972H827.968V12H828.969V8.678C828.969 7.38 829.662 6.731 830.674 6.731C831.664 6.731 832.324 7.358 832.324 8.59V12H833.314V8.678C833.314 7.38 834.007 6.731 835.019 6.731C836.009 6.731 836.669 7.358 836.669 8.59V12ZM841.754 6.72C842.788 6.72 843.668 7.369 843.657 8.546H839.851C839.961 7.369 840.775 6.72 841.754 6.72ZM844.57 10.141H843.492C843.272 10.79 842.7 11.252 841.798 11.252C840.775 11.252 839.917 10.581 839.84 9.36H844.658C844.68 9.151 844.691 8.975 844.691 8.755C844.691 7.105 843.547 5.873 841.798 5.873C840.038 5.873 838.817 7.072 838.817 8.975C838.817 10.889 840.082 12.099 841.798 12.099C843.294 12.099 844.262 11.241 844.57 10.141ZM850.314 12H851.304V8.447C851.304 6.72 850.237 5.862 848.84 5.862C848.026 5.862 847.3 6.203 846.904 6.83V5.972H845.903V12H846.904V8.667C846.904 7.369 847.608 6.731 848.631 6.731C849.643 6.731 850.314 7.358 850.314 8.59V12ZM853.049 10.35C853.049 11.56 853.654 12 854.721 12H855.623V11.153H854.886C854.27 11.153 854.05 10.944 854.05 10.35V6.797H855.623V5.972H854.05V4.454H853.049V5.972H852.268V6.797H853.049V10.35ZM859.289 6.72C860.323 6.72 861.203 7.369 861.192 8.546H857.386C857.496 7.369 858.31 6.72 859.289 6.72ZM862.105 10.141H861.027C860.807 10.79 860.235 11.252 859.333 11.252C858.31 11.252 857.452 10.581 857.375 9.36H862.193C862.215 9.151 862.226 8.975 862.226 8.755C862.226 7.105 861.082 5.873 859.333 5.873C857.573 5.873 856.352 7.072 856.352 8.975C856.352 10.889 857.617 12.099 859.333 12.099C860.829 12.099 861.797 11.241 862.105 10.141ZM858.024 4.773V5.521L860.367 4.267V3.398L858.024 4.773Z"
        fill="#292929"
      />
      <line
        x1="172.234"
        y1="34"
        x2="172.234"
        y2="54"
        stroke="white"
        stroke-dasharray="2 2"
      />
      <line
        x1="99.1562"
        y1="34"
        x2="99.1562"
        y2="54"
        stroke="white"
        stroke-dasharray="2 2"
      />
      <path
        d="M24.3594 44C24.3594 38.4772 28.8365 34 34.3594 34H926.639C932.162 34 936.639 38.4772 936.639 44V44C936.639 49.5228 932.162 54 926.639 54H34.3594C28.8365 54 24.3594 49.5228 24.3594 44V44Z"
        fill="#E4ECEE"
      />
      <line
        x1="172.234"
        y1="34"
        x2="172.234"
        y2="54"
        stroke="white"
        stroke-dasharray="2 2"
      />
      <line
        x1="99.1562"
        y1="34"
        x2="99.1562"
        y2="54"
        stroke="white"
        stroke-dasharray="2 2"
      />
      <path
        d="M24 44C24 38.4772 28.4772 34 34 34H698C703.523 34 708 38.4772 708 44V44C708 49.5228 703.523 54 698 54H34C28.4772 54 24 49.5228 24 44V44Z"
        fill="url(#paint0_linear_13592_85030)"
      />
      <line
        x1="329.5"
        y1="34"
        x2="329.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="228.5"
        y1="34"
        x2="228.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="127.5"
        y1="34"
        x2="127.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="27.5"
        y1="34"
        x2="27.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="630.5"
        y1="34"
        x2="630.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="429.5"
        y1="34"
        x2="429.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="530.5"
        y1="34"
        x2="530.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="932.5"
        y1="34"
        x2="932.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="731.5"
        y1="34"
        x2="731.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="832.5"
        y1="34"
        x2="832.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13592_85030"
          x1="708"
          y1="34"
          x2="24"
          y2="34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D3F0C9" />
          <stop
            offset="0.559254"
            stop-color="#F8F1B6"
          />
          <stop
            offset="0.750999"
            stop-color="#F7F7F7"
          />
          <stop
            offset="1"
            stop-color="#F7F7F7"
          />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function Junior() {
  return (
    <svg
      width="961"
      height="79"
      viewBox="0 0 961 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="8"
        width="961"
        height="71"
        fill="white"
      />
      <path
        d="M97.5423 4.322H93.4173V12H97.5423V11.175H94.4183V8.535H97.2123V7.71H94.4183V5.147H97.5423V4.322ZM103.358 12H104.348V8.447C104.348 6.72 103.281 5.862 101.884 5.862C101.07 5.862 100.344 6.203 99.948 6.83V5.972H98.947V12H99.948V8.667C99.948 7.369 100.652 6.731 101.675 6.731C102.687 6.731 103.358 7.358 103.358 8.59V12ZM108.883 12H109.884V6.797H111.149V5.972H109.884V5.543C109.884 4.762 110.181 4.432 111.083 4.432V3.596C109.543 3.596 108.883 4.201 108.883 5.543V5.972H108.102V6.797H108.883V12ZM117.926 8.975C117.926 7.072 116.595 5.873 114.879 5.873C113.174 5.873 111.832 7.072 111.832 8.975C111.832 10.889 113.13 12.099 114.835 12.099C116.551 12.099 117.926 10.889 117.926 8.975ZM112.855 8.975C112.855 7.457 113.812 6.742 114.868 6.742C115.902 6.742 116.903 7.457 116.903 8.975C116.903 10.504 115.88 11.219 114.835 11.219C113.79 11.219 112.855 10.504 112.855 8.975ZM120.133 8.722C120.133 7.325 120.859 6.896 121.816 6.896H122.08V5.862C121.123 5.862 120.474 6.28 120.133 6.951V5.972H119.132V12H120.133V8.722ZM131.826 12H132.816V8.447C132.816 6.72 131.749 5.862 130.374 5.862C129.45 5.862 128.592 6.335 128.24 7.204C127.844 6.302 127.019 5.862 126.029 5.862C125.237 5.862 124.522 6.203 124.126 6.841V5.972H123.125V12H124.126V8.678C124.126 7.38 124.819 6.731 125.831 6.731C126.821 6.731 127.481 7.358 127.481 8.59V12H128.471V8.678C128.471 7.38 129.164 6.731 130.176 6.731C131.166 6.731 131.826 7.358 131.826 8.59V12ZM133.974 8.964C133.974 10.834 135.217 12.099 136.823 12.099C137.934 12.099 138.715 11.527 139.078 10.878V12H140.09V5.972H139.078V7.072C138.726 6.445 137.956 5.873 136.834 5.873C135.217 5.873 133.974 7.083 133.974 8.964ZM139.078 8.975C139.078 10.394 138.132 11.219 137.032 11.219C135.932 11.219 134.997 10.383 134.997 8.964C134.997 7.545 135.932 6.742 137.032 6.742C138.132 6.742 139.078 7.578 139.078 8.975ZM141.892 10.35C141.892 11.56 142.497 12 143.564 12H144.466V11.153H143.729C143.113 11.153 142.893 10.944 142.893 10.35V6.797H144.466V5.972H142.893V4.454H141.892V5.972H141.111V6.797H141.892V10.35ZM145.569 12H146.57V5.972H145.569V12ZM146.086 4.993C146.449 4.993 146.746 4.696 146.746 4.311C146.746 3.926 146.449 3.629 146.086 3.629C145.701 3.629 145.404 3.926 145.404 4.311C145.404 4.696 145.701 4.993 146.086 4.993ZM153.886 8.975C153.886 7.072 152.555 5.873 150.839 5.873C149.134 5.873 147.792 7.072 147.792 8.975C147.792 10.889 149.09 12.099 150.795 12.099C152.511 12.099 153.886 10.889 153.886 8.975ZM148.815 8.975C148.815 7.457 149.772 6.742 150.828 6.742C151.862 6.742 152.863 7.457 152.863 8.975C152.863 10.504 151.84 11.219 150.795 11.219C149.75 11.219 148.815 10.504 148.815 8.975ZM159.503 12H160.493V8.447C160.493 6.72 159.426 5.862 158.029 5.862C157.215 5.862 156.489 6.203 156.093 6.83V5.972H155.092V12H156.093V8.667C156.093 7.369 156.797 6.731 157.82 6.731C158.832 6.731 159.503 7.358 159.503 8.59V12Z"
        fill="#292929"
      />
      <path
        d="M347.899 9.998C347.899 10.636 347.58 11.186 346.788 11.186C345.996 11.186 345.666 10.625 345.655 9.921H344.654C344.654 11.263 345.512 12.077 346.788 12.077C348.053 12.077 348.911 11.274 348.911 9.998V4.333H347.899V9.998ZM356.119 5.972H355.118V9.283C355.118 10.581 354.425 11.219 353.391 11.219C352.379 11.219 351.708 10.592 351.708 9.371V5.972H350.718V9.503C350.718 11.23 351.807 12.088 353.193 12.088C353.996 12.088 354.733 11.736 355.118 11.109V12H356.119V5.972ZM362.11 12H363.1V8.447C363.1 6.72 362.033 5.862 360.636 5.862C359.822 5.862 359.096 6.203 358.7 6.83V5.972H357.699V12H358.7V8.667C358.7 7.369 359.404 6.731 360.427 6.731C361.439 6.731 362.11 7.358 362.11 8.59V12ZM364.625 12H365.626V5.972H364.625V12ZM365.142 4.993C365.505 4.993 365.802 4.696 365.802 4.311C365.802 3.926 365.505 3.629 365.142 3.629C364.757 3.629 364.46 3.926 364.46 4.311C364.46 4.696 364.757 4.993 365.142 4.993ZM372.942 8.975C372.942 7.072 371.611 5.873 369.895 5.873C368.19 5.873 366.848 7.072 366.848 8.975C366.848 10.889 368.146 12.099 369.851 12.099C371.567 12.099 372.942 10.889 372.942 8.975ZM367.871 8.975C367.871 7.457 368.828 6.742 369.884 6.742C370.918 6.742 371.919 7.457 371.919 8.975C371.919 10.504 370.896 11.219 369.851 11.219C368.806 11.219 367.871 10.504 367.871 8.975ZM375.15 8.722C375.15 7.325 375.876 6.896 376.833 6.896H377.097V5.862C376.14 5.862 375.491 6.28 375.15 6.951V5.972H374.149V12H375.15V8.722Z"
        fill="#292929"
      />
      <path
        d="M555.394 12H556.395V4.333H555.394V12ZM562.402 12H563.392V8.447C563.392 6.72 562.325 5.862 560.928 5.862C560.114 5.862 559.388 6.203 558.992 6.83V5.972H557.991V12H558.992V8.667C558.992 7.369 559.696 6.731 560.719 6.731C561.731 6.731 562.402 7.358 562.402 8.59V12ZM565.137 10.35C565.137 11.56 565.742 12 566.809 12H567.711V11.153H566.974C566.358 11.153 566.138 10.944 566.138 10.35V6.797H567.711V5.972H566.138V4.454H565.137V5.972H564.356V6.797H565.137V10.35ZM571.377 6.72C572.411 6.72 573.291 7.369 573.28 8.546H569.474C569.584 7.369 570.398 6.72 571.377 6.72ZM574.193 10.141H573.115C572.895 10.79 572.323 11.252 571.421 11.252C570.398 11.252 569.54 10.581 569.463 9.36H574.281C574.303 9.151 574.314 8.975 574.314 8.755C574.314 7.105 573.17 5.873 571.421 5.873C569.661 5.873 568.44 7.072 568.44 8.975C568.44 10.889 569.705 12.099 571.421 12.099C572.917 12.099 573.885 11.241 574.193 10.141ZM576.526 8.722C576.526 7.325 577.252 6.896 578.209 6.896H578.473V5.862C577.516 5.862 576.867 6.28 576.526 6.951V5.972H575.525V12H576.526V8.722ZM588.22 12H589.21V8.447C589.21 6.72 588.143 5.862 586.768 5.862C585.844 5.862 584.986 6.335 584.634 7.204C584.238 6.302 583.413 5.862 582.423 5.862C581.631 5.862 580.916 6.203 580.52 6.841V5.972H579.519V12H580.52V8.678C580.52 7.38 581.213 6.731 582.225 6.731C583.215 6.731 583.875 7.358 583.875 8.59V12H584.865V8.678C584.865 7.38 585.558 6.731 586.57 6.731C587.56 6.731 588.22 7.358 588.22 8.59V12ZM593.305 6.72C594.339 6.72 595.219 7.369 595.208 8.546H591.402C591.512 7.369 592.326 6.72 593.305 6.72ZM596.121 10.141H595.043C594.823 10.79 594.251 11.252 593.349 11.252C592.326 11.252 591.468 10.581 591.391 9.36H596.209C596.231 9.151 596.242 8.975 596.242 8.755C596.242 7.105 595.098 5.873 593.349 5.873C591.589 5.873 590.368 7.072 590.368 8.975C590.368 10.889 591.633 12.099 593.349 12.099C594.845 12.099 595.813 11.241 596.121 10.141ZM592.04 4.773V5.521L594.383 4.267V3.398L592.04 4.773ZM597.079 8.964C597.079 10.834 598.322 12.099 599.939 12.099C601.039 12.099 601.82 11.538 602.183 10.867V12H603.195V3.86H602.183V7.05C601.765 6.357 600.896 5.873 599.95 5.873C598.322 5.873 597.079 7.083 597.079 8.964ZM602.183 8.975C602.183 10.394 601.237 11.219 600.137 11.219C599.037 11.219 598.102 10.383 598.102 8.964C598.102 7.545 599.037 6.742 600.137 6.742C601.237 6.742 602.183 7.578 602.183 8.975ZM604.777 12H605.778V5.972H604.777V12ZM605.294 4.993C605.657 4.993 605.954 4.696 605.954 4.311C605.954 3.926 605.657 3.629 605.294 3.629C604.909 3.629 604.612 3.926 604.612 4.311C604.612 4.696 604.909 4.993 605.294 4.993ZM607 8.964C607 10.834 608.243 12.099 609.849 12.099C610.96 12.099 611.741 11.527 612.104 10.878V12H613.116V5.972H612.104V7.072C611.752 6.445 610.982 5.873 609.86 5.873C608.243 5.873 607 7.083 607 8.964ZM612.104 8.975C612.104 10.394 611.158 11.219 610.058 11.219C608.958 11.219 608.023 10.383 608.023 8.964C608.023 7.545 608.958 6.742 610.058 6.742C611.158 6.742 612.104 7.578 612.104 8.975ZM614.697 12H615.698V5.972H614.697V12ZM615.214 4.993C615.577 4.993 615.874 4.696 615.874 4.311C615.874 3.926 615.577 3.629 615.214 3.629C614.829 3.629 614.532 3.926 614.532 4.311C614.532 4.696 614.829 4.993 615.214 4.993ZM618.295 8.722C618.295 7.325 619.021 6.896 619.978 6.896H620.242V5.862C619.285 5.862 618.636 6.28 618.295 6.951V5.972H617.294V12H618.295V8.722ZM623.851 6.72C624.885 6.72 625.765 7.369 625.754 8.546H621.948C622.058 7.369 622.872 6.72 623.851 6.72ZM626.667 10.141H625.589C625.369 10.79 624.797 11.252 623.895 11.252C622.872 11.252 622.014 10.581 621.937 9.36H626.755C626.777 9.151 626.788 8.975 626.788 8.755C626.788 7.105 625.644 5.873 623.895 5.873C622.135 5.873 620.914 7.072 620.914 8.975C620.914 10.889 622.179 12.099 623.895 12.099C625.391 12.099 626.359 11.241 626.667 10.141Z"
        fill="#292929"
      />
      <path
        d="M800.785 4.322H796.66V12H800.785V11.175H797.661V8.535H800.455V7.71H797.661V5.147H800.785V4.322ZM805.335 12H806.468L804.521 8.953L806.457 5.972H805.412L804.048 8.205L802.618 5.972H801.485L803.432 9.008L801.485 12H802.53L803.905 9.756L805.335 12ZM808.344 7.083V5.972H807.343V14.86H808.344V10.889C808.718 11.505 809.499 12.099 810.599 12.099C812.216 12.099 813.459 10.834 813.459 8.964C813.459 7.083 812.216 5.873 810.599 5.873C809.499 5.873 808.707 6.445 808.344 7.083ZM812.436 8.964C812.436 10.383 811.501 11.219 810.39 11.219C809.301 11.219 808.344 10.394 808.344 8.975C808.344 7.578 809.301 6.742 810.39 6.742C811.501 6.742 812.436 7.545 812.436 8.964ZM817.229 6.72C818.263 6.72 819.143 7.369 819.132 8.546H815.326C815.436 7.369 816.25 6.72 817.229 6.72ZM820.045 10.141H818.967C818.747 10.79 818.175 11.252 817.273 11.252C816.25 11.252 815.392 10.581 815.315 9.36H820.133C820.155 9.151 820.166 8.975 820.166 8.755C820.166 7.105 819.022 5.873 817.273 5.873C815.513 5.873 814.292 7.072 814.292 8.975C814.292 10.889 815.557 12.099 817.273 12.099C818.769 12.099 819.737 11.241 820.045 10.141ZM815.964 4.773V5.521L818.307 4.267V3.398L815.964 4.773ZM822.379 8.722C822.379 7.325 823.105 6.896 824.062 6.896H824.326V5.862C823.369 5.862 822.72 6.28 822.379 6.951V5.972H821.378V12H822.379V8.722ZM825.371 12H826.372V5.972H825.371V12ZM825.888 4.993C826.251 4.993 826.548 4.696 826.548 4.311C826.548 3.926 826.251 3.629 825.888 3.629C825.503 3.629 825.206 3.926 825.206 4.311C825.206 4.696 825.503 4.993 825.888 4.993ZM836.669 12H837.659V8.447C837.659 6.72 836.592 5.862 835.217 5.862C834.293 5.862 833.435 6.335 833.083 7.204C832.687 6.302 831.862 5.862 830.872 5.862C830.08 5.862 829.365 6.203 828.969 6.841V5.972H827.968V12H828.969V8.678C828.969 7.38 829.662 6.731 830.674 6.731C831.664 6.731 832.324 7.358 832.324 8.59V12H833.314V8.678C833.314 7.38 834.007 6.731 835.019 6.731C836.009 6.731 836.669 7.358 836.669 8.59V12ZM841.754 6.72C842.788 6.72 843.668 7.369 843.657 8.546H839.851C839.961 7.369 840.775 6.72 841.754 6.72ZM844.57 10.141H843.492C843.272 10.79 842.7 11.252 841.798 11.252C840.775 11.252 839.917 10.581 839.84 9.36H844.658C844.68 9.151 844.691 8.975 844.691 8.755C844.691 7.105 843.547 5.873 841.798 5.873C840.038 5.873 838.817 7.072 838.817 8.975C838.817 10.889 840.082 12.099 841.798 12.099C843.294 12.099 844.262 11.241 844.57 10.141ZM850.314 12H851.304V8.447C851.304 6.72 850.237 5.862 848.84 5.862C848.026 5.862 847.3 6.203 846.904 6.83V5.972H845.903V12H846.904V8.667C846.904 7.369 847.608 6.731 848.631 6.731C849.643 6.731 850.314 7.358 850.314 8.59V12ZM853.049 10.35C853.049 11.56 853.654 12 854.721 12H855.623V11.153H854.886C854.27 11.153 854.05 10.944 854.05 10.35V6.797H855.623V5.972H854.05V4.454H853.049V5.972H852.268V6.797H853.049V10.35ZM859.289 6.72C860.323 6.72 861.203 7.369 861.192 8.546H857.386C857.496 7.369 858.31 6.72 859.289 6.72ZM862.105 10.141H861.027C860.807 10.79 860.235 11.252 859.333 11.252C858.31 11.252 857.452 10.581 857.375 9.36H862.193C862.215 9.151 862.226 8.975 862.226 8.755C862.226 7.105 861.082 5.873 859.333 5.873C857.573 5.873 856.352 7.072 856.352 8.975C856.352 10.889 857.617 12.099 859.333 12.099C860.829 12.099 861.797 11.241 862.105 10.141ZM858.024 4.773V5.521L860.367 4.267V3.398L858.024 4.773Z"
        fill="#292929"
      />
      <line
        x1="172.234"
        y1="34"
        x2="172.234"
        y2="54"
        stroke="white"
        stroke-dasharray="2 2"
      />
      <line
        x1="99.1562"
        y1="34"
        x2="99.1562"
        y2="54"
        stroke="white"
        stroke-dasharray="2 2"
      />
      <path
        d="M24.3594 44C24.3594 38.4772 28.8365 34 34.3594 34H926.639C932.162 34 936.639 38.4772 936.639 44C936.639 49.5228 932.162 54 926.639 54H34.3594C28.8365 54 24.3594 49.5228 24.3594 44Z"
        fill="#E4ECEE"
      />
      <line
        x1="172.234"
        y1="34"
        x2="172.234"
        y2="54"
        stroke="white"
        stroke-dasharray="2 2"
      />
      <line
        x1="99.1562"
        y1="34"
        x2="99.1562"
        y2="54"
        stroke="white"
        stroke-dasharray="2 2"
      />
      <path
        d="M24 44C24 38.4772 28.4772 34 34 34H470C475.523 34 480 38.4772 480 44C480 49.5228 475.523 54 470 54H34C28.4771 54 24 49.5228 24 44Z"
        fill="url(#paint0_linear_13592_85055)"
      />
      <line
        x1="329.5"
        y1="34"
        x2="329.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="228.5"
        y1="34"
        x2="228.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="630.5"
        y1="34"
        x2="630.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="127.5"
        y1="34"
        x2="127.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="832.5"
        y1="34"
        x2="832.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="27.5"
        y1="34"
        x2="27.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="429.5"
        y1="34"
        x2="429.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="731.5"
        y1="34"
        x2="731.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="530.5"
        y1="34"
        x2="530.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="932.5"
        y1="34"
        x2="932.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13592_85055"
          x1="480"
          y1="34"
          x2="24"
          y2="34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EAF1BE" />
          <stop
            offset="0.320175"
            stop-color="#F8F1B6"
          />
          <stop
            offset="0.666667"
            stop-color="#F7F7F7"
          />
          <stop
            offset="1"
            stop-color="#F7F7F7"
          />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function Formation() {
  return (
    <svg
      width="961"
      height="79"
      viewBox="0 0 961 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="8"
        width="961"
        height="71"
        fill="white"
      />
      <path
        d="M97.5423 4.322H93.4173V12H97.5423V11.175H94.4183V8.535H97.2123V7.71H94.4183V5.147H97.5423V4.322ZM103.358 12H104.348V8.447C104.348 6.72 103.281 5.862 101.884 5.862C101.07 5.862 100.344 6.203 99.948 6.83V5.972H98.947V12H99.948V8.667C99.948 7.369 100.652 6.731 101.675 6.731C102.687 6.731 103.358 7.358 103.358 8.59V12ZM108.883 12H109.884V6.797H111.149V5.972H109.884V5.543C109.884 4.762 110.181 4.432 111.083 4.432V3.596C109.543 3.596 108.883 4.201 108.883 5.543V5.972H108.102V6.797H108.883V12ZM117.926 8.975C117.926 7.072 116.595 5.873 114.879 5.873C113.174 5.873 111.832 7.072 111.832 8.975C111.832 10.889 113.13 12.099 114.835 12.099C116.551 12.099 117.926 10.889 117.926 8.975ZM112.855 8.975C112.855 7.457 113.812 6.742 114.868 6.742C115.902 6.742 116.903 7.457 116.903 8.975C116.903 10.504 115.88 11.219 114.835 11.219C113.79 11.219 112.855 10.504 112.855 8.975ZM120.133 8.722C120.133 7.325 120.859 6.896 121.816 6.896H122.08V5.862C121.123 5.862 120.474 6.28 120.133 6.951V5.972H119.132V12H120.133V8.722ZM131.826 12H132.816V8.447C132.816 6.72 131.749 5.862 130.374 5.862C129.45 5.862 128.592 6.335 128.24 7.204C127.844 6.302 127.019 5.862 126.029 5.862C125.237 5.862 124.522 6.203 124.126 6.841V5.972H123.125V12H124.126V8.678C124.126 7.38 124.819 6.731 125.831 6.731C126.821 6.731 127.481 7.358 127.481 8.59V12H128.471V8.678C128.471 7.38 129.164 6.731 130.176 6.731C131.166 6.731 131.826 7.358 131.826 8.59V12ZM133.974 8.964C133.974 10.834 135.217 12.099 136.823 12.099C137.934 12.099 138.715 11.527 139.078 10.878V12H140.09V5.972H139.078V7.072C138.726 6.445 137.956 5.873 136.834 5.873C135.217 5.873 133.974 7.083 133.974 8.964ZM139.078 8.975C139.078 10.394 138.132 11.219 137.032 11.219C135.932 11.219 134.997 10.383 134.997 8.964C134.997 7.545 135.932 6.742 137.032 6.742C138.132 6.742 139.078 7.578 139.078 8.975ZM141.892 10.35C141.892 11.56 142.497 12 143.564 12H144.466V11.153H143.729C143.113 11.153 142.893 10.944 142.893 10.35V6.797H144.466V5.972H142.893V4.454H141.892V5.972H141.111V6.797H141.892V10.35ZM145.569 12H146.57V5.972H145.569V12ZM146.086 4.993C146.449 4.993 146.746 4.696 146.746 4.311C146.746 3.926 146.449 3.629 146.086 3.629C145.701 3.629 145.404 3.926 145.404 4.311C145.404 4.696 145.701 4.993 146.086 4.993ZM153.886 8.975C153.886 7.072 152.555 5.873 150.839 5.873C149.134 5.873 147.792 7.072 147.792 8.975C147.792 10.889 149.09 12.099 150.795 12.099C152.511 12.099 153.886 10.889 153.886 8.975ZM148.815 8.975C148.815 7.457 149.772 6.742 150.828 6.742C151.862 6.742 152.863 7.457 152.863 8.975C152.863 10.504 151.84 11.219 150.795 11.219C149.75 11.219 148.815 10.504 148.815 8.975ZM159.503 12H160.493V8.447C160.493 6.72 159.426 5.862 158.029 5.862C157.215 5.862 156.489 6.203 156.093 6.83V5.972H155.092V12H156.093V8.667C156.093 7.369 156.797 6.731 157.82 6.731C158.832 6.731 159.503 7.358 159.503 8.59V12Z"
        fill="#292929"
      />
      <path
        d="M347.899 9.998C347.899 10.636 347.58 11.186 346.788 11.186C345.996 11.186 345.666 10.625 345.655 9.921H344.654C344.654 11.263 345.512 12.077 346.788 12.077C348.053 12.077 348.911 11.274 348.911 9.998V4.333H347.899V9.998ZM356.119 5.972H355.118V9.283C355.118 10.581 354.425 11.219 353.391 11.219C352.379 11.219 351.708 10.592 351.708 9.371V5.972H350.718V9.503C350.718 11.23 351.807 12.088 353.193 12.088C353.996 12.088 354.733 11.736 355.118 11.109V12H356.119V5.972ZM362.11 12H363.1V8.447C363.1 6.72 362.033 5.862 360.636 5.862C359.822 5.862 359.096 6.203 358.7 6.83V5.972H357.699V12H358.7V8.667C358.7 7.369 359.404 6.731 360.427 6.731C361.439 6.731 362.11 7.358 362.11 8.59V12ZM364.625 12H365.626V5.972H364.625V12ZM365.142 4.993C365.505 4.993 365.802 4.696 365.802 4.311C365.802 3.926 365.505 3.629 365.142 3.629C364.757 3.629 364.46 3.926 364.46 4.311C364.46 4.696 364.757 4.993 365.142 4.993ZM372.942 8.975C372.942 7.072 371.611 5.873 369.895 5.873C368.19 5.873 366.848 7.072 366.848 8.975C366.848 10.889 368.146 12.099 369.851 12.099C371.567 12.099 372.942 10.889 372.942 8.975ZM367.871 8.975C367.871 7.457 368.828 6.742 369.884 6.742C370.918 6.742 371.919 7.457 371.919 8.975C371.919 10.504 370.896 11.219 369.851 11.219C368.806 11.219 367.871 10.504 367.871 8.975ZM375.15 8.722C375.15 7.325 375.876 6.896 376.833 6.896H377.097V5.862C376.14 5.862 375.491 6.28 375.15 6.951V5.972H374.149V12H375.15V8.722Z"
        fill="#292929"
      />
      <path
        d="M555.394 12H556.395V4.333H555.394V12ZM562.402 12H563.392V8.447C563.392 6.72 562.325 5.862 560.928 5.862C560.114 5.862 559.388 6.203 558.992 6.83V5.972H557.991V12H558.992V8.667C558.992 7.369 559.696 6.731 560.719 6.731C561.731 6.731 562.402 7.358 562.402 8.59V12ZM565.137 10.35C565.137 11.56 565.742 12 566.809 12H567.711V11.153H566.974C566.358 11.153 566.138 10.944 566.138 10.35V6.797H567.711V5.972H566.138V4.454H565.137V5.972H564.356V6.797H565.137V10.35ZM571.377 6.72C572.411 6.72 573.291 7.369 573.28 8.546H569.474C569.584 7.369 570.398 6.72 571.377 6.72ZM574.193 10.141H573.115C572.895 10.79 572.323 11.252 571.421 11.252C570.398 11.252 569.54 10.581 569.463 9.36H574.281C574.303 9.151 574.314 8.975 574.314 8.755C574.314 7.105 573.17 5.873 571.421 5.873C569.661 5.873 568.44 7.072 568.44 8.975C568.44 10.889 569.705 12.099 571.421 12.099C572.917 12.099 573.885 11.241 574.193 10.141ZM576.526 8.722C576.526 7.325 577.252 6.896 578.209 6.896H578.473V5.862C577.516 5.862 576.867 6.28 576.526 6.951V5.972H575.525V12H576.526V8.722ZM588.22 12H589.21V8.447C589.21 6.72 588.143 5.862 586.768 5.862C585.844 5.862 584.986 6.335 584.634 7.204C584.238 6.302 583.413 5.862 582.423 5.862C581.631 5.862 580.916 6.203 580.52 6.841V5.972H579.519V12H580.52V8.678C580.52 7.38 581.213 6.731 582.225 6.731C583.215 6.731 583.875 7.358 583.875 8.59V12H584.865V8.678C584.865 7.38 585.558 6.731 586.57 6.731C587.56 6.731 588.22 7.358 588.22 8.59V12ZM593.305 6.72C594.339 6.72 595.219 7.369 595.208 8.546H591.402C591.512 7.369 592.326 6.72 593.305 6.72ZM596.121 10.141H595.043C594.823 10.79 594.251 11.252 593.349 11.252C592.326 11.252 591.468 10.581 591.391 9.36H596.209C596.231 9.151 596.242 8.975 596.242 8.755C596.242 7.105 595.098 5.873 593.349 5.873C591.589 5.873 590.368 7.072 590.368 8.975C590.368 10.889 591.633 12.099 593.349 12.099C594.845 12.099 595.813 11.241 596.121 10.141ZM592.04 4.773V5.521L594.383 4.267V3.398L592.04 4.773ZM597.079 8.964C597.079 10.834 598.322 12.099 599.939 12.099C601.039 12.099 601.82 11.538 602.183 10.867V12H603.195V3.86H602.183V7.05C601.765 6.357 600.896 5.873 599.95 5.873C598.322 5.873 597.079 7.083 597.079 8.964ZM602.183 8.975C602.183 10.394 601.237 11.219 600.137 11.219C599.037 11.219 598.102 10.383 598.102 8.964C598.102 7.545 599.037 6.742 600.137 6.742C601.237 6.742 602.183 7.578 602.183 8.975ZM604.777 12H605.778V5.972H604.777V12ZM605.294 4.993C605.657 4.993 605.954 4.696 605.954 4.311C605.954 3.926 605.657 3.629 605.294 3.629C604.909 3.629 604.612 3.926 604.612 4.311C604.612 4.696 604.909 4.993 605.294 4.993ZM607 8.964C607 10.834 608.243 12.099 609.849 12.099C610.96 12.099 611.741 11.527 612.104 10.878V12H613.116V5.972H612.104V7.072C611.752 6.445 610.982 5.873 609.86 5.873C608.243 5.873 607 7.083 607 8.964ZM612.104 8.975C612.104 10.394 611.158 11.219 610.058 11.219C608.958 11.219 608.023 10.383 608.023 8.964C608.023 7.545 608.958 6.742 610.058 6.742C611.158 6.742 612.104 7.578 612.104 8.975ZM614.697 12H615.698V5.972H614.697V12ZM615.214 4.993C615.577 4.993 615.874 4.696 615.874 4.311C615.874 3.926 615.577 3.629 615.214 3.629C614.829 3.629 614.532 3.926 614.532 4.311C614.532 4.696 614.829 4.993 615.214 4.993ZM618.295 8.722C618.295 7.325 619.021 6.896 619.978 6.896H620.242V5.862C619.285 5.862 618.636 6.28 618.295 6.951V5.972H617.294V12H618.295V8.722ZM623.851 6.72C624.885 6.72 625.765 7.369 625.754 8.546H621.948C622.058 7.369 622.872 6.72 623.851 6.72ZM626.667 10.141H625.589C625.369 10.79 624.797 11.252 623.895 11.252C622.872 11.252 622.014 10.581 621.937 9.36H626.755C626.777 9.151 626.788 8.975 626.788 8.755C626.788 7.105 625.644 5.873 623.895 5.873C622.135 5.873 620.914 7.072 620.914 8.975C620.914 10.889 622.179 12.099 623.895 12.099C625.391 12.099 626.359 11.241 626.667 10.141Z"
        fill="#292929"
      />
      <path
        d="M800.785 4.322H796.66V12H800.785V11.175H797.661V8.535H800.455V7.71H797.661V5.147H800.785V4.322ZM805.335 12H806.468L804.521 8.953L806.457 5.972H805.412L804.048 8.205L802.618 5.972H801.485L803.432 9.008L801.485 12H802.53L803.905 9.756L805.335 12ZM808.344 7.083V5.972H807.343V14.86H808.344V10.889C808.718 11.505 809.499 12.099 810.599 12.099C812.216 12.099 813.459 10.834 813.459 8.964C813.459 7.083 812.216 5.873 810.599 5.873C809.499 5.873 808.707 6.445 808.344 7.083ZM812.436 8.964C812.436 10.383 811.501 11.219 810.39 11.219C809.301 11.219 808.344 10.394 808.344 8.975C808.344 7.578 809.301 6.742 810.39 6.742C811.501 6.742 812.436 7.545 812.436 8.964ZM817.229 6.72C818.263 6.72 819.143 7.369 819.132 8.546H815.326C815.436 7.369 816.25 6.72 817.229 6.72ZM820.045 10.141H818.967C818.747 10.79 818.175 11.252 817.273 11.252C816.25 11.252 815.392 10.581 815.315 9.36H820.133C820.155 9.151 820.166 8.975 820.166 8.755C820.166 7.105 819.022 5.873 817.273 5.873C815.513 5.873 814.292 7.072 814.292 8.975C814.292 10.889 815.557 12.099 817.273 12.099C818.769 12.099 819.737 11.241 820.045 10.141ZM815.964 4.773V5.521L818.307 4.267V3.398L815.964 4.773ZM822.379 8.722C822.379 7.325 823.105 6.896 824.062 6.896H824.326V5.862C823.369 5.862 822.72 6.28 822.379 6.951V5.972H821.378V12H822.379V8.722ZM825.371 12H826.372V5.972H825.371V12ZM825.888 4.993C826.251 4.993 826.548 4.696 826.548 4.311C826.548 3.926 826.251 3.629 825.888 3.629C825.503 3.629 825.206 3.926 825.206 4.311C825.206 4.696 825.503 4.993 825.888 4.993ZM836.669 12H837.659V8.447C837.659 6.72 836.592 5.862 835.217 5.862C834.293 5.862 833.435 6.335 833.083 7.204C832.687 6.302 831.862 5.862 830.872 5.862C830.08 5.862 829.365 6.203 828.969 6.841V5.972H827.968V12H828.969V8.678C828.969 7.38 829.662 6.731 830.674 6.731C831.664 6.731 832.324 7.358 832.324 8.59V12H833.314V8.678C833.314 7.38 834.007 6.731 835.019 6.731C836.009 6.731 836.669 7.358 836.669 8.59V12ZM841.754 6.72C842.788 6.72 843.668 7.369 843.657 8.546H839.851C839.961 7.369 840.775 6.72 841.754 6.72ZM844.57 10.141H843.492C843.272 10.79 842.7 11.252 841.798 11.252C840.775 11.252 839.917 10.581 839.84 9.36H844.658C844.68 9.151 844.691 8.975 844.691 8.755C844.691 7.105 843.547 5.873 841.798 5.873C840.038 5.873 838.817 7.072 838.817 8.975C838.817 10.889 840.082 12.099 841.798 12.099C843.294 12.099 844.262 11.241 844.57 10.141ZM850.314 12H851.304V8.447C851.304 6.72 850.237 5.862 848.84 5.862C848.026 5.862 847.3 6.203 846.904 6.83V5.972H845.903V12H846.904V8.667C846.904 7.369 847.608 6.731 848.631 6.731C849.643 6.731 850.314 7.358 850.314 8.59V12ZM853.049 10.35C853.049 11.56 853.654 12 854.721 12H855.623V11.153H854.886C854.27 11.153 854.05 10.944 854.05 10.35V6.797H855.623V5.972H854.05V4.454H853.049V5.972H852.268V6.797H853.049V10.35ZM859.289 6.72C860.323 6.72 861.203 7.369 861.192 8.546H857.386C857.496 7.369 858.31 6.72 859.289 6.72ZM862.105 10.141H861.027C860.807 10.79 860.235 11.252 859.333 11.252C858.31 11.252 857.452 10.581 857.375 9.36H862.193C862.215 9.151 862.226 8.975 862.226 8.755C862.226 7.105 861.082 5.873 859.333 5.873C857.573 5.873 856.352 7.072 856.352 8.975C856.352 10.889 857.617 12.099 859.333 12.099C860.829 12.099 861.797 11.241 862.105 10.141ZM858.024 4.773V5.521L860.367 4.267V3.398L858.024 4.773Z"
        fill="#292929"
      />
      <line
        x1="172.234"
        y1="34"
        x2="172.234"
        y2="54"
        stroke="white"
        stroke-dasharray="2 2"
      />
      <line
        x1="99.1562"
        y1="34"
        x2="99.1562"
        y2="54"
        stroke="white"
        stroke-dasharray="2 2"
      />
      <path
        d="M24.3594 44C24.3594 38.4772 28.8365 34 34.3594 34H926.639C932.162 34 936.639 38.4772 936.639 44C936.639 49.5228 932.162 54 926.639 54H34.3594C28.8365 54 24.3594 49.5228 24.3594 44Z"
        fill="#E4ECEE"
      />
      <line
        x1="172.234"
        y1="34"
        x2="172.234"
        y2="54"
        stroke="white"
        stroke-dasharray="2 2"
      />
      <line
        x1="99.1562"
        y1="34"
        x2="99.1562"
        y2="54"
        stroke="white"
        stroke-dasharray="2 2"
      />
      <path
        d="M24 44C24 38.4772 28.4772 34 34 34H242C247.523 34 252 38.4772 252 44C252 49.5228 247.523 54 242 54H34C28.4772 54 24 49.5228 24 44Z"
        fill="url(#paint0_linear_13592_84833)"
      />
      <line
        x1="327.5"
        y1="34"
        x2="327.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="226.5"
        y1="34"
        x2="226.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="125.5"
        y1="34"
        x2="125.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="25.5"
        y1="34"
        x2="25.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="628.5"
        y1="34"
        x2="628.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="427.5"
        y1="34"
        x2="427.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="528.5"
        y1="34"
        x2="528.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="930.5"
        y1="34"
        x2="930.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="729.5"
        y1="34"
        x2="729.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <line
        x1="830.5"
        y1="34"
        x2="830.5"
        y2="54"
        stroke="#292929"
        stroke-dasharray="2 2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13592_84833"
          x1="252"
          y1="34"
          x2="24"
          y2="34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F8F5DF" />
          <stop
            offset="0.530702"
            stop-color="#F7F7F7"
          />
          <stop
            offset="1"
            stop-color="#F7F7F7"
          />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function SvgDuplicateNews() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13792_51537)">
        <path
          d="M9.36 0H0.52C0.232959 0 0 0.232959 0 0.52V9.36C0 9.64704 0.232959 9.88 0.52 9.88H9.36C9.64704 9.88 9.88 9.64704 9.88 9.36V0.52C9.88 0.232959 9.64704 0 9.36 0Z"
          fill="#292929"
        />
        <path
          d="M11.9602 10.6599V11.9599H10.6602V12.9999H12.4802C12.7672 12.9999 13.0002 12.7669 13.0002 12.4799V10.6599H11.9602Z"
          fill="#292929"
        />
        <path
          d="M9.45775 11.96H6.66016V13H9.45775V11.96Z"
          fill="#292929"
        />
        <path
          d="M4.16109 11.9599V10.6599H3.12109V12.4799C3.12109 12.7669 3.35405 12.9999 3.64109 12.9999H5.46109V11.9599H4.16109Z"
          fill="#292929"
        />
        <path
          d="M12.4802 3.12012H10.6602V4.16012H11.9602V5.46012H13.0002V3.64012C13.0002 3.35308 12.7672 3.12012 12.4802 3.12012Z"
          fill="#292929"
        />
        <path
          d="M13.0009 6.66113H11.9609V9.45872H13.0009V6.66113Z"
          fill="#292929"
        />
      </g>
      <defs>
        <clipPath id="clip0_13792_51537">
          <rect
            width="13"
            height="13"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgAttach() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9606 4.41274C14.2763 4.0961 13.8759 3.18175 13.0646 2.37054C12.263 1.56871 11.3635 1.1701 11.0365 1.46649L11.0302 1.46038L6.5365 5.49718C5.70569 4.7729 4.44936 4.79761 3.65796 5.58862C3.52476 5.72205 3.44969 5.90288 3.44969 6.09152C3.44969 6.28019 3.52474 6.46108 3.65796 6.59427L5.69656 8.63314L1.50719 13.363C1.37402 13.513 1.37107 13.7422 1.50757 13.896C1.65474 14.0617 1.90845 14.0769 2.0745 13.9295L6.79735 9.73442L7.00016 9.93699L8.05042 10.9875L8.83515 11.7723C8.96837 11.9054 9.14917 11.9803 9.33761 11.9803C9.52588 11.9803 9.7068 11.9053 9.83995 11.7718C10.6305 10.9808 10.6554 9.72371 9.93149 8.89286L13.9463 4.42115C13.9503 4.41758 13.9568 4.41678 13.9606 4.41274Z"
        stroke="#1A4E63"
      />
    </svg>
  );
}

export function SvgAttachOn() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9606 4.41274C14.2763 4.0961 13.8759 3.18175 13.0646 2.37054C12.263 1.56871 11.3635 1.1701 11.0365 1.46649L11.0302 1.46038L6.5365 5.49718C5.70569 4.7729 4.44936 4.79761 3.65796 5.58862C3.52476 5.72205 3.44969 5.90288 3.44969 6.09152C3.44969 6.28019 3.52474 6.46108 3.65796 6.59427L5.69656 8.63314L1.50719 13.363C1.37402 13.513 1.37107 13.7422 1.50757 13.896C1.65474 14.0617 1.90845 14.0769 2.0745 13.9295L6.79735 9.73442L7.00016 9.93699L8.05042 10.9875L8.83515 11.7723C8.96837 11.9054 9.14917 11.9803 9.33761 11.9803C9.52588 11.9803 9.7068 11.9053 9.83995 11.7718C10.6305 10.9808 10.6554 9.72371 9.93149 8.89286L13.9463 4.42115C13.9503 4.41758 13.9568 4.41678 13.9606 4.41274Z"
        stroke="white"
      />
    </svg>
  );
}

export function SvgCircleCheckmark({ color = "#73C7B7" }) {
  return (
    <svg
      width="30"
      height="29"
      viewBox="0 0 30 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.3327 14.4997C28.3327 7.13588 22.3631 1.16635 14.9993 1.16635C7.63555 1.16635 1.66602 7.13588 1.66602 14.4997C1.66602 21.8635 7.63555 27.833 14.9993 27.833C22.3631 27.833 28.3327 21.8635 28.3327 14.4997Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M9.66602 15.4998C9.66602 15.4998 11.7993 16.7165 12.866 18.4998C12.866 18.4998 16.066 11.4998 20.3327 9.1665"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgDownloadImage({ color }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.08594 9.00065C1.08594 5.2687 1.08594 3.40272 2.24531 2.24335C3.40468 1.08398 5.27065 1.08398 9.0026 1.08398C12.7346 1.08398 14.6005 1.08398 15.7599 2.24335C16.9193 3.40272 16.9193 5.2687 16.9193 9.00065C16.9193 12.7326 16.9193 14.5986 15.7599 15.7579C14.6005 16.9173 12.7346 16.9173 9.0026 16.9173C5.27065 16.9173 3.40468 16.9173 2.24531 15.7579C1.08594 14.5986 1.08594 12.7326 1.08594 9.00065Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <circle
        cx="12.75"
        cy="5.25"
        r="1.25"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M0.667969 10.7808C1.2235 10.7059 1.78513 10.6689 2.34771 10.6702C4.72766 10.6235 7.04931 11.3121 8.89842 12.6131C10.6134 13.8198 11.8184 15.4804 12.3346 17.3346"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M9.83594 14.0007C11.2539 12.8951 12.7813 12.3279 14.3245 12.334C15.1995 12.3331 16.0703 12.5187 16.9193 12.8854"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgDownloadPDF({ color }) {
  return (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.04064 8.62076C9.04064 8.2378 8.72983 7.927 8.34688 7.927C7.96392 7.927 7.65312 8.2378 7.65312 8.62076L7.65312 12.5294L6.66871 11.5407C6.3986 11.2687 5.95922 11.2687 5.68727 11.5388C5.41624 11.8089 5.41532 12.2474 5.68542 12.5193L7.8555 14.6986C7.87038 14.7136 7.88592 14.7278 7.90205 14.741C8.02251 14.8418 8.17765 14.9025 8.34688 14.9025C8.50874 14.9025 8.65771 14.847 8.77577 14.754C8.79783 14.7371 8.81889 14.7186 8.83879 14.6986L11.007 12.5193C11.278 12.2474 11.2762 11.8089 11.0052 11.5388C10.8701 11.4038 10.6925 11.3362 10.5158 11.3362C10.3382 11.3362 10.1597 11.4038 10.0247 11.5407L9.04064 12.529L9.04064 8.62076Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.00122302 5.4411C0.0663079 2.70423 2.32171 0.5 5.04478 0.5H11.2118C11.6231 0.5 12.0154 0.667465 12.3002 0.962249L12.3019 0.964072L16.989 5.84634C17.2579 6.12741 17.4082 6.50296 17.4082 6.89153V15.3899C17.4244 18.1525 15.2655 20.4005 12.501 20.4995L12.4863 20.5H4.93332L4.92453 20.4998C2.15259 20.4402 -0.053609 18.14 0.000992014 15.3692V5.45082L0.00122302 5.4411ZM1.6358 5.47077V15.3864L1.63561 15.3952C1.59543 17.2647 3.08298 18.8205 4.95134 18.8652H12.4563C14.3333 18.7908 15.7853 17.2708 15.7734 15.3976L15.7734 15.3924L15.7734 7.76705H13.3454C11.6517 7.76242 10.2762 6.3823 10.2762 4.69138V2.13481H5.04478C3.21612 2.13481 1.68472 3.622 1.6358 5.47077ZM11.6638 2.65994L15.2346 6.37953H13.3473C12.4186 6.37675 11.6638 5.62009 11.6638 4.69138V2.65994Z"
        fill={color}
      />
    </svg>
  );
}

export function SvgPlus() {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.08073 8.29131V4.92441H0.713831C0.602211 4.92441 0.495164 4.88007 0.416236 4.80114C0.337309 4.72221 0.292969 4.61517 0.292969 4.50355C0.292969 4.39193 0.337309 4.28488 0.416236 4.20595C0.495164 4.12702 0.602211 4.08268 0.713831 4.08268H4.08073V0.715784C4.08073 0.604165 4.12507 0.497117 4.204 0.41819C4.28292 0.339263 4.38997 0.294922 4.50159 0.294922C4.61321 0.294922 4.72026 0.339263 4.79919 0.41819C4.87811 0.497117 4.92245 0.604165 4.92245 0.715784V4.08268H8.28935C8.40097 4.08268 8.50802 4.12702 8.58695 4.20595C8.66588 4.28488 8.71022 4.39193 8.71022 4.50355C8.71022 4.61517 8.66588 4.72221 8.58695 4.80114C8.50802 4.88007 8.40097 4.92441 8.28935 4.92441H4.92245V8.29131C4.92245 8.40293 4.87811 8.50998 4.79919 8.5889C4.72026 8.66783 4.61321 8.71217 4.50159 8.71217C4.38997 8.71217 4.28292 8.66783 4.204 8.5889C4.12507 8.50998 4.08073 8.40293 4.08073 8.29131Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function SvgMoins() {
  return (
    <svg
      width="10"
      height="2"
      viewBox="0 0 10 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.125 1.16406H8.55"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function SvgExternalLinkFile() {
  return (
    <svg
      width="15"
      height="17"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.875 20H14.125C14.1315 20 14.1381 20 14.1446 19.9999H9.58314C8.31086 19.9999 7.25027 18.8067 7.25027 17.3399C7.25027 16.0242 8.10882 14.9284 9.19899 14.7167C9.1986 14.7046 9.1986 14.692 9.1986 14.6799C9.1986 12.7243 10.5787 11.1332 12.2749 11.1332C13.3729 11.1332 14.3613 11.7952 14.9104 12.859C15.2377 12.6253 15.6104 12.4899 16 12.4668V7.65054C15.9997 7.64413 15.9987 7.63777 15.9972 7.63154V7.62584C15.9937 7.61704 15.9914 7.60775 15.9906 7.59829C15.9863 7.51487 15.9709 7.43242 15.9447 7.3532L15.9353 7.3266C15.9287 7.30475 15.9222 7.2848 15.9137 7.26391C15.8684 7.16041 15.8048 7.06611 15.7263 6.98557L10.1013 1.28582C10.0218 1.20619 9.9287 1.14182 9.82656 1.09582C9.81141 1.08091 9.79511 1.06725 9.77781 1.05498H9.73844C9.65993 1.02818 9.5783 1.0119 9.49563 1.00653C9.4864 1.00555 9.47729 1.00364 9.46844 1.00083H9.46281C9.45441 0.999724 9.4459 0.999724 9.4375 1.00083H2.875C1.83947 1.00083 1 1.85145 1 2.90075V18.1001C1 19.1494 1.83947 20 2.875 20ZM9.4375 7.65054V2.90075L14.125 7.65054H9.4375Z"
        fill="#292929"
      />
      <path
        d="M18.9303 14.7113C18.7497 13.4394 17.7477 12.4632 16.542 12.4632C16.0884 12.4632 15.6525 12.6013 15.2745 12.8589C14.6994 11.7952 13.6639 11.1332 12.5137 11.1332C10.7367 11.1332 9.29102 12.7242 9.29102 14.6798C9.29102 14.6919 9.29102 14.7044 9.29142 14.7165C8.14939 14.9282 7.25027 16.0242 7.25027 17.3399C7.25027 18.8066 8.36104 19.9995 9.69385 19.9995H18.5562C19.889 19.9995 21 18.8064 21 17.3396C21 16.0127 20.0861 14.9101 18.9303 14.7113Z"
        fill="white"
      />
      <path
        d="M7.25027 17.3399C7.25027 18.8067 8.31086 19.9999 9.58314 19.9999H14.1446C14.1381 20 14.1315 20 14.125 20H2.875C1.83947 20 1 19.1494 1 18.1001V2.90075C1 1.85145 1.83947 1.00083 2.875 1.00083H9.4375C9.4459 0.999724 9.45441 0.999724 9.46281 1.00083H9.46844C9.47729 1.00364 9.4864 1.00555 9.49563 1.00653C9.5783 1.0119 9.65993 1.02818 9.73844 1.05498H9.77781C9.79511 1.06725 9.81141 1.08091 9.82656 1.09582C9.9287 1.14182 10.0218 1.20619 10.1013 1.28582L15.7263 6.98557C15.8048 7.06611 15.8684 7.16041 15.9137 7.26391C15.9222 7.2848 15.9287 7.30475 15.9353 7.3266L15.9447 7.3532C15.9709 7.43242 15.9863 7.51487 15.9906 7.59829C15.9914 7.60775 15.9937 7.61704 15.9972 7.62584V7.63154C15.9987 7.63777 15.9997 7.64413 16 7.65054V12.4668C15.6104 12.4899 15.2377 12.6253 14.9104 12.859C14.3613 11.7952 13.3729 11.1332 12.2749 11.1332C10.5787 11.1332 9.1986 12.7243 9.1986 14.6799C9.1986 14.692 9.1986 14.7046 9.19899 14.7167C8.10882 14.9284 7.25027 16.0242 7.25027 17.3399ZM7.25027 17.3399C7.25027 16.0242 8.14939 14.9282 9.29142 14.7165C9.29102 14.7044 9.29102 14.6919 9.29102 14.6798C9.29102 12.7242 10.7367 11.1332 12.5137 11.1332C13.6639 11.1332 14.6994 11.7952 15.2745 12.8589C15.6525 12.6013 16.0884 12.4632 16.542 12.4632C17.7477 12.4632 18.7497 13.4394 18.9303 14.7113C20.0861 14.9101 21 16.0127 21 17.3396C21 18.8064 19.889 19.9995 18.5562 19.9995H9.69385C8.36104 19.9995 7.25027 18.8066 7.25027 17.3399ZM9.4375 2.90075V7.65054H14.125L9.4375 2.90075Z"
        stroke="#292929"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function SvgIconeFile() {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.17372 6.16906H7.52608C7.87957 6.16906 8.16647 5.88428 8.16647 5.53338C8.16647 5.18249 7.87957 4.89771 7.52608 4.89771H5.17372C4.82023 4.89771 4.53333 5.18249 4.53333 5.53338C4.53333 5.88428 4.82023 6.16906 5.17372 6.16906Z"
        fill="#11142D"
      />
      <path
        d="M11.3388 9.70333H5.17402C4.82052 9.70333 4.53363 9.41854 4.53363 9.06765C4.53363 8.71675 4.82052 8.43197 5.17402 8.43197H11.3388C11.6923 8.43197 11.9792 8.71675 11.9792 9.06765C11.9792 9.41854 11.6923 9.70333 11.3388 9.70333Z"
        fill="#11142D"
      />
      <path
        d="M11.3388 13.2529H5.17402C4.82052 13.2529 4.53363 12.9681 4.53363 12.6172C4.53363 12.2663 4.82052 11.9815 5.17402 11.9815H11.3388C11.6923 11.9815 11.9792 12.2663 11.9792 12.6172C11.9792 12.9681 11.6923 13.2529 11.3388 13.2529Z"
        fill="#11142D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 4.5C0 2.01472 2.02964 0 4.53333 0H11.4667C13.9704 0 16 2.01472 16 4.5V13.5C16 15.9853 13.9704 18 11.4667 18H4.53333C2.02964 18 0 15.9853 0 13.5V4.5ZM4.53333 1.125H11.4667C13.3444 1.125 14.8667 2.63604 14.8667 4.5V13.5C14.8667 15.364 13.3444 16.875 11.4667 16.875H4.53333C2.65556 16.875 1.13333 15.364 1.13333 13.5V4.5C1.13333 2.63604 2.65557 1.125 4.53333 1.125Z"
        fill="#11142D"
      />
    </svg>
  );
}

export function customDomain() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15132_54835)">
        <g clipPath="url(#clip1_15132_54835)">
          <path
            d="M10.1195 8.90914L10.2919 8.73671C11.9409 7.08776 14.6143 7.08776 16.2633 8.73671C17.9122 10.3857 17.9122 13.0591 16.2633 14.7081L13.8747 17.0966C12.2258 18.7456 9.55233 18.7456 7.90338 17.0966C6.25444 15.4477 6.25444 12.7742 7.90338 11.1253L8.29034 10.7383"
            stroke="#2A353D"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M16.7097 9.26202L17.0966 8.87507C18.7456 7.22612 18.7456 4.55265 17.0966 2.9037C15.4477 1.25476 12.7742 1.25476 11.1253 2.9037L8.73671 5.29225C7.08776 6.9412 7.08776 9.61467 8.73671 11.2636C10.3857 12.9126 13.0591 12.9126 14.7081 11.2636L14.8805 11.0912"
            stroke="#2A353D"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M3.75001 3.33398L5.00001 5.00065M1.66667 6.66732L4.16667 7.50065M2.50001 11.2507L4.16667 10.0007"
            stroke="#2A353D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_15132_54835">
          <rect
            width="20"
            height="20"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_15132_54835">
          <rect
            width="20"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgLink() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.465 20.5346C6.44284 20.5346 4.61978 19.3164 3.8458 17.4483C3.07182 15.5801 3.49933 13.4296 4.929 11.9995L7.051 9.87753L8.465 11.2915L6.344 13.4125C5.58606 14.1705 5.29005 15.2752 5.56748 16.3106C5.8449 17.3459 6.65361 18.1546 7.68898 18.4321C8.72434 18.7095 9.82906 18.4135 10.587 17.6555L12.708 15.5345L14.122 16.9495L12.001 19.0705C11.0651 20.0111 9.79185 20.5382 8.465 20.5346ZM9.172 16.2415L7.758 14.8275L14.829 7.75653L16.243 9.17053L9.173 16.2405L9.172 16.2415ZM16.951 14.1205L15.536 12.7065L17.657 10.5855C18.4253 9.82986 18.7292 8.7202 18.4532 7.67851C18.1773 6.63683 17.3638 5.82318 16.3222 5.54698C15.2806 5.27077 14.1708 5.57445 13.415 6.34253L11.293 8.46353L9.879 7.04953L12.001 4.92753C13.9561 2.9895 17.11 2.9964 19.0565 4.94298C21.0031 6.88956 21.01 10.0434 19.072 11.9985L16.951 14.1195V14.1205Z"
        fill="#2E3A59"
      />
    </svg>
  );
}

export function SvgCopy() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6667 18.3337H3.33332C2.88672 18.3492 2.45372 18.1786 2.13773 17.8626C1.82174 17.5466 1.65113 17.1136 1.66665 16.667V8.33365C1.65113 7.88705 1.82174 7.45405 2.13773 7.13806C2.45372 6.82207 2.88672 6.65147 3.33332 6.66699H6.66665V3.33366C6.65113 2.88705 6.82174 2.45405 7.13773 2.13806C7.45371 1.82208 7.88671 1.65147 8.33332 1.66699H16.6666C17.1133 1.65147 17.5463 1.82208 17.8622 2.13806C18.1782 2.45405 18.3488 2.88705 18.3333 3.33366V11.667C18.3486 12.1135 18.1779 12.5464 17.862 12.8623C17.546 13.1782 17.1132 13.3489 16.6666 13.3337H13.3333V16.667C13.3486 17.1135 13.1779 17.5464 12.862 17.8623C12.546 18.1782 12.1132 18.3489 11.6667 18.3337ZM3.33332 8.33365V16.667H11.6667V13.3337H8.33332C7.88679 13.3489 7.45393 13.1782 7.138 12.8623C6.82207 12.5464 6.65138 12.1135 6.66665 11.667V8.33365H3.33332ZM8.33332 3.33366V11.667H16.6666V3.33366H8.33332Z"
        fill="white"
      />
    </svg>
  );
}

export function Connected() {
  return (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6276 7.875H11.8699V5.34375C11.8699 2.39766 9.7169 0 7.07143 0C4.42596 0 2.27296 2.39766 2.27296 5.34375V7.875H1.51531C0.678731 7.875 0 8.63086 0 9.5625V16.3125C0 17.2441 0.678731 18 1.51531 18H12.6276C13.4641 18 14.1429 17.2441 14.1429 16.3125V9.5625C14.1429 8.63086 13.4641 7.875 12.6276 7.875ZM9.34439 7.875H4.79847V5.34375C4.79847 3.94805 5.81814 2.8125 7.07143 2.8125C8.32471 2.8125 9.34439 3.94805 9.34439 5.34375V7.875Z"
        fill="#25BDA0"
      />
    </svg>
  );
}

export function NotConnected() {
  return (
    <svg
      width="19"
      height="15"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3635 14.4H0.888911C0.57133 14.4 0.277876 14.2475 0.119089 14C-0.0396983 13.7524 -0.0396962 13.4475 0.119095 13.1999L8.35596 0.399293C8.51487 0.15217 8.80808 0 9.12533 0C9.44258 0 9.73579 0.15217 9.8947 0.399293L18.1316 13.1999C18.2903 13.4473 18.2904 13.7521 18.1318 13.9996C17.9732 14.2471 17.6801 14.3997 17.3626 14.4H17.3635ZM8.23773 10.3998V11.9999H9.0671H9.12488H9.18266H10.0138V10.3998H8.23773ZM8.23773 4.79952V8.79972H10.0156V4.79952H8.23773Z"
        fill="#DE271C"
      />
    </svg>
  );
}

export function Refresh() {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 14.4001V8.10007H7L3.783 10.9981C4.89296 12.0196 6.41246 12.5968 8 12.6001C10.5394 12.5967 12.8015 11.1549 13.648 9.00007H13.666C13.7805 8.70723 13.8672 8.40614 13.925 8.10007H15.937C15.4331 11.7 12.0315 14.4 8 14.4001H7.99C5.86876 14.4058 3.83316 13.6474 2.337 12.2941L0 14.4001ZM2.074 6.30007H0.062C0.56575 2.70152 3.965 0.0020024 7.995 3.66299e-05H8C10.1216 -0.00607301 12.1577 0.75233 13.654 2.10607L16 3.66299e-05V6.30007H9L12.222 3.40207C11.1109 2.37936 9.5893 1.802 8 1.80007C5.46055 1.80345 3.19848 3.24528 2.352 5.40007H2.334C2.21856 5.69267 2.13189 5.99383 2.075 6.30007H2.074Z"
        fill="#292929"
      />
    </svg>
  );
}

export function CheckCircle() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15533_55405)">
        <path
          d="M14.6654 7.38674V8.00007C14.6645 9.43769 14.199 10.8365 13.3383 11.988C12.4775 13.1394 11.2676 13.9817 9.88894 14.3893C8.51032 14.797 7.03687 14.748 5.68835 14.2498C4.33982 13.7516 3.18847 12.8308 2.406 11.6248C1.62354 10.4188 1.25189 8.99212 1.34648 7.55762C1.44107 6.12312 1.99684 4.75762 2.93088 3.66479C3.86493 2.57195 5.12722 1.81033 6.52949 1.4935C7.93176 1.17668 9.39888 1.32163 10.712 1.90674M14.6654 2.66674L7.9987 9.34007L5.9987 7.34007"
          stroke="#58B9A6"
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_15533_55405">
          <rect
            width="16"
            height="16"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function AlteeFooter() {
  return (
    <svg
      width="56"
      height="23"
      viewBox="0 0 56 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.9844 16.4147C27.9844 15.8061 28.1075 15.2736 28.3539 14.8172C28.6002 14.3535 28.9371 13.9948 29.3646 13.7413C29.7993 13.4877 30.2811 13.3609 30.81 13.3609C31.3317 13.3609 31.7845 13.4732 32.1685 13.6978C32.5525 13.9224 32.8387 14.2049 33.027 14.5455V13.4587H34.0269V19.4143H33.027V18.3057C32.8314 18.6535 32.538 18.9433 32.1468 19.1752C31.7628 19.3998 31.3136 19.5121 30.7991 19.5121C30.2702 19.5121 29.7921 19.3817 29.3646 19.1208C28.9371 18.86 28.6002 18.4941 28.3539 18.0232C28.1075 17.5522 27.9844 17.0161 27.9844 16.4147ZM33.027 16.4256C33.027 15.9764 32.9365 15.5852 32.7553 15.2519C32.5742 14.9186 32.3279 14.665 32.0163 14.4911C31.712 14.31 31.3751 14.2194 31.0056 14.2194C30.6361 14.2194 30.2992 14.3064 29.9949 14.4803C29.6906 14.6542 29.4479 14.9077 29.2668 15.241C29.0856 15.5743 28.9951 15.9655 28.9951 16.4147C28.9951 16.8712 29.0856 17.2697 29.2668 17.6102C29.4479 17.9435 29.6906 18.2007 29.9949 18.3818C30.2992 18.5557 30.6361 18.6426 31.0056 18.6426C31.3751 18.6426 31.712 18.5557 32.0163 18.3818C32.3279 18.2007 32.5742 17.9435 32.7553 17.6102C32.9365 17.2697 33.027 16.8748 33.027 16.4256Z"
        fill="black"
      />
      <path
        d="M36.9045 11.3721V19.4143H35.9155V11.3721H36.9045Z"
        fill="black"
      />
      <path
        d="M40.0137 14.2738V17.7841C40.0137 18.0739 40.0753 18.2804 40.1985 18.4036C40.3216 18.5195 40.5354 18.5774 40.8397 18.5774H41.5678V19.4143H40.6766C40.126 19.4143 39.713 19.2875 39.4377 19.0339C39.1624 18.7803 39.0247 18.3637 39.0247 17.7841V14.2738H38.2531V13.4587H39.0247V11.9589H40.0137V13.4587H41.5678V14.2738H40.0137Z"
        fill="black"
      />
      <path
        d="M48.4173 16.2083C48.4173 16.3966 48.4065 16.5959 48.3847 16.806H43.6246C43.6608 17.3928 43.8601 17.8529 44.2223 18.1862C44.5919 18.5122 45.0374 18.6752 45.5591 18.6752C45.9866 18.6752 46.3416 18.5774 46.6241 18.3818C46.9139 18.179 47.1168 17.9109 47.2327 17.5776H48.2978C48.1384 18.15 47.8196 18.6173 47.3414 18.9795C46.8632 19.3346 46.2691 19.5121 45.5591 19.5121C44.994 19.5121 44.4868 19.3853 44.0376 19.1317C43.5956 18.8781 43.2479 18.5195 42.9943 18.0558C42.7407 17.5848 42.6139 17.0415 42.6139 16.4256C42.6139 15.8098 42.7371 15.27 42.9834 14.8063C43.2298 14.3426 43.5739 13.9876 44.0159 13.7413C44.4651 13.4877 44.9795 13.3609 45.5591 13.3609C46.1242 13.3609 46.6241 13.4841 47.0588 13.7304C47.4936 13.9767 47.8268 14.3173 48.0587 14.752C48.2978 15.1794 48.4173 15.6649 48.4173 16.2083ZM47.3958 16.0018C47.3958 15.625 47.3124 15.3026 47.1458 15.0345C46.9792 14.7592 46.7509 14.5527 46.4611 14.4151C46.1786 14.2702 45.8634 14.1977 45.5156 14.1977C45.0157 14.1977 44.5882 14.3571 44.2332 14.6759C43.8854 14.9947 43.6862 15.4366 43.6355 16.0018H47.3958Z"
        fill="black"
      />
      <path
        d="M55.374 16.2083C55.374 16.3966 55.3631 16.5959 55.3414 16.806H50.5813C50.6175 17.3928 50.8168 17.8529 51.179 18.1862C51.5485 18.5122 51.9941 18.6752 52.5158 18.6752C52.9432 18.6752 53.2983 18.5774 53.5808 18.3818C53.8706 18.179 54.0735 17.9109 54.1894 17.5776H55.2545C55.0951 18.15 54.7763 18.6173 54.2981 18.9795C53.8199 19.3346 53.2258 19.5121 52.5158 19.5121C51.9506 19.5121 51.4435 19.3853 50.9943 19.1317C50.5523 18.8781 50.2045 18.5195 49.951 18.0558C49.6974 17.5848 49.5706 17.0415 49.5706 16.4256C49.5706 15.8098 49.6938 15.27 49.9401 14.8063C50.1864 14.3426 50.5306 13.9876 50.9725 13.7413C51.4217 13.4877 51.9362 13.3609 52.5158 13.3609C53.0809 13.3609 53.5808 13.4841 54.0155 13.7304C54.4502 13.9767 54.7835 14.3173 55.0154 14.752C55.2545 15.1794 55.374 15.6649 55.374 16.2083ZM54.3524 16.0018C54.3524 15.625 54.2691 15.3026 54.1025 15.0345C53.9358 14.7592 53.7076 14.5527 53.4178 14.4151C53.1352 14.2702 52.8201 14.1977 52.4723 14.1977C51.9724 14.1977 51.5449 14.3571 51.1899 14.6759C50.8421 14.9947 50.6429 15.4366 50.5922 16.0018H54.3524Z"
        fill="black"
      />
      <path
        d="M22.1067 9.65409V22.1073C14.7407 21.5589 12.4872 15.0619 12.2812 11.882V0C19.4495 0.365599 21.8183 6.58839 22.1067 9.65409Z"
        fill="#FA966B"
      />
      <circle
        cx="4.91273"
        cy="15.9664"
        r="4.91273"
        fill="#73C7B7"
      />
      <path
        d="M11.0536 6.61348C9.96085 7.0088 9.38409 8.91952 9.23232 9.82546H0.0118398C-0.0450767 8.7548 0.0118397 5.80947 2.34542 3.4015C5.12294 0.535426 9.3082 -0.0575549 11.0536 0.00421391V6.61348Z"
        fill="#4472A3"
      />
    </svg>
  );
}

export function SvgTaxes() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 9.12779C13 9.542 13.3358 9.87779 13.75 9.87779C14.1642 9.87779 14.5 9.542 14.5 9.12779H13ZM8.75 12.8726C8.75 12.4584 8.41421 12.1226 8 12.1226C7.58579 12.1226 7.25 12.4584 7.25 12.8726H8.75ZM11.75 6C11.75 5.58579 11.4142 5.25 11 5.25C10.5858 5.25 10.25 5.58579 10.25 6H11.75ZM10.25 16C10.25 16.4142 10.5858 16.75 11 16.75C11.4142 16.75 11.75 16.4142 11.75 16H10.25ZM20.25 11C20.25 16.1086 16.1086 20.25 11 20.25V21.75C16.9371 21.75 21.75 16.9371 21.75 11H20.25ZM11 20.25C5.89137 20.25 1.75 16.1086 1.75 11H0.25C0.25 16.9371 5.06294 21.75 11 21.75V20.25ZM1.75 11C1.75 5.89137 5.89137 1.75 11 1.75V0.25C5.06294 0.25 0.25 5.06294 0.25 11H1.75ZM11 1.75C16.1086 1.75 20.25 5.89137 20.25 11H21.75C21.75 5.06294 16.9371 0.25 11 0.25V1.75ZM11 10.1062C10.0478 10.1062 9.54306 9.9543 9.29223 9.78638C9.10564 9.66146 9 9.4909 9 9.12779H7.5C7.5 9.87834 7.76936 10.572 8.45777 11.0328C9.08195 11.4507 9.95218 11.6062 11 11.6062V10.1062ZM9 9.12779C9 8.86732 9.14242 8.56819 9.49895 8.30676C9.85504 8.04566 10.3833 7.86133 11 7.86133V6.36133C10.0979 6.36133 9.25118 6.6284 8.61196 7.09711C7.97319 7.56549 7.5 8.27459 7.5 9.12779H9ZM11 7.86133C11.6167 7.86133 12.145 8.04566 12.501 8.30676C12.8576 8.56819 13 8.86732 13 9.12779H14.5C14.5 8.27459 14.0268 7.56549 13.388 7.09711C12.7488 6.6284 11.9021 6.36133 11 6.36133V7.86133ZM13.25 12.8726C13.25 13.3084 13.0711 13.5775 12.7369 13.777C12.3572 14.0037 11.7608 14.1391 11 14.1391V15.6391C11.896 15.6391 12.7997 15.4865 13.5057 15.065C14.2573 14.6163 14.75 13.8772 14.75 12.8726H13.25ZM11 14.1391C10.3002 14.1391 9.70037 13.9471 9.29707 13.676C8.88907 13.4018 8.75 13.1036 8.75 12.8726H7.25C7.25 13.7554 7.78251 14.4654 8.46029 14.921C9.14277 15.3797 10.0429 15.6391 11 15.6391V14.1391ZM11 11.6062C11.9582 11.6062 12.5279 11.7501 12.8421 11.9537C13.088 12.1131 13.25 12.354 13.25 12.8726H14.75C14.75 11.951 14.412 11.1837 13.6579 10.6949C12.9721 10.2504 12.0418 10.1062 11 10.1062V11.6062ZM11.75 7.11133V6H10.25V7.11133H11.75ZM10.25 14.8891V16H11.75V14.8891H10.25Z"
        fill="#2A353D"
      />
    </svg>
  );
}

export function SvgCircleQuestionMark() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="16"
        cy="16"
        r="14"
        stroke="#2A353D"
        strokeWidth="2.2"
      />
      <path
        d="M13.1992 11.8C13.1992 10.2536 14.4528 9 15.9992 9C17.5456 9 18.7992 10.2536 18.7992 11.8C18.7992 12.3574 18.6363 12.8768 18.3556 13.3131C17.5188 14.6135 15.9992 15.8536 15.9992 17.4V18.1"
        stroke="#2A353D"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path
        d="M15.988 23H16.0006"
        stroke="#2A353D"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgCheckMarkCircle({ width = "30", height = "30" } = {}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="15"
        cy="15"
        r="14"
        stroke="#2C2C31"
        strokeWidth="2"
      />
      <svg
        x="7.5"
        y="9"
        width="15"
        height="12"
        viewBox="0 0 15 12"
      >
        <path
          d="M13.8333 1.75L5.12496 10.4583L1.16663 6.5"
          stroke="#101828"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </svg>
  );
}

export function SvgCirclePair() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="15"
        cy="15"
        r="14"
        stroke="#B0BEC5"
        strokeWidth="2"
      />
      <circle
        cx="15"
        cy="15"
        r="6.66667"
        fill="#B0BEC5"
      />
    </svg>
  );
}

export function SvgUserCheck() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.668 18.25V16.4167C14.668 15.4442 14.2817 14.5116 13.594 13.8239C12.9064 13.1363 11.9738 12.75 11.0013 12.75H4.58464C3.61218 12.75 2.67954 13.1363 1.99191 13.8239C1.30428 14.5116 0.917969 15.4442 0.917969 16.4167V18.25M15.5846 9.08333L17.418 10.9167L21.0846 7.25M11.4596 5.41667C11.4596 7.44171 9.81801 9.08333 7.79297 9.08333C5.76792 9.08333 4.1263 7.44171 4.1263 5.41667C4.1263 3.39162 5.76792 1.75 7.79297 1.75C9.81801 1.75 11.4596 3.39162 11.4596 5.41667Z"
        stroke="#2C2C31"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgEmployeFile() {
  return (
    <svg
      width="17"
      height="22"
      viewBox="0 0 17 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.03516 17.8749C1.03516 17.2671 1.2766 16.6842 1.70637 16.2545C2.13614 15.8247 2.71904 15.5833 3.32682 15.5833H15.7018M1.03516 17.8749C1.03516 18.4827 1.2766 19.0656 1.70637 19.4954C2.13614 19.9251 2.71904 20.1666 3.32682 20.1666H15.7018V1.83325H3.32682C2.71904 1.83325 2.13614 2.07469 1.70637 2.50447C1.2766 2.93424 1.03516 3.51713 1.03516 4.12492V17.8749Z"
        stroke="#2C2C31"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgHours() {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.8997 10.9999C19.8997 16.0625 15.7957 20.1666 10.7331 20.1666M19.8997 10.9999C19.8997 5.93731 15.7957 1.83325 10.7331 1.83325M19.8997 10.9999H16.2331M10.7331 20.1666C5.67046 20.1666 1.56641 16.0625 1.56641 10.9999M10.7331 20.1666V16.4999M1.56641 10.9999C1.56641 5.93731 5.67046 1.83325 10.7331 1.83325M1.56641 10.9999H5.23307M10.7331 1.83325V5.49992"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgMessageCircle() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.25 9.54169C18.2532 10.7516 17.9705 11.9451 17.425 13.025C16.7782 14.3191 15.7839 15.4076 14.5535 16.1685C13.3231 16.9295 11.9051 17.3328 10.4583 17.3334C9.24845 17.3365 8.05494 17.0538 6.975 16.5084L1.75 18.25L3.49167 13.025C2.94619 11.9451 2.66351 10.7516 2.66667 9.54169C2.66723 8.09497 3.07056 6.67697 3.83149 5.44653C4.59242 4.21609 5.6809 3.2218 6.975 2.57503C8.05494 2.02955 9.24845 1.74687 10.4583 1.75003H10.9167C12.8273 1.85544 14.632 2.66189 15.985 4.01498C17.3381 5.36807 18.1446 7.17271 18.25 9.08336V9.54169Z"
        stroke="#2C2C31"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgPieChart() {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8088 14.5658C18.2256 15.9449 17.3135 17.1601 16.1521 18.1053C14.9908 19.0504 13.6156 19.6967 12.1468 19.9876C10.678 20.2785 9.16031 20.2052 7.72639 19.7741C6.29247 19.3429 4.986 18.5671 3.92119 17.5144C2.85638 16.4616 2.06567 15.1641 1.61817 13.7352C1.17067 12.3063 1.08002 10.7895 1.35414 9.3175C1.62825 7.84547 2.25879 6.46299 3.19063 5.29095C4.12247 4.1189 5.32723 3.19296 6.69959 2.59409M19.5329 10.9999C19.5329 9.79613 19.2958 8.60414 18.8352 7.49199C18.3745 6.37984 17.6993 5.36931 16.8481 4.51811C15.9969 3.6669 14.9863 2.99169 13.8742 2.53102C12.762 2.07035 11.57 1.83325 10.3663 1.83325V10.9999H19.5329Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgCoinStack() {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3614 3.87031C11.3624 2.74484 9.0675 1.83325 6.23981 1.83325C3.41212 1.83325 1.11924 2.74585 1.11719 3.87031M1.11719 3.87031C1.11719 4.99578 3.41007 5.90737 6.23981 5.90737C9.06955 5.90737 11.3624 4.99578 11.3624 3.87031L11.3624 11.774M1.11719 3.87031V16.0926C1.11821 17.2181 3.4111 18.1296 6.23981 18.1296C7.61165 18.1296 8.8503 17.9127 9.7693 17.5633M1.11821 7.94441C1.11821 9.06988 3.4111 9.98147 6.24084 9.98147C9.07058 9.98147 11.3635 9.06988 11.3635 7.94441M9.83077 13.47C8.90665 13.8316 7.63931 14.0556 6.23981 14.0556C3.4111 14.0556 1.11821 13.1441 1.11821 12.0186M17.1838 12.3425C18.9839 14.1321 18.9839 17.0349 17.1838 18.8244C15.3837 20.614 12.4638 20.614 10.6637 18.8244C8.86362 17.0349 8.86362 14.1321 10.6637 12.3425C12.4638 10.5529 15.3837 10.5529 17.1838 12.3425Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgCriteriaManagement() {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.90104 1.75H1.48438V8.16667H7.90104V1.75Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9844 1.75H11.5677V8.16667H17.9844V1.75Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9844 11.8333H11.5677V18.25H17.9844V11.8333Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.90104 11.8333H1.48438V18.25H7.90104V11.8333Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgPerformanceTracking() {
  return (
    <svg
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.73187 6.37999L9.73438 11.0092L17.7369 6.37999M9.73438 20.24V11M17.9844 14.6667V7.33333C17.984 7.01183 17.8992 6.69607 17.7383 6.41772C17.5774 6.13938 17.3461 5.90824 17.0677 5.74749L10.651 2.08083C10.3723 1.91992 10.0562 1.83521 9.73438 1.83521C9.41256 1.83521 9.09641 1.91992 8.81771 2.08083L2.40104 5.74749C2.12262 5.90824 1.89136 6.13938 1.73046 6.41772C1.56957 6.69607 1.4847 7.01183 1.48438 7.33333V14.6667C1.4847 14.9882 1.56957 15.3039 1.73046 15.5823C1.89136 15.8606 2.12262 16.0917 2.40104 16.2525L8.81771 19.9192C9.09641 20.0801 9.41256 20.1648 9.73438 20.1648C10.0562 20.1648 10.3723 20.0801 10.651 19.9192L17.0677 16.2525C17.3461 16.0917 17.5774 15.8606 17.7383 15.5823C17.8992 15.3039 17.984 14.9882 17.9844 14.6667Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgEmployeeUsers() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5846 18.25V16.4167C15.5846 15.4442 15.1983 14.5116 14.5107 13.8239C13.8231 13.1363 12.8904 12.75 11.918 12.75H4.58464C3.61218 12.75 2.67954 13.1363 1.99191 13.8239C1.30428 14.5116 0.917969 15.4442 0.917969 16.4167V18.25M21.0846 18.25V16.4167C21.084 15.6043 20.8136 14.815 20.3159 14.173C19.8181 13.5309 19.1213 13.0723 18.3346 12.8692M14.668 1.86917C15.4567 2.07111 16.1558 2.52981 16.655 3.17295C17.1542 3.81609 17.4252 4.60709 17.4252 5.42125C17.4252 6.23541 17.1542 7.02641 16.655 7.66955C16.1558 8.31269 15.4567 8.77139 14.668 8.97333M11.918 5.41667C11.918 7.44171 10.2763 9.08333 8.2513 9.08333C6.22626 9.08333 4.58464 7.44171 4.58464 5.41667C4.58464 3.39162 6.22626 1.75 8.2513 1.75C10.2763 1.75 11.918 3.39162 11.918 5.41667Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgCareerSite() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.75 7.25H18.25M7.25 18.25V7.25M3.58333 1.75H16.4167C17.4292 1.75 18.25 2.57081 18.25 3.58333V16.4167C18.25 17.4292 17.4292 18.25 16.4167 18.25H3.58333C2.57081 18.25 1.75 17.4292 1.75 16.4167V3.58333C1.75 2.57081 2.57081 1.75 3.58333 1.75Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgUserPlus() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.668 18.25V16.4167C14.668 15.4442 14.2817 14.5116 13.594 13.8239C12.9064 13.1363 11.9738 12.75 11.0013 12.75H4.58464C3.61218 12.75 2.67954 13.1363 1.99191 13.8239C1.30428 14.5116 0.917969 15.4442 0.917969 16.4167V18.25M18.3346 6.33333V11.8333M21.0846 9.08333H15.5846M11.4596 5.41667C11.4596 7.44171 9.81801 9.08333 7.79297 9.08333C5.76792 9.08333 4.1263 7.44171 4.1263 5.41667C4.1263 3.39162 5.76792 1.75 7.79297 1.75C9.81801 1.75 11.4596 3.39162 11.4596 5.41667Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgSidebar() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 18.25L12.75 1.75M16.4167 18.25L3.58333 18.25C2.57081 18.25 1.75 17.4292 1.75 16.4167L1.75 3.58333C1.75 2.57081 2.57081 1.75 3.58333 1.75L16.4167 1.75C17.4292 1.75 18.25 2.57081 18.25 3.58333L18.25 16.4167C18.25 17.4292 17.4292 18.25 16.4167 18.25Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgIconDocumentation() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 5.44444C11 4.2657 10.5786 3.13524 9.82843 2.30175C9.07828 1.46825 8.06087 1 7 1H1V17.6667H8C8.79565 17.6667 9.55871 18.0179 10.1213 18.643C10.6839 19.2681 11 20.1159 11 21M11 5.44444V21M11 5.44444C11 4.2657 11.4214 3.13524 12.1716 2.30175C12.9217 1.46825 13.9391 1 15 1H21V17.6667H14C13.2044 17.6667 12.4413 18.0179 11.8787 18.643C11.3161 19.2681 11 20.1159 11 21"
        stroke="#2C2C31"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgVectorOrganigramme() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.30832 18.5666C9.48465 17.9986 9.92412 17.5468 10.4926 17.3489L10.4926 14.7367H7.32365C6.57188 14.7385 5.84554 15.004 5.27407 15.4855C4.70283 15.9669 4.32406 16.633 4.20566 17.3643C4.7667 17.576 5.19237 18.0374 5.35322 18.6077C5.51406 19.1779 5.39099 19.7895 5.02134 20.2562C4.65168 20.7226 4.07939 20.9889 3.47886 20.9736C2.87832 20.9583 2.32069 20.6636 1.97608 20.179C1.63126 19.6942 1.54002 19.0773 1.73057 18.5159C1.92092 17.9546 2.37011 17.5154 2.94136 17.3323C3.06973 16.2751 3.58601 15.3004 4.3934 14.5922C5.20058 13.8841 6.24286 13.4912 7.3236 13.4879H10.4926V9.74157H7.95744C7.2852 9.74157 6.64033 9.47836 6.1648 9.01007C5.68948 8.54157 5.42232 7.90625 5.42232 7.24395V3.49762C5.42232 2.83533 5.68948 2.2 6.1648 1.7315C6.64034 1.26321 7.2852 1 7.95744 1H14.2952C14.9675 1 15.6123 1.26321 16.0877 1.7315C16.5632 2.2 16.8301 2.83533 16.8301 3.49762V7.24395C16.8301 7.90625 16.5632 8.54157 16.0877 9.01007C15.6123 9.47836 14.9675 9.74157 14.2952 9.74157H11.7601V13.4879H14.9288C16.0098 13.4913 17.0521 13.8841 17.8593 14.5922C18.6664 15.3004 19.1829 16.2748 19.3113 17.3323C19.8872 17.5154 20.3409 17.9572 20.5336 18.5224C20.7262 19.0877 20.6352 19.7095 20.2883 20.198C19.9413 20.6866 19.3794 20.9841 18.7745 20.9994C18.1693 21.0146 17.5927 20.7462 17.2207 20.2758C16.8487 19.8054 16.7255 19.1889 16.8884 18.6146C17.0514 18.0404 17.4813 17.5765 18.047 17.3643C17.9286 16.633 17.5499 15.967 16.9784 15.4855C16.4072 15.004 15.6806 14.7385 14.9288 14.7367H11.7601V17.3489C12.3286 17.5468 12.7678 17.9986 12.9443 18.5666C13.1209 19.1347 13.0133 19.7514 12.6549 20.2289C12.2963 20.7064 11.7291 20.9882 11.1262 20.9882C10.5234 20.9882 9.95616 20.7064 9.59776 20.2289C9.23915 19.7514 9.13178 19.1346 9.30832 18.5666ZM8.63281 3C8.08053 3 7.63281 3.44772 7.63281 4V7C7.63281 7.55228 8.08053 8 8.63281 8H13.6328C14.1851 8 14.6328 7.55228 14.6328 7V4C14.6328 3.44772 14.1851 3 13.6328 3H8.63281Z"
        fill="black"
      />
    </svg>
  );
}

export function SvgArchiveMaterial() {
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6185 6.33333V18.25H3.11849V6.33333M9.53516 10H13.2018M1.28516 1.75H21.4518V6.33333H1.28516V1.75Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgSingUpCalendar() {
  return (
    <svg
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0339 1.83325V5.49992M5.70052 1.83325V5.49992M1.11719 9.16658H17.6172M2.95052 3.66659H15.7839C16.7964 3.66659 17.6172 4.4874 17.6172 5.49992V18.3333C17.6172 19.3458 16.7964 20.1666 15.7839 20.1666H2.95052C1.938 20.1666 1.11719 19.3458 1.11719 18.3333V5.49992C1.11719 4.4874 1.938 3.66659 2.95052 3.66659Z"
        stroke="#101828"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgCheckMark() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4287 6.49519L7.77273 12.6654L4.57128 9.17288L5.77753 8.06715L7.77273 10.2437L12.2225 5.38946L13.4287 6.49519Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9ZM9 1.63636C4.93318 1.63636 1.63636 4.93318 1.63636 9C1.63636 13.0668 4.93318 16.3636 9 16.3636C13.0668 16.3636 16.3636 13.0668 16.3636 9C16.3636 4.93318 13.0668 1.63636 9 1.63636Z"
        fill="black"
      />
    </svg>
  );
}

export function SvgCheckMarkAnime() {
  return (
    <svg
      width="80px"
      height="80px"
      viewBox="0 0 133 133"
      version="1.1"
    >
      <g
        id="check-group"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <circle
          id="filled-circle"
          fill="#73C7B7"
          cx="66.5"
          cy="66.5"
          r="54.5"
        ></circle>
        <circle
          id="white-circle"
          fill="#FFFFFF"
          cx="66.5"
          cy="66.5"
          r="55.5"
        ></circle>
        <circle
          id="outline"
          stroke="#73C7B7"
          strokeWidth="4"
          cx="66.5"
          cy="66.5"
          r="54.5"
        ></circle>
        <polyline
          id="check"
          stroke="#FFFFFF"
          strokeWidth="4"
          points="41 70 56 85 92 49"
        ></polyline>
      </g>
    </svg>
  );
}

export function ArrowRigthWhite() {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00001 12.8538L6.10418 11.958L10.9583 7.12467H0.645844V5.87467H10.9583L6.10418 1.04134L7.00001 0.145508L13.3542 6.49967L7.00001 12.8538Z"
        fill="white"
      />
    </svg>
  );
}

export function ChiefRecruiters() {
  return (
    <svg
      width="28"
      height="24"
      viewBox="0 0 28 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5045 19.0002H18.9457C19.9805 19.0002 20.8036 18.5287 21.5427 17.8694C23.4202 16.1944 19.0067 14.5 17.5 14.5"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 5.06877C15.2271 5.02373 15.4629 5 15.7048 5C17.5247 5 19 6.34315 19 8C19 9.65685 17.5247 11 15.7048 11C15.4629 11 15.2271 10.9763 15 10.9312"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M4.78256 15.1112C3.68218 15.743 0.797061 17.0331 2.55429 18.6474C3.41269 19.436 4.36872 20 5.57068 20H12.4293C13.6313 20 14.5873 19.436 15.4457 18.6474C17.2029 17.0331 14.3178 15.743 13.2174 15.1112C10.6371 13.6296 7.36292 13.6296 4.78256 15.1112Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z"
        stroke="#2A353D"
        strokeWidth="1.5"
      />
      <g clipPath="url(#clip0_0_1)">
        <path
          d="M24.5733 1.14838L25.1599 2.33128C25.2399 2.49595 25.4532 2.65389 25.6332 2.68414L26.6964 2.86224C27.3763 2.9765 27.5363 3.47386 27.0463 3.96449L26.2198 4.7979C26.0798 4.93904 26.0031 5.21124 26.0464 5.40615L26.2831 6.43782C26.4697 7.25443 26.0398 7.57032 25.3232 7.14353L24.3266 6.54872C24.1467 6.44119 23.85 6.44119 23.6667 6.54872L22.6702 7.14353C21.9569 7.57032 21.5236 7.25107 21.7103 6.43782L21.9469 5.40615C21.9902 5.21124 21.9136 4.93904 21.7736 4.7979L20.947 3.96449C20.4604 3.47386 20.617 2.9765 21.297 2.86224L22.3602 2.68414C22.5368 2.65389 22.7501 2.49595 22.8301 2.33128L23.4167 1.14838C23.7367 0.506528 24.2566 0.506528 24.5733 1.14838Z"
          fill="white"
          stroke="#2A353D"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_0_1">
          <rect
            width="8"
            height="8"
            fill="white"
            transform="translate(20)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgCircleNotice() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_16997_54865)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.503 0.958008C9.41797 0.958008 7.37977 1.57629 5.64614 2.73466C3.91251 3.89304 2.56131 5.53948 1.76341 7.46579C0.965505 9.3921 0.756737 11.5118 1.1635 13.5567C1.57027 15.6017 2.5743 17.4801 4.04864 18.9544C5.52297 20.4287 7.40138 21.4328 9.44634 21.8395C11.4913 22.2463 13.611 22.0375 15.5373 21.2396C17.4636 20.4417 19.11 19.0905 20.2684 17.3569C21.4268 15.6233 22.045 13.5851 22.045 11.5001C22.045 10.1157 21.7724 8.74481 21.2426 7.46579C20.7128 6.18677 19.9363 5.02462 18.9573 4.0457C17.9784 3.06678 16.8163 2.29026 15.5373 1.76047C14.2582 1.23069 12.8874 0.958008 11.503 0.958008ZM11.503 20.1251C9.79713 20.1251 8.12957 19.6192 6.7112 18.6715C5.29282 17.7238 4.18734 16.3767 3.53453 14.8007C2.88173 13.2247 2.71092 11.4905 3.04372 9.8174C3.37652 8.14432 4.19797 6.60749 5.4042 5.40126C6.61042 4.19503 8.14725 3.37358 9.82034 3.04078C11.4934 2.70799 13.2276 2.87879 14.8036 3.5316C16.3796 4.1844 17.7267 5.28989 18.6744 6.70826C19.6221 8.12664 20.128 9.79419 20.128 11.5001C20.128 12.6327 19.9049 13.7543 19.4715 14.8007C19.038 15.8471 18.4027 16.7979 17.6018 17.5989C16.8009 18.3998 15.8501 19.0351 14.8036 19.4685C13.7572 19.902 12.6356 20.1251 11.503 20.1251Z"
          fill="#7A858A"
        />
        <path
          d="M11.497 16.2908C11.243 16.2905 10.9996 16.1894 10.82 16.0099C10.6404 15.8303 10.5394 15.5868 10.5391 15.3328V10.3775C10.5391 10.1233 10.6401 9.87945 10.8198 9.69969C10.9996 9.51993 11.2434 9.41895 11.4976 9.41895C11.7518 9.41895 11.9956 9.51993 12.1754 9.69969C12.3551 9.87945 12.4561 10.1233 12.4561 10.3775V15.3317C12.4561 15.586 12.3551 15.83 12.1752 16.0099C11.9953 16.1897 11.7514 16.2908 11.497 16.2908Z"
          fill="#7A858A"
        />
        <path
          d="M11.497 8.66623C11.373 8.67135 11.2493 8.65134 11.1333 8.6074C11.0172 8.56346 10.9113 8.49651 10.8218 8.41056C10.7323 8.32462 10.6611 8.22146 10.6125 8.10729C10.5639 7.99312 10.539 7.87031 10.5391 7.74623V7.66458C10.5391 7.41036 10.6401 7.16656 10.8198 6.9868C10.9996 6.80704 11.2434 6.70605 11.4976 6.70605C11.7518 6.70605 11.9956 6.80704 12.1754 6.9868C12.3551 7.16656 12.4561 7.41036 12.4561 7.66458C12.4581 7.92353 12.359 8.17304 12.1799 8.36009C12.0008 8.54713 11.7558 8.65696 11.497 8.66623Z"
          fill="#7A858A"
        />
      </g>
      <defs>
        <clipPath id="clip0_16997_54865">
          <rect
            width="23"
            height="23"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PostGroup() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1464 17.0961H1.95185C1.427 17.0961 1 16.6691 1 16.1443V9.51416H8.81465L8.80431 9.82263C8.80372 9.84192 8.80153 9.86042 8.79894 9.87911C8.79934 10.5525 9.35999 11.113 10.0493 11.113C10.7345 11.113 11.2927 10.5589 11.2991 9.87513C11.2961 9.85485 11.2945 9.83735 11.2941 9.81925L11.2873 9.51416H19.0982V16.1443C19.0982 16.6689 18.6712 17.0961 18.1464 17.0961ZM1.59664 10.1108V16.1443C1.59664 16.3402 1.75595 16.4995 1.95185 16.4995H18.1464C18.3423 16.4995 18.5016 16.3402 18.5016 16.1443V10.1108H11.879C11.7579 11.0121 10.9833 11.7096 10.0491 11.7096C9.11496 11.7096 8.34052 11.0121 8.2192 10.1108H1.59664Z"
        fill="#393C40"
      />
      <path
        d="M18.1464 3.22546H12.8539V2.94722C12.8539 1.56241 11.7273 0.435547 10.3423 0.435547H9.75616C8.37135 0.435547 7.24448 1.56241 7.24448 2.94722V3.22546H1.95185C1.427 3.22546 1 3.65246 1 4.1773V8.2854H19.0982V4.1773C19.0982 3.65246 18.6712 3.22546 18.1464 3.22546ZM7.84113 2.94722C7.84113 1.89116 8.7001 1.03219 9.75616 1.03219H10.3423C11.3983 1.03219 12.2573 1.89116 12.2573 2.94722V3.22546H7.84113V2.94722ZM18.5016 7.68856H1.59664V4.1773C1.59664 3.98161 1.75595 3.8221 1.95185 3.8221H18.1464C18.3423 3.8221 18.5016 3.98141 18.5016 4.1773V7.68856Z"
        fill="#393C40"
      />
      <path
        d="M18.1464 17.0961H1.95185C1.427 17.0961 1 16.6691 1 16.1443V9.51416H8.81465L8.80431 9.82263C8.80372 9.84192 8.80153 9.86042 8.79894 9.87911C8.79934 10.5525 9.35999 11.113 10.0493 11.113C10.7345 11.113 11.2927 10.5589 11.2991 9.87513C11.2961 9.85485 11.2945 9.83735 11.2941 9.81925L11.2873 9.51416H19.0982V16.1443C19.0982 16.6689 18.6712 17.0961 18.1464 17.0961ZM1.59664 10.1108V16.1443C1.59664 16.3402 1.75595 16.4995 1.95185 16.4995H18.1464C18.3423 16.4995 18.5016 16.3402 18.5016 16.1443V10.1108H11.879C11.7579 11.0121 10.9833 11.7096 10.0491 11.7096C9.11496 11.7096 8.34052 11.0121 8.2192 10.1108H1.59664Z"
        stroke="#393C40"
        strokeWidth="0.8"
      />
      <path
        d="M18.1464 3.22546H12.8539V2.94722C12.8539 1.56241 11.7273 0.435547 10.3423 0.435547H9.75616C8.37135 0.435547 7.24448 1.56241 7.24448 2.94722V3.22546H1.95185C1.427 3.22546 1 3.65246 1 4.1773V8.2854H19.0982V4.1773C19.0982 3.65246 18.6712 3.22546 18.1464 3.22546ZM7.84113 2.94722C7.84113 1.89116 8.7001 1.03219 9.75616 1.03219H10.3423C11.3983 1.03219 12.2573 1.89116 12.2573 2.94722V3.22546H7.84113V2.94722ZM18.5016 7.68856H1.59664V4.1773C1.59664 3.98161 1.75595 3.8221 1.95185 3.8221H18.1464C18.3423 3.8221 18.5016 3.98141 18.5016 4.1773V7.68856Z"
        stroke="#393C40"
        strokeWidth="0.8"
      />
    </svg>
  );
}

export function Roles() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7778 17.75H1.97222C0.882994 17.75 0 16.867 0 15.7778V11.8333H1.97222V15.7778H15.7778V1.97222H1.97222V5.91667H0V1.97222C0 0.882994 0.882994 0 1.97222 0H15.7778C16.867 0 17.75 0.882994 17.75 1.97222V15.7778C17.75 16.867 16.867 17.75 15.7778 17.75ZM7.88889 12.8194V9.86111H0V7.88889H7.88889V4.93056L12.8194 8.875L7.88889 12.8194Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function ArrowLitleCollapse() {
  return (
    <svg
      width="6"
      height="9"
      viewBox="0 0 6 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.876042 9L5.85937 4.515L0.876042 0.0300002L0.0449965 0.777412L4.19846 4.515L0.0449971 8.25259L0.876042 9Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function ConnexionJobboard() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5563 11.2183C11.514 12.2606 9.82407 12.2606 8.78174 11.2183C7.73942 10.1759 7.73942 8.48597 8.78174 7.44364L11.1409 5.0845C12.1357 4.08961 13.7206 4.04433 14.7692 4.94866M14.4437 1.78175C15.486 0.739417 17.1759 0.739417 18.2183 1.78175C19.2606 2.82408 19.2606 4.51403 18.2183 5.55636L15.8591 7.9155C14.8643 8.91039 13.2794 8.95567 12.2308 8.05134"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M19 11C19 14.7712 19 16.6569 17.8284 17.8284C16.6569 19 14.7712 19 11 19H9C5.22876 19 3.34315 19 2.17157 17.8284C1 16.6569 1 14.7712 1 11V9C1 5.22876 1 3.34315 2.17157 2.17157C3.34315 1 5.22876 1 9 1"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function SvgNoConnection() {
  return (
    <svg
      width="80px"
      height="80px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector"
        d="M8.34277 14.5898C8.80861 14.0902 9.37187 13.6914 9.9978 13.418C10.6237 13.1445 11.2995 13.0024 11.9826 13C12.6656 12.9976 13.3419 13.1353 13.9697 13.4044C14.5975 13.6734 15.1637 14.0682 15.633 14.5645M6.14941 11.5439C6.89312 10.7464 7.79203 10.1093 8.79091 9.67188C9.7898 9.23441 10.8678 9.00575 11.9583 9M3.22363 8.81649C4.34177 7.61743 5.69376 6.66021 7.19618 6.00391C8.69859 5.3476 10.3198 5.00558 11.9593 5M16 8.99997L18 6.99998M18 6.99998L20 5M18 6.99998L16 5M18 6.99998L20 8.99997M12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18C13 18.5523 12.5523 19 12 19Z"
        stroke="#474D55"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgDownloadIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5223 8.08982C11.4408 7.90979 11.2618 7.79514 11.0647 7.79514H9.05317V1.25776C9.05317 0.980171 8.82788 0.754883 8.5503 0.754883H6.5388C6.26121 0.754883 6.03592 0.980171 6.03592 1.25776V7.79514H4.02442C3.82729 7.79514 3.64827 7.9108 3.5668 8.08982C3.48433 8.26985 3.51652 8.48005 3.64626 8.6289L7.16638 12.6519C7.26193 12.7615 7.39972 12.8239 7.54455 12.8239C7.68937 12.8239 7.82716 12.7605 7.92271 12.6519L11.4428 8.6289C11.5736 8.48106 11.6038 8.26985 11.5223 8.08982Z"
        fill="#626262"
      />
      <path
        d="M13.0747 11.8203V14.8376H2.0115V11.8203H0V15.8433C0 16.3995 0.450576 16.8491 1.00575 16.8491H14.0805C14.6367 16.8491 15.0862 16.3995 15.0862 15.8433V11.8203H13.0747Z"
        fill="#626262"
      />
    </svg>
  );
}

export function SvgDeleteLabel() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.3 5L1.15 1.85C0.95 1.65 0.95 1.35 1.15 1.15C1.35 0.95 1.65 0.95 1.85 1.15L5 4.3L8.15 1.15C8.35 0.95 8.65 0.95 8.85 1.15C9.05 1.35 9.05 1.65 8.85 1.85L5.7 5L8.85 8.15C9.05 8.35 9.05 8.65 8.85 8.85C8.65 9.05 8.35 9.05 8.15 8.85L5 5.7L1.85 8.85C1.65 9.05 1.35 9.05 1.15 8.85C0.95 8.65 0.95 8.35 1.15 8.15L4.3 5Z"
        fill="#1A4E63"
        stroke="#1A4E63"
        strokeWidth="0.5"
      />
    </svg>
  );
}

export function CompetenceIcones() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3703 18.5H7.0943C6.6714 18.5 6.3055 18.2057 6.215 17.7926L5.8487 16.097C5.36005 15.8829 4.8967 15.6152 4.4672 15.2987L2.8139 15.8252C2.4107 15.9538 1.97239 15.7841 1.7609 15.4175L0.1193 12.5816C-0.0898713 12.2149 -0.0178076 11.7522 0.293 11.4665L1.5755 10.2965C1.51718 9.7665 1.51718 9.2317 1.5755 8.7017L0.293 7.5344C-0.0182655 7.24853 -0.0903577 6.78535 0.1193 6.4184L1.7573 3.5807C1.96879 3.21413 2.4071 3.04442 2.8103 3.173L4.4636 3.6995C4.68326 3.53674 4.91192 3.3865 5.1485 3.2495C5.37561 3.12142 5.60933 3.00546 5.8487 2.9021L6.2159 1.2083C6.30596 0.795172 6.67147 0.500445 7.0943 0.5H10.3703C10.7931 0.500445 11.1586 0.795172 11.2487 1.2083L11.6195 2.903C11.8722 3.01416 12.1183 3.13977 12.3566 3.2792C12.5788 3.40773 12.7937 3.54865 13.0001 3.7013L14.6543 3.1748C15.0572 3.0467 15.495 3.21634 15.7064 3.5825L17.3444 6.4202C17.5536 6.78694 17.4815 7.24956 17.1707 7.5353L15.8882 8.7053C15.9465 9.2353 15.9465 9.7701 15.8882 10.3001L17.1707 11.4701C17.4815 11.7558 17.5536 12.2185 17.3444 12.5852L15.7064 15.4229C15.495 15.7891 15.0572 15.9587 14.6543 15.8306L13.0001 15.3041C12.7908 15.4583 12.5733 15.601 12.3485 15.7316C12.1125 15.8683 11.8692 15.9918 11.6195 16.1015L11.2487 17.7926C11.1583 18.2054 10.7929 18.4996 10.3703 18.5ZM4.7903 13.3061L5.5283 13.8461C5.69466 13.9686 5.86806 14.0813 6.0476 14.1836C6.21653 14.2814 6.39047 14.3704 6.5687 14.45L7.4084 14.8181L7.8197 16.7H9.6467L10.058 14.8172L10.8977 14.4491C11.2643 14.2874 11.6122 14.0865 11.9354 13.8497L12.6743 13.3097L14.5112 13.8947L15.4247 12.3125L14 11.0138L14.1008 10.103C14.1451 9.70463 14.1451 9.30257 14.1008 8.9042L14 7.9934L15.4256 6.692L14.5112 5.1089L12.6743 5.6939L11.9354 5.1539C11.6121 4.91604 11.2642 4.71358 10.8977 4.55L10.058 4.1819L9.6467 2.3H7.8197L7.4066 4.1828L6.5687 4.55C6.39033 4.62834 6.21637 4.71637 6.0476 4.8137C5.86916 4.9157 5.69668 5.02778 5.531 5.1494L4.7921 5.6894L2.9561 5.1044L2.0408 6.692L3.4655 7.9889L3.3647 8.9006C3.32042 9.29897 3.32042 9.70103 3.3647 10.0994L3.4655 11.0102L2.0408 12.3089L2.9543 13.8911L4.7903 13.3061ZM8.7287 13.1C6.74047 13.1 5.1287 11.4882 5.1287 9.5C5.1287 7.51178 6.74047 5.9 8.7287 5.9C10.7169 5.9 12.3287 7.51178 12.3287 9.5C12.3262 11.4872 10.7159 13.0975 8.7287 13.1ZM8.7287 7.7C7.74536 7.701 6.9448 8.49096 6.93071 9.47421C6.91662 10.4574 7.69421 11.27 8.67712 11.2992C9.66003 11.3284 10.4844 10.5633 10.5287 9.581V9.941V9.5C10.5287 8.50589 9.72281 7.7 8.7287 7.7Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function PerformanceIcones() {
  return (
    <svg
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.51152 16.2818C2.56548 16.1331 2.71469 16.0353 2.87959 16.0406C2.89226 16.041 2.9048 16.0422 2.91735 16.044C3.05765 16.0619 3.17549 16.1535 3.22217 16.2809L3.63152 17.406L4.88067 17.4312C5.04079 17.4342 5.18135 17.5335 5.23104 17.6787C5.28061 17.8237 5.22853 17.983 5.10116 18.0754L4.10412 18.7958L4.46692 19.936C4.51323 20.0824 4.45726 20.2405 4.32763 20.3302C4.198 20.4199 4.02294 20.4214 3.89155 20.3341L2.86551 19.6538L1.84123 20.3349C1.70959 20.4221 1.53428 20.4202 1.40477 20.3301C1.27514 20.24 1.21979 20.0815 1.26673 19.9353L1.62689 18.7951L0.631628 18.0746C0.505006 17.9819 0.453428 17.8232 0.502998 17.6784C0.552563 17.5337 0.692484 17.4346 0.852112 17.4312L2.10127 17.4069L2.51152 16.2818Z"
        fill="#130F26"
      />
      <path
        d="M7.77505 16.2818C7.82901 16.1331 7.97822 16.0353 8.14311 16.0406C8.15579 16.041 8.16836 16.0422 8.18091 16.044C8.32121 16.0619 8.43905 16.1535 8.48573 16.2809L8.89508 17.406L10.1433 17.4312C10.3035 17.4341 10.444 17.5335 10.4937 17.6786C10.5433 17.8237 10.4912 17.983 10.3638 18.0754L9.36765 18.7958L9.73045 19.936C9.77676 20.0824 9.72079 20.2405 9.59116 20.3302C9.46153 20.4199 9.28647 20.4214 9.15508 20.3341L8.12904 19.6538L7.10389 20.3349C6.97226 20.4228 6.79645 20.4213 6.66656 20.3311C6.53655 20.2408 6.48108 20.0818 6.52852 19.9353L6.89045 18.7951L5.89429 18.0746C5.76767 17.9819 5.71609 17.8232 5.76566 17.6784C5.81522 17.5337 5.95515 17.4346 6.11477 17.4312L7.36393 17.4069L7.77505 16.2818Z"
        fill="#130F26"
      />
      <path
        d="M13.0388 16.2818C13.0926 16.1334 13.2415 16.0357 13.406 16.0406C13.4187 16.041 13.4312 16.0422 13.4438 16.044C13.5841 16.0619 13.7019 16.1535 13.7486 16.2809L14.1579 17.406L15.4071 17.4311C15.5672 17.4341 15.7078 17.5335 15.7574 17.6786C15.807 17.8237 15.7549 17.983 15.6276 18.0754L14.6305 18.7958L14.9933 19.936C15.0396 20.0824 14.9837 20.2405 14.854 20.3302C14.7244 20.4199 14.5493 20.4214 14.418 20.3341L13.3928 19.6538L12.3668 20.3349C12.2351 20.4221 12.0598 20.4202 11.9303 20.3301C11.8007 20.24 11.7453 20.0815 11.7923 19.9353L12.1542 18.7951L11.158 18.0746C11.0314 17.982 10.9798 17.8234 11.0292 17.6788C11.0786 17.5342 11.2183 17.4349 11.3777 17.4312L12.6277 17.4069L13.0388 16.2818Z"
        fill="#130F26"
      />
      <path
        d="M8.07802 0.0351562C5.64139 0.0351562 3.64937 1.93628 3.64937 4.26006C3.64937 5.62053 4.33502 6.83209 5.39017 7.60589C3.23031 8.57237 1.72989 10.6588 1.72989 13.0831V14.6878C1.72904 14.8815 1.80945 15.0676 1.95326 15.2047C2.09686 15.3417 2.29215 15.4184 2.4953 15.4177H13.6682C14.0892 15.4161 14.4294 15.0893 14.4277 14.6878V13.0831C14.4277 10.6583 12.9272 8.57215 10.7674 7.60587C11.8225 6.83213 12.5082 5.62051 12.5082 4.26004C12.5082 1.93632 10.5147 0.0351562 8.07802 0.0351562ZM8.07802 1.48937C9.69073 1.48937 10.9833 2.72202 10.9833 4.26006C10.9833 5.79804 9.69079 7.02929 8.07802 7.02929C6.46526 7.02929 5.17424 5.79804 5.17424 4.26006C5.17424 2.72207 6.46531 1.48937 8.07802 1.48937ZM8.07802 8.48361C10.7642 8.48361 12.9073 10.5217 12.9073 13.0834V13.9639H3.25487V13.0834C3.25487 10.5215 5.39186 8.48361 8.07802 8.48361Z"
        fill="#130F26"
      />
    </svg>
  );
}

export function IconeNoteEntretient() {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.98003 13H2.20226C1.40451 13 0.757812 12.3533 0.757812 11.5556V1.44444C0.757812 0.6467 1.40451 0 2.20226 0H12.3134C13.1111 0 13.7578 0.6467 13.7578 1.44444V7.22222C13.7575 7.23057 13.756 7.23883 13.7535 7.24678C13.7514 7.25337 13.75 7.26014 13.7491 7.267C13.7451 7.33069 13.7327 7.39357 13.7123 7.45406L13.7058 7.47356C13.701 7.48986 13.6949 7.50579 13.6878 7.52122C13.6528 7.5999 13.6038 7.6716 13.5433 7.73283L8.48776 12.7884C8.35305 12.9231 8.17056 12.9992 7.98003 13ZM2.20226 1.44444V11.5556H7.25781V7.22222C7.25781 6.82335 7.58116 6.5 7.98003 6.5H12.3134V1.44444H2.20226ZM8.70226 7.94444V10.5351L11.2921 7.94444H8.70226Z"
        fill="#292929"
      />
    </svg>
  );
}

export function DeveloppementPlan() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0557 14.6271L11.3891 16.6271C11.2373 16.6917 11.0718 16.7178 10.9075 16.7029C10.7432 16.6881 10.5851 16.6329 10.4473 16.5421C10.3095 16.4514 10.1963 16.3279 10.1178 16.1828C10.0393 16.0377 9.99796 15.8754 9.9974 15.7104V1.21043C9.99796 1.04545 10.0393 0.883165 10.1178 0.738053C10.1963 0.592941 10.3095 0.469507 10.4473 0.378753C10.5851 0.287999 10.7432 0.232744 10.9075 0.217915C11.0718 0.203086 11.2373 0.229143 11.3891 0.293763L16.0557 2.29376C16.2356 2.37035 16.3892 2.498 16.4973 2.66092C16.6054 2.82385 16.6634 3.01489 16.6641 3.21043V13.7104C16.6634 13.906 16.6054 14.097 16.4973 14.2599C16.3892 14.4229 16.2356 14.5505 16.0557 14.6271ZM14.9974 3.6521L11.6641 2.2271V14.7271L14.9974 13.2688V3.6521Z"
        fill="#292929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.49479 15.1273C7.27378 15.1273 7.06182 15.0395 6.90554 14.8832C6.74926 14.7269 6.66146 14.515 6.66146 14.2939V2.62728C6.66146 2.40626 6.74926 2.1943 6.90554 2.03802C7.06182 1.88174 7.27378 1.79395 7.49479 1.79395C7.71581 1.79395 7.92777 1.88174 8.08405 2.03802C8.24033 2.1943 8.32812 2.40626 8.32812 2.62728V14.2939C8.32812 14.515 8.24033 14.7269 8.08405 14.8832C7.92777 15.0395 7.71581 15.1273 7.49479 15.1273Z"
        fill="#292929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16667 15.1273C3.94565 15.1273 3.73369 15.0395 3.57741 14.8832C3.42113 14.7269 3.33333 14.515 3.33333 14.2939V2.62728C3.33333 2.40626 3.42113 2.1943 3.57741 2.03802C3.73369 1.88174 3.94565 1.79395 4.16667 1.79395C4.38768 1.79395 4.59964 1.88174 4.75592 2.03802C4.9122 2.1943 5 2.40626 5 2.62728V14.2939C5 14.515 4.9122 14.7269 4.75592 14.8832C4.59964 15.0395 4.38768 15.1273 4.16667 15.1273Z"
        fill="#292929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.830729 15.1273C0.609715 15.1273 0.397752 15.0395 0.241472 14.8832C0.0851914 14.7269 -0.00260544 14.515 -0.00260544 14.2939V2.62728C-0.00260544 2.40626 0.0851914 2.1943 0.241472 2.03802C0.397752 1.88174 0.609715 1.79395 0.830729 1.79395C1.05174 1.79395 1.2637 1.88174 1.41999 2.03802C1.57627 2.1943 1.66406 2.40626 1.66406 2.62728V14.2939C1.66406 14.515 1.57627 14.7269 1.41999 14.8832C1.2637 15.0395 1.05174 15.1273 0.830729 15.1273Z"
        fill="#292929"
      />
    </svg>
  );
}

export function AlerteDate() {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.31379 15.9998C5.44204 15.9998 4.73534 15.2835 4.73534 14.3998H7.89224C7.89224 15.2835 7.18554 15.9998 6.31379 15.9998ZM12.6276 13.5998H0V11.9999L1.57845 11.1999V6.79992C1.53687 5.67123 1.78833 4.55125 2.30769 3.55196C2.82466 2.62518 3.70832 1.96708 4.73534 1.74398V0H7.61285C6.58717 1.16193 6.41599 2.86109 7.1888 4.20919C7.96161 5.55729 9.50274 6.24788 11.0065 5.91993C11.0341 6.20553 11.0476 6.50153 11.0476 6.79992V11.1999L12.626 11.9999V13.5998H12.6276Z"
        fill="#3D3F3C"
      />
      <path
        d="M7.90215 2.53353C7.9719 3.80378 9.0074 4.79815 10.2625 4.80013C10.4431 4.80018 10.6231 4.77951 10.7992 4.73853C12.022 4.45213 12.812 3.24824 12.5997 1.99434C12.3875 0.740448 11.2469 -0.127719 9.99976 0.0154253C8.75264 0.15857 7.8324 1.26329 7.90215 2.53353Z"
        fill="#F9CB55"
      />
    </svg>
  );
}

export function Alerte() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.6092 17.5H8.40119C4.54251 17.5 2.61317 17.5 1.90218 16.245C1.19119 14.9899 2.17801 13.3262 4.15166 9.99873L5.75569 7.29444C7.65154 4.09815 8.59946 2.5 10.0052 2.5C11.411 2.5 12.3589 4.09814 14.2547 7.29443L15.8588 9.99872C17.8324 13.3262 18.8192 14.9899 18.1082 16.245C17.3972 17.5 15.4679 17.5 11.6092 17.5Z" stroke="#EB3818" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M10.0078 7.5V11.25" stroke="#EB3818" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M10 14.1602V14.1685" stroke="#EB3818" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  );
}

export function ArrowLeftPrecedent() {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.485 11.4854L4.79514e-07 6.00035L5.485 0.515352L6.39971 1.42941L1.82812 6.00035L6.39971 10.5713L5.485 11.4854Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function ArrowRightNext() {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.31188 11.4854L6.79687 6.00035L1.31187 0.515352L0.397169 1.42941L4.96876 6.00035L0.39717 10.5713L1.31188 11.4854Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function LineSeparationPrevNext() {
  return (
    <svg
      width="2"
      height="16"
      viewBox="0 0 2 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="1"
        height="16"
        transform="translate(0.398438)"
        fill="#393C40"
        fill-opacity="0.15"
      />
    </svg>
  );
}

export function MiniSidebarLogo() {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.6147 18.044V40.9795C28.003 39.9695 24.1447 28.0038 23.792 22.1471V0.263672C36.0652 0.937009 40.121 12.3978 40.6147 18.044Z"
        fill="#FA966B"
      />
      <ellipse
        cx="9.89425"
        cy="29.1538"
        rx="9.50851"
        ry="9.6304"
        fill="#73C7B7"
      />
      <path
        d="M21.3539 11.3428C19.3292 12.0197 18.2606 15.2911 17.9794 16.8423H0.89596C0.790507 15.0091 0.89596 9.96626 5.21954 5.84343C10.3657 0.936264 18.12 -0.0790118 21.3539 0.0267461V11.3428Z"
        fill="#4472A3"
      />
    </svg>
  );
}

export function SvgAddGroup() {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.8481 0C5.47118 0 3.5443 1.8978 3.5443 4.23885C3.5443 6.57991 5.47118 8.47771 7.8481 8.47771C10.225 8.47771 12.1519 6.57991 12.1519 4.23885C12.1519 1.8978 10.225 0 7.8481 0ZM5.06329 4.23885C5.06329 2.72405 6.31009 1.49607 7.8481 1.49607C9.38611 1.49607 10.6329 2.72405 10.6329 4.23885C10.6329 5.75365 9.38611 6.98164 7.8481 6.98164C6.31009 6.98164 5.06329 5.75365 5.06329 4.23885Z"
        fill="#11142D"
      />
      <path
        d="M1.51899 13.7139C1.51899 12.4746 2.5391 11.4698 3.79747 11.4698H4.14265C4.16934 11.4698 4.19586 11.474 4.22123 11.4822L5.0977 11.764C5.78584 11.9853 6.49462 12.1214 7.20815 12.1723C7.3583 12.183 7.49008 12.0792 7.52401 11.9347C7.60054 11.6088 7.70022 11.2917 7.82128 10.9851C7.87471 10.8498 7.7743 10.7001 7.62691 10.6958C6.93164 10.6751 6.23863 10.5572 5.5692 10.3419L4.69273 10.06C4.51513 10.0029 4.32948 9.97378 4.14265 9.97378H3.79747C1.70018 9.97378 0 11.6483 0 13.7139V14.8991C0 15.6504 0.552794 16.2909 1.30559 16.412C3.49106 16.7634 5.69841 16.9376 7.90557 16.9345C8.0596 16.9343 8.15633 16.7704 8.0874 16.6348C7.93869 16.3421 7.81026 16.0377 7.7039 15.7234C7.64701 15.5553 7.49051 15.4373 7.3106 15.4348C5.38376 15.4087 3.45839 15.2423 1.55035 14.9354C1.53227 14.9325 1.51899 14.9172 1.51899 14.8991V13.7139Z"
        fill="#11142D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4304 19C17.5064 19 20 16.544 20 13.5144C20 10.4848 17.5064 8.02885 14.4304 8.02885C11.3544 8.02885 8.86076 10.4848 8.86076 13.5144C8.86076 16.544 11.3544 19 14.4304 19ZM14.4304 17.5039C16.6675 17.5039 18.481 15.7178 18.481 13.5144C18.481 11.3111 16.6675 9.52491 14.4304 9.52491C12.1933 9.52491 10.3797 11.3111 10.3797 13.5144C10.3797 15.7178 12.1933 17.5039 14.4304 17.5039Z"
        fill="#11142D"
      />
      <path
        d="M14.4937 10.4515C14.9131 10.4515 15.2532 10.7864 15.2532 11.1996V12.945H17.0253C17.4448 12.945 17.7848 13.2799 17.7848 13.693C17.7848 14.1061 17.4448 14.441 17.0253 14.441H15.2532V16.1865C15.2532 16.5996 14.9131 16.9345 14.4937 16.9345C14.0742 16.9345 13.7342 16.5996 13.7342 16.1865V14.441H11.962C11.5426 14.441 11.2025 14.1061 11.2025 13.693C11.2025 13.2799 11.5426 12.945 11.962 12.945H13.7342V11.1996C13.7342 10.7864 14.0742 10.4515 14.4937 10.4515Z"
        fill="#11142D"
      />
    </svg>
  );
}

export function AlertActiveAssesment() {
  return (
    <svg
      width="40"
      height="31"
      viewBox="0 0 40 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="1"
        width="39"
        height="29"
        rx="3.5"
        fill="#E6F8EF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.288 21.8351L23.213 23.0111C23.8192 23.2548 24.5239 22.9267 24.784 22.2796C24.9221 21.9362 24.9127 21.5547 24.7578 21.2339C24.7484 21.2137 24.7372 21.1944 24.7251 21.1756C24.1475 19.9447 24.1163 18.4959 24.6412 17.1903L24.935 16.4595C25.0466 16.1819 24.9261 15.8717 24.6661 15.7672C24.4061 15.6626 24.1044 15.8031 23.9928 16.0807L23.699 16.8115C23.0477 18.4316 23.0963 20.2309 23.8319 21.7495L23.8363 21.7581C23.8407 21.7667 23.8449 21.7748 23.8497 21.7832C23.8582 21.8131 23.8608 21.8538 23.8419 21.9008C23.8052 21.9919 23.7028 22.0396 23.6174 22.0053L13.2537 17.8388C13.1684 17.8045 13.1275 17.6992 13.1641 17.6081C13.1827 17.5618 13.2131 17.5335 13.2392 17.5175C13.25 17.5148 13.2594 17.5115 13.2695 17.508L13.2761 17.5058C14.8571 16.9194 16.1386 15.6539 16.7899 14.0338L17.542 12.163C18.3596 10.1293 20.5749 9.09831 22.4792 9.86389L22.5079 9.87522C22.5498 9.89156 22.594 9.90882 22.6319 9.93228C22.8654 10.0792 23.1873 9.99356 23.34 9.73716C23.4927 9.48081 23.4237 9.15153 23.1852 9.00273C23.0919 8.94415 22.9841 8.89849 22.8835 8.85808C20.4597 7.88365 17.6404 9.19607 16.5999 11.7843L15.8478 13.6551C15.3231 14.96 14.2987 15.9836 13.0313 16.4719C13.0088 16.477 12.9866 16.4836 12.9649 16.492C12.6308 16.6171 12.36 16.8859 12.222 17.2293C11.9618 17.8764 12.2433 18.601 12.8494 18.8446L15.7711 20.0193C15.5969 21.206 16.1889 22.3745 17.2725 22.8101C18.3563 23.2458 19.5923 22.8123 20.288 21.8351ZM19.3007 21.4382L16.7584 20.4162C16.7726 21.023 17.1144 21.5782 17.6769 21.8043C18.2394 22.0305 18.8704 21.8663 19.3007 21.4382Z"
        fill="#48B59C"
      />
      <path
        d="M25.2259 14.6897C26.5912 14.6897 27.698 13.5829 27.698 12.2176C27.698 10.8523 26.5912 9.74552 25.2259 9.74552C23.8606 9.74552 22.7538 10.8523 22.7538 12.2176C22.7538 13.5829 23.8606 14.6897 25.2259 14.6897Z"
        fill="#48B59C"
      />
      <rect
        x="0.5"
        y="1"
        width="39"
        height="29"
        rx="3.5"
        stroke="#73C7B7"
      />
    </svg>
  );
}

export function AlertNotActiveAssesment() {
  return (
    <svg
      width="41"
      height="31"
      viewBox="0 0 41 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.929688"
        y="1"
        width="39"
        height="29"
        rx="3.5"
        fill="#EAECEF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7176 21.8351L23.6427 23.0111C24.2489 23.2548 24.9536 22.9267 25.2137 22.2796C25.3518 21.9362 25.3424 21.5547 25.1875 21.2339C25.1781 21.2137 25.1669 21.1944 25.1548 21.1756C24.5772 19.9447 24.546 18.4959 25.0709 17.1903L25.3647 16.4595C25.4763 16.1819 25.3558 15.8717 25.0958 15.7672C24.8358 15.6626 24.5341 15.8031 24.4225 16.0807L24.1287 16.8115C23.4774 18.4316 23.526 20.2309 24.2616 21.7495L24.266 21.7581C24.2704 21.7667 24.2746 21.7748 24.2794 21.7832C24.2878 21.8131 24.2904 21.8538 24.2715 21.9008C24.2349 21.9919 24.1325 22.0396 24.0471 22.0053L13.6834 17.8388C13.5981 17.8045 13.5572 17.6992 13.5938 17.6081C13.6124 17.5618 13.6428 17.5335 13.6688 17.5175C13.6796 17.5148 13.6891 17.5115 13.6992 17.508L13.7057 17.5058C15.2868 16.9194 16.5683 15.6539 17.2196 14.0338L17.9717 12.163C18.7893 10.1293 21.0045 9.09831 22.9089 9.86389L22.9376 9.87522C22.9795 9.89156 23.0237 9.90882 23.0616 9.93228C23.2951 10.0792 23.617 9.99356 23.7697 9.73716C23.9224 9.48081 23.8533 9.15153 23.6148 9.00273C23.5216 8.94415 23.4137 8.89849 23.3132 8.85808C20.8894 7.88365 18.0701 9.19607 17.0295 11.7843L16.2774 13.6551C15.7528 14.96 14.7284 15.9836 13.461 16.4719C13.4385 16.477 13.4162 16.4836 13.3946 16.492C13.0605 16.6171 12.7897 16.8859 12.6516 17.2293C12.3915 17.8764 12.6729 18.601 13.279 18.8446L16.2008 20.0193C16.0265 21.206 16.6186 22.3745 17.7022 22.8101C18.786 23.2458 20.022 22.8123 20.7176 21.8351ZM19.7303 21.4382L17.1881 20.4162C17.2023 21.023 17.5441 21.5782 18.1066 21.8043C18.6691 22.0305 19.3001 21.8663 19.7303 21.4382Z"
        fill="#A5A5A7"
      />
      <path
        d="M25.6556 14.6897C27.0209 14.6897 28.1277 13.5829 28.1277 12.2176C28.1277 10.8523 27.0209 9.74552 25.6556 9.74552C24.2903 9.74552 23.1835 10.8523 23.1835 12.2176C23.1835 13.5829 24.2903 14.6897 25.6556 14.6897Z"
        fill="#A5A5A7"
      />
      <rect
        x="0.929688"
        y="1"
        width="39"
        height="29"
        rx="3.5"
        stroke="#DCDCDF"
      />
    </svg>
  );
}

export function AlertAssesment() {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.26462 12.7599L10.9238 13.829C11.4749 14.0505 12.1155 13.7522 12.3519 13.164C12.4774 12.8518 12.4689 12.505 12.3281 12.2133C12.3196 12.195 12.3094 12.1774 12.2984 12.1603C11.7733 11.0413 11.7449 9.72426 12.2221 8.53731L12.4892 7.87296C12.5907 7.62059 12.4811 7.33864 12.2447 7.2436C12.0084 7.14856 11.7342 7.27625 11.6327 7.52862L11.3656 8.19297C10.7735 9.66578 10.8176 11.3015 11.4864 12.6821L11.4904 12.6899C11.4944 12.6977 11.4982 12.7051 11.5026 12.7127C11.5103 12.7399 11.5126 12.7769 11.4954 12.8196C11.4621 12.9025 11.369 12.9458 11.2914 12.9146L1.86986 9.12691C1.79228 9.09572 1.7551 9 1.78839 8.91718C1.80531 8.8751 1.8329 8.84937 1.85662 8.83479C1.86643 8.83231 1.87504 8.82935 1.88423 8.82619L1.89016 8.82415C3.32749 8.29108 4.49247 7.14064 5.08457 5.66784L5.76831 3.96711C6.51159 2.11827 8.52544 1.18099 10.2566 1.87698L10.2828 1.88728C10.3208 1.90213 10.361 1.91782 10.3955 1.93915C10.6078 2.07272 10.9004 1.99486 11.0392 1.76177C11.1781 1.52872 11.1153 1.22937 10.8984 1.0941C10.8137 1.04084 10.7156 0.999337 10.6242 0.9626C8.42077 0.0767545 5.85773 1.26986 4.9118 3.62278L4.22807 5.32351C3.75116 6.50979 2.81982 7.44038 1.66768 7.88428C1.64724 7.8889 1.62698 7.89489 1.60727 7.90252C1.30357 8.01628 1.0574 8.26065 0.931893 8.57284C0.69541 9.16107 0.951258 9.81978 1.50225 10.0413L4.1584 11.1091C3.99998 12.188 4.5382 13.2502 5.52334 13.6463C6.50856 14.0424 7.63224 13.6482 8.26462 12.7599ZM7.36708 12.3991L5.05594 11.47C5.06885 12.0216 5.37959 12.5263 5.89094 12.7319C6.40229 12.9375 6.97594 12.7883 7.36708 12.3991Z"
        fill="#48B59C"
      />
      <path
        d="M12.7537 6.26403C13.9948 6.26403 15.001 5.25787 15.001 4.0167C15.001 2.77553 13.9948 1.76937 12.7537 1.76937C11.5125 1.76937 10.5063 2.77553 10.5063 4.0167C10.5063 5.25787 11.5125 6.26403 12.7537 6.26403Z"
        fill="#48B59C"
      />
    </svg>
  );
}

export function AlertAssesmentEdit() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2173 4.1361L10.9425 4.41089L7.91975 1.38813L8.19454 1.11334C8.74414 0.563746 9.49982 0.357649 10.2555 0.563746C11.0112 0.769844 11.5608 1.31944 11.7669 2.07513C11.973 2.83081 11.7669 3.5865 11.2173 4.1361ZM9.91202 5.44138L7.91975 7.43365L5.24049 10.1129C4.89699 10.4564 4.4848 10.6625 4.0726 10.7999L1.46204 11.4869C1.32464 11.5556 1.11855 11.4869 1.04985 11.4182C0.84375 11.2808 0.84375 11.0747 0.84375 10.9373L1.53074 8.32674C1.66814 7.91454 1.87424 7.50235 2.21773 7.15885L4.89699 4.47959L6.88926 2.48732L9.91202 5.44138Z"
        fill="#4DA493"
      />
    </svg>
  );
}

export function AlertAssesmentDelete() {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.43723 10.4415C1.43831 10.7776 1.56363 11.0996 1.78584 11.3372C2.00805 11.5749 2.30912 11.7089 2.62337 11.71H7.36958C7.68455 11.71 7.98667 11.5765 8.20977 11.3388C8.43286 11.101 8.55874 10.7784 8.55983 10.4415V2.82791H1.43723V10.4415ZM9.14921 0.924727H7.07243L6.47977 0.290039H3.51318L2.92052 0.924727H0.84375V2.19323H9.14921V0.924727Z"
        fill="#4DA493"
      />
    </svg>
  );
}

export function AlertAssesmentDividerBtn() {
  return (
    <svg
      width="2"
      height="32"
      viewBox="0 0 2 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.84375"
        width="1"
        height="32"
        rx="0.5"
        fill="#73C7B7"
        fill-opacity="0.2"
      />
    </svg>
  );
}

export function AlerteAssesmentClose() {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.30593 4.50573L8.86083 0.970251C9.03126 0.801546 9.03126 0.528424 8.86083 0.360151C8.69083 0.191445 8.41468 0.191445 8.24469 0.360151L4.69281 3.89261L1.10815 0.307511C0.938148 0.13708 0.662006 0.13708 0.492007 0.307511C0.322007 0.478374 0.322007 0.754947 0.492007 0.925378L4.07408 4.50788L0.479062 8.08306C0.309063 8.25176 0.309063 8.52488 0.479062 8.69316C0.649062 8.86186 0.925204 8.86186 1.0952 8.69316L4.6872 5.12101L8.25763 8.69186C8.42763 8.8623 8.70377 8.8623 8.87377 8.69186C9.04377 8.521 9.04377 8.24443 8.87377 8.074L5.30593 4.50573Z"
        fill="#121313"
      />
    </svg>
  );
}

export function SvgLoadingForButton({ textColor = "arh-text-white" } = {}) {
  return (
    <svg
      aria-hidden="true"
      role="status"
      className={`arh-mr-3 arh-inline arh-h-4 arh-w-4 arh-animate-spin ${textColor}`}
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="#E5E7EB"
      ></path>
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentColor"
      ></path>
    </svg>
  );
}

export function SvgMenu() {
  return (
    <svg
      width="25"
      height="11"
      viewBox="0 0 25 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 10H25"
        stroke="#1A1B2D"
        strokeWidth="2"
      />
      <path
        d="M0 1H25"
        stroke="#1A1B2D"
        strokeWidth="2"
      />
    </svg>
  );
}

export function SvgNotificationRing() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="notification-bell"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
    >
      <path
        d="M6.02636 18.4751C4.6236 17.9111 3.97597 16.2215 4.58413 14.7088C4.70588 14.4059 5.03272 14.2518 5.3137 14.3648C5.59467 14.4777 5.72389 14.8152 5.60214 15.1181C5.23716 16.0259 5.62593 17.0395 6.46748 17.3778C7.30903 17.7162 8.29121 17.2537 8.65619 16.3459C8.77794 16.043 9.10478 15.8889 9.38576 16.0019C9.66673 16.1148 9.79595 16.4523 9.6742 16.7551C9.06604 18.2679 7.42924 19.0391 6.02636 18.4751Z"
        fill="#11142D"
      />
      <path
        d="M12.5073 18.6943L1.20148 14.1491C0.540289 13.8833 0.233272 13.0928 0.517051 12.387C0.667663 12.0123 0.963068 11.7191 1.3275 11.5826C1.35115 11.5734 1.37547 11.5662 1.39999 11.5607C2.78256 11.028 3.90017 9.91128 4.47246 8.48775L5.29295 6.44687C6.42806 3.62337 9.50371 2.19164 12.1479 3.25466C12.2575 3.29874 12.3752 3.34855 12.4769 3.41246C12.7371 3.57478 12.8125 3.934 12.6458 4.21366C12.4793 4.49337 12.1281 4.58681 11.8734 4.42652C11.8223 4.39497 11.7609 4.3737 11.7067 4.35191C9.62931 3.51673 7.21268 4.64146 6.32075 6.86007L5.50026 8.90095C4.78974 10.6683 3.39176 12.0488 1.66697 12.6885C1.65313 12.6932 1.64099 12.6977 1.62672 12.7013C1.59826 12.7188 1.56515 12.7497 1.54485 12.8002C1.5049 12.8995 1.54951 13.0144 1.64261 13.0518L12.9484 17.597C13.0416 17.6345 13.1533 17.5825 13.1933 17.4831C13.2139 17.4318 13.2111 17.3874 13.2019 17.3548C13.1948 17.3426 13.1892 17.331 13.1824 17.318C12.38 15.6614 12.327 13.6985 13.0375 11.9311L13.358 11.1339C13.4798 10.831 13.8088 10.6778 14.0925 10.7919C14.3762 10.9059 14.5076 11.2442 14.3858 11.5471L14.0653 12.3443C13.4927 13.7686 13.5267 15.3491 14.1569 16.6919C14.17 16.7124 14.1823 16.7335 14.1925 16.7555C14.3615 17.1056 14.3717 17.5217 14.2211 17.8963C13.9373 18.6022 13.1686 18.9602 12.5073 18.6943Z"
        fill="#11142D"
      />
      <circle
        cx="14.7027"
        cy="6.91946"
        r="2.6968"
        fill="#F55611"
      />
    </svg>
  );
}

export function SvgNotification() {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.77658 15.8919C5.18008 17.3758 5.90181 19.0678 7.38564 19.6643C8.86946 20.2608 10.5615 19.5391 11.158 18.0553C11.261 17.7992 11.1367 17.5078 10.8806 17.4049C10.6245 17.3019 10.3331 17.4262 10.2302 17.6823C9.83961 18.6539 8.73023 19.1271 7.75862 18.7365C6.78702 18.3459 6.31383 17.2365 6.70441 16.2649C6.80737 16.0088 6.6831 15.7175 6.42699 15.6145C6.17088 15.5116 5.87953 15.6358 5.77658 15.8919Z"
        fill="#37474F"
        stroke="#37474F"
        strokeWidth="0.2"
      />
      <path
        d="M2.04112 12.463L2.04051 12.4632C1.67961 12.5851 1.39179 12.8572 1.24989 13.2101C0.982523 13.8752 1.30609 14.6338 1.97119 14.9012L14.5898 19.9738C15.2556 20.2415 16.0135 19.9176 16.2808 19.2525C16.4229 18.8992 16.4031 18.5037 16.2234 18.1586L16.2231 18.158C15.4683 16.7327 15.3806 15.0574 15.9822 13.5608L16.8887 11.3058C18.0611 8.38941 16.6425 5.0635 13.7261 3.89112C10.8097 2.71873 7.48379 4.13735 6.31141 7.05375L5.4049 9.30877C4.8036 10.8045 3.58052 11.9537 2.04112 12.463ZM7.23924 7.42674C8.20602 5.02182 10.9482 3.85218 13.3531 4.81895C15.758 5.78573 16.9277 8.5279 15.9609 10.9328L15.0544 13.1878C14.3431 14.9572 14.4473 16.9398 15.3407 18.6291C15.3812 18.7068 15.3856 18.7984 15.353 18.8796C15.2912 19.0332 15.1164 19.1078 14.9628 19.046L2.34418 13.9734C2.19056 13.9116 2.11597 13.7368 2.17773 13.5831C2.21019 13.5024 2.27659 13.439 2.36385 13.4098C4.17487 12.8102 5.62118 11.4518 6.33273 9.68176L7.23924 7.42674Z"
        fill="#37474F"
        stroke="#37474F"
        strokeWidth="0.2"
      />
    </svg>
  );
}

export function SvgCoolIcon() {
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.02813 11.657L0.078125 6.70702L1.49213 5.29302L5.02963 8.82652L5.02813 8.82802L13.5131 0.343018L14.9271 1.75702L6.44213 10.243L5.02913 11.656L5.02813 11.657Z"
        fill="#2E3A59"
      />
    </svg>
  );
}

export function SvgListNotConnected() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_21205_2764)">
        <path
          d="M7.4974 3.33341V1.66675M12.4974 16.6667V18.3334M3.33073 7.50008H1.66406M16.6641 12.5001H18.3307M4.09257 4.09526L2.91406 2.91675M15.9022 15.9049L17.0807 17.0834M9.9974 14.7141L8.22963 16.4819C6.92788 17.7836 4.81733 17.7836 3.51558 16.4819C2.21384 15.1801 2.21384 13.0696 3.51558 11.7678L5.28335 10.0001M14.7114 10.0001L16.4792 8.23231C17.781 6.93057 17.781 4.82002 16.4792 3.51827C15.1775 2.21652 13.0669 2.21652 11.7652 3.51827L9.9974 5.28604"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_21205_2764">
          <rect
            width="20"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgStatSalary() {
  return (
    <svg
      width="23"
      height="21"
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2578 15C11.2578 17.7614 13.4964 20 16.2578 20C19.0192 20 21.2578 17.7614 21.2578 15C21.2578 12.2386 19.0192 10 16.2578 10C13.4964 10 11.2578 12.2386 11.2578 15ZM11.2578 15C11.2578 13.8742 11.6299 12.8353 12.2578 11.9995V3M11.2578 15C11.2578 15.8254 11.4578 16.604 11.8119 17.2901C10.9695 18.0018 9.02366 18.5 6.75781 18.5C3.72025 18.5 1.25781 17.6046 1.25781 16.5V3M12.2578 3C12.2578 4.10457 9.79538 5 6.75781 5C3.72025 5 1.25781 4.10457 1.25781 3M12.2578 3C12.2578 1.89543 9.79538 1 6.75781 1C3.72025 1 1.25781 1.89543 1.25781 3M1.25781 12C1.25781 13.1046 3.72025 14 6.75781 14C8.94681 14 10.8371 13.535 11.7225 12.8618M12.2578 7.5C12.2578 8.60457 9.79538 9.5 6.75781 9.5C3.72025 9.5 1.25781 8.60457 1.25781 7.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgStatHoliday() {
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2578 5C15.2578 4.07003 15.2578 3.60504 15.1556 3.22354C14.8782 2.18827 14.0695 1.37962 13.0343 1.10222C12.6528 1 12.1878 1 11.2578 1C10.3278 1 9.86286 1 9.48136 1.10222C8.44608 1.37962 7.63744 2.18827 7.36003 3.22354C7.25781 3.60504 7.25781 4.07003 7.25781 5M12.0578 15.5H16.9578C17.2378 15.5 17.3779 15.5 17.4848 15.4455C17.5789 15.3976 17.6554 15.3211 17.7033 15.227C17.7578 15.12 17.7578 14.98 17.7578 14.7V12.3C17.7578 12.02 17.7578 11.88 17.7033 11.773C17.6554 11.6789 17.5789 11.6024 17.4848 11.5545C17.3779 11.5 17.2378 11.5 16.9578 11.5H12.0578C11.7778 11.5 11.6378 11.5 11.5308 11.5545C11.4367 11.6024 11.3602 11.6789 11.3123 11.773C11.2578 11.88 11.2578 12.02 11.2578 12.3V14.7C11.2578 14.98 11.2578 15.12 11.3123 15.227C11.3602 15.3211 11.4367 15.3976 11.5308 15.4455C11.6378 15.5 11.7778 15.5 12.0578 15.5ZM6.05781 19H16.4578C18.138 19 18.978 19 19.6198 18.673C20.1843 18.3854 20.6432 17.9265 20.9308 17.362C21.2578 16.7202 21.2578 15.8802 21.2578 14.2V9.8C21.2578 8.11984 21.2578 7.27976 20.9308 6.63803C20.6432 6.07354 20.1843 5.6146 19.6198 5.32698C18.978 5 18.138 5 16.4578 5H6.05781C4.37766 5 3.53758 5 2.89584 5.32698C2.33135 5.6146 1.87241 6.07354 1.58479 6.63803C1.25781 7.27976 1.25781 8.11984 1.25781 9.8V14.2C1.25781 15.8802 1.25781 16.7202 1.58479 17.362C1.87241 17.9265 2.33135 18.3854 2.89584 18.673C3.53758 19 4.37766 19 6.05781 19Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgStatEmployees() {
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2578 19L21.2578 16M21.2578 16L18.2578 13M21.2578 16H15.2578M14.7578 1.29076C16.2237 1.88415 17.2578 3.32131 17.2578 5C17.2578 6.67869 16.2237 8.11585 14.7578 8.70924M11.2578 13H7.25781C5.39405 13 4.46216 13 3.72708 13.3045C2.74697 13.7105 1.96827 14.4892 1.56229 15.4693C1.25781 16.2044 1.25781 17.1362 1.25781 19M12.7578 5C12.7578 7.20914 10.967 9 8.75781 9C6.54867 9 4.75781 7.20914 4.75781 5C4.75781 2.79086 6.54867 1 8.75781 1C10.967 1 12.7578 2.79086 12.7578 5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgStatPersonnalComposition() {
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25781 13.5H6.75782C5.36225 13.5 4.66447 13.5 4.09667 13.6722C2.81827 14.06 1.81785 15.0605 1.43005 16.3389C1.25781 16.9067 1.25781 17.6044 1.25781 19M13.7578 5.5C13.7578 7.98528 11.7431 10 9.25781 10C6.77253 10 4.75781 7.98528 4.75781 5.5C4.75781 3.01472 6.77253 1 9.25781 1C11.7431 1 13.7578 3.01472 13.7578 5.5ZM10.2578 19L13.3592 18.1139C13.5077 18.0715 13.5819 18.0502 13.6512 18.0184C13.7127 17.9902 13.7712 17.9558 13.8257 17.9158C13.8872 17.8707 13.9418 17.8161 14.051 17.7068L20.5079 11.25C21.1982 10.5597 21.1982 9.44034 20.5078 8.74997C19.8175 8.05963 18.6982 8.05964 18.0078 8.74999L11.551 15.2068C11.4418 15.3161 11.3872 15.3707 11.3421 15.4321C11.302 15.4866 11.2676 15.5451 11.2394 15.6066C11.2076 15.6759 11.1863 15.7501 11.1439 15.8987L10.2578 19Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgStatPersonnalRepartition() {
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2578 16L17.2578 18L21.2578 14M11.2578 13H7.25781C5.39405 13 4.46216 13 3.72708 13.3045C2.74697 13.7105 1.96827 14.4892 1.56229 15.4693C1.25781 16.2044 1.25781 17.1362 1.25781 19M14.7578 1.29076C16.2237 1.88415 17.2578 3.32131 17.2578 5C17.2578 6.67869 16.2237 8.11585 14.7578 8.70924M12.7578 5C12.7578 7.20914 10.967 9 8.75781 9C6.54867 9 4.75781 7.20914 4.75781 5C4.75781 2.79086 6.54867 1 8.75781 1C10.967 1 12.7578 2.79086 12.7578 5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgStatunavailability() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.1025 6.5349L18.8256 6.4977V4.06151M7.33872 22.4998C3.91974 22.4998 1 21.9754 1 19.8752C1 17.775 3.90121 15.8362 7.33872 15.8362C10.7577 15.8362 13.6774 17.7562 13.6774 19.8564C13.6774 21.9557 10.7762 22.4998 7.33872 22.4998ZM7.33488 12.9264C9.57856 12.9264 11.3971 11.134 11.3971 8.92247C11.3971 6.71097 9.57856 4.9177 7.33488 4.9177C5.09119 4.9177 3.27183 6.71097 3.27183 8.92247C3.26425 11.1265 5.07014 12.9189 7.30625 12.9264C7.31635 12.9264 7.32562 12.9264 7.33488 12.9264ZM23.6442 6.14923C23.6442 8.71661 21.5629 10.7985 18.995 10.7985C16.4276 10.7985 14.3457 8.71661 14.3457 6.14923C14.3457 3.58135 16.4276 1.5 18.995 1.5C21.5629 1.5 23.6442 3.58135 23.6442 6.14923Z"
        stroke="#130F26"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgStatHealth() {
  return (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7578 9.5H13.7578L12.2578 12.5L10.2578 6.5L8.75781 9.5H7.75781M11.251 3.13581C9.25161 0.7984 5.91756 0.169643 3.41251 2.31001C0.907456 4.45038 0.55478 8.02898 2.52201 10.5604C4.0079 12.4724 8.22911 16.311 10.2058 18.0749C10.5692 18.3991 10.7509 18.5613 10.9636 18.6251C11.1483 18.6805 11.3536 18.6805 11.5383 18.6251C11.751 18.5613 11.9327 18.3991 12.2961 18.0749C14.2728 16.311 18.494 12.4724 19.9799 10.5604C21.9471 8.02898 21.6375 4.42787 19.0894 2.31001C16.5413 0.192157 13.2503 0.7984 11.251 3.13581Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgSortBy() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        width="24"
        height="24"
        rx="5"
        transform="rotate(0.5 1 0)"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0389 10.088C10.5383 10.0836 10.2617 9.51012 10.5158 9.07564L12.4119 6.92735C12.6661 6.49286 13.2605 6.49805 13.4757 6.93663L15.3341 9.11769C15.5806 9.55654 15.2628 10.1248 14.7934 10.1207L11.0389 10.088Z"
        fill="#292929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.758 14.1205C15.2586 14.1249 15.5352 14.6984 15.2811 15.1329L13.3849 17.2811C13.1308 17.7156 12.5363 17.7104 12.3211 17.2719L10.4628 15.0908C10.2163 14.652 10.5341 14.0837 11.0034 14.0878L14.758 14.1205Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgReenvoieEmailActive() {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.96266 4.53046L3.25119 4.49848L6.03001 1.79393L6.10363 1.72228L6.03002 1.65062L5.28816 0.92835L5.21841 0.860446L5.14865 0.928337L0.930255 5.03385L0.856627 5.10551L0.930249 5.17717L5.22188 9.35457L5.29162 9.42246L5.36137 9.35457L6.1035 8.6323L6.17712 8.56065L6.10352 8.48899L3.25882 5.71951L9.33277 5.74806V5.75202H9.43277H10.1872C12.2095 5.75202 13.851 7.35304 13.851 9.31545C13.851 11.2772 12.2095 12.8784 10.1872 12.8784H1H0.9V12.9784V14V14.1H1H10.1866C12.8935 14.1 15.1 11.9564 15.1 9.31545C15.1 6.674 12.8935 4.53046 10.1866 4.53046H9.96293H9.96266Z"
        fill="#FFFFFF"
        stroke="#FFFFFF"
        strokeWidth="0.2"
      />
    </svg>
  );
}

export function SvgReenvoieEmailNotActive() {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.96266 4.53046L3.25119 4.49848L6.03001 1.79393L6.10363 1.72228L6.03002 1.65062L5.28816 0.92835L5.21841 0.860446L5.14865 0.928337L0.930255 5.03385L0.856627 5.10551L0.930249 5.17717L5.22188 9.35457L5.29162 9.42246L5.36137 9.35457L6.1035 8.6323L6.17712 8.56065L6.10352 8.48899L3.25882 5.71951L9.33277 5.74806V5.75202H9.43277H10.1872C12.2095 5.75202 13.851 7.35304 13.851 9.31545C13.851 11.2772 12.2095 12.8784 10.1872 12.8784H1H0.9V12.9784V14V14.1H1H10.1866C12.8935 14.1 15.1 11.9564 15.1 9.31545C15.1 6.674 12.8935 4.53046 10.1866 4.53046H9.96293H9.96266Z"
        fill="#BDBDBD"
        stroke="#BDBDBD"
        strokeWidth="0.2"
      />
    </svg>
  );
}

export function IconesFilterMobile({ color = "#4CA090" } = {}) {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.875 3.83334L10.375 3.83334M10.375 3.83334C10.375 5.14502 11.4383 6.20834 12.75 6.20834C14.0617 6.20834 15.125 5.14502 15.125 3.83334C15.125 2.52167 14.0617 1.45834 12.75 1.45834C11.4383 1.45834 10.375 2.52167 10.375 3.83334ZM5.625 10.1667L15.125 10.1667M5.625 10.1667C5.625 11.4784 4.56168 12.5417 3.25 12.5417C1.93832 12.5417 0.875 11.4784 0.875 10.1667C0.875 8.855 1.93832 7.79168 3.25 7.79168C4.56168 7.79168 5.625 8.855 5.625 10.1667Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgBookOpen() {
  return (
    <svg
      width="19"
      height="15"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.4974 14.1663H3.83073C2.89731 14.1663 2.4306 14.1663 2.07408 13.9847C1.76047 13.8249 1.50551 13.5699 1.34572 13.2563C1.16406 12.8998 1.16406 12.4331 1.16406 11.4997V3.49967C1.16406 2.56625 1.16406 2.09954 1.34572 1.74302C1.50551 1.42942 1.76047 1.17445 2.07408 1.01466C2.4306 0.833008 2.89731 0.833008 3.83073 0.833008H4.16406C6.0309 0.833008 6.96433 0.833008 7.67736 1.19632C8.30457 1.5159 8.81451 2.02583 9.13408 2.65304C9.4974 3.36608 9.4974 4.2995 9.4974 6.16634M9.4974 14.1663V6.16634M9.4974 14.1663H15.1641C16.0975 14.1663 16.5642 14.1663 16.9207 13.9847C17.2343 13.8249 17.4893 13.5699 17.6491 13.2563C17.8307 12.8998 17.8307 12.4331 17.8307 11.4997V3.49967C17.8307 2.56625 17.8307 2.09954 17.6491 1.74302C17.4893 1.42942 17.2343 1.17445 16.9207 1.01466C16.5642 0.833008 16.0975 0.833008 15.1641 0.833008H14.8307C12.9639 0.833008 12.0305 0.833008 11.3174 1.19632C10.6902 1.5159 10.1803 2.02583 9.86071 2.65304C9.4974 3.36608 9.4974 4.2995 9.4974 6.16634"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgBookOpen2() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 20H5.2C4.07989 20 3.51984 20 3.09202 19.782C2.71569 19.5903 2.40973 19.2843 2.21799 18.908C2 18.4802 2 17.9201 2 16.8V7.2C2 6.07989 2 5.51984 2.21799 5.09202C2.40973 4.71569 2.71569 4.40973 3.09202 4.21799C3.51984 4 4.07989 4 5.2 4H5.6C7.84021 4 8.96031 4 9.81596 4.43597C10.5686 4.81947 11.1805 5.43139 11.564 6.18404C12 7.03968 12 8.15979 12 10.4M12 20V10.4M12 20H18.8C19.9201 20 20.4802 20 20.908 19.782C21.2843 19.5903 21.5903 19.2843 21.782 18.908C22 18.4802 22 17.9201 22 16.8V7.2C22 6.07989 22 5.51984 21.782 5.09202C21.5903 4.71569 21.2843 4.40973 20.908 4.21799C20.4802 4 19.9201 4 18.8 4H18.4C16.1598 4 15.0397 4 14.184 4.43597C13.4314 4.81947 12.8195 5.43139 12.436 6.18404C12 7.03968 12 8.15979 12 10.4"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgPaperDownload() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1693 9.16699H7.16927M8.83594 12.5003H7.16927M13.8359 5.83366H7.16927M17.1693 8.75033V5.66699C17.1693 4.26686 17.1693 3.5668 16.8968 3.03202C16.6571 2.56161 16.2747 2.17916 15.8042 1.93948C15.2695 1.66699 14.5694 1.66699 13.1693 1.66699H7.83594C6.43581 1.66699 5.73574 1.66699 5.20096 1.93948C4.73056 2.17916 4.3481 2.56161 4.10842 3.03202C3.83594 3.5668 3.83594 4.26686 3.83594 5.66699V14.3337C3.83594 15.7338 3.83594 16.4339 4.10842 16.9686C4.3481 17.439 4.73056 17.8215 5.20096 18.0612C5.73574 18.3337 6.43581 18.3337 7.83594 18.3337H10.0859M18.8359 18.3337L17.5859 17.0837M18.4193 15.0003C18.4193 16.6112 17.1134 17.917 15.5026 17.917C13.8918 17.917 12.5859 16.6112 12.5859 15.0003C12.5859 13.3895 13.8918 12.0837 15.5026 12.0837C17.1134 12.0837 18.4193 13.3895 18.4193 15.0003Z"
        stroke="#48B19D"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgUserAvatar() {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.29074 44.596C10.8116 41.013 14.3623 38.5 18.5 38.5H33.5C37.6377 38.5 41.1884 41.013 42.7093 44.596M36 19.75C36 25.2728 31.5228 29.75 26 29.75C20.4772 29.75 16 25.2728 16 19.75C16 14.2272 20.4772 9.75 26 9.75C31.5228 9.75 36 14.2272 36 19.75ZM51 26C51 39.8071 39.8071 51 26 51C12.1929 51 1 39.8071 1 26C1 12.1929 12.1929 1 26 1C39.8071 1 51 12.1929 51 26Z"
        stroke="#808D93"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgAlertCircle() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#FFDF6B"
      />
      <path
        d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#7A6417"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgAffinities() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.54186 3.25015C0.974606 2.61616 0.690978 2.29917 0.680279 2.02976C0.670986 1.79573 0.771557 1.57079 0.952165 1.42167C1.16007 1.25 1.58543 1.25 2.43615 1.25H13.5683C14.4191 1.25 14.8444 1.25 15.0523 1.42167C15.2329 1.57079 15.3335 1.79573 15.3242 2.02976C15.3135 2.29917 15.0299 2.61616 14.4626 3.25015L10.183 8.03332C10.0699 8.1597 10.0133 8.22289 9.97303 8.29481C9.93728 8.35859 9.91104 8.42726 9.89516 8.49863C9.87725 8.57911 9.87725 8.6639 9.87725 8.83348V12.8438C9.87725 12.9905 9.87725 13.0638 9.8536 13.1272C9.83269 13.1832 9.7987 13.2334 9.75444 13.2736C9.70436 13.3192 9.63627 13.3464 9.50009 13.4009L6.95009 14.4209C6.67443 14.5311 6.5366 14.5863 6.42596 14.5633C6.3292 14.5432 6.24429 14.4857 6.18969 14.4033C6.12725 14.3091 6.12725 14.1607 6.12725 13.8638V8.83348C6.12725 8.6639 6.12725 8.57911 6.10934 8.49863C6.09346 8.42726 6.06722 8.35859 6.03147 8.29481C5.99115 8.22289 5.93462 8.1597 5.82154 8.03332L1.54186 3.25015Z"
        stroke="#F55611"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgAlertHolidayCircle() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 4V6M6 8H6.005M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
        stroke="#F55611"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgBriefCase() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3307 6.33333C13.3307 5.55836 13.3307 5.17087 13.2455 4.85295C13.0144 3.99022 12.3405 3.31635 11.4778 3.08519C11.1599 3 10.7724 3 9.9974 3C9.22242 3 8.83493 3 8.51702 3.08519C7.65429 3.31635 6.98042 3.99022 6.74925 4.85295C6.66406 5.17087 6.66406 5.55836 6.66406 6.33333M4.33073 18H15.6641C16.5975 18 17.0642 18 17.4207 17.8183C17.7343 17.6586 17.9893 17.4036 18.1491 17.09C18.3307 16.7335 18.3307 16.2668 18.3307 15.3333V9C18.3307 8.06658 18.3307 7.59987 18.1491 7.24335C17.9893 6.92975 17.7343 6.67478 17.4207 6.51499C17.0642 6.33333 16.5975 6.33333 15.6641 6.33333H4.33073C3.39731 6.33333 2.9306 6.33333 2.57408 6.51499C2.26047 6.67478 2.00551 6.92975 1.84572 7.24335C1.66406 7.59987 1.66406 8.06658 1.66406 9V15.3333C1.66406 16.2668 1.66406 16.7335 1.84572 17.09C2.00551 17.4036 2.26047 17.6586 2.57408 17.8183C2.9306 18 3.39731 18 4.33073 18Z"
        stroke="black"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgClipBoard() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3359 3.83366C14.1109 3.83366 14.4984 3.83366 14.8163 3.91884C15.679 4.15001 16.3529 4.82388 16.5841 5.68661C16.6693 6.00453 16.6693 6.39202 16.6693 7.16699V14.8337C16.6693 16.2338 16.6693 16.9339 16.3968 17.4686C16.1571 17.939 15.7747 18.3215 15.3042 18.5612C14.7695 18.8337 14.0694 18.8337 12.6693 18.8337H7.33594C5.93581 18.8337 5.23574 18.8337 4.70096 18.5612C4.23056 18.3215 3.8481 17.939 3.60842 17.4686C3.33594 16.9339 3.33594 16.2338 3.33594 14.8337V7.16699C3.33594 6.39202 3.33594 6.00453 3.42112 5.68661C3.65229 4.82388 4.32616 4.15001 5.18889 3.91884C5.50681 3.83366 5.89429 3.83366 6.66927 3.83366M8.0026 5.50033H12.0026C12.4693 5.50033 12.7027 5.50033 12.8809 5.4095C13.0377 5.3296 13.1652 5.20212 13.2451 5.04532C13.3359 4.86706 13.3359 4.6337 13.3359 4.16699V3.50033C13.3359 3.03362 13.3359 2.80026 13.2451 2.622C13.1652 2.4652 13.0377 2.33771 12.8809 2.25782C12.7027 2.16699 12.4693 2.16699 12.0026 2.16699H8.0026C7.53589 2.16699 7.30254 2.16699 7.12428 2.25782C6.96748 2.33771 6.83999 2.4652 6.7601 2.622C6.66927 2.80026 6.66927 3.03362 6.66927 3.50033V4.16699C6.66927 4.6337 6.66927 4.86706 6.7601 5.04532C6.83999 5.20212 6.96748 5.3296 7.12428 5.4095C7.30254 5.50033 7.53589 5.50033 8.0026 5.50033Z"
        stroke="black"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgHairPin() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.63 9.58247L10.117 17.0955C8.40849 18.804 5.63839 18.804 3.92985 17.0955C2.2213 15.3869 2.2213 12.6168 3.92985 10.9083L11.4429 3.39529C12.5819 2.25626 14.4286 2.25626 15.5676 3.39529C16.7067 4.53432 16.7067 6.38105 15.5676 7.52008L8.34926 14.7385C7.77975 15.308 6.85638 15.308 6.28687 14.7385C5.71735 14.1689 5.71735 13.2456 6.28687 12.6761L12.6214 6.34157"
        stroke="black"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgFileLock() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6693 8.33366V5.66699C16.6693 4.26686 16.6693 3.5668 16.3968 3.03202C16.1571 2.56161 15.7747 2.17916 15.3042 1.93948C14.7695 1.66699 14.0694 1.66699 12.6693 1.66699H7.33594C5.93581 1.66699 5.23574 1.66699 4.70096 1.93948C4.23056 2.17916 3.8481 2.56161 3.60842 3.03202C3.33594 3.5668 3.33594 4.26686 3.33594 5.66699V14.3337C3.33594 15.7338 3.33594 16.4339 3.60842 16.9686C3.8481 17.439 4.23056 17.8215 4.70096 18.0612C5.23574 18.3337 5.93581 18.3337 7.33594 18.3337H8.7526M10.8359 9.16699H6.66927M9.16927 12.5003H6.66927M13.3359 5.83366H6.66927M16.0443 14.167V12.7087C16.0443 11.9032 15.3914 11.2503 14.5859 11.2503C13.7805 11.2503 13.1276 11.9032 13.1276 12.7087V14.167M13.0026 17.5003H16.1693C16.636 17.5003 16.8693 17.5003 17.0476 17.4095C17.2044 17.3296 17.3319 17.2021 17.4118 17.0453C17.5026 16.8671 17.5026 16.6337 17.5026 16.167V15.5003C17.5026 15.0336 17.5026 14.8003 17.4118 14.622C17.3319 14.4652 17.2044 14.3377 17.0476 14.2578C16.8693 14.167 16.636 14.167 16.1693 14.167H13.0026C12.5359 14.167 12.3025 14.167 12.1243 14.2578C11.9675 14.3377 11.84 14.4652 11.7601 14.622C11.6693 14.8003 11.6693 15.0336 11.6693 15.5003V16.167C11.6693 16.6337 11.6693 16.8671 11.7601 17.0453C11.84 17.2021 11.9675 17.3296 12.1243 17.4095C12.3025 17.5003 12.5359 17.5003 13.0026 17.5003Z"
        stroke="black"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgFileBold() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6693 1.89154V5.33366C11.6693 5.80037 11.6693 6.03372 11.7601 6.21198C11.84 6.36879 11.9675 6.49627 12.1243 6.57616C12.3025 6.66699 12.5359 6.66699 13.0026 6.66699H16.4447M16.6693 8.32385V14.3337C16.6693 15.7338 16.6693 16.4339 16.3968 16.9686C16.1571 17.439 15.7747 17.8215 15.3042 18.0612C14.7695 18.3337 14.0694 18.3337 12.6693 18.3337H7.33594C5.93581 18.3337 5.23574 18.3337 4.70096 18.0612C4.23056 17.8215 3.8481 17.439 3.60842 16.9686C3.33594 16.4339 3.33594 15.7338 3.33594 14.3337V5.66699C3.33594 4.26686 3.33594 3.5668 3.60842 3.03202C3.8481 2.56161 4.23056 2.17916 4.70096 1.93948C5.23574 1.66699 5.93581 1.66699 7.33594 1.66699H10.0124C10.6239 1.66699 10.9296 1.66699 11.2173 1.73607C11.4724 1.79731 11.7163 1.89832 11.94 2.03539C12.1923 2.19 12.4085 2.40619 12.8408 2.83857L15.4977 5.49542C15.9301 5.9278 16.1463 6.14399 16.3009 6.39628C16.4379 6.61996 16.539 6.86382 16.6002 7.11891C16.6693 7.40663 16.6693 7.71237 16.6693 8.32385Z"
        stroke="black"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgUserEdit() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 13.5H6.5C5.10444 13.5 4.40665 13.5 3.83886 13.6722C2.56045 14.06 1.56004 15.0605 1.17224 16.3389C1 16.9067 1 17.6044 1 19M13.5 5.5C13.5 7.98528 11.4853 10 9 10C6.51472 10 4.5 7.98528 4.5 5.5C4.5 3.01472 6.51472 1 9 1C11.4853 1 13.5 3.01472 13.5 5.5ZM10 19L13.1014 18.1139C13.2499 18.0715 13.3241 18.0502 13.3934 18.0184C13.4549 17.9902 13.5134 17.9558 13.5679 17.9158C13.6293 17.8707 13.6839 17.8161 13.7932 17.7068L20.25 11.25C20.9404 10.5597 20.9404 9.44034 20.25 8.74997C19.5597 8.05963 18.4404 8.05964 17.75 8.74999L11.2932 15.2068C11.1839 15.3161 11.1293 15.3707 11.0842 15.4321C11.0442 15.4866 11.0098 15.5451 10.9816 15.6066C10.9497 15.6759 10.9285 15.7501 10.8861 15.8987L10 19Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgUserEditOthers() {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 13H7C5.13623 13 4.20435 13 3.46927 13.3045C2.48915 13.7105 1.71046 14.4892 1.30448 15.4693C1 16.2044 1 17.1362 1 19M14.5 1.29076C15.9659 1.88415 17 3.32131 17 5M10.9999 19.5L13.025 19.095C13.2015 19.0597 13.2898 19.042 13.3721 19.0097C13.4452 18.9811 13.5147 18.9439 13.579 18.899C13.6516 18.8484 13.7152 18.7848 13.8426 18.6574L20.5 12C21.0524 11.4477 21.0523 10.5523 20.5 9.99997C19.9477 9.4477 19.0523 9.44771 18.5 9.99999L11.8425 16.6575C11.7152 16.7848 11.6516 16.8484 11.601 16.921C11.5561 16.9853 11.5189 17.0548 11.4902 17.1278C11.458 17.2102 11.4403 17.2984 11.405 17.475L10.9999 19.5ZM12.5 5C12.5 7.20914 10.7091 9 8.5 9C6.29086 9 4.5 7.20914 4.5 5C4.5 2.79086 6.29086 1 8.5 1C10.7091 1 12.5 2.79086 12.5 5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgUserEmploye() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 19V17C21 15.1362 19.7252 13.5701 18 13.126M14.5 1.29076C15.9659 1.88415 17 3.32131 17 5C17 6.67869 15.9659 8.11585 14.5 8.70924M16 19C16 17.1362 16 16.2044 15.6955 15.4693C15.2895 14.4892 14.5108 13.7105 13.5307 13.3045C12.7956 13 11.8638 13 10 13H7C5.13623 13 4.20435 13 3.46927 13.3045C2.48915 13.7105 1.71046 14.4892 1.30448 15.4693C1 16.2044 1 17.1362 1 19M12.5 5C12.5 7.20914 10.7091 9 8.5 9C6.29086 9 4.5 7.20914 4.5 5C4.5 2.79086 6.29086 1 8.5 1C10.7091 1 12.5 2.79086 12.5 5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgEmployeeNotesEdit() {
  return (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="30" height="30" rx="5.5" fill="#E6F8EF" />
      <rect x="0.5" y="0.5" width="30" height="30" rx="5.5" stroke="#73C7B7" />
      <path
        d="M19.0091 9.65199L20.1773 8.48386C20.8224 7.83871 21.8684 7.83871 22.5135 8.48386C23.1587 9.129 23.1587 10.175 22.5135 10.8201L21.3454 11.9883M19.0091 9.65199L14.6476 14.0135C13.7765 14.8846 13.3409 15.3202 13.0444 15.8509C12.7478 16.3817 12.4494 17.6349 12.1641 18.8333C13.3625 18.548 14.6157 18.2496 15.1465 17.953C15.6772 17.6564 16.1128 17.2209 16.9839 16.3498L21.3454 11.9883M19.0091 9.65199L21.3454 11.9883"
        stroke="#357569"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 15.5C23 19.0355 23 20.8033 21.9016 21.9016C20.8033 23 19.0355 23 15.5 23C11.9645 23 10.1967 23 9.09835 21.9016C8 20.8033 8 19.0355 8 15.5C8 11.9645 8 10.1967 9.09835 9.09835C10.1967 8 11.9645 8 15.5 8"
        stroke="#357569"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function SvgNotificationText() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V13M13 17H7M15 13H7M20.1213 3.87868C21.2929 5.05025 21.2929 6.94975 20.1213 8.12132C18.9497 9.29289 17.0503 9.29289 15.8787 8.12132C14.7071 6.94975 14.7071 5.05025 15.8787 3.87868C17.0503 2.70711 18.9497 2.70711 20.1213 3.87868Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgParamClock() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6V12L16 14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgLockUnclocked() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 10V8C7 5.23858 9.23858 3 12 3C13.6358 3 15.0882 3.78555 16.0004 5M12 14V16M19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15C5 11.134 8.13401 8 12 8C15.866 8 19 11.134 19 15Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgUserCheck01() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15.5H7.5C6.10444 15.5 5.40665 15.5 4.83886 15.6722C3.56045 16.06 2.56004 17.0605 2.17224 18.3389C2 18.9067 2 19.6044 2 21M16 18L18 20L22 16M14.5 7.5C14.5 9.98528 12.4853 12 10 12C7.51472 12 5.5 9.98528 5.5 7.5C5.5 5.01472 7.51472 3 10 3C12.4853 3 14.5 5.01472 14.5 7.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgInfo() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 10V7.5M7.5 5H7.50625M13.75 7.5C13.75 10.9518 10.9518 13.75 7.5 13.75C4.04822 13.75 1.25 10.9518 1.25 7.5C1.25 4.04822 4.04822 1.25 7.5 1.25C10.9518 1.25 13.75 4.04822 13.75 7.5Z"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * @param {Object} props
 * @param {string=} props.width
 * @param {string=} props.height
 * @return {JSX.Element}
 */
export function SvgTargetIcon(props = {}) {
  return (
    <svg
      width={props.width || "20"}
      height={props.height || "19"}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3307 6.1665V3.6665L15.8307 1.1665L16.664 2.83317L18.3307 3.6665L15.8307 6.1665H13.3307ZM13.3307 6.1665L9.99737 9.49979M18.3307 9.49984C18.3307 14.1022 14.5998 17.8332 9.9974 17.8332C5.39502 17.8332 1.66406 14.1022 1.66406 9.49984C1.66406 4.89746 5.39502 1.1665 9.9974 1.1665M14.1641 9.49984C14.1641 11.801 12.2986 13.6665 9.9974 13.6665C7.69621 13.6665 5.83073 11.801 5.83073 9.49984C5.83073 7.19865 7.69621 5.33317 9.9974 5.33317"
        stroke="black"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SeeEvaluation() {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.06364 7.5944C0.950155 7.4147 0.89341 7.32485 0.861645 7.18626C0.837785 7.08217 0.837785 6.918 0.861645 6.8139C0.89341 6.67532 0.950155 6.58547 1.06364 6.40577C2.00148 4.92078 4.79304 1.16675 9.04721 1.16675C13.3014 1.16675 16.0929 4.92078 17.0308 6.40577C17.1443 6.58547 17.201 6.67532 17.2328 6.8139C17.2566 6.918 17.2566 7.08217 17.2328 7.18626C17.201 7.32485 17.1443 7.4147 17.0308 7.5944C16.0929 9.07938 13.3014 12.8334 9.04721 12.8334C4.79304 12.8334 2.00148 9.07938 1.06364 7.5944Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.04721 9.50008C10.4279 9.50008 11.5472 8.38079 11.5472 7.00008C11.5472 5.61937 10.4279 4.50008 9.04721 4.50008C7.6665 4.50008 6.54721 5.61937 6.54721 7.00008C6.54721 8.38079 7.6665 9.50008 9.04721 9.50008Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NoSeeEvaluation() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99933 3.2436C8.338 3.19353 8.68738 3.16667 9.04722 3.16667C13.3014 3.16667 16.093 6.9207 17.0308 8.40569C17.1443 8.58542 17.2011 8.67528 17.2328 8.81389C17.2567 8.91799 17.2567 9.08222 17.2328 9.18631C17.201 9.32492 17.1438 9.41538 17.0295 9.59631C16.7797 9.99179 16.3987 10.5476 15.894 11.1504M4.65048 4.59586C2.84875 5.81808 1.62558 7.51615 1.06446 8.4044C0.950446 8.58489 0.893437 8.67514 0.861658 8.81373C0.837789 8.91783 0.83778 9.08203 0.861636 9.18613C0.8934 9.32473 0.950151 9.41459 1.06365 9.59432C2.00149 11.0793 4.79305 14.8333 9.04722 14.8333C10.7626 14.8333 12.2401 14.223 13.4542 13.3972M1.54722 1.5L16.5472 16.5M7.27945 7.23223C6.82704 7.68464 6.54722 8.30964 6.54722 9C6.54722 10.3807 7.66651 11.5 9.04722 11.5C9.73758 11.5 10.3626 11.2202 10.815 10.7678"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgMinusCircle() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.66406 8.99996H11.3307M15.5807 8.99996C15.5807 12.912 12.4094 16.0833 8.4974 16.0833C4.58538 16.0833 1.41406 12.912 1.41406 8.99996C1.41406 5.08794 4.58538 1.91663 8.4974 1.91663C12.4094 1.91663 15.5807 5.08794 15.5807 8.99996Z"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ClockDetailed() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.05469 8.5791V12.4316L8.581 13.6317"
        stroke="#292929"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.97656 2.68421C8.03975 1.64237 9.49587 1 11.102 1C14.3576 1 16.9968 3.63916 16.9968 6.89474C16.9968 8.50091 16.3544 9.95705 15.3125 11.0202"
        stroke="#292929"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.89474 16.9999C10.1503 16.9999 12.7895 14.3608 12.7895 11.1052C12.7895 7.84961 10.1503 5.21045 6.89474 5.21045C3.63916 5.21045 1 7.84961 1 11.1052C1 14.3608 3.63916 16.9999 6.89474 16.9999Z"
        stroke="#292929"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function EditInjection() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.43802 9.05797C1.46099 8.85122 1.47248 8.74785 1.50376 8.65123C1.53151 8.56551 1.57072 8.48393 1.62032 8.40871C1.67623 8.32392 1.74977 8.25038 1.89686 8.10329L8.50001 1.50015C9.0523 0.947866 9.94773 0.947867 10.5 1.50015C11.0523 2.05244 11.0523 2.94787 10.5 3.50015L3.89686 10.1033C3.74977 10.2504 3.67623 10.3239 3.59144 10.3798C3.51622 10.4294 3.43464 10.4686 3.34892 10.4964C3.2523 10.5277 3.14893 10.5392 2.94218 10.5621L1.25 10.7502L1.43802 9.05797Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function AddSubgroup() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.16582 1.5C3.3252 1.5 1.83309 2.99238 1.83309 4.83333C1.83309 6.67428 3.3252 8.16667 5.16582 8.16667C7.00643 8.16667 8.49855 6.67428 8.49855 4.83333C8.49855 2.99238 7.00643 1.5 5.16582 1.5Z"
        fill="#292929"
      />
      <path
        d="M9.71929 4.94522C9.75117 4.60037 9.83164 3.50004 9.83164 3.50004C10.2526 3.50004 10.6676 3.59971 11.0427 3.79097C11.084 3.81203 11.1247 3.83414 11.1647 3.85727C11.4883 4.04409 11.7694 4.29713 11.9894 4.60037C12.2367 4.94115 12.3998 5.33565 12.4653 5.75158C12.5309 6.16751 12.497 6.59305 12.3665 6.99337C12.2359 7.39369 12.0125 7.75741 11.7144 8.05475C11.4164 8.3521 11.0521 8.57462 10.6515 8.70411C10.2951 8.81933 9.91885 8.85797 9.54739 8.81814C9.50141 8.8132 9.45551 8.80707 9.40973 8.79973C8.99433 8.73315 8.60058 8.56919 8.26067 8.32126C8.26067 8.32126 9.10536 7.03362 9.40973 6.10417C9.72252 5.149 9.83164 3.50004 9.83164 3.50004C9.83164 4.16667 9.83164 7.5 9.62069 7.48316L9.58324 7.41988C9.54739 7.44792 9.56719 7.29127 9.56719 7.29127C9.56719 7.29127 9.49925 7.19352 9.56451 6.99337C9.56884 6.86011 9.56451 6.77083 9.58324 6.58001C9.55048 6.37205 9.6022 6.29876 9.62655 5.98592C9.62655 5.59896 9.62655 5.30729 9.71929 4.94522Z"
        fill="#292929"
      />
      <path
        d="M12.4966 13.5C11.8313 13.5 9.83164 13.5 9.83164 13.5C9.83164 13.5 10.4982 13.3125 10.4982 12.8333C10.4982 12.3542 10.4982 12.5269 10.4982 12.1667C10.4982 11.5 9.83164 10.8346 9.83164 10.8346V9.5C10.2863 9.5 10.7371 9.57753 11.1647 9.72876C11.2311 9.75223 11.2969 9.77748 11.3621 9.80448C11.8473 10.0055 12.2882 10.3001 12.6596 10.6716C13.0309 11.043 13.3255 11.484 13.5265 11.9693C13.5535 12.0345 13.5787 12.1003 13.6022 12.1667C13.7534 12.5944 13.8309 13.0453 13.8309 13.5H12.4966Z"
        fill="#292929"
      />
      <path
        d="M9.83164 13.5H8.49855C5.83236 13.5 7.00643 13.5 5.16582 13.5C3.3252 13.5 5.16582 13.5 1.83309 13.5H0.5C0.5 10.9227 2.58896 8.83333 5.16582 8.83333C7.74268 8.83333 9.83164 10.9227 9.83164 13.5Z"
        fill="#292929"
      />
    </svg>
  );
}

export function EditGroup() {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2545 4.79709L11.9299 5.12171L8.35904 1.55085L8.68367 1.22623C9.33291 0.576985 10.2256 0.333517 11.1183 0.576985C12.0111 0.820452 12.6603 1.4697 12.9038 2.36241C13.1472 3.25513 12.9038 4.14784 12.2545 4.79709ZM10.7126 6.33905L8.35904 8.69257L5.19397 11.8576C4.78819 12.2634 4.30126 12.5069 3.81432 12.6692L0.730402 13.4808C0.56809 13.5619 0.324623 13.4808 0.243467 13.3996C0 13.2373 0 12.9938 0 12.8315L0.811558 9.74759C0.973869 9.26066 1.21734 8.77372 1.62312 8.36794L4.78819 5.20287L7.14171 2.84935L10.7126 6.33905Z"
        fill="#292929"
      />
    </svg>
  );
}

export function RemoveGroup() {
  return (
    <svg
      width="10"
      height="14"
      viewBox="0 0 10 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.697418 12.2194C0.698689 12.6143 0.845951 12.9927 1.10708 13.2719C1.3682 13.5512 1.722 13.7087 2.09129 13.71H7.66871C8.03883 13.71 8.39387 13.5532 8.65604 13.2738C8.9182 12.9943 9.06613 12.6152 9.06741 12.2194V3.27238H0.697418V12.2194ZM9.76 1.03588H7.31952L6.62307 0.290039H3.13694L2.44048 1.03588H0V2.52653H9.76V1.03588Z"
        fill="#292929"
      />
    </svg>
  );
}

export function IconUnion() {
  return (
    <svg
      width="13"
      height="18"
      viewBox="0 0 13 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 0C0.447715 0 0 0.447716 0 1V12.0181V14V14.0296C0 14.3071 0.225288 14.5324 0.502875 14.5324L7.04025 14.5324V16.5439C7.04025 16.7411 7.15592 16.9201 7.33494 17.0016C7.51497 17.084 7.72517 17.0518 7.87402 16.9221L11.897 13.402C12.0066 13.3064 12.069 13.1686 12.069 13.0238C12.069 12.879 12.0056 12.7412 11.897 12.6456L7.87402 9.12552C7.72618 8.99478 7.51497 8.96461 7.33494 9.04607C7.15491 9.12754 7.04025 9.30656 7.04025 9.50369V11.5152H3V1C3 0.447715 2.55228 0 2 0H1Z"
        fill="#626262"
      />
    </svg>
  );
}

export function UserUnavailable() {
  return (
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.70863 6.24831C6.19162 6.24831 7.39382 5.04611 7.39382 3.56312C7.39382 2.08013 6.19162 0.87793 4.70863 0.87793C3.22564 0.87793 2.02344 2.08013 2.02344 3.56312C2.02344 5.04611 3.22564 6.24831 4.70863 6.24831Z"
        fill="#265985"
      />
      <path
        d="M10.7888 6.65028C9.81125 5.67256 8.22639 5.67256 7.24892 6.65028C6.27119 7.62776 6.27119 9.21262 7.24892 10.1901C8.22639 11.1677 9.81125 11.1677 10.7888 10.1901C11.7662 9.21262 11.7662 7.62776 10.7888 6.65028ZM10.19 7.24889C10.726 7.78487 10.8163 8.59644 10.4639 9.22705L8.21171 6.97506C8.84231 6.62242 9.65388 6.71291 10.19 7.24889ZM7.84765 9.59136C7.31141 9.05525 7.22106 8.24368 7.57357 7.6132L9.82581 9.86519C9.1952 10.2178 8.38376 10.1275 7.84765 9.59136Z"
        fill="#265985"
      />
      <path
        d="M6.97138 6.36965C7.16238 6.17877 7.37434 6.02266 7.5986 5.89616C7.42542 5.77744 7.24333 5.66513 7.05044 5.56348C6.48522 6.22383 5.6473 6.64385 4.70986 6.64385C3.77242 6.64385 2.9345 6.22383 2.36952 5.56348C1.03552 6.26624 0.140625 7.44049 0.140625 8.26862C0.140625 9.52205 2.18655 10.5383 4.70973 10.5383C5.46533 10.5383 6.17713 10.4467 6.80498 10.2854C5.84382 9.14633 5.89816 7.44262 6.97138 6.36965Z"
        fill="#265985"
      />
    </svg>
  );
}

export function ConnectedNethris() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.58833 14.3034L8.40982 15.4819C6.78264 17.1091 4.14445 17.1091 2.51726 15.4819C0.890079 13.8547 0.890079 11.2165 2.51726 9.58931L3.69577 8.4108M14.3024 9.58931L15.4809 8.4108C17.1081 6.78361 17.1081 4.14542 15.4809 2.51824C13.8537 0.891055 11.2155 0.891056 9.58833 2.51824L8.40982 3.69675M6.08241 11.9167L11.9157 6.08337"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DeconnectedNethris() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.4974 3.33366V1.66699M12.4974 16.667V18.3337M3.33073 7.50033H1.66406M16.6641 12.5003H18.3307M4.09257 4.0955L2.91406 2.91699M15.9022 15.9051L17.0807 17.0837M9.9974 14.7144L8.22963 16.4821C6.92788 17.7839 4.81733 17.7839 3.51558 16.4821C2.21384 15.1804 2.21384 13.0698 3.51558 11.7681L5.28335 10.0003M14.7114 10.0003L16.4792 8.23256C17.781 6.93081 17.781 4.82026 16.4792 3.51851C15.1775 2.21677 13.0669 2.21677 11.7652 3.51851L9.9974 5.28628"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TinyClock() {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.94047 10.5C2.21193 10.5 0 8.26142 0 5.5C0 2.73858 2.21193 0.5 4.94047 0.5C7.66902 0.5 9.88095 2.73858 9.88095 5.5C9.87795 8.26017 7.66778 10.497 4.94047 10.5ZM4.94047 1.5C2.75764 1.5 0.988095 3.29086 0.988095 5.5C0.988095 7.70914 2.75764 9.5 4.94047 9.5C7.12331 9.5 8.89285 7.70914 8.89285 5.5C8.8904 3.29189 7.1223 1.50248 4.94047 1.5ZM7.41071 6H4.44643V3H5.43452V5H7.41071V6Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgAccessSecurity() {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 10.5004L8 12.5004L12.5 8.00036M17 11.0004C17 15.9088 11.646 19.4788 9.69799 20.6152C9.4766 20.7444 9.3659 20.809 9.20968 20.8425C9.08844 20.8685 8.91156 20.8685 8.79032 20.8425C8.6341 20.809 8.5234 20.7444 8.30201 20.6152C6.35396 19.4788 1 15.9088 1 11.0004V6.21796C1 5.41845 1 5.01869 1.13076 4.67506C1.24627 4.3715 1.43398 4.10064 1.67766 3.88589C1.9535 3.6428 2.3278 3.50243 3.0764 3.22171L8.4382 1.21103C8.6461 1.13307 8.75005 1.09409 8.85698 1.07864C8.95184 1.06493 9.04816 1.06493 9.14302 1.07864C9.24995 1.09409 9.3539 1.13307 9.5618 1.21103L14.9236 3.22171C15.6722 3.50243 16.0465 3.6428 16.3223 3.88589C16.566 4.10064 16.7537 4.3715 16.8692 4.67506C17 5.01869 17 5.41845 17 6.21796V11.0004Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgViewDocument() {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37"
        height="37"
        rx="4"
        fill="#F9FAFC"
      />
      <path
        d="M20 17.7H15.2M16.8 20.9H15.2M21.6 14.5H15.2M24.8 14.34V22.66C24.8 24.0041 24.8 24.6762 24.5384 25.1896C24.3083 25.6412 23.9412 26.0083 23.4896 26.2384C22.9762 26.5 22.3041 26.5 20.96 26.5H15.84C14.4959 26.5 13.8238 26.5 13.3104 26.2384C12.8588 26.0083 12.4917 25.6412 12.2616 25.1896C12 24.6762 12 24.0041 12 22.66V14.34C12 12.9959 12 12.3238 12.2616 11.8104C12.4917 11.3588 12.8588 10.9917 13.3104 10.7616C13.8238 10.5 14.4959 10.5 15.84 10.5H20.96C22.3041 10.5 22.9762 10.5 23.4896 10.7616C23.9412 10.9917 24.3083 11.3588 24.5384 11.8104C24.8 12.3238 24.8 12.9959 24.8 14.34Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgViewDownload() {
  return (
    <svg
      width="15"
      height="37"
      viewBox="0 0 15 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_29951_17664)">
        <path
          d="M5 9.5L7.5 12M7.5 12L10 9.5M7.5 12V7M13.75 9.5C13.75 12.9518 10.9518 15.75 7.5 15.75C4.04822 15.75 1.25 12.9518 1.25 9.5C1.25 6.04822 4.04822 3.25 7.5 3.25C10.9518 3.25 13.75 6.04822 13.75 9.5Z"
          stroke="#4CA090"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_29951_17664">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0 2)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgCompetence() {
  return (
    <svg
      width="20"
      height="23"
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0078 3.49902C8.6271 3.49902 7.50781 4.61831 7.50781 5.99902C7.50781 7.37974 8.6271 8.49902 10.0078 8.49902C11.3885 8.49902 12.5078 7.37974 12.5078 5.99902C12.5078 4.61831 11.3885 3.49902 10.0078 3.49902ZM10.0078 3.49902V1.49902M19.0078 14.4365C16.809 16.9278 13.5919 18.499 10.0078 18.499C6.42373 18.499 3.20665 16.9278 1.00781 14.4365M8.75264 8.16071L1.00781 21.499M11.263 8.16071L19.0078 21.499"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgPerf() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8828 14.0459L7.88281 11.0459M10.8828 14.0459C12.2797 13.5146 13.6197 12.8446 14.8828 12.0459M10.8828 14.0459V19.0459C10.8828 19.0459 13.9128 18.4959 14.8828 17.0459C15.9628 15.4259 14.8828 12.0459 14.8828 12.0459M7.88281 11.0459C8.41496 9.66533 9.08502 8.34197 9.88281 7.0959C11.048 5.23289 12.6704 3.69895 14.5958 2.63999C16.5212 1.58104 18.6855 1.03227 20.8828 1.0459C20.8828 3.7659 20.1028 8.5459 14.8828 12.0459M7.88281 11.0459H2.88281C2.88281 11.0459 3.43281 8.0159 4.88281 7.0459C6.50281 5.9659 9.88281 7.0459 9.88281 7.0459M3.38281 15.5459C1.88281 16.8059 1.38281 20.5459 1.38281 20.5459C1.38281 20.5459 5.12281 20.0459 6.38281 18.5459C7.09281 17.7059 7.08281 16.4159 6.29281 15.6359C5.90412 15.2649 5.39211 15.0505 4.85504 15.0339C4.31797 15.0173 3.79369 15.1996 3.38281 15.5459Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgSuivi() {
  return (
    <svg
      width="27"
      height="25"
      viewBox="0 0 27 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0395 22.0524C17.9508 23.6415 15.3983 24.501 12.7739 24.499C10.5379 24.4999 8.34615 23.876 6.44581 22.6978C4.54547 21.5195 3.01213 19.8337 2.01869 17.8306C1.02526 15.8274 0.611254 13.5865 0.82337 11.3606C1.03548 9.13476 1.86528 7.0124 3.21918 5.23293C4.57308 3.45345 6.39722 2.08764 8.4859 1.28952C10.5746 0.491404 12.8447 0.292722 15.0403 0.715884C17.2358 1.13905 19.2695 2.16722 20.9119 3.68445C22.1987 4.87312 23.2052 6.32492 23.8672 7.93433L25.2122 5.08176C25.2809 4.95157 25.3971 4.8529 25.5368 4.80631C25.6764 4.75972 25.8286 4.7688 25.9617 4.83166C26.0948 4.89452 26.1985 5.00632 26.2512 5.14375C26.3039 5.28118 26.3015 5.43364 26.2446 5.56938L24.3017 9.6989C24.2554 9.79708 24.1821 9.88004 24.0903 9.93806C23.9986 9.99608 23.8922 10.0268 23.7836 10.0265C23.6991 10.0259 23.6158 10.0063 23.5398 9.96938L19.4103 8.02652C19.3391 7.99668 19.2748 7.95273 19.2211 7.89733C19.1673 7.84193 19.1254 7.77622 19.0978 7.70418C19.0702 7.63213 19.0574 7.55523 19.0603 7.47812C19.0632 7.40102 19.0817 7.32529 19.1146 7.25552C19.1476 7.18575 19.1943 7.12338 19.252 7.07216C19.3098 7.02095 19.3773 6.98195 19.4504 6.95752C19.5236 6.9331 19.601 6.92375 19.6779 6.93005C19.7548 6.93634 19.8297 6.95814 19.8979 6.99414L22.808 8.36323C21.9823 6.36029 20.5716 4.63985 18.7464 3.43608C16.553 1.98954 13.9095 1.38717 11.306 1.74058C8.70241 2.094 6.31522 3.37924 4.5868 5.35813C2.85838 7.33702 1.90592 9.87539 1.90592 12.5028C1.90592 15.1303 2.85838 17.6686 4.5868 19.6475C6.31522 21.6264 8.70241 22.9117 11.306 23.2651C13.9095 23.6185 16.553 23.0161 18.7464 21.5696C20.9397 20.1231 22.5344 17.9304 23.2348 15.3981C23.253 15.3238 23.2859 15.2539 23.3316 15.1926C23.3773 15.1313 23.4349 15.0798 23.5009 15.0411C23.5668 15.0025 23.6399 14.9774 23.7157 14.9675C23.7915 14.9576 23.8686 14.963 23.9423 14.9834C24.0159 15.0038 24.0848 15.0388 24.1447 15.0863C24.2047 15.1338 24.2544 15.1928 24.2911 15.2599C24.3278 15.327 24.3507 15.4008 24.3584 15.4768C24.366 15.5529 24.3583 15.6298 24.3358 15.7028C23.6375 18.2327 22.1282 20.4634 20.0395 22.0524Z"
        fill="white"
      />
      <path
        d="M12.7739 24.499L12.7737 23.999H12.7742L12.7739 24.499ZM20.0395 22.0524L19.7368 21.6545L20.0395 22.0524ZM6.44581 22.6978L6.18233 23.1227L6.44581 22.6978ZM2.01869 17.8306L1.57075 18.0527V18.0527L2.01869 17.8306ZM0.82337 11.3606L1.32112 11.4081V11.4081L0.82337 11.3606ZM8.4859 1.28952L8.66438 1.75659V1.75659L8.4859 1.28952ZM15.0403 0.715884L14.9456 1.20685L15.0403 0.715884ZM20.9119 3.68445L21.2512 3.31718L20.9119 3.68445ZM23.8672 7.93433L24.3194 8.14757L23.836 9.17289L23.4048 8.12453L23.8672 7.93433ZM25.2122 5.08176L24.76 4.86852L24.7647 4.85839L24.77 4.84849L25.2122 5.08176ZM25.5368 4.80631L25.695 5.2806H25.695L25.5368 4.80631ZM25.9617 4.83166L26.1752 4.37955L26.1752 4.37955L25.9617 4.83166ZM26.2512 5.14375L26.718 4.96472L26.718 4.96472L26.2512 5.14375ZM26.2446 5.56938L26.7057 5.76278L26.7015 5.7726L26.697 5.78224L26.2446 5.56938ZM24.3017 9.6989L24.7542 9.91176L24.7539 9.91223L24.3017 9.6989ZM24.0903 9.93806L24.3576 10.3607H24.3576L24.0903 9.93806ZM23.7836 10.0265L23.7825 10.5265L23.7797 10.5265L23.7836 10.0265ZM23.5398 9.96938L23.7527 9.51691L23.7585 9.51973L23.5398 9.96938ZM19.4103 8.02652L19.6037 7.56544L19.6135 7.56956L19.6232 7.57409L19.4103 8.02652ZM19.0978 7.70418L19.5646 7.52514L19.5646 7.52515L19.0978 7.70418ZM19.0603 7.47812L19.5599 7.49689L19.5599 7.49689L19.0603 7.47812ZM19.252 7.07216L19.5839 7.44614L19.5839 7.44614L19.252 7.07216ZM19.4504 6.95752L19.6087 7.43181L19.6087 7.43181L19.4504 6.95752ZM19.6779 6.93005L19.6372 7.42838H19.6372L19.6779 6.93005ZM19.8979 6.99414L19.6851 7.44657L19.6747 7.44171L19.6647 7.43639L19.8979 6.99414ZM22.808 8.36323L23.2703 8.17267L23.7616 9.36442L22.5952 8.81566L22.808 8.36323ZM18.7464 3.43608L19.0216 3.01868L18.7464 3.43608ZM11.306 1.74058L11.2387 1.24513L11.306 1.74058ZM4.5868 5.35813L4.21022 5.02921L4.5868 5.35813ZM4.5868 19.6475L4.21022 19.9764L4.5868 19.6475ZM11.306 23.2651L11.2387 23.7605L11.306 23.2651ZM23.2348 15.3981L23.7204 15.5171L23.7187 15.5243L23.7167 15.5314L23.2348 15.3981ZM23.9423 14.9834L23.8089 15.4653L23.8089 15.4653L23.9423 14.9834ZM24.1447 15.0863L23.8342 15.4782H23.8342L24.1447 15.0863ZM24.2911 15.2599L23.8525 15.4999L23.8525 15.4999L24.2911 15.2599ZM24.3584 15.4768L23.8609 15.527L24.3584 15.4768ZM24.3358 15.7028L23.8538 15.5698L23.8558 15.5625L23.8581 15.5552L24.3358 15.7028ZM12.7742 23.999C15.2892 24.0009 17.7352 23.1773 19.7368 21.6545L20.3423 22.4504C18.1664 24.1057 15.5074 25.0011 12.7735 24.999L12.7742 23.999ZM6.70929 22.2728C8.53045 23.402 10.6309 23.9998 12.7737 23.999L12.7741 24.999C10.4449 24.9999 8.16186 24.35 6.18233 23.1227L6.70929 22.2728ZM2.46663 17.6084C3.41867 19.5281 4.88813 21.1436 6.70929 22.2728L6.18233 23.1227C4.20281 21.8954 2.60558 20.1394 1.57075 18.0527L2.46663 17.6084ZM1.32112 11.4081C1.11784 13.5412 1.51459 15.6887 2.46663 17.6084L1.57075 18.0527C0.535925 15.9661 0.10467 13.6318 0.325624 11.3132L1.32112 11.4081ZM3.6171 5.53568C2.31961 7.24101 1.52439 9.27493 1.32112 11.4081L0.325624 11.3132C0.546577 8.99458 1.41095 6.78379 2.82126 4.93017L3.6171 5.53568ZM8.66438 1.75659C6.66273 2.52145 4.91459 3.83035 3.6171 5.53568L2.82126 4.93017C4.23157 3.07656 6.13172 1.65384 8.30743 0.822461L8.66438 1.75659ZM14.9456 1.20685C12.8416 0.801318 10.666 0.991721 8.66438 1.75659L8.30743 0.822461C10.4831 -0.00891387 12.8479 -0.215874 15.1349 0.22492L14.9456 1.20685ZM20.5727 4.05173C18.9987 2.59771 17.0497 1.61238 14.9456 1.20685L15.1349 0.22492C17.4219 0.665714 19.5403 1.73673 21.2512 3.31718L20.5727 4.05173ZM23.4048 8.12453C22.7704 6.58217 21.8058 5.19087 20.5727 4.05173L21.2512 3.31718C22.5916 4.55538 23.64 6.06767 24.3296 7.74414L23.4048 8.12453ZM25.6645 5.295L24.3194 8.14757L23.4149 7.72109L24.76 4.86852L25.6645 5.295ZM25.695 5.2806C25.6776 5.28642 25.663 5.29876 25.6545 5.31503L24.77 4.84849C24.8987 4.60439 25.1167 4.41938 25.3785 4.33202L25.695 5.2806ZM25.7481 5.28377C25.7315 5.27591 25.7125 5.27477 25.695 5.2806L25.3785 4.33202C25.6403 4.24466 25.9257 4.26169 26.1752 4.37955L25.7481 5.28377ZM25.7843 5.32278C25.7777 5.3056 25.7648 5.29162 25.7481 5.28377L26.1752 4.37955C26.4248 4.49742 26.6192 4.70703 26.718 4.96472L25.7843 5.32278ZM25.7835 5.37598C25.7906 5.35901 25.7909 5.33996 25.7843 5.32278L26.718 4.96472C26.8168 5.2224 26.8124 5.50827 26.7057 5.76278L25.7835 5.37598ZM23.8493 9.48604L25.7922 5.35652L26.697 5.78224L24.7542 9.91176L23.8493 9.48604ZM23.8231 9.51546C23.8346 9.50821 23.8437 9.49784 23.8495 9.48557L24.7539 9.91223C24.6671 10.0963 24.5296 10.2519 24.3576 10.3607L23.8231 9.51546ZM23.7848 9.52652C23.7983 9.52655 23.8116 9.52272 23.8231 9.51546L24.3576 10.3607C24.1855 10.4694 23.9861 10.527 23.7825 10.5265L23.7848 9.52652ZM23.7585 9.51973C23.7675 9.52413 23.7775 9.52646 23.7875 9.52654L23.7797 10.5265C23.6208 10.5253 23.4641 10.4885 23.3212 10.419L23.7585 9.51973ZM19.6232 7.57409L23.7527 9.51695L23.327 10.4218L19.1974 8.47895L19.6232 7.57409ZM19.58 7.54929C19.5868 7.55622 19.5948 7.56171 19.6037 7.56544L19.2169 8.4876C19.0835 8.43164 18.9628 8.34924 18.8621 8.24536L19.58 7.54929ZM19.5646 7.52515C19.5681 7.53415 19.5733 7.54236 19.58 7.54929L18.8621 8.24536C18.7614 8.14149 18.6827 8.0183 18.6309 7.88321L19.5646 7.52515ZM19.5599 7.49689C19.5596 7.50653 19.5612 7.51614 19.5646 7.52514L18.6309 7.88321C18.5791 7.74812 18.5552 7.60394 18.5607 7.45936L19.5599 7.49689ZM19.5667 7.46906C19.5626 7.47779 19.5603 7.48725 19.5599 7.49689L18.5607 7.45936C18.5661 7.31478 18.6007 7.1728 18.6625 7.04198L19.5667 7.46906ZM19.5839 7.44614C19.5767 7.45255 19.5709 7.46035 19.5667 7.46906L18.6625 7.04198C18.7243 6.91116 18.812 6.79421 18.9202 6.69818L19.5839 7.44614ZM19.6087 7.43181C19.5996 7.43487 19.5911 7.43974 19.5839 7.44614L18.9202 6.69818C19.0284 6.60215 19.1549 6.52903 19.2922 6.48323L19.6087 7.43181ZM19.6372 7.42838C19.6275 7.42759 19.6179 7.42876 19.6087 7.43181L19.2922 6.48323C19.4294 6.43744 19.5745 6.41991 19.7187 6.43171L19.6372 7.42838ZM19.6647 7.43639C19.6561 7.43189 19.6468 7.42917 19.6372 7.42838L19.7187 6.43171C19.8629 6.44351 20.0032 6.48439 20.1312 6.55189L19.6647 7.43639ZM22.5952 8.81566L19.6851 7.44657L20.1108 6.54171L23.0209 7.9108L22.5952 8.81566ZM19.0216 3.01868C20.931 4.27787 22.4065 6.07751 23.2703 8.17267L22.3458 8.5538C21.558 6.64306 20.2123 5.00183 18.4711 3.85348L19.0216 3.01868ZM11.2387 1.24513C13.9621 0.875442 16.7273 1.50555 19.0216 3.01868L18.4711 3.85348C16.3787 2.47354 13.8569 1.89889 11.3732 2.23604L11.2387 1.24513ZM4.21022 5.02921C6.01821 2.95922 8.5153 1.61481 11.2387 1.24513L11.3732 2.23604C8.88952 2.57318 6.61223 3.79926 4.96338 5.68705L4.21022 5.02921ZM1.40592 12.5028C1.40592 9.75443 2.40223 7.09921 4.21022 5.02921L4.96338 5.68705C3.31453 7.57484 2.40592 9.99635 2.40592 12.5028H1.40592ZM4.21022 19.9764C2.40223 17.9065 1.40592 15.2512 1.40592 12.5028H2.40592C2.40592 15.0093 3.31453 17.4308 4.96338 19.3186L4.21022 19.9764ZM11.2387 23.7605C8.5153 23.3909 6.01821 22.0464 4.21022 19.9764L4.96338 19.3186C6.61223 21.2064 8.88952 22.4325 11.3732 22.7696L11.2387 23.7605ZM19.0216 21.987C16.7273 23.5001 13.9621 24.1302 11.2387 23.7605L11.3732 22.7696C13.8569 23.1068 16.3787 22.5321 18.4711 21.1522L19.0216 21.987ZM23.7167 15.5314C22.9841 18.1803 21.316 20.4739 19.0216 21.987L18.4711 21.1522C20.5635 19.7722 22.0847 17.6806 22.7529 15.2648L23.7167 15.5314ZM23.7325 15.4914C23.7268 15.4991 23.7227 15.5078 23.7204 15.5171L22.7492 15.279C22.7833 15.1398 22.8451 15.0088 22.9308 14.8938L23.7325 15.4914ZM23.7537 15.4725C23.7454 15.4773 23.7382 15.4838 23.7325 15.4914L22.9308 14.8938C23.0164 14.7789 23.1243 14.6823 23.248 14.6098L23.7537 15.4725ZM23.7805 15.4633C23.7711 15.4645 23.7619 15.4677 23.7537 15.4725L23.248 14.6098C23.3717 14.5373 23.5087 14.4903 23.6509 14.4718L23.7805 15.4633ZM23.8089 15.4653C23.7997 15.4627 23.79 15.4621 23.7805 15.4633L23.6509 14.4718C23.793 14.4532 23.9375 14.4633 24.0756 14.5015L23.8089 15.4653ZM23.8342 15.4782C23.8267 15.4722 23.8181 15.4678 23.8089 15.4653L24.0756 14.5015C24.2138 14.5398 24.3429 14.6054 24.4553 14.6944L23.8342 15.4782ZM23.8525 15.4999C23.8479 15.4915 23.8417 15.4841 23.8342 15.4782L24.4553 14.6944C24.5677 14.7835 24.661 14.8942 24.7298 15.02L23.8525 15.4999ZM23.8609 15.527C23.8599 15.5175 23.8571 15.5082 23.8525 15.4999L24.7298 15.02C24.7986 15.1458 24.8415 15.2841 24.8558 15.4267L23.8609 15.527ZM23.8581 15.5552C23.8609 15.5461 23.8618 15.5365 23.8609 15.527L24.8558 15.4267C24.8702 15.5694 24.8558 15.7135 24.8135 15.8504L23.8581 15.5552ZM19.7368 21.6545C21.7383 20.1318 23.1847 17.9941 23.8538 15.5698L24.8177 15.8359C24.0904 18.4712 22.5181 20.795 20.3423 22.4504L19.7368 21.6545Z"
        fill="white"
      />
    </svg>
  );
}

export function SvgXDownload() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_29951_18095)">
        <path
          d="M9.375 5.625L5.625 9.375M5.625 5.625L9.375 9.375M13.75 7.5C13.75 10.9518 10.9518 13.75 7.5 13.75C4.04822 13.75 1.25 10.9518 1.25 7.5C1.25 4.04822 4.04822 1.25 7.5 1.25C10.9518 1.25 13.75 4.04822 13.75 7.5Z"
          stroke="#4CA090"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_29951_18095">
          <rect
            width="15"
            height="15"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgEditWhite() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.15703 13.5867C1.19149 13.2766 1.20872 13.1215 1.25564 12.9766C1.29726 12.848 1.35607 12.7256 1.43048 12.6128C1.51434 12.4856 1.62466 12.3753 1.8453 12.1547L11.75 2.24998C12.5784 1.42156 13.9216 1.42156 14.75 2.24998C15.5784 3.07841 15.5784 4.42156 14.75 5.24998L4.84529 15.1547C4.62466 15.3753 4.51434 15.4856 4.38717 15.5695C4.27434 15.6439 4.15197 15.7027 4.02338 15.7443C3.87845 15.7913 3.72339 15.8085 3.41328 15.843L0.875 16.125L1.15703 13.5867Z"
        stroke="black"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgTrashWhite() {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.125 0.875H10.875M1.375 3.25H15.625M14.0417 3.25L13.4865 11.5778C13.4032 12.8272 13.3615 13.4519 13.0917 13.9256C12.8541 14.3427 12.4957 14.6779 12.0638 14.8873C11.5732 15.125 10.9471 15.125 9.6949 15.125H7.3051C6.05288 15.125 5.42677 15.125 4.93618 14.8873C4.50427 14.6779 4.1459 14.3427 3.90832 13.9256C3.63846 13.4519 3.59681 12.8272 3.51352 11.5778L2.95833 3.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function paramShortcut() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_31753_40040)">
        <path
          d="M2.75 18.3332H5.86667C8.94696 18.3332 10.4871 18.3332 11.6636 17.7337C12.6985 17.2064 13.5399 16.365 14.0672 15.3301C14.6667 14.1536 14.6667 12.6135 14.6667 9.53317L14.6667 3.6665M14.6667 3.6665L10.0833 8.24984M14.6667 3.6665L19.25 8.24984"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_31753_40040">
          <rect
            width="21.8316"
            height="22"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function paramAdditionalInformation() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 14V10M10 6H10.01M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function treeSetup() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M1 1V11.2C1 12.8802 1 13.7202 1.32698 14.362C1.6146 14.9265 2.07354 15.3854 2.63803 15.673C3.27976 16 4.11984 16 5.8 16H13M13 16C13 17.6569 14.3431 19 16 19C17.6569 19 19 17.6569 19 16C19 14.3431 17.6569 13 16 13C14.3431 13 13 14.3431 13 16ZM1 6L13 6M13 6C13 7.65686 14.3431 9 16 9C17.6569 9 19 7.65685 19 6C19 4.34315 17.6569 3 16 3C14.3431 3 13 4.34315 13 6Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SettingsIcon(color = "#1A4E63") {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgGroup() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5833 5.66667V12.5C16.5833 13.9001 16.5833 14.6002 16.3108 15.135C16.0712 15.6054 15.6887 15.9878 15.2183 16.2275C14.6835 16.5 13.9835 16.5 12.5833 16.5H6.41666C5.01653 16.5 4.31647 16.5 3.78169 16.2275C3.31128 15.9878 2.92883 15.6054 2.68915 15.135C2.41666 14.6002 2.41666 13.9001 2.41666 12.5V5.66667M2.5 1.5H16.5C16.9667 1.5 17.2001 1.5 17.3783 1.59083C17.5351 1.67072 17.6626 1.79821 17.7425 1.95501C17.8333 2.13327 17.8333 2.36662 17.8333 2.83333V4.33333C17.8333 4.80004 17.8333 5.0334 17.7425 5.21166C17.6626 5.36846 17.5351 5.49594 17.3783 5.57584C17.2001 5.66667 16.9667 5.66667 16.5 5.66667H2.5C2.03329 5.66667 1.79993 5.66667 1.62167 5.57584C1.46487 5.49594 1.33739 5.36846 1.25749 5.21166C1.16666 5.0334 1.16666 4.80004 1.16666 4.33333V2.83333C1.16666 2.36662 1.16666 2.13327 1.25749 1.95501C1.33739 1.79821 1.46487 1.67072 1.62167 1.59083C1.79993 1.5 2.03329 1.5 2.5 1.5ZM7.5 8.58333H11.5C11.9667 8.58333 12.2001 8.58333 12.3783 8.67416C12.5351 8.75406 12.6626 8.88154 12.7425 9.03834C12.8333 9.2166 12.8333 9.44996 12.8333 9.91667V10.5833C12.8333 11.05 12.8333 11.2834 12.7425 11.4617C12.6626 11.6185 12.5351 11.7459 12.3783 11.8258C12.2001 11.9167 11.9667 11.9167 11.5 11.9167H7.5C7.03329 11.9167 6.79993 11.9167 6.62167 11.8258C6.46487 11.7459 6.33739 11.6185 6.25749 11.4617C6.16666 11.2834 6.16666 11.05 6.16666 10.5833V9.91667C6.16666 9.44996 6.16666 9.2166 6.25749 9.03834C6.33739 8.88154 6.46487 8.75406 6.62167 8.67416C6.79993 8.58333 7.03329 8.58333 7.5 8.58333Z"
        stroke="#888C97"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgDetails() {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66671 9.16663H4.66671M6.33337 12.5H4.66671M11.3334 5.83329H4.66671M14.6667 5.66663V14.3333C14.6667 15.7334 14.6667 16.4335 14.3942 16.9683C14.1545 17.4387 13.7721 17.8211 13.3017 18.0608C12.7669 18.3333 12.0668 18.3333 10.6667 18.3333H5.33337C3.93324 18.3333 3.23318 18.3333 2.6984 18.0608C2.22799 17.8211 1.84554 17.4387 1.60586 16.9683C1.33337 16.4335 1.33337 15.7334 1.33337 14.3333V5.66663C1.33337 4.26649 1.33337 3.56643 1.60586 3.03165C1.84554 2.56124 2.22799 2.17879 2.6984 1.93911C3.23318 1.66663 3.93324 1.66663 5.33337 1.66663H10.6667C12.0668 1.66663 12.7669 1.66663 13.3017 1.93911C13.7721 2.17879 14.1545 2.56124 14.3942 3.03165C14.6667 3.56643 14.6667 4.26649 14.6667 5.66663Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function removePicture() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_33445_23933)">
        <rect
          width="26"
          height="26"
          rx="13"
          fill="#EEF6F7"
        />
        <circle
          cx="13"
          cy="13"
          r="12.5"
          stroke="#7DCDC1"
        />
        <path
          d="M16.25 9.75L9.75 16.25M9.75 9.75L16.25 16.25"
          stroke="#7DCDC1"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_33445_23933">
          <rect
            width="26"
            height="26"
            rx="13"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function nothingData() {
  return (
    <svg
      width="190"
      height="197"
      viewBox="0 0 190 197"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="95"
        cy="102.5"
        r="94.5"
        fill="#FAFAFA"
      />
      <path
        d="M27.2649 7.12293L27.4309 2.90206C27.4504 2.42258 27.5838 1.95463 27.8199 1.53685C28.056 1.11907 28.3881 0.763453 28.7887 0.499358C29.1894 0.235262 29.6472 0.0702691 30.1242 0.0180003C30.6012 -0.0342684 31.0838 0.0276867 31.5322 0.198752C31.9809 0.370131 32.3824 0.645988 32.7033 1.00346C33.0241 1.36094 33.2552 1.78974 33.3773 2.25433C33.4994 2.71891 33.5091 3.20591 33.4054 3.67497C33.3018 4.14402 33.0878 4.58162 32.7814 4.9515L30.0976 8.2062L27.2649 7.12293ZM26.1158 10.1507L23.432 13.4054C23.126 13.7753 22.9125 14.2127 22.8092 14.6815C22.7058 15.1502 22.7156 15.6369 22.8377 16.1011C22.9598 16.5654 23.1906 16.9939 23.5112 17.3512C23.8318 17.7084 24.2329 17.9842 24.6812 18.1557C25.1295 18.3274 25.6123 18.3898 26.0895 18.3377C26.5668 18.2857 27.0248 18.1208 27.4256 17.8566C27.8264 17.5924 28.1586 17.2365 28.3945 16.8185C28.6305 16.4004 28.7635 15.9321 28.7825 15.4524L28.9509 11.2316L26.1158 10.1507Z"
        fill="#E1E6EE"
      />
      <path
        d="M24.4219 7.80824L25.7394 10.6018C25.9952 11.1432 26.4555 11.5609 27.0191 11.7631C27.5827 11.9653 28.2036 11.9355 28.7452 11.6802L31.4436 10.4091L30.1286 7.6155C29.8727 7.07413 29.4126 6.65633 28.8491 6.45372C28.2856 6.25111 27.6648 6.28022 27.1227 6.53466L24.4219 7.80824Z"
        fill="#9CAAC2"
      />
      <path
        d="M23.5675 9.49243C24.7007 9.49243 25.6194 8.57377 25.6194 7.44055C25.6194 6.30733 24.7007 5.38867 23.5675 5.38867C22.4343 5.38867 21.5156 6.30733 21.5156 7.44055C21.5156 8.57377 22.4343 9.49243 23.5675 9.49243Z"
        fill="#9CAAC2"
      />
      <path
        d="M115.465 71.3711L121.319 58.6838L122.648 59.2972L116.794 71.9844L115.465 71.3711Z"
        fill="#9CAAC2"
      />
      <path
        d="M100.711 52.6523H102.175V71.6828H100.711V52.6523Z"
        fill="#9CAAC2"
      />
      <path
        d="M82.957 60.2441L84.3241 59.7205L88.7166 71.1875L87.3496 71.7112L82.957 60.2441Z"
        fill="#9CAAC2"
      />
      <path
        d="M20.4883 5.55664L21.4583 4.46026L22.8416 5.68407L21.8716 6.78046L20.4883 5.55664Z"
        fill="#9CAAC2"
      />
      <path
        d="M20 8.25L20.0097 6.78615L21.8566 6.7984L21.8469 8.26225L20 8.25Z"
        fill="#9CAAC2"
      />
      <path
        d="M67.7955 99.188L66.3633 98.8928C66.4999 98.2316 66.6292 97.5631 66.7537 96.9043L68.1907 97.1703C68.0687 97.8412 67.9345 98.5195 67.7955 99.188ZM68.8007 93.535L67.3539 93.3324C67.5344 92.1125 67.6881 90.9073 67.815 89.7337L69.2789 89.8874C69.1422 91.0732 68.9885 92.3028 68.8007 93.5374V93.535ZM69.5765 86.196L68.1126 86.1082C68.1858 84.8883 68.2273 83.6684 68.2346 82.4899H69.6985C69.6912 83.7025 69.6497 84.9468 69.5765 86.1984V86.196ZM68.1517 78.8766C68.0834 77.6567 67.976 76.4368 67.8296 75.2852L69.2935 75.1046C69.4423 76.2953 69.5546 77.5444 69.6229 78.7961L68.1517 78.8766ZM67.2416 71.7377C66.9977 70.5446 66.6927 69.376 66.3511 68.2634L67.7491 67.834C68.1053 68.988 68.4176 70.2006 68.6762 71.44L67.2416 71.7377ZM53.8227 65.3942C53.3908 65.3942 52.9517 65.3771 52.515 65.3454L52.6247 63.8815C53.0249 63.9132 53.4421 63.923 53.8227 63.9279C54.585 63.9286 55.3461 63.8691 56.099 63.7498L56.343 65.1941C55.5127 65.3256 54.6731 65.3901 53.8324 65.3869L53.8227 65.3942ZM65.1092 64.9062C64.6395 63.8171 64.1034 62.7579 63.5038 61.7345L64.7677 61.0025C65.3974 62.0821 65.9604 63.1992 66.4536 64.3475L65.1092 64.9062ZM48.7381 64.472C47.5171 63.9446 46.4244 63.1598 45.5347 62.1712L46.6277 61.1953C47.378 62.0274 48.2993 62.6874 49.3286 63.1301L48.7381 64.472ZM60.0344 64.0743L59.4196 62.747C60.463 62.2681 61.4272 61.633 62.2791 60.8635L63.2672 61.9443C62.3005 62.8156 61.2062 63.5339 60.0222 64.0743H60.0344ZM61.53 58.7872C60.7996 57.856 59.9995 56.9817 59.1366 56.1717L60.1369 55.1031C61.0503 55.9638 61.897 56.8928 62.6694 57.882L61.53 58.7872ZM65.5143 58.7872L64.226 58.0919C64.7911 57.05 65.2804 55.9688 65.6899 54.8567L67.0635 55.3641C66.6256 56.5379 66.1037 57.6786 65.5021 58.7774L65.5143 58.7872ZM43.6462 58.7116C43.5198 58.2735 43.422 57.8277 43.3535 57.377C43.3027 57.0542 43.2774 56.7279 43.2778 56.4011C43.2778 55.8231 43.36 55.2481 43.5218 54.6932L44.9271 55.1006C44.8066 55.5211 44.7458 55.9564 44.7466 56.3937C44.7466 56.6454 44.7662 56.8966 44.8052 57.1452C44.8624 57.5346 44.9439 57.92 45.0491 58.2992L43.6462 58.7116ZM56.365 53.993C55.4805 53.3919 54.5291 52.8957 53.5299 52.5145L53.303 52.451L53.6885 51.0384L53.9496 51.1116C55.0872 51.5273 56.1683 52.0839 57.1677 52.7682L56.365 53.993ZM46.7643 52.6804L46.0007 51.4336C47.1669 50.7576 48.4983 50.4196 49.8458 50.4577H49.8946L49.8824 51.9216H49.8458C48.7651 51.8798 47.694 52.1391 46.7521 52.6706L46.7643 52.6804ZM68.0809 51.7239L66.6414 51.4531C66.8606 50.2971 66.9749 49.1237 66.983 47.9471H68.4469C68.4339 49.2116 68.3073 50.4724 68.0687 51.7142L68.0809 51.7239ZM66.6902 44.4436C66.4848 43.2831 66.1871 42.1409 65.7997 41.0278L67.1831 40.5399C67.5972 41.7282 67.9146 42.948 68.1322 44.1874L66.6902 44.4436ZM64.4017 37.7609C63.8569 36.7 63.2516 35.6711 62.5889 34.6795L63.8088 33.8694C64.502 34.9073 65.135 35.9843 65.7046 37.0949L64.4017 37.7609ZM60.4492 31.781C59.7173 30.8782 58.917 29.9682 58.068 29.0728L59.1293 28.0651C60.0052 28.9874 60.8371 29.9267 61.5862 30.8587L60.4492 31.781ZM55.4915 26.5378C54.6303 25.7424 53.7105 24.9397 52.7589 24.1541L53.6934 23.0245C54.6693 23.8272 55.6037 24.647 56.4845 25.4643L55.4915 26.5378ZM49.9044 21.9022C48.9577 21.1946 47.9525 20.4846 46.9473 19.7917L47.772 18.5718C48.804 19.2769 49.8165 20.0016 50.7802 20.7213L49.9044 21.9022ZM43.9024 17.8009C42.885 17.1641 41.8335 16.5322 40.7819 15.9246L41.5139 14.6559C42.5801 15.2732 43.6462 15.9124 44.6856 16.5614L43.9024 17.8009ZM37.5931 14.1655C35.6071 13.1189 34.3481 12.5528 34.3359 12.5455L34.9361 11.2109C34.9898 11.2353 36.2439 11.8014 38.2762 12.87L37.5931 14.1655Z"
        fill="#9CAAC2"
      />
      <path
        d="M48.5 79.0488H140.725V151.267H48.5V79.0488Z"
        fill="#F9FAFC"
      />
      <path
        d="M141.458 152.001H47.7695V78.3184H141.458V152.001ZM49.2334 150.537H139.994V79.7822H49.2334V150.537Z"
        fill="#9CAAC2"
      />
      <path
        d="M27.6406 98.4464H83.2682L105.714 79.1719H48.379L27.6406 98.4464Z"
        fill="white"
      />
      <path
        d="M83.5374 99.1778H25.7773L48.0894 78.4395H107.689L83.5374 99.1778ZM29.5005 97.7139H82.9957L103.734 79.9033H48.6652L29.5005 97.7139Z"
        fill="#9CAAC2"
      />
      <path
        d="M105.348 79.0488H140.725V151.267H105.348V79.0488Z"
        fill="#9CAAC2"
      />
      <path
        d="M155.729 98.4464H117.18L105.469 79.1719H140.846L155.729 98.4464Z"
        fill="white"
      />
      <path
        d="M157.223 99.1778H116.771L104.172 78.4395H141.215L157.223 99.1778ZM117.596 97.7139H154.242L140.484 79.9033H106.773L117.596 97.7139Z"
        fill="#9CAAC2"
      />
    </svg>
  );
}

export function Bank() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 7.00002V15M7.5 7.00002V15M12.5 7.00002V15M17 7.00002V15M1 16.6L1 17.4C1 17.9601 1 18.2401 1.10899 18.454C1.20487 18.6422 1.35785 18.7952 1.54601 18.891C1.75992 19 2.03995 19 2.6 19H17.4C17.9601 19 18.2401 19 18.454 18.891C18.6422 18.7952 18.7951 18.6422 18.891 18.454C19 18.2401 19 17.9601 19 17.4V16.6C19 16.04 19 15.7599 18.891 15.546C18.7951 15.3579 18.6422 15.2049 18.454 15.109C18.2401 15 17.9601 15 17.4 15H2.6C2.03995 15 1.75992 15 1.54601 15.109C1.35785 15.2049 1.20487 15.3579 1.10899 15.546C1 15.7599 1 16.04 1 16.6ZM9.65291 1.07715L2.25291 2.7216C1.80585 2.82094 1.58232 2.87062 1.41546 2.99082C1.26829 3.09685 1.15273 3.24092 1.08115 3.40759C1 3.59654 1 3.82553 1 4.28349L1 5.40002C1 5.96007 1 6.2401 1.10899 6.45401C1.20487 6.64217 1.35785 6.79515 1.54601 6.89103C1.75992 7.00002 2.03995 7.00002 2.6 7.00002H17.4C17.9601 7.00002 18.2401 7.00002 18.454 6.89103C18.6422 6.79515 18.7951 6.64217 18.891 6.45401C19 6.2401 19 5.96007 19 5.40002V4.2835C19 3.82553 19 3.59655 18.9188 3.40759C18.8473 3.24092 18.7317 3.09685 18.5845 2.99082C18.4177 2.87062 18.1942 2.82094 17.7471 2.7216L10.3471 1.07715C10.2176 1.04837 10.1528 1.03398 10.0874 1.02824C10.0292 1.02314 9.97077 1.02314 9.91264 1.02824C9.8472 1.03398 9.78244 1.04837 9.65291 1.07715Z"
        stroke="#11142D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      43c0a
    </svg>
  );
}

export function Lock() {
  return (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 9.5V6.5C14 3.73858 11.7614 1.5 9 1.5C6.23858 1.5 4 3.73858 4 6.5V9.5M5.8 19.5H12.2C13.8802 19.5 14.7202 19.5 15.362 19.173C15.9265 18.8854 16.3854 18.4265 16.673 17.862C17 17.2202 17 16.3802 17 14.7V14.3C17 12.6198 17 11.7798 16.673 11.138C16.3854 10.5735 15.9265 10.1146 15.362 9.82698C14.7202 9.5 13.8802 9.5 12.2 9.5H5.8C4.11984 9.5 3.27976 9.5 2.63803 9.82698C2.07354 10.1146 1.6146 10.5735 1.32698 11.138C1 11.7798 1 12.6198 1 14.3V14.7C1 16.3802 1 17.2202 1.32698 17.862C1.6146 18.4265 2.07354 18.8854 2.63803 19.173C3.27976 19.5 4.11984 19.5 5.8 19.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function TheSun() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 20H9V17H11V20ZM16.364 17.778L14.243 15.657L15.657 14.243L17.779 16.365L16.366 17.778H16.364ZM3.636 17.778L2.221 16.364L4.341 14.242L5.756 15.656L3.636 17.777V17.778ZM10 15.007C7.23497 15.0059 4.99426 12.7637 4.995 9.99867C4.99574 7.23364 7.23764 4.99263 10.0027 4.993C12.7677 4.99337 15.009 7.23497 15.009 10C15.0062 12.7649 12.7649 15.0053 10 15.007ZM10 6.993C8.33954 6.9941 6.99426 8.34087 6.995 10.0013C6.99574 11.6618 8.34221 13.0074 10.0027 13.007C11.6631 13.0066 13.009 11.6605 13.009 10C13.0073 8.33918 11.6608 6.99355 10 6.993ZM20 11H17V9H20V11ZM3 11H0V9H3V11ZM15.656 5.758L14.243 4.343L16.364 2.221L17.779 3.636L15.657 5.757L15.656 5.758ZM4.343 5.758L2.223 3.637L3.638 2.223L5.758 4.345L4.344 5.757L4.343 5.758ZM11 3H9V0H11V3Z"
        fill="#393C40"
      />
    </svg>
  );
}

export function TheTimes() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 18L15.5 20L20 15.5M20.9851 11.5499C20.995 11.3678 21 11.1845 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.4354 5.33651 20.858 10.7385 20.9966M11 5V11L14.7384 12.8692"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NumberVisibility() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 10.9375H5.125C4.07833 10.9375 3.55499 10.9375 3.12914 11.0667C2.17034 11.3575 1.42003 12.1078 1.12918 13.0666C1 13.4925 1 14.0158 1 15.0625M15.625 15.4375L14.5 14.3125M10.375 4.9375C10.375 6.80146 8.86396 8.3125 7 8.3125C5.13604 8.3125 3.625 6.80146 3.625 4.9375C3.625 3.07354 5.13604 1.5625 7 1.5625C8.86396 1.5625 10.375 3.07354 10.375 4.9375ZM15.25 12.4375C15.25 13.8872 14.0747 15.0625 12.625 15.0625C11.1753 15.0625 10 13.8872 10 12.4375C10 10.9878 11.1753 9.8125 12.625 9.8125C14.0747 9.8125 15.25 10.9878 15.25 12.4375Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SVGNewLink() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4419 5.75L14.4419 1.25M14.4419 1.25H9.94189M14.4419 1.25L8.44189 7.25M6.19189 2.75H4.54189C3.28178 2.75 2.65172 2.75 2.17042 2.99524C1.74705 3.21095 1.40284 3.55516 1.18713 3.97852C0.941895 4.45982 0.941895 5.08988 0.941895 6.35V11.15C0.941895 12.4101 0.941895 13.0402 1.18713 13.5215C1.40284 13.9448 1.74705 14.289 2.17042 14.5048C2.65172 14.75 3.28178 14.75 4.54189 14.75H9.34189C10.602 14.75 11.2321 14.75 11.7134 14.5048C12.1367 14.289 12.4809 13.9448 12.6967 13.5215C12.9419 13.0402 12.9419 12.4101 12.9419 11.15V9.5"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SVGNextStep() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.74357 3.04175H8.05127C10.2097 3.04175 11.289 3.04175 11.6986 3.42941C12.0528 3.76451 12.2097 4.25816 12.1141 4.73623C12.0035 5.2893 11.1224 5.91252 9.36019 7.15896L6.48112 9.19537C4.71892 10.4418 3.83781 11.065 3.7272 11.6181C3.6316 12.0962 3.78853 12.5898 4.14266 12.9249C4.55234 13.3126 5.63157 13.3126 7.79004 13.3126H8.4519M5.2644 3.04175C5.2644 4.21535 4.31301 5.16675 3.1394 5.16675C1.9658 5.16675 1.0144 4.21535 1.0144 3.04175C1.0144 1.86814 1.9658 0.916748 3.1394 0.916748C4.31301 0.916748 5.2644 1.86814 5.2644 3.04175ZM15.1811 12.9584C15.1811 14.132 14.2297 15.0834 13.0561 15.0834C11.8825 15.0834 10.9311 14.132 10.9311 12.9584C10.9311 11.7848 11.8825 10.8334 13.0561 10.8334C14.2297 10.8334 15.1811 11.7848 15.1811 12.9584Z"
        stroke="#292929"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function VisibilityAssignation() {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.42012 8.71318C1.28394 8.49754 1.21584 8.38972 1.17772 8.22342C1.14909 8.0985 1.14909 7.9015 1.17772 7.77658C1.21584 7.61028 1.28394 7.50246 1.42012 7.28682C2.54553 5.50484 5.8954 1 11.0004 1C16.1054 1 19.4553 5.50484 20.5807 7.28682C20.7169 7.50246 20.785 7.61028 20.8231 7.77658C20.8517 7.9015 20.8517 8.0985 20.8231 8.22342C20.785 8.38972 20.7169 8.49754 20.5807 8.71318C19.4553 10.4952 16.1054 15 11.0004 15C5.8954 15 2.54553 10.4952 1.42012 8.71318Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0004 11C12.6573 11 14.0004 9.65685 14.0004 8C14.0004 6.34315 12.6573 5 11.0004 5C9.34355 5 8.0004 6.34315 8.0004 8C8.0004 9.65685 9.34355 11 11.0004 11Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function VisibilityCount({ stroke = "black" } = {}) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 10.9375H5.125C4.07833 10.9375 3.55499 10.9375 3.12914 11.0667C2.17034 11.3575 1.42003 12.1078 1.12918 13.0666C1 13.4925 1 14.0158 1 15.0625M15.625 15.4375L14.5 14.3125M10.375 4.9375C10.375 6.80146 8.86396 8.3125 7 8.3125C5.13604 8.3125 3.625 6.80146 3.625 4.9375C3.625 3.07354 5.13604 1.5625 7 1.5625C8.86396 1.5625 10.375 3.07354 10.375 4.9375ZM15.25 12.4375C15.25 13.8872 14.0747 15.0625 12.625 15.0625C11.1753 15.0625 10 13.8872 10 12.4375C10 10.9878 11.1753 9.8125 12.625 9.8125C14.0747 9.8125 15.25 10.9878 15.25 12.4375Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgRedAlert(stroke = "#F55611") {
  return (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.49649 5.37516V8.2085M8.49649 11.0418H8.50357M7.51567 1.7568L1.68971 11.8198C1.36657 12.378 1.20499 12.6571 1.22888 12.8861C1.2497 13.0859 1.35437 13.2674 1.51684 13.3856C1.7031 13.521 2.02558 13.521 2.67053 13.521H14.3224C14.9674 13.521 15.2899 13.521 15.4761 13.3856C15.6386 13.2674 15.7433 13.0859 15.7641 12.8861C15.788 12.6571 15.6264 12.378 15.3033 11.8198L9.47731 1.7568C9.15532 1.20064 8.99433 0.922563 8.78429 0.829167C8.60107 0.747699 8.39191 0.747699 8.20869 0.829167C7.99865 0.922563 7.83766 1.20064 7.51567 1.7568Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgYellowAlert() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4974 5.66699V8.50033M8.4974 11.3337H8.50448M15.5807 8.50033C15.5807 12.4123 12.4094 15.5837 8.4974 15.5837C4.58538 15.5837 1.41406 12.4123 1.41406 8.50033C1.41406 4.58831 4.58538 1.41699 8.4974 1.41699C12.4094 1.41699 15.5807 4.58831 15.5807 8.50033Z"
        stroke="#E98F30"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function IconesLogs() {
  return (
    <svg
      width="32"
      height="30"
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="31"
        height="29"
        rx="3.5"
        fill="#FFEFE8"
      />
      <rect
        x="0.5"
        y="0.5"
        width="31"
        height="29"
        rx="3.5"
        stroke="#FFC6AE"
      />
      <g clipPath="url(#clip0_35696_21644)">
        <path
          d="M16.0026 17.6668V15.0002M16.0026 12.3335H16.0093M22.6693 15.0002C22.6693 18.6821 19.6845 21.6668 16.0026 21.6668C12.3207 21.6668 9.33594 18.6821 9.33594 15.0002C9.33594 11.3183 12.3207 8.3335 16.0026 8.3335C19.6845 8.3335 22.6693 11.3183 22.6693 15.0002Z"
          stroke="#F55611"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_35696_21644">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(8 7)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function EditDetailHoursBank() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.43802 9.05797C1.46099 8.85122 1.47248 8.74785 1.50376 8.65123C1.53151 8.56551 1.57072 8.48393 1.62032 8.40871C1.67623 8.32392 1.74977 8.25038 1.89686 8.10329L8.50001 1.50015C9.0523 0.947866 9.94773 0.947867 10.5 1.50015C11.0523 2.05244 11.0523 2.94787 10.5 3.50015L3.89686 10.1033C3.74977 10.2504 3.67623 10.3239 3.59144 10.3798C3.51622 10.4294 3.43464 10.4686 3.34892 10.4964C3.2523 10.5277 3.14893 10.5392 2.94218 10.5621L1.25 10.7502L1.43802 9.05797Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgLocationHours() {
  return (
    <svg
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.43427 2.29459C6.77806 1.12653 5.61249 0.412919 4.31634 0.385648C4.26101 0.384472 4.20532 0.384472 4.14997 0.385648C2.85385 0.412919 1.68828 1.12653 1.03204 2.29459C0.361279 3.48853 0.342927 4.92268 0.982943 6.13097L3.6642 9.70591C3.66541 9.70815 3.66661 9.7104 3.66786 9.71262C3.78583 9.9241 3.99716 10.0504 4.2332 10.0504C4.46922 10.0504 4.68055 9.92408 4.7985 9.71262C4.79974 9.7104 4.80095 9.70815 4.80215 9.70591L7.48341 6.13097C8.12339 4.92268 8.10503 3.48853 7.43427 2.29459ZM4.23316 5.43829C3.39473 5.43829 2.71263 4.73475 2.71263 3.86996C2.71263 3.00518 3.39473 2.30163 4.23316 2.30163C5.07158 2.30163 5.75368 3.00518 5.75368 3.86996C5.75368 4.73475 5.0716 5.43829 4.23316 5.43829Z"
        fill="#DA5014"
      />
    </svg>
  );
}

export function SvgPrimes() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1311 7.51983C12.5586 7.92792 11.8581 8.16797 11.1016 8.16797C9.16857 8.16797 7.60156 6.60097 7.60156 4.66797C7.60156 2.73497 9.16857 1.16797 11.1016 1.16797C12.3546 1.16797 13.4538 1.82639 14.0721 2.81611M5.60156 19.2551H8.21185C8.55219 19.2551 8.89045 19.2956 9.22037 19.3766L11.9785 20.0468C12.5769 20.1926 13.2003 20.2068 13.805 20.0894L16.8545 19.4961C17.6601 19.3392 18.4011 18.9534 18.9819 18.3885L21.1395 16.2897C21.7556 15.6913 21.7556 14.7204 21.1395 14.121C20.5847 13.5814 19.7063 13.5207 19.0787 13.9783L16.5642 15.8128C16.204 16.0761 15.7659 16.2178 15.3152 16.2178H12.8871L14.4326 16.2177C15.3038 16.2177 16.0094 15.5313 16.0094 14.6839V14.3771C16.0094 13.6735 15.5171 13.0599 14.8156 12.8898L12.4302 12.3097C12.0419 12.2156 11.6444 12.168 11.2447 12.168C10.2799 12.168 8.53346 12.9668 8.53346 12.9668L5.60156 14.1929M19.6016 5.66797C19.6016 7.60097 18.0346 9.16797 16.1016 9.16797C14.1686 9.16797 12.6016 7.60097 12.6016 5.66797C12.6016 3.73497 14.1686 2.16797 16.1016 2.16797C18.0346 2.16797 19.6016 3.73497 19.6016 5.66797ZM1.60156 13.768L1.60156 19.568C1.60156 20.128 1.60156 20.408 1.71056 20.622C1.80643 20.8101 1.95941 20.9631 2.14757 21.059C2.36148 21.168 2.64151 21.168 3.20156 21.168H4.00156C4.56161 21.168 4.84164 21.168 5.05555 21.059C5.24371 20.9631 5.3967 20.8101 5.49257 20.622C5.60156 20.408 5.60156 20.128 5.60156 19.568V13.768C5.60156 13.2079 5.60156 12.9279 5.49257 12.714C5.3967 12.5258 5.24372 12.3728 5.05555 12.277C4.84164 12.168 4.56162 12.168 4.00156 12.168L3.20156 12.168C2.64151 12.168 2.36148 12.168 2.14757 12.277C1.95941 12.3728 1.80643 12.5258 1.71056 12.714C1.60156 12.9279 1.60156 13.2079 1.60156 13.768Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgTimeClock() {
  return (
    <svg
      width="22"
      height="8"
      viewBox="0 0 22 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.06902 5.09104C6.06902 6.69761 4.71042 8 3.03451 8C1.3586 8 0 6.69761 0 5.09104C0 3.48446 1.3586 2.18208 3.03451 2.18208C4.71042 2.18208 6.06902 3.48446 6.06902 5.09104Z"
        fill="black"
      />
      <path
        d="M14.0345 2.90896C14.0345 4.51554 12.6759 5.81792 11 5.81792C9.32409 5.81792 7.96549 4.51554 7.96549 2.90896C7.96549 1.30239 9.32409 0 11 0C12.6759 0 14.0345 1.30239 14.0345 2.90896Z"
        fill="black"
      />
      <path
        d="M22 5.09104C22 6.69761 20.6414 8 18.9655 8C17.2896 8 15.931 6.69761 15.931 5.09104C15.931 3.48446 17.2896 2.18208 18.9655 2.18208C20.6414 2.18208 22 3.48446 22 5.09104Z"
        fill="black"
      />
    </svg>
  );
}

export function SvgPrimesList() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1357 9.96108C12.3331 9.67469 14.0278 7.84251 14.0278 5.625C14.0278 3.20875 12.0157 1.25 9.53368 1.25C7.2558 1.25 5.37375 2.89979 5.07956 5.03892M10.1757 9.375C10.1757 11.7912 8.16362 13.75 5.6816 13.75C3.19958 13.75 1.1875 11.7912 1.1875 9.375C1.1875 6.95875 3.19958 5 5.6816 5C8.16362 5 10.1757 6.95875 10.1757 9.375Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DeleteElementPrime() {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.38095 3.82534L7.52439 0.699063C7.6751 0.549884 7.6751 0.308374 7.52439 0.159576C7.37407 0.0103968 7.12989 0.0103968 6.97957 0.159576L3.83879 3.28318L0.669017 0.113029C0.518694 -0.0376763 0.274513 -0.0376763 0.124189 0.113029C-0.0261349 0.264116 -0.0261349 0.508678 0.124189 0.659384L3.29167 3.82725L0.112743 6.98863C-0.037581 7.13781 -0.037581 7.37932 0.112743 7.52812C0.263067 7.67729 0.507248 7.67729 0.657571 7.52812L3.83383 4.36941L6.99101 7.52697C7.14134 7.67768 7.38552 7.67768 7.53584 7.52697C7.68616 7.37588 7.68616 7.13132 7.53584 6.98062L4.38095 3.82534Z"
        fill="#121313"
      />
    </svg>
  );
}

export function SvgH() {
  return (
    <svg
      width="36"
      height="30"
      viewBox="0 0 36 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0L33 0C34.6569 0 36 1.34315 36 3L36 27C36 28.6569 34.6569 30 33 30L0 30L0 0Z"
        fill="#F9FAFC"
      />
      <path
        d="M20.9479 19V15.208H16.6879V19H15.5959V10.636H16.6879V14.308H20.9479V10.636H22.0399V19H20.9479Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgMin() {
  return (
    <svg
      width="37"
      height="30"
      viewBox="0 0 37 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 0L33.5 0C35.1569 0 36.5 1.34315 36.5 3L36.5 27C36.5 28.6569 35.1569 30 33.5 30L0.5 30L0.5 0Z"
        fill="#F9FAFC"
      />
      <path
        d="M19.5799 10.696V19H18.4879V12.808L15.7279 19H14.9599L12.1879 12.796V19H11.0959V10.696H12.2719L15.3439 17.56L18.4159 10.696H19.5799ZM21.9958 11.356C21.7878 11.356 21.6118 11.284 21.4678 11.14C21.3238 10.996 21.2518 10.82 21.2518 10.612C21.2518 10.404 21.3238 10.228 21.4678 10.084C21.6118 9.94 21.7878 9.868 21.9958 9.868C22.1958 9.868 22.3638 9.94 22.4998 10.084C22.6438 10.228 22.7158 10.404 22.7158 10.612C22.7158 10.82 22.6438 10.996 22.4998 11.14C22.3638 11.284 22.1958 11.356 21.9958 11.356ZM22.5238 12.424V19H21.4318V12.424H22.5238ZM27.5889 12.304C28.3889 12.304 29.0369 12.548 29.5329 13.036C30.0289 13.516 30.2769 14.212 30.2769 15.124V19H29.1969V15.28C29.1969 14.624 29.0329 14.124 28.7049 13.78C28.3769 13.428 27.9289 13.252 27.3609 13.252C26.7849 13.252 26.3249 13.432 25.9809 13.792C25.6449 14.152 25.4769 14.676 25.4769 15.364V19H24.3849V12.424H25.4769V13.36C25.6929 13.024 25.9849 12.764 26.3529 12.58C26.7289 12.396 27.1409 12.304 27.5889 12.304Z"
        fill="#292929"
      />
    </svg>
  );
}

export function SvgClothes() {
  return (
    <svg
      width="26"
      height="22"
      viewBox="0 0 26 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.23988 0.710938C9.21456 0.711728 9.18941 0.71532 9.16489 0.72165C9.14281 0.726652 9.12128 0.733829 9.10061 0.743075C5.59849 2.14392 2.54864 4.7643 1.04473 7.40632C1.01063 7.46636 0.99545 7.5353 1.00118 7.60411C1.00692 7.67292 1.0333 7.7384 1.07687 7.79197L4.1621 11.5628C4.19109 11.5988 4.22705 11.6285 4.26782 11.6503C4.30859 11.672 4.35333 11.6852 4.39936 11.6892C4.44538 11.6933 4.49174 11.6879 4.53565 11.6735C4.57956 11.6592 4.62012 11.6361 4.65488 11.6057L6.48674 10.0309V19.5758C6.48578 19.6327 6.49899 19.6889 6.52517 19.7394C6.55135 19.7899 6.58968 19.8331 6.63671 19.8651C7.75289 20.6092 9.86398 21.2899 13 21.2899C16.136 21.2899 18.2471 20.6092 19.3633 19.8651C19.4103 19.8331 19.4487 19.7899 19.4748 19.7394C19.501 19.6889 19.5142 19.6327 19.5133 19.5758V10.0309L21.3451 11.6057C21.3799 11.6361 21.4204 11.6592 21.4643 11.6735C21.5083 11.6879 21.5546 11.6933 21.6006 11.6892C21.6467 11.6852 21.6914 11.672 21.7322 11.6503C21.773 11.6285 21.8089 11.5988 21.8379 11.5628L24.9231 7.79197C24.9667 7.7384 24.9931 7.67292 24.9988 7.60411C25.0045 7.5353 24.9894 7.46636 24.9553 7.40632C23.4514 4.7643 20.4015 2.14392 16.8994 0.743075C16.8539 0.724784 16.805 0.716469 16.756 0.718693C16.707 0.720917 16.659 0.733628 16.6154 0.755968C16.5717 0.778307 16.5333 0.809755 16.5029 0.848188C16.4724 0.886621 16.4505 0.931145 16.4387 0.978753C16.3349 1.39481 15.9147 1.86503 15.2818 2.2107C14.6489 2.55637 13.8228 2.77847 13 2.77847C12.1772 2.77847 11.3511 2.55637 10.7182 2.2107C10.0853 1.86503 9.6651 1.39481 9.56125 0.978753C9.54475 0.904903 9.50428 0.838589 9.44615 0.790146C9.38802 0.741702 9.31549 0.713853 9.23988 0.710938ZM9.10061 1.51438C9.35981 2.03416 9.78755 2.4837 10.3861 2.81061C11.1273 3.2154 12.055 3.46408 13 3.46408C13.945 3.46408 14.8727 3.2154 15.6139 2.81061C16.2124 2.4837 16.6402 2.03416 16.8994 1.51438C20.0611 2.84788 22.8249 5.22688 24.2268 7.567L21.5272 10.8558L19.3954 9.03463C19.3459 8.99157 19.285 8.96363 19.2201 8.95413C19.1552 8.94464 19.0889 8.95398 19.0291 8.98105C18.9693 9.00813 18.9185 9.0518 18.8828 9.10687C18.8471 9.16194 18.828 9.2261 18.8277 9.29173V19.3616C17.8417 19.9663 15.9092 20.6042 13 20.6042C10.0908 20.6042 8.15834 19.9663 7.17234 19.3616V9.29173C7.17203 9.2261 7.15289 9.16194 7.11718 9.10687C7.08148 9.0518 7.03072 9.00813 6.97093 8.98105C6.91114 8.95398 6.84484 8.94464 6.7799 8.95413C6.71496 8.96363 6.65411 8.99157 6.60457 9.03463L4.47277 10.8558L1.77319 7.567C3.17507 5.22688 5.93893 2.84788 9.10061 1.51438Z"
        fill="black"
        stroke="black"
      />
    </svg>
  );
}

export function SvgRoundingSchedule() {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 18.333L16 20.333L20.5 15.833M21.4851 11.8829C21.495 11.7008 21.5 11.5175 21.5 11.333C21.5 5.81016 17.0228 1.33301 11.5 1.33301C5.97715 1.33301 1.5 5.81016 1.5 11.333C1.5 16.7684 5.83651 21.191 11.2385 21.3297M11.5 5.33301V11.333L15.2384 13.2022"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgInformation() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99966 0C3.58197 0 0 3.58197 0 7.99966C0 12.4174 3.58197 16 7.99966 16C12.4174 16 16 12.4174 16 7.99966C16 3.58197 12.4174 0 7.99966 0ZM9.66502 12.3984C9.25325 12.5609 8.92546 12.6842 8.67962 12.7695C8.43445 12.8549 8.14933 12.8975 7.82493 12.8975C7.32648 12.8975 6.93841 12.7756 6.6621 12.5325C6.38578 12.2894 6.2483 11.9812 6.2483 11.6067C6.2483 11.4611 6.25845 11.3121 6.27877 11.1604C6.29977 11.0087 6.33295 10.838 6.37833 10.6463L6.89371 8.8259C6.93909 8.65117 6.97837 8.48525 7.00952 8.33084C7.04068 8.17507 7.05558 8.03217 7.05558 7.90214C7.05558 7.67052 7.00749 7.50798 6.912 7.41655C6.81515 7.32512 6.63297 7.28042 6.3614 7.28042C6.22866 7.28042 6.09185 7.30006 5.95166 7.34138C5.81283 7.38404 5.69228 7.42265 5.5934 7.46057L5.72952 6.89981C6.06679 6.76233 6.38984 6.64449 6.69799 6.54696C7.00614 6.44808 7.29735 6.39932 7.57164 6.39932C8.06671 6.39932 8.44868 6.51987 8.71754 6.75826C8.98506 6.99733 9.11983 7.30819 9.11983 7.69016C9.11983 7.7694 9.11035 7.90891 9.09206 8.10802C9.07378 8.30781 9.03924 8.48999 8.98912 8.65727L8.47644 10.4723C8.43445 10.6179 8.39721 10.7845 8.36334 10.9708C8.33016 11.157 8.3139 11.2992 8.3139 11.3947C8.3139 11.6358 8.36741 11.8004 8.47577 11.8877C8.58277 11.9751 8.77037 12.0191 9.03585 12.0191C9.16114 12.0191 9.30133 11.9968 9.45981 11.9534C9.61693 11.9101 9.73071 11.8715 9.8025 11.8383L9.66502 12.3984ZM9.57426 5.03128C9.3352 5.25342 9.04737 5.36449 8.71077 5.36449C8.37486 5.36449 8.085 5.25342 7.84389 5.03128C7.60415 4.80914 7.48292 4.53892 7.48292 4.22332C7.48292 3.9084 7.60483 3.6375 7.84389 3.41333C8.085 3.18849 8.37486 3.07674 8.71077 3.07674C9.04737 3.07674 9.33587 3.18849 9.57426 3.41333C9.81333 3.6375 9.93321 3.9084 9.93321 4.22332C9.93321 4.5396 9.81333 4.80914 9.57426 5.03128Z"
        fill="#3D3F3C"
      />
    </svg>
  );
}

export function SvgStatus() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5049 3.80273L15.6136 3.69307L15.469 3.63873C14.3709 3.22585 13.1814 3.00007 11.9395 3.00007C6.39475 3.00007 1.9 7.49969 1.9 13.05C1.9 14.9573 2.43254 16.7884 3.42159 18.3717C3.8254 19.0181 4.30157 19.6169 4.84006 20.156C5.37773 20.6943 5.97477 21.1704 6.61937 21.5743C8.20196 22.566 10.0326 23.1 11.9395 23.1C17.4843 23.1 21.9791 18.6004 21.9791 13.05C21.9791 11.8322 21.7626 10.6647 21.366 9.58417L21.3118 9.43649L21.2011 9.54825L19.8832 10.8785L19.8431 10.919L19.8575 10.9742C20.0304 11.637 20.1225 12.3327 20.1225 13.05C20.1225 17.5743 16.4587 21.2417 11.9395 21.2417C10.3834 21.2417 8.89379 20.8071 7.60453 19.9992C7.07887 19.6698 6.59177 19.2814 6.15301 18.8421C5.71359 18.4022 5.3251 17.9137 4.9958 17.3865C4.19004 16.0966 3.75659 14.6065 3.75659 13.05C3.75659 8.52582 7.42032 4.8584 11.9395 4.8584C12.6878 4.8584 13.4124 4.9589 14.1007 5.1471L14.157 5.1625L14.1981 5.12104L15.5049 3.80273ZM22.0138 2.66425L22.0138 2.6642L22.0111 2.66185C20.7789 1.59335 18.9129 1.64964 17.7479 2.82533L10.7804 9.85654C10.5723 10.0666 10.4204 10.3257 10.339 10.6101L9.00238 15.2751C8.96867 15.3927 8.96868 15.5174 9.0024 15.635C9.10173 15.9815 9.46291 16.1819 9.80923 16.0825L14.4614 14.746C14.75 14.6631 15.0125 14.5075 15.2239 14.2942L22.1858 7.26904C23.4079 6.03584 23.4042 4.04572 22.1776 2.81706L22.1776 2.81701L22.175 2.81456L22.0138 2.66425ZM11.3862 13.6961L12.1166 11.147L19.066 4.13399C19.5589 3.6366 20.3608 3.63272 20.8585 4.12482L20.9603 4.23785C21.3664 4.74538 21.3358 5.48804 20.8677 5.96035L13.9242 12.967L11.3862 13.6961Z"
        fill="black"
        stroke="black"
        strokeWidth="0.2"
      />
    </svg>
  );
}

export function SvgHourModel() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 9.5H10.5M15.5 13.5H10.5M15.5 5.5H10.5M7 1.5L7 19.5M5.8 1.5H14.2C15.8802 1.5 16.7202 1.5 17.362 1.82698C17.9265 2.1146 18.3854 2.57354 18.673 3.13803C19 3.77976 19 4.61984 19 6.3V14.7C19 16.3802 19 17.2202 18.673 17.862C18.3854 18.4265 17.9265 18.8854 17.362 19.173C16.7202 19.5 15.8802 19.5 14.2 19.5H5.8C4.11984 19.5 3.27976 19.5 2.63803 19.173C2.07354 18.8854 1.6146 18.4265 1.32698 17.862C1 17.2202 1 16.3802 1 14.7V6.3C1 4.61984 1 3.77976 1.32698 3.13803C1.6146 2.57354 2.07354 2.1146 2.63803 1.82698C3.27976 1.5 4.11984 1.5 5.8 1.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgProgress() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 6C12.5 9.31371 9.81371 12 6.5 12C3.18629 12 0.5 9.31371 0.5 6C0.5 2.68629 3.18629 0 6.5 0C9.81371 0 12.5 2.68629 12.5 6Z"
        fill="#A9DD9C"
      />
      <path
        d="M9.63043 6C9.63043 7.72889 8.22889 9.13043 6.5 9.13043C4.77111 9.13043 3.36957 7.72889 3.36957 6C3.36957 4.27111 4.77111 2.86957 6.5 2.86957C8.22889 2.86957 9.63043 4.27111 9.63043 6Z"
        fill="#68C153"
      />
    </svg>
  );
}

export function svgOffline() {
  return (
    <svg
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 4V6M6.5 8H6.505M11.5 6C11.5 8.76142 9.26142 11 6.5 11C3.73858 11 1.5 8.76142 1.5 6C1.5 3.23858 3.73858 1 6.5 1C9.26142 1 11.5 3.23858 11.5 6Z"
        stroke="#DF3431"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgSquareUpRight() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_39950_28583)">
        <path
          d="M10.3335 10.3334V5.66671M10.3335 5.66671H5.66681M10.3335 5.66671L5.66681 10.3333M4.73333 15H11.2667C12.5735 15 13.2269 15 13.726 14.7457C14.165 14.522 14.522 14.165 14.7457 13.726C15 13.2269 15 12.5735 15 11.2667V4.73333C15 3.42654 15 2.77315 14.7457 2.27402C14.522 1.83498 14.165 1.47802 13.726 1.25432C13.2269 1 12.5735 1 11.2667 1H4.73333C3.42654 1 2.77315 1 2.27402 1.25432C1.83498 1.47802 1.47802 1.83498 1.25432 2.27402C1 2.77315 1 3.42654 1 4.73333V11.2667C1 12.5735 1 13.2269 1.25432 13.726C1.47802 14.165 1.83498 14.522 2.27402 14.7457C2.77315 15 3.42654 15 4.73333 15Z"
          stroke="#2E3A59"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_39950_28583">
          <rect
            width="16"
            height="16"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgEditTask() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.03589 13.3328C2.06844 13.0399 2.08471 12.8934 2.12902 12.7566C2.16833 12.6351 2.22388 12.5195 2.29415 12.413C2.37335 12.2929 2.47754 12.1887 2.68592 11.9803L12.0404 2.62586C12.8228 1.84346 14.0913 1.84346 14.8737 2.62587C15.6561 3.40827 15.6561 4.6768 14.8737 5.4592L5.51925 14.8136C5.31088 15.022 5.20669 15.1262 5.08658 15.2054C4.98001 15.2757 4.86445 15.3312 4.74301 15.3705C4.60613 15.4149 4.45968 15.4311 4.16679 15.4637L1.76953 15.73L2.03589 13.3328Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgTaskClosure() {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.88036 10.6102L9.1902 12.9191L13.8079 8.30133M1.34375 10.6106C1.34375 17.3601 3.59424 19.6106 10.3438 19.6106C17.0933 19.6106 19.3438 17.3601 19.3438 10.6106C19.3438 3.86108 17.0933 1.6106 10.3438 1.6106C3.59424 1.6106 1.34375 3.86108 1.34375 10.6106Z"
        stroke="#11142D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PaperUpload2() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_43220_54624"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="2"
        width="18"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 2.00684H21.1681V21.9986H4V2.00684Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_43220_54624)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.59918 3.5087C6.93091 3.5087 5.54555 4.86004 5.50629 6.52657V17.3202C5.47004 19.0331 6.81915 20.4428 8.51561 20.4801H16.6536C18.3339 20.4196 19.6639 19.0331 19.6528 17.3252V8.37032L14.9873 3.5087H8.61126H8.59918ZM8.61625 21.9991H8.48939C5.96031 21.9447 3.94671 19.8422 4.00108 17.3127V6.51703C4.06048 4.01875 6.1224 2.00684 8.60115 2.00684H8.61927H15.3135C15.5189 2.00684 15.7152 2.09041 15.8582 2.23844L20.9586 7.55219C21.0925 7.69215 21.168 7.88046 21.168 8.0748V17.3288C21.1841 19.8553 19.2148 21.9085 16.6848 21.9991H8.61625Z"
          fill="#292929"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4102 9.03263H17.6374C15.794 9.0276 14.2969 7.52521 14.2969 5.68448V2.75522C14.2969 2.33834 14.6352 2 15.052 2C15.4688 2 15.8071 2.33834 15.8071 2.75522V5.68448C15.8071 6.69547 16.6286 7.51917 17.6395 7.52219H20.4102C20.827 7.52219 21.1653 7.86053 21.1653 8.27741C21.1653 8.69429 20.827 9.03263 20.4102 9.03263Z"
        fill="#292929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1926 16.7957C11.7758 16.7957 11.4375 16.4573 11.4375 16.0404V9.95737C11.4375 9.54049 11.7758 9.20215 12.1926 9.20215C12.6094 9.20215 12.9477 9.54049 12.9477 9.95737V16.0404C12.9477 16.4573 12.6094 16.7957 12.1926 16.7957Z"
        fill="#292929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.84079 13.084C9.64849 13.084 9.45518 13.0105 9.30819 12.8635C9.0132 12.5694 9.01119 12.0921 9.30618 11.7961L11.6661 9.42369C11.95 9.13872 12.4534 9.13872 12.7363 9.42369L15.0983 11.7961C15.3923 12.0921 15.3913 12.5694 15.0963 12.8635C14.8003 13.1575 14.3221 13.1575 14.0281 12.8615L12.2017 11.0268L10.3754 12.8615C10.2284 13.0105 10.0341 13.084 9.84079 13.084Z"
        fill="#292929"
      />
    </svg>
  );
}

export function PaperDownload2() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_43220_54642"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="2"
        width="18"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 2.00684H21.1681V21.9986H4V2.00684Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_43220_54642)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.59918 3.5087C6.93091 3.5087 5.54555 4.86004 5.50629 6.52657V17.3202C5.47004 19.0331 6.81915 20.4428 8.51561 20.4801H16.6536C18.3339 20.4196 19.6639 19.0331 19.6528 17.3252V8.37032L14.9873 3.5087H8.61126H8.59918ZM8.61625 21.9991H8.48939C5.96031 21.9447 3.94671 19.8422 4.00108 17.3127V6.51703C4.06048 4.01875 6.1224 2.00684 8.60115 2.00684H8.61927H15.3135C15.5189 2.00684 15.7152 2.09041 15.8582 2.23844L20.9586 7.55219C21.0925 7.69215 21.168 7.88046 21.168 8.0748V17.3288C21.1841 19.8553 19.2148 21.9085 16.6848 21.9991H8.61625Z"
          fill="#292929"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4102 9.03263H17.6374C15.794 9.0276 14.2969 7.52521 14.2969 5.68448V2.75522C14.2969 2.33834 14.6352 2 15.052 2C15.4688 2 15.8071 2.33834 15.8071 2.75522V5.68448C15.8071 6.69547 16.6286 7.51917 17.6395 7.52219H20.4102C20.827 7.52219 21.1653 7.86053 21.1653 8.27741C21.1653 8.69429 20.827 9.03263 20.4102 9.03263Z"
        fill="#292929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2017 9.20336C12.6185 9.20336 12.9568 9.5417 12.9568 9.95858L12.9568 16.0417C12.9568 16.4585 12.6185 16.7969 12.2017 16.7969C11.7848 16.7969 11.4466 16.4585 11.4466 16.0417L11.4466 9.95858C11.4466 9.5417 11.7849 9.20336 12.2017 9.20336Z"
        fill="#292929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5576 12.9153C14.7499 12.9153 14.9433 12.9889 15.0902 13.1359C15.3852 13.4299 15.3873 13.9072 15.0923 14.2032L12.7323 16.5757C12.4484 16.8606 11.945 16.8606 11.6621 16.5757L9.30014 14.2032C9.00615 13.9072 9.00716 13.4299 9.30215 13.1359C9.59815 12.8418 10.0764 12.8418 10.3704 13.1379L12.1967 14.9726L14.023 13.1379C14.17 12.9889 14.3643 12.9153 14.5576 12.9153Z"
        fill="#292929"
      />
    </svg>
  );
}

export function svgBulkEdit() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="20"
        height="20"
        transform="translate(0.5)"
        fill="white"
      />
      <path
        d="M6.30399 11.956C6.34249 11.8213 6.36174 11.7539 6.3906 11.6911C6.41622 11.6353 6.44743 11.5822 6.48377 11.5327C6.52469 11.477 6.57424 11.4274 6.67334 11.3283L12.5319 5.4698C13.1583 4.84341 14.1738 4.8434 14.8002 5.46978C15.4266 6.09617 15.4266 7.11178 14.8002 7.73818L8.94168 13.5967C8.84258 13.6958 8.79303 13.7453 8.73729 13.7862C8.6878 13.8226 8.63474 13.8538 8.57894 13.8794C8.5161 13.9083 8.44873 13.9275 8.31397 13.966L5.5 14.77L6.30399 11.956Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2.25"
        y="1.75"
        width="16.5"
        height="16.5"
        rx="1.25"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  );
}
export function SvgSettingsModeleEvaluation() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 9.5H10.5M15.5 13.5H10.5M15.5 5.5H10.5M7 1.5L7 19.5M5.8 1.5H14.2C15.8802 1.5 16.7202 1.5 17.362 1.82698C17.9265 2.1146 18.3854 2.57354 18.673 3.13803C19 3.77976 19 4.61984 19 6.3V14.7C19 16.3802 19 17.2202 18.673 17.862C18.3854 18.4265 17.9265 18.8854 17.362 19.173C16.7202 19.5 15.8802 19.5 14.2 19.5H5.8C4.11984 19.5 3.27976 19.5 2.63803 19.173C2.07354 18.8854 1.6146 18.4265 1.32698 17.862C1 17.2202 1 16.3802 1 14.7V6.3C1 4.61984 1 3.77976 1.32698 3.13803C1.6146 2.57354 2.07354 2.1146 2.63803 1.82698C3.27976 1.5 4.11984 1.5 5.8 1.5Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgWhiteDownloadIcon() {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 11V12C16.5 13.4001 16.5 14.1002 16.2275 14.635C15.9878 15.1054 15.6054 15.4878 15.135 15.7275C14.6002 16 13.9001 16 12.5 16H5.5C4.09987 16 3.3998 16 2.86502 15.7275C2.39462 15.4878 2.01217 15.1054 1.77248 14.635C1.5 14.1002 1.5 13.4001 1.5 12V11M13.1667 6.83333L9 11M9 11L4.83333 6.83333M9 11V1"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgWhiteUploadIcon() {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 11V12C16.5 13.4001 16.5 14.1002 16.2275 14.635C15.9878 15.1054 15.6054 15.4878 15.135 15.7275C14.6002 16 13.9001 16 12.5 16H5.5C4.09987 16 3.3998 16 2.86502 15.7275C2.39462 15.4878 2.01217 15.1054 1.77248 14.635C1.5 14.1002 1.5 13.4001 1.5 12V11M13.1667 5.16667L9 1M9 1L4.83333 5.16667M9 1V11"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgBlackArrowLeft() {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.292893 8.70711C-0.0976314 8.31658 -0.0976315 7.68342 0.292892 7.29289L6.65685 0.928933C7.04738 0.538409 7.68054 0.538409 8.07107 0.928933C8.46159 1.31946 8.46159 1.95262 8.07107 2.34315L2.41421 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68054 15.4616 7.04738 15.4616 6.65686 15.0711L0.292893 8.70711ZM20 8L20 9L1 9L1 8L1 7L20 7L20 8Z"
        fill="black"
      />
    </svg>
  );
}

export function SvgBlackArrowRight() {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7071 8.70711C20.0976 8.31658 20.0976 7.68342 19.7071 7.29289L13.3431 0.928933C12.9526 0.538409 12.3195 0.538409 11.9289 0.928933C11.5384 1.31946 11.5384 1.95262 11.9289 2.34315L17.5858 8L11.9289 13.6569C11.5384 14.0474 11.5384 14.6805 11.9289 15.0711C12.3195 15.4616 12.9526 15.4616 13.3431 15.0711L19.7071 8.70711ZM0 8L-8.74227e-08 9L19 9L19 8L19 7L8.74227e-08 7L0 8Z"
        fill="black"
      />
    </svg>
  );
}

export function SvgHeadTitleIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33073 14.7153V16.6665C8.33073 17.587 9.07692 18.3332 9.9974 18.3332C10.9179 18.3332 11.6641 17.587 11.6641 16.6665V14.7153M9.9974 1.6665V2.49984M2.4974 9.99984H1.66406M4.58073 4.58317L4.08065 4.08309M15.4141 4.58317L15.9143 4.08309M18.3307 9.99984H17.4974M14.9974 9.99984C14.9974 12.7613 12.7588 14.9998 9.9974 14.9998C7.23597 14.9998 4.9974 12.7613 4.9974 9.99984C4.9974 7.23841 7.23597 4.99984 9.9974 4.99984C12.7588 4.99984 14.9974 7.23841 14.9974 9.99984Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function InfoOrange() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.9974 13.3311C9.21129 13.3311 9.38698 13.2623 9.52448 13.1248C9.66198 12.9873 9.73073 12.8116 9.73073 12.5978C9.73073 12.3839 9.66198 12.2082 9.52448 12.0707C9.38698 11.9332 9.21129 11.8644 8.9974 11.8644C8.78351 11.8644 8.60781 11.9332 8.47031 12.0707C8.33281 12.2082 8.26406 12.3839 8.26406 12.5978C8.26406 12.8116 8.33281 12.9873 8.47031 13.1248C8.60781 13.2623 8.78351 13.3311 8.9974 13.3311ZM8.3099 9.98525H9.6849V4.48525H8.3099V9.98525ZM8.9974 17.7082C7.79045 17.7082 6.65623 17.479 5.59473 17.0207C4.53262 16.5623 3.61198 15.9436 2.83281 15.1644C2.05365 14.3853 1.4349 13.4646 0.976563 12.4025C0.518229 11.341 0.289062 10.2068 0.289062 8.99984C0.289062 7.79289 0.518229 6.65837 0.976563 5.59625C1.4349 4.53475 2.05365 3.61442 2.83281 2.83525C3.61198 2.05609 4.53262 1.43734 5.59473 0.979004C6.65623 0.520671 7.79045 0.291504 8.9974 0.291504C10.2043 0.291504 11.3389 0.520671 12.401 0.979004C13.4625 1.43734 14.3828 2.05609 15.162 2.83525C15.9411 3.61442 16.5599 4.53475 17.0182 5.59625C17.4766 6.65837 17.7057 7.79289 17.7057 8.99984C17.7057 10.2068 17.4766 11.341 17.0182 12.4025C16.5599 13.4646 15.9411 14.3853 15.162 15.1644C14.3828 15.9436 13.4625 16.5623 12.401 17.0207C11.3389 17.479 10.2043 17.7082 8.9974 17.7082ZM8.9974 16.3332C11.0446 16.3332 12.7786 15.6228 14.1995 14.2019C15.6203 12.7811 16.3307 11.0471 16.3307 8.99984C16.3307 6.95262 15.6203 5.21859 14.1995 3.79775C12.7786 2.37692 11.0446 1.6665 8.9974 1.6665C6.95017 1.6665 5.21615 2.37692 3.79531 3.79775C2.37448 5.21859 1.66406 6.95262 1.66406 8.99984C1.66406 11.0471 2.37448 12.7811 3.79531 14.2019C5.21615 15.6228 6.95017 16.3332 8.9974 16.3332Z"
        fill="#DF5023"
      />
    </svg>
  );
}

// Bouton Précedent and Suivant avec fleche
export function BtnPrecedent() {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.9974 0.14567L7.89323 1.0415L3.03906 5.87484L13.3516 5.87484L13.3516 7.12484L3.03906 7.12484L7.89323 11.9582L6.9974 12.854L0.64323 6.49984L6.9974 0.14567Z"
        fill="#11142D"
      />
    </svg>
  );
}
export function BtnNext() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5026 12.8543L5.60677 11.9585L10.4609 7.12516H0.148438V5.87516H10.4609L5.60677 1.04183L6.5026 0.145996L12.8568 6.50016L6.5026 12.8543Z"
        fill="#11142D"
      />
    </svg>
  );
}
// END Bouton Précedent and Suivant avec fleche

export function SvgLegally() {
  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.125 7.18797L5.375 8.43797L8.1875 5.62547M11 7.50047C11 10.5682 7.65377 12.7995 6.43624 13.5098C6.29787 13.5905 6.22869 13.6309 6.13105 13.6518C6.05528 13.668 5.94472 13.668 5.86895 13.6518C5.77131 13.6309 5.70213 13.5905 5.56376 13.5098C4.34623 12.7995 1 10.5682 1 7.50047V4.51147C1 4.01177 1 3.76193 1.08173 3.54716C1.15392 3.35743 1.27124 3.18814 1.42354 3.05392C1.59593 2.90199 1.82987 2.81427 2.29775 2.63881L5.64888 1.38214C5.77881 1.33341 5.84378 1.30905 5.91061 1.29939C5.9699 1.29083 6.0301 1.29083 6.08938 1.29939C6.15622 1.30905 6.22119 1.33341 6.35112 1.38214L9.70225 2.63881C10.1701 2.81427 10.4041 2.90199 10.5765 3.05392C10.7288 3.18814 10.8461 3.35743 10.9183 3.54716C11 3.76193 11 4.01177 11 4.51147V7.50047Z"
        stroke="#627A71"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// File Signature electronique

export function CheckedSignFile() {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Checked sign"
    >
      <rect
        width="19"
        height="20"
        fill="url(#pattern0)"
      />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            href="#image0"
            transform="matrix(0.00236967 0 0 0.00225118 0 -0.00651659)"
          />
        </pattern>
        <image
          id="image0"
          width="422"
          height="450"
          preserveAspectRatio="none"
          href="data:image/png;base64,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"
        />
      </defs>
    </svg>
  );
}

export function SvgSettingCalendar() {
  return (
    <svg
      width="20"
      height="23"
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 9.5H1M14 1.5V5.5M6 1.5V5.5M5.8 21.5H14.2C15.8802 21.5 16.7202 21.5 17.362 21.173C17.9265 20.8854 18.3854 20.4265 18.673 19.862C19 19.2202 19 18.3802 19 16.7V8.3C19 6.61984 19 5.77976 18.673 5.13803C18.3854 4.57354 17.9265 4.1146 17.362 3.82698C16.7202 3.5 15.8802 3.5 14.2 3.5H5.8C4.11984 3.5 3.27976 3.5 2.63803 3.82698C2.07354 4.1146 1.6146 4.57354 1.32698 5.13803C1 5.77976 1 6.61984 1 8.3V16.7C1 18.3802 1 19.2202 1.32698 19.862C1.6146 20.4265 2.07354 20.8854 2.63803 21.173C3.27976 21.5 4.11984 21.5 5.8 21.5Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

// End File Signature electronique

// Module Implantation
export function SvgImplantationSidebar() {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="21"
        height="21"
        rx="4"
        fill="#0069CA"
      />
      <path
        d="M10.5 15.5001H6.25001C5.54994 15.5001 5.19991 15.5001 4.93252 15.3638C4.69731 15.244 4.50609 15.0528 4.38624 14.8176C4.25 14.5502 4.25 14.2001 4.25 13.5001V7.50001C4.25 6.79994 4.25 6.44991 4.38624 6.18252C4.50609 5.94731 4.69731 5.75609 4.93252 5.63624C5.19991 5.5 5.54994 5.5 6.25001 5.5H6.50001C7.90016 5.5 8.60023 5.5 9.13501 5.77249C9.60542 6.01217 9.98787 6.39462 10.2276 6.86503C10.5 7.39982 10.5 8.09989 10.5 9.50003M10.5 15.5001V9.50003M10.5 15.5001H14.7501C15.4501 15.5001 15.8002 15.5001 16.0676 15.3638C16.3028 15.244 16.494 15.0528 16.6138 14.8176C16.7501 14.5502 16.7501 14.2001 16.7501 13.5001V7.50001C16.7501 6.79994 16.7501 6.44991 16.6138 6.18252C16.494 5.94731 16.3028 5.75609 16.0676 5.63624C15.8002 5.5 15.4501 5.5 14.7501 5.5H14.5001C13.0999 5.5 12.3999 5.5 11.8651 5.77249C11.3947 6.01217 11.0122 6.39462 10.7725 6.86503C10.5 7.39982 10.5 8.09989 10.5 9.50003"
        stroke="white"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function SvgLinkVideo() {
  return (
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9818 2.99986C17.8918 2.64035 17.7086 2.31094 17.4505 2.04492C17.1925 1.7789 16.8688 1.58568 16.5122 1.48479C15.2092 1.16663 9.9974 1.16663 9.9974 1.16663C9.9974 1.16663 4.78555 1.16663 3.48258 1.51509C3.12597 1.61599 2.8023 1.8092 2.54426 2.07522C2.28622 2.34124 2.10295 2.67065 2.01296 3.03017C1.7745 4.35249 1.65786 5.6939 1.6645 7.03753C1.656 8.39129 1.77265 9.74293 2.01296 11.0752C2.11217 11.4236 2.29954 11.7404 2.55698 11.9952C2.81442 12.25 3.13322 12.4341 3.48258 12.5297C4.78555 12.8781 9.9974 12.8781 9.9974 12.8781C9.9974 12.8781 15.2092 12.8781 16.5122 12.5297C16.8688 12.4288 17.1925 12.2356 17.4505 11.9695C17.7086 11.7035 17.8918 11.3741 17.9818 11.0146C18.2185 9.70224 18.3351 8.37105 18.3303 7.03753C18.3388 5.68378 18.2221 4.33214 17.9818 2.99986Z"
        stroke="black"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.1224 4.88774C8.1224 4.49 8.1224 4.29113 8.20551 4.18011C8.27795 4.08336 8.38882 4.02282 8.50938 4.01421C8.64772 4.00433 8.815 4.11187 9.14957 4.32695L12.4352 6.43917C12.7256 6.62581 12.8707 6.71913 12.9209 6.83779C12.9647 6.94146 12.9647 7.05846 12.9209 7.16213C12.8707 7.28079 12.7256 7.37411 12.4352 7.56075L9.14957 9.67297C8.815 9.88805 8.64772 9.99559 8.50938 9.98571C8.38882 9.9771 8.27795 9.91656 8.20551 9.81981C8.1224 9.70879 8.1224 9.50992 8.1224 9.11218V4.88774Z"
        stroke="black"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgLinkDocument() {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 14.75L8.92496 14.6374C8.40398 13.856 8.14349 13.4652 7.79933 13.1824C7.49464 12.9319 7.14357 12.7441 6.7662 12.6295C6.33994 12.5 5.87033 12.5 4.93112 12.5H3.9C3.05992 12.5 2.63988 12.5 2.31901 12.3365C2.03677 12.1927 1.8073 11.9632 1.66349 11.681C1.5 11.3601 1.5 10.9401 1.5 10.1V3.65C1.5 2.80992 1.5 2.38988 1.66349 2.06901C1.8073 1.78677 2.03677 1.5573 2.31901 1.41349C2.63988 1.25 3.05992 1.25 3.9 1.25H4.2C5.88016 1.25 6.72024 1.25 7.36197 1.57698C7.92646 1.8646 8.3854 2.32354 8.67302 2.88803C9 3.52976 9 4.36984 9 6.05M9 14.75V6.05M9 14.75L9.07504 14.6374C9.59602 13.856 9.85651 13.4652 10.2007 13.1824C10.5054 12.9319 10.8564 12.7441 11.2338 12.6295C11.6601 12.5 12.1297 12.5 13.0689 12.5H14.1C14.9401 12.5 15.3601 12.5 15.681 12.3365C15.9632 12.1927 16.1927 11.9632 16.3365 11.681C16.5 11.3601 16.5 10.9401 16.5 10.1V3.65C16.5 2.80992 16.5 2.38988 16.3365 2.06901C16.1927 1.78677 15.9632 1.5573 15.681 1.41349C15.3601 1.25 14.9401 1.25 14.1 1.25H13.8C12.1198 1.25 11.2798 1.25 10.638 1.57698C10.0735 1.8646 9.6146 2.32354 9.32698 2.88803C9 3.52976 9 4.36984 9 6.05"
        stroke="black"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgCameraVideo() {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1693 5.18713C20.1693 4.6318 20.1693 4.35413 20.0595 4.22556C19.9642 4.114 19.8212 4.05479 19.675 4.0663C19.5064 4.07957 19.3101 4.27591 18.9174 4.66859L15.5859 8.00004L18.9174 11.3315C19.3101 11.7242 19.5064 11.9205 19.675 11.9338C19.8212 11.9453 19.9642 11.8861 20.0595 11.7745C20.1693 11.6459 20.1693 11.3683 20.1693 10.8129V5.18713Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.83594 5.98337C1.83594 4.44323 1.83594 3.67316 2.13567 3.0849C2.39932 2.56745 2.82002 2.14676 3.33746 1.88311C3.92572 1.58337 4.69579 1.58337 6.23594 1.58337H11.1859C12.7261 1.58337 13.4962 1.58337 14.0844 1.88311C14.6019 2.14676 15.0226 2.56745 15.2862 3.0849C15.5859 3.67316 15.5859 4.44323 15.5859 5.98337V10.0167C15.5859 11.5569 15.5859 12.3269 15.2862 12.9152C15.0226 13.4326 14.6019 13.8533 14.0844 14.117C13.4962 14.4167 12.7261 14.4167 11.1859 14.4167H6.23594C4.69579 14.4167 3.92572 14.4167 3.33746 14.117C2.82002 13.8533 2.39932 13.4326 2.13567 12.9152C1.83594 12.3269 1.83594 11.5569 1.83594 10.0167V5.98337Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
// End Module Implantation

export function SvgDetail() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.4974 11.8333V8.99996M8.4974 6.16663H8.50448M15.5807 8.99996C15.5807 12.912 12.4094 16.0833 8.4974 16.0833C4.58538 16.0833 1.41406 12.912 1.41406 8.99996C1.41406 5.08794 4.58538 1.91663 8.4974 1.91663C12.4094 1.91663 15.5807 5.08794 15.5807 8.99996Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgTimeZone() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9268 2.0166C19.4706 2.0166 23.9805 6.52676 23.9805 12.0703C23.9805 17.6129 19.472 22.1223 13.9297 22.124V22.123L13.9277 22.124L13.9238 22.123C13.0039 22.1228 12.0966 21.9968 11.2197 21.752C10.3158 23.0951 8.78442 23.9834 7.0459 23.9834C4.27132 23.9833 2.01393 21.7267 2.01367 18.9521C2.01367 17.2134 2.90178 15.6803 4.24512 14.7764C4.00026 13.8987 3.87402 12.9903 3.87402 12.0703C3.87404 6.52689 8.38337 2.01681 13.9268 2.0166ZM7.0459 14.9639C4.84707 14.9639 3.05762 16.7533 3.05762 18.9521C3.05787 21.1508 4.84722 22.9394 7.0459 22.9395C9.24464 22.9395 11.0339 21.1508 11.0342 18.9521C11.0342 16.7533 9.2448 14.9639 7.0459 14.9639ZM11.2861 16.252C11.7852 17.0325 12.0781 17.9577 12.0781 18.9512C12.0781 19.0957 12.0696 19.2383 12.0576 19.3789C12.3476 19.9367 12.6593 20.3627 12.9766 20.6484C13.3001 20.9398 13.6208 21.0784 13.9248 21.0791H13.9287C14.4535 21.0782 15.0364 20.6502 15.5752 19.7764C16.088 18.9446 16.5357 17.7442 16.8359 16.252H11.2861ZM17.8945 16.252C17.5273 18.1736 16.9082 19.7678 16.1182 20.8076C18.6281 20.1779 20.7205 18.4922 21.9004 16.252H17.8945ZM7.0459 16.084C7.33395 16.084 7.56813 16.3175 7.56836 16.6055V18.6504L8.7959 19.3594C9.01421 19.4854 9.10686 19.7454 9.03027 19.9756L8.9873 20.0723C8.8907 20.2395 8.71533 20.3329 8.53516 20.333C8.46837 20.333 8.40089 20.3203 8.33691 20.2939L8.27441 20.2637L6.78516 19.4033C6.62385 19.3101 6.52458 19.1383 6.52441 18.9521V16.6055C6.52465 16.3176 6.75802 16.0842 7.0459 16.084ZM18.0635 8.93262C18.1975 9.91631 18.2725 10.9694 18.2725 12.0703C18.2725 13.1713 18.1975 14.2244 18.0635 15.208H22.3682C22.733 14.23 22.9365 13.174 22.9365 12.0703C22.9365 10.9667 22.7341 9.91046 22.3691 8.93262H18.0635ZM10.8398 8.93262C10.7045 9.88981 10.626 10.941 10.626 12.0703C10.626 13.1554 10.7037 14.2055 10.8486 15.208H17.0146C17.1501 14.2506 17.2285 13.1997 17.2285 12.0703C17.2285 10.941 17.15 9.88981 17.0146 8.93262H10.8398ZM5.48535 8.93262C5.12041 9.91049 4.91797 10.9667 4.91797 12.0703C4.91797 12.8185 5.01081 13.5577 5.19141 14.2754C5.76563 14.0467 6.3912 13.92 7.0459 13.9199C8.03263 13.9199 8.95305 14.2074 9.73047 14.7002C9.63452 13.8494 9.58203 12.9701 9.58203 12.0703C9.58203 10.9694 9.65697 9.91618 9.79102 8.93262H5.48535ZM16.1182 3.33203C16.9084 4.37176 17.5272 5.96649 17.8945 7.88867H21.9004C20.7207 5.64825 18.6281 3.96169 16.1182 3.33203ZM13.9268 3.06055C13.4021 3.06075 12.8193 3.48872 12.2803 4.3623C11.767 5.19421 11.319 6.39557 11.0186 7.88867H16.8359C16.5355 6.39546 16.0875 5.19418 15.5742 4.3623C15.035 3.48852 14.4516 3.06055 13.9268 3.06055ZM11.7354 3.33203C9.22575 3.96183 7.13391 5.64844 5.9541 7.88867H9.95996C10.3272 5.96673 10.9453 4.37177 11.7354 3.33203Z"
        fill="#F55611"
        stroke="#F55611"
        stroke-width="0.3"
      />
    </svg>
  );
}

export function SvgVisibility(color = "#4472A3") {
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.01677 8.09432C0.90328 7.91462 0.846535 7.82477 0.81477 7.68618C0.79091 7.58209 0.79091 7.41792 0.81477 7.31383C0.846535 7.17524 0.90328 7.08539 1.01677 6.90569C1.95461 5.42071 4.74617 1.66667 9.00034 1.66667C13.2545 1.66667 16.0461 5.42071 16.9839 6.90569C17.0974 7.08539 17.1541 7.17524 17.1859 7.31383C17.2098 7.41792 17.2098 7.58209 17.1859 7.68618C17.1541 7.82477 17.0974 7.91462 16.9839 8.09432C16.0461 9.5793 13.2545 13.3333 9.00034 13.3333C4.74617 13.3333 1.95461 9.5793 1.01677 8.09432Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.00034 10C10.381 10 11.5003 8.88072 11.5003 7.5C11.5003 6.11929 10.381 5.00001 9.00034 5.00001C7.61962 5.00001 6.50034 6.11929 6.50034 7.5C6.50034 8.88072 7.61962 10 9.00034 10Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgMessageAlert() {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33129 6.80235V4.26382M8.33129 9.34088H8.33854M8.33129 13.33C11.7361 13.33 14.4963 10.5698 14.4963 7.165C14.4963 3.76016 11.7361 1 8.33129 1C4.92645 1 2.16629 3.76016 2.16629 7.165C2.16629 7.85403 2.27933 8.51665 2.48786 9.13534C2.56634 9.36817 2.60558 9.48458 2.61266 9.57401C2.61965 9.66233 2.61436 9.72425 2.59251 9.81011C2.57039 9.89705 2.52154 9.98747 2.42384 10.1683L1.2375 12.3642C1.06829 12.6774 0.983676 12.834 1.00261 12.9549C1.01911 13.0601 1.08107 13.1528 1.17204 13.2083C1.27648 13.272 1.45354 13.2537 1.80766 13.2171L5.52191 12.8332C5.63439 12.8216 5.69063 12.8157 5.74189 12.8177C5.79231 12.8196 5.8279 12.8244 5.87706 12.8357C5.92705 12.8472 5.98991 12.8714 6.11563 12.9199C6.80325 13.1848 7.55031 13.33 8.33129 13.33Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgNightAlert() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6392 8.63783C13.7212 10.248 11.9887 11.3336 10.0026 11.3336C7.05709 11.3336 4.66927 8.94582 4.66927 6.0003C4.66927 4.01406 5.75505 2.28141 7.36545 1.36353C3.98243 1.68429 1.33594 4.53315 1.33594 8.00014C1.33594 11.682 4.32071 14.6668 8.0026 14.6668C11.4694 14.6668 14.3182 12.0206 14.6392 8.63783Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgClockWithDownload(color = "#F55611") {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6364 8.66659C14.6581 8.44731 14.6693 8.22492 14.6693 7.99992C14.6693 4.31802 11.6845 1.33325 8.0026 1.33325C4.32071 1.33325 1.33594 4.31802 1.33594 7.99992C1.33594 11.6818 4.32071 14.6666 8.0026 14.6666C8.11438 14.6666 8.22551 14.6638 8.33594 14.6584C8.4478 14.6529 8.55893 14.6446 8.66927 14.6337M8.0026 3.99992V7.99992L10.4949 9.24604M11.0026 12.8879L13.0026 14.8879M13.0026 14.8879L15.0026 12.8879M13.0026 14.8879V10.8879"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgWallet() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 6.99983V3.50048C14 2.66874 14 2.25287 13.8248 1.9973C13.6717 1.77401 13.4346 1.62232 13.1678 1.57691C12.8623 1.52493 12.4847 1.6992 11.7295 2.04775L2.85901 6.14182C2.18551 6.45267 1.84875 6.6081 1.60211 6.84915C1.38406 7.06225 1.21762 7.32238 1.1155 7.60966C1 7.93462 1 8.30551 1 9.04729V13.9998M14.5 13.4998H14.51M1 10.1998L1 16.7998C1 17.9199 1 18.48 1.21799 18.9078C1.40973 19.2841 1.71569 19.5901 2.09202 19.7818C2.51984 19.9998 3.07989 19.9998 4.2 19.9998H15.8C16.9201 19.9998 17.4802 19.9998 17.908 19.7818C18.2843 19.5901 18.5903 19.2841 18.782 18.9078C19 18.48 19 17.9199 19 16.7998V10.1998C19 9.07972 19 8.51967 18.782 8.09185C18.5903 7.71552 18.2843 7.40956 17.908 7.21782C17.4802 6.99983 16.9201 6.99983 15.8 6.99983L4.2 6.99983C3.0799 6.99983 2.51984 6.99983 2.09202 7.21781C1.7157 7.40956 1.40973 7.71552 1.21799 8.09185C1 8.51967 1 9.07972 1 10.1998ZM15 13.4998C15 13.776 14.7761 13.9998 14.5 13.9998C14.2239 13.9998 14 13.776 14 13.4998C14 13.2237 14.2239 12.9998 14.5 12.9998C14.7761 12.9998 15 13.2237 15 13.4998Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgRecordEmployeeSetting() {
  return (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 13H7C5.13623 13 4.20435 13 3.46927 13.3045C2.48915 13.7105 1.71046 14.4892 1.30448 15.4693C1 16.2044 1 17.1362 1 19M14.5 1.29076C15.9659 1.88415 17 3.32131 17 5M10.9999 19.5L13.025 19.095C13.2015 19.0597 13.2898 19.042 13.3721 19.0097C13.4452 18.9811 13.5147 18.9439 13.579 18.899C13.6516 18.8484 13.7152 18.7848 13.8426 18.6574L20.5 12C21.0524 11.4477 21.0523 10.5523 20.5 9.99997C19.9477 9.4477 19.0523 9.44771 18.5 9.99999L11.8425 16.6575C11.7152 16.7848 11.6516 16.8484 11.601 16.921C11.5561 16.9853 11.5189 17.0548 11.4902 17.1278C11.458 17.2102 11.4403 17.2984 11.405 17.475L10.9999 19.5ZM12.5 5C12.5 7.20914 10.7091 9 8.5 9C6.29086 9 4.5 7.20914 4.5 5C4.5 2.79086 6.29086 1 8.5 1C10.7091 1 12.5 2.79086 12.5 5Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgItemAdditionalInformation() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="12"
      viewBox="0 0 21 12"
      fill="none"
    >
      <path
        d="M10.1667 6H10.1713M14.75 6H14.7546M5.58333 6H5.58792M3.93333 1H16.4C17.4268 1 17.9401 1 18.3323 1.21799C18.6773 1.40973 18.9577 1.71569 19.1335 2.09202C19.3333 2.51984 19.3333 3.0799 19.3333 4.2V7.8C19.3333 8.9201 19.3333 9.48016 19.1335 9.90798C18.9577 10.2843 18.6773 10.5903 18.3323 10.782C17.9401 11 17.4268 11 16.4 11H3.93333C2.90657 11 2.39319 11 2.00102 10.782C1.65605 10.5903 1.37559 10.2843 1.19982 9.90798C1 9.48016 1 8.9201 1 7.8V4.2C1 3.0799 1 2.51984 1.19982 2.09202C1.37559 1.71569 1.65605 1.40973 2.00102 1.21799C2.39319 1 2.90657 1 3.93333 1ZM10.3958 6C10.3958 6.13807 10.2932 6.25 10.1667 6.25C10.0401 6.25 9.9375 6.13807 9.9375 6C9.9375 5.86193 10.0401 5.75 10.1667 5.75C10.2932 5.75 10.3958 5.86193 10.3958 6ZM14.9792 6C14.9792 6.13807 14.8766 6.25 14.75 6.25C14.6234 6.25 14.5208 6.13807 14.5208 6C14.5208 5.86193 14.6234 5.75 14.75 5.75C14.8766 5.75 14.9792 5.86193 14.9792 6ZM5.8125 6C5.8125 6.13807 5.7099 6.25 5.58333 6.25C5.45677 6.25 5.35417 6.13807 5.35417 6C5.35417 5.86193 5.45677 5.75 5.58333 5.75C5.7099 5.75 5.8125 5.86193 5.8125 6Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgSectionEnterpriseAdditionalInfo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 14V10M10 6H10.01M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgUserUp() {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5651 13.4004L15.0651 10.9004M15.0651 10.9004L17.5651 13.4004M15.0651 10.9004V15.9004M9.23177 11.3171H5.48177C4.3188 11.3171 3.73732 11.3171 3.26415 11.4606C2.19882 11.7838 1.36514 12.6174 1.04197 13.6828C0.898438 14.1559 0.898438 14.7374 0.898438 15.9004M11.3151 4.65039C11.3151 6.72146 9.63617 8.40039 7.5651 8.40039C5.49404 8.40039 3.8151 6.72146 3.8151 4.65039C3.8151 2.57932 5.49404 0.900391 7.5651 0.900391C9.63617 0.900391 11.3151 2.57932 11.3151 4.65039Z"
        stroke="black"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgEyeGreen() {
  return (
    <svg
      width="17"
      height="12"
      viewBox="0 0 17 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.947904 6.53488C0.845764 6.37315 0.794694 6.29229 0.766105 6.16756C0.744632 6.07387 0.744632 5.92613 0.766105 5.83244C0.794694 5.70771 0.845764 5.62685 0.947904 5.46512C1.79196 4.12863 4.30436 0.75 8.13312 0.75C11.9619 0.75 14.4743 4.12863 15.3183 5.46512C15.4205 5.62685 15.4715 5.70771 15.5001 5.83244C15.5216 5.92613 15.5216 6.07387 15.5001 6.16756C15.4715 6.29229 15.4205 6.37315 15.3183 6.53488C14.4743 7.87137 11.9619 11.25 8.13312 11.25C4.30436 11.25 1.79196 7.87137 0.947904 6.53488Z"
        stroke="#73C7B7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.13312 8.25C9.37576 8.25 10.3831 7.24264 10.3831 6C10.3831 4.75736 9.37576 3.75 8.13312 3.75C6.89047 3.75 5.88312 4.75736 5.88312 6C5.88312 7.24264 6.89047 8.25 8.13312 8.25Z"
        stroke="#73C7B7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function SVGFormationetSupport() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.7673 7.96328V18.095C12.1961 17.6488 10.4917 12.363 10.3359 9.77583V0.108887C15.7576 0.406331 17.5492 5.46908 17.7673 7.96328Z"
        fill="#FA966B"
      />
      <ellipse
        cx="4.20035"
        cy="12.8699"
        rx="4.20035"
        ry="4.2542"
        fill="#73C7B7"
      />
      <path
        d="M9.25784 5.00203C8.36344 5.30103 7.89139 6.74618 7.76717 7.43138H0.220628C0.174044 6.6216 0.220628 4.39393 2.13055 2.57269C4.40383 0.404964 7.82928 -0.043531 9.25784 0.00318715V5.00203Z"
        fill="#4472A3"
      />
    </svg>
  );
}

export function SvgIconNo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M3.44167 3.44167L15.225 15.225M17.6667 9.33333C17.6667 13.9357 13.9357 17.6667 9.33333 17.6667C4.73096 17.6667 1 13.9357 1 9.33333C1 4.73096 4.73096 1 9.33333 1C13.9357 1 17.6667 4.73096 17.6667 9.33333Z"
        stroke="#DA5014"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgIconYes() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M5.58333 9.33333L8.08333 11.8333L13.0833 6.83333M17.6667 9.33333C17.6667 13.9357 13.9357 17.6667 9.33333 17.6667C4.73096 17.6667 1 13.9357 1 9.33333C1 4.73096 4.73096 1 9.33333 1C13.9357 1 17.6667 4.73096 17.6667 9.33333Z"
        stroke="#2DAA7F"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

// Icones Sondages
export function SvgSondages({ color = "#292929" }) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.75 4.08333H2.08333C1.61662 4.08333 1.38327 4.08333 1.20501 4.17416C1.04821 4.25406 0.920722 4.38154 0.840828 4.53834C0.75 4.7166 0.75 4.94996 0.75 5.41667V14.4167C0.75 14.8834 0.75 15.1167 0.840828 15.295C0.920722 15.4518 1.04821 15.5793 1.20501 15.6592C1.38327 15.75 1.61662 15.75 2.08333 15.75H5.75M5.75 15.75H10.75M5.75 15.75L5.75 2.08333C5.75 1.61662 5.75 1.38327 5.84083 1.20501C5.92072 1.04821 6.04821 0.920722 6.20501 0.840828C6.38327 0.75 6.61662 0.75 7.08333 0.75L9.41667 0.75C9.88338 0.75 10.1167 0.75 10.295 0.840828C10.4518 0.920722 10.5793 1.04821 10.6592 1.20501C10.75 1.38327 10.75 1.61662 10.75 2.08333V15.75M10.75 7.41667H14.4167C14.8834 7.41667 15.1167 7.41667 15.295 7.50749C15.4518 7.58739 15.5793 7.71487 15.6592 7.87167C15.75 8.04993 15.75 8.28329 15.75 8.75V14.4167C15.75 14.8834 15.75 15.1167 15.6592 15.295C15.5793 15.4518 15.4518 15.5793 15.295 15.6592C15.1167 15.75 14.8834 15.75 14.4167 15.75H10.75"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgTypeSondage() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 11V15M14 9V15M10 5V15M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgListTypesSondages() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 12V16M15 10V16M11 6V16M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgSondagesDisclosure() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 12V16M15 10V16M11 6V16M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
// End Icones Sondages

export function SvgDate() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 2V5M17 2V5M3 9H21M5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4Z"
        stroke="#9E9E9E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SvgPencilIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_56617_81809)">
        <path
          d="M8.79607 2.42841C9.26181 1.9238 9.49468 1.6715 9.74213 1.52433C10.3392 1.16922 11.0744 1.15818 11.6815 1.4952C11.9331 1.63487 12.1731 1.88008 12.6531 2.37048C13.1332 2.86088 13.3732 3.10608 13.51 3.36308C13.8399 3.9832 13.8291 4.73424 13.4815 5.34419C13.3374 5.59697 13.0904 5.83486 12.5964 6.31063L6.71914 11.9714C5.78305 12.873 5.315 13.3239 4.73004 13.5523C4.14508 13.7808 3.502 13.764 2.21585 13.7304L2.04086 13.7258C1.64932 13.7155 1.45354 13.7104 1.33974 13.5813C1.22594 13.4521 1.24148 13.2527 1.27255 12.8539L1.28942 12.6373C1.37688 11.5147 1.42061 10.9534 1.63982 10.4489C1.85903 9.94434 2.23715 9.53467 2.99339 8.71531L8.79607 2.42841Z"
          stroke="#141B34"
          stroke-width="1.3"
          stroke-linejoin="round"
        />
        <path
          d="M8.125 2.5L12.5 6.875"
          stroke="#141B34"
          stroke-width="1.3"
          stroke-linejoin="round"
        />
        <path
          d="M8.75 13.75L13.75 13.75"
          stroke="#141B34"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_56617_81809">
          <rect
            width="15"
            height="15"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SvgPencilIconOutline() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.1945 1.8288C8.66024 1.32419 8.89312 1.07189 9.14057 0.92472C9.73765 0.569615 10.4729 0.558572 11.0799 0.895592C11.3315 1.03527 11.5715 1.28047 12.0516 1.77087C12.5316 2.26127 12.7717 2.50647 12.9084 2.76347C13.2383 3.38359 13.2275 4.13464 12.8799 4.74458C12.7358 4.99736 12.4888 5.23525 11.9949 5.71102L6.11758 11.3718C5.18148 12.2734 4.71344 12.7242 4.12848 12.9527C3.54351 13.1812 2.90044 13.1644 1.61429 13.1308L1.4393 13.1262C1.04775 13.1159 0.851981 13.1108 0.738179 12.9817C0.624377 12.8525 0.639914 12.6531 0.670987 12.2542L0.68786 12.0377C0.775318 10.9151 0.819047 10.3538 1.03825 9.84928C1.25746 9.34473 1.63558 8.93506 2.39183 8.1157L8.1945 1.8288Z"
        stroke="#BEBFC1"
        stroke-width="1.3"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function SvgDocumentAttachement() {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0885 8.7513V8.33463C15.0885 5.19193 15.0885 3.62059 14.1122 2.64428C13.1359 1.66797 11.5645 1.66797 8.42179 1.66797H7.58854C4.4459 1.66797 2.87457 1.66797 1.89826 2.64427C0.92195 3.62057 0.921934 5.1919 0.921909 8.33458L0.921875 12.0846C0.92185 14.8241 0.921842 16.194 1.67844 17.1159C1.81698 17.2847 1.97176 17.4395 2.14056 17.578C3.06252 18.3346 4.43228 18.3346 7.17179 18.3346"
        stroke="#161616"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.25 5.83203H11.75"
        stroke="#161616"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.25 10H9.25"
        stroke="#161616"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.0781 16.668V14.168C15.0781 12.9768 13.9589 11.668 12.5781 11.668C11.1974 11.668 10.0781 12.9768 10.0781 14.168V17.0846C10.0781 17.775 10.6378 18.3346 11.3281 18.3346C12.0185 18.3346 12.5781 17.775 12.5781 17.0846V14.168"
        stroke="#161616"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
export function SvgPencilIconTach() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_60750_130712)">
        <path
          d="M6.9974 9.33317V6.99984M6.9974 4.6665H7.00323M12.8307 6.99984C12.8307 10.2215 10.2191 12.8332 6.9974 12.8332C3.77573 12.8332 1.16406 10.2215 1.16406 6.99984C1.16406 3.77818 3.77573 1.1665 6.9974 1.1665C10.2191 1.1665 12.8307 3.77818 12.8307 6.99984Z"
          stroke="black"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_60750_130712">
          <rect
            width="14"
            height="14"
            fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function SvgReferencePeriods (){
  return (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.75 0.75V4.75M5.75 0.75V4.75" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M10.75 2.75H8.75C4.97876 2.75 3.09315 2.75 1.92157 3.92157C0.75 5.09315 0.75 6.97876 0.75 10.75V12.75C0.75 16.5212 0.75 18.4069 1.92157 19.5784C3.09315 20.75 4.97876 20.75 8.75 20.75H10.75C14.5212 20.75 16.4069 20.75 17.5784 19.5784C18.75 18.4069 18.75 16.5212 18.75 12.75V10.75C18.75 6.97876 18.75 5.09315 17.5784 3.92157C16.4069 2.75 14.5212 2.75 10.75 2.75Z" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M0.75 8.75H18.75" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8.75 12.75H13.75M5.75 12.75H5.75898M10.75 16.75H5.75M13.75 16.75H13.741" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  )
}
